// const data = {
//   AAE: {
//     iataCode: "AAE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 7.81,
//       longitude: 36.82,
//     },
//     shortName: "Annaba Airport",
//     longName: "Annaba Rabah Bitat Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "DZA",
//       code: "DZ",
//       shortName: "Algeria",
//       longName: "Algeria",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "AAE",
//       shortName: "Annaba",
//       longName: "Annaba",
//     },
//   },
//   BLJ: {
//     iataCode: "BLJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 6.31,
//       longitude: 35.75,
//     },
//     shortName: "Batna Airport",
//     longName: "Batna Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "DZA",
//       code: "DZ",
//       shortName: "Algeria",
//       longName: "Algeria",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "BLJ",
//       shortName: "Batna",
//       longName: "Batna",
//     },
//   },
//   BJA: {
//     iataCode: "BJA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 5.07,
//       longitude: 36.71,
//     },
//     shortName: "Bejaia Airport",
//     longName: "Bejaia Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "DZA",
//       code: "DZ",
//       shortName: "Algeria",
//       longName: "Algeria",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "BJA",
//       shortName: "Bejaia",
//       longName: "Bejaia",
//     },
//   },
//   BSK: {
//     iataCode: "BSK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 5.74,
//       longitude: 34.79,
//     },
//     shortName: "Biskra Airport",
//     longName: "Biskra Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "DZA",
//       code: "DZ",
//       shortName: "Algeria",
//       longName: "Algeria",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "BSK",
//       shortName: "Biskra",
//       longName: "Biskra",
//     },
//   },
//   CZL: {
//     iataCode: "CZL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 6.62,
//       longitude: 36.28,
//     },
//     shortName: "Constantine Airport",
//     longName: "Constantine Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "DZA",
//       code: "DZ",
//       shortName: "Algeria",
//       longName: "Algeria",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "CZL",
//       shortName: "Constantine",
//       longName: "Constantine",
//     },
//   },
//   ALG: {
//     iataCode: "ALG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 36.69,
//       longitude: 3.21,
//     },
//     shortName: "Algiers",
//     longName: "Houari Boumediene Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "DZA",
//       code: "DZ",
//       shortName: "Algeria",
//       longName: "Algeria",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "ALG",
//       shortName: "Algiers",
//       longName: "Algiers",
//     },
//   },
//   GHA: {
//     iataCode: "GHA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 3.79,
//       longitude: 32.38,
//     },
//     shortName: "Ghardaia Airport",
//     longName: "Ghardaia Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "DZA",
//       code: "DZ",
//       shortName: "Algeria",
//       longName: "Algeria",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "GHA",
//       shortName: "Ghardaia",
//       longName: "Ghardaia",
//     },
//   },
//   HME: {
//     iataCode: "HME",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 6.14,
//       longitude: 31.67,
//     },
//     shortName: "Hassi Messaoud Airport",
//     longName: "Hassi Messaoud Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "DZA",
//       code: "DZ",
//       shortName: "Algeria",
//       longName: "Algeria",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "HME",
//       shortName: "Hassi Messaoud",
//       longName: "Hassi Messaoud",
//     },
//   },
//   GJL: {
//     iataCode: "GJL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 5.87,
//       longitude: 36.8,
//     },
//     shortName: "Jijel Airport",
//     longName: "Jijel Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "DZA",
//       code: "DZ",
//       shortName: "Algeria",
//       longName: "Algeria",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "GJL",
//       shortName: "Jijel",
//       longName: "Jijel",
//     },
//   },
//   ORN: {
//     iataCode: "ORN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -0.62,
//       longitude: 35.62,
//     },
//     shortName: "Oran Airport",
//     longName: "Oran Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "DZA",
//       code: "DZ",
//       shortName: "Algeria",
//       longName: "Algeria",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "ORN",
//       shortName: "Oran",
//       longName: "Oran",
//     },
//   },
//   QSF: {
//     iataCode: "QSF",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 5.32,
//       longitude: 36.18,
//     },
//     shortName: "Setif Airport",
//     longName: "Setif Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "DZA",
//       code: "DZ",
//       shortName: "Algeria",
//       longName: "Algeria",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "QSF",
//       shortName: "Setif",
//       longName: "Setif",
//     },
//   },
//   TLM: {
//     iataCode: "TLM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -1.45,
//       longitude: 35.02,
//     },
//     shortName: "Tlemcen Airport",
//     longName: "Tlemcen Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "DZA",
//       code: "DZ",
//       shortName: "Algeria",
//       longName: "Algeria",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "TLM",
//       shortName: "Tlemcen",
//       longName: "Tlemcen",
//     },
//   },
//   LAD: {
//     iataCode: "LAD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: -8.86,
//       longitude: 13.23,
//     },
//     shortName: "Luanda",
//     longName: "4 de Fevereiro Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "AGO",
//       code: "AO",
//       shortName: "Angola",
//       longName: "Angola",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "LAD",
//       shortName: "Luanda",
//       longName: "Luanda",
//     },
//   },
//   BBK: {
//     iataCode: "BBK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -17.83,
//       longitude: 25.16,
//     },
//     shortName: "Kasane",
//     longName: "Kasane Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "BWA",
//       code: "BW",
//       shortName: "Botswana",
//       longName: "Botswana",
//     },
//     city: {
//       code: "BBK",
//       shortName: "Kasane",
//       longName: "Kasane",
//     },
//   },
//   MUB: {
//     iataCode: "MUB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -19.97,
//       longitude: 23.43,
//     },
//     shortName: "Maun",
//     longName: "Maun Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "BWA",
//       code: "BW",
//       shortName: "Botswana",
//       longName: "Botswana",
//     },
//     city: {
//       code: "MUB",
//       shortName: "Maun",
//       longName: "Maun",
//     },
//   },
//   GBE: {
//     iataCode: "GBE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -24.56,
//       longitude: 25.92,
//     },
//     shortName: "Gaborone",
//     longName: "Sir Seretse Khama International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "BWA",
//       code: "BW",
//       shortName: "Botswana",
//       longName: "Botswana",
//     },
//     city: {
//       code: "GBE",
//       shortName: "Gaborone",
//       longName: "Gaborone",
//     },
//   },
//   OUG: {
//     iataCode: "OUG",
//     showAsOrigin: false,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 13.57,
//       longitude: -2.42,
//     },
//     shortName: "Ouahigouya",
//     longName: "Ouahigouya Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "BFA",
//       code: "BF",
//       shortName: "Burkina Faso",
//       longName: "Burkina Faso",
//     },
//     city: {
//       code: "OUG",
//       shortName: "Ouahigouya",
//       longName: "Ouahigouya",
//     },
//   },
//   BOY: {
//     iataCode: "BOY",
//     showAsOrigin: false,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 11.16,
//       longitude: -4.33,
//     },
//     shortName: "Bobo Dioulasso Airport",
//     longName: "Bobo Dioulasso Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "BFA",
//       code: "BF",
//       shortName: "Burkina Faso",
//       longName: "Burkina Faso",
//     },
//     city: {
//       code: "BOY",
//       shortName: "Bobo Dioulasso",
//       longName: "Bobo Dioulasso",
//     },
//   },
//   OUA: {
//     iataCode: "OUA",
//     showAsOrigin: false,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 12.35,
//       longitude: -1.51,
//     },
//     shortName: "Ouagadougou Airport",
//     longName: "Ouagadougou Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "BFA",
//       code: "BF",
//       shortName: "Burkina Faso",
//       longName: "Burkina Faso",
//     },
//     city: {
//       code: "OUA",
//       shortName: "Ouagadougou",
//       longName: "Ouagadougou",
//     },
//   },
//   BJM: {
//     iataCode: "BJM",
//     showAsOrigin: false,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -3.32,
//       longitude: 29.32,
//     },
//     shortName: "Bujumbura Airport",
//     longName: "Bujumbura International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "BDI",
//       code: "BI",
//       shortName: "Burundi",
//       longName: "Burundi",
//     },
//     city: {
//       code: "BJM",
//       shortName: "Bujumbura",
//       longName: "Bujumbura",
//     },
//   },
//   NSI: {
//     iataCode: "NSI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 3.72,
//       longitude: 11.55,
//     },
//     shortName: "Yaoundé",
//     longName: "Yaoundé Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "CMR",
//       code: "CM",
//       shortName: "Cameroon",
//       longName: "Cameroon",
//     },
//     city: {
//       code: "NSI",
//       shortName: "Yaoundé",
//       longName: "Yaoundé",
//     },
//   },
//   DLA: {
//     iataCode: "DLA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 4.01,
//       longitude: 9.71,
//     },
//     shortName: "Douala",
//     longName: "Douala International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "CMR",
//       code: "CM",
//       shortName: "Cameroon",
//       longName: "Cameroon",
//     },
//     city: {
//       code: "DLA",
//       shortName: "Douala",
//       longName: "Douala",
//     },
//   },
//   RAI: {
//     iataCode: "RAI",
//     showAsOrigin: false,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 14.94,
//       longitude: -23.48,
//     },
//     shortName: "Praia",
//     longName: "Praia International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "CPV",
//       code: "CV",
//       shortName: "Cape Verde",
//       longName: "Cape Verde",
//     },
//     city: {
//       code: "RAI",
//       shortName: "Praia",
//       longName: "Praia",
//     },
//   },
//   SID: {
//     iataCode: "SID",
//     showAsOrigin: false,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 16.74,
//       longitude: -22.95,
//     },
//     shortName: "Sal International Airport",
//     longName: "Sal Amílcar Cabral International Airport ",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "CPV",
//       code: "CV",
//       shortName: "Cape Verde",
//       longName: "Cape Verde",
//     },
//     city: {
//       code: "SID",
//       shortName: "Sal Island ",
//       longName: "Sal Island ",
//     },
//   },
//   VXE: {
//     iataCode: "VXE",
//     showAsOrigin: false,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 16.83,
//       longitude: -25.06,
//     },
//     shortName: "São Vicente Airport",
//     longName: "São Vicente Cesária Évora International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "CPV",
//       code: "CV",
//       shortName: "Cape Verde",
//       longName: "Cape Verde",
//     },
//     city: {
//       code: "VXE",
//       shortName: "São Vicente",
//       longName: "São Vicente",
//     },
//   },
//   BGF: {
//     iataCode: "BGF",
//     showAsOrigin: false,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 4.4,
//       longitude: 18.52,
//     },
//     shortName: "Bangui Airport",
//     longName: "Bangui M'Poko International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "CAF",
//       code: "CF",
//       shortName: "Central African Republic",
//       longName: "Central African Republic",
//     },
//     city: {
//       code: "BGF",
//       shortName: "Bangui",
//       longName: "Bangui",
//     },
//   },
//   FIH: {
//     iataCode: "FIH",
//     showAsOrigin: false,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -4.39,
//       longitude: 15.44,
//     },
//     shortName: "Kinshasa",
//     longName: "Kinshasa International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "COD",
//       code: "CD",
//       shortName: "Congo, Democratic Republic of the",
//       longName: "Congo, Democratic Republic of the",
//     },
//     city: {
//       code: "FIH",
//       shortName: "Kinshasa",
//       longName: "Kinshasa",
//     },
//   },
//   FBM: {
//     iataCode: "FBM",
//     showAsOrigin: false,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -11.59,
//       longitude: 27.53,
//     },
//     shortName: "Lubumbashi",
//     longName: "Lubumbashi International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "COG",
//       code: "CG",
//       shortName: "Congo, Republic of the",
//       longName: "Congo, Republic of the",
//     },
//     city: {
//       code: "FBM",
//       shortName: "Lubumbashi",
//       longName: "Lubumbashi",
//     },
//   },
//   BYK: {
//     iataCode: "BYK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 7.74,
//       longitude: -5.07,
//     },
//     shortName: "Bouake Airport",
//     longName: "Bouake Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "CIV",
//       code: "CI",
//       shortName: "Côte d'Ivoire (Ivory Coast)",
//       longName: "Côte d'Ivoire (Ivory Coast)",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "BYK",
//       shortName: "Bouake",
//       longName: "Bouake",
//     },
//   },
//   ABJ: {
//     iataCode: "ABJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 5.25,
//       longitude: -3.93,
//     },
//     shortName: "Abidjan",
//     longName: "Felix Houphouet Boigny Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "CIV",
//       code: "CI",
//       shortName: "Côte d'Ivoire (Ivory Coast)",
//       longName: "Côte d'Ivoire (Ivory Coast)",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "ABJ",
//       shortName: "Abidjan",
//       longName: "Abidjan",
//     },
//   },
//   HGO: {
//     iataCode: "HGO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 9.39,
//       longitude: -5.56,
//     },
//     shortName: "Korhogo Airport",
//     longName: "Korhogo Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "CIV",
//       code: "CI",
//       shortName: "Côte d'Ivoire (Ivory Coast)",
//       longName: "Côte d'Ivoire (Ivory Coast)",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "HGO",
//       shortName: "Korhogo",
//       longName: "Korhogo",
//     },
//   },
//   MJC: {
//     iataCode: "MJC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 7.27,
//       longitude: -7.59,
//     },
//     shortName: "Man Airport",
//     longName: "Man Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "CIV",
//       code: "CI",
//       shortName: "Côte d'Ivoire (Ivory Coast)",
//       longName: "Côte d'Ivoire (Ivory Coast)",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "MJC",
//       shortName: "Man",
//       longName: "Man",
//     },
//   },
//   KEO: {
//     iataCode: "KEO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 9.5,
//       longitude: -7.57,
//     },
//     shortName: "Odienne Airport",
//     longName: "Odienne Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "CIV",
//       code: "CI",
//       shortName: "Côte d'Ivoire (Ivory Coast)",
//       longName: "Côte d'Ivoire (Ivory Coast)",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "KEO",
//       shortName: "Odienne",
//       longName: "Odienne",
//     },
//   },
//   SPY: {
//     iataCode: "SPY",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 4.75,
//       longitude: -6.66,
//     },
//     shortName: "San Pedro Airport",
//     longName: "San Pedro Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "CIV",
//       code: "CI",
//       shortName: "Côte d'Ivoire (Ivory Coast)",
//       longName: "Côte d'Ivoire (Ivory Coast)",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "SPY",
//       shortName: "San Pedro",
//       longName: "San Pedro",
//     },
//   },
//   JIB: {
//     iataCode: "JIB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 11.55,
//       longitude: 43.16,
//     },
//     shortName: "Djibouti",
//     longName: "Djibouti-Ambouli International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "DJI",
//       code: "DJ",
//       shortName: "Djibouti",
//       longName: "Djibouti",
//     },
//     city: {
//       code: "JIB",
//       shortName: "Djibouti",
//       longName: "Djibouti",
//     },
//   },
//   DBB: {
//     iataCode: "DBB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 30.92,
//       longitude: 28.46,
//     },
//     shortName: "Al Alamein Airport",
//     longName: "Al Alamein International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "EGY",
//       code: "EG",
//       shortName: "Egypt",
//       longName: "Egypt",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "DBB",
//       shortName: "Al Alamein",
//       longName: "Al Alamein",
//     },
//   },
//   HBE: {
//     iataCode: "HBE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 30.92,
//       longitude: 29.7,
//     },
//     shortName: "Alexandria",
//     longName: "Borg El Arab Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "EGY",
//       code: "EG",
//       shortName: "Egypt",
//       longName: "Egypt",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "ALY",
//       shortName: "Alexandria",
//       longName: "Alexandria",
//     },
//   },
//   ATZ: {
//     iataCode: "ATZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 27.05,
//       longitude: 31.01,
//     },
//     shortName: "Asyut",
//     longName: "Assiut Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "EGY",
//       code: "EG",
//       shortName: "Egypt",
//       longName: "Egypt",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "ATZ",
//       shortName: "Asyut",
//       longName: "Asyut",
//     },
//   },
//   ASW: {
//     iataCode: "ASW",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 23.96,
//       longitude: 32.82,
//     },
//     shortName: "Aswan Airport",
//     longName: "Aswan International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "EGY",
//       code: "EG",
//       shortName: "Egypt",
//       longName: "Egypt",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "Aswan",
//       shortName: "Aswan",
//       longName: "Aswan",
//     },
//   },
//   CAI: {
//     iataCode: "CAI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 30.11,
//       longitude: 31.41,
//     },
//     shortName: "Cairo",
//     longName: "Cairo International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "EGY",
//       code: "EG",
//       shortName: "Egypt",
//       longName: "Egypt",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "CAI",
//       shortName: "Cairo",
//       longName: "Cairo",
//     },
//   },
//   LXR: {
//     iataCode: "LXR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 25.67,
//       longitude: 32.71,
//     },
//     shortName: "Luxor",
//     longName: "Luxor International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "EGY",
//       code: "EG",
//       shortName: "Egypt",
//       longName: "Egypt",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "LXR",
//       shortName: "Luxor",
//       longName: "Luxor",
//     },
//   },
//   SSH: {
//     iataCode: "SSH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 27.98,
//       longitude: 34.4,
//     },
//     shortName: "Sharm el-Sheikh Airport",
//     longName: "Sharm el-Sheikh International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "EGY",
//       code: "EG",
//       shortName: "Egypt",
//       longName: "Egypt",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "SSH",
//       shortName: "Sharm el-Sheikh",
//       longName: "Sharm el-Sheikh",
//     },
//   },
//   HRG: {
//     iataCode: "HRG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 27.18,
//       longitude: 33.8,
//     },
//     shortName: "Hurghada Airport",
//     longName: "Hurghada International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "EGY",
//       code: "EG",
//       shortName: "Egypt",
//       longName: "Egypt",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "HRG",
//       shortName: "Hurghada",
//       longName: "Hurghada",
//     },
//   },
//   ASM: {
//     iataCode: "ASM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 15.29,
//       longitude: 38.91,
//     },
//     shortName: "Asmara Airport",
//     longName: "Asmara International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "ERI",
//       code: "ER",
//       shortName: "Eritrea",
//       longName: "Eritrea",
//     },
//     city: {
//       code: "ASM",
//       shortName: "Asmara",
//       longName: "Asmara",
//     },
//   },
//   SHO: {
//     iataCode: "SHO",
//     showAsOrigin: false,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 31.72,
//       longitude: -26.36,
//     },
//     shortName: "Manzini Airport",
//     longName: "Manzini King Mswati III International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "SWZ",
//       code: "SZ",
//       shortName: "Eswatini",
//       longName: "Eswatini",
//     },
//     city: {
//       code: "MTS",
//       shortName: "Manzini",
//       longName: "Manzini",
//     },
//   },
//   ADD: {
//     iataCode: "ADD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 8.98,
//       longitude: 38.8,
//     },
//     shortName: "Addis Ababa",
//     longName: "Bole International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "ETH",
//       code: "ET",
//       shortName: "Ethiopia",
//       longName: "Ethiopia",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "ADD",
//       shortName: "Addis Ababa",
//       longName: "Addis Ababa",
//     },
//   },
//   LBV: {
//     iataCode: "LBV",
//     showAsOrigin: false,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 0.46,
//       longitude: 9.41,
//     },
//     shortName: "Libreville",
//     longName: "Libreville Leon M'ba International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "GAB",
//       code: "GA",
//       shortName: "Gabon",
//       longName: "Gabon",
//     },
//     city: {
//       code: "LBV",
//       shortName: "Libreville",
//       longName: "Libreville",
//     },
//   },
//   BJL: {
//     iataCode: "BJL",
//     showAsOrigin: false,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 13.34,
//       longitude: -16.66,
//     },
//     shortName: "Banjul",
//     longName: "Banjul International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "GMB",
//       code: "GM",
//       shortName: "Gambia",
//       longName: "Gambia",
//     },
//     city: {
//       code: "BJL",
//       shortName: "Banjul",
//       longName: "Banjul",
//     },
//   },
//   ACC: {
//     iataCode: "ACC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 5.6,
//       longitude: -0.17,
//     },
//     shortName: "Accra",
//     longName: "Kotoka International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "GHA",
//       code: "GH",
//       shortName: "Ghana",
//       longName: "Ghana",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "ACC",
//       shortName: "Accra",
//       longName: "Accra",
//     },
//   },
//   KMS: {
//     iataCode: "KMS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 6.71,
//       longitude: -1.59,
//     },
//     shortName: "Kumasi Airport",
//     longName: "Kumasi Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "GHA",
//       code: "GH",
//       shortName: "Ghana",
//       longName: "Ghana",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "KMS",
//       shortName: "Kumasi",
//       longName: "Kumasi",
//     },
//   },
//   TKD: {
//     iataCode: "TKD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 4.9,
//       longitude: -1.77,
//     },
//     shortName: "Takoradi Airport",
//     longName: "Takoradi Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "GHA",
//       code: "GH",
//       shortName: "Ghana",
//       longName: "Ghana",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "TKD",
//       shortName: "Takoradi",
//       longName: "Takoradi",
//     },
//   },
//   TML: {
//     iataCode: "TML",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 9.56,
//       longitude: -0.86,
//     },
//     shortName: "Tamale Airport",
//     longName: "Tamale Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "GHA",
//       code: "GH",
//       shortName: "Ghana",
//       longName: "Ghana",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "TML ",
//       shortName: "Tamale",
//       longName: "Tamale",
//     },
//   },
//   CKY: {
//     iataCode: "CKY",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 9.58,
//       longitude: -13.61,
//     },
//     shortName: "Conakry",
//     longName: "Conakry International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "GIN",
//       code: "GN",
//       shortName: "Guinea",
//       longName: "Guinea",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "CKY",
//       shortName: "Conakry",
//       longName: "Conakry",
//     },
//   },
//   OXB: {
//     iataCode: "OXB",
//     showAsOrigin: false,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 11.89,
//       longitude: -15.65,
//     },
//     shortName: "Bissau",
//     longName: "Osvaldo Vieira International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "GNB",
//       code: "GW",
//       shortName: "Guinea-Bissau",
//       longName: "Guinea-Bissau",
//     },
//     city: {
//       code: "OXB",
//       shortName: "Bissau",
//       longName: "Bissau",
//     },
//   },
//   MBA: {
//     iataCode: "MBA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -4.03,
//       longitude: 39.6,
//     },
//     shortName: "Mombasa",
//     longName: "Moi International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "KEN",
//       code: "KE",
//       shortName: "Kenya",
//       longName: "Kenya",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "MBA",
//       shortName: "Mombasa",
//       longName: "Mombasa",
//     },
//   },
//   NBO: {
//     iataCode: "NBO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: -1.32,
//       longitude: 36.93,
//     },
//     shortName: "Nairobi",
//     longName: "Jomo Kenyatta International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "KEN",
//       code: "KE",
//       shortName: "Kenya",
//       longName: "Kenya",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "NBO",
//       shortName: "Nairobi",
//       longName: "Nairobi",
//     },
//   },
//   MSU: {
//     iataCode: "MSU",
//     showAsOrigin: false,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -29.45,
//       longitude: 27.56,
//     },
//     shortName: "Maseru",
//     longName: "Maseru Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "LSO",
//       code: "LS",
//       shortName: "Lesotho",
//       longName: "Lesotho",
//     },
//     city: {
//       code: "MSU",
//       shortName: "Maseru",
//       longName: "Maseru",
//     },
//   },
//   DIE: {
//     iataCode: "DIE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -12.35,
//       longitude: 49.29,
//     },
//     shortName: "Arrachart Airport",
//     longName: "Antsiranana Arrachart Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "MDG",
//       code: "MG",
//       shortName: "Madagascar",
//       longName: "Madagascar",
//     },
//     city: {
//       code: "DIE",
//       shortName: "Antsiranana",
//       longName: "Antsiranana",
//     },
//   },
//   TNR: {
//     iataCode: "TNR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: -18.8,
//       longitude: 47.48,
//     },
//     shortName: "Antananarivo",
//     longName: "Ivato International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "MDG",
//       code: "MG",
//       shortName: "Madagascar",
//       longName: "Madagascar",
//     },
//     city: {
//       code: "TNR",
//       shortName: "Antananarivo",
//       longName: "Antananarivo",
//     },
//   },
//   MJN: {
//     iataCode: "MJN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -15.67,
//       longitude: 46.35,
//     },
//     shortName: "Amborovy Airport",
//     longName: "Mahajanga Amborovy Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "MDG",
//       code: "MG",
//       shortName: "Madagascar",
//       longName: "Madagascar",
//     },
//     city: {
//       code: "MJN",
//       shortName: "Mahajanga",
//       longName: "Mahajanga",
//     },
//   },
//   WMN: {
//     iataCode: "WMN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -15.44,
//       longitude: 49.69,
//     },
//     shortName: "Maroantsetra Airport",
//     longName: "Maroantsetra Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "MDG",
//       code: "MG",
//       shortName: "Madagascar",
//       longName: "Madagascar",
//     },
//     city: {
//       code: "WMN",
//       shortName: "Maroantsetra",
//       longName: "Maroantsetra",
//     },
//   },
//   MOQ: {
//     iataCode: "MOQ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -20.28,
//       longitude: 44.32,
//     },
//     shortName: "Morondava Airport",
//     longName: "Morondava Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "MDG",
//       code: "MG",
//       shortName: "Madagascar",
//       longName: "Madagascar",
//     },
//     city: {
//       code: "MOQ",
//       shortName: "Morondava",
//       longName: "Morondava",
//     },
//   },
//   NOS: {
//     iataCode: "NOS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -13.31,
//       longitude: 48.31,
//     },
//     shortName: "Nosy Be Airport",
//     longName: "Nosy Be Fascene Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "MDG",
//       code: "MG",
//       shortName: "Madagascar",
//       longName: "Madagascar",
//     },
//     city: {
//       code: "NOS",
//       shortName: "Nosy Be",
//       longName: "Nosy Be",
//     },
//   },
//   SMS: {
//     iataCode: "SMS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -17.09,
//       longitude: 49.82,
//     },
//     shortName: "Sainte Marie Airport",
//     longName: "Sainte Marie Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "MDG",
//       code: "MG",
//       shortName: "Madagascar",
//       longName: "Madagascar",
//     },
//     city: {
//       code: "SMS",
//       shortName: "Sainte Marie",
//       longName: "Sainte Marie",
//     },
//   },
//   SVB: {
//     iataCode: "SVB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -14.28,
//       longitude: 50.17,
//     },
//     shortName: "Sambava Airport",
//     longName: "Sambava Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "MDG",
//       code: "MG",
//       shortName: "Madagascar",
//       longName: "Madagascar",
//     },
//     city: {
//       code: "SVB",
//       shortName: "Sambava",
//       longName: "Sambava",
//     },
//   },
//   TMM: {
//     iataCode: "TMM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -18.11,
//       longitude: 49.39,
//     },
//     shortName: "Toamasina Airport",
//     longName: "Toamasina Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "MDG",
//       code: "MG",
//       shortName: "Madagascar",
//       longName: "Madagascar",
//     },
//     city: {
//       code: "TMM",
//       shortName: "Toamasina",
//       longName: "Toamasina",
//     },
//   },
//   TLE: {
//     iataCode: "TLE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -23.38,
//       longitude: 43.73,
//     },
//     shortName: "Toliara Airport",
//     longName: "Toliara Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "MDG",
//       code: "MG",
//       shortName: "Madagascar",
//       longName: "Madagascar",
//     },
//     city: {
//       code: "TLE",
//       shortName: "Toliara",
//       longName: "Toliara ",
//     },
//   },
//   FTU: {
//     iataCode: "FTU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -25.04,
//       longitude: 46.96,
//     },
//     shortName: "Tôlanaro Airport",
//     longName: "Tôlanaro Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "MDG",
//       code: "MG",
//       shortName: "Madagascar",
//       longName: "Madagascar",
//     },
//     city: {
//       code: "FTU",
//       shortName: "Tôlanaro",
//       longName: "Tôlanaro",
//     },
//   },
//   LLW: {
//     iataCode: "LLW",
//     showAsOrigin: false,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -13.78,
//       longitude: 33.78,
//     },
//     shortName: "Lilongwe",
//     longName: "Lilongwe International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "MWI",
//       code: "MW",
//       shortName: "Malawi",
//       longName: "Malawi",
//     },
//     city: {
//       code: "LLW",
//       shortName: "Lilongwe",
//       longName: "Lilongwe",
//     },
//   },
//   BLZ: {
//     iataCode: "BLZ",
//     showAsOrigin: false,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -15.68,
//       longitude: 34.97,
//     },
//     shortName: "Blantyre",
//     longName: "Chileka International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "MWI",
//       code: "MW",
//       shortName: "Malawi",
//       longName: "Malawi",
//     },
//     city: {
//       code: "BLZ",
//       shortName: "Blantyre",
//       longName: "Blantyre",
//     },
//   },
//   BKO: {
//     iataCode: "BKO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 12.54,
//       longitude: -7.94,
//     },
//     shortName: "Bamako",
//     longName: "Bamako Senou International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "MLI",
//       code: "ML",
//       shortName: "Mali",
//       longName: "Mali",
//     },
//     city: {
//       code: "BKO",
//       shortName: "Bamako",
//       longName: "Bamako",
//     },
//   },
//   NKC: {
//     iataCode: "NKC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 18.1,
//       longitude: -15.95,
//     },
//     shortName: "Nouakchott",
//     longName: "Nouakchott International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "MRT",
//       code: "MR",
//       shortName: "Mauritania",
//       longName: "Mauritania",
//     },
//     city: {
//       code: "NKC",
//       shortName: "Nouakchott",
//       longName: "Nouakchott",
//     },
//   },
//   MRU: {
//     iataCode: "MRU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: -20.43,
//       longitude: 57.68,
//     },
//     shortName: "Mauritius",
//     longName: "Sir Seewoosagur Ramgoolam International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "MUS",
//       code: "MU",
//       shortName: "Mauritius",
//       longName: "Mauritius",
//       otherRegion: {
//         shortName: "Indian Ocean Islands",
//         longName: "Indian Ocean Islands",
//       },
//     },
//     city: {
//       code: "MRU",
//       shortName: "Mauritius",
//       longName: "Mauritius",
//     },
//   },
//   RRG: {
//     iataCode: "RRG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -19.76,
//       longitude: 63.36,
//     },
//     shortName: "Duval Airport",
//     longName: "Sir Charles Gaetan Duval Airport ",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "MUS",
//       code: "MU",
//       shortName: "Mauritius",
//       longName: "Mauritius",
//       otherRegion: {
//         shortName: "Indian Ocean Islands",
//         longName: "Indian Ocean Islands",
//       },
//     },
//     city: {
//       code: "RRG",
//       shortName: "Rodrigues Island",
//       longName: "Rodrigues Island",
//     },
//   },
//   DZA: {
//     iataCode: "DZA",
//     showAsOrigin: false,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -12.8,
//       longitude: 45.28,
//     },
//     shortName: "Dzaoudzi Airport",
//     longName: "Dzaoudzi International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "MYT",
//       code: "YT",
//       shortName: "Mayotte",
//       longName: "Mayotte",
//     },
//     city: {
//       code: "DZA",
//       shortName: "Dzaoudzi",
//       longName: "Dzaoudzi",
//     },
//   },
//   FEZ: {
//     iataCode: "FEZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 33.93,
//       longitude: -4.98,
//     },
//     shortName: "Fes Airport",
//     longName: "Fes Saïss Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "MAR",
//       code: "MA",
//       shortName: "Morocco",
//       longName: "Morocco",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "FEZ",
//       shortName: "Fes",
//       longName: "Fes",
//     },
//   },
//   CMN: {
//     iataCode: "CMN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 33.36,
//       longitude: -7.58,
//     },
//     shortName: "Casablanca Mohammed V International Airport",
//     longName: "Mohammed V International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "MAR",
//       code: "MA",
//       shortName: "Morocco",
//       longName: "Morocco",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "CMN",
//       shortName: "Casablanca",
//       longName: "Casablanca",
//     },
//   },
//   RAK: {
//     iataCode: "RAK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 31.61,
//       longitude: -8.04,
//     },
//     shortName: "Marrakech",
//     longName: "Marrakech-Menara Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "MAR",
//       code: "MA",
//       shortName: "Morocco",
//       longName: "Morocco",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "RAK",
//       shortName: "Marrakech",
//       longName: "Marrakech",
//     },
//   },
//   AGA: {
//     iataCode: "AGA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 30.33,
//       longitude: -9.41,
//     },
//     shortName: "Agadir Airport",
//     longName: "Agadir Al Massira Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "MAR",
//       code: "MA",
//       shortName: "Morocco",
//       longName: "Morocco",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "AGA",
//       shortName: "Agadir",
//       longName: "Agadir",
//     },
//   },
//   OUD: {
//     iataCode: "OUD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 34.79,
//       longitude: -1.92,
//     },
//     shortName: "Oujda",
//     longName: "Oujda Angads Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "MAR",
//       code: "MA",
//       shortName: "Morocco",
//       longName: "Morocco",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "OUD",
//       shortName: "Oujda",
//       longName: "Oujda",
//     },
//   },
//   TNG: {
//     iataCode: "TNG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 35.73,
//       longitude: -5.92,
//     },
//     shortName: "Tangier Airport",
//     longName: "Tangier Ibn Batouta Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "MAR",
//       code: "MA",
//       shortName: "Morocco",
//       longName: "Morocco",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "TNG",
//       shortName: "Tangier",
//       longName: "Tangier",
//     },
//   },
//   POL: {
//     iataCode: "POL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -12.98,
//       longitude: 40.52,
//     },
//     shortName: "Pemba",
//     longName: "Pemba Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "MOZ",
//       code: "MZ",
//       shortName: "Mozambique",
//       longName: "Mozambique",
//     },
//     city: {
//       code: "POL",
//       shortName: "Pemba",
//       longName: "Pemba",
//     },
//   },
//   VNX: {
//     iataCode: "VNX",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -22.02,
//       longitude: 35.31,
//     },
//     shortName: "Vilanculo Airport",
//     longName: "Vilanculo Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "MOZ",
//       code: "MZ",
//       shortName: "Mozambique",
//       longName: "Mozambique",
//     },
//     city: {
//       code: "VNX",
//       shortName: "Vilanculo",
//       longName: "Vilanculo",
//     },
//   },
//   MPM: {
//     iataCode: "MPM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -25.92,
//       longitude: 32.57,
//     },
//     shortName: "Maputo",
//     longName: "Maputo International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "MOZ",
//       code: "MZ",
//       shortName: "Mozambique",
//       longName: "Mozambique",
//     },
//     city: {
//       code: "MPM",
//       shortName: "Maputo",
//       longName: "Maputo",
//     },
//   },
//   APL: {
//     iataCode: "APL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -15.1,
//       longitude: 39.28,
//     },
//     shortName: "Nampula",
//     longName: "Nampula Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "MOZ",
//       code: "MZ",
//       shortName: "Mozambique",
//       longName: "Mozambique",
//     },
//     city: {
//       code: "APL",
//       shortName: "Nampula",
//       longName: "Nampula",
//     },
//   },
//   BEW: {
//     iataCode: "BEW",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -19.8,
//       longitude: 34.9,
//     },
//     shortName: "Beira",
//     longName: "Beira Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "MOZ",
//       code: "MZ",
//       shortName: "Mozambique",
//       longName: "Mozambique",
//     },
//     city: {
//       code: "BEW",
//       shortName: "Beira",
//       longName: "Beira",
//     },
//   },
//   TET: {
//     iataCode: "TET",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -16.1,
//       longitude: 33.64,
//     },
//     shortName: "Tete Airport",
//     longName: "Tete Chingozi Airport ",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "MOZ",
//       code: "MZ",
//       shortName: "Mozambique",
//       longName: "Mozambique",
//     },
//     city: {
//       code: "TET",
//       shortName: "Tete",
//       longName: "Tete",
//     },
//   },
//   WDH: {
//     iataCode: "WDH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -22.48,
//       longitude: 17.47,
//     },
//     shortName: "Windhoek",
//     longName: "Windhoek Hosea Kutako International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "NAM",
//       code: "NA",
//       shortName: "Namibia",
//       longName: "Namibia",
//     },
//     city: {
//       code: "WDH",
//       shortName: "Windhoek",
//       longName: "Windhoek",
//     },
//   },
//   WVB: {
//     iataCode: "WVB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -22.98,
//       longitude: 14.65,
//     },
//     shortName: "Walvis Bay Airport",
//     longName: "Walvis Bay Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "NAM",
//       code: "NA",
//       shortName: "Namibia",
//       longName: "Namibia",
//     },
//     city: {
//       code: "WVB",
//       shortName: "Walvis Bay",
//       longName: "Walvis Bay",
//     },
//   },
//   NIM: {
//     iataCode: "NIM",
//     showAsOrigin: false,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 13.48,
//       longitude: 2.17,
//     },
//     shortName: "Niamey",
//     longName: "Diori Hamani International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "NER",
//       code: "NE",
//       shortName: "Niger",
//       longName: "Niger",
//     },
//     city: {
//       code: "NIM",
//       shortName: "Niamey",
//       longName: "Niamey",
//     },
//   },
//   AKR: {
//     iataCode: "AKR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 7.25,
//       longitude: 5.3,
//     },
//     shortName: "Akure Airport",
//     longName: "Akure Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "NGA",
//       code: "NG",
//       shortName: "Nigeria",
//       longName: "Nigeria",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "AKR",
//       shortName: "Akure",
//       longName: "Akure",
//     },
//   },
//   ABB: {
//     iataCode: "ABB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 6.2,
//       longitude: 6.66,
//     },
//     shortName: "Asaba Airport",
//     longName: "Asaba Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "NGA",
//       code: "NG",
//       shortName: "Nigeria",
//       longName: "Nigeria",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "ABB",
//       shortName: "Asaba",
//       longName: "Asaba",
//     },
//   },
//   BNI: {
//     iataCode: "BNI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 6.32,
//       longitude: 5.6,
//     },
//     shortName: "Benin Airport",
//     longName: "Benin Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "NGA",
//       code: "NG",
//       shortName: "Nigeria",
//       longName: "Nigeria",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "BNI",
//       shortName: "Benin",
//       longName: "Benin",
//     },
//   },
//   CBQ: {
//     iataCode: "CBQ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 4.98,
//       longitude: 8.35,
//     },
//     shortName: "Calabar Airport",
//     longName: "Calabar Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "NGA",
//       code: "NG",
//       shortName: "Nigeria",
//       longName: "Nigeria",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "CBQ",
//       shortName: "Calabar",
//       longName: "Calabar",
//     },
//   },
//   ENU: {
//     iataCode: "ENU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 6.47,
//       longitude: 7.56,
//     },
//     shortName: "Enegu Airport",
//     longName: "Enegu Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "NGA",
//       code: "NG",
//       shortName: "Nigeria",
//       longName: "Nigeria",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "ENU",
//       shortName: "Enegu",
//       longName: "Enegu",
//     },
//   },
//   ILR: {
//     iataCode: "ILR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 8.44,
//       longitude: 4.49,
//     },
//     shortName: "Ilorin Airport",
//     longName: "Ilorin Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "NGA",
//       code: "NG",
//       shortName: "Nigeria",
//       longName: "Nigeria",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "ILR",
//       shortName: "Ilorin",
//       longName: "Ilorin",
//     },
//   },
//   KAD: {
//     iataCode: "KAD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 10.7,
//       longitude: 7.32,
//     },
//     shortName: "Kaduna Airport",
//     longName: "Kaduna Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "NGA",
//       code: "NG",
//       shortName: "Nigeria",
//       longName: "Nigeria",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "KAD",
//       shortName: "Kaduna",
//       longName: "Kaduna",
//     },
//   },
//   ABV: {
//     iataCode: "ABV",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 9.01,
//       longitude: 7.26,
//     },
//     shortName: "Abuja",
//     longName: "Abuja Nnamdi Azikiwe International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "NGA",
//       code: "NG",
//       shortName: "Nigeria",
//       longName: "Nigeria",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "ABV",
//       shortName: "Abuja",
//       longName: "Abuja",
//     },
//   },
//   KAN: {
//     iataCode: "KAN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 12.05,
//       longitude: 8.52,
//     },
//     shortName: "Kano Airport",
//     longName: "Mallam Aminu Kano International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "NGA",
//       code: "NG",
//       shortName: "Nigeria",
//       longName: "Nigeria",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "KAN",
//       shortName: "Kano",
//       longName: "Kano",
//     },
//   },
//   LOS: {
//     iataCode: "LOS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 6.58,
//       longitude: 3.32,
//     },
//     shortName: "Lagos",
//     longName: "Murtala Muhammed Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "NGA",
//       code: "NG",
//       shortName: "Nigeria",
//       longName: "Nigeria",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "LOS",
//       shortName: "Lagos",
//       longName: "Lagos",
//     },
//   },
//   QOW: {
//     iataCode: "QOW",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 5.43,
//       longitude: 7.21,
//     },
//     shortName: "Owerri Airport",
//     longName: "Owerri Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "NGA",
//       code: "NG",
//       shortName: "Nigeria",
//       longName: "Nigeria",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "QOW",
//       shortName: "Owerri",
//       longName: "Owerri",
//     },
//   },
//   PHC: {
//     iataCode: "PHC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 5.02,
//       longitude: 6.95,
//     },
//     shortName: "Port Harcourt Airport",
//     longName: "\r\nPort Harcourt International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "NGA",
//       code: "NG",
//       shortName: "Nigeria",
//       longName: "Nigeria",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "PHC",
//       shortName: "Port Harcourt",
//       longName: "Port Harcourt",
//     },
//   },
//   QUO: {
//     iataCode: "QUO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 4.87,
//       longitude: 8.09,
//     },
//     shortName: "Uyo Airport",
//     longName: "Uyo Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "NGA",
//       code: "NG",
//       shortName: "Nigeria",
//       longName: "Nigeria",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "QUO",
//       shortName: "Uyo",
//       longName: "Uyo",
//     },
//   },
//   QRW: {
//     iataCode: "QRW",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 5.6,
//       longitude: 5.82,
//     },
//     shortName: "Warri Airport",
//     longName: "Warri Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "NGA",
//       code: "NG",
//       shortName: "Nigeria",
//       longName: "Nigeria",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "QRW",
//       shortName: "Warri",
//       longName: "Warri",
//     },
//   },
//   ZSE: {
//     iataCode: "ZSE",
//     showAsOrigin: false,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -21.32,
//       longitude: 55.42,
//     },
//     shortName: "Pierrefonds ",
//     longName: "Pierrefonds Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "REU",
//       code: "RE",
//       shortName: "Reunion",
//       longName: "Reunion",
//     },
//     city: {
//       code: "ZSE",
//       shortName: "Saint Pierre Reunion",
//       longName: "Saint Pierre Reunion",
//     },
//   },
//   RUN: {
//     iataCode: "RUN",
//     showAsOrigin: false,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -20.89,
//       longitude: 55.51,
//     },
//     shortName: "Réunion Airport",
//     longName: "Réunion Roland Garros Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "REU",
//       code: "RE",
//       shortName: "Reunion",
//       longName: "Reunion",
//     },
//     city: {
//       code: "RUN",
//       shortName: "St. Denis Reunion",
//       longName: "St. Denis De La Reunion",
//     },
//   },
//   KGL: {
//     iataCode: "KGL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -1.97,
//       longitude: 30.14,
//     },
//     shortName: "Kigali Airport",
//     longName: "Kigali International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "RWA",
//       code: "RW",
//       shortName: "Rwanda",
//       longName: "Rwanda",
//     },
//     city: {
//       code: "KGL",
//       shortName: "Kigali",
//       longName: "Kigali",
//     },
//   },
//   DSS: {
//     iataCode: "DSS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 14.74,
//       longitude: -17.49,
//     },
//     shortName: "Dakar",
//     longName: "Dakar Blaise Diagne International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "SEN",
//       code: "SN",
//       shortName: "Senegal",
//       longName: "Senegal",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "DKR",
//       shortName: "Dakar",
//       longName: "Dakar",
//     },
//   },
//   FNA: {
//     iataCode: "FNA",
//     showAsOrigin: false,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 8.62,
//       longitude: -13.2,
//     },
//     shortName: "Freetown",
//     longName: "Freetown-Lungi International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "SLE",
//       code: "SL",
//       shortName: "Sierra Leone",
//       longName: "Sierra Leone",
//     },
//     city: {
//       code: "FNA",
//       shortName: "Freetown",
//       longName: "Freetown",
//     },
//   },
//   GGR: {
//     iataCode: "GGR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 8.42,
//       longitude: 48.48,
//     },
//     shortName: "Garowe Airport",
//     longName: "Garowe Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "SOM",
//       code: "SO",
//       shortName: "Somalia",
//       longName: "Somalia",
//     },
//     city: {
//       code: "GGR",
//       shortName: "Garowe",
//       longName: "Garowe",
//     },
//   },
//   HGA: {
//     iataCode: "HGA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 9.52,
//       longitude: 44.09,
//     },
//     shortName: "Hargeisa Airport",
//     longName: "Hargeisa Egal International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "SOM",
//       code: "SO",
//       shortName: "Somalia",
//       longName: "Somalia",
//     },
//     city: {
//       code: "HGA",
//       shortName: "Hargeisa",
//       longName: "Hargeisa",
//     },
//   },
//   MGQ: {
//     iataCode: "MGQ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 2.01,
//       longitude: 45.3,
//     },
//     shortName: "Mogadishu Airport",
//     longName: "Mogadishu Aden Adde International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "SOM",
//       code: "SO",
//       shortName: "Somalia",
//       longName: "Somalia",
//     },
//     city: {
//       code: "MGQ",
//       shortName: "Mogadishu",
//       longName: "Mogadishu",
//     },
//   },
//   AAM: {
//     iataCode: "AAM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -24.82,
//       longitude: 31.54,
//     },
//     shortName: "Mala Mala Airport",
//     longName: "Mala Mala Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "ZAF",
//       code: "ZA",
//       shortName: "South Africa",
//       longName: "South Africa",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "AAM",
//       shortName: "Mala Mala",
//       longName: "Mala Mala",
//     },
//   },
//   ELS: {
//     iataCode: "ELS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -33.04,
//       longitude: 27.82,
//     },
//     shortName: "East London",
//     longName: "East London Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "ZAF",
//       code: "ZA",
//       shortName: "South Africa",
//       longName: "South Africa",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "ELS",
//       shortName: "East London",
//       longName: "East London",
//     },
//   },
//   UTT: {
//     iataCode: "UTT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -31.55,
//       longitude: 28.67,
//     },
//     shortName: "Mthatha Airport",
//     longName: "Mthatha K. D. Matanzima Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "ZAF",
//       code: "ZA",
//       shortName: "South Africa",
//       longName: "South Africa",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "UTT",
//       shortName: "Mthatha",
//       longName: "Mthatha",
//     },
//   },
//   PLZ: {
//     iataCode: "PLZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -33.99,
//       longitude: 25.61,
//     },
//     shortName: "Port Elizabeth",
//     longName: "Port Elizabeth Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "ZAF",
//       code: "ZA",
//       shortName: "South Africa",
//       longName: "South Africa",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "PLZ",
//       shortName: "Port Elizabeth",
//       longName: "Port Elizabeth",
//     },
//   },
//   BFN: {
//     iataCode: "BFN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -29.09,
//       longitude: 26.3,
//     },
//     shortName: "Bloemfontein",
//     longName: "Bloemfontein Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "ZAF",
//       code: "ZA",
//       shortName: "South Africa",
//       longName: "South Africa",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "BFN",
//       shortName: "Bloemfontein",
//       longName: "Bloemfontein",
//     },
//   },
//   JNB: {
//     iataCode: "JNB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: -26.13,
//       longitude: 28.24,
//     },
//     shortName: "Johannesburg",
//     longName: "O R Tambo International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "ZAF",
//       code: "ZA",
//       shortName: "South Africa",
//       longName: "South Africa",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "JNB",
//       shortName: "Johannesburg",
//       longName: "Johannesburg",
//     },
//   },
//   DUR: {
//     iataCode: "DUR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: -29.61,
//       longitude: 31.12,
//     },
//     shortName: "Durban",
//     longName: "King Shaka International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "ZAF",
//       code: "ZA",
//       shortName: "South Africa",
//       longName: "South Africa",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "DUR",
//       shortName: "Durban",
//       longName: "Durban",
//     },
//   },
//   MGH: {
//     iataCode: "MGH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -30.86,
//       longitude: 30.34,
//     },
//     shortName: "Margate Airport",
//     longName: "Margate Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "ZAF",
//       code: "ZA",
//       shortName: "South Africa",
//       longName: "South Africa",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "MGH",
//       shortName: "Margate",
//       longName: "Margate",
//     },
//   },
//   PZB: {
//     iataCode: "PZB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -29.65,
//       longitude: 30.4,
//     },
//     shortName: "Pietermaritzburg Airport",
//     longName: "Pietermaritzburg Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "ZAF",
//       code: "ZA",
//       shortName: "South Africa",
//       longName: "South Africa",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "RCB",
//       shortName: "Pietermaritzburg",
//       longName: "Pietermaritzburg",
//     },
//   },
//   RCB: {
//     iataCode: "RCB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -28.74,
//       longitude: 32.09,
//     },
//     shortName: "Richards Bay",
//     longName: "Richards Bay Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "ZAF",
//       code: "ZA",
//       shortName: "South Africa",
//       longName: "South Africa",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "RCB",
//       shortName: "Richards Bay",
//       longName: "Richards Bay",
//     },
//   },
//   HDS: {
//     iataCode: "HDS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -24.37,
//       longitude: 31.05,
//     },
//     shortName: "Hoedspruit Airport",
//     longName: "Hoedspruit Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "ZAF",
//       code: "ZA",
//       shortName: "South Africa",
//       longName: "South Africa",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "HDS",
//       shortName: "Hoedspruit",
//       longName: "Hoedspruit",
//     },
//   },
//   PTG: {
//     iataCode: "PTG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -23.85,
//       longitude: 29.46,
//     },
//     shortName: "Polokwane Airport",
//     longName: "Polokwane International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "ZAF",
//       code: "ZA",
//       shortName: "South Africa",
//       longName: "South Africa",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "PTG",
//       shortName: "Polokwane",
//       longName: "Polokwane",
//     },
//   },
//   MQP: {
//     iataCode: "MQP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -25.38,
//       longitude: 31.11,
//     },
//     shortName: "Kruger Airport",
//     longName: "Kruger Mpumalanga International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "ZAF",
//       code: "ZA",
//       shortName: "South Africa",
//       longName: "South Africa",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "NLP",
//       shortName: "Nelspruit",
//       longName: "Nelspruit",
//     },
//   },
//   SZK: {
//     iataCode: "SZK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -24.96,
//       longitude: 31.59,
//     },
//     shortName: "Skukuza Airport",
//     longName: "Skukuza Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "ZAF",
//       code: "ZA",
//       shortName: "South Africa",
//       longName: "South Africa",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "SZK",
//       shortName: "Skukuza",
//       longName: "Skukuza",
//     },
//   },
//   KIM: {
//     iataCode: "KIM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -28.8,
//       longitude: 24.76,
//     },
//     shortName: "Kimberley",
//     longName: "Kimberley Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "ZAF",
//       code: "ZA",
//       shortName: "South Africa",
//       longName: "South Africa",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "KIM",
//       shortName: "Kimberley",
//       longName: "Kimberley",
//     },
//   },
//   SIS: {
//     iataCode: "SIS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -27.65,
//       longitude: 23,
//     },
//     shortName: "Sishen Airport",
//     longName: "Sishen Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "ZAF",
//       code: "ZA",
//       shortName: "South Africa",
//       longName: "South Africa",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "SIS",
//       shortName: "Sishen",
//       longName: "Sishen",
//     },
//   },
//   UTN: {
//     iataCode: "UTN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -28.4,
//       longitude: 21.26,
//     },
//     shortName: "Upington Airport",
//     longName: "Upington Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "ZAF",
//       code: "ZA",
//       shortName: "South Africa",
//       longName: "South Africa",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "UTN",
//       shortName: "Upington",
//       longName: "Upington",
//     },
//   },
//   CPT: {
//     iataCode: "CPT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: -33.97,
//       longitude: 18.6,
//     },
//     shortName: "Cape Town",
//     longName: "Cape Town International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "ZAF",
//       code: "ZA",
//       shortName: "South Africa",
//       longName: "South Africa",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "CPT",
//       shortName: "Cape Town",
//       longName: "Cape Town",
//     },
//   },
//   GRJ: {
//     iataCode: "GRJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -34.01,
//       longitude: 22.37,
//     },
//     shortName: "George",
//     longName: "George Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "ZAF",
//       code: "ZA",
//       shortName: "South Africa",
//       longName: "South Africa",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "GRJ",
//       shortName: "George",
//       longName: "George",
//     },
//   },
//   PBZ: {
//     iataCode: "PBZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -34.09,
//       longitude: 23.33,
//     },
//     shortName: "Plettenberg Bay Airport",
//     longName: "Plettenberg Bay Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "ZAF",
//       code: "ZA",
//       shortName: "South Africa",
//       longName: "South Africa",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "PBZ",
//       shortName: "Plettenberg Bay",
//       longName: "Plettenberg Bay",
//     },
//   },
//   JUB: {
//     iataCode: "JUB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 4.87,
//       longitude: 31.6,
//     },
//     shortName: "Juba",
//     longName: "Juba International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "SSD",
//       code: "SS",
//       shortName: "South Sudan",
//       longName: "South Sudan",
//     },
//     city: {
//       code: "JUB",
//       shortName: "Juba",
//       longName: "Juba",
//     },
//   },
//   KRT: {
//     iataCode: "KRT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 15.59,
//       longitude: 32.55,
//     },
//     shortName: "Khartoum",
//     longName: "Khartoum Civil Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "SDN",
//       code: "SD",
//       shortName: "Sudan",
//       longName: "Sudan",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "KRT",
//       shortName: "Khartoum",
//       longName: "Khartoum",
//     },
//   },
//   PZU: {
//     iataCode: "PZU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 19.43,
//       longitude: 37.23,
//     },
//     shortName: "Port Sudan",
//     longName: "Port Sudan New International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "SDN",
//       code: "SD",
//       shortName: "Sudan",
//       longName: "Sudan",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "PZU",
//       shortName: "Port Sudan",
//       longName: "Port Sudan",
//     },
//   },
//   ARK: {
//     iataCode: "ARK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -3.37,
//       longitude: 36.63,
//     },
//     shortName: "Arusha Airport",
//     longName: "Arusha Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "TZA",
//       code: "TZ",
//       shortName: "Tanzania",
//       longName: "Tanzania",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "ARK",
//       shortName: "Arusha",
//       longName: "Arusha",
//     },
//   },
//   DOD: {
//     iataCode: "DOD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -6.17,
//       longitude: 35.75,
//     },
//     shortName: "Dodoma Airport",
//     longName: "Dodoma Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "TZA",
//       code: "TZ",
//       shortName: "Tanzania",
//       longName: "Tanzania",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "DOD",
//       shortName: "Dodoma",
//       longName: "Dodoma",
//     },
//   },
//   TKQ: {
//     iataCode: "TKQ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -4.89,
//       longitude: 29.67,
//     },
//     shortName: "Kigoma Airport",
//     longName: "Kigoma Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "TZA",
//       code: "TZ",
//       shortName: "Tanzania",
//       longName: "Tanzania",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "TKQ",
//       shortName: "Kigoma",
//       longName: "Kigoma",
//     },
//   },
//   MBI: {
//     iataCode: "MBI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -8.92,
//       longitude: 33.47,
//     },
//     shortName: "Mbeya Airport",
//     longName: "Mbeya Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "TZA",
//       code: "TZ",
//       shortName: "Tanzania",
//       longName: "Tanzania",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "MBI",
//       shortName: "Mbeya",
//       longName: "Mbeya",
//     },
//   },
//   MYW: {
//     iataCode: "MYW",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -10.34,
//       longitude: 40.18,
//     },
//     shortName: "Mtwara Airport",
//     longName: "Mtwara Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "TZA",
//       code: "TZ",
//       shortName: "Tanzania",
//       longName: "Tanzania",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "MYW",
//       shortName: "Mtwara",
//       longName: "Mtwara",
//     },
//   },
//   SGX: {
//     iataCode: "SGX",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -10.68,
//       longitude: 35.58,
//     },
//     shortName: "Songea Airport",
//     longName: "Songea Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "TZA",
//       code: "TZ",
//       shortName: "Tanzania",
//       longName: "Tanzania",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "SGX",
//       shortName: "Songea",
//       longName: "Songea",
//     },
//   },
//   DAR: {
//     iataCode: "DAR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: -6.88,
//       longitude: 39.2,
//     },
//     shortName: "Dar Es Salaam",
//     longName: "Dar Es Salaam International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "TZA",
//       code: "TZ",
//       shortName: "Tanzania",
//       longName: "Tanzania",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "DAR",
//       shortName: "Dar Es Salaam",
//       longName: "Dar Es Salaam",
//     },
//   },
//   JRO: {
//     iataCode: "JRO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -3.43,
//       longitude: 37.07,
//     },
//     shortName: "Kilimanjaro",
//     longName: "Kilimanjaro Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "TZA",
//       code: "TZ",
//       shortName: "Tanzania",
//       longName: "Tanzania",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "JRO",
//       shortName: "Kilimanjaro",
//       longName: "Kilimanjaro",
//     },
//   },
//   MWZ: {
//     iataCode: "MWZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -2.44,
//       longitude: 32.93,
//     },
//     shortName: "Mwanza Airport",
//     longName: "Mwanza Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "TZA",
//       code: "TZ",
//       shortName: "Tanzania",
//       longName: "Tanzania",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "MWZ",
//       shortName: "Mwanza",
//       longName: "Mwanza",
//     },
//   },
//   ZNZ: {
//     iataCode: "ZNZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -6.22,
//       longitude: 39.22,
//     },
//     shortName: "Zanzibar",
//     longName: "Zanzibar Abeid Amani Karume Int. Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "TZA",
//       code: "TZ",
//       shortName: "Tanzania",
//       longName: "Tanzania",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "ZNZ",
//       shortName: "Zanzibar",
//       longName: "Zanzibar",
//     },
//   },
//   TBO: {
//     iataCode: "TBO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -5.08,
//       longitude: 32.83,
//     },
//     shortName: "Tabora Airport",
//     longName: "Tabora Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "TZA",
//       code: "TZ",
//       shortName: "Tanzania",
//       longName: "Tanzania",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "TBO",
//       shortName: "Tabora",
//       longName: "Tabora",
//     },
//   },
//   LFW: {
//     iataCode: "LFW",
//     showAsOrigin: false,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 6.17,
//       longitude: 1.25,
//     },
//     shortName: "Lomé Airport",
//     longName: "Lomé-Tokoin Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "TGO",
//       code: "TG",
//       shortName: "Togo",
//       longName: "Togo",
//     },
//     city: {
//       code: "LFW",
//       shortName: "Lomé",
//       longName: "Lomé",
//     },
//   },
//   TUN: {
//     iataCode: "TUN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 36.85,
//       longitude: 10.23,
//     },
//     shortName: "Tunis",
//     longName: "Carthage Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "TUN",
//       code: "TN",
//       shortName: "Tunisia",
//       longName: "Tunisia",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "TUN",
//       shortName: "Tunis",
//       longName: "Tunis",
//     },
//   },
//   EBB: {
//     iataCode: "EBB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 0.04,
//       longitude: 32.44,
//     },
//     shortName: "Entebbe",
//     longName: "Entebbe Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "UGA",
//       code: "UG",
//       shortName: "Uganda",
//       longName: "Uganda",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "EBB",
//       shortName: "Entebbe",
//       longName: "Entebbe",
//     },
//   },
//   UMB: {
//     iataCode: "UMB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -14.33,
//       longitude: 26.45,
//     },
//     shortName: "Kalumbila Airport",
//     longName: "Kalumbila Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "ZMB",
//       code: "ZM",
//       shortName: "Zambia",
//       longName: "Zambia",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "UMB",
//       shortName: "Kalumbila",
//       longName: "Kalumbila",
//     },
//   },
//   NLA: {
//     iataCode: "NLA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -13,
//       longitude: 28.66,
//     },
//     shortName: "Ndola",
//     longName: "Ndola Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "ZMB",
//       code: "ZM",
//       shortName: "Zambia",
//       longName: "Zambia",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "NLA",
//       shortName: "Ndola",
//       longName: "Ndola",
//     },
//   },
//   CIP: {
//     iataCode: "CIP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -13.56,
//       longitude: 32.59,
//     },
//     shortName: "Chipata",
//     longName: "Chipata Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "ZMB",
//       code: "ZM",
//       shortName: "Zambia",
//       longName: "Zambia",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "CIP",
//       shortName: "Chipata",
//       longName: "Chipata",
//     },
//   },
//   MFU: {
//     iataCode: "MFU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -13.26,
//       longitude: 31.94,
//     },
//     shortName: "Mfuwe",
//     longName: "Mfuwe Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "ZMB",
//       code: "ZM",
//       shortName: "Zambia",
//       longName: "Zambia",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "MFU",
//       shortName: "Mfuwe",
//       longName: "Mfuwe",
//     },
//   },
//   MNS: {
//     iataCode: "MNS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -11.14,
//       longitude: 28.87,
//     },
//     shortName: "Mansa",
//     longName: "Mansa Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "ZMB",
//       code: "ZM",
//       shortName: "Zambia",
//       longName: "Zambia",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "MNS",
//       shortName: "Mansa",
//       longName: "Mansa",
//     },
//   },
//   JEK: {
//     iataCode: "JEK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -13.54,
//       longitude: 23.11,
//     },
//     shortName: "Jeki",
//     longName: "Jeki Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "ZMB",
//       code: "ZM",
//       shortName: "Zambia",
//       longName: "Zambia",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "JEK",
//       shortName: "Jeki",
//       longName: "Jeki",
//     },
//   },
//   LUN: {
//     iataCode: "LUN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: -15.33,
//       longitude: 28.46,
//     },
//     shortName: "Lusaka",
//     alternateNames: ["Lusaka International Airport"],
//     longName: "Kenneth Kaunda International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "ZMB",
//       code: "ZM",
//       shortName: "Zambia",
//       longName: "Zambia",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "LUN",
//       shortName: "Lusaka",
//       longName: "Lusaka",
//     },
//   },
//   RYL: {
//     iataCode: "RYL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -13.54,
//       longitude: 23.11,
//     },
//     shortName: "Lower Zambezi National Park",
//     longName: "Royal Airstrip, Lower Zambezi National Park",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "ZMB",
//       code: "ZM",
//       shortName: "Zambia",
//       longName: "Zambia",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "RYL",
//       shortName: "Royal Airstrip, Lower Zambezi National Park",
//       longName: "Royal Airstrip, Lower Zambezi National Park",
//     },
//   },
//   SLI: {
//     iataCode: "SLI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -12.17,
//       longitude: 26.37,
//     },
//     shortName: "Solwezi",
//     longName: "Solwezi Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "ZMB",
//       code: "ZM",
//       shortName: "Zambia",
//       longName: "Zambia",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "SLI",
//       shortName: "Solwezi",
//       longName: "Solwezi",
//     },
//   },
//   KAA: {
//     iataCode: "KAA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -10.22,
//       longitude: 31.13,
//     },
//     shortName: "Kasama",
//     longName: "Kasama Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "ZMB",
//       code: "ZM",
//       shortName: "Zambia",
//       longName: "Zambia",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "KAA",
//       shortName: "Kasama",
//       longName: "Kasama",
//     },
//   },
//   LVI: {
//     iataCode: "LVI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -17.81,
//       longitude: 25.82,
//     },
//     shortName: "Livingstone",
//     longName: "Livingstone Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "ZMB",
//       code: "ZM",
//       shortName: "Zambia",
//       longName: "Zambia",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "LVI",
//       shortName: "Livingstone",
//       longName: "Livingstone",
//     },
//   },
//   MNR: {
//     iataCode: "MNR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -15.25,
//       longitude: 23.16,
//     },
//     shortName: "Mongu",
//     longName: "Mongu Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "ZMB",
//       code: "ZM",
//       shortName: "Zambia",
//       longName: "Zambia",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "MNR",
//       shortName: "Mongu",
//       longName: "Mongu",
//     },
//   },
//   BUQ: {
//     iataCode: "BUQ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -20.02,
//       longitude: 28.62,
//     },
//     shortName: "Bulawayo Airport",
//     longName: "Bulawayo Joshua Mqabuko Nkomo International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "ZWE",
//       code: "ZW",
//       shortName: "Zimbabwe",
//       longName: "Zimbabwe",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "BUQ",
//       shortName: "Bulawayo",
//       longName: "Bulawayo",
//     },
//   },
//   HRE: {
//     iataCode: "HRE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: -17.93,
//       longitude: 31.09,
//     },
//     shortName: "Harare Airport",
//     alternateNames: ["Harare International Airport"],
//     longName: "Robert Gabriel Mugabe International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "ZWE",
//       code: "ZW",
//       shortName: "Zimbabwe",
//       longName: "Zimbabwe",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "HRE",
//       shortName: "Harare",
//       longName: "Harare",
//     },
//   },
//   VFA: {
//     iataCode: "VFA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -18.1,
//       longitude: 25.84,
//     },
//     shortName: "Victoria Falls Airport",
//     longName: "Victoria Falls International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Africa",
//       longName: "Africa",
//       code: "AFRI",
//     },
//     country: {
//       a3code: "ZWE",
//       code: "ZW",
//       shortName: "Zimbabwe",
//       longName: "Zimbabwe",
//       otherRegion: {
//         shortName: "Africa",
//         longName: "Africa",
//       },
//     },
//     city: {
//       code: "VFA",
//       shortName: "Victoria Falls",
//       longName: "Victoria Falls",
//     },
//   },
//   KBL: {
//     iataCode: "KBL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 34.57,
//       longitude: 69.21,
//     },
//     shortName: "Kabul",
//     longName: "Kabul International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AFG",
//       code: "AF",
//       shortName: "Afghanistan",
//       longName: "Afghanistan",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "KBL",
//       shortName: "Kabul",
//       longName: "Kabul",
//     },
//   },
//   HEA: {
//     iataCode: "HEA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 34.21,
//       longitude: 62.23,
//     },
//     shortName: "Herat Airport",
//     longName: "Herat Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AFG",
//       code: "AF",
//       shortName: "Afghanistan",
//       longName: "Afghanistan",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "HEA",
//       shortName: "Herat",
//       longName: "Herat",
//     },
//   },
//   KDH: {
//     iataCode: "KDH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 31.51,
//       longitude: 65.85,
//     },
//     shortName: "Kandahar Airport",
//     longName: "Kandahar Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AFG",
//       code: "AF",
//       shortName: "Afghanistan",
//       longName: "Afghanistan",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "KDH",
//       shortName: "Kandahar",
//       longName: "Kandahar",
//     },
//   },
//   KHT: {
//     iataCode: "KHT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 33.33,
//       longitude: 69.95,
//     },
//     shortName: "Khost Airport",
//     longName: "Khost Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AFG",
//       code: "AF",
//       shortName: "Afghanistan",
//       longName: "Afghanistan",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "KHT",
//       shortName: "Khost",
//       longName: "Khost",
//     },
//   },
//   MZR: {
//     iataCode: "MZR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 36.71,
//       longitude: 67.21,
//     },
//     shortName: "Mazar I Sharif Airport",
//     longName: "Mazar I Sharif Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AFG",
//       code: "AF",
//       shortName: "Afghanistan",
//       longName: "Afghanistan",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "MZR",
//       shortName: "Mazar I Sharif",
//       longName: "Mazar I Sharif",
//     },
//   },
//   EVN: {
//     iataCode: "EVN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 40.15,
//       longitude: 44.4,
//     },
//     shortName: "Yerevan",
//     longName: "Zvartnots International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "ARM",
//       code: "AM",
//       shortName: "Armenia",
//       longName: "Armenia",
//     },
//     city: {
//       code: "EVN",
//       shortName: "Yerevan",
//       longName: "Yerevan",
//     },
//   },
//   CBR: {
//     iataCode: "CBR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -35.31,
//       longitude: 149.2,
//     },
//     shortName: "Canberra",
//     longName: "Canberra International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "CBR",
//       shortName: "Canberra",
//       longName: "Canberra",
//     },
//   },
//   ABX: {
//     iataCode: "ABX",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -36.07,
//       longitude: 146.96,
//     },
//     shortName: "Albury",
//     longName: "Albury Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "ABX",
//       shortName: "Albury",
//       longName: "Albury",
//     },
//   },
//   ARM: {
//     iataCode: "ARM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -30.53,
//       longitude: 151.62,
//     },
//     shortName: "Armidale",
//     longName: "Armidale Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "ARM",
//       shortName: "Armidale",
//       longName: "Armidale",
//     },
//   },
//   BNK: {
//     iataCode: "BNK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -28.83,
//       longitude: 153.56,
//     },
//     shortName: "Ballina",
//     longName: "Ballina Byron Gateway Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "BNK",
//       shortName: "Ballina",
//       longName: "Ballina",
//     },
//   },
//   CFS: {
//     iataCode: "CFS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -30.32,
//       longitude: 153.12,
//     },
//     shortName: "Coffs Harbour",
//     longName: "Coffs Harbour Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "CFS",
//       shortName: "Coffs Harbour",
//       longName: "Coffs Harbour",
//     },
//   },
//   DBO: {
//     iataCode: "DBO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -32.22,
//       longitude: 148.57,
//     },
//     shortName: "Dubbo",
//     longName: "Dubbo Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "DBO",
//       shortName: "Dubbo",
//       longName: "Dubbo",
//     },
//   },
//   MRZ: {
//     iataCode: "MRZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -29.5,
//       longitude: 149.84,
//     },
//     shortName: "Moree",
//     longName: "Moree Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "MRZ",
//       shortName: "Moree",
//       longName: "Moree",
//     },
//   },
//   NTL: {
//     iataCode: "NTL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -32.79,
//       longitude: 151.83,
//     },
//     shortName: "Newcastle",
//     longName: "Newcastle Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "NTL",
//       shortName: "Newcastle",
//       longName: "Newcastle",
//     },
//   },
//   PQQ: {
//     iataCode: "PQQ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -31.44,
//       longitude: 152.86,
//     },
//     shortName: "Port Macquarie",
//     longName: "Port Macquarie Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "PQQ",
//       shortName: "Port Macquarie",
//       longName: "Port Macquarie",
//     },
//   },
//   SYD: {
//     iataCode: "SYD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: -33.95,
//       longitude: 151.18,
//     },
//     shortName: "Sydney",
//     longName: "Kingsford Smith Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "SYD",
//       shortName: "Sydney",
//       longName: "Sydney",
//     },
//   },
//   TMW: {
//     iataCode: "TMW",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -31.08,
//       longitude: 150.85,
//     },
//     shortName: "Tamworth",
//     longName: "Tamworth Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "TMW",
//       shortName: "Tamworth",
//       longName: "Tamworth",
//     },
//   },
//   WGA: {
//     iataCode: "WGA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -35.17,
//       longitude: 147.47,
//     },
//     shortName: "Wagga Wagga",
//     longName: "Wagga Wagga Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "WGA",
//       shortName: "Wagga Wagga",
//       longName: "Wagga Wagga",
//     },
//   },
//   ASP: {
//     iataCode: "ASP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -23.81,
//       longitude: 133.9,
//     },
//     shortName: "Alice Springs",
//     longName: "Alice Springs Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "ASP",
//       shortName: "Alice Springs",
//       longName: "Alice Springs",
//     },
//   },
//   DRW: {
//     iataCode: "DRW",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -12.41,
//       longitude: 130.88,
//     },
//     shortName: "Darwin",
//     longName: "Darwin International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "DRW",
//       shortName: "Darwin",
//       longName: "Darwin",
//     },
//   },
//   GOV: {
//     iataCode: "GOV",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -12.27,
//       longitude: 136.82,
//     },
//     shortName: "Gove",
//     longName: "Gove Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "GOV",
//       shortName: "Gove",
//       longName: "Gove",
//     },
//   },
//   AYQ: {
//     iataCode: "AYQ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -25.19,
//       longitude: 130.98,
//     },
//     shortName: "Ayers Rock",
//     longName: "Ayers Rock Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "AYQ",
//       shortName: "Uluru",
//       longName: "Uluru",
//     },
//   },
//   BCI: {
//     iataCode: "BCI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -23.57,
//       longitude: 145.31,
//     },
//     shortName: "Barcaldine",
//     longName: "Barcaldine Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "BCI",
//       shortName: "Barcaldine",
//       longName: "Barcaldine",
//     },
//   },
//   ZBL: {
//     iataCode: "ZBL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -24.42,
//       longitude: 150.5,
//     },
//     shortName: "Biloela",
//     longName: "Biloela",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "ZBL",
//       shortName: "Bilbao",
//       longName: "Biloela",
//     },
//   },
//   BKQ: {
//     iataCode: "BKQ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -24.43,
//       longitude: 145.43,
//     },
//     shortName: "Blackall",
//     longName: "Blackall Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "BKQ",
//       shortName: "Blackall",
//       longName: "Blackall",
//     },
//   },
//   BNE: {
//     iataCode: "BNE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: -27.38,
//       longitude: 153.12,
//     },
//     shortName: "Brisbane",
//     longName: "Brisbane Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "BNE",
//       shortName: "Brisbane",
//       longName: "Brisbane",
//     },
//   },
//   BDB: {
//     iataCode: "BDB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -24.9,
//       longitude: 152.32,
//     },
//     shortName: "Bundaberg",
//     longName: "Bundaberg Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "BDB",
//       shortName: "Bundaberg",
//       longName: "Bundaberg",
//     },
//   },
//   CNS: {
//     iataCode: "CNS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -16.89,
//       longitude: 145.76,
//     },
//     shortName: "Cairns",
//     longName: "Cairns Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "CNS",
//       shortName: "Cairns",
//       longName: "Cairns",
//     },
//   },
//   CTL: {
//     iataCode: "CTL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -26.41,
//       longitude: 146.26,
//     },
//     shortName: "Charleville",
//     longName: "Charleville Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "CTL",
//       shortName: "Charleville",
//       longName: "Charleville",
//     },
//   },
//   CNJ: {
//     iataCode: "CNJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -20.67,
//       longitude: 140.51,
//     },
//     shortName: "Cloncurry",
//     longName: "Cloncurry Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "CNJ",
//       shortName: "Cloncurry",
//       longName: "Cloncurry",
//     },
//   },
//   EMD: {
//     iataCode: "EMD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -23.57,
//       longitude: 148.18,
//     },
//     shortName: "Emerald",
//     longName: "Emerald Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "EMD",
//       shortName: "Emerald",
//       longName: "Emerald",
//     },
//   },
//   GLT: {
//     iataCode: "GLT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -23.87,
//       longitude: 151.22,
//     },
//     shortName: "Gladstone",
//     longName: "Gladstone Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "GLT",
//       shortName: "Gladstone",
//       longName: "Gladstone",
//     },
//   },
//   OOL: {
//     iataCode: "OOL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -28.16,
//       longitude: 153.5,
//     },
//     shortName: "Gold Coast",
//     longName: "Gold Coast Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "OOL",
//       shortName: "Gold Coast",
//       longName: "Gold Coast",
//     },
//   },
//   HTI: {
//     iataCode: "HTI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -20.36,
//       longitude: 148.95,
//     },
//     shortName: "Hamilton Island",
//     longName: "Hamilton Island Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "HTI",
//       shortName: "Hamilton Island",
//       longName: "Hamilton Island",
//     },
//   },
//   HVB: {
//     iataCode: "HVB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -25.32,
//       longitude: 152.88,
//     },
//     shortName: "Hervey Bay",
//     longName: "Hervey Bay Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "HVB",
//       shortName: "Hervey Bay",
//       longName: "Hervey Bay",
//     },
//   },
//   HID: {
//     iataCode: "HID",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -10.59,
//       longitude: 142.29,
//     },
//     shortName: "Horn Island",
//     longName: "Horn Island Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "HID",
//       shortName: "Horn Island",
//       longName: "Horn Island",
//     },
//   },
//   LRE: {
//     iataCode: "LRE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -23.43,
//       longitude: 144.28,
//     },
//     shortName: "Longreach",
//     longName: "Longreach Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "LRE",
//       shortName: "Longreach",
//       longName: "Longreach",
//     },
//   },
//   MKY: {
//     iataCode: "MKY",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -21.17,
//       longitude: 149.18,
//     },
//     shortName: "Mackay",
//     longName: "Mackay Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "MKY",
//       shortName: "Mackay",
//       longName: "Mackay",
//     },
//   },
//   MOV: {
//     iataCode: "MOV",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -22.06,
//       longitude: 148.08,
//     },
//     shortName: "Moranbah",
//     longName: "Moranbah Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "MOV",
//       shortName: "Moranbah",
//       longName: "Moranbah",
//     },
//   },
//   ISA: {
//     iataCode: "ISA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -20.66,
//       longitude: 139.49,
//     },
//     shortName: "Mount Isa",
//     longName: "Mount Isa Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "ISA",
//       shortName: "Mount Isa",
//       longName: "Mount Isa",
//     },
//   },
//   PPP: {
//     iataCode: "PPP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -20.49,
//       longitude: 148.55,
//     },
//     shortName: "Proserpine",
//     longName: "Whitsunday Coast Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "PPP",
//       shortName: "Proserpine",
//       longName: "Proserpine",
//     },
//   },
//   ROK: {
//     iataCode: "ROK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -23.38,
//       longitude: 150.48,
//     },
//     shortName: "Rockhampton",
//     longName: "Rockhampton Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "ROK",
//       shortName: "Rockhampton",
//       longName: "Rockhampton",
//     },
//   },
//   RMA: {
//     iataCode: "RMA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -26.54,
//       longitude: 148.77,
//     },
//     shortName: "Roma ",
//     longName: "Roma Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "RMA",
//       shortName: "Roma",
//       longName: "Roma (AU)",
//     },
//   },
//   MCY: {
//     iataCode: "MCY",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -26.6,
//       longitude: 153.09,
//     },
//     shortName: "Sunshine Coast",
//     longName: "Sunshine Coast Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "MCY",
//       shortName: "Sunshine Coast",
//       longName: "Sunshine Coast",
//     },
//   },
//   TSV: {
//     iataCode: "TSV",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -19.25,
//       longitude: 146.77,
//     },
//     shortName: "Townsville",
//     longName: "Townsville International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "TSV",
//       shortName: "Townsville",
//       longName: "Townsville",
//     },
//   },
//   WEI: {
//     iataCode: "WEI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -12.68,
//       longitude: 141.93,
//     },
//     shortName: "Weipa",
//     longName: "Weipa Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "WEI",
//       shortName: "Weipa",
//       longName: "Weipa",
//     },
//   },
//   ADL: {
//     iataCode: "ADL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: -34.94,
//       longitude: 138.53,
//     },
//     shortName: "Adelaide",
//     longName: "Adelaide Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "ADL",
//       shortName: "Adelaide",
//       longName: "Adelaide",
//     },
//   },
//   OLP: {
//     iataCode: "OLP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -30.48,
//       longitude: 136.88,
//     },
//     shortName: "Olympic Dam",
//     longName: "Olympic Dam Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "OLP",
//       shortName: "Olympic Dam",
//       longName: "Olympic Dam",
//     },
//   },
//   PLO: {
//     iataCode: "PLO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -34.61,
//       longitude: 135.88,
//     },
//     shortName: "Port Lincoln",
//     longName: "Port Lincoln Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "PLO",
//       shortName: "Port Lincoln",
//       longName: "Port Lincoln",
//     },
//   },
//   DPO: {
//     iataCode: "DPO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -41.17,
//       longitude: 146.43,
//     },
//     shortName: "Devonport",
//     longName: "Devonport Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "DPO",
//       shortName: "Devonport",
//       longName: "Devonport",
//     },
//   },
//   HBA: {
//     iataCode: "HBA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -42.84,
//       longitude: 147.51,
//     },
//     shortName: "Hobart",
//     longName: "Hobart International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "HBA",
//       shortName: "Hobart",
//       longName: "Hobart",
//     },
//   },
//   LST: {
//     iataCode: "LST",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -41.55,
//       longitude: 147.21,
//     },
//     shortName: "Launceston",
//     longName: "Launceston Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "LST",
//       shortName: "Launceston",
//       longName: "Launceston",
//     },
//   },
//   MEL: {
//     iataCode: "MEL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: -37.67,
//       longitude: 144.84,
//     },
//     shortName: "Melbourne",
//     longName: "Melbourne Tullamarine Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "MEL",
//       shortName: "Melbourne",
//       longName: "Melbourne",
//     },
//   },
//   MQL: {
//     iataCode: "MQL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -34.23,
//       longitude: 142.09,
//     },
//     shortName: "Mildura",
//     longName: "Mildura Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "MQL",
//       shortName: "Mildura",
//       longName: "Mildura",
//     },
//   },
//   MHU: {
//     iataCode: "MHU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -37.05,
//       longitude: 147.33,
//     },
//     shortName: "Mount Hotham",
//     longName: "Mount Hotham Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "MHU",
//       shortName: "Mount Hotham",
//       longName: "Mount Hotham",
//     },
//   },
//   BME: {
//     iataCode: "BME",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -17.95,
//       longitude: 122.23,
//     },
//     shortName: "Broome",
//     longName: "Broome International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "BME",
//       shortName: "Broome",
//       longName: "Broome",
//     },
//   },
//   GET: {
//     iataCode: "GET",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -28.8,
//       longitude: 114.71,
//     },
//     shortName: "Geraldton",
//     longName: "Geraldton Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "GET",
//       shortName: "Geraldton",
//       longName: "Geraldton",
//     },
//   },
//   KGI: {
//     iataCode: "KGI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -30.79,
//       longitude: 121.46,
//     },
//     shortName: "Kalgoorlie",
//     longName: "Kalgoorlie-Boulder Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "KGI",
//       shortName: "Kalgoorlie",
//       longName: "Kalgoorlie",
//     },
//   },
//   KTA: {
//     iataCode: "KTA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -20.71,
//       longitude: 116.77,
//     },
//     shortName: "Karratha",
//     longName: "Karratha Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "KTA",
//       shortName: "Karratha",
//       longName: "Karratha",
//     },
//   },
//   LEA: {
//     iataCode: "LEA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -22.24,
//       longitude: 114.09,
//     },
//     shortName: "Learmonth",
//     longName: "Learmonth Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "LEA",
//       shortName: "Learmonth",
//       longName: "Learmonth (Exmouth)",
//     },
//   },
//   ZNE: {
//     iataCode: "ZNE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -23.42,
//       longitude: 119.8,
//     },
//     shortName: "Newman",
//     longName: "Newman Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "ZNE",
//       shortName: "Newman",
//       longName: "Newman",
//     },
//   },
//   PBO: {
//     iataCode: "PBO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -23.17,
//       longitude: 117.75,
//     },
//     shortName: "Paraburdoo",
//     longName: "Paraburdoo Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "PBO",
//       shortName: "Paraburdoo",
//       longName: "Paraburdoo",
//     },
//   },
//   PER: {
//     iataCode: "PER",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: -31.94,
//       longitude: 115.97,
//     },
//     shortName: "Perth",
//     longName: "Perth Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "PER",
//       shortName: "Perth",
//       longName: "Perth",
//     },
//   },
//   PHE: {
//     iataCode: "PHE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -20.38,
//       longitude: 118.63,
//     },
//     shortName: "Port Hedland",
//     longName: "Port Hedland International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "PHE",
//       shortName: "Port Hedland",
//       longName: "Port Hedland",
//     },
//   },
//   BXG: {
//     iataCode: "BXG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -36.74,
//       longitude: 144.33,
//     },
//     shortName: "Bendigo Airport",
//     longName: "Bendigo Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "BXG",
//       shortName: "Bendigo",
//       longName: "Bendigo",
//     },
//   },
//   BWT: {
//     iataCode: "BWT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -41,
//       longitude: 145.73,
//     },
//     shortName: "Burnie Airport",
//     longName: "Burnie Wynyard Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "BWT",
//       shortName: "Burnie",
//       longName: "Burnie",
//     },
//   },
//   OOM: {
//     iataCode: "OOM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -36.3,
//       longitude: 148.97,
//     },
//     shortName: "Cooma Airport",
//     longName: "Cooma Snowy Mountains Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "OOM",
//       shortName: "Cooma",
//       longName: "Cooma",
//     },
//   },
//   GFF: {
//     iataCode: "GFF",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -34.25,
//       longitude: 146.07,
//     },
//     shortName: "Griffith Airport",
//     longName: "Griffith Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "GFF",
//       shortName: "Griffith",
//       longName: "Griffith",
//     },
//   },
//   LDH: {
//     iataCode: "LDH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -31.54,
//       longitude: 159.08,
//     },
//     shortName: "Lord Howe Island",
//     longName: "Lord Howe Island Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "LDH",
//       shortName: "Lord Howe Island",
//       longName: "Lord Howe Island",
//     },
//   },
//   MGB: {
//     iataCode: "MGB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -37.75,
//       longitude: 140.79,
//     },
//     shortName: "Mount Gambier Airport",
//     longName: "Mount Gambier Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "MGB",
//       shortName: "Mount Gambier ",
//       longName: "Mount Gambier ",
//     },
//   },
//   ONS: {
//     iataCode: "ONS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -21.67,
//       longitude: 115.1,
//     },
//     shortName: "Onslow Airport",
//     longName: "Onslow Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "ONS",
//       shortName: "Onslow ",
//       longName: "Onslow ",
//     },
//   },
//   OAG: {
//     iataCode: "OAG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -33.38,
//       longitude: 149.13,
//     },
//     shortName: "Orange Airport",
//     longName: "Orange Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AUS",
//       code: "AU",
//       shortName: "Australia",
//       longName: "Australia",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "OAG",
//       shortName: "Orange ",
//       longName: "Orange ",
//     },
//   },
//   GYD: {
//     iataCode: "GYD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 40.47,
//       longitude: 50.05,
//     },
//     shortName: "Baku",
//     longName: "Heydar Aliyev International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AZE",
//       code: "AZ",
//       shortName: "Azerbaijan",
//       longName: "Azerbaijan",
//     },
//     city: {
//       code: "GYD",
//       shortName: "Baku",
//       longName: "Baku",
//     },
//   },
//   GBB: {
//     iataCode: "GBB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 40.83,
//       longitude: 47.71,
//     },
//     shortName: "Gabala Airport",
//     longName: "Gabala International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "AZE",
//       code: "AZ",
//       shortName: "Azerbaijan",
//       longName: "Azerbaijan",
//     },
//     city: {
//       code: "GBB",
//       shortName: "Gabala",
//       longName: "Gabala",
//     },
//   },
//   CGP: {
//     iataCode: "CGP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 22.26,
//       longitude: 91.82,
//     },
//     shortName: "Chittagong",
//     longName: "Shah Amanat International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "BGD",
//       code: "BD",
//       shortName: "Bangladesh",
//       longName: "Bangladesh",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "CGP",
//       shortName: "Chittagong",
//       longName: "Chittagong",
//     },
//   },
//   DAC: {
//     iataCode: "DAC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 23.84,
//       longitude: 90.4,
//     },
//     shortName: "Dhaka",
//     longName: "Hazrat Shahjalal International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "BGD",
//       code: "BD",
//       shortName: "Bangladesh",
//       longName: "Bangladesh",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "DAC",
//       shortName: "Dhaka",
//       longName: "Dhaka",
//     },
//   },
//   ZYL: {
//     iataCode: "ZYL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 24.96,
//       longitude: 91.87,
//     },
//     shortName: "Sylhet Airport",
//     longName: "Sylhet MAG Osmani International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "BGD",
//       code: "BD",
//       shortName: "Bangladesh",
//       longName: "Bangladesh",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "ZYL",
//       shortName: "Sylhet",
//       longName: "Sylhet",
//     },
//   },
//   BZL: {
//     iataCode: "BZL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 22.8,
//       longitude: 90.3,
//     },
//     shortName: "Barisal Airport",
//     longName: "Barisal Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "BGD",
//       code: "BD",
//       shortName: "Bangladesh",
//       longName: "Bangladesh",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "BZL",
//       shortName: "Barisal",
//       longName: "Barisal",
//     },
//   },
//   CXB: {
//     iataCode: "CXB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 21.45,
//       longitude: 91.96,
//     },
//     shortName: "Cox's Bazar Airport",
//     longName: "Cox's Bazar Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "BGD",
//       code: "BD",
//       shortName: "Bangladesh",
//       longName: "Bangladesh",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "CXB",
//       shortName: "Cox's Bazar",
//       longName: "Cox's Bazar",
//     },
//   },
//   JSR: {
//     iataCode: "JSR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 23.18,
//       longitude: 89.16,
//     },
//     shortName: "Jashore Airport",
//     longName: "Jashore Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "BGD",
//       code: "BD",
//       shortName: "Bangladesh",
//       longName: "Bangladesh",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "JSR",
//       shortName: "Jashore",
//       longName: "Jashore",
//     },
//   },
//   RJH: {
//     iataCode: "RJH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 24.44,
//       longitude: 88.62,
//     },
//     shortName: "Rajshahi Airport",
//     longName: "Rajshahi Shah Mokhdum Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "BGD",
//       code: "BD",
//       shortName: "Bangladesh",
//       longName: "Bangladesh",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "RJH",
//       shortName: "Rajshahi",
//       longName: "Rajshahi",
//     },
//   },
//   SPD: {
//     iataCode: "SPD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 25.76,
//       longitude: 88.91,
//     },
//     shortName: "Saidpur Airport",
//     longName: "Saidpur Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "BGD",
//       code: "BD",
//       shortName: "Bangladesh",
//       longName: "Bangladesh",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "SPD",
//       shortName: "Saidpur",
//       longName: "Saidpur",
//     },
//   },
//   BWN: {
//     iataCode: "BWN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 4.94,
//       longitude: 114.93,
//     },
//     shortName: "Brunei Airport",
//     longName: "Brunei International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "BRN",
//       code: "BN",
//       shortName: "Brunei Darussalam",
//       longName: "Brunei Darussalam",
//     },
//     city: {
//       code: "BWN",
//       shortName: "Bandar Seri Begawan",
//       longName: "Bandar Seri Begawan",
//     },
//   },
//   PNH: {
//     iataCode: "PNH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 11.55,
//       longitude: 104.84,
//     },
//     shortName: "Phnom Penh",
//     longName: "Phnom Penh International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "KHM",
//       code: "KH",
//       shortName: "Cambodia",
//       longName: "Cambodia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "PNH",
//       shortName: "Phnom Penh",
//       longName: "Phnom Penh",
//     },
//   },
//   SAI: {
//     iataCode: "SAI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 13.41,
//       longitude: 103.81,
//     },
//     shortName: "Siem Reap Angkor Airport",
//     longName: "Siem Reap Angkor International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "KHM",
//       code: "KH",
//       shortName: "Cambodia",
//       longName: "Cambodia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "REP",
//       shortName: "Siem Reap",
//       longName: "Siem Reap",
//     },
//   },
//   KTI: {
//     iataCode: "KTI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 12.49,
//       longitude: 106.06,
//     },
//     shortName: "Phnom Penh Airport",
//     longName: "Phnom Penh Techo International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "KHM",
//       code: "KH",
//       shortName: "Cambodia",
//       longName: "Cambodia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "KTI",
//       shortName: "Phnom Penh",
//       longName: "Phnom Penh Krong Ta Khmau",
//     },
//   },
//   KOS: {
//     iataCode: "KOS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 10.58,
//       longitude: 103.64,
//     },
//     shortName: "Sihanoukville International Airport",
//     longName: "Sihanoukville International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "KHM",
//       code: "KH",
//       shortName: "Cambodia",
//       longName: "Cambodia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "KOS",
//       shortName: "Sihanoukville",
//       longName: "Sihanoukville",
//     },
//   },
//   HFE: {
//     iataCode: "HFE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 31.78,
//       longitude: 117.3,
//     },
//     shortName: "Hefei",
//     longName: "Hefei Luogang International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "HFE",
//       shortName: "Hefei",
//       longName: "Hefei",
//     },
//   },
//   PEK: {
//     iataCode: "PEK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 40.07,
//       longitude: 116.6,
//     },
//     shortName: "Beijing",
//     longName: "Beijing Capital Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "BJS",
//       shortName: "Beijing",
//       longName: "Beijing",
//     },
//   },
//   PKX: {
//     iataCode: "PKX",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 39.78,
//       longitude: 116.39,
//     },
//     shortName: "Daxing Airport",
//     longName: "Beijing Daxing Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "BJS",
//       shortName: "Beijing",
//       longName: "Beijing",
//     },
//   },
//   CKG: {
//     iataCode: "CKG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 29.72,
//       longitude: 106.64,
//     },
//     shortName: "Chongqing",
//     longName: "Chongqing Jiangbei International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "CKG",
//       shortName: "Chongqing",
//       longName: "Chongqing",
//     },
//   },
//   MIG: {
//     iataCode: "MIG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 31.43,
//       longitude: 104.74,
//     },
//     shortName: "Mianyang Airport",
//     longName: "Mianyang Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "MIG",
//       shortName: "Mianyang",
//       longName: "Mianyang",
//     },
//   },
//   WXN: {
//     iataCode: "WXN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 30.8,
//       longitude: 108.43,
//     },
//     shortName: "Wanzhou Airport",
//     longName: "Wanzhou Wuqiao Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "WXN",
//       shortName: "Wanzhou",
//       longName: "Wanzhou",
//     },
//   },
//   ZHY: {
//     iataCode: "ZHY",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 37.57,
//       longitude: 105.15,
//     },
//     shortName: "Zhongwei Airport",
//     longName: "Zhongwei Shapotou Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "ZHY",
//       shortName: "Zhongwei",
//       longName: "Zhongwei",
//     },
//   },
//   FOC: {
//     iataCode: "FOC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 25.93,
//       longitude: 119.66,
//     },
//     shortName: "Fuzhou",
//     longName: "Fuzhou Changle International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "FOC",
//       shortName: "Fuzhou",
//       longName: "Fuzhou",
//     },
//   },
//   XMN: {
//     iataCode: "XMN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 24.54,
//       longitude: 118.13,
//     },
//     shortName: "Xiamen",
//     longName: "Xiamen Gaoqi International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "XMN",
//       shortName: "Xiamen",
//       longName: "Xiamen",
//     },
//   },
//   LHW: {
//     iataCode: "LHW",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 36.52,
//       longitude: 103.62,
//     },
//     shortName: "Lanzhou",
//     longName: "Lanzhou Zhongchuan Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "LHW",
//       shortName: "Lanzhou",
//       longName: "Lanzhou",
//     },
//   },
//   CAN: {
//     iataCode: "CAN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 23.39,
//       longitude: 113.31,
//     },
//     shortName: "Guangzhou",
//     longName: "Guangzhou Baiyun International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "CAN",
//       shortName: "Guangzhou",
//       longName: "Guangzhou",
//     },
//   },
//   SWA: {
//     iataCode: "SWA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 23.43,
//       longitude: 116.76,
//     },
//     shortName: "Shantou",
//     longName: "Jieyang Chaoshan Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "SWA",
//       shortName: "Shantou",
//       longName: "Shantou",
//     },
//   },
//   SZX: {
//     iataCode: "SZX",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 22.64,
//       longitude: 113.81,
//     },
//     shortName: "Shenzhen International Airport",
//     longName: "Shenzhen Bao'an International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "SZX",
//       shortName: "Shenzhen",
//       longName: "Shenzhen",
//     },
//   },
//   ZHA: {
//     iataCode: "ZHA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 21.21,
//       longitude: 110.36,
//     },
//     shortName: "Zhanjiang Airport",
//     longName: "Zhanjiang Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "ZHA",
//       shortName: "Zhanjiang",
//       longName: "Zhanjiang",
//     },
//   },
//   KWL: {
//     iataCode: "KWL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 25.22,
//       longitude: 110.04,
//     },
//     shortName: "Guilin",
//     longName: "Guilin Liangjiang International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "KWL",
//       shortName: "Guilin",
//       longName: "Guilin",
//     },
//   },
//   LZH: {
//     iataCode: "LZH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 24.21,
//       longitude: 109.39,
//     },
//     shortName: "Liuzhou",
//     longName: "Liuzhou Bailian Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "LZH",
//       shortName: "Liuzhou",
//       longName: "Liuzhou",
//     },
//   },
//   NNG: {
//     iataCode: "NNG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 22.62,
//       longitude: 108.18,
//     },
//     shortName: "Nanning",
//     longName: "Nanning Wuxu International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "NNG",
//       shortName: "Nanning",
//       longName: "Nanning",
//     },
//   },
//   KWE: {
//     iataCode: "KWE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 26.54,
//       longitude: 106.8,
//     },
//     shortName: "Guiyang",
//     longName: "Guiyang Longdongbao International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "KWE",
//       shortName: "Guiyang",
//       longName: "Guiyang",
//     },
//   },
//   HAK: {
//     iataCode: "HAK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 19.93,
//       longitude: 110.46,
//     },
//     shortName: "Haikou",
//     longName: "Haikou Meilan International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "HAK",
//       shortName: "Haikou",
//       longName: "Haikou",
//     },
//   },
//   SYX: {
//     iataCode: "SYX",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 18.3,
//       longitude: 109.41,
//     },
//     shortName: "Sanya",
//     longName: "Sanya Phoenix International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "SYX",
//       shortName: "Sanya",
//       longName: "Sanya",
//     },
//   },
//   HRB: {
//     iataCode: "HRB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 45.62,
//       longitude: 126.25,
//     },
//     shortName: "Harbin",
//     longName: "Harbin Taiping International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "HRB",
//       shortName: "Harbin",
//       longName: "Harbin",
//     },
//   },
//   LYA: {
//     iataCode: "LYA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 34.74,
//       longitude: 112.39,
//     },
//     shortName: "Luoyang",
//     longName: "Luoyang Beijiao Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "LYA",
//       shortName: "Luoyang",
//       longName: "Luoyang",
//     },
//   },
//   CGO: {
//     iataCode: "CGO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 34.52,
//       longitude: 113.84,
//     },
//     shortName: "Zhengzhou",
//     longName: "Zhengzhou Xinzheng International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "CGO",
//       shortName: "Zhengzhou",
//       longName: "Zhengzhou",
//     },
//   },
//   WUH: {
//     iataCode: "WUH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 30.79,
//       longitude: 114.21,
//     },
//     shortName: "Wuhan",
//     longName: "Wuhan Tianhe International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "WUH",
//       shortName: "Wuhan",
//       longName: "Wuhan",
//     },
//   },
//   CSX: {
//     iataCode: "CSX",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 28.2,
//       longitude: 113.22,
//     },
//     shortName: "Changsha",
//     longName: "Changsha Huanghua International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "CSX",
//       shortName: "Changsha",
//       longName: "Changsha",
//     },
//   },
//   BAV: {
//     iataCode: "BAV",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 40.56,
//       longitude: 110,
//     },
//     shortName: "Baotou Airport",
//     longName: "Baotou Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "BAV",
//       shortName: "Baotou",
//       longName: "Baotou",
//     },
//   },
//   HET: {
//     iataCode: "HET",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 40.85,
//       longitude: 111.82,
//     },
//     shortName: "Hohhot Airport",
//     longName: "Hohhot Baita International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "HET",
//       shortName: "Hohhot",
//       longName: "Hohhot",
//     },
//   },
//   NKG: {
//     iataCode: "NKG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 31.74,
//       longitude: 118.86,
//     },
//     shortName: "Nanjing",
//     longName: "Nanjing Lukou International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "NKG",
//       shortName: "Nanjing",
//       longName: "Nanjing",
//     },
//   },
//   KHN: {
//     iataCode: "KHN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 28.87,
//       longitude: 115.9,
//     },
//     shortName: "Nanchang",
//     longName: "Nanchang Changbei International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "KHN",
//       shortName: "Nanchang",
//       longName: "Nanchang",
//     },
//   },
//   CGQ: {
//     iataCode: "CGQ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 44,
//       longitude: 125.68,
//     },
//     shortName: "Changchun Airport",
//     longName: "Changchun Longjia Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "CGQ",
//       shortName: "Changchun",
//       longName: "Changchun",
//     },
//   },
//   GXH: {
//     iataCode: "GXH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 34.81,
//       longitude: 102.64,
//     },
//     shortName: "Xiahe Airport",
//     longName: "Xiahe Gannan Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "GXH",
//       shortName: "Xiahe",
//       longName: "Xiahe",
//     },
//   },
//   YNJ: {
//     iataCode: "YNJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 42.88,
//       longitude: 129.45,
//     },
//     shortName: "Yanji Airport",
//     longName: "Yanji Chaoyangchuan Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "YNJ",
//       shortName: "Yanji",
//       longName: "Yanji",
//     },
//   },
//   DLC: {
//     iataCode: "DLC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 38.96,
//       longitude: 121.54,
//     },
//     shortName: "Dalian",
//     longName: "Dalian Zhoushuizi International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "DLC",
//       shortName: "Dalian",
//       longName: "Dalian",
//     },
//   },
//   SHE: {
//     iataCode: "SHE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 41.64,
//       longitude: 123.49,
//     },
//     shortName: "Shenyang",
//     longName: "Shenyang Taoxian International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "SHE",
//       shortName: "Shenyang",
//       longName: "Shenyang",
//     },
//   },
//   SIA: {
//     iataCode: "SIA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 34.45,
//       longitude: 108.75,
//     },
//     shortName: "Xi'an",
//     longName: "Xi'an Xiguan Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "XIY",
//       shortName: "Xi'an",
//       longName: "Xi'an",
//     },
//   },
//   XIY: {
//     iataCode: "XIY",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 34.45,
//       longitude: 108.75,
//     },
//     shortName: "Xi'an Airport",
//     longName: "Xi'an Xianyang International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "XIY",
//       shortName: "Xi'an",
//       longName: "Xi'an",
//     },
//   },
//   TAO: {
//     iataCode: "TAO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 36.27,
//       longitude: 120.38,
//     },
//     shortName: "Qingdao Airport",
//     longName: "Qingdao Jiaodong International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "TAO",
//       shortName: "Qingdao",
//       longName: "Qingdao",
//     },
//   },
//   PVG: {
//     iataCode: "PVG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 31.14,
//       longitude: 121.79,
//     },
//     shortName: "Shanghai Pudong International Airport",
//     longName: "Pudong International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "SHA",
//       shortName: "Shanghai",
//       longName: "Shanghai",
//     },
//   },
//   TYN: {
//     iataCode: "TYN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 37.75,
//       longitude: 112.63,
//     },
//     shortName: "Taiyuan Airport",
//     longName: "Taiyuan Wusu Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "TYN",
//       shortName: "Taiyuan",
//       longName: "Taiyuan",
//     },
//   },
//   CTU: {
//     iataCode: "CTU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 30.58,
//       longitude: 103.95,
//     },
//     shortName: "Chengdu",
//     longName: "Chengdu Shuangliu International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "CTU",
//       shortName: "Chengdu",
//       longName: "Chengdu",
//     },
//   },
//   TSN: {
//     iataCode: "TSN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 39.13,
//       longitude: 117.35,
//     },
//     shortName: "Tianjin",
//     longName: "Tianjin Binhai International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "TSN",
//       shortName: "Tianjin",
//       longName: "Tianjin",
//     },
//   },
//   URC: {
//     iataCode: "URC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.91,
//       longitude: 87.48,
//     },
//     shortName: "Urumqi",
//     longName: "Ürümqi Diwopu International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "URC",
//       shortName: "Urumqi",
//       longName: "Urumqi",
//     },
//   },
//   KMG: {
//     iataCode: "KMG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 25,
//       longitude: 102.75,
//     },
//     shortName: "Kunming",
//     longName: "Kunming Changshui International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "KMG",
//       shortName: "Kunming",
//       longName: "Kunming",
//     },
//   },
//   HGH: {
//     iataCode: "HGH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 30.23,
//       longitude: 120.43,
//     },
//     shortName: "Hangzhou",
//     longName: "Hangzhou Xiaoshan International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "HGH",
//       shortName: "Hangzhou",
//       longName: "Hangzhou",
//     },
//   },
//   NGB: {
//     iataCode: "NGB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 29.82,
//       longitude: 121.46,
//     },
//     shortName: "Ningbo",
//     longName: "Ningbo Lishe International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "NGB",
//       shortName: "Ningbo",
//       longName: "Ningbo",
//     },
//   },
//   WNZ: {
//     iataCode: "WNZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 27.91,
//       longitude: 120.85,
//     },
//     shortName: "Wenzhou Airport",
//     longName: "Wenzhou Yongqiang Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "WNZ",
//       shortName: "Wenzhou",
//       longName: "Wenzhou",
//     },
//   },
//   DZH: {
//     iataCode: "DZH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 31.13,
//       longitude: 107.43,
//     },
//     shortName: "Dazhou Jinya Airport",
//     longName: "Dazhou Jinya Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "DAX",
//       shortName: "Dazhou",
//       longName: "Dazhou",
//     },
//   },
//   LZO: {
//     iataCode: "LZO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 28.85,
//       longitude: 105.39,
//     },
//     shortName: "Luzhou Airport",
//     longName: "Luzhou Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "LZO",
//       shortName: "Luzhou",
//       longName: "Luzhou",
//     },
//   },
//   YBP: {
//     iataCode: "YBP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 28.8,
//       longitude: 104.55,
//     },
//     shortName: "Yibin Airport",
//     longName: "Yibin Caiba Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "YBP",
//       shortName: "Yibin",
//       longName: "Yibin",
//     },
//   },
//   YCU: {
//     iataCode: "YCU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 35.12,
//       longitude: 111.03,
//     },
//     shortName: "Yuncheng Airport",
//     longName: "Yuncheng Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "YCU",
//       shortName: "Yuncheng",
//       longName: "Yuncheng",
//     },
//   },
//   ZUH: {
//     iataCode: "ZUH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 22.01,
//       longitude: 113.38,
//     },
//     shortName: "Zhuhai Airport",
//     longName: "Zhuhai Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "CHN",
//       code: "CN",
//       shortName: "China",
//       longName: "China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "ZUH",
//       shortName: "Zhuhai",
//       longName: "Zhuhai",
//     },
//   },
//   HAH: {
//     iataCode: "HAH",
//     showAsOrigin: false,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -11.53,
//       longitude: 43.27,
//     },
//     shortName: "Moroni Airport",
//     longName: "Moroni Prince Said Ibrahim International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "COM",
//       code: "KM",
//       shortName: "Comoros",
//       longName: "Comoros",
//     },
//     city: {
//       code: "HAH",
//       shortName: "Moroni",
//       longName: "Moroni",
//     },
//   },
//   NAN: {
//     iataCode: "NAN",
//     showAsOrigin: false,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -17.76,
//       longitude: 177.44,
//     },
//     shortName: "Nadi Airport",
//     longName: "Nadi International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "FJI",
//       code: "FJ",
//       shortName: "Fiji",
//       longName: "Fiji",
//     },
//     city: {
//       code: "NAN",
//       shortName: "Nadi",
//       longName: "Nadi",
//     },
//   },
//   PPT: {
//     iataCode: "PPT",
//     showAsOrigin: false,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -17.55,
//       longitude: -149.61,
//     },
//     shortName: "Papeete Airport",
//     longName: "Papeete Faa'a International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "PYF",
//       code: "PF",
//       shortName: "French Polynesia",
//       longName: "French Polynesia",
//     },
//     city: {
//       code: "PPT",
//       shortName: "Papeete",
//       longName: "Papeete",
//     },
//   },
//   HKG: {
//     iataCode: "HKG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 22.31,
//       longitude: 113.91,
//     },
//     shortName: "Hong Kong",
//     longName: "Hong Kong International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "HKG",
//       code: "HK",
//       shortName: "Hong Kong, China",
//       longName: "Hong Kong, China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "HKG",
//       shortName: "Hong Kong",
//       longName: "Hong Kong",
//     },
//   },
//   IXZ: {
//     iataCode: "IXZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 11.64,
//       longitude: 92.73,
//     },
//     shortName: "Port Blair Airport",
//     longName: "Port Blair Vir Savarkar International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "IXZ",
//       shortName: "Port Blair",
//       longName: "Port Blair",
//     },
//   },
//   HYD: {
//     iataCode: "HYD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 17.24,
//       longitude: 78.43,
//     },
//     shortName: "Hyderabad",
//     longName: "Rajiv Gandhi Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "HYD",
//       shortName: "Hyderabad",
//       longName: "Hyderabad",
//     },
//   },
//   TIR: {
//     iataCode: "TIR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 13.63,
//       longitude: 79.54,
//     },
//     shortName: "Tirupati Airport",
//     longName: "Tirupati Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "TIR",
//       shortName: "Tirupati",
//       longName: "Tirupati",
//     },
//   },
//   VGA: {
//     iataCode: "VGA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 16.53,
//       longitude: 80.8,
//     },
//     shortName: "Vijayawada",
//     longName: "Vijayawada Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "VGA",
//       shortName: "Vijayawada",
//       longName: "Vijayawada",
//     },
//   },
//   VTZ: {
//     iataCode: "VTZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 17.72,
//       longitude: 83.22,
//     },
//     shortName: "Vishakhapatnam",
//     longName: "Visakhapatnam Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "VTZ",
//       shortName: "Vishakhapatnam",
//       longName: "Vishakhapatnam",
//     },
//   },
//   DIB: {
//     iataCode: "DIB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 27.48,
//       longitude: 95.02,
//     },
//     shortName: "Dibrugarh Airport",
//     longName: "Dibrugarh Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "DIB",
//       shortName: "Dibrugarh",
//       longName: "Dibrugarh",
//     },
//   },
//   GAU: {
//     iataCode: "GAU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 26.1,
//       longitude: 91.59,
//     },
//     shortName: "Guwahati",
//     longName: "Lokpriya Gopinath Bordoloi International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "GAU",
//       shortName: "Guwahati",
//       longName: "Guwahati",
//     },
//   },
//   IXS: {
//     iataCode: "IXS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 24.91,
//       longitude: 92.98,
//     },
//     shortName: "Silchar Airport",
//     longName: "Silchar Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "IXS",
//       shortName: "Silchar",
//       longName: "Silchar",
//     },
//   },
//   PAT: {
//     iataCode: "PAT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 25.59,
//       longitude: 85.09,
//     },
//     shortName: "Patna",
//     longName: "Lok Nayak Jayaprakash Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "PAT",
//       shortName: "Patna",
//       longName: "Patna",
//     },
//   },
//   IXC: {
//     iataCode: "IXC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 30.67,
//       longitude: 76.79,
//     },
//     shortName: "Chandigarh",
//     longName: "Chandigarh Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "IXC",
//       shortName: "Chandigarh",
//       longName: "Chandigarh",
//     },
//   },
//   RPR: {
//     iataCode: "RPR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 21.18,
//       longitude: 81.74,
//     },
//     shortName: "Raipur",
//     longName: "Raipur Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "RPR",
//       shortName: "Raipur",
//       longName: "Raipur",
//     },
//   },
//   DEL: {
//     iataCode: "DEL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 28.57,
//       longitude: 77.11,
//     },
//     shortName: "Delhi",
//     longName: "Indira Gandhi International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "DEL",
//       shortName: "Delhi",
//       alternateNames: ["Delhi"],
//       longName: "New Delhi",
//     },
//   },
//   GOI: {
//     iataCode: "GOI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 15.38,
//       longitude: 73.83,
//     },
//     shortName: "Goa",
//     longName: "Dabolim Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "GOI",
//       shortName: "Goa",
//       longName: "Goa",
//     },
//   },
//   GOX: {
//     iataCode: "GOX",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 15.38,
//       longitude: 73.83,
//     },
//     shortName: "Goa Mopa Airport",
//     longName: "Goa Mopa Manohar International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "GOI",
//       shortName: "Goa",
//       longName: "Goa",
//     },
//   },
//   AMD: {
//     iataCode: "AMD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 23.07,
//       longitude: 72.63,
//     },
//     shortName: "Ahmedabad",
//     longName: "Sardar Vallabhbhai Patel International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "AMD",
//       shortName: "Ahmedabad",
//       longName: "Ahmedabad",
//     },
//   },
//   IXY: {
//     iataCode: "IXY",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 23.11,
//       longitude: 70.1,
//     },
//     shortName: "Kandla Airport",
//     longName: "Kandla Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "IXY",
//       shortName: "Kandla",
//       longName: "Kandla",
//     },
//   },
//   PBD: {
//     iataCode: "PBD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 21.65,
//       longitude: 69.66,
//     },
//     shortName: "Porbandar Airport",
//     longName: "Porbandar Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "PBD",
//       shortName: "Porbandar",
//       longName: "Porbandar",
//     },
//   },
//   RAJ: {
//     iataCode: "RAJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 22.31,
//       longitude: 70.78,
//     },
//     shortName: "Rajkot",
//     longName: "Rajkot Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "RAJ",
//       shortName: "Rajkot",
//       longName: "Rajkot",
//     },
//   },
//   STV: {
//     iataCode: "STV",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 21.11,
//       longitude: 72.74,
//     },
//     shortName: "Surat Airport",
//     longName: "Surat Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "STV",
//       shortName: "Surat",
//       longName: "Surat",
//     },
//   },
//   BDQ: {
//     iataCode: "BDQ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 22.33,
//       longitude: 73.22,
//     },
//     shortName: "Vadodara",
//     alternateNames: ["Baroda"],
//     longName: "Vadodara Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "BDQ",
//       shortName: "Vadodra",
//       longName: "Vadodra",
//     },
//   },
//   DHM: {
//     iataCode: "DHM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 32.17,
//       longitude: 76.26,
//     },
//     shortName: "Dharamsala Airport",
//     longName: "Dharamsala Kangra Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "DHM",
//       shortName: "Dharamsala",
//       longName: "Dharamsala",
//     },
//   },
//   IXJ: {
//     iataCode: "IXJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 32.69,
//       longitude: 74.84,
//     },
//     shortName: "Jammu Airport",
//     longName: "Jammu Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "IXJ",
//       shortName: "Jammu",
//       longName: "Jammu",
//     },
//   },
//   IXL: {
//     iataCode: "IXL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 34.14,
//       longitude: 77.55,
//     },
//     shortName: "Leh",
//     longName: "Leh Kushok Bakula Rimpochee Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "IXL",
//       shortName: "Leh",
//       longName: "Leh",
//     },
//   },
//   SXR: {
//     iataCode: "SXR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 33.99,
//       longitude: 74.77,
//     },
//     shortName: "Srinagar",
//     longName: "Sheikh ul Alam Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "SXR",
//       shortName: "Srinagar",
//       longName: "Srinagar",
//     },
//   },
//   IXR: {
//     iataCode: "IXR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 23.31,
//       longitude: 85.32,
//     },
//     shortName: "Ranchi",
//     longName: "Birsa Munda Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "IXR",
//       shortName: "Ranchi",
//       longName: "Ranchi",
//     },
//   },
//   IXG: {
//     iataCode: "IXG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 15.86,
//       longitude: 74.62,
//     },
//     shortName: "Belgaum Airport",
//     longName: "Belgaum Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "IXG",
//       shortName: "Belgaum",
//       longName: "Belgaum",
//     },
//   },
//   BLR: {
//     iataCode: "BLR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 13.2,
//       longitude: 77.71,
//     },
//     shortName: "Bengaluru",
//     longName: "Bengaluru International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "BLR",
//       shortName: "Bengaluru",
//       longName: "Bengaluru (Bangalore)",
//     },
//   },
//   HBX: {
//     iataCode: "HBX",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 15.36,
//       longitude: 75.08,
//     },
//     shortName: "Hubli Airport",
//     longName: "Hubli Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "HBX",
//       shortName: "Hubli",
//       longName: "Hubli",
//     },
//   },
//   IXE: {
//     iataCode: "IXE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 12.96,
//       longitude: 74.89,
//     },
//     shortName: "Mangalore",
//     longName: "Mangalore International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "IXE",
//       shortName: "Mangalore",
//       longName: "Mangalore",
//     },
//   },
//   COK: {
//     iataCode: "COK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 10.15,
//       longitude: 76.41,
//     },
//     shortName: "Kochi",
//     longName: "Kochi International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "COK",
//       shortName: "Kochi",
//       longName: "Kochi (Cochin)",
//     },
//   },
//   CCJ: {
//     iataCode: "CCJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 11.14,
//       longitude: 75.95,
//     },
//     shortName: "Kozhikode",
//     longName: "Kozhikode International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "CCJ",
//       shortName: "Kozhikode",
//       longName: "Kozhikode (Calicut)",
//     },
//   },
//   TRV: {
//     iataCode: "TRV",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 8.48,
//       longitude: 76.92,
//     },
//     shortName: "Thiruvananthapuram",
//     longName: "Thiruvananthapuram International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "TRV",
//       shortName: "Thiruvananthapuram",
//       longName: "Thiruvananthapuram (Trivandrum)",
//     },
//   },
//   BHO: {
//     iataCode: "BHO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 23.29,
//       longitude: 77.34,
//     },
//     shortName: "Bhopal",
//     longName: "Bhopal Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "BHO",
//       shortName: "Bhopal",
//       longName: "Bhopal",
//     },
//   },
//   GWL: {
//     iataCode: "GWL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 26.29,
//       longitude: 78.23,
//     },
//     shortName: "Gwalior Airport",
//     longName: "Gwalior Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "GWL",
//       shortName: "Gwalior",
//       longName: "Gwalior",
//     },
//   },
//   IDR: {
//     iataCode: "IDR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 22.72,
//       longitude: 75.81,
//     },
//     shortName: "Indore",
//     longName: "Devi Ahilyabai Holkar Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "IDR",
//       shortName: "Indore",
//       longName: "Indore",
//     },
//   },
//   JLR: {
//     iataCode: "JLR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 23.18,
//       longitude: 80.05,
//     },
//     shortName: "Jabalpur Airport",
//     longName: "Jabalpur Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "JLR",
//       shortName: "Jabalpur",
//       longName: "Jabalpur",
//     },
//   },
//   IXU: {
//     iataCode: "IXU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 19.86,
//       longitude: 75.4,
//     },
//     shortName: "Aurangabad",
//     longName: "Aurangabad Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "IXU",
//       shortName: "Aurangabad",
//       longName: "Aurangabad",
//     },
//   },
//   BOM: {
//     iataCode: "BOM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 19.09,
//       longitude: 72.87,
//     },
//     shortName: "Mumbai",
//     longName: "Chhatrapati Shivaji International",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "BOM",
//       shortName: "Mumbai",
//       longName: "Mumbai (Bombay)",
//     },
//   },
//   NAG: {
//     iataCode: "NAG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 21.09,
//       longitude: 79.05,
//     },
//     shortName: "Nagpur",
//     longName: "Dr. Babasaheb Ambedkar International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "NAG",
//       shortName: "Nagpur",
//       longName: "Nagpur",
//     },
//   },
//   PNQ: {
//     iataCode: "PNQ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 18.58,
//       longitude: 73.92,
//     },
//     shortName: "Pune",
//     longName: "Pune International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "PNQ",
//       shortName: "Pune",
//       longName: "Pune",
//     },
//   },
//   BBI: {
//     iataCode: "BBI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 20.24,
//       longitude: 85.82,
//     },
//     shortName: "Bhubaneswar Airport",
//     longName: "Bhubaneswar Biju Patnaik Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "BBI",
//       shortName: "Bhubaneswar",
//       longName: "Bhubaneswar",
//     },
//   },
//   PNY: {
//     iataCode: "PNY",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 11.97,
//       longitude: 79.81,
//     },
//     shortName: "Pondicherry Airport",
//     longName: "Pondicherry Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "PNY",
//       shortName: "Pondicherry",
//       longName: "Pondicherry",
//     },
//   },
//   ATQ: {
//     iataCode: "ATQ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 31.7,
//       longitude: 74.8,
//     },
//     shortName: "Amritsar",
//     longName: "Raja Sansi International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "ATQ",
//       shortName: "Amritsar",
//       longName: "Amritsar",
//     },
//   },
//   JAI: {
//     iataCode: "JAI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 26.82,
//       longitude: 75.8,
//     },
//     shortName: "Jaipur",
//     longName: "Jaipur Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "JAI",
//       shortName: "Jaipur",
//       longName: "Jaipur",
//     },
//   },
//   JSA: {
//     iataCode: "JSA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 26.89,
//       longitude: 70.86,
//     },
//     shortName: "Jaisalmer Airport",
//     longName: "Jaisalmer Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "JSA",
//       shortName: "Jaisalmer",
//       longName: "Jaisalmer",
//     },
//   },
//   JDH: {
//     iataCode: "JDH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 26.25,
//       longitude: 73.05,
//     },
//     shortName: "Jodhpur Airport",
//     longName: "Jodhpur Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "JDH",
//       shortName: "Jodhpur",
//       longName: "Jodhpur",
//     },
//   },
//   UDR: {
//     iataCode: "UDR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 24.62,
//       longitude: 73.89,
//     },
//     shortName: "Udaipur",
//     longName: "Udaipur Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "UDR",
//       shortName: "Udaipur",
//       longName: "Udaipur",
//     },
//   },
//   MAA: {
//     iataCode: "MAA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 12.99,
//       longitude: 80.18,
//     },
//     shortName: "Chennai",
//     longName: "Chennai International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "MAA",
//       shortName: "Chennai",
//       longName: "Chennai (Madras)",
//     },
//   },
//   CJB: {
//     iataCode: "CJB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 11.03,
//       longitude: 77.04,
//     },
//     shortName: "Coimbatore",
//     longName: "Coimbatore International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "CJB",
//       shortName: "Coimbatore",
//       longName: "Coimbatore",
//     },
//   },
//   IXM: {
//     iataCode: "IXM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 9.84,
//       longitude: 78.09,
//     },
//     shortName: "Madurai",
//     longName: "Madurai Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "IXM",
//       shortName: "Madurai",
//       longName: "Madurai",
//     },
//   },
//   TRZ: {
//     iataCode: "TRZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 10.77,
//       longitude: 78.72,
//     },
//     shortName: "Tiruchirapally",
//     longName: "Tiruchirapalli Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "TRZ",
//       shortName: "Tiruchirapally",
//       longName: "Tiruchirapally",
//     },
//   },
//   TCR: {
//     iataCode: "TCR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 8.72,
//       longitude: 78.03,
//     },
//     shortName: "Tuticorin Airport",
//     longName: "Tuticorin Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "TCR",
//       shortName: "Tuticorin",
//       longName: "Tuticorin",
//     },
//   },
//   IXA: {
//     iataCode: "IXA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 23.89,
//       longitude: 91.24,
//     },
//     shortName: "Agartala",
//     longName: "Agartala Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "IXA",
//       shortName: "Agartala",
//       longName: "Agartala",
//     },
//   },
//   IXD: {
//     iataCode: "IXD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 25.44,
//       longitude: 81.74,
//     },
//     shortName: "Allahabad",
//     longName: "Allahabad Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "IXD",
//       shortName: "Allahabad",
//       longName: "Allahabad",
//     },
//   },
//   GOP: {
//     iataCode: "GOP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 26.74,
//       longitude: 83.45,
//     },
//     shortName: "Gorakhpur Airport",
//     longName: "Gorakhpur Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "GOP",
//       shortName: "Gorakhpur",
//       longName: "Gorakhpur",
//     },
//   },
//   KNU: {
//     iataCode: "KNU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 26.44,
//       longitude: 80.36,
//     },
//     shortName: "Kanpur Airport",
//     longName: "Kanpur Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "KNU",
//       shortName: "Kanpur",
//       longName: "Kanpur",
//     },
//   },
//   LKO: {
//     iataCode: "LKO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 26.76,
//       longitude: 80.88,
//     },
//     shortName: "Lucknow",
//     longName: "Chaudhary Charan Singh Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "LKO",
//       shortName: "Lucknow",
//       longName: "Lucknow",
//     },
//   },
//   VNS: {
//     iataCode: "VNS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 25.45,
//       longitude: 82.86,
//     },
//     shortName: "Varanasi",
//     longName: "Varanasi Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "VNS",
//       shortName: "Varanasi",
//       longName: "Varanasi",
//     },
//   },
//   DED: {
//     iataCode: "DED",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 30.19,
//       longitude: 78.18,
//     },
//     shortName: "Dehradun Airport",
//     longName: "Dehradun Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "DED",
//       shortName: "Dehradun",
//       longName: "Dehradun",
//     },
//   },
//   RDP: {
//     iataCode: "RDP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 23.62,
//       longitude: 87.24,
//     },
//     shortName: "Durgapur Airport",
//     longName: "Durgapur Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "RDP",
//       shortName: "Durgapur",
//       longName: "Durgapur",
//     },
//   },
//   CCU: {
//     iataCode: "CCU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 22.65,
//       longitude: 88.45,
//     },
//     shortName: "Kolkata",
//     longName: "Netaji Subhas Chandra Bose International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "CCU",
//       shortName: "Kolkata",
//       longName: "Kolkata (Calcutta)",
//     },
//   },
//   IXB: {
//     iataCode: "IXB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 26.68,
//       longitude: 88.33,
//     },
//     shortName: "Siliguri Airport",
//     longName: "Siliguri Bagdogra Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IND",
//       code: "IN",
//       shortName: "India",
//       longName: "India",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "IXB",
//       shortName: "Siliguri",
//       longName: "Siliguri",
//     },
//   },
//   AMQ: {
//     iataCode: "AMQ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -3.71,
//       longitude: 128.09,
//     },
//     shortName: "Ambon Airport",
//     longName: "Pattimura Ambon Airport ",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IDN",
//       code: "ID",
//       shortName: "Indonesia",
//       longName: "Indonesia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "AMQ",
//       shortName: "Ambon",
//       longName: "Ambon",
//     },
//   },
//   BPN: {
//     iataCode: "BPN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -1.27,
//       longitude: 116.89,
//     },
//     shortName: "Balikpapan Airport",
//     longName: "Balikpapan Sultan Aji Muhamad Sulaiman Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IDN",
//       code: "ID",
//       shortName: "Indonesia",
//       longName: "Indonesia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "BPN",
//       shortName: "Balikpapan",
//       longName: "Balikpapan",
//     },
//   },
//   BTJ: {
//     iataCode: "BTJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 5.52,
//       longitude: 95.42,
//     },
//     shortName: "Banda Aceh Airport",
//     longName: "Banda Aceh Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IDN",
//       code: "ID",
//       shortName: "Indonesia",
//       longName: "Indonesia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "BTJ",
//       shortName: "Banda Aceh",
//       longName: "Banda Aceh",
//     },
//   },
//   TKG: {
//     iataCode: "TKG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -5.24,
//       longitude: 105.18,
//     },
//     shortName: "Bandar Lampung Airport",
//     longName: "Bandar Lampung Radin Inten II  Airport ",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IDN",
//       code: "ID",
//       shortName: "Indonesia",
//       longName: "Indonesia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "TKG",
//       shortName: "Bandar Lampung",
//       longName: "Bandar Lampung",
//     },
//   },
//   BDO: {
//     iataCode: "BDO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -6.9,
//       longitude: 107.58,
//     },
//     shortName: "Bandung",
//     longName: "Bandung  Husein Sastranegara Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IDN",
//       code: "ID",
//       shortName: "Indonesia",
//       longName: "Indonesia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "BDO",
//       shortName: "Bandung",
//       longName: "Bandung-Java Island",
//     },
//   },
//   BDJ: {
//     iataCode: "BDJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -3.44,
//       longitude: 114.76,
//     },
//     shortName: "Banjarmasin Airport",
//     longName: "Banjarmasin Syamsudin Noor Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IDN",
//       code: "ID",
//       shortName: "Indonesia",
//       longName: "Indonesia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "BDJ",
//       shortName: "Banjarmasin",
//       longName: "Banjarmasin",
//     },
//   },
//   BTH: {
//     iataCode: "BTH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 1.12,
//       longitude: 104.12,
//     },
//     shortName: "Batam Airport",
//     longName: "Batam Island Hang Nadim International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IDN",
//       code: "ID",
//       shortName: "Indonesia",
//       longName: "Indonesia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "BTH",
//       shortName: "Batam Island",
//       longName: "Batam Island",
//     },
//   },
//   BKS: {
//     iataCode: "BKS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -3.86,
//       longitude: 102.34,
//     },
//     shortName: "Bengkulu Airport",
//     longName: "Bengkulu Fatmawati Soekarno Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IDN",
//       code: "ID",
//       shortName: "Indonesia",
//       longName: "Indonesia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "BKS",
//       shortName: "Bengkulu",
//       longName: "Bengkulu",
//     },
//   },
//   BIK: {
//     iataCode: "BIK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -1.19,
//       longitude: 136.11,
//     },
//     shortName: "Biak Airport",
//     longName: "Biak Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IDN",
//       code: "ID",
//       shortName: "Indonesia",
//       longName: "Indonesia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "BIK",
//       shortName: "Biak",
//       longName: "Biak",
//     },
//   },
//   ENE: {
//     iataCode: "ENE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -8.85,
//       longitude: 121.66,
//     },
//     shortName: "Ende Airport",
//     longName: "Ende H Hasan Aroeboesman Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IDN",
//       code: "ID",
//       shortName: "Indonesia",
//       longName: "Indonesia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "ENE",
//       shortName: "Ende",
//       longName: "Ende-Flores Island",
//     },
//   },
//   GTO: {
//     iataCode: "GTO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 0.64,
//       longitude: 122.85,
//     },
//     shortName: "Gorontalo Airport",
//     longName: "Gorontalo Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IDN",
//       code: "ID",
//       shortName: "Indonesia",
//       longName: "Indonesia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "GTO",
//       shortName: "Gorontalo",
//       longName: "Gorontalo",
//     },
//   },
//   DPS: {
//     iataCode: "DPS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: -8.75,
//       longitude: 115.17,
//     },
//     shortName: "Denpasar",
//     longName: "Ngurah Rai International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IDN",
//       code: "ID",
//       shortName: "Indonesia",
//       longName: "Indonesia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "DPS",
//       shortName: "Bali",
//       longName: "Bali",
//     },
//   },
//   CGK: {
//     iataCode: "CGK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: -6.12,
//       longitude: 106.66,
//     },
//     shortName: "Jakarta",
//     longName: "Soekarno-Hatta International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IDN",
//       code: "ID",
//       shortName: "Indonesia",
//       longName: "Indonesia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "JKT",
//       shortName: "Jakarta",
//       longName: "Jakarta",
//     },
//   },
//   JOG: {
//     iataCode: "JOG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -7.79,
//       longitude: 110.43,
//     },
//     shortName: "Adi Sutjipto International Airport",
//     longName: "Adi Sutjipto International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IDN",
//       code: "ID",
//       shortName: "Indonesia",
//       longName: "Indonesia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "JOG",
//       shortName: "Yogyakarta",
//       longName: "Yogyakarta",
//     },
//   },
//   DJB: {
//     iataCode: "DJB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -1.64,
//       longitude: 103.64,
//     },
//     shortName: "Jambi Airport",
//     longName: "Jambi-Sumatra Island Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IDN",
//       code: "ID",
//       shortName: "Indonesia",
//       longName: "Indonesia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "DJB",
//       shortName: "Jambi Island",
//       longName: "Jambi-Sumatra Island",
//     },
//   },
//   DJJ: {
//     iataCode: "DJJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -2.58,
//       longitude: 140.52,
//     },
//     shortName: "Jayapura Airport",
//     longName: "Jayapura Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IDN",
//       code: "ID",
//       shortName: "Indonesia",
//       longName: "Indonesia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "DJJ",
//       shortName: "Jayapura",
//       longName: "Jayapura",
//     },
//   },
//   KDI: {
//     iataCode: "KDI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -4.08,
//       longitude: 122.42,
//     },
//     shortName: "Kendari Airport",
//     longName: "Kendari Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IDN",
//       code: "ID",
//       shortName: "Indonesia",
//       longName: "Indonesia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "KDI",
//       shortName: "Kendari",
//       longName: "Kendari",
//     },
//   },
//   KOE: {
//     iataCode: "KOE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -10.17,
//       longitude: 123.67,
//     },
//     shortName: "Kupang Airport",
//     longName: "Kupang El Tari Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IDN",
//       code: "ID",
//       shortName: "Indonesia",
//       longName: "Indonesia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "KOE",
//       shortName: "Kupang",
//       longName: "Kupang-Timor Island",
//     },
//   },
//   LBJ: {
//     iataCode: "LBJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -8.49,
//       longitude: 119.89,
//     },
//     shortName: "Labuan Bajo Airport",
//     longName: "Labuan Bajo Komodo Mutiara II Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IDN",
//       code: "ID",
//       shortName: "Indonesia",
//       longName: "Indonesia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "LBJ",
//       shortName: "Labuan Bajo",
//       longName: "Labuan Bajo-Flores Island",
//     },
//   },
//   LOP: {
//     iataCode: "LOP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -8.76,
//       longitude: 116.28,
//     },
//     shortName: "Lombok Airport",
//     longName: "Bandara International Lombok Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IDN",
//       code: "ID",
//       shortName: "Indonesia",
//       longName: "Indonesia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "LOP",
//       shortName: "Lombok",
//       longName: "Lombok",
//     },
//   },
//   UPG: {
//     iataCode: "UPG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -5.06,
//       longitude: 119.55,
//     },
//     shortName: "Makassar Airport",
//     longName: "Hasanuddin International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IDN",
//       code: "ID",
//       shortName: "Indonesia",
//       longName: "Indonesia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "UPG",
//       shortName: "Makassar",
//       longName: "Makassar",
//     },
//   },
//   MLG: {
//     iataCode: "MLG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -7.93,
//       longitude: 112.71,
//     },
//     shortName: "Malang Airport",
//     longName: "Malang Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IDN",
//       code: "ID",
//       shortName: "Indonesia",
//       longName: "Indonesia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "MLG",
//       shortName: "Malang",
//       longName: "Malang",
//     },
//   },
//   MDC: {
//     iataCode: "MDC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 1.55,
//       longitude: 124.93,
//     },
//     shortName: "Manado Airport",
//     longName: "Manado Sam Ratulangi Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IDN",
//       code: "ID",
//       shortName: "Indonesia",
//       longName: "Indonesia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "MDC",
//       shortName: "Manado",
//       longName: "Manado-Celebes Island",
//     },
//   },
//   KNO: {
//     iataCode: "KNO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 3.56,
//       longitude: 98.67,
//     },
//     shortName: "Kualanamu Airport",
//     longName: "Kualanamu International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IDN",
//       code: "ID",
//       shortName: "Indonesia",
//       longName: "Indonesia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "MES",
//       shortName: "Medan",
//       longName: "Medan",
//     },
//   },
//   MKQ: {
//     iataCode: "MKQ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -8.52,
//       longitude: 140.42,
//     },
//     shortName: "Merauke Airport",
//     longName: "Merauke Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IDN",
//       code: "ID",
//       shortName: "Indonesia",
//       longName: "Indonesia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "MKQ",
//       shortName: "Merauke",
//       longName: "Merauke",
//     },
//   },
//   PDG: {
//     iataCode: "PDG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -0.79,
//       longitude: 100.28,
//     },
//     shortName: "Padang Airport",
//     longName: "Padang Minangkabau Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IDN",
//       code: "ID",
//       shortName: "Indonesia",
//       longName: "Indonesia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "PDG",
//       shortName: "Padang",
//       longName: "Padang",
//     },
//   },
//   PKY: {
//     iataCode: "PKY",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -2.23,
//       longitude: 113.94,
//     },
//     shortName: "Palangkaraya Airport",
//     longName: "Palangkaraya Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IDN",
//       code: "ID",
//       shortName: "Indonesia",
//       longName: "Indonesia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "PKY",
//       shortName: "Palangkaraya",
//       longName: "Palangkaraya",
//     },
//   },
//   PLM: {
//     iataCode: "PLM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -2.9,
//       longitude: 104.7,
//     },
//     shortName: "Palembang Airport",
//     longName: "Palembang-Sumatra Island Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IDN",
//       code: "ID",
//       shortName: "Indonesia",
//       longName: "Indonesia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "PLM",
//       shortName: "Palembang Island",
//       longName: "Palembang-Sumatra Island",
//     },
//   },
//   PLW: {
//     iataCode: "PLW",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -0.92,
//       longitude: 119.91,
//     },
//     shortName: "Palu Airport",
//     longName: "Palu Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IDN",
//       code: "ID",
//       shortName: "Indonesia",
//       longName: "Indonesia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "PLW",
//       shortName: "Palu",
//       longName: "Palu",
//     },
//   },
//   PGK: {
//     iataCode: "PGK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -2.16,
//       longitude: 106.14,
//     },
//     shortName: "Pangkal Pinang Airport",
//     longName: "Pangkal Pinang Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IDN",
//       code: "ID",
//       shortName: "Indonesia",
//       longName: "Indonesia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "PGK",
//       shortName: "Pangkal Pinang",
//       longName: "Pangkal Pinang",
//     },
//   },
//   PKU: {
//     iataCode: "PKU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 0.46,
//       longitude: 101.44,
//     },
//     shortName: "Pekanbaru Airport ",
//     longName: "Pekanbaru Sultan Syarif Kasim Ii Airport ",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IDN",
//       code: "ID",
//       shortName: "Indonesia",
//       longName: "Indonesia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "PKU",
//       shortName: "Pekanbaru",
//       longName: "Pekanbaru",
//     },
//   },
//   PNK: {
//     iataCode: "PNK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -0.15,
//       longitude: 109.4,
//     },
//     shortName: "Pontianak Airport",
//     longName: "Pontianak Supadio Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IDN",
//       code: "ID",
//       shortName: "Indonesia",
//       longName: "Indonesia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "PNK",
//       shortName: "Pontianak",
//       longName: "Pontianak",
//     },
//   },
//   TTE: {
//     iataCode: "TTE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 0.83,
//       longitude: 127.38,
//     },
//     shortName: "Sango-Ternate Airport",
//     longName: "Sango-Ternate Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IDN",
//       code: "ID",
//       shortName: "Indonesia",
//       longName: "Indonesia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "TTE",
//       shortName: "Sango-Ternate Island",
//       longName: "Sango-Ternate Island",
//     },
//   },
//   SRG: {
//     iataCode: "SRG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -6.97,
//       longitude: 110.38,
//     },
//     shortName: "Semarang Airport",
//     longName: "Semarang Achmad Yani Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IDN",
//       code: "ID",
//       shortName: "Indonesia",
//       longName: "Indonesia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "SRG",
//       shortName: "Semarang",
//       longName: "Semarang-Java Island",
//     },
//   },
//   SOQ: {
//     iataCode: "SOQ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -0.89,
//       longitude: 131.29,
//     },
//     shortName: "Sorong Airport",
//     longName: "Sorong Dominique Edward Osok Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IDN",
//       code: "ID",
//       shortName: "Indonesia",
//       longName: "Indonesia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "SOQ",
//       shortName: "Sorong",
//       longName: "Sorong",
//     },
//   },
//   SOC: {
//     iataCode: "SOC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -7.52,
//       longitude: 110.76,
//     },
//     shortName: "Sukarata(Solo) Airport",
//     longName: "Sukarata(Solo) Adi Sumarmo Wiryokusumo Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IDN",
//       code: "ID",
//       shortName: "Indonesia",
//       longName: "Indonesia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "SOC",
//       shortName: "Sukarata(Solo)",
//       longName: "Sukarata(Solo)",
//     },
//   },
//   SUB: {
//     iataCode: "SUB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -7.38,
//       longitude: 112.79,
//     },
//     shortName: "Surabaya Airport",
//     longName: "Surabaya Juanda International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IDN",
//       code: "ID",
//       shortName: "Indonesia",
//       longName: "Indonesia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "SUB",
//       shortName: "Surabaya",
//       longName: "Surabaya",
//     },
//   },
//   TMC: {
//     iataCode: "TMC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -9.41,
//       longitude: 119.24,
//     },
//     shortName: "Tambolaka Airport",
//     longName: "Tambolaka Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IDN",
//       code: "ID",
//       shortName: "Indonesia",
//       longName: "Indonesia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "TMC",
//       shortName: "Tambolaka",
//       longName: "Tambolaka",
//     },
//   },
//   TNJ: {
//     iataCode: "TNJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 0.92,
//       longitude: 104.53,
//     },
//     shortName: "Tanjung Pinang Airport",
//     longName: "Tanjung Pinang Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IDN",
//       code: "ID",
//       shortName: "Indonesia",
//       longName: "Indonesia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "TNJ",
//       shortName: "Tanjung Pinang",
//       longName: "Tanjung Pinang-Bintan Island",
//     },
//   },
//   TIM: {
//     iataCode: "TIM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -4.53,
//       longitude: 136.89,
//     },
//     shortName: "Timika Airport",
//     longName: "Timika Mozes Kilangin Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IDN",
//       code: "ID",
//       shortName: "Indonesia",
//       longName: "Indonesia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "TIM",
//       shortName: "Timika",
//       longName: "Timika-Papua Island",
//     },
//   },
//   YIA: {
//     iataCode: "YIA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -7.79,
//       longitude: 110.43,
//     },
//     shortName: "Yogyakarta International Airport",
//     longName: "Yogyakarta International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "IDN",
//       code: "ID",
//       shortName: "Indonesia",
//       longName: "Indonesia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "YIA",
//       shortName: "Yogyakarta",
//       longName: "Yogyakarta",
//     },
//   },
//   AXT: {
//     iataCode: "AXT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 39.62,
//       longitude: 140.22,
//     },
//     shortName: "Akita Airport",
//     longName: "Akita Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "AXT",
//       shortName: "Akita",
//       longName: "Akita",
//     },
//   },
//   AOJ: {
//     iataCode: "AOJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 40.73,
//       longitude: 140.69,
//     },
//     shortName: "Aomori Airport",
//     longName: "Aomori Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "AOJ",
//       shortName: "Aomori",
//       longName: "Aomori",
//     },
//   },
//   FKS: {
//     iataCode: "FKS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 37.23,
//       longitude: 140.43,
//     },
//     shortName: "Fukushima Airport",
//     longName: "Fukushima Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "FKS",
//       shortName: "Fukushima",
//       longName: "Fukushima",
//     },
//   },
//   HAC: {
//     iataCode: "HAC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 33.12,
//       longitude: 139.79,
//     },
//     shortName: "Hachijojima Airport",
//     longName: "Hachijojima Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "HAC",
//       shortName: "Hachijo Jima",
//       longName: "Hachijo Jima",
//     },
//   },
//   HKD: {
//     iataCode: "HKD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 41.77,
//       longitude: 140.82,
//     },
//     shortName: "Hakodate Airport",
//     longName: "Hakodate Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "HKD",
//       shortName: "Hakodate",
//       longName: "Hakodate",
//     },
//   },
//   HIJ: {
//     iataCode: "HIJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 34.44,
//       longitude: 132.92,
//     },
//     shortName: "Hiroshima Airport",
//     longName: "Hiroshima Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "HIJ",
//       shortName: "Hiroshima",
//       longName: "Hiroshima",
//     },
//   },
//   IWJ: {
//     iataCode: "IWJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 34.68,
//       longitude: 131.79,
//     },
//     shortName: "Iwami Airport",
//     longName: "Iwami Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "IWJ",
//       shortName: "Iwami",
//       longName: "Iwami",
//     },
//   },
//   NGO: {
//     iataCode: "NGO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 34.86,
//       longitude: 136.81,
//     },
//     shortName: "Nagoya",
//     longName: "Central Japan International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "NGO",
//       shortName: "Nagoya",
//       longName: "Nagoya",
//     },
//   },
//   NGY: {
//     iataCode: "NGY",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "1",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 35.14,
//       longitude: 136.9,
//     },
//     shortName: "Nagoya (BUS)",
//     longName: "Nagoya Bus Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "NGO",
//       shortName: "Nagoya",
//       longName: "Nagoya",
//     },
//   },
//   FUK: {
//     iataCode: "FUK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 33.58,
//       longitude: 130.45,
//     },
//     shortName: "Fukuoka",
//     longName: "Fukuoka Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "FUK",
//       shortName: "Fukuoka",
//       longName: "Fukuoka",
//     },
//   },
//   CTS: {
//     iataCode: "CTS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 42.78,
//       longitude: 141.69,
//     },
//     shortName: "Sapporo",
//     longName: "New Chitose Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "SPK",
//       shortName: "Sapporo",
//       longName: "Sapporo",
//     },
//   },
//   OKD: {
//     iataCode: "OKD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.12,
//       longitude: 141.38,
//     },
//     shortName: "Okadama Airport",
//     longName: "Sapporo Okadama Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "SPK",
//       shortName: "Sapporo",
//       longName: "Sapporo",
//     },
//   },
//   KIX: {
//     iataCode: "KIX",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 34.43,
//       longitude: 135.23,
//     },
//     shortName: "Osaka",
//     longName: "Kansai International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "KIX",
//       shortName: "Osaka",
//       longName: "Osaka",
//     },
//   },
//   ITM: {
//     iataCode: "ITM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 34.79,
//       longitude: 135.44,
//     },
//     shortName: "Itami Airport",
//     longName: "Osaka Itami Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "KIX",
//       shortName: "Osaka",
//       longName: "Osaka",
//     },
//   },
//   TYO: {
//     iataCode: "TYO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 35.55,
//       longitude: 139.77,
//     },
//     shortName: "Tokyo",
//     longName: "Tokyo All Airports",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "TYO",
//       shortName: "Tokyo",
//       longName: "Tokyo",
//     },
//   },
//   HND: {
//     iataCode: "HND",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 35.55,
//       longitude: 139.78,
//     },
//     shortName: "Tokyo Haneda",
//     longName: "Tokyo Haneda Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "TYO",
//       shortName: "Tokyo",
//       longName: "Tokyo",
//     },
//   },
//   NRT: {
//     iataCode: "NRT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 35.77,
//       longitude: 140.39,
//     },
//     shortName: "Tokyo Narita",
//     longName: "Tokyo Narita International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "TYO",
//       shortName: "Tokyo",
//       longName: "Tokyo",
//     },
//   },
//   KOJ: {
//     iataCode: "KOJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 31.8,
//       longitude: 130.72,
//     },
//     shortName: "Kagoshima Airport",
//     longName: "Kagoshima Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "KOJ",
//       shortName: "Kagoshima",
//       longName: "Kagoshima",
//     },
//   },
//   KKX: {
//     iataCode: "KKX",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 28.32,
//       longitude: 129.93,
//     },
//     shortName: "Kikai Airport",
//     longName: "Kikaiga Shima Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "KKX",
//       shortName: "Kikai",
//       longName: "Kikai",
//     },
//   },
//   KMQ: {
//     iataCode: "KMQ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 36.39,
//       longitude: 136.41,
//     },
//     shortName: "Komatsu Airport",
//     longName: "Komatsu Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "KMQ",
//       shortName: "Komatsu",
//       longName: "Komatsu",
//     },
//   },
//   KMJ: {
//     iataCode: "KMJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 32.84,
//       longitude: 130.85,
//     },
//     shortName: "Kumamoto Airport",
//     longName: "Kumamoto Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "KMJ",
//       shortName: "Kumamoto",
//       longName: "Kumamoto",
//     },
//   },
//   KUH: {
//     iataCode: "KUH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.04,
//       longitude: 144.19,
//     },
//     shortName: "Kushiro Airport",
//     longName: "Kushiro Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "KUH",
//       shortName: "Kushiro",
//       longName: "Kushiro",
//     },
//   },
//   MYJ: {
//     iataCode: "MYJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 33.83,
//       longitude: 132.7,
//     },
//     shortName: "Matsuyama Airport",
//     longName: "Matsuyama Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "MYJ",
//       shortName: "Matsuyama",
//       longName: "Matsuyama",
//     },
//   },
//   MYE: {
//     iataCode: "MYE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 34.07,
//       longitude: 139.56,
//     },
//     shortName: "Miyakejima Airport",
//     longName: "Miyakejima Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "MYE",
//       shortName: "Miyake Jima",
//       longName: "Miyake Jima",
//     },
//   },
//   KMI: {
//     iataCode: "KMI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 31.88,
//       longitude: 131.45,
//     },
//     shortName: "Miyazaki Airport",
//     longName: "Miyazaki Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "KMI",
//       shortName: "Miyazaki",
//       longName: "Miyazaki",
//     },
//   },
//   NGS: {
//     iataCode: "NGS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 32.92,
//       longitude: 129.91,
//     },
//     shortName: "Nagasaki Airport",
//     longName: "Nagasaki Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "NGS",
//       shortName: "Nagasaki",
//       longName: "Nagasaki",
//     },
//   },
//   OBO: {
//     iataCode: "OBO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 42.73,
//       longitude: 143.22,
//     },
//     shortName: "Obihiro Airport",
//     longName: "Tokachi Obihiro Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "OBO",
//       shortName: "Obihiro",
//       longName: "Obihiro",
//     },
//   },
//   ONJ: {
//     iataCode: "ONJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 40.19,
//       longitude: 140.37,
//     },
//     shortName: "Odate Noshiro Airport",
//     longName: "Odate Noshiro Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "ONJ",
//       shortName: "Odate Noshiro",
//       longName: "Odate Noshiro",
//     },
//   },
//   OIT: {
//     iataCode: "OIT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 33.48,
//       longitude: 131.74,
//     },
//     shortName: "Oita Airport",
//     longName: "Oita Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "OIT",
//       shortName: "Oita",
//       longName: "Oita",
//     },
//   },
//   OKJ: {
//     iataCode: "OKJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 34.76,
//       longitude: 133.85,
//     },
//     shortName: "Okayama Airport",
//     longName: "Okayama Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "OKJ",
//       shortName: "Okayama",
//       longName: "Okayama",
//     },
//   },
//   OKA: {
//     iataCode: "OKA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 26.2,
//       longitude: 127.65,
//     },
//     shortName: "Okinawa Airport",
//     longName: "Okinawa Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "OKA",
//       shortName: "Okinawa",
//       longName: "Okinawa",
//     },
//   },
//   OKE: {
//     iataCode: "OKE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 27.43,
//       longitude: 128.7,
//     },
//     shortName: "Okinoerabu Airport",
//     longName: "Okinoerabu Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "OKE",
//       shortName: "Okinoerabu",
//       longName: "Okinoerabu",
//     },
//   },
//   OIR: {
//     iataCode: "OIR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 42.07,
//       longitude: 139.43,
//     },
//     shortName: "Okushiri Airport",
//     longName: "Okushiri Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "OIR",
//       shortName: "Okushiri",
//       longName: "Okushiri",
//     },
//   },
//   OIM: {
//     iataCode: "OIM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 34.78,
//       longitude: 139.36,
//     },
//     shortName: "Oshima Airport",
//     longName: "Oshima Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "OIM",
//       shortName: "Oshima",
//       longName: "Oshima",
//     },
//   },
//   RIS: {
//     iataCode: "RIS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 45.24,
//       longitude: 141.19,
//     },
//     shortName: "Rishiri Airport",
//     longName: "Rishiri Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "RIS",
//       shortName: "Rishiri",
//       longName: "Rishiri",
//     },
//   },
//   HSG: {
//     iataCode: "HSG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 33.15,
//       longitude: 130.3,
//     },
//     shortName: "Saga Airport",
//     longName: "Saga Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "HSG",
//       shortName: "Saga",
//       longName: "Saga",
//     },
//   },
//   SDJ: {
//     iataCode: "SDJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 38.14,
//       longitude: 140.92,
//     },
//     shortName: "Sendai  Airport",
//     longName: "Sendai  Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "SDJ",
//       shortName: "Sendai",
//       longName: "Sendai",
//     },
//   },
//   SYO: {
//     iataCode: "SYO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 38.81,
//       longitude: 139.79,
//     },
//     shortName: "Shonai Airport",
//     longName: "Shonai Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "SYO",
//       shortName: "Shonai",
//       longName: "Shonai",
//     },
//   },
//   TJH: {
//     iataCode: "TJH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 35.51,
//       longitude: 134.79,
//     },
//     shortName: "Tajima Airport",
//     longName: "Tajima Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "TJH",
//       shortName: "Tajima",
//       longName: "Tajima",
//     },
//   },
//   TAK: {
//     iataCode: "TAK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 34.21,
//       longitude: 134.02,
//     },
//     shortName: "Takamatsu Airport",
//     longName: "Takamatsu Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "TAK",
//       shortName: "Takamatsu",
//       longName: "Takamatsu",
//     },
//   },
//   TKS: {
//     iataCode: "TKS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 34.13,
//       longitude: 134.61,
//     },
//     shortName: "Tokushima Airport",
//     longName: "Tokushima Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "TKS",
//       shortName: "Tokushima",
//       longName: "Tokushima",
//     },
//   },
//   TTJ: {
//     iataCode: "TTJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 35.53,
//       longitude: 134.17,
//     },
//     shortName: "Tottori Airport",
//     longName: "Tottori Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "TTJ",
//       shortName: "Tottori",
//       longName: "Tottori",
//     },
//   },
//   TOY: {
//     iataCode: "TOY",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 36.65,
//       longitude: 137.19,
//     },
//     shortName: "Toyama Airport",
//     longName: "Toyama Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "TOY",
//       shortName: "Toyama",
//       longName: "Toyama",
//     },
//   },
//   UBJ: {
//     iataCode: "UBJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 33.93,
//       longitude: 131.28,
//     },
//     shortName: "Yamaguchi Ube Airport",
//     longName: "Yamaguchi Ube Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "UBJ",
//       shortName: "Ube",
//       longName: "Ube",
//     },
//   },
//   NTQ: {
//     iataCode: "NTQ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 37.29,
//       longitude: 136.96,
//     },
//     shortName: "Noto Wajima Airport",
//     longName: "Noto Wajima Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "NTQ",
//       shortName: "Wajima",
//       longName: "Wajima",
//     },
//   },
//   KUM: {
//     iataCode: "KUM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 30.39,
//       longitude: 130.66,
//     },
//     shortName: "Yakushima Airport",
//     longName: "Yakushima Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "KUM",
//       shortName: "Yakushima",
//       longName: "Yakushima",
//     },
//   },
//   YGJ: {
//     iataCode: "YGJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 35.49,
//       longitude: 133.24,
//     },
//     shortName: "Yonago Airport",
//     longName: "Yonago Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "YGJ",
//       shortName: "Yonago",
//       longName: "Yonago",
//     },
//   },
//   RNJ: {
//     iataCode: "RNJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 27.04,
//       longitude: 128.4,
//     },
//     shortName: "Yoronjima Airport",
//     longName: "Yoronjima Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "JPN",
//       code: "JP",
//       shortName: "Japan",
//       longName: "Japan",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "RNJ",
//       shortName: "Yoronjima",
//       longName: "Yoronjima",
//     },
//   },
//   SCO: {
//     iataCode: "SCO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.86,
//       longitude: 51.09,
//     },
//     shortName: "Aktau Airport",
//     longName: "Aktau Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "KAZ",
//       code: "KZ",
//       shortName: "Kazakhstan",
//       longName: "Kazakhstan",
//     },
//     city: {
//       code: "SCO",
//       shortName: "Aktau",
//       longName: "Aktau",
//     },
//   },
//   AKX: {
//     iataCode: "AKX",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 50.25,
//       longitude: 57.21,
//     },
//     shortName: "Aktobe Airport",
//     longName: "Aktobe Aliya Moldagulova International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "KAZ",
//       code: "KZ",
//       shortName: "Kazakhstan",
//       longName: "Kazakhstan",
//     },
//     city: {
//       code: "AKX",
//       shortName: "Aktyubinsk",
//       longName: "Aktyubinsk",
//     },
//   },
//   ALA: {
//     iataCode: "ALA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.36,
//       longitude: 77.04,
//     },
//     shortName: "Almaty",
//     longName: "Almaty International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "KAZ",
//       code: "KZ",
//       shortName: "Kazakhstan",
//       longName: "Kazakhstan",
//     },
//     city: {
//       code: "ALA",
//       shortName: "Almaty",
//       longName: "Almaty",
//     },
//   },
//   GUW: {
//     iataCode: "GUW",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 47.12,
//       longitude: 51.82,
//     },
//     shortName: "Atyrau Airport",
//     longName: "Atyrau Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "KAZ",
//       code: "KZ",
//       shortName: "Kazakhstan",
//       longName: "Kazakhstan",
//     },
//     city: {
//       code: "GUW",
//       shortName: "Atyrau",
//       longName: "Atyrau",
//     },
//   },
//   NQZ: {
//     iataCode: "NQZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 51.02,
//       longitude: 71.47,
//     },
//     shortName: "Astana Nursultan Airport",
//     longName: "Astana Nursultan Nazarbayev International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "KAZ",
//       code: "KZ",
//       shortName: "Kazakhstan",
//       longName: "Kazakhstan",
//     },
//     city: {
//       code: "NQZ",
//       shortName: "Nursultan",
//       longName: "Nursultan",
//     },
//   },
//   KZO: {
//     iataCode: "KZO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 44.71,
//       longitude: 65.59,
//     },
//     shortName: "Kzyl-Orda Airport",
//     longName: "Kzyl-Orda Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "KAZ",
//       code: "KZ",
//       shortName: "Kazakhstan",
//       longName: "Kazakhstan",
//     },
//     city: {
//       code: "KZO ",
//       shortName: "Kzyl-Orda",
//       longName: "Kzyl-Orda",
//     },
//   },
//   CIT: {
//     iataCode: "CIT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 42.36,
//       longitude: 69.48,
//     },
//     shortName: "Shymkent Airport",
//     longName: "Shymkent Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "KAZ",
//       code: "KZ",
//       shortName: "Kazakhstan",
//       longName: "Kazakhstan",
//     },
//     city: {
//       code: "CIT",
//       shortName: "Shymkent",
//       longName: "Shymkent",
//     },
//   },
//   CJU: {
//     iataCode: "CJU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 33.51,
//       longitude: 126.49,
//     },
//     shortName: "Jeju Airport",
//     longName: "Jeju International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "KOR",
//       code: "KR",
//       shortName: "Korea, Republic of",
//       longName: "Korea, Republic of",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "CJU",
//       shortName: "Jeju",
//       longName: "Jeju",
//     },
//   },
//   ICN: {
//     iataCode: "ICN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 37.46,
//       longitude: 126.44,
//     },
//     shortName: "Seoul",
//     longName: "Incheon International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "KOR",
//       code: "KR",
//       shortName: "Korea, Republic of",
//       longName: "Korea, Republic of",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "ICN",
//       shortName: "Seoul",
//       longName: "Seoul",
//     },
//   },
//   GMP: {
//     iataCode: "GMP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 37.56,
//       longitude: 126.79,
//     },
//     shortName: "Gimpo International Airport",
//     longName: "Seoul Gimpo International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "KOR",
//       code: "KR",
//       shortName: "Korea, Republic of",
//       longName: "Korea, Republic of",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "ICN",
//       shortName: "Seoul",
//       longName: "Seoul",
//     },
//   },
//   FRU: {
//     iataCode: "FRU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.06,
//       longitude: 74.48,
//     },
//     shortName: "Bishkek",
//     longName: "Manas International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "KGZ",
//       code: "KG",
//       shortName: "Kyrgyzstan",
//       longName: "Kyrgyzstan",
//     },
//     city: {
//       code: "FRU",
//       shortName: "Bishkek",
//       longName: "Bishkek",
//     },
//   },
//   OSS: {
//     iataCode: "OSS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 40.61,
//       longitude: 72.79,
//     },
//     shortName: "Osh Airport",
//     longName: "Osh International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "KGZ",
//       code: "KG",
//       shortName: "Kyrgyzstan",
//       longName: "Kyrgyzstan",
//     },
//     city: {
//       code: "OSS",
//       shortName: "Osh",
//       longName: "Osh",
//     },
//   },
//   LPQ: {
//     iataCode: "LPQ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 19.9,
//       longitude: 102.16,
//     },
//     shortName: "Luang Prabang Airport",
//     longName: "Luang Prabang International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "LAO",
//       code: "LA",
//       shortName: "Lao People's Democratic Republic",
//       longName: "Lao People's Democratic Republic",
//     },
//     city: {
//       code: "LPQ",
//       shortName: "Luang Prabang",
//       longName: "Luang Prabang",
//     },
//   },
//   PKZ: {
//     iataCode: "PKZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 15.13,
//       longitude: 105.78,
//     },
//     shortName: "Pakse International Airport",
//     longName: "Pakse International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "LAO",
//       code: "LA",
//       shortName: "Lao People's Democratic Republic",
//       longName: "Lao People's Democratic Republic",
//     },
//     city: {
//       code: "PKZ",
//       shortName: "Pakse",
//       longName: "Pakse",
//     },
//   },
//   ZVK: {
//     iataCode: "ZVK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 16.56,
//       longitude: 104.76,
//     },
//     shortName: "Savannakhet Airport",
//     longName: "Savannakhet Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "LAO",
//       code: "LA",
//       shortName: "Lao People's Democratic Republic",
//       longName: "Lao People's Democratic Republic",
//     },
//     city: {
//       code: "ZVK",
//       shortName: "Savannakhet",
//       longName: "Savannakhet",
//     },
//   },
//   VTE: {
//     iataCode: "VTE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 17.99,
//       longitude: 102.56,
//     },
//     shortName: "Vientiane Airport",
//     longName: "Vientiane Wattay International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "LAO",
//       code: "LA",
//       shortName: "Lao People's Democratic Republic",
//       longName: "Lao People's Democratic Republic",
//     },
//     city: {
//       code: "VTE",
//       shortName: "Vientiane",
//       longName: "Vientiane",
//     },
//   },
//   BTU: {
//     iataCode: "BTU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 3.12,
//       longitude: 113.02,
//     },
//     shortName: "Bintulu Airport",
//     longName: "Bintulu Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "MYS",
//       code: "MY",
//       shortName: "Malaysia",
//       longName: "Malaysia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "BTU",
//       shortName: "Bintulu",
//       longName: "Bintulu",
//     },
//   },
//   KBR: {
//     iataCode: "KBR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 6.17,
//       longitude: 102.29,
//     },
//     shortName: "Kota Bharu Airport",
//     longName: "Sultan Ismail Petra Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "MYS",
//       code: "MY",
//       shortName: "Malaysia",
//       longName: "Malaysia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "KBR",
//       shortName: "Kota Bharu",
//       longName: "Kota Bharu",
//     },
//   },
//   TGG: {
//     iataCode: "TGG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 5.38,
//       longitude: 103.1,
//     },
//     shortName: "Kuala Terengganu Airport",
//     longName: "Sultan Mahmud Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "MYS",
//       code: "MY",
//       shortName: "Malaysia",
//       longName: "Malaysia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "TGG",
//       shortName: "Kuala Terengganu",
//       longName: "Kuala Terengganu",
//     },
//   },
//   KUA: {
//     iataCode: "KUA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 3.78,
//       longitude: 103.21,
//     },
//     shortName: "Kuantan Airport",
//     longName: "Kuantan Sultan Ahmad Shah Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "MYS",
//       code: "MY",
//       shortName: "Malaysia",
//       longName: "Malaysia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "KUA",
//       shortName: "Kuantan",
//       longName: "Kuantan",
//     },
//   },
//   LBU: {
//     iataCode: "LBU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 5.3,
//       longitude: 115.25,
//     },
//     shortName: "Labuan Airport",
//     longName: "Labuan Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "MYS",
//       code: "MY",
//       shortName: "Malaysia",
//       longName: "Malaysia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "LBU",
//       shortName: "Labuan",
//       longName: "Labuan",
//     },
//   },
//   KUL: {
//     iataCode: "KUL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 2.74,
//       longitude: 101.7,
//     },
//     shortName: "Kuala Lumpur",
//     longName: "Kuala Lumpur International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "MYS",
//       code: "MY",
//       shortName: "Malaysia",
//       longName: "Malaysia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "KUL",
//       shortName: "Kuala Lumpur",
//       longName: "Kuala Lumpur",
//     },
//   },
//   JHB: {
//     iataCode: "JHB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 1.64,
//       longitude: 103.67,
//     },
//     shortName: "Johor Bahru",
//     longName: "Senai International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "MYS",
//       code: "MY",
//       shortName: "Malaysia",
//       longName: "Malaysia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "JHB",
//       shortName: "Johor Bahru",
//       longName: "Johor Bahru",
//     },
//   },
//   AOR: {
//     iataCode: "AOR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 6.19,
//       longitude: 100.4,
//     },
//     shortName: "Alor Setar",
//     longName: "Sultan Abdul Halim Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "MYS",
//       code: "MY",
//       shortName: "Malaysia",
//       longName: "Malaysia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "AOR",
//       shortName: "Alor Setar",
//       longName: "Alor Setar",
//     },
//   },
//   LGK: {
//     iataCode: "LGK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 6.33,
//       longitude: 99.73,
//     },
//     shortName: "Langkawi",
//     longName: "Langkawi International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "MYS",
//       code: "MY",
//       shortName: "Malaysia",
//       longName: "Malaysia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "LGK",
//       shortName: "Langkawi",
//       longName: "Langkawi",
//     },
//   },
//   PEN: {
//     iataCode: "PEN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 5.3,
//       longitude: 100.28,
//     },
//     shortName: "Penang",
//     longName: "Penang International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "MYS",
//       code: "MY",
//       shortName: "Malaysia",
//       longName: "Malaysia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "PEN",
//       shortName: "Penang",
//       longName: "Penang",
//     },
//   },
//   BKI: {
//     iataCode: "BKI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 5.94,
//       longitude: 116.05,
//     },
//     shortName: "Kota Kinabalu",
//     longName: "Kota Kinabalu International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "MYS",
//       code: "MY",
//       shortName: "Malaysia",
//       longName: "Malaysia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "BKI",
//       shortName: "Kota Kinabalu",
//       longName: "Kota Kinabalu",
//     },
//   },
//   SDK: {
//     iataCode: "SDK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 5.9,
//       longitude: 118.05,
//     },
//     shortName: "Sandakan",
//     longName: "Sandakan Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "MYS",
//       code: "MY",
//       shortName: "Malaysia",
//       longName: "Malaysia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "SDK",
//       shortName: "Sandakan",
//       longName: "Sandakan",
//     },
//   },
//   KCH: {
//     iataCode: "KCH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 1.48,
//       longitude: 110.34,
//     },
//     shortName: "Kuching",
//     longName: "Kuching International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "MYS",
//       code: "MY",
//       shortName: "Malaysia",
//       longName: "Malaysia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "KCH",
//       shortName: "Kuching",
//       longName: "Kuching",
//     },
//   },
//   MYY: {
//     iataCode: "MYY",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 4.33,
//       longitude: 113.99,
//     },
//     shortName: "Miri",
//     longName: "Miri Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "MYS",
//       code: "MY",
//       shortName: "Malaysia",
//       longName: "Malaysia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "MYY",
//       shortName: "Miri",
//       longName: "Miri",
//     },
//   },
//   SBW: {
//     iataCode: "SBW",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 2.26,
//       longitude: 111.99,
//     },
//     shortName: "Sibu Airport",
//     longName: "Sibu Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "MYS",
//       code: "MY",
//       shortName: "Malaysia",
//       longName: "Malaysia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "SBW",
//       shortName: "Sibu",
//       longName: "Sibu",
//     },
//   },
//   TWU: {
//     iataCode: "TWU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 4.32,
//       longitude: 118.13,
//     },
//     shortName: "Tawau Airport",
//     longName: "Tawau Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "MYS",
//       code: "MY",
//       shortName: "Malaysia",
//       longName: "Malaysia",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "TWU",
//       shortName: "Tawau",
//       longName: "Tawau",
//     },
//   },
//   DRV: {
//     iataCode: "DRV",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 4.19,
//       longitude: 73.53,
//     },
//     shortName: "Dharavandhoo Island Airport",
//     longName: "Dharavandhoo Island Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "MDV",
//       code: "MV",
//       shortName: "Maldives",
//       longName: "Maldives",
//       otherRegion: {
//         shortName: "Indian Ocean Islands",
//         longName: "Indian Ocean Islands",
//       },
//     },
//     city: {
//       code: "DRV",
//       shortName: "Dharavandhoo Island",
//       longName: "Dharavandhoo Island",
//     },
//   },
//   FMT: {
//     iataCode: "FMT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 4.19,
//       longitude: 73.53,
//     },
//     shortName: "Faresmathoda Airport",
//     longName: "Faresmathoda Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "MDV",
//       code: "MV",
//       shortName: "Maldives",
//       longName: "Maldives",
//       otherRegion: {
//         shortName: "Indian Ocean Islands",
//         longName: "Indian Ocean Islands",
//       },
//     },
//     city: {
//       code: "FMT",
//       shortName: "Faresmathoda",
//       longName: "Faresmathoda",
//     },
//   },
//   FND: {
//     iataCode: "FND",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 4.19,
//       longitude: 73.53,
//     },
//     shortName: "Funadhoo Airport",
//     longName: "Funadhoo Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "MDV",
//       code: "MV",
//       shortName: "Maldives",
//       longName: "Maldives",
//       otherRegion: {
//         shortName: "Indian Ocean Islands",
//         longName: "Indian Ocean Islands",
//       },
//     },
//     city: {
//       code: "FND",
//       shortName: "Funadhoo",
//       longName: "Funadhoo",
//     },
//   },
//   FVM: {
//     iataCode: "FVM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 4.19,
//       longitude: 73.53,
//     },
//     shortName: "Fuvahmulak Island Airport",
//     longName: "Fuvahmulak Island Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "MDV",
//       code: "MV",
//       shortName: "Maldives",
//       longName: "Maldives",
//       otherRegion: {
//         shortName: "Indian Ocean Islands",
//         longName: "Indian Ocean Islands",
//       },
//     },
//     city: {
//       code: "FVM",
//       shortName: "Fuvahmulak Island",
//       longName: "Fuvahmulak Island",
//     },
//   },
//   GAN: {
//     iataCode: "GAN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -0.69,
//       longitude: 73.16,
//     },
//     shortName: "Gan Island Airport",
//     longName: "Gan Island Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "MDV",
//       code: "MV",
//       shortName: "Maldives",
//       longName: "Maldives",
//       otherRegion: {
//         shortName: "Indian Ocean Islands",
//         longName: "Indian Ocean Islands",
//       },
//     },
//     city: {
//       code: "GAN",
//       shortName: "Gan Island",
//       longName: "Gan Island",
//     },
//   },
//   HAQ: {
//     iataCode: "HAQ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 4.19,
//       longitude: 73.53,
//     },
//     shortName: "Hanimaadhoo Island Airport",
//     longName: "Hanimaadhoo Island Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "MDV",
//       code: "MV",
//       shortName: "Maldives",
//       longName: "Maldives",
//       otherRegion: {
//         shortName: "Indian Ocean Islands",
//         longName: "Indian Ocean Islands",
//       },
//     },
//     city: {
//       code: "HAQ",
//       shortName: "Hanimaadhoo Island",
//       longName: "Hanimaadhoo Island",
//     },
//   },
//   HRF: {
//     iataCode: "HRF",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 4.19,
//       longitude: 73.53,
//     },
//     shortName: "Hoarafushi Airport",
//     longName: "Hoarafushi Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "MDV",
//       code: "MV",
//       shortName: "Maldives",
//       longName: "Maldives",
//       otherRegion: {
//         shortName: "Indian Ocean Islands",
//         longName: "Indian Ocean Islands",
//       },
//     },
//     city: {
//       code: "HRF",
//       shortName: "Hoarafushi",
//       longName: "Hoarafushi",
//     },
//   },
//   IFU: {
//     iataCode: "IFU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 4.19,
//       longitude: 73.53,
//     },
//     shortName: "Ifuru Airport",
//     longName: "Ifuru Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "MDV",
//       code: "MV",
//       shortName: "Maldives",
//       longName: "Maldives",
//       otherRegion: {
//         shortName: "Indian Ocean Islands",
//         longName: "Indian Ocean Islands",
//       },
//     },
//     city: {
//       code: "IFU",
//       shortName: "Ifuru",
//       longName: "Ifuru",
//     },
//   },
//   KDM: {
//     iataCode: "KDM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 4.19,
//       longitude: 73.53,
//     },
//     shortName: "Kaadedhdhoo Island Airport",
//     longName: "Kaadedhdhoo Island Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "MDV",
//       code: "MV",
//       shortName: "Maldives",
//       longName: "Maldives",
//       otherRegion: {
//         shortName: "Indian Ocean Islands",
//         longName: "Indian Ocean Islands",
//       },
//     },
//     city: {
//       code: "KDM",
//       shortName: "Kaadedhdhoo Island",
//       longName: "Kaadedhdhoo Island",
//     },
//   },
//   KDO: {
//     iataCode: "KDO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 4.19,
//       longitude: 73.53,
//     },
//     shortName: "Kadhdhoo Island Airport",
//     longName: "Kadhdhoo Island Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "MDV",
//       code: "MV",
//       shortName: "Maldives",
//       longName: "Maldives",
//       otherRegion: {
//         shortName: "Indian Ocean Islands",
//         longName: "Indian Ocean Islands",
//       },
//     },
//     city: {
//       code: "KDO",
//       shortName: "Kadhdhoo Island",
//       longName: "Kadhdhoo Island",
//     },
//   },
//   GKK: {
//     iataCode: "GKK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 4.19,
//       longitude: 73.53,
//     },
//     shortName: "Kooddoo Island Airport",
//     longName: "Kooddoo Island Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "MDV",
//       code: "MV",
//       shortName: "Maldives",
//       longName: "Maldives",
//       otherRegion: {
//         shortName: "Indian Ocean Islands",
//         longName: "Indian Ocean Islands",
//       },
//     },
//     city: {
//       code: "GKK",
//       shortName: "Kooddoo Island",
//       longName: "Kooddoo Island",
//     },
//   },
//   HDK: {
//     iataCode: "HDK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 4.19,
//       longitude: 73.53,
//     },
//     shortName: "Kulhudhuffushi Airport",
//     longName: "Kulhudhuffushi Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "MDV",
//       code: "MV",
//       shortName: "Maldives",
//       longName: "Maldives",
//       otherRegion: {
//         shortName: "Indian Ocean Islands",
//         longName: "Indian Ocean Islands",
//       },
//     },
//     city: {
//       code: "HDK",
//       shortName: "Kulhudhuffushi",
//       longName: "Kulhudhuffushi",
//     },
//   },
//   MLE: {
//     iataCode: "MLE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 4.19,
//       longitude: 73.53,
//     },
//     shortName: "Malé",
//     longName: "Velana International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "MDV",
//       code: "MV",
//       shortName: "Maldives",
//       longName: "Maldives",
//       otherRegion: {
//         shortName: "Indian Ocean Islands",
//         longName: "Indian Ocean Islands",
//       },
//     },
//     city: {
//       code: "MLE",
//       shortName: "Malé",
//       longName: "Malé",
//     },
//   },
//   NMF: {
//     iataCode: "NMF",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 4.19,
//       longitude: 73.53,
//     },
//     shortName: "Maafaru International Airport",
//     longName: "Maafaru International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "MDV",
//       code: "MV",
//       shortName: "Maldives",
//       longName: "Maldives",
//       otherRegion: {
//         shortName: "Indian Ocean Islands",
//         longName: "Indian Ocean Islands",
//       },
//     },
//     city: {
//       code: "NMF",
//       shortName: "Maafaru",
//       longName: "Maafaru",
//     },
//   },
//   RUL: {
//     iataCode: "RUL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 4.19,
//       longitude: 73.53,
//     },
//     shortName: "Maavarulu Airport",
//     longName: "Maavarulu Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "MDV",
//       code: "MV",
//       shortName: "Maldives",
//       longName: "Maldives",
//       otherRegion: {
//         shortName: "Indian Ocean Islands",
//         longName: "Indian Ocean Islands",
//       },
//     },
//     city: {
//       code: "RUL",
//       shortName: "Maavarulu",
//       longName: "Maavarulu",
//     },
//   },
//   LMV: {
//     iataCode: "LMV",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 4.19,
//       longitude: 73.53,
//     },
//     shortName: "Madivaru Airport",
//     longName: "Madivaru Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "MDV",
//       code: "MV",
//       shortName: "Maldives",
//       longName: "Maldives",
//       otherRegion: {
//         shortName: "Indian Ocean Islands",
//         longName: "Indian Ocean Islands",
//       },
//     },
//     city: {
//       code: "LMV",
//       shortName: "Naifaru",
//       longName: "Naifaru",
//     },
//   },
//   TMF: {
//     iataCode: "TMF",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 4.19,
//       longitude: 73.53,
//     },
//     shortName: "Thimarafushi Airport",
//     longName: "Thimarafushi Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "MDV",
//       code: "MV",
//       shortName: "Maldives",
//       longName: "Maldives",
//       otherRegion: {
//         shortName: "Indian Ocean Islands",
//         longName: "Indian Ocean Islands",
//       },
//     },
//     city: {
//       code: "TMF",
//       shortName: "Thimarafushi",
//       longName: "Thimarafushi",
//     },
//   },
//   UBN: {
//     iataCode: "UBN",
//     showAsOrigin: false,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 47.84,
//       longitude: 106.77,
//     },
//     shortName: "Ulaanbaatar Airport",
//     longName: "Ulaanbaatar Chinggis Khaan International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "MNG",
//       code: "MN",
//       shortName: "Mongolia",
//       longName: "Mongolia",
//     },
//     city: {
//       code: "ULN",
//       shortName: "Ulaanbaatar",
//       longName: "Ulaanbaatar",
//     },
//   },
//   MDL: {
//     iataCode: "MDL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 21.7,
//       longitude: 95.98,
//     },
//     shortName: "Mandalay Airport",
//     longName: "Mandalay International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "MMR",
//       code: "MM",
//       shortName: "Myanmar",
//       longName: "Myanmar",
//     },
//     city: {
//       code: "MDL",
//       shortName: "Mandalay",
//       longName: "Mandalay",
//     },
//   },
//   NYT: {
//     iataCode: "NYT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 19.62,
//       longitude: 96.2,
//     },
//     shortName: "Naypyidaw Airport",
//     longName: "Naypyidaw Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "MMR",
//       code: "MM",
//       shortName: "Myanmar",
//       longName: "Myanmar",
//     },
//     city: {
//       code: "NYT",
//       shortName: "Nay Pyi Taw",
//       longName: "Nay Pyi Taw",
//     },
//   },
//   RGN: {
//     iataCode: "RGN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 16.91,
//       longitude: 96.13,
//     },
//     shortName: "Yangon",
//     longName: "Yangon International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "MMR",
//       code: "MM",
//       shortName: "Myanmar",
//       longName: "Myanmar",
//     },
//     city: {
//       code: "RGN",
//       shortName: "Yangon",
//       longName: "Yangon",
//     },
//   },
//   BWA: {
//     iataCode: "BWA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 27.51,
//       longitude: 83.42,
//     },
//     shortName: "Bhairawa Airport",
//     longName: "Bhairawa Gautam Buddha Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "NPL",
//       code: "NP",
//       shortName: "Nepal",
//       longName: "Nepal",
//     },
//     city: {
//       code: "BWA",
//       shortName: "Bhairawa",
//       longName: "Bhairawa",
//     },
//   },
//   KTM: {
//     iataCode: "KTM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 27.7,
//       longitude: 85.36,
//     },
//     shortName: "Kathmandu",
//     longName: "Tribhuvan International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "NPL",
//       code: "NP",
//       shortName: "Nepal",
//       longName: "Nepal",
//     },
//     city: {
//       code: "KTM",
//       shortName: "Kathmandu",
//       longName: "Kathmandu",
//     },
//   },
//   NOU: {
//     iataCode: "NOU",
//     showAsOrigin: false,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -22.02,
//       longitude: 166.22,
//     },
//     shortName: "Noumea",
//     longName: "Noumea La Tontouta Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "NCL",
//       code: "NC",
//       shortName: "New Caledonia",
//       longName: "New Caledonia",
//     },
//     city: {
//       code: "NOU",
//       shortName: "Noumea",
//       longName: "Noumea La Tontouta Airport",
//     },
//   },
//   AKL: {
//     iataCode: "AKL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: -37.01,
//       longitude: 174.79,
//     },
//     shortName: "Auckland",
//     longName: "Auckland International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "NZL",
//       code: "NZ",
//       shortName: "New Zealand",
//       longName: "New Zealand",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "AKL",
//       shortName: "Auckland",
//       longName: "Auckland",
//     },
//   },
//   CHC: {
//     iataCode: "CHC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: -43.49,
//       longitude: 172.53,
//     },
//     shortName: "Christchurch",
//     longName: "Christchurch International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "NZL",
//       code: "NZ",
//       shortName: "New Zealand",
//       longName: "New Zealand",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "CHC",
//       shortName: "Christchurch",
//       longName: "Christchurch",
//     },
//   },
//   DUD: {
//     iataCode: "DUD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -45.93,
//       longitude: 170.2,
//     },
//     shortName: "Dunedin",
//     longName: "Dunedin International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "NZL",
//       code: "NZ",
//       shortName: "New Zealand",
//       longName: "New Zealand",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "DUD",
//       shortName: "Dunedin",
//       longName: "Dunedin",
//     },
//   },
//   ZQN: {
//     iataCode: "ZQN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -45.02,
//       longitude: 168.74,
//     },
//     shortName: "Queenstown",
//     longName: "Queenstown Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "NZL",
//       code: "NZ",
//       shortName: "New Zealand",
//       longName: "New Zealand",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "ZQN",
//       shortName: "Queenstown",
//       longName: "Queenstown",
//     },
//   },
//   WLG: {
//     iataCode: "WLG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -41.33,
//       longitude: 174.81,
//     },
//     shortName: "Wellington",
//     longName: "Wellington International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "NZL",
//       code: "NZ",
//       shortName: "New Zealand",
//       longName: "New Zealand",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "WLG",
//       shortName: "Wellington",
//       longName: "Wellington",
//     },
//   },
//   NPE: {
//     iataCode: "NPE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -39.47,
//       longitude: 176.87,
//     },
//     shortName: "Napier Airport",
//     longName: "Napier Hawke's Bay Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "NZL",
//       code: "NZ",
//       shortName: "New Zealand",
//       longName: "New Zealand",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "NPE",
//       shortName: "Napier",
//       longName: "Napier",
//     },
//   },
//   NSN: {
//     iataCode: "NSN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -41.3,
//       longitude: 173.22,
//     },
//     shortName: "Nelson Airport",
//     longName: "Nelson Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "NZL",
//       code: "NZ",
//       shortName: "New Zealand",
//       longName: "New Zealand",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "NSN",
//       shortName: "Nelson",
//       longName: "Nelson",
//     },
//   },
//   NPL: {
//     iataCode: "NPL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -39.01,
//       longitude: 174.18,
//     },
//     shortName: "New Plymouth Airport",
//     longName: "New Plymouth Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "NZL",
//       code: "NZ",
//       shortName: "New Zealand",
//       longName: "New Zealand",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "NPL",
//       shortName: "New Plymouth",
//       longName: "New Plymouth",
//     },
//   },
//   PMR: {
//     iataCode: "PMR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -40.32,
//       longitude: 175.62,
//     },
//     shortName: "Palmerston North Airport",
//     longName: "Palmerston North Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "NZL",
//       code: "NZ",
//       shortName: "New Zealand",
//       longName: "New Zealand",
//       otherRegion: {
//         shortName: "Australasia",
//         longName: "Australasia",
//       },
//     },
//     city: {
//       code: "PMR",
//       shortName: "Palmerston North",
//       longName: "Palmerston North",
//     },
//   },
//   NLK: {
//     iataCode: "NLK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -29.04,
//       longitude: 167.94,
//     },
//     shortName: "Norfolk Island Airport",
//     longName: "Burnt Pine Norfolk Island International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "NFK",
//       code: "NF",
//       shortName: "Norfolk Island",
//       longName: "Norfolk Island",
//     },
//     city: {
//       code: "NLK",
//       shortName: "Burnt Pine",
//       longName: "Burnt Pine",
//     },
//   },
//   BHV: {
//     iataCode: "BHV",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 29.35,
//       longitude: 71.72,
//     },
//     shortName: "Bahawalpur Airport",
//     longName: "Bahawalpur Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "PAK",
//       code: "PK",
//       shortName: "Pakistan",
//       longName: "Pakistan",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "BHV",
//       shortName: "Bahawalpur",
//       longName: "Bahawalpur",
//     },
//   },
//   LYP: {
//     iataCode: "LYP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 31.36,
//       longitude: 72.99,
//     },
//     shortName: "Faisalabad  Airport",
//     longName: "Faisalabad International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "PAK",
//       code: "PK",
//       shortName: "Pakistan",
//       longName: "Pakistan",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "LYP",
//       shortName: "Faisalabad",
//       longName: "Faisalabad",
//     },
//   },
//   ISB: {
//     iataCode: "ISB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 33.62,
//       longitude: 73.1,
//     },
//     shortName: "Islamabad",
//     longName: "Islamabad International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "PAK",
//       code: "PK",
//       shortName: "Pakistan",
//       longName: "Pakistan",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "ISB",
//       shortName: "Islamabad",
//       longName: "Islamabad",
//     },
//   },
//   PEW: {
//     iataCode: "PEW",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 33.99,
//       longitude: 71.51,
//     },
//     shortName: "Peshawar",
//     longName: "Bacha Khan International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "PAK",
//       code: "PK",
//       shortName: "Pakistan",
//       longName: "Pakistan",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "PEW",
//       shortName: "Peshawar",
//       longName: "Peshawar",
//     },
//   },
//   LHE: {
//     iataCode: "LHE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 31.52,
//       longitude: 74.4,
//     },
//     shortName: "Lahore",
//     longName: "Alama Iqbal International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "PAK",
//       code: "PK",
//       shortName: "Pakistan",
//       longName: "Pakistan",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "LHE",
//       shortName: "Lahore",
//       longName: "Lahore",
//     },
//   },
//   MUX: {
//     iataCode: "MUX",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 30.2,
//       longitude: 71.42,
//     },
//     shortName: "Multan",
//     longName: "Multan Muhammad Bin Qasim International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "PAK",
//       code: "PK",
//       shortName: "Pakistan",
//       longName: "Pakistan",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "MUX",
//       shortName: "Multan",
//       longName: "Multan",
//     },
//   },
//   SKT: {
//     iataCode: "SKT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 32.54,
//       longitude: 74.36,
//     },
//     shortName: "Sialkot",
//     longName: "Sialkot International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "PAK",
//       code: "PK",
//       shortName: "Pakistan",
//       longName: "Pakistan",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "SKT",
//       shortName: "Sialkot",
//       longName: "Sialkot",
//     },
//   },
//   KHI: {
//     iataCode: "KHI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 24.91,
//       longitude: 67.16,
//     },
//     shortName: "Karachi",
//     longName: "Quaid-E-Azam International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "PAK",
//       code: "PK",
//       shortName: "Pakistan",
//       longName: "Pakistan",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "KHI",
//       shortName: "Karachi",
//       longName: "Karachi",
//     },
//   },
//   UET: {
//     iataCode: "UET",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 30.25,
//       longitude: 66.94,
//     },
//     shortName: "Quetta Airport",
//     longName: "Quetta International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "PAK",
//       code: "PK",
//       shortName: "Pakistan",
//       longName: "Pakistan",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "UET",
//       shortName: "Quetta",
//       longName: "Quetta",
//     },
//   },
//   RYK: {
//     iataCode: "RYK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 28.38,
//       longitude: 70.28,
//     },
//     shortName: "Rahim Yar Khan Airport",
//     longName: "Rahim Yar Khan Shaikh Zaid Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "PAK",
//       code: "PK",
//       shortName: "Pakistan",
//       longName: "Pakistan",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "RYK",
//       shortName: "Rahim Yar Khan",
//       longName: "Rahim Yar Khan",
//     },
//   },
//   SKZ: {
//     iataCode: "SKZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 27.72,
//       longitude: 68.79,
//     },
//     shortName: "Sukkur Airport",
//     longName: "Sukkur Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "PAK",
//       code: "PK",
//       shortName: "Pakistan",
//       longName: "Pakistan",
//       otherRegion: {
//         shortName: "West Asia",
//         longName: "West Asia",
//       },
//     },
//     city: {
//       code: "SKZ",
//       shortName: "Sukkur",
//       longName: "Sukkur",
//     },
//   },
//   POM: {
//     iataCode: "POM",
//     showAsOrigin: false,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -9.44,
//       longitude: 147.22,
//     },
//     shortName: "Port Moresby Airport",
//     longName: "Port Moresby Jacksons International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "PNG",
//       code: "PG",
//       shortName: "Papua New Guinea",
//       longName: "Papua New Guinea",
//     },
//     city: {
//       code: "POM",
//       shortName: "Port Moresby",
//       longName: "Port Moresby",
//     },
//   },
//   BCD: {
//     iataCode: "BCD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 10.78,
//       longitude: 123.01,
//     },
//     shortName: "Bacolod Airport",
//     longName: "Bacolod-Silay City International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "PHL",
//       code: "PH",
//       shortName: "Philippines",
//       longName: "Philippines",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "BCD",
//       shortName: "Bacolod",
//       longName: "Bacolod",
//     },
//   },
//   USU: {
//     iataCode: "USU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 12.12,
//       longitude: 120.1,
//     },
//     shortName: "Busuanga Airport",
//     longName: "Busuanga Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "PHL",
//       code: "PH",
//       shortName: "Philippines",
//       longName: "Philippines",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "USU",
//       shortName: "Busuanga",
//       longName: "Busuanga",
//     },
//   },
//   BXU: {
//     iataCode: "BXU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 8.95,
//       longitude: 125.48,
//     },
//     shortName: "Butuan Airport",
//     longName: "Butuan Bancasi Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "PHL",
//       code: "PH",
//       shortName: "Philippines",
//       longName: "Philippines",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "BXU",
//       shortName: "Butuan City",
//       longName: "Butuan City",
//     },
//   },
//   CGY: {
//     iataCode: "CGY",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 8.61,
//       longitude: 124.46,
//     },
//     shortName: "Cagayan de Oro Airport",
//     longName: "Cagayan de Oro Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "PHL",
//       code: "PH",
//       shortName: "Philippines",
//       longName: "Philippines",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "CGY",
//       shortName: "Cagayan de Oro",
//       longName: "Cagayan de Oro",
//     },
//   },
//   CYP: {
//     iataCode: "CYP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 12.07,
//       longitude: 124.54,
//     },
//     shortName: "Calbayog Airport",
//     longName: "Calbayog Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "PHL",
//       code: "PH",
//       shortName: "Philippines",
//       longName: "Philippines",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "CYP",
//       shortName: "Calbayog",
//       longName: "Calbayog",
//     },
//   },
//   CRM: {
//     iataCode: "CRM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 12.5,
//       longitude: 124.64,
//     },
//     shortName: "Catarman Airport",
//     longName: "Catarman Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "PHL",
//       code: "PH",
//       shortName: "Philippines",
//       longName: "Philippines",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "CRM",
//       shortName: "Catarman",
//       longName: "Catarman",
//     },
//   },
//   MPH: {
//     iataCode: "MPH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 11.92,
//       longitude: 121.95,
//     },
//     shortName: "Caticlan Airport",
//     longName: "Caticlan Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "PHL",
//       code: "PH",
//       shortName: "Philippines",
//       longName: "Philippines",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "MPH",
//       shortName: "Caticlan",
//       longName: "Caticlan",
//     },
//   },
//   CBO: {
//     iataCode: "CBO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 7.17,
//       longitude: 124.21,
//     },
//     shortName: "Cotabato Airport",
//     longName: "Cotabato Awang Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "PHL",
//       code: "PH",
//       shortName: "Philippines",
//       longName: "Philippines",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "CBO",
//       shortName: "Cotabato",
//       longName: "Cotabato",
//     },
//   },
//   DRP: {
//     iataCode: "DRP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 9.36,
//       longitude: 123.65,
//     },
//     shortName: "Daraga Airport",
//     longName: "Daraga Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "PHL",
//       code: "PH",
//       shortName: "Philippines",
//       longName: "Philippines",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "DRP",
//       shortName: "Daraga",
//       longName: "Daraga",
//     },
//   },
//   DVO: {
//     iataCode: "DVO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 7.13,
//       longitude: 125.65,
//     },
//     shortName: "Davao Airport",
//     longName: "Davao Francisco Bangoy International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "PHL",
//       code: "PH",
//       shortName: "Philippines",
//       longName: "Philippines",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "DVO",
//       shortName: "Davao City",
//       longName: "Davao City",
//     },
//   },
//   IAO: {
//     iataCode: "IAO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 9.86,
//       longitude: 126.01,
//     },
//     shortName: "Del Carmen Airport",
//     longName: "Del Carmen Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "PHL",
//       code: "PH",
//       shortName: "Philippines",
//       longName: "Philippines",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "IAO",
//       shortName: "Del Carmen",
//       longName: "Del Carmen",
//     },
//   },
//   DGT: {
//     iataCode: "DGT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 9.33,
//       longitude: 123.3,
//     },
//     shortName: "Dumaguete Airport",
//     longName: "Dumaguete Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "PHL",
//       code: "PH",
//       shortName: "Philippines",
//       longName: "Philippines",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "DGT",
//       shortName: "Dumaguete",
//       longName: "Dumaguete",
//     },
//   },
//   ILO: {
//     iataCode: "ILO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 10.83,
//       longitude: 122.49,
//     },
//     shortName: "Iloilo Airport",
//     longName: "Iloilo International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "PHL",
//       code: "PH",
//       shortName: "Philippines",
//       longName: "Philippines",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "ILO",
//       shortName: "Iloilo",
//       longName: "Iloilo",
//     },
//   },
//   KLO: {
//     iataCode: "KLO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 11.68,
//       longitude: 122.38,
//     },
//     shortName: "Kalibo Airport",
//     longName: "Kalibo Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "PHL",
//       code: "PH",
//       shortName: "Philippines",
//       longName: "Philippines",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "KLO",
//       shortName: "Kalibo",
//       longName: "Kalibo",
//     },
//   },
//   LAO: {
//     iataCode: "LAO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 18.18,
//       longitude: 120.53,
//     },
//     shortName: "Laoag Airport",
//     longName: "Laoag Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "PHL",
//       code: "PH",
//       shortName: "Philippines",
//       longName: "Philippines",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "LAO",
//       shortName: "Laoag",
//       longName: "Laoag",
//     },
//   },
//   CRK: {
//     iataCode: "CRK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 15.19,
//       longitude: 120.56,
//     },
//     shortName: "Clark",
//     longName: "Clark International Airport, Manila Angeles City",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "PHL",
//       code: "PH",
//       shortName: "Philippines",
//       longName: "Philippines",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "CRK",
//       shortName: "Clark",
//       longName: "Clark",
//     },
//   },
//   CEB: {
//     iataCode: "CEB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 10.31,
//       longitude: 123.98,
//     },
//     shortName: "Cebu",
//     longName: "Mactan-Cebu International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "PHL",
//       code: "PH",
//       shortName: "Philippines",
//       longName: "Philippines",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "CEB",
//       shortName: "Cebu",
//       longName: "Cebu",
//     },
//   },
//   MNL: {
//     iataCode: "MNL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: true,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 14.51,
//       longitude: 121.01,
//     },
//     shortName: "Manila",
//     longName: "Ninoy Aquino International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "PHL",
//       code: "PH",
//       shortName: "Philippines",
//       longName: "Philippines",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "MNL",
//       shortName: "Manila",
//       longName: "Manila",
//     },
//   },
//   TAG: {
//     iataCode: "TAG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 9.66,
//       longitude: 123.85,
//     },
//     shortName: "Panglao Airport",
//     longName: "Panglao Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "PHL",
//       code: "PH",
//       shortName: "Philippines",
//       longName: "Philippines",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "TAG",
//       shortName: "Panglao",
//       longName: "Panglao",
//     },
//   },
//   PPS: {
//     iataCode: "PPS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 9.74,
//       longitude: 118.76,
//     },
//     shortName: "Puerto Princesa Airport",
//     longName: "Puerto Princesa Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "PHL",
//       code: "PH",
//       shortName: "Philippines",
//       longName: "Philippines",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "PPS",
//       shortName: "Puerto Princesa",
//       longName: "Puerto Princesa",
//     },
//   },
//   TAC: {
//     iataCode: "TAC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 11.23,
//       longitude: 125.03,
//     },
//     shortName: "Tacloban Airport",
//     longName: "Tacloban Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "PHL",
//       code: "PH",
//       shortName: "Philippines",
//       longName: "Philippines",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "TAC",
//       shortName: "Tacloban",
//       longName: "Tacloban",
//     },
//   },
//   ZAM: {
//     iataCode: "ZAM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 6.92,
//       longitude: 122.06,
//     },
//     shortName: "Zamboanga Airport",
//     longName: "Zamboanga Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "PHL",
//       code: "PH",
//       shortName: "Philippines",
//       longName: "Philippines",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "ZAM",
//       shortName: "Zamboanga",
//       longName: "Zamboanga",
//     },
//   },
//   APW: {
//     iataCode: "APW",
//     showAsOrigin: false,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -13.83,
//       longitude: -172.01,
//     },
//     shortName: "Apia Airport",
//     longName: "Apia Faleolo International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "WSM",
//       code: "WS",
//       shortName: "Samoa",
//       longName: "Samoa",
//     },
//     city: {
//       code: "APW",
//       shortName: "Apia",
//       longName: "Apia",
//     },
//   },
//   PRI: {
//     iataCode: "PRI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -4.32,
//       longitude: 55.69,
//     },
//     shortName: "Praslin Airport",
//     longName: "Praslin Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "SYC",
//       code: "SC",
//       shortName: "Seychelles",
//       longName: "Seychelles",
//       otherRegion: {
//         shortName: "Indian Ocean Islands",
//         longName: "Indian Ocean Islands",
//       },
//     },
//     city: {
//       code: "PRI",
//       shortName: "Praslin Island",
//       longName: "Praslin Island",
//     },
//   },
//   SEZ: {
//     iataCode: "SEZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: -4.67,
//       longitude: 55.52,
//     },
//     shortName: "Seychelles",
//     longName: "Seychelles International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "SYC",
//       code: "SC",
//       shortName: "Seychelles",
//       longName: "Seychelles",
//       otherRegion: {
//         shortName: "Indian Ocean Islands",
//         longName: "Indian Ocean Islands",
//       },
//     },
//     city: {
//       code: "SEZ",
//       shortName: "Mahe",
//       longName: "Mahe",
//     },
//   },
//   SIN: {
//     iataCode: "SIN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 1.36,
//       longitude: 103.99,
//     },
//     shortName: "Singapore",
//     longName: "Changi Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "SGP",
//       code: "SG",
//       shortName: "Singapore",
//       longName: "Singapore",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "SIN",
//       shortName: "Singapore",
//       longName: "Singapore",
//     },
//   },
//   HRI: {
//     iataCode: "HRI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 6.19,
//       longitude: 81.14,
//     },
//     shortName: "Hambantota Airport",
//     longName: "Mattala Rajapaksa International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "LKA",
//       code: "LK",
//       shortName: "Sri Lanka",
//       longName: "Sri Lanka",
//       otherRegion: {
//         shortName: "Indian Ocean Islands",
//         longName: "Indian Ocean Islands",
//       },
//     },
//     city: {
//       code: "HRI",
//       shortName: "Hambantota",
//       longName: "Hambantota",
//     },
//   },
//   CMB: {
//     iataCode: "CMB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 7.18,
//       longitude: 79.89,
//     },
//     shortName: "Colombo Bandaranaike Airport",
//     longName: "Bandaranaike Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "LKA",
//       code: "LK",
//       shortName: "Sri Lanka",
//       longName: "Sri Lanka",
//       otherRegion: {
//         shortName: "Indian Ocean Islands",
//         longName: "Indian Ocean Islands",
//       },
//     },
//     city: {
//       code: "CMB",
//       shortName: "Colombo",
//       longName: "Colombo",
//     },
//   },
//   KHH: {
//     iataCode: "KHH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 22.58,
//       longitude: 120.35,
//     },
//     shortName: "Kaohsiung Airport",
//     longName: "Kaohsiung International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "TWN",
//       code: "TW",
//       shortName: "Taiwan, China",
//       longName: "Taiwan, China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "KHH",
//       shortName: "Kaohsiung",
//       longName: "Kaohsiung",
//     },
//   },
//   TSA: {
//     iataCode: "TSA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 25.07,
//       longitude: 121.55,
//     },
//     shortName: "Songshan Airport",
//     longName: "Taipei Songshan Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "TWN",
//       code: "TW",
//       shortName: "Taiwan, China",
//       longName: "Taiwan, China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "TPE",
//       shortName: "Taipei",
//       longName: "Taipei",
//     },
//   },
//   TPE: {
//     iataCode: "TPE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 25.08,
//       longitude: 121.23,
//     },
//     shortName: "Taipei",
//     longName: "Taiwan Taoyuan International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "TWN",
//       code: "TW",
//       shortName: "Taiwan, China",
//       longName: "Taiwan, China",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "TPE",
//       shortName: "Taipei",
//       longName: "Taipei",
//     },
//   },
//   DYU: {
//     iataCode: "DYU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 38.54,
//       longitude: 68.82,
//     },
//     shortName: "Dushanbe Airport",
//     longName: "Dushanbe Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "TJK",
//       code: "TJ",
//       shortName: "Tajikistan",
//       longName: "Tajikistan",
//     },
//     city: {
//       code: "DYU",
//       shortName: "Dushanbe",
//       longName: "Dushanbe",
//     },
//   },
//   USM: {
//     iataCode: "USM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 9.55,
//       longitude: 100.06,
//     },
//     shortName: "Koh Samui",
//     longName: "Ko Samui Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "THA",
//       code: "TH",
//       shortName: "Thailand",
//       longName: "Thailand",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "USM",
//       shortName: "Koh Samui",
//       longName: "Koh Samui",
//     },
//   },
//   BKK: {
//     iataCode: "BKK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 13.69,
//       longitude: 100.75,
//     },
//     shortName: "Bangkok",
//     longName: "Suvarnabhumi International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "THA",
//       code: "TH",
//       shortName: "Thailand",
//       longName: "Thailand",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "BKK",
//       shortName: "Bangkok",
//       longName: "Bangkok",
//     },
//   },
//   CNX: {
//     iataCode: "CNX",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 18.77,
//       longitude: 98.96,
//     },
//     shortName: "Chiang Mai",
//     longName: "Chiang Mai International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "THA",
//       code: "TH",
//       shortName: "Thailand",
//       longName: "Thailand",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "CNX",
//       shortName: "Chiang Mai",
//       longName: "Chiang Mai",
//     },
//   },
//   CEI: {
//     iataCode: "CEI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 19.95,
//       longitude: 99.88,
//     },
//     shortName: "Chiang Rai",
//     longName: "Chiang Rai International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "THA",
//       code: "TH",
//       shortName: "Thailand",
//       longName: "Thailand",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "CEI",
//       shortName: "Chiang Rai",
//       longName: "Chiang Rai",
//     },
//   },
//   KKC: {
//     iataCode: "KKC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 16.46,
//       longitude: 102.78,
//     },
//     shortName: "Khon Kaen",
//     longName: "Khon Kaen Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "THA",
//       code: "TH",
//       shortName: "Thailand",
//       longName: "Thailand",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "KKC",
//       shortName: "Khon Kaen",
//       longName: "Khon Kaen",
//     },
//   },
//   KBV: {
//     iataCode: "KBV",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 8.1,
//       longitude: 98.99,
//     },
//     shortName: "Krabi",
//     longName: "Krabi Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "THA",
//       code: "TH",
//       shortName: "Thailand",
//       longName: "Thailand",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "KBV",
//       shortName: "Krabi",
//       longName: "Krabi",
//     },
//   },
//   LPT: {
//     iataCode: "LPT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 18.27,
//       longitude: 99.5,
//     },
//     shortName: "Lampang",
//     longName: "Lampang Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "THA",
//       code: "TH",
//       shortName: "Thailand",
//       longName: "Thailand",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "LPT",
//       shortName: "Lampang",
//       longName: "Lampang",
//     },
//   },
//   HKT: {
//     iataCode: "HKT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 8.11,
//       longitude: 98.31,
//     },
//     shortName: "Phuket",
//     longName: "Phuket International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "THA",
//       code: "TH",
//       shortName: "Thailand",
//       longName: "Thailand",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "HKT",
//       shortName: "Phuket",
//       longName: "Phuket",
//     },
//   },
//   HDY: {
//     iataCode: "HDY",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 6.93,
//       longitude: 100.4,
//     },
//     shortName: "Hat Yai",
//     longName: "Hat Yai International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "THA",
//       code: "TH",
//       shortName: "Thailand",
//       longName: "Thailand",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "HDY",
//       shortName: "Hat Yai",
//       longName: "Hat Yai",
//     },
//   },
//   THS: {
//     iataCode: "THS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 17.24,
//       longitude: 99.82,
//     },
//     shortName: "Sukhothai",
//     longName: "Sukhothai Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "THA",
//       code: "TH",
//       shortName: "Thailand",
//       longName: "Thailand",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "THS",
//       shortName: "Sukhothai",
//       longName: "Sukhothai",
//     },
//   },
//   TDX: {
//     iataCode: "TDX",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 12.27,
//       longitude: 102.32,
//     },
//     shortName: "Trat",
//     longName: "Trat Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "THA",
//       code: "TH",
//       shortName: "Thailand",
//       longName: "Thailand",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "TDX",
//       shortName: "Trat",
//       longName: "Trat",
//     },
//   },
//   UBP: {
//     iataCode: "UBP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 15.25,
//       longitude: 104.87,
//     },
//     shortName: "Ubon Ratchathani",
//     longName: "Ubon Ratchathani Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "THA",
//       code: "TH",
//       shortName: "Thailand",
//       longName: "Thailand",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "UBP",
//       shortName: "Ubon Ratchathani",
//       longName: "Ubon Ratchathani",
//     },
//   },
//   UTH: {
//     iataCode: "UTH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 17.39,
//       longitude: 102.79,
//     },
//     shortName: "Udon Thani",
//     longName: "Udonthani International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "THA",
//       code: "TH",
//       shortName: "Thailand",
//       longName: "Thailand",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "UTH",
//       shortName: "Udon Thani",
//       longName: "Udon Thani",
//     },
//   },
//   UTP: {
//     iataCode: "UTP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 12.68,
//       longitude: 101,
//     },
//     shortName: "UTapao Pattaya Airport",
//     longName: "UTapao Pattaya International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "THA",
//       code: "TH",
//       shortName: "Thailand",
//       longName: "Thailand",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "UTP",
//       shortName: "UTapao",
//       longName: "UTapao",
//     },
//   },
//   TBU: {
//     iataCode: "TBU",
//     showAsOrigin: false,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -21.24,
//       longitude: -175.15,
//     },
//     shortName: "Nuku'alofa Airport",
//     longName: "Nuku'alofa Fua'amotu International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "TON",
//       code: "TO",
//       shortName: "Tonga",
//       longName: "Tonga",
//     },
//     city: {
//       code: "TBU",
//       shortName: "Nuku'alofa",
//       longName: "Nuku'alofa",
//     },
//   },
//   ASB: {
//     iataCode: "ASB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 37.99,
//       longitude: 58.36,
//     },
//     shortName: "Ashgabat",
//     longName: "Ashgabat Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "TKM",
//       code: "TM",
//       shortName: "Turkmenistan",
//       longName: "Turkmenistan",
//     },
//     city: {
//       code: "ASB",
//       shortName: "Ashgabat",
//       longName: "Ashgabat",
//     },
//   },
//   FEG: {
//     iataCode: "FEG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 40.36,
//       longitude: 71.75,
//     },
//     shortName: "Fergana International Airport",
//     longName: "Fergana International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "UZB",
//       code: "UZ",
//       shortName: "Uzbekistan",
//       longName: "Uzbekistan",
//     },
//     city: {
//       code: "FEG",
//       shortName: "Fergana",
//       longName: "Fergana",
//     },
//   },
//   NMA: {
//     iataCode: "NMA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 40.98,
//       longitude: 71.56,
//     },
//     shortName: "Namangan Airport",
//     longName: "Namangan Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "UZB",
//       code: "UZ",
//       shortName: "Uzbekistan",
//       longName: "Uzbekistan",
//     },
//     city: {
//       code: "NMA",
//       shortName: "Namangan",
//       longName: "Namangan",
//     },
//   },
//   SKD: {
//     iataCode: "SKD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 39.7,
//       longitude: 66.98,
//     },
//     shortName: "Samarkand Airport",
//     longName: "Samarkand Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "UZB",
//       code: "UZ",
//       shortName: "Uzbekistan",
//       longName: "Uzbekistan",
//     },
//     city: {
//       code: "SKD",
//       shortName: "Samarkand",
//       longName: "Samarkand",
//     },
//   },
//   TAS: {
//     iataCode: "TAS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 41.26,
//       longitude: 69.28,
//     },
//     shortName: "Tashkent Airport",
//     longName: "Tashkent International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "UZB",
//       code: "UZ",
//       shortName: "Uzbekistan",
//       longName: "Uzbekistan",
//     },
//     city: {
//       code: "TAS",
//       shortName: "Tashkent",
//       longName: "Tashkent",
//     },
//   },
//   SON: {
//     iataCode: "SON",
//     showAsOrigin: false,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -15.51,
//       longitude: 167.22,
//     },
//     shortName: "Luganville Airport",
//     longName: "Luganville Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "VUT",
//       code: "VU",
//       shortName: "Vanuatu",
//       longName: "Vanuatu",
//     },
//     city: {
//       code: "SON",
//       shortName: "Luganville",
//       longName: "Luganville",
//     },
//   },
//   PQC: {
//     iataCode: "PQC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 10.23,
//       longitude: 103.96,
//     },
//     shortName: "Phu Quoc",
//     longName: "Duong Dong Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "VIE",
//       code: "VN",
//       shortName: "Vietnam",
//       longName: "Vietnam",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "PQC",
//       shortName: "Phu Quoc",
//       longName: "Phu Quoc",
//     },
//   },
//   UIH: {
//     iataCode: "UIH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 13.95,
//       longitude: 109.05,
//     },
//     shortName: "Qui Nhon",
//     longName: "Phu Cat Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "VIE",
//       code: "VN",
//       shortName: "Vietnam",
//       longName: "Vietnam",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "UIH",
//       shortName: "Qui Nhon",
//       longName: "Qui Nhon",
//     },
//   },
//   DAD: {
//     iataCode: "DAD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 16.05,
//       longitude: 108.13,
//     },
//     shortName: "Da Nang",
//     longName: "Da Nang International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "VIE",
//       code: "VN",
//       shortName: "Vietnam",
//       longName: "Vietnam",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "DAD",
//       shortName: "Da Nang",
//       longName: "Da Nang",
//     },
//   },
//   BMV: {
//     iataCode: "BMV",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 12.67,
//       longitude: 108.12,
//     },
//     shortName: "Banmethuot",
//     longName: "Buon Ma Thuot Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "VIE",
//       code: "VN",
//       shortName: "Vietnam",
//       longName: "Vietnam",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "BMV",
//       shortName: "Banmethuot",
//       longName: "Banmethuot",
//     },
//   },
//   VCL: {
//     iataCode: "VCL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 15.4,
//       longitude: 108.71,
//     },
//     shortName: "Dung Quat Bay Chu Lai Airport",
//     longName: "Dung Quat Bay Chu Lai International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "VIE",
//       code: "VN",
//       shortName: "Vietnam",
//       longName: "Vietnam",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "VCL",
//       shortName: "Dung Quat Bay",
//       longName: "Dung Quat Bay",
//     },
//   },
//   PXU: {
//     iataCode: "PXU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 14,
//       longitude: 108.02,
//     },
//     shortName: "Pleiku",
//     longName: "Pleiku Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "VIE",
//       code: "VN",
//       shortName: "Vietnam",
//       longName: "Vietnam",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "PXU",
//       shortName: "Pleiku",
//       longName: "Pleiku",
//     },
//   },
//   HPH: {
//     iataCode: "HPH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 20.82,
//       longitude: 106.72,
//     },
//     shortName: "Haiphong",
//     longName: "Cat Bi International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "VIE",
//       code: "VN",
//       shortName: "Vietnam",
//       longName: "Vietnam",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "HPH",
//       shortName: "Haiphong",
//       longName: "Haiphong",
//     },
//   },
//   HAN: {
//     iataCode: "HAN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 21.22,
//       longitude: 105.81,
//     },
//     shortName: "Hanoi",
//     longName: "Noi Bai International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "VIE",
//       code: "VN",
//       shortName: "Vietnam",
//       longName: "Vietnam",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "HAN",
//       shortName: "Hanoi",
//       longName: "Hanoi",
//     },
//   },
//   SGN: {
//     iataCode: "SGN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 10.82,
//       longitude: 106.66,
//     },
//     shortName: "Ho Chi Minh City",
//     longName: "Tan Son Nhat International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "VIE",
//       code: "VN",
//       shortName: "Vietnam",
//       longName: "Vietnam",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "SGN",
//       shortName: "Ho Chi Minh City",
//       alternateNames: ["Saigon"],
//       longName: "Ho Chi Minh City",
//     },
//   },
//   NHA: {
//     iataCode: "NHA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 12.22,
//       longitude: 109.2,
//     },
//     shortName: "Nha Trang",
//     longName: "Nha Trang Air Base",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "VIE",
//       code: "VN",
//       shortName: "Vietnam",
//       longName: "Vietnam",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "NHA",
//       shortName: "Nha Trang",
//       longName: "Nha Trang",
//     },
//   },
//   VKG: {
//     iataCode: "VKG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 9.96,
//       longitude: 105.14,
//     },
//     shortName: "Rach Gia",
//     longName: "Rach Gia Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "VIE",
//       code: "VN",
//       shortName: "Vietnam",
//       longName: "Vietnam",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "VKG",
//       shortName: "Rach Gia",
//       longName: "Rach Gia",
//     },
//   },
//   DLI: {
//     iataCode: "DLI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 11.75,
//       longitude: 108.37,
//     },
//     shortName: "Dalat",
//     longName: "Lien Khuong International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "VIE",
//       code: "VN",
//       shortName: "Vietnam",
//       longName: "Vietnam",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "DLI",
//       shortName: "Dalat",
//       longName: "Dalat",
//     },
//   },
//   VII: {
//     iataCode: "VII",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 18.73,
//       longitude: 105.68,
//     },
//     shortName: "Vinh City",
//     longName: "Vinh Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "VIE",
//       code: "VN",
//       shortName: "Vietnam",
//       longName: "Vietnam",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "VII",
//       shortName: "Vinh City",
//       longName: "Vinh City",
//     },
//   },
//   CXR: {
//     iataCode: "CXR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 12,
//       longitude: 109.22,
//     },
//     shortName: "Nha Trang Airport",
//     longName: "Nha Trang Cam Ranh Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "VIE",
//       code: "VN",
//       shortName: "Vietnam",
//       longName: "Vietnam",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "CXR",
//       shortName: "Nha Trang",
//       longName: "Nha Trang",
//     },
//   },
//   VDH: {
//     iataCode: "VDH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 17.52,
//       longitude: 106.59,
//     },
//     shortName: "Dong Hoi",
//     longName: "Dong Hoi Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "VIE",
//       code: "VN",
//       shortName: "Vietnam",
//       longName: "Vietnam",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "VDH",
//       shortName: "Dong Hoi",
//       longName: "Dong Hoi",
//     },
//   },
//   THD: {
//     iataCode: "THD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 18.74,
//       longitude: 105.67,
//     },
//     shortName: "Thanh Hoa Airport",
//     longName: "Thanh Hoa Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "VIE",
//       code: "VN",
//       shortName: "Vietnam",
//       longName: "Vietnam",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "THD",
//       shortName: "Thanh Hoa",
//       longName: "Thanh Hoa",
//     },
//   },
//   HUI: {
//     iataCode: "HUI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 16.4,
//       longitude: 107.71,
//     },
//     shortName: "Hue",
//     longName: "Phu Bai International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "VIE",
//       code: "VN",
//       shortName: "Vietnam",
//       longName: "Vietnam",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "HUI",
//       shortName: "Hue",
//       longName: "Hue",
//     },
//   },
//   TBB: {
//     iataCode: "TBB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 13.05,
//       longitude: 109.33,
//     },
//     shortName: "Tuy Hoa Airport ",
//     longName: "Tuy Hoa Dong Tac Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Asia and the Pacific",
//       longName: "Asia and the Pacific",
//       code: "ASIA",
//     },
//     country: {
//       a3code: "VIE",
//       code: "VN",
//       shortName: "Vietnam",
//       longName: "Vietnam",
//       otherRegion: {
//         shortName: "Far East",
//         longName: "Far East",
//       },
//     },
//     city: {
//       code: "TBB",
//       shortName: "Tuy Hoa",
//       longName: "Tuy Hoa",
//     },
//   },
//   TIA: {
//     iataCode: "TIA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 41.41,
//       longitude: 19.72,
//     },
//     shortName: "Tirana",
//     longName: "Tirana International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ALB",
//       code: "AL",
//       shortName: "Albania",
//       longName: "Albania",
//     },
//     city: {
//       code: "TIA",
//       shortName: "Tirana",
//       longName: "Tirana",
//     },
//   },
//   VIE: {
//     iataCode: "VIE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 48.11,
//       longitude: 16.57,
//     },
//     shortName: "Vienna",
//     longName: "Vienna International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "AUT",
//       code: "AT",
//       shortName: "Austria",
//       alternateNames: ["Österreich"],
//       longName: "Austria",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "VIE",
//       shortName: "Vienna",
//       longName: "Vienna",
//     },
//   },
//   XGZ: {
//     iataCode: "XGZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 47.5,
//       longitude: 9.75,
//     },
//     shortName: "Bregenz Rail Station",
//     longName: "Bregenz Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "AUT",
//       code: "AT",
//       shortName: "Austria",
//       alternateNames: ["Österreich"],
//       longName: "Austria",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "XGZ",
//       shortName: "Bregenz",
//       longName: "Bregenz",
//     },
//   },
//   GGZ: {
//     iataCode: "GGZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 46.99,
//       longitude: 15.44,
//     },
//     shortName: "Graz Rail Station",
//     longName: "Graz Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "AUT",
//       code: "AT",
//       shortName: "Austria",
//       alternateNames: ["Österreich"],
//       longName: "Austria",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "GRZ",
//       shortName: "Graz",
//       longName: "Graz",
//     },
//   },
//   INN: {
//     iataCode: "INN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 47.26,
//       longitude: 11.34,
//     },
//     shortName: "Innsbruck Airport",
//     longName: "Innsbruck Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "AUT",
//       code: "AT",
//       shortName: "Austria",
//       alternateNames: ["Österreich"],
//       longName: "Austria",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "INN",
//       shortName: "Innsbruck",
//       longName: "Innsbruck",
//     },
//   },
//   IOB: {
//     iataCode: "IOB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 47.26,
//       longitude: 11.34,
//     },
//     shortName: "Innsbruck Rail Station",
//     longName: "Innsbruck Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "AUT",
//       code: "AT",
//       shortName: "Austria",
//       alternateNames: ["Österreich"],
//       longName: "Austria",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "INN",
//       shortName: "Innsbruck",
//       longName: "Innsbruck",
//     },
//   },
//   KGV: {
//     iataCode: "KGV",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 46.64,
//       longitude: 14.34,
//     },
//     shortName: "Klagenfurt Rail Station",
//     longName: "Klagenfurt Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "AUT",
//       code: "AT",
//       shortName: "Austria",
//       alternateNames: ["Österreich"],
//       longName: "Austria",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "KLU",
//       shortName: "Klagenfurt",
//       longName: "Klagenfurt",
//     },
//   },
//   LZS: {
//     iataCode: "LZS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 48.23,
//       longitude: 14.19,
//     },
//     shortName: "Linz Rail Station",
//     longName: "Linz Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "AUT",
//       code: "AT",
//       shortName: "Austria",
//       alternateNames: ["Österreich"],
//       longName: "Austria",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "LNZ",
//       shortName: "Linz",
//       longName: "Linz",
//     },
//   },
//   POK: {
//     iataCode: "POK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 48.11,
//       longitude: 16.57,
//     },
//     shortName: "Saint Polten Rail station",
//     longName: "Saint Polten Rail station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "AUT",
//       code: "AT",
//       shortName: "Austria",
//       alternateNames: ["Österreich"],
//       longName: "Austria",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "POK",
//       shortName: "Saint Polten",
//       longName: "Saint Polten",
//     },
//   },
//   SZG: {
//     iataCode: "SZG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 47.79,
//       longitude: 13,
//     },
//     shortName: "Salzburg Airport",
//     longName: "Salzburg Airport",
//     nearbyAirports: ["VIE"],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "AUT",
//       code: "AT",
//       shortName: "Austria",
//       alternateNames: ["Österreich"],
//       longName: "Austria",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "SZG",
//       shortName: "Salzburg",
//       longName: "Salzburg",
//     },
//   },
//   ZSB: {
//     iataCode: "ZSB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 47.79,
//       longitude: 13,
//     },
//     shortName: "Salzburg Rail Station",
//     longName: "Salzburg Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "AUT",
//       code: "AT",
//       shortName: "Austria",
//       alternateNames: ["Österreich"],
//       longName: "Austria",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "SZG",
//       shortName: "Salzburg",
//       longName: "Salzburg",
//     },
//   },
//   MSQ: {
//     iataCode: "MSQ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 53.88,
//       longitude: 28.03,
//     },
//     shortName: "Minsk Airport",
//     longName: "Minsk International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "BLR",
//       code: "BY",
//       shortName: "Belarus",
//       longName: "Belarus",
//     },
//     city: {
//       code: "MSQ",
//       shortName: "Minsk",
//       longName: "Minsk",
//     },
//   },
//   BRU: {
//     iataCode: "BRU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 50.9,
//       longitude: 4.48,
//     },
//     shortName: "Brussels",
//     longName: "Brussels Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "BEL",
//       code: "BE",
//       shortName: "Belgium",
//       longName: "Belgium",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "BRU",
//       shortName: "Brussels",
//       longName: "Brussels",
//     },
//   },
//   SJJ: {
//     iataCode: "SJJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.82,
//       longitude: 18.33,
//     },
//     shortName: "Sarajevo",
//     longName: "Sarajevo International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "BIH",
//       code: "BA",
//       shortName: "Bosnia and Herzegovina",
//       longName: "Bosnia and Herzegovina",
//     },
//     city: {
//       code: "SJJ",
//       shortName: "Sarajevo",
//       longName: "Sarajevo",
//     },
//   },
//   STT: {
//     iataCode: "STT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 18.34,
//       longitude: -64.97,
//     },
//     shortName: "St Thomas Airport",
//     longName: "St Thomas Cyril E. King Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "VGB",
//       code: "VG",
//       shortName: "British Virgin Islands",
//       longName: "British Virgin Islands",
//     },
//     city: {
//       code: "STT",
//       shortName: "St. Thomas Island",
//       longName: "St. Thomas Island",
//     },
//   },
//   SOF: {
//     iataCode: "SOF",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 42.7,
//       longitude: 23.41,
//     },
//     shortName: "Sofia",
//     longName: "Sofia Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "BGR",
//       code: "BG",
//       shortName: "Bulgaria",
//       longName: "Bulgaria",
//     },
//     city: {
//       code: "SOF",
//       shortName: "Sofia",
//       longName: "Sofia",
//     },
//   },
//   VAR: {
//     iataCode: "VAR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.23,
//       longitude: 27.83,
//     },
//     shortName: "Varna",
//     longName: "Varna Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "BGR",
//       code: "BG",
//       shortName: "Bulgaria",
//       longName: "Bulgaria",
//     },
//     city: {
//       code: "VAR",
//       shortName: "Varna",
//       longName: "Varna",
//     },
//   },
//   BWK: {
//     iataCode: "BWK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.29,
//       longitude: 16.68,
//     },
//     shortName: "Brac Airport",
//     longName: "Brac Bol Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "HRV",
//       code: "HR",
//       shortName: "Croatia",
//       longName: "Croatia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "BWK",
//       shortName: "Brač Island",
//       longName: "Brač Island",
//     },
//   },
//   DBV: {
//     iataCode: "DBV",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 42.56,
//       longitude: 18.27,
//     },
//     shortName: "Dubrovnik Airport",
//     longName: "Dubrovnik Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "HRV",
//       code: "HR",
//       shortName: "Croatia",
//       longName: "Croatia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "DBV",
//       shortName: "Dubrovnik",
//       longName: "Dubrovnik",
//     },
//   },
//   ZAG: {
//     iataCode: "ZAG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 45.74,
//       longitude: 16.07,
//     },
//     shortName: "Zagreb",
//     longName: "Zagreb Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "HRV",
//       code: "HR",
//       shortName: "Croatia",
//       longName: "Croatia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "ZAG",
//       shortName: "Zagreb",
//       longName: "Zagreb",
//     },
//   },
//   SPU: {
//     iataCode: "SPU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.54,
//       longitude: 16.3,
//     },
//     shortName: "Split",
//     longName: "Split Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "HRV",
//       code: "HR",
//       shortName: "Croatia",
//       longName: "Croatia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "SPU",
//       shortName: "Split",
//       longName: "Split",
//     },
//   },
//   OSI: {
//     iataCode: "OSI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 45.46,
//       longitude: 18.81,
//     },
//     shortName: "Osijek Airport",
//     longName: "Osijek Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "HRV",
//       code: "HR",
//       shortName: "Croatia",
//       longName: "Croatia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "OSI",
//       shortName: "Osijek",
//       longName: "Osijek",
//     },
//   },
//   PUY: {
//     iataCode: "PUY",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 44.89,
//       longitude: 13.92,
//     },
//     shortName: "Pula Airport",
//     longName: "Pula Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "HRV",
//       code: "HR",
//       shortName: "Croatia",
//       longName: "Croatia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "PUY",
//       shortName: "Pula",
//       longName: "Pula",
//     },
//   },
//   ZAD: {
//     iataCode: "ZAD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 44.11,
//       longitude: 15.35,
//     },
//     shortName: "Zadar Airport",
//     longName: "Zadar Zemunik Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "HRV",
//       code: "HR",
//       shortName: "Croatia",
//       longName: "Croatia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "ZAD",
//       shortName: "Zadar",
//       longName: "Zadar",
//     },
//   },
//   LCA: {
//     iataCode: "LCA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 34.88,
//       longitude: 33.63,
//     },
//     shortName: "Larnaca",
//     longName: "Larnaca Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "CYP",
//       code: "CY",
//       shortName: "Cyprus",
//       longName: "Cyprus",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "LCA",
//       shortName: "Larnaca",
//       longName: "Larnaca",
//     },
//   },
//   PFO: {
//     iataCode: "PFO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 34.72,
//       longitude: 32.49,
//     },
//     shortName: "Paphos Airport",
//     longName: "Paphos International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "CYP",
//       code: "CY",
//       shortName: "Cyprus",
//       longName: "Cyprus",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "PFO",
//       shortName: "Paphos",
//       longName: "Paphos",
//     },
//   },
//   ZDN: {
//     iataCode: "ZDN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 49.15,
//       longitude: 16.69,
//     },
//     shortName: "Brno Railway Station",
//     longName: "Brno Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "CZE",
//       code: "CZ",
//       shortName: "Czech Republic",
//       longName: "Czech Republic",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "BRQ",
//       shortName: "Brno",
//       longName: "Brno",
//     },
//   },
//   PRG: {
//     iataCode: "PRG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 50.1,
//       longitude: 14.26,
//     },
//     shortName: "Prague",
//     longName: "Václav Havel Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "CZE",
//       code: "CZ",
//       shortName: "Czech Republic",
//       longName: "Czech Republic",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "PRG",
//       shortName: "Prague",
//       longName: "Prague",
//     },
//   },
//   XJV: {
//     iataCode: "XJV",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 49.7,
//       longitude: 18.11,
//     },
//     shortName: "Ostrava Railway Station",
//     longName: "Ostrava Main Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "CZE",
//       code: "CZ",
//       shortName: "Czech Republic",
//       longName: "Czech Republic",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "OSR",
//       shortName: "Ostrava",
//       longName: "Ostrava",
//     },
//   },
//   CPH: {
//     iataCode: "CPH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 55.62,
//       longitude: 12.66,
//     },
//     shortName: "Copenhagen",
//     longName: "Copenhagen Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "DNK",
//       code: "DK",
//       shortName: "Denmark",
//       longName: "Denmark",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "CPH",
//       shortName: "Copenhagen",
//       longName: "Copenhagen",
//     },
//   },
//   AAR: {
//     iataCode: "AAR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 56.3,
//       longitude: 10.62,
//     },
//     shortName: "Aarhus",
//     longName: "Aarhus Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "DNK",
//       code: "DK",
//       shortName: "Denmark",
//       longName: "Denmark",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "AAR",
//       shortName: "Aarhus",
//       longName: "Aarhus",
//     },
//   },
//   AAL: {
//     iataCode: "AAL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 57.09,
//       longitude: 9.85,
//     },
//     shortName: "Aalborg",
//     longName: "Aalborg Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "DNK",
//       code: "DK",
//       shortName: "Denmark",
//       longName: "Denmark",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "AAL",
//       shortName: "Aalborg",
//       longName: "Aalborg",
//     },
//   },
//   BLL: {
//     iataCode: "BLL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 55.74,
//       longitude: 9.15,
//     },
//     shortName: "Billund Airport",
//     longName: "Billund Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "DNK",
//       code: "DK",
//       shortName: "Denmark",
//       longName: "Denmark",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "BLL",
//       shortName: "Billund",
//       longName: "Billund",
//     },
//   },
//   KRP: {
//     iataCode: "KRP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 56.3,
//       longitude: 9.12,
//     },
//     shortName: "Karup Airport",
//     longName: "Karup Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "DNK",
//       code: "DK",
//       shortName: "Denmark",
//       longName: "Denmark",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "KRP",
//       shortName: "Karup ",
//       longName: "Karup ",
//     },
//   },
//   RNN: {
//     iataCode: "RNN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 55.06,
//       longitude: 14.76,
//     },
//     shortName: "Bornholm Airport ",
//     longName: "Rønne Bornholm Airport ",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "DNK",
//       code: "DK",
//       shortName: "Denmark",
//       longName: "Denmark",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "RNN",
//       shortName: "Rønne",
//       longName: "Rønne",
//     },
//   },
//   TLL: {
//     iataCode: "TLL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 59.41,
//       longitude: 24.83,
//     },
//     shortName: "Tallinn",
//     longName: "Lennart Meri Tallinn Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "EST",
//       code: "EE",
//       shortName: "Estonia",
//       longName: "Estonia",
//     },
//     city: {
//       code: "TLL",
//       shortName: "Tallinn",
//       longName: "Tallinn",
//     },
//   },
//   FAE: {
//     iataCode: "FAE",
//     showAsOrigin: false,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 62.07,
//       longitude: -7.28,
//     },
//     shortName: "Vágar Airport",
//     longName: "Vágar Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "FRO",
//       code: "FO",
//       shortName: "Faroe Islands",
//       longName: "Faroe Islands",
//     },
//     city: {
//       code: "FAE",
//       shortName: "Vágar",
//       longName: "Vágar",
//     },
//   },
//   HEL: {
//     iataCode: "HEL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 60.32,
//       longitude: 24.96,
//     },
//     shortName: "Helsinki",
//     longName: "Helsinki Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "FIN",
//       code: "FI",
//       shortName: "Finland",
//       longName: "Finland",
//     },
//     city: {
//       code: "HEL",
//       shortName: "Helsinki",
//       longName: "Helsinki",
//     },
//   },
//   JOE: {
//     iataCode: "JOE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 62.66,
//       longitude: 29.61,
//     },
//     shortName: "Joensuu Airport",
//     longName: "Joensuu Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "FIN",
//       code: "FI",
//       shortName: "Finland",
//       longName: "Finland",
//     },
//     city: {
//       code: "JOE",
//       shortName: "Joensuu",
//       longName: "Joensuu",
//     },
//   },
//   JYV: {
//     iataCode: "JYV",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 62.4,
//       longitude: 25.68,
//     },
//     shortName: "Jyvaskyla Airport",
//     longName: "Jyvaskyla Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "FIN",
//       code: "FI",
//       shortName: "Finland",
//       longName: "Finland",
//     },
//     city: {
//       code: "JYV",
//       shortName: "Jyvaskyla",
//       longName: "Jyvaskyla",
//     },
//   },
//   KAJ: {
//     iataCode: "KAJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 64.29,
//       longitude: 27.69,
//     },
//     shortName: "Kajaani Airport",
//     longName: "Kajaani Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "FIN",
//       code: "FI",
//       shortName: "Finland",
//       longName: "Finland",
//     },
//     city: {
//       code: "KAJ",
//       shortName: "Kajaani",
//       longName: "Kajaani",
//     },
//   },
//   KEM: {
//     iataCode: "KEM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 65.78,
//       longitude: 24.58,
//     },
//     shortName: "Kemi-Tornio Airport",
//     longName: "Kemi-Tornio Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "FIN",
//       code: "FI",
//       shortName: "Finland",
//       longName: "Finland",
//     },
//     city: {
//       code: "KEM",
//       shortName: "Kemi-Tornio",
//       longName: "Kemi-Tornio",
//     },
//   },
//   KOK: {
//     iataCode: "KOK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 63.72,
//       longitude: 23.14,
//     },
//     shortName: "Kokkola-Pietarsaari Airport",
//     longName: "Kokkola-Pietarsaari Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "FIN",
//       code: "FI",
//       shortName: "Finland",
//       longName: "Finland",
//     },
//     city: {
//       code: "KOK",
//       shortName: "Kokkola",
//       longName: "Kokkola",
//     },
//   },
//   TKU: {
//     iataCode: "TKU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 60.51,
//       longitude: 22.26,
//     },
//     shortName: "Turku",
//     longName: "Turku Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "FIN",
//       code: "FI",
//       shortName: "Finland",
//       longName: "Finland",
//     },
//     city: {
//       code: "TKU",
//       shortName: "Turku",
//       longName: "Turku",
//     },
//   },
//   VAA: {
//     iataCode: "VAA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 63.05,
//       longitude: 21.76,
//     },
//     shortName: "Vaasa Airport",
//     longName: "Vaasa Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "FIN",
//       code: "FI",
//       shortName: "Finland",
//       longName: "Finland",
//     },
//     city: {
//       code: "VAA",
//       shortName: "Vaasa",
//       longName: "Vaasa",
//     },
//   },
//   QXB: {
//     iataCode: "QXB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.51,
//       longitude: 5.37,
//     },
//     shortName: "Aix Rail Station",
//     longName: "Aix TGV Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "FRA",
//       code: "FR",
//       shortName: "France",
//       longName: "France",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "QXB",
//       shortName: "Aix",
//       longName: "Aix En-Provence",
//     },
//   },
//   QXG: {
//     iataCode: "QXG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 47.56,
//       longitude: -0.31,
//     },
//     shortName: "Angers Rail Station",
//     longName: "Angers Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "FRA",
//       code: "FR",
//       shortName: "France",
//       longName: "France",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "ANE",
//       shortName: "Angers",
//       longName: "Angers",
//     },
//   },
//   XRZ: {
//     iataCode: "XRZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 50.29,
//       longitude: 2.78,
//     },
//     shortName: "Arras Rail Station",
//     longName: "Arras Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "FRA",
//       code: "FR",
//       shortName: "France",
//       longName: "France",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "QRV",
//       shortName: "Arras",
//       longName: "Arras",
//     },
//   },
//   XZN: {
//     iataCode: "XZN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.91,
//       longitude: 4.9,
//     },
//     shortName: "Avignon Rail Station",
//     longName: "Avignon TGV Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "FRA",
//       code: "FR",
//       shortName: "France",
//       longName: "France",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "AVN",
//       shortName: "Avignon",
//       longName: "Avignon",
//     },
//   },
//   DOL: {
//     iataCode: "DOL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 49.37,
//       longitude: 0.15,
//     },
//     shortName: "Deauville Airport",
//     longName: "Deauville-Saint-Gatien Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "FRA",
//       code: "FR",
//       shortName: "France",
//       longName: "France",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "DOL",
//       shortName: "Deauville",
//       longName: "Deauville",
//     },
//   },
//   ZFQ: {
//     iataCode: "ZFQ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 44.83,
//       longitude: -0.72,
//     },
//     shortName: "Bordeaux",
//     longName: "Bordeaux",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "FRA",
//       code: "FR",
//       shortName: "France",
//       longName: "France",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "BOD",
//       shortName: "Bordeaux",
//       longName: "Bordeaux",
//     },
//   },
//   TLS: {
//     iataCode: "TLS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.64,
//       longitude: 1.37,
//     },
//     shortName: "Toulouse",
//     longName: "Toulouse-Blagnac Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "FRA",
//       code: "FR",
//       shortName: "France",
//       longName: "France",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "TLS",
//       shortName: "Toulouse",
//       longName: "Toulouse",
//     },
//   },
//   MRS: {
//     iataCode: "MRS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.44,
//       longitude: 5.22,
//     },
//     shortName: "Marseille",
//     longName: "Marseille Provence Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "FRA",
//       code: "FR",
//       shortName: "France",
//       longName: "France",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "MRS",
//       shortName: "Marseille",
//       longName: "Marseille",
//     },
//   },
//   XRF: {
//     iataCode: "XRF",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.44,
//       longitude: 5.22,
//     },
//     shortName: "Marseille St. Charles Rail Station",
//     longName: "Marseille St. Charles Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "FRA",
//       code: "FR",
//       shortName: "France",
//       longName: "France",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "MRS",
//       shortName: "Marseille",
//       longName: "Marseille",
//     },
//   },
//   NCE: {
//     iataCode: "NCE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 43.67,
//       longitude: 7.22,
//     },
//     shortName: "Nice",
//     longName: "Cote d'Azur International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "FRA",
//       code: "FR",
//       shortName: "France",
//       longName: "France",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "NCE",
//       shortName: "Nice",
//       longName: "Nice",
//     },
//   },
//   XYD: {
//     iataCode: "XYD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 45.73,
//       longitude: 5.09,
//     },
//     shortName: "Lyon Part Dieu Rail Station",
//     longName: "Lyon Part Dieu Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "FRA",
//       code: "FR",
//       shortName: "France",
//       longName: "France",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "LYS",
//       shortName: "Lyon",
//       alternateNames: ["Paris", "Geneva", "Nice"],
//       longName: "Lyon",
//     },
//   },
//   LYS: {
//     iataCode: "LYS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 45.73,
//       longitude: 5.08,
//     },
//     shortName: "Lyon",
//     longName: "Lyon-Saint Exupéry Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "FRA",
//       code: "FR",
//       shortName: "France",
//       longName: "France",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "LYS",
//       shortName: "Lyon",
//       alternateNames: ["Paris", "Geneva", "Nice"],
//       longName: "Lyon",
//     },
//   },
//   CDG: {
//     iataCode: "CDG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 49.01,
//       longitude: 2.55,
//     },
//     shortName: "Paris",
//     longName: "Charles De Gaulle Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "FRA",
//       code: "FR",
//       shortName: "France",
//       longName: "France",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "PAR",
//       shortName: "Paris",
//       longName: "Paris",
//     },
//   },
//   LAV: {
//     iataCode: "LAV",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 48.08,
//       longitude: 0.76,
//     },
//     shortName: "Laval Rail Station",
//     longName: "Laval Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "FRA",
//       code: "FR",
//       shortName: "France",
//       longName: "France",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "LVA",
//       shortName: "Laval",
//       longName: "Laval",
//     },
//   },
//   ZLN: {
//     iataCode: "ZLN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 47.95,
//       longitude: 0.2,
//     },
//     shortName: "Le Mans Rail Station",
//     longName: "Le Mans Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "FRA",
//       code: "FR",
//       shortName: "France",
//       longName: "France",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "LME",
//       shortName: "Le Mans",
//       longName: "Le Mans",
//     },
//   },
//   XDB: {
//     iataCode: "XDB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 50.56,
//       longitude: 3.09,
//     },
//     shortName: "Lille Europe Rail Station",
//     longName: "Lille Europe Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "FRA",
//       code: "FR",
//       shortName: "France",
//       longName: "France",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "LIL",
//       shortName: "Lille",
//       longName: "Lille",
//     },
//   },
//   XFA: {
//     iataCode: "XFA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 50.64,
//       longitude: 3.07,
//     },
//     shortName: "Lille Flandres Rail Station",
//     longName: "Lille Flandres Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "FRA",
//       code: "FR",
//       shortName: "France",
//       longName: "France",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "LIL",
//       shortName: "Lille",
//       longName: "Lille",
//     },
//   },
//   LIL: {
//     iataCode: "LIL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 50.56,
//       longitude: 3.09,
//     },
//     shortName: "Lille Airport",
//     longName: "Lille-Lesquin Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "FRA",
//       code: "FR",
//       shortName: "France",
//       longName: "France",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "LIL",
//       shortName: "Lille",
//       longName: "Lille",
//     },
//   },
//   XZI: {
//     iataCode: "XZI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 48.98,
//       longitude: 6.25,
//     },
//     shortName: "Lorraine Rail Station",
//     longName: "Lorraine TGV Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "FRA",
//       code: "FR",
//       shortName: "France",
//       longName: "France",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "ETZ",
//       shortName: "Metz",
//       longName: "Metz",
//     },
//   },
//   ETZ: {
//     iataCode: "ETZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 48.98,
//       longitude: 6.25,
//     },
//     shortName: "Metz-Nancy Airport",
//     longName: "Metz-Nancy Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "FRA",
//       code: "FR",
//       shortName: "France",
//       longName: "France",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "ETZ",
//       shortName: "Metz",
//       longName: "Metz",
//     },
//   },
//   XPJ: {
//     iataCode: "XPJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.58,
//       longitude: 3.96,
//     },
//     shortName: "Montpellier St. Roch Rail Station",
//     longName: "Montpellier St. Roch Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "FRA",
//       code: "FR",
//       shortName: "France",
//       longName: "France",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "MPL",
//       shortName: "Montpellier",
//       longName: "Montpellier",
//     },
//   },
//   NTE: {
//     iataCode: "NTE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 47.15,
//       longitude: -1.61,
//     },
//     shortName: "Nantes Airport",
//     longName: "Nantes Atlantique Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "FRA",
//       code: "FR",
//       shortName: "France",
//       longName: "France",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "NTE",
//       shortName: "Nantes",
//       longName: "Nantes",
//     },
//   },
//   QJZ: {
//     iataCode: "QJZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 47.15,
//       longitude: -1.61,
//     },
//     shortName: "Nantes Rail Station",
//     longName: "Nantes Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "FRA",
//       code: "FR",
//       shortName: "France",
//       longName: "France",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "NTE",
//       shortName: "Nantes",
//       longName: "Nantes",
//     },
//   },
//   NPD: {
//     iataCode: "NPD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.76,
//       longitude: 4.42,
//     },
//     shortName: "Nimes Pont Du Gard Rail Station",
//     longName: "Nimes Pont Du Gard Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "FRA",
//       code: "FR",
//       shortName: "France",
//       longName: "France",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "FNI",
//       shortName: "Nimes",
//       longName: "Nimes",
//     },
//   },
//   ZYN: {
//     iataCode: "ZYN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.76,
//       longitude: 4.42,
//     },
//     shortName: "Nimes Rail Station",
//     longName: "Nimes Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "FRA",
//       code: "FR",
//       shortName: "France",
//       longName: "France",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "FNI",
//       shortName: "Nimes",
//       longName: "Nimes",
//     },
//   },
//   XPI: {
//     iataCode: "XPI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 42.7,
//       longitude: 2.88,
//     },
//     shortName: "Perpignan Rail Station",
//     longName: "Perpignan Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "FRA",
//       code: "FR",
//       shortName: "France",
//       longName: "France",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "PGF",
//       shortName: "Perpignan",
//       longName: "Perpignan",
//     },
//   },
//   XOP: {
//     iataCode: "XOP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 46.59,
//       longitude: 0.31,
//     },
//     shortName: "Poitiers Rail Station",
//     longName: "Poitiers Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "FRA",
//       code: "FR",
//       shortName: "France",
//       longName: "France",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "PIS",
//       shortName: "Poitiers",
//       longName: "Poitiers",
//     },
//   },
//   XIZ: {
//     iataCode: "XIZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 49.31,
//       longitude: 4.05,
//     },
//     shortName: "Champagne Rail Station",
//     longName: "Champagne TGV Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "FRA",
//       code: "FR",
//       shortName: "France",
//       longName: "France",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "RHE",
//       shortName: "Reims",
//       longName: "Reims",
//     },
//   },
//   ZFJ: {
//     iataCode: "ZFJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 48.07,
//       longitude: -1.73,
//     },
//     shortName: "Rennes Rail Station",
//     longName: "Rennes Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "FRA",
//       code: "FR",
//       shortName: "France",
//       longName: "France",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "RNS",
//       shortName: "Rennes",
//       longName: "Rennes",
//     },
//   },
//   SXB: {
//     iataCode: "SXB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 48.54,
//       longitude: 7.63,
//     },
//     shortName: "Strasbourg Airport",
//     longName: "Strasbourg Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "FRA",
//       code: "FR",
//       shortName: "France",
//       longName: "France",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "SXB",
//       shortName: "Strasbourg",
//       longName: "Strasbourg",
//     },
//   },
//   XWG: {
//     iataCode: "XWG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 48.54,
//       longitude: 7.63,
//     },
//     shortName: "Strasbourg Rail Station",
//     longName: "Strasbourg Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "FRA",
//       code: "FR",
//       shortName: "France",
//       longName: "France",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "SXB",
//       shortName: "Strasbourg",
//       longName: "Strasbourg",
//     },
//   },
//   XZV: {
//     iataCode: "XZV",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.1,
//       longitude: 6.15,
//     },
//     shortName: "Toulon Rail Station",
//     longName: "Toulon Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "FRA",
//       code: "FR",
//       shortName: "France",
//       longName: "France",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "TLN",
//       shortName: "Toulon",
//       longName: "Toulon",
//     },
//   },
//   XSH: {
//     iataCode: "XSH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 47.43,
//       longitude: 0.73,
//     },
//     shortName: "St Pierre des Corps Rail Station",
//     longName: "St Pierre des Corps Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "FRA",
//       code: "FR",
//       shortName: "France",
//       longName: "France",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "TUF",
//       shortName: "Tours",
//       longName: "Tours",
//     },
//   },
//   XHK: {
//     iataCode: "XHK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 44.92,
//       longitude: 4.97,
//     },
//     shortName: "Valence TGV Rail Station",
//     longName: "Valence TGV Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "FRA",
//       code: "FR",
//       shortName: "France",
//       longName: "France",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "VAF",
//       shortName: "Valence",
//       longName: "Valence",
//     },
//   },
//   BUS: {
//     iataCode: "BUS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 41.61,
//       longitude: 41.6,
//     },
//     shortName: "Batumi Airport",
//     longName: "Batumi International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GEO",
//       code: "GE",
//       shortName: "Georgia",
//       longName: "Georgia",
//     },
//     city: {
//       code: "BUS",
//       shortName: "Batumi",
//       longName: "Batumi",
//     },
//   },
//   KUT: {
//     iataCode: "KUT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 42.18,
//       longitude: 42.48,
//     },
//     shortName: "Kutaisi Airport",
//     longName: "Kutaisi Kopitnari Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GEO",
//       code: "GE",
//       shortName: "Georgia",
//       longName: "Georgia",
//     },
//     city: {
//       code: "KUT",
//       shortName: "Kutaisi",
//       longName: "Kutaisi",
//     },
//   },
//   TBS: {
//     iataCode: "TBS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 41.67,
//       longitude: 44.95,
//     },
//     shortName: "Tbilisi",
//     longName: "Tbilisi International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GEO",
//       code: "GE",
//       shortName: "Georgia",
//       longName: "Georgia",
//     },
//     city: {
//       code: "TBS",
//       shortName: "Tbilisi",
//       longName: "Tbilisi",
//     },
//   },
//   ZQU: {
//     iataCode: "ZQU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 52.32,
//       longitude: 10.56,
//     },
//     shortName: "Wolfsburg Rail Station",
//     longName: "Wolfsburg Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "DEU",
//       code: "DE",
//       shortName: "Germany",
//       longName: "Germany",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "BWE",
//       shortName: "Braunschweig",
//       longName: "Braunschweig",
//     },
//   },
//   DHC: {
//     iataCode: "DHC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 53.05,
//       longitude: 8.79,
//     },
//     shortName: "Bremen Railway Station",
//     longName: "Bremen Central Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "DEU",
//       code: "DE",
//       shortName: "Germany",
//       longName: "Germany",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "BRE",
//       shortName: "Bremen",
//       longName: "Bremen",
//     },
//   },
//   FKB: {
//     iataCode: "FKB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 48.78,
//       longitude: 8.08,
//     },
//     shortName: "Baden Baden",
//     longName: "Baden Airpark",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "DEU",
//       code: "DE",
//       shortName: "Germany",
//       longName: "Germany",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "FKB",
//       shortName: "Baden Baden",
//       longName: "Baden Baden",
//     },
//   },
//   STR: {
//     iataCode: "STR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 48.69,
//       longitude: 9.22,
//     },
//     shortName: "Stuttgart",
//     longName: "Stuttgart Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "DEU",
//       code: "DE",
//       shortName: "Germany",
//       longName: "Germany",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "STR",
//       shortName: "Stuttgart",
//       longName: "Stuttgart",
//     },
//   },
//   ZWS: {
//     iataCode: "ZWS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 48.69,
//       longitude: 9.22,
//     },
//     shortName: "Stuttgart Rail Station",
//     longName: "Stuttgart Main Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "DEU",
//       code: "DE",
//       shortName: "Germany",
//       longName: "Germany",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "STR",
//       shortName: "Stuttgart",
//       longName: "Stuttgart",
//     },
//   },
//   MUC: {
//     iataCode: "MUC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 48.35,
//       longitude: 11.79,
//     },
//     shortName: "Munich",
//     alternateNames: ["München", "Muenchen"],
//     longName: "Franz Josef Strauss Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "DEU",
//       code: "DE",
//       shortName: "Germany",
//       longName: "Germany",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "MUC",
//       shortName: "Munich",
//       longName: "Munich",
//     },
//   },
//   NUE: {
//     iataCode: "NUE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 49.5,
//       longitude: 11.08,
//     },
//     shortName: "Nuremberg",
//     longName: "Nuremberg Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "DEU",
//       code: "DE",
//       shortName: "Germany",
//       longName: "Germany",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "NUE",
//       shortName: "Nuremberg",
//       longName: "Nuremberg",
//     },
//   },
//   ZAQ: {
//     iataCode: "ZAQ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 49.5,
//       longitude: 11.07,
//     },
//     shortName: "Nuremberg Railway Station",
//     longName: "Nuremberg Central Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "DEU",
//       code: "DE",
//       shortName: "Germany",
//       longName: "Germany",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "NUE",
//       shortName: "Nuremberg",
//       longName: "Nuremberg",
//     },
//   },
//   BER: {
//     iataCode: "BER",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 52.52,
//       longitude: 13.39,
//     },
//     shortName: "Berlin Brandenburg Airport",
//     longName: "Berlin Brandenburg International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "DEU",
//       code: "DE",
//       shortName: "Germany",
//       longName: "Germany",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "BER",
//       shortName: "Berlin",
//       longName: "Berlin",
//     },
//   },
//   QPP: {
//     iataCode: "QPP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 52.52,
//       longitude: 13.4,
//     },
//     shortName: "Berlin Railway Station",
//     longName: "Berlin Central Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "DEU",
//       code: "DE",
//       shortName: "Germany",
//       longName: "Germany",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "BER",
//       shortName: "Berlin",
//       longName: "Berlin",
//     },
//   },
//   XIT: {
//     iataCode: "XIT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 51.43,
//       longitude: 12.24,
//     },
//     shortName: "Leipzig Railway Station",
//     longName: "Leipzig Central Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "DEU",
//       code: "DE",
//       shortName: "Germany",
//       longName: "Germany",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "LEJ",
//       shortName: "Leipzig",
//       longName: "Leipzig",
//     },
//   },
//   LEJ: {
//     iataCode: "LEJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 51.43,
//       longitude: 12.24,
//     },
//     shortName: "Leipzig Airport",
//     longName: "Leipzig Halle Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "DEU",
//       code: "DE",
//       shortName: "Germany",
//       longName: "Germany",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "LEJ",
//       shortName: "Leipzig",
//       longName: "Leipzig",
//     },
//   },
//   HAM: {
//     iataCode: "HAM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 53.63,
//       longitude: 9.99,
//     },
//     shortName: "Hamburg",
//     longName: "Hamburg Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "DEU",
//       code: "DE",
//       shortName: "Germany",
//       longName: "Germany",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "HAM",
//       shortName: "Hamburg",
//       longName: "Hamburg",
//     },
//   },
//   FRA: {
//     iataCode: "FRA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 50.03,
//       longitude: 8.57,
//     },
//     shortName: "Frankfurt",
//     longName: "Rhein-Main International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "DEU",
//       code: "DE",
//       shortName: "Germany",
//       longName: "Germany",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "FRA",
//       shortName: "Frankfurt",
//       longName: "Frankfurt am Main",
//     },
//   },
//   ZVR: {
//     iataCode: "ZVR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 52.46,
//       longitude: 9.69,
//     },
//     shortName: "Hannover Railway Station",
//     longName: "Hannover Central Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "DEU",
//       code: "DE",
//       shortName: "Germany",
//       longName: "Germany",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "HAJ",
//       shortName: "Hanover",
//       longName: "Hanover",
//     },
//   },
//   HAJ: {
//     iataCode: "HAJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 52.46,
//       longitude: 9.68,
//     },
//     shortName: "Hanover",
//     longName: "Hannover-Langenhagen Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "DEU",
//       code: "DE",
//       shortName: "Germany",
//       longName: "Germany",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "HAJ",
//       shortName: "Hanover",
//       longName: "Hanover",
//     },
//   },
//   CGN: {
//     iataCode: "CGN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 50.87,
//       longitude: 7.14,
//     },
//     shortName: "Cologne",
//     alternateNames: ["Koelln", "Kölln"],
//     longName: "Cologne Bonn Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "DEU",
//       code: "DE",
//       shortName: "Germany",
//       longName: "Germany",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "CGN",
//       shortName: "Cologne",
//       longName: "Cologne",
//     },
//   },
//   QKL: {
//     iataCode: "QKL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 50.87,
//       longitude: 7.14,
//     },
//     shortName: "Cologne Railway Station",
//     longName: "Cologne Central Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "DEU",
//       code: "DE",
//       shortName: "Germany",
//       longName: "Germany",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "CGN",
//       shortName: "Cologne",
//       longName: "Cologne",
//     },
//   },
//   DUS: {
//     iataCode: "DUS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 51.28,
//       longitude: 6.76,
//     },
//     shortName: "Düsseldorf",
//     alternateNames: ["Dusseldorf", "Duesseldorf"],
//     longName: "Düsseldorf Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "DEU",
//       code: "DE",
//       shortName: "Germany",
//       longName: "Germany",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "DUS",
//       shortName: "Düsseldorf",
//       longName: "Düsseldorf",
//     },
//   },
//   FMO: {
//     iataCode: "FMO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 52.13,
//       longitude: 7.68,
//     },
//     shortName: "Münster Osnabrück",
//     longName: "Münster Osnabrück Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "DEU",
//       code: "DE",
//       shortName: "Germany",
//       longName: "Germany",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "FMO",
//       shortName: "Münster",
//       longName: "Münster",
//     },
//   },
//   MKF: {
//     iataCode: "MKF",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 52.13,
//       longitude: 7.68,
//     },
//     shortName: "Münster Rail Station",
//     longName: "Münster Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "DEU",
//       code: "DE",
//       shortName: "Germany",
//       longName: "Germany",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "FMO",
//       shortName: "Münster",
//       longName: "Münster",
//     },
//   },
//   DRS: {
//     iataCode: "DRS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 51.13,
//       longitude: 13.77,
//     },
//     shortName: "Dresden",
//     longName: "Dresden Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "DEU",
//       code: "DE",
//       shortName: "Germany",
//       longName: "Germany",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "DRS",
//       shortName: "Dresden",
//       longName: "Dresden",
//     },
//   },
//   XIR: {
//     iataCode: "XIR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 51.13,
//       longitude: 13.77,
//     },
//     shortName: "Dresden Railway Station",
//     longName: "Dresden Central Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "DEU",
//       code: "DE",
//       shortName: "Germany",
//       longName: "Germany",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "DRS",
//       shortName: "Dresden",
//       longName: "Dresden",
//     },
//   },
//   DTZ: {
//     iataCode: "DTZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 51.52,
//       longitude: 7.61,
//     },
//     shortName: "Dortmund Rail Station",
//     longName: "Dortmund Main Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "DEU",
//       code: "DE",
//       shortName: "Germany",
//       longName: "Germany",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "DTM",
//       shortName: "Dortmund",
//       longName: "Dortmund",
//     },
//   },
//   KSF: {
//     iataCode: "KSF",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 51.41,
//       longitude: 9.38,
//     },
//     shortName: "Kassel Airport",
//     longName: "Kassel-Calden Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "DEU",
//       code: "DE",
//       shortName: "Germany",
//       longName: "Germany",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "KSF",
//       shortName: "Kassel",
//       longName: "Kassel",
//     },
//   },
//   SCN: {
//     iataCode: "SCN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 49.21,
//       longitude: 7.11,
//     },
//     shortName: "Saarbrücken Airport",
//     longName: "Saarbrücken Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "DEU",
//       code: "DE",
//       shortName: "Germany",
//       longName: "Germany",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "SCN",
//       shortName: "Saarbrücken",
//       longName: "Saarbrücken",
//     },
//   },
//   AXD: {
//     iataCode: "AXD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 40.86,
//       longitude: 25.96,
//     },
//     shortName: "Dimokritos Airport",
//     longName: "Alexandroupoli Dimokritos Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GRC",
//       code: "GR",
//       shortName: "Greece",
//       longName: "Greece",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "AXD",
//       shortName: "Alexandroupolis",
//       longName: "Alexandroupolis",
//     },
//   },
//   JTY: {
//     iataCode: "JTY",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 36.58,
//       longitude: 26.38,
//     },
//     shortName: "Astypalaia Airport",
//     longName: "Astypalaia Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GRC",
//       code: "GR",
//       shortName: "Greece",
//       longName: "Greece",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "JTY",
//       shortName: "Astypalaia Island",
//       longName: "Astypalaia Island",
//     },
//   },
//   JKH: {
//     iataCode: "JKH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 38.34,
//       longitude: 26.14,
//     },
//     shortName: "Chios Airport",
//     longName: "Chios Island National Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GRC",
//       code: "GR",
//       shortName: "Greece",
//       longName: "Greece",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "JKH",
//       shortName: "Chios Island",
//       longName: "Chios Island",
//     },
//   },
//   JSH: {
//     iataCode: "JSH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 35.22,
//       longitude: 26.1,
//     },
//     shortName: "Sitia Airport",
//     longName: "Crete Sitia Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GRC",
//       code: "GR",
//       shortName: "Greece",
//       longName: "Greece",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "JSH",
//       shortName: "Crete",
//       longName: "Crete",
//     },
//   },
//   ATH: {
//     iataCode: "ATH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 37.94,
//       longitude: 23.94,
//     },
//     shortName: "Athens",
//     longName: "Eleftherios Venizelos Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GRC",
//       code: "GR",
//       shortName: "Greece",
//       longName: "Greece",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "ATH",
//       shortName: "Athens",
//       longName: "Athens",
//     },
//   },
//   CHQ: {
//     iataCode: "CHQ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 35.53,
//       longitude: 24.15,
//     },
//     shortName: "Chania",
//     longName: "Chania International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GRC",
//       code: "GR",
//       shortName: "Greece",
//       longName: "Greece",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "CHQ",
//       shortName: "Chania",
//       longName: "Chania",
//     },
//   },
//   HER: {
//     iataCode: "HER",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 35.34,
//       longitude: 25.18,
//     },
//     shortName: "Heraklion",
//     longName: "Heraklion International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GRC",
//       code: "GR",
//       shortName: "Greece",
//       longName: "Greece",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "HER",
//       shortName: "Heraklion",
//       longName: "Heraklion",
//     },
//   },
//   MJT: {
//     iataCode: "MJT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 39.06,
//       longitude: 26.6,
//     },
//     shortName: "Mitilini",
//     longName: "Mytilene International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GRC",
//       code: "GR",
//       shortName: "Greece",
//       longName: "Greece",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "MJT",
//       shortName: "Mitilini",
//       longName: "Mitilini",
//     },
//   },
//   RHO: {
//     iataCode: "RHO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 36.41,
//       longitude: 28.09,
//     },
//     shortName: "Rhodes",
//     longName: "Rhodes International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GRC",
//       code: "GR",
//       shortName: "Greece",
//       longName: "Greece",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "RHO",
//       shortName: "Rhodes",
//       longName: "Rhodes",
//     },
//   },
//   SKG: {
//     iataCode: "SKG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 40.52,
//       longitude: 22.97,
//     },
//     shortName: "Thessaloniki",
//     longName: "Thessaloniki International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GRC",
//       code: "GR",
//       shortName: "Greece",
//       longName: "Greece",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "SKG",
//       shortName: "Thessaloniki",
//       longName: "Thessaloniki",
//     },
//   },
//   CFU: {
//     iataCode: "CFU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 39.6,
//       longitude: 19.91,
//     },
//     shortName: "Corfu",
//     longName: "Corfu International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GRC",
//       code: "GR",
//       shortName: "Greece",
//       longName: "Greece",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "CFU",
//       shortName: "Corfu",
//       longName: "Corfu",
//     },
//   },
//   JIK: {
//     iataCode: "JIK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 37.68,
//       longitude: 26.35,
//     },
//     shortName: "Ikaria Airport",
//     longName: "Ikaria Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GRC",
//       code: "GR",
//       shortName: "Greece",
//       longName: "Greece",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "JIK",
//       shortName: "Ikaria",
//       longName: "Ikaria",
//     },
//   },
//   IOA: {
//     iataCode: "IOA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 39.7,
//       longitude: 20.82,
//     },
//     shortName: "Ioannina Airport",
//     longName: "Ioannina Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GRC",
//       code: "GR",
//       shortName: "Greece",
//       longName: "Greece",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "IOA",
//       shortName: "Ioannina",
//       longName: "Ioannina",
//     },
//   },
//   KLX: {
//     iataCode: "KLX",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 37.07,
//       longitude: 22.03,
//     },
//     shortName: "Kalamata Airport",
//     longName: "Kalamata Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GRC",
//       code: "GR",
//       shortName: "Greece",
//       longName: "Greece",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "KLX",
//       shortName: "Kalamata",
//       longName: "Kalamata",
//     },
//   },
//   JKL: {
//     iataCode: "JKL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 36.96,
//       longitude: 26.94,
//     },
//     shortName: "Kalymnos Airport",
//     longName: "Kalymnos Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GRC",
//       code: "GR",
//       shortName: "Greece",
//       longName: "Greece",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "JKL",
//       shortName: "Kalymnos Island",
//       longName: "Kalymnos Island",
//     },
//   },
//   AOK: {
//     iataCode: "AOK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 35.42,
//       longitude: 27.15,
//     },
//     shortName: "Karpathos Airport",
//     longName: "Karpathos Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GRC",
//       code: "GR",
//       shortName: "Greece",
//       longName: "Greece",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "AOK",
//       shortName: "Karpathos",
//       longName: "Karpathos",
//     },
//   },
//   KSJ: {
//     iataCode: "KSJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 35.42,
//       longitude: 26.91,
//     },
//     shortName: "Kasos Airport",
//     longName: "Kasos Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GRC",
//       code: "GR",
//       shortName: "Greece",
//       longName: "Greece",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "KSJ",
//       shortName: "Kasos Island",
//       longName: "Kasos Island",
//     },
//   },
//   KZS: {
//     iataCode: "KZS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 36.14,
//       longitude: 29.58,
//     },
//     shortName: "Kastelorizo Airport",
//     longName: "Kastelorizo Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GRC",
//       code: "GR",
//       shortName: "Greece",
//       longName: "Greece",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "KZS",
//       shortName: "Kastelorizo Island",
//       longName: "Kastelorizo Island",
//     },
//   },
//   KVA: {
//     iataCode: "KVA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 40.91,
//       longitude: 24.62,
//     },
//     shortName: "Kavala Airport",
//     longName: "Kavala  International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GRC",
//       code: "GR",
//       shortName: "Greece",
//       longName: "Greece",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "KVA",
//       shortName: "Kavala",
//       longName: "Kavala",
//     },
//   },
//   EFL: {
//     iataCode: "EFL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 38.12,
//       longitude: 20.5,
//     },
//     shortName: "Kefallinia Airport",
//     longName: "Kefallinia Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GRC",
//       code: "GR",
//       shortName: "Greece",
//       longName: "Greece",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "EFL",
//       shortName: "Kefallinia Island",
//       longName: "Kefallinia Island",
//     },
//   },
//   KIT: {
//     iataCode: "KIT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 36.27,
//       longitude: 23.02,
//     },
//     shortName: "Kithira Airport",
//     longName: "Kithira Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GRC",
//       code: "GR",
//       shortName: "Greece",
//       longName: "Greece",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "KIT",
//       shortName: "Kithira",
//       longName: "Kithira",
//     },
//   },
//   KGS: {
//     iataCode: "KGS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 36.79,
//       longitude: 27.09,
//     },
//     shortName: "Kos Airport",
//     longName: "Kos Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GRC",
//       code: "GR",
//       shortName: "Greece",
//       longName: "Greece",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "KGS",
//       shortName: "Kos Island",
//       longName: "Kos Island",
//     },
//   },
//   LRS: {
//     iataCode: "LRS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 37.18,
//       longitude: 26.8,
//     },
//     shortName: "Leros Airport",
//     longName: "Leros Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GRC",
//       code: "GR",
//       shortName: "Greece",
//       longName: "Greece",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "LRS",
//       shortName: "Leros",
//       longName: "Leros",
//     },
//   },
//   LXS: {
//     iataCode: "LXS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 39.92,
//       longitude: 25.24,
//     },
//     shortName: "Limnos Airport",
//     longName: "Limnos Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GRC",
//       code: "GR",
//       shortName: "Greece",
//       longName: "Greece",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "LXS",
//       shortName: "Limnos",
//       longName: "Limnos",
//     },
//   },
//   MLO: {
//     iataCode: "MLO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 36.7,
//       longitude: 24.48,
//     },
//     shortName: "Milos Airport",
//     longName: "Milos Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GRC",
//       code: "GR",
//       shortName: "Greece",
//       longName: "Greece",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "MLO",
//       shortName: "Milos",
//       longName: "Milos",
//     },
//   },
//   JMK: {
//     iataCode: "JMK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 25.35,
//       longitude: 37.44,
//     },
//     shortName: "Mikonos Airport",
//     longName: "Mikonos Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GRC",
//       code: "GR",
//       shortName: "Greece",
//       longName: "Greece",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "JMK",
//       shortName: "Mykonos Island",
//       longName: "Mykonos Island",
//     },
//   },
//   JNX: {
//     iataCode: "JNX",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 37.08,
//       longitude: 25.37,
//     },
//     shortName: "Naxos Airport",
//     longName: "Naxos Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GRC",
//       code: "GR",
//       shortName: "Greece",
//       longName: "Greece",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "JNX",
//       shortName: "Naxos",
//       longName: "Naxos",
//     },
//   },
//   PAS: {
//     iataCode: "PAS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 37.02,
//       longitude: 25.11,
//     },
//     shortName: "Paros Airport",
//     longName: "Paros Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GRC",
//       code: "GR",
//       shortName: "Greece",
//       longName: "Greece",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "PAS",
//       shortName: "Paros",
//       longName: "Paros",
//     },
//   },
//   PVK: {
//     iataCode: "PVK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 38.93,
//       longitude: 20.77,
//     },
//     shortName: "Preveza Airport",
//     longName: "Preveza Aktion National Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GRC",
//       code: "GR",
//       shortName: "Greece",
//       longName: "Greece",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "PVK",
//       shortName: "Preveza",
//       longName: "Preveza",
//     },
//   },
//   SMI: {
//     iataCode: "SMI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 37.69,
//       longitude: 26.91,
//     },
//     shortName: "Samos Airport",
//     longName: "Samos Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GRC",
//       code: "GR",
//       shortName: "Greece",
//       longName: "Greece",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "SMI",
//       shortName: "Samos Island",
//       longName: "Samos Island",
//     },
//   },
//   JTR: {
//     iataCode: "JTR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 36.4,
//       longitude: 25.48,
//     },
//     shortName: "Santorini Airport",
//     longName: "Santorini Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GRC",
//       code: "GR",
//       shortName: "Greece",
//       longName: "Greece",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "JTR",
//       shortName: "Santorini Island",
//       longName: "Santorini Island",
//     },
//   },
//   JSI: {
//     iataCode: "JSI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 39.18,
//       longitude: 23.5,
//     },
//     shortName: "Skiathos Airport",
//     longName: "Skiathos Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GRC",
//       code: "GR",
//       shortName: "Greece",
//       longName: "Greece",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "JSI",
//       shortName: "Skiathos",
//       longName: "Skiathos",
//     },
//   },
//   SKU: {
//     iataCode: "SKU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 38.97,
//       longitude: 24.49,
//     },
//     shortName: "Skiros Airport",
//     longName: "Skiros Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GRC",
//       code: "GR",
//       shortName: "Greece",
//       longName: "Greece",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "SKU",
//       shortName: "Skiros",
//       longName: "Skiros",
//     },
//   },
//   JSY: {
//     iataCode: "JSY",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 37.42,
//       longitude: 24.95,
//     },
//     shortName: "Syros Airport",
//     longName: "Syros Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GRC",
//       code: "GR",
//       shortName: "Greece",
//       longName: "Greece",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "JSY",
//       shortName: "Syros Island",
//       longName: "Syros Island",
//     },
//   },
//   ZTH: {
//     iataCode: "ZTH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 37.75,
//       longitude: 20.88,
//     },
//     shortName: "Zakynthos Airport",
//     longName: "Zakynthos Dionysios Solomos Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GRC",
//       code: "GR",
//       shortName: "Greece",
//       longName: "Greece",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "ZTH",
//       shortName: "Zakynthos Island",
//       longName: "Zakynthos Island",
//     },
//   },
//   QGY: {
//     iataCode: "QGY",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 47.62,
//       longitude: 17.81,
//     },
//     shortName: "Győr Railway Station",
//     longName: "Győr Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "HUN",
//       code: "HU",
//       shortName: "Hungary",
//       longName: "Hungary",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "QGY",
//       shortName: "Győr",
//       longName: "Győr",
//     },
//   },
//   BUD: {
//     iataCode: "BUD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 47.44,
//       longitude: 19.26,
//     },
//     shortName: "Budapest",
//     longName: "Ferenc Liszt International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "HUN",
//       code: "HU",
//       shortName: "Hungary",
//       longName: "Hungary",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "BUD",
//       shortName: "Budapest",
//       longName: "Budapest",
//     },
//   },
//   KEF: {
//     iataCode: "KEF",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 63.99,
//       longitude: -22.61,
//     },
//     shortName: "Reykjavík Airport",
//     longName: "Reykjavík-Keflavík Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ISL",
//       code: "IS",
//       shortName: "Iceland",
//       longName: "Iceland",
//     },
//     city: {
//       code: "REK",
//       shortName: "Reykjavik",
//       longName: "Reykjavik",
//     },
//   },
//   ORK: {
//     iataCode: "ORK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 51.84,
//       longitude: -8.49,
//     },
//     shortName: "Cork",
//     longName: "Cork Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "IRL",
//       code: "IE",
//       shortName: "Ireland",
//       longName: "Ireland",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "ORK",
//       shortName: "Cork",
//       longName: "Cork",
//     },
//   },
//   CFN: {
//     iataCode: "CFN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 55.04,
//       longitude: -8.34,
//     },
//     shortName: "Donegal Airport",
//     longName: "Donegal Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "IRL",
//       code: "IE",
//       shortName: "Ireland",
//       longName: "Ireland",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "CFN",
//       shortName: "Donegal",
//       longName: "Donegal",
//     },
//   },
//   DUB: {
//     iataCode: "DUB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 53.42,
//       longitude: -6.27,
//     },
//     shortName: "Dublin",
//     longName: "Dublin Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "IRL",
//       code: "IE",
//       shortName: "Ireland",
//       longName: "Ireland",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "DUB",
//       shortName: "Dublin",
//       longName: "Dublin",
//     },
//   },
//   IOM: {
//     iataCode: "IOM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 54.08,
//       longitude: -4.62,
//     },
//     shortName: "Isle of Man",
//     longName: "Isle of Man Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "IMN",
//       code: "IM",
//       shortName: "Isle of Man",
//       longName: "Isle of Man",
//     },
//     city: {
//       code: "IOM",
//       shortName: "Isle of Man",
//       longName: "Isle of Man",
//     },
//   },
//   PSR: {
//     iataCode: "PSR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 42.44,
//       longitude: 14.19,
//     },
//     shortName: "Pescara",
//     longName: "Pescara Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "PSR",
//       shortName: "Pescara",
//       longName: "Pescara",
//     },
//   },
//   BDS: {
//     iataCode: "BDS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 40.66,
//       longitude: 17.95,
//     },
//     shortName: "Brindisi",
//     longName: "Brindisi Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "BDS",
//       shortName: "Brindisi",
//       longName: "Brindisi",
//     },
//   },
//   BQD: {
//     iataCode: "BQD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 40.66,
//       longitude: 17.95,
//     },
//     shortName: "Brindisi Rail Station",
//     longName: "Brindisi Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "BDS",
//       shortName: "Brindisi",
//       longName: "Brindisi",
//     },
//   },
//   FOI: {
//     iataCode: "FOI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 15.53,
//       longitude: 41.43,
//     },
//     shortName: "Foggia Rail Station",
//     longName: "Foggia Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "FOG",
//       shortName: "Foggia",
//       longName: "Foggia",
//     },
//   },
//   LCZ: {
//     iataCode: "LCZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 40.36,
//       longitude: 18.29,
//     },
//     shortName: "Lecce Rail Station",
//     longName: "Lecce Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "LCZ",
//       shortName: "Lecce",
//       longName: "Lecce",
//     },
//   },
//   LTZ: {
//     iataCode: "LTZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 38.91,
//       longitude: 16.24,
//     },
//     shortName: "Lamezia Terme Centrale Rail Station",
//     longName: "Lamezia Terme Centrale Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "SUF",
//       shortName: "Lamezia Terme",
//       longName: "Lamezia Terme",
//     },
//   },
//   SUF: {
//     iataCode: "SUF",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 38.91,
//       longitude: 16.24,
//     },
//     shortName: "Lamezia Terme",
//     longName: "Lamezia Terme Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "SUF",
//       shortName: "Lamezia Terme",
//       longName: "Lamezia Terme",
//     },
//   },
//   RCC: {
//     iataCode: "RCC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 38.07,
//       longitude: 15.65,
//     },
//     shortName: "Reggio Di Calabria Centrale Rail Station",
//     longName: "Reggio Di Calabria Centrale Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "REG",
//       shortName: "Reggio Calabria",
//       longName: "Reggio Calabria",
//     },
//   },
//   REG: {
//     iataCode: "REG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 38.07,
//       longitude: 15.65,
//     },
//     shortName: "Reggio Calabria",
//     longName: "Reggio Calabria Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "REG",
//       shortName: "Reggio Calabria",
//       longName: "Reggio Calabria",
//     },
//   },
//   CTJ: {
//     iataCode: "CTJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 41.06,
//       longitude: 14.08,
//     },
//     shortName: "Caserta Rail Station",
//     longName: "Caserta Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "CTJ",
//       shortName: "Caserta",
//       longName: "Caserta",
//     },
//   },
//   INP: {
//     iataCode: "INP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 40.89,
//       longitude: 14.29,
//     },
//     shortName: "Naples Napoli Centrale Rail Station",
//     longName: "Naples Napoli Centrale Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "NAP",
//       shortName: "Naples",
//       longName: "Naples",
//     },
//   },
//   NAP: {
//     iataCode: "NAP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 40.88,
//       longitude: 14.29,
//     },
//     shortName: "Naples",
//     longName: "Naples Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "NAP",
//       shortName: "Naples",
//       longName: "Naples",
//     },
//   },
//   ISR: {
//     iataCode: "ISR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 40.62,
//       longitude: 14.91,
//     },
//     shortName: "Salerno Rail Station",
//     longName: "Salerno Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "QSR",
//       shortName: "Salerno",
//       longName: "Salerno",
//     },
//   },
//   BLQ: {
//     iataCode: "BLQ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 44.53,
//       longitude: 11.3,
//     },
//     shortName: "Bologna",
//     longName: "Bologna Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "BLQ",
//       shortName: "Bologna",
//       longName: "Bologna",
//     },
//   },
//   IBT: {
//     iataCode: "IBT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 44.54,
//       longitude: 11.29,
//     },
//     shortName: "Bologna Centrale Rail Station",
//     longName: "Bologna Centrale Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "BLQ",
//       shortName: "Bologna",
//       longName: "Bologna",
//     },
//   },
//   XRL: {
//     iataCode: "XRL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 44.7,
//       longitude: 10.63,
//     },
//     shortName: "Reggio Emilia Rail Station",
//     longName: "Reggio Emilia Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "LREW",
//       shortName: "Reggio Emilia",
//       longName: "Reggio Emilia",
//     },
//   },
//   TRS: {
//     iataCode: "TRS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 45.83,
//       longitude: 13.47,
//     },
//     shortName: "Trieste",
//     longName: "Friuli Venezia Giulia Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "TRS",
//       shortName: "Trieste",
//       longName: "Trieste",
//     },
//   },
//   TXB: {
//     iataCode: "TXB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 44.09,
//       longitude: 10,
//     },
//     shortName: "Trieste Centrale",
//     longName: "Trieste Central Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "TRS",
//       shortName: "Trieste",
//       longName: "Trieste",
//     },
//   },
//   FCO: {
//     iataCode: "FCO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 41.8,
//       longitude: 12.24,
//     },
//     shortName: "Rome",
//     longName: "Fiumicino Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "ROM",
//       shortName: "Rome",
//       longName: "Rome",
//     },
//   },
//   XRJ: {
//     iataCode: "XRJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 41.8,
//       longitude: 12.25,
//     },
//     shortName: "Rome Roma Termini Rail Station",
//     longName: "Rome Roma Termini Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "ROM",
//       shortName: "Rome",
//       longName: "Rome",
//     },
//   },
//   IRT: {
//     iataCode: "IRT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 41.8,
//       longitude: 12.25,
//     },
//     shortName: "Rome Roma Tiburtina Rail Station",
//     longName: "Rome Roma Tiburtina Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "ROM",
//       shortName: "Rome",
//       longName: "Rome",
//     },
//   },
//   ALL: {
//     iataCode: "ALL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 44.05,
//       longitude: 8.13,
//     },
//     shortName: "Albenga",
//     longName: "Villanova d'Albenga International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "ALL",
//       shortName: "Albenga",
//       longName: "Albenga",
//     },
//   },
//   GEP: {
//     iataCode: "GEP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 44.41,
//       longitude: 8.84,
//     },
//     shortName: "Genoa Brignole Rail Station",
//     longName: "Genoa Brignole Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "GOA",
//       shortName: "Genoa",
//       longName: "Genoa",
//     },
//   },
//   GOA: {
//     iataCode: "GOA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 44.41,
//       longitude: 8.84,
//     },
//     shortName: "Genoa",
//     longName: "Genoa Cristoforo Colombo Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "GOA",
//       shortName: "Genoa",
//       longName: "Genoa",
//     },
//   },
//   GPP: {
//     iataCode: "GPP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 44.41,
//       longitude: 8.84,
//     },
//     shortName: "Genoa Piazza Principle Rail Station",
//     longName: "Genoa Piazza Principle Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "GOA",
//       shortName: "Genoa",
//       longName: "Genoa",
//     },
//   },
//   QLP: {
//     iataCode: "QLP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 44.09,
//       longitude: 9.99,
//     },
//     shortName: "La Spezia Centrale",
//     longName: "La Spezia Central Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "QLP",
//       shortName: "La Spezia",
//       longName: "La Spezia",
//     },
//   },
//   BRZ: {
//     iataCode: "BRZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 45.43,
//       longitude: 10.33,
//     },
//     shortName: "Brescia Rail Station",
//     longName: "Brescia Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "BRZ",
//       shortName: "Brescia",
//       longName: "Brescia",
//     },
//   },
//   IMR: {
//     iataCode: "IMR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 45.63,
//       longitude: 8.73,
//     },
//     shortName: "Milan Milano Rogoredo Rail Station",
//     longName: "Milan Milano Rogoredo Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "MIL",
//       shortName: "Milan",
//       longName: "Milan",
//     },
//   },
//   IPR: {
//     iataCode: "IPR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 45.63,
//       longitude: 8.73,
//     },
//     shortName: "Milan Milano Porta Garibaldi Rail Station",
//     longName: "Milan Milano Porta Garibaldi Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "MIL",
//       shortName: "Milan",
//       longName: "Milan",
//     },
//   },
//   MXP: {
//     iataCode: "MXP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 45.63,
//       longitude: 8.72,
//     },
//     shortName: "Milan",
//     longName: "Malpensa Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "MIL",
//       shortName: "Milan",
//       longName: "Milan",
//     },
//   },
//   BGY: {
//     iataCode: "BGY",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 45.67,
//       longitude: 9.7,
//     },
//     shortName: "Milan Bergamo Airport",
//     longName: "Milan Bergamo Orio al Serio Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "MIL",
//       shortName: "Milan",
//       longName: "Milan",
//     },
//   },
//   XIK: {
//     iataCode: "XIK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 45.63,
//       longitude: 8.73,
//     },
//     shortName: "Milan Milano Centrale Rail Station",
//     longName: "Milan Milano Centrale Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "MIL",
//       shortName: "Milan",
//       longName: "Milan",
//     },
//   },
//   AOI: {
//     iataCode: "AOI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.62,
//       longitude: 13.36,
//     },
//     shortName: "Ancona",
//     longName: "Ancona Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "AOI",
//       shortName: "Ancona",
//       longName: "Ancona",
//     },
//   },
//   ITT: {
//     iataCode: "ITT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 45.2,
//       longitude: 7.65,
//     },
//     shortName: "Turin Torino Porta Susa Rail Station",
//     longName: "Turin Torino Porta Susa Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "TRN",
//       shortName: "Turin",
//       longName: "Turin",
//     },
//   },
//   TPY: {
//     iataCode: "TPY",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 45.2,
//       longitude: 7.65,
//     },
//     shortName: "Turin Torino Porta Nuova Rail Station",
//     longName: "Turin Torino Porta Nuova Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "TRN",
//       shortName: "Turin",
//       longName: "Turin",
//     },
//   },
//   TRN: {
//     iataCode: "TRN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 45.2,
//       longitude: 7.65,
//     },
//     shortName: "Turin",
//     longName: "Turin Caselle Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "TRN",
//       shortName: "Turin",
//       longName: "Turin",
//     },
//   },
//   BAU: {
//     iataCode: "BAU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 41.14,
//       longitude: 16.76,
//     },
//     shortName: "Bari Centrale Rail Station",
//     longName: "Bari Centrale Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "BRI",
//       shortName: "Bari",
//       longName: "Bari",
//     },
//   },
//   BRI: {
//     iataCode: "BRI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 41.14,
//       longitude: 16.77,
//     },
//     shortName: "Bari",
//     longName: "Bari Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "BRI",
//       shortName: "Bari",
//       longName: "Bari",
//     },
//   },
//   AHO: {
//     iataCode: "AHO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 40.63,
//       longitude: 8.29,
//     },
//     shortName: "Alghero",
//     longName: "Alghero Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "AHO",
//       shortName: "Alghero",
//       longName: "Alghero",
//     },
//   },
//   CAG: {
//     iataCode: "CAG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 39.25,
//       longitude: 9.06,
//     },
//     shortName: "Cagliari",
//     longName: "Cagliari-Elmas Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "CAG",
//       shortName: "Cagliari",
//       longName: "Cagliari",
//     },
//   },
//   CTA: {
//     iataCode: "CTA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 37.47,
//       longitude: 15.06,
//     },
//     shortName: "Catania",
//     longName: "Catania-Fontanarossa Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "CTA",
//       shortName: "Catania",
//       longName: "Catania",
//     },
//   },
//   PMO: {
//     iataCode: "PMO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 38.18,
//       longitude: 13.1,
//     },
//     shortName: "Palermo",
//     longName: "Falcone-Borsellino Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "PMO",
//       shortName: "Palermo",
//       longName: "Palermo",
//     },
//   },
//   FIR: {
//     iataCode: "FIR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.81,
//       longitude: 11.21,
//     },
//     shortName: "Florence Firenze Cm Rail Station",
//     longName: "Florence Firenze Cm Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "FLR",
//       shortName: "Florence",
//       longName: "Florence",
//     },
//   },
//   FLR: {
//     iataCode: "FLR",
//     showAsOrigin: true,
//     sellingPOS: "BLQ",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.81,
//       longitude: 11.2,
//     },
//     shortName: "Florence",
//     longName: "Florence Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "FLR",
//       shortName: "Florence",
//       longName: "Florence",
//     },
//   },
//   ZMS: {
//     iataCode: "ZMS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.81,
//       longitude: 11.21,
//     },
//     shortName: "Florence Firenze S. M. Novella Rail Station",
//     longName: "Florence Firenze S. M. Novella Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "FLR",
//       shortName: "Florence",
//       longName: "Florence",
//     },
//   },
//   PCE: {
//     iataCode: "PCE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.68,
//       longitude: 10.39,
//     },
//     shortName: "Pisa Centrale",
//     longName: "Pisa Central Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "PSA",
//       shortName: "Pisa",
//       longName: "Pisa",
//     },
//   },
//   PSA: {
//     iataCode: "PSA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.68,
//       longitude: 10.4,
//     },
//     shortName: "Pisa Airport",
//     longName: "Pisa Galileo Galilei Airport International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "PSA",
//       shortName: "Pisa",
//       longName: "Pisa",
//     },
//   },
//   BZQ: {
//     iataCode: "BZQ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 46.46,
//       longitude: 11.33,
//     },
//     shortName: "Bolzano Bozen Rail Station",
//     longName: "Bolzano Bozen Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "BZO",
//       shortName: "Bolzano",
//       longName: "Bolzano",
//     },
//   },
//   QPA: {
//     iataCode: "QPA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 45.4,
//       longitude: 11.85,
//     },
//     shortName: "Padova Rail Station",
//     longName: "Padova Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "QPA",
//       shortName: "Padova",
//       longName: "Padova",
//     },
//   },
//   VCE: {
//     iataCode: "VCE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 45.51,
//       longitude: 12.35,
//     },
//     shortName: "Venice",
//     longName: "Marco Polo Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "VCE",
//       shortName: "Venice",
//       longName: "Venice",
//     },
//   },
//   XVQ: {
//     iataCode: "XVQ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 45.51,
//       longitude: 12.35,
//     },
//     shortName: "Venice Venezia S. Lucia Rail Station",
//     longName: "Venice Venezia S. Lucia Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "VCE",
//       shortName: "Venice",
//       longName: "Venice",
//     },
//   },
//   XVY: {
//     iataCode: "XVY",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 45.51,
//       longitude: 12.35,
//     },
//     shortName: "Venice Venezia Mestre Rail Station",
//     longName: "Venice Venezia Mestre Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "VCE",
//       shortName: "Venice",
//       longName: "Venice",
//     },
//   },
//   VRN: {
//     iataCode: "VRN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 45.4,
//       longitude: 10.89,
//     },
//     shortName: "Verona Airport",
//     longName: "Verona Villafranca Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "VRN",
//       shortName: "Verona",
//       longName: "Verona",
//     },
//   },
//   XIX: {
//     iataCode: "XIX",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 45.42,
//       longitude: 11.03,
//     },
//     shortName: "Verona Rail Station",
//     longName: "Verona Porta Nuova Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "VRN",
//       shortName: "Verona",
//       longName: "Verona",
//     },
//   },
//   VNZ: {
//     iataCode: "VNZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 45.57,
//       longitude: 11.53,
//     },
//     shortName: "Vicenza Rail Station",
//     longName: "Vicenza Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "VIC",
//       shortName: "Vicenza",
//       longName: "Vicenza",
//     },
//   },
//   OLB: {
//     iataCode: "OLB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 40.9,
//       longitude: 9.52,
//     },
//     shortName: "Olbia Airport",
//     longName: "Olbia Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "OLB",
//       shortName: "Olbia",
//       longName: "Olbia",
//     },
//   },
//   PNL: {
//     iataCode: "PNL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 36.82,
//       longitude: 11.97,
//     },
//     shortName: "Pantelleria Airport",
//     longName: "Pantelleria Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ITA",
//       code: "IT",
//       shortName: "Italy",
//       longName: "Italy",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "PNL",
//       shortName: "Pantelleria",
//       longName: "Pantelleria",
//     },
//   },
//   RIX: {
//     iataCode: "RIX",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 56.92,
//       longitude: 23.97,
//     },
//     shortName: "Riga",
//     longName: "Riga Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "LVA",
//       code: "LV",
//       shortName: "Latvia",
//       longName: "Latvia",
//     },
//     city: {
//       code: "RIX",
//       shortName: "Riga",
//       longName: "Riga",
//     },
//   },
//   VNO: {
//     iataCode: "VNO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 54.63,
//       longitude: 25.29,
//     },
//     shortName: "Vilnius Airport",
//     longName: "Vilnius International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "LTU",
//       code: "LT",
//       shortName: "Lithuania",
//       longName: "Lithuania",
//     },
//     city: {
//       code: "VNO",
//       shortName: "Vilnius",
//       longName: "Vilnius",
//     },
//   },
//   PLQ: {
//     iataCode: "PLQ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 55.97,
//       longitude: 21.09,
//     },
//     shortName: "Palanga Airport",
//     longName: "Palanga International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "LTU",
//       code: "LT",
//       shortName: "Lithuania",
//       longName: "Lithuania",
//     },
//     city: {
//       code: "PLQ",
//       shortName: "Palanga",
//       longName: "Palanga",
//     },
//   },
//   LUX: {
//     iataCode: "LUX",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 49.62,
//       longitude: 6.2,
//     },
//     shortName: "Luxembourg",
//     longName: "Findel Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "LUX",
//       code: "LU",
//       shortName: "Luxembourg",
//       longName: "Luxembourg",
//     },
//     city: {
//       code: "LUX",
//       shortName: "Luxembourg",
//       longName: "Luxembourg",
//     },
//   },
//   SKP: {
//     iataCode: "SKP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 41.96,
//       longitude: 21.62,
//     },
//     shortName: "Skopje",
//     longName: "Skopje Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "MKD",
//       code: "MK",
//       shortName: "Macedonia, Former Yugoslav Republic of",
//       longName: "Macedonia, Former Yugoslav Republic of",
//     },
//     city: {
//       code: "SKP",
//       shortName: "Skopje",
//       longName: "Skopje",
//     },
//   },
//   MLA: {
//     iataCode: "MLA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 35.86,
//       longitude: 14.48,
//     },
//     shortName: "Malta",
//     longName: "Malta International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "MLT",
//       code: "MT",
//       shortName: "Malta",
//       longName: "Malta",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "MLA",
//       shortName: "Malta",
//       longName: "Malta",
//     },
//   },
//   RMO: {
//     iataCode: "RMO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 46.93,
//       longitude: 28.93,
//     },
//     shortName: "Chisinau Airport",
//     longName: "Chisinau International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "MDA",
//       code: "MD",
//       shortName: "Moldova",
//       longName: "Moldova",
//     },
//     city: {
//       code: "RMO",
//       shortName: "Chisinau",
//       longName: "Chisinau",
//     },
//   },
//   MCM: {
//     iataCode: "MCM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.73,
//       longitude: 7.42,
//     },
//     shortName: "Monte Carlo Heliport",
//     longName: "Monte Carlo Heliport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "MCO",
//       code: "MC",
//       shortName: "Monaco",
//       longName: "Monaco",
//     },
//     city: {
//       code: "MCM",
//       shortName: "Monaco",
//       longName: "Monaco",
//     },
//   },
//   TGD: {
//     iataCode: "TGD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 42.36,
//       longitude: 19.25,
//     },
//     shortName: "Podgorica",
//     longName: "Podgorica Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "MNE",
//       code: "ME",
//       shortName: "Montenegro",
//       longName: "Montenegro",
//     },
//     city: {
//       code: "TGD",
//       shortName: "Podgorica",
//       longName: "Podgorica",
//     },
//   },
//   TIV: {
//     iataCode: "TIV",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 42.4,
//       longitude: 18.72,
//     },
//     shortName: "Tivat Airport",
//     longName: "Tivat Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "MNE",
//       code: "ME",
//       shortName: "Montenegro",
//       longName: "Montenegro",
//     },
//     city: {
//       code: "TIV",
//       shortName: "Tivat",
//       longName: "Tivat",
//     },
//   },
//   EIN: {
//     iataCode: "EIN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 51.45,
//       longitude: 5.37,
//     },
//     shortName: "Eindhoven Airport",
//     longName: "Eindhoven Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "NLD",
//       code: "NL",
//       shortName: "Netherlands",
//       longName: "Netherlands",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "EIN",
//       shortName: "Eindhoven",
//       longName: "Eindhoven",
//     },
//   },
//   AMS: {
//     iataCode: "AMS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 52.31,
//       longitude: 4.76,
//     },
//     shortName: "Amsterdam ",
//     longName: "Amsterdam Airport Schiphol",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "NLD",
//       code: "NL",
//       shortName: "Netherlands",
//       longName: "Netherlands",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "AMS",
//       shortName: "Amsterdam",
//       longName: "Amsterdam",
//     },
//   },
//   ALF: {
//     iataCode: "ALF",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 69.98,
//       longitude: 23.37,
//     },
//     shortName: "Alta Airport",
//     longName: "Alta Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "NOR",
//       code: "NO",
//       shortName: "Norway",
//       longName: "Norway",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "ALF",
//       shortName: "Alta",
//       longName: "Alta",
//     },
//   },
//   BOO: {
//     iataCode: "BOO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 67.27,
//       longitude: 14.37,
//     },
//     shortName: "Bodo Airport",
//     longName: "Bodo Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "NOR",
//       code: "NO",
//       shortName: "Norway",
//       longName: "Norway",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "BOO",
//       shortName: "Bodo",
//       longName: "Bodo",
//     },
//   },
//   XGP: {
//     iataCode: "XGP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 63.14,
//       longitude: 14.7,
//     },
//     shortName: "Dombås Rail Station",
//     longName: "Dombås Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "NOR",
//       code: "NO",
//       shortName: "Norway",
//       longName: "Norway",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "XGP",
//       shortName: "Dombås",
//       longName: "Dombås",
//     },
//   },
//   EVE: {
//     iataCode: "EVE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 68.49,
//       longitude: 16.68,
//     },
//     shortName: "Evenes Airport",
//     longName: "Harstad Evenes Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "NOR",
//       code: "NO",
//       shortName: "Norway",
//       longName: "Norway",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "EVE",
//       shortName: "Evenes",
//       longName: "Evenes",
//     },
//   },
//   FRO: {
//     iataCode: "FRO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 61.58,
//       longitude: 5.02,
//     },
//     shortName: "Florø Airport",
//     longName: "Florø Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "NOR",
//       code: "NO",
//       shortName: "Norway",
//       longName: "Norway",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "FRO",
//       shortName: "Florø",
//       longName: "Florø",
//     },
//   },
//   XUG: {
//     iataCode: "XUG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 60.19,
//       longitude: 11.1,
//     },
//     shortName: "Holmestrand Rail Station",
//     longName: "Holmestrand Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "NOR",
//       code: "NO",
//       shortName: "Norway",
//       longName: "Norway",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "XUG",
//       shortName: "Holmestrand",
//       longName: "Holmestrand",
//     },
//   },
//   KKN: {
//     iataCode: "KKN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 69.73,
//       longitude: 29.89,
//     },
//     shortName: "Kirkenes Airport",
//     longName: "Kirkenes Hoybuktmoen Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "NOR",
//       code: "NO",
//       shortName: "Norway",
//       longName: "Norway",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "KKN",
//       shortName: "Kirkenes",
//       longName: "Kirkenes",
//     },
//   },
//   XKK: {
//     iataCode: "XKK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 60.17,
//       longitude: 11.18,
//     },
//     shortName: "Larvik Rail Station",
//     longName: "Larvik Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "NOR",
//       code: "NO",
//       shortName: "Norway",
//       longName: "Norway",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "XKK",
//       shortName: "Larvik",
//       longName: "Larvik",
//     },
//   },
//   XXL: {
//     iataCode: "XXL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 60.18,
//       longitude: 11.4,
//     },
//     shortName: "Lillehammer Rail Station",
//     longName: "Lillehammer Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "NOR",
//       code: "NO",
//       shortName: "Norway",
//       longName: "Norway",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "XXL",
//       shortName: "Lillehammer",
//       longName: "Lillehammer",
//     },
//   },
//   LYR: {
//     iataCode: "LYR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 78.25,
//       longitude: 15.47,
//     },
//     shortName: "Longyearbyen Airport",
//     longName: "Svalbard Longyearbyen Airport ",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "NOR",
//       code: "NO",
//       shortName: "Norway",
//       longName: "Norway",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "LYR",
//       shortName: "Longyearbyen",
//       longName: "Longyearbyen",
//     },
//   },
//   BGO: {
//     iataCode: "BGO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 60.29,
//       longitude: 5.22,
//     },
//     shortName: "Bergen",
//     longName: "Flesland Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "NOR",
//       code: "NO",
//       shortName: "Norway",
//       longName: "Norway",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "BGO",
//       shortName: "Bergen",
//       longName: "Bergen",
//     },
//   },
//   AES: {
//     iataCode: "AES",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 62.56,
//       longitude: 6.12,
//     },
//     shortName: "Aalesund",
//     longName: "Alesund Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "NOR",
//       code: "NO",
//       shortName: "Norway",
//       longName: "Norway",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "AES",
//       shortName: "Aalesund",
//       longName: "Aalesund",
//     },
//   },
//   KSU: {
//     iataCode: "KSU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 63.11,
//       longitude: 7.82,
//     },
//     shortName: "Kristiansund Airport",
//     longName: "Kristiansund Kvernberget Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "NOR",
//       code: "NO",
//       shortName: "Norway",
//       longName: "Norway",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "KSU",
//       shortName: "Kristiansund",
//       longName: "Kristiansund",
//     },
//   },
//   MOL: {
//     iataCode: "MOL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 62.74,
//       longitude: 7.26,
//     },
//     shortName: "Molde Airport",
//     longName: "Molde Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "NOR",
//       code: "NO",
//       shortName: "Norway",
//       longName: "Norway",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "MOL",
//       shortName: "Molde",
//       longName: "Molde",
//     },
//   },
//   OSL: {
//     iataCode: "OSL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 60.2,
//       longitude: 11.08,
//     },
//     shortName: "Oslo",
//     longName: "Gardermoen Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "NOR",
//       code: "NO",
//       shortName: "Norway",
//       longName: "Norway",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "OSL",
//       shortName: "Oslo",
//       longName: "Oslo",
//     },
//   },
//   HAU: {
//     iataCode: "HAU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 59.35,
//       longitude: 5.21,
//     },
//     shortName: "Haugesund  Airport",
//     longName: "Haugesund  Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "NOR",
//       code: "NO",
//       shortName: "Norway",
//       longName: "Norway",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "HAU",
//       shortName: "Haugesund ",
//       longName: "Haugesund ",
//     },
//   },
//   SVG: {
//     iataCode: "SVG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 58.88,
//       longitude: 5.64,
//     },
//     shortName: "Stavanger",
//     longName: "Stavanger Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "NOR",
//       code: "NO",
//       shortName: "Norway",
//       longName: "Norway",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "SVG",
//       shortName: "Stavanger",
//       longName: "Stavanger",
//     },
//   },
//   TRD: {
//     iataCode: "TRD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 63.46,
//       longitude: 10.92,
//     },
//     shortName: "Trondheim",
//     longName: "Trondheim Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "NOR",
//       code: "NO",
//       shortName: "Norway",
//       longName: "Norway",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "TRD",
//       shortName: "Trondheim",
//       longName: "Trondheim",
//     },
//   },
//   KRS: {
//     iataCode: "KRS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 58.2,
//       longitude: 8.09,
//     },
//     shortName: "Kristiansand",
//     longName: "Kristiansand Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "NOR",
//       code: "NO",
//       shortName: "Norway",
//       longName: "Norway",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "KRS",
//       shortName: "Kristiansand",
//       longName: "Kristiansand",
//     },
//   },
//   XOR: {
//     iataCode: "XOR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 60.19,
//       longitude: 11.11,
//     },
//     shortName: "Otta Rail Station",
//     longName: "Otta Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "NOR",
//       code: "NO",
//       shortName: "Norway",
//       longName: "Norway",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "XOR",
//       shortName: "Otta",
//       longName: "Otta",
//     },
//   },
//   XKP: {
//     iataCode: "XKP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 61.19,
//       longitude: 12.4,
//     },
//     shortName: "Porsgrunn Rail Station",
//     longName: "Porsgrunn Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "NOR",
//       code: "NO",
//       shortName: "Norway",
//       longName: "Norway",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "XKP",
//       shortName: "Porsgrunn",
//       longName: "Porsgrunn",
//     },
//   },
//   XUQ: {
//     iataCode: "XUQ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 61.16,
//       longitude: 12.6,
//     },
//     shortName: "Ringebu Rail Station",
//     longName: "Ringebu Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "NOR",
//       code: "NO",
//       shortName: "Norway",
//       longName: "Norway",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "XUQ",
//       shortName: "Ringebu",
//       longName: "Ringebu",
//     },
//   },
//   RRS: {
//     iataCode: "RRS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 62.58,
//       longitude: 11.34,
//     },
//     shortName: "Røros Airport",
//     longName: "Røros Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "NOR",
//       code: "NO",
//       shortName: "Norway",
//       longName: "Norway",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "RRS",
//       shortName: "Røros",
//       longName: "Røros",
//     },
//   },
//   TRF: {
//     iataCode: "TRF",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 59.19,
//       longitude: 10.26,
//     },
//     shortName: "Sandefjord Airport",
//     longName: "Sandefjord Torp Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "NOR",
//       code: "NO",
//       shortName: "Norway",
//       longName: "Norway",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "TRF",
//       shortName: "Sandefjord",
//       longName: "Sandefjord",
//     },
//   },
//   ZYS: {
//     iataCode: "ZYS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 61.19,
//       longitude: 12.1,
//     },
//     shortName: "Sandefjord Rail Station",
//     longName: "Sandefjord Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "NOR",
//       code: "NO",
//       shortName: "Norway",
//       longName: "Norway",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "ZYS",
//       shortName: "Sandefjord",
//       longName: "Sandefjord",
//     },
//   },
//   SKE: {
//     iataCode: "SKE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 64.19,
//       longitude: 14.1,
//     },
//     shortName: "Skien Rail Station",
//     longName: "Skien Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "NOR",
//       code: "NO",
//       shortName: "Norway",
//       longName: "Norway",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "SKE",
//       shortName: "Skien",
//       longName: "Skien",
//     },
//   },
//   SRP: {
//     iataCode: "SRP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 59.79,
//       longitude: 5.34,
//     },
//     shortName: "Stord Airport",
//     longName: "Stord Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "NOR",
//       code: "NO",
//       shortName: "Norway",
//       longName: "Norway",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "SRP",
//       shortName: "Stord",
//       longName: "Stord",
//     },
//   },
//   TOS: {
//     iataCode: "TOS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 69.68,
//       longitude: 18.92,
//     },
//     shortName: "Tromso Airport",
//     longName: "Tromso Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "NOR",
//       code: "NO",
//       shortName: "Norway",
//       longName: "Norway",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "TOS",
//       shortName: "Tromso",
//       longName: "Tromso",
//     },
//   },
//   XKW: {
//     iataCode: "XKW",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 62.2,
//       longitude: 13.1,
//     },
//     shortName: "Tønsberg Rail Station",
//     longName: "Tønsberg Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "NOR",
//       code: "NO",
//       shortName: "Norway",
//       longName: "Norway",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "XKW",
//       shortName: "Tønsberg",
//       longName: "Tønsberg",
//     },
//   },
//   XKZ: {
//     iataCode: "XKZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 61.14,
//       longitude: 12.1,
//     },
//     shortName: "Vinstra Rail Station",
//     longName: "Vinstra Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "NOR",
//       code: "NO",
//       shortName: "Norway",
//       longName: "Norway",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "XKZ",
//       shortName: "Vinstra",
//       longName: "Vinstra",
//     },
//   },
//   OLA: {
//     iataCode: "OLA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 63.7,
//       longitude: 9.6,
//     },
//     shortName: "Ørland Airport",
//     longName: "Ørland Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "NOR",
//       code: "NO",
//       shortName: "Norway",
//       longName: "Norway",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "OLA",
//       shortName: "Ørland",
//       longName: "Ørland",
//     },
//   },
//   IEG: {
//     iataCode: "IEG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 15.8,
//       longitude: 52.14,
//     },
//     shortName: "Zielona Góra Airport",
//     longName: "Zielona Góra-Babimost Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "POL",
//       code: "PL",
//       shortName: "Poland",
//       longName: "Poland",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "IEG",
//       shortName: "Babimost",
//       longName: "Babimost",
//     },
//   },
//   BZG: {
//     iataCode: "BZG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 17.98,
//       longitude: 53.1,
//     },
//     shortName: "Bydgoszcz Airport",
//     longName: "Bydgoszcz Ignacy Jan Paderewski Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "POL",
//       code: "PL",
//       shortName: "Poland",
//       longName: "Poland",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "BZG",
//       shortName: "Bydgoszcz",
//       longName: "Bydgoszcz",
//     },
//   },
//   KTW: {
//     iataCode: "KTW",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 50.47,
//       longitude: 19.08,
//     },
//     shortName: "Katowice Airport",
//     longName: "Katowice International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "POL",
//       code: "PL",
//       shortName: "Poland",
//       longName: "Poland",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "KTW",
//       shortName: "Katowice",
//       longName: "Katowice",
//     },
//   },
//   LUZ: {
//     iataCode: "LUZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 22.71,
//       longitude: 51.24,
//     },
//     shortName: "Lublin Airport",
//     longName: "Lublin Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "POL",
//       code: "PL",
//       shortName: "Poland",
//       longName: "Poland",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "LUZ",
//       shortName: "Lublin",
//       longName: "Lublin",
//     },
//   },
//   POZ: {
//     iataCode: "POZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 52.42,
//       longitude: 16.83,
//     },
//     shortName: "Poznan",
//     longName: "Poznan-lawica Henryk Wieniawski Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "POL",
//       code: "PL",
//       shortName: "Poland",
//       longName: "Poland",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "POZ",
//       shortName: "Poznan",
//       longName: "Poznan",
//     },
//   },
//   KRK: {
//     iataCode: "KRK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 50.08,
//       longitude: 19.78,
//     },
//     shortName: "Krakow",
//     longName: "John Paul II International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "POL",
//       code: "PL",
//       shortName: "Poland",
//       longName: "Poland",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "KRK",
//       shortName: "Krakow",
//       longName: "Krakow",
//     },
//   },
//   WRO: {
//     iataCode: "WRO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 51.1,
//       longitude: 16.89,
//     },
//     shortName: "Wroclaw",
//     longName: "Copernicus Airport Wroclaw",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "POL",
//       code: "PL",
//       shortName: "Poland",
//       longName: "Poland",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "WRO",
//       shortName: "Wroclaw",
//       longName: "Wroclaw",
//     },
//   },
//   WAW: {
//     iataCode: "WAW",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 52.17,
//       longitude: 20.97,
//     },
//     shortName: "Warsaw",
//     longName: "Warsaw Frédéric Chopin Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "POL",
//       code: "PL",
//       shortName: "Poland",
//       longName: "Poland",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "WAW",
//       shortName: "Warsaw",
//       longName: "Warsaw",
//     },
//   },
//   GDN: {
//     iataCode: "GDN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 54.38,
//       longitude: 18.47,
//     },
//     shortName: "Gdansk",
//     longName: "Gdańsk Lech Wałęsa Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "POL",
//       code: "PL",
//       shortName: "Poland",
//       longName: "Poland",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "GDN",
//       shortName: "Gdansk",
//       longName: "Gdansk",
//     },
//   },
//   RZE: {
//     iataCode: "RZE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 22.02,
//       longitude: 50.11,
//     },
//     shortName: "Rzeszów Airport",
//     longName: "Rzeszów-Jasionka Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "POL",
//       code: "PL",
//       shortName: "Poland",
//       longName: "Poland",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "RZE",
//       shortName: "Rzeszów",
//       longName: "Rzeszów",
//     },
//   },
//   SZZ: {
//     iataCode: "SZZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 53.58,
//       longitude: 14.9,
//     },
//     shortName: "Szczecin Airport",
//     longName: "Szczecin–Goleniów Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "POL",
//       code: "PL",
//       shortName: "Poland",
//       longName: "Poland",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "SZZ",
//       shortName: "Szczecin",
//       longName: "Szczecin",
//     },
//   },
//   FAO: {
//     iataCode: "FAO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 37.01,
//       longitude: -7.97,
//     },
//     shortName: "Faro",
//     longName: "Faro Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "PRT",
//       code: "PT",
//       shortName: "Portugal",
//       longName: "Portugal",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "FAO",
//       shortName: "Faro",
//       longName: "Faro",
//     },
//   },
//   LIS: {
//     iataCode: "LIS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 38.77,
//       longitude: -9.13,
//     },
//     shortName: "Lisbon",
//     longName: "Lisbon General Humberto Delgado Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "PRT",
//       code: "PT",
//       shortName: "Portugal",
//       longName: "Portugal",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "LIS",
//       shortName: "Lisbon",
//       longName: "Lisbon",
//     },
//   },
//   FNC: {
//     iataCode: "FNC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 32.69,
//       longitude: -16.78,
//     },
//     shortName: "Funchal",
//     longName: "Madeira Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "PRT",
//       code: "PT",
//       shortName: "Portugal",
//       longName: "Portugal",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "FNC",
//       shortName: "Funchal",
//       longName: "Funchal",
//     },
//   },
//   OPO: {
//     iataCode: "OPO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 41.24,
//       longitude: -8.68,
//     },
//     shortName: "Porto",
//     longName: "Porto Francisco Sá Carneiro Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "PRT",
//       code: "PT",
//       shortName: "Portugal",
//       longName: "Portugal",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "OPO",
//       shortName: "Porto",
//       longName: "Porto",
//     },
//   },
//   PDL: {
//     iataCode: "PDL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 37.74,
//       longitude: -25.7,
//     },
//     shortName: "Ponta Delgada Airport",
//     longName: "Ponta Delgada João Paulo II Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "PRT",
//       code: "PT",
//       shortName: "Portugal",
//       longName: "Portugal",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "PDL",
//       shortName: "Ponta Delgada",
//       longName: "Ponta Delgada",
//     },
//   },
//   TER: {
//     iataCode: "TER",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 38.76,
//       longitude: -27.09,
//     },
//     shortName: "Terceira Airport",
//     longName: "Terceira Lajes Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "PRT",
//       code: "PT",
//       shortName: "Portugal",
//       longName: "Portugal",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "TER",
//       shortName: "Terceira",
//       longName: "Terceira (Azores)",
//     },
//   },
//   PXO: {
//     iataCode: "PXO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 33.07,
//       longitude: -16.35,
//     },
//     shortName: "Vila Baleira Airport",
//     longName: "Vila Baleira Porto Santo Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "PRT",
//       code: "PT",
//       shortName: "Portugal",
//       longName: "Portugal",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "PXO",
//       shortName: "Vila Baleira",
//       longName: "Vila Baleira",
//     },
//   },
//   OTP: {
//     iataCode: "OTP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 44.57,
//       longitude: 26.09,
//     },
//     shortName: "Bucharest",
//     longName: "Henri Coanda International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ROU",
//       code: "RO",
//       shortName: "Romania",
//       longName: "Romania",
//     },
//     city: {
//       code: "BUH",
//       shortName: "Bucharest",
//       longName: "Bucharest",
//     },
//   },
//   CLJ: {
//     iataCode: "CLJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 46.79,
//       longitude: 23.69,
//     },
//     shortName: "Cluj-Napoca Airport",
//     longName: "Cluj-Napoca International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ROU",
//       code: "RO",
//       shortName: "Romania",
//       longName: "Romania",
//     },
//     city: {
//       code: "CLJ",
//       shortName: "Cluj-Napoca",
//       longName: "Cluj-Napoca",
//     },
//   },
//   ABA: {
//     iataCode: "ABA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 53.74,
//       longitude: 91.39,
//     },
//     shortName: "Abakan Airport",
//     longName: "Abakan Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "ABA",
//       shortName: "Abakan",
//       longName: "Abakan",
//     },
//   },
//   KVK: {
//     iataCode: "KVK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 67.46,
//       longitude: 33.59,
//     },
//     shortName: "Kirovsk Airport",
//     longName: "Kirovsk-Apatity Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "KVK",
//       shortName: "Apatity",
//       longName: "Apatity",
//     },
//   },
//   ARH: {
//     iataCode: "ARH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 64.6,
//       longitude: 40.72,
//     },
//     shortName: "Arkhangelsk Airport",
//     longName: "Arkhangelsk Talagi Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "ARH",
//       shortName: "Arkhangelsk",
//       longName: "Arkhangelsk",
//     },
//   },
//   VKV: {
//     iataCode: "VKV",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 64.6,
//       longitude: 40.72,
//     },
//     shortName: "Vaskovo Airport",
//     longName: "Vaskovo Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "ARH",
//       shortName: "Arkhangelsk",
//       longName: "Arkhangelsk",
//     },
//   },
//   BZK: {
//     iataCode: "BZK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 53.21,
//       longitude: 34.18,
//     },
//     shortName: "Bryansk Airport",
//     longName: "Bryansk Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "BZK",
//       shortName: "Bryansk",
//       longName: "Bryansk",
//     },
//   },
//   KZN: {
//     iataCode: "KZN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 55.61,
//       longitude: 49.28,
//     },
//     shortName: "Kazan",
//     longName: "Kazan International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "KZN",
//       shortName: "Kazan",
//       longName: "Kazan (Ka San)",
//     },
//   },
//   LPK: {
//     iataCode: "LPK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 52.7,
//       longitude: 39.54,
//     },
//     shortName: "Lipetsk Airport",
//     longName: "Lipetsk Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "LPK",
//       shortName: "Lipetsk",
//       longName: "Lipetsk",
//     },
//   },
//   MCX: {
//     iataCode: "MCX",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 42.82,
//       longitude: 47.65,
//     },
//     shortName: "Makhachkala Airport",
//     longName: "Makhachkala Uytash Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "MCX",
//       shortName: "Makhachkala",
//       longName: "Makhachkala",
//     },
//   },
//   MJZ: {
//     iataCode: "MJZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 62.53,
//       longitude: 114.04,
//     },
//     shortName: "Mirny Airport",
//     longName: "Mirny Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "MJZ",
//       shortName: "Mirny",
//       longName: "Mirny",
//     },
//   },
//   MMK: {
//     iataCode: "MMK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 68.78,
//       longitude: 32.75,
//     },
//     shortName: "Murmansk Airport",
//     longName: "Murmansk Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "MMK",
//       shortName: "Murmansk",
//       longName: "Murmansk",
//     },
//   },
//   NER: {
//     iataCode: "NER",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 56.91,
//       longitude: 124.91,
//     },
//     shortName: "Neryungri Airport",
//     longName: "Neryungri Chulman Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "NER",
//       shortName: "Neryungri",
//       longName: "Neryungri",
//     },
//   },
//   PEZ: {
//     iataCode: "PEZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 53.11,
//       longitude: 45.02,
//     },
//     shortName: "Penza Airport",
//     longName: "Penza Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "PEZ",
//       shortName: "Penza",
//       longName: "Penza",
//     },
//   },
//   PES: {
//     iataCode: "PES",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 61.89,
//       longitude: 34.15,
//     },
//     shortName: "Petrozavodsk Airport",
//     longName: "Petrozavodsk Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "PES",
//       shortName: "Petrozavodsk",
//       longName: "Petrozavodsk",
//     },
//   },
//   BAX: {
//     iataCode: "BAX",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 53.36,
//       longitude: 83.54,
//     },
//     shortName: "Barnaul",
//     longName: "Barnaul",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "BAX",
//       shortName: "Barnaul",
//       longName: "Barnaul",
//     },
//   },
//   ASF: {
//     iataCode: "ASF",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 46.28,
//       longitude: 48.01,
//     },
//     shortName: "Astrakhan",
//     longName: "Astrakhan",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "ASF",
//       shortName: "Astrakhan",
//       longName: "Astrakhan",
//     },
//   },
//   GRV: {
//     iataCode: "GRV",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.39,
//       longitude: 45.7,
//     },
//     shortName: "Grozny Airport",
//     longName: "Grozny Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "GRV",
//       shortName: "Grozny",
//       longName: "Grozny",
//     },
//   },
//   CEK: {
//     iataCode: "CEK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 55.31,
//       longitude: 61.51,
//     },
//     shortName: "Chelyabinsk",
//     longName: "Chelyabinsk",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "CEK",
//       shortName: "Chelyabinsk",
//       longName: "Chelyabinsk",
//     },
//   },
//   MQF: {
//     iataCode: "MQF",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 53.39,
//       longitude: 58.76,
//     },
//     shortName: "Magnitogorsk Airport",
//     longName: "Magnitogorsk International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "MQF",
//       shortName: "Magnitogorsk",
//       longName: "Magnitogorsk",
//     },
//   },
//   HTA: {
//     iataCode: "HTA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 52.03,
//       longitude: 113.31,
//     },
//     shortName: "Chita Airport",
//     longName: "Chita Kadala International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "HTA",
//       shortName: "Chita",
//       longName: "Chita",
//     },
//   },
//   RGK: {
//     iataCode: "RGK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 51.97,
//       longitude: 85.83,
//     },
//     shortName: "Gorno-Altaysk Airport",
//     longName: "Gorno-Altaysk Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "RGK",
//       shortName: "Gorno-Altaysk",
//       longName: "Gorno-Altaysk",
//     },
//   },
//   BTK: {
//     iataCode: "BTK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 56.37,
//       longitude: 101.7,
//     },
//     shortName: "Bratsk",
//     longName: "Bratsk",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "BTK",
//       shortName: "Bratsk",
//       longName: "Bratsk",
//     },
//   },
//   IKT: {
//     iataCode: "IKT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 52.27,
//       longitude: 104.4,
//     },
//     shortName: "Irkutsk",
//     longName: "Irkutsk",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "IKT",
//       shortName: "Irkutsk",
//       longName: "Irkutsk",
//     },
//   },
//   KGD: {
//     iataCode: "KGD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 54.89,
//       longitude: 20.6,
//     },
//     shortName: "Kaliningrad",
//     longName: "Kaliningrad",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "KGD",
//       shortName: "Kaliningrad",
//       longName: "Kaliningrad",
//     },
//   },
//   KEJ: {
//     iataCode: "KEJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 55.27,
//       longitude: 86.11,
//     },
//     shortName: "Kemerovo",
//     longName: "Kemerovo",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "KEJ",
//       shortName: "Kemerovo",
//       longName: "Kemerovo",
//     },
//   },
//   NOZ: {
//     iataCode: "NOZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 53.81,
//       longitude: 86.88,
//     },
//     shortName: "Novokuznetsk",
//     longName: "Novokuznetsk",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "NOZ",
//       shortName: "Novokuznetsk",
//       longName: "Novokuznetsk",
//     },
//   },
//   KHV: {
//     iataCode: "KHV",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 48.53,
//       longitude: 135.19,
//     },
//     shortName: "Khabarovsk",
//     longName: "Khabarovsk Novy Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "KHV",
//       shortName: "Khabarovsk",
//       longName: "Khabarovsk",
//     },
//   },
//   NJC: {
//     iataCode: "NJC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 60.95,
//       longitude: 76.48,
//     },
//     shortName: "Nizhnevartovsk",
//     longName: "Nizhnevartovsk",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "NJC",
//       shortName: "Nizhnevartovsk",
//       longName: "Nizhnevartovsk",
//     },
//   },
//   SGC: {
//     iataCode: "SGC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 61.34,
//       longitude: 73.4,
//     },
//     shortName: "Surgut",
//     longName: "Surgut",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "SGC",
//       shortName: "Surgut",
//       longName: "Surgut",
//     },
//   },
//   AER: {
//     iataCode: "AER",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.45,
//       longitude: 39.95,
//     },
//     shortName: "Adler-Sochi",
//     longName: "Adler-Sochi",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "AER",
//       shortName: "Adler-Sochi",
//       longName: "Adler-Sochi",
//     },
//   },
//   AAQ: {
//     iataCode: "AAQ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 45,
//       longitude: 37.35,
//     },
//     shortName: "Anapa",
//     longName: "Anapa",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "AAQ",
//       shortName: "Anapa",
//       longName: "Anapa",
//     },
//   },
//   GDZ: {
//     iataCode: "GDZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 44.58,
//       longitude: 38.01,
//     },
//     shortName: "Gelendzhik Airport",
//     longName: "Gelendzhik Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "GDZ",
//       shortName: "Gelendzhik",
//       longName: "Gelendzhik",
//     },
//   },
//   KRR: {
//     iataCode: "KRR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 45.04,
//       longitude: 39.17,
//     },
//     shortName: "Krasnodar",
//     longName: "Krasnodar",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "KRR",
//       shortName: "Krasnodar",
//       longName: "Krasnodar",
//     },
//   },
//   KJA: {
//     iataCode: "KJA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 56.17,
//       longitude: 92.49,
//     },
//     shortName: "Krasnoyarsk Yemelyanovo",
//     longName: "Krasnoyarsk Yemelyanovo",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "KJA",
//       shortName: "Krasnoyarsk Yemelyanovo",
//       longName: "Krasnoyarsk Yemelyanovo",
//     },
//   },
//   NSK: {
//     iataCode: "NSK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 69.31,
//       longitude: 87.33,
//     },
//     shortName: "Norilsk",
//     longName: "Norilsk",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "NSK",
//       shortName: "Norilsk",
//       longName: "Norilsk",
//     },
//   },
//   DME: {
//     iataCode: "DME",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 55.41,
//       longitude: 37.91,
//     },
//     shortName: "Moscow",
//     longName: "Domodedovo Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "MOW",
//       shortName: "Moscow",
//       longName: "Moscow",
//     },
//   },
//   MOW: {
//     iataCode: "MOW",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 55.97,
//       longitude: 37.41,
//     },
//     shortName: "Moscow",
//     longName: "Moscow all airports",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "MOW",
//       shortName: "Moscow",
//       longName: "Moscow",
//     },
//   },
//   SVO: {
//     iataCode: "SVO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 55.97,
//       longitude: 37.42,
//     },
//     shortName: "Moscow Sheremetyevo Airport",
//     longName: "Sheremetyevo International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "MOW",
//       shortName: "Moscow",
//       longName: "Moscow",
//     },
//   },
//   VKO: {
//     iataCode: "VKO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 55.59,
//       longitude: 37.26,
//     },
//     shortName: "Moscow Vnukovo Airport",
//     longName: "Vnukovo International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "MOW",
//       shortName: "Moscow",
//       longName: "Moscow",
//     },
//   },
//   GOJ: {
//     iataCode: "GOJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 56.23,
//       longitude: 43.78,
//     },
//     shortName: "Nizhniy Novgorod",
//     longName: "Nizhniy Novgorod",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "GOJ",
//       shortName: "Nizhniy Novgorod",
//       longName: "Nizhniy Novgorod",
//     },
//   },
//   NBC: {
//     iataCode: "NBC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 55.56,
//       longitude: 52.09,
//     },
//     shortName: "Nizhnekamsk Begishevo Airport",
//     longName: "Nizhnekamsk Begishevo Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "NBC",
//       shortName: "Nizhnekamsk",
//       longName: "Nizhnekamsk",
//     },
//   },
//   OVB: {
//     iataCode: "OVB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 55.03,
//       longitude: 82.6,
//     },
//     shortName: "Novosibirsk",
//     longName: "Novosibirsk Tolmachevo Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "OVB",
//       shortName: "Novosibirsk",
//       longName: "Novosibirsk",
//     },
//   },
//   OMS: {
//     iataCode: "OMS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 54.97,
//       longitude: 73.31,
//     },
//     shortName: "Omsk",
//     longName: "Omsk",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "OMS",
//       shortName: "Omsk",
//       longName: "Omsk",
//     },
//   },
//   PEE: {
//     iataCode: "PEE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 57.91,
//       longitude: 56.02,
//     },
//     shortName: "Perm Oblast",
//     longName: "Perm Oblast",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "PEE",
//       shortName: "Perm Oblast",
//       longName: "Perm Oblast",
//     },
//   },
//   VVO: {
//     iataCode: "VVO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.4,
//       longitude: 132.15,
//     },
//     shortName: "Vladivostok",
//     longName: "Vladivostok International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "VVO",
//       shortName: "Vladivostok",
//       longName: "Vladivostok",
//     },
//   },
//   UFA: {
//     iataCode: "UFA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 54.56,
//       longitude: 55.88,
//     },
//     shortName: "Ufa",
//     longName: "Ufa",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "UFA",
//       shortName: "Ufa",
//       longName: "Ufa",
//     },
//   },
//   UUD: {
//     iataCode: "UUD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 51.81,
//       longitude: 107.44,
//     },
//     shortName: "Ulan-Ude",
//     longName: "Ulan-Ude",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "UUD",
//       shortName: "Ulan-Ude",
//       longName: "Ulan-Ude",
//     },
//   },
//   ROV: {
//     iataCode: "ROV",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 47.26,
//       longitude: 39.82,
//     },
//     shortName: "Rostov",
//     longName: "Rostov",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "ROV",
//       shortName: "Rostov",
//       longName: "Rostov",
//     },
//   },
//   LED: {
//     iataCode: "LED",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 59.8,
//       longitude: 30.26,
//     },
//     shortName: "St. Petersburg",
//     alternateNames: ["Saint Petersburg"],
//     longName: "Pulkovo International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "LED",
//       shortName: "St. Petersburg",
//       longName: "St. Petersburg",
//     },
//   },
//   YKS: {
//     iataCode: "YKS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 62.09,
//       longitude: 129.77,
//     },
//     shortName: "Yakutsk",
//     longName: "Yakutsk",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "YKS",
//       shortName: "Yakutsk",
//       longName: "Yakutsk",
//     },
//   },
//   KUF: {
//     iataCode: "KUF",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 53.5,
//       longitude: 50.16,
//     },
//     shortName: "Samara",
//     longName: "Samara",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "KUF",
//       shortName: "Samara",
//       longName: "Samara",
//     },
//   },
//   GSV: {
//     iataCode: "GSV",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 51.56,
//       longitude: 46.05,
//     },
//     shortName: "Saratov Airport",
//     longName: "Saratov Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "GSV",
//       shortName: "Saratov",
//       longName: "Saratov",
//     },
//   },
//   OGZ: {
//     iataCode: "OGZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.21,
//       longitude: 44.61,
//     },
//     shortName: "Vladikavkaz",
//     longName: "Vladikavkaz",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "OGZ",
//       shortName: "Vladikavkaz",
//       longName: "Vladikavkaz",
//     },
//   },
//   STW: {
//     iataCode: "STW",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 45.11,
//       longitude: 42.11,
//     },
//     shortName: "Stavropol Airport",
//     longName: "Stavropol Shpakovskoye Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "STW",
//       shortName: "Stavropol",
//       longName: "Stavropol",
//     },
//   },
//   MRV: {
//     iataCode: "MRV",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 44.23,
//       longitude: 43.08,
//     },
//     shortName: "Mineralnyye Vody",
//     longName: "Mineralnyye Vody Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "MRV",
//       shortName: "Mineralnyye Vody",
//       longName: "Mineralnyye Vody",
//     },
//   },
//   SVX: {
//     iataCode: "SVX",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 56.74,
//       longitude: 60.81,
//     },
//     shortName: "Ekaterinburg",
//     longName: "Koltsovo International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "SVX",
//       shortName: "Ekaterinburg",
//       longName: "Ekaterinburg",
//     },
//   },
//   TOF: {
//     iataCode: "TOF",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 56.38,
//       longitude: 85.21,
//     },
//     shortName: "Tomsk",
//     longName: "Tomsk",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "TOF",
//       shortName: "Tomsk",
//       longName: "Tomsk",
//     },
//   },
//   TJM: {
//     iataCode: "TJM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 57.17,
//       longitude: 65.32,
//     },
//     shortName: "Tyumen",
//     longName: "Tyumen",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "TJM",
//       shortName: "Tyumen",
//       longName: "Tyumen",
//     },
//   },
//   ULY: {
//     iataCode: "ULY",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 54.4,
//       longitude: 48.8,
//     },
//     shortName: "Ulyanovsk Airport",
//     longName: "Ulyanovsk Vostochny Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "ULY",
//       shortName: "Ulyanovsk",
//       longName: "Ulyanovsk",
//     },
//   },
//   VOG: {
//     iataCode: "VOG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 48.78,
//       longitude: 44.35,
//     },
//     shortName: "Volgograd",
//     longName: "Volgograd",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "VOG",
//       shortName: "Volgograd",
//       longName: "Volgograd",
//     },
//   },
//   VOZ: {
//     iataCode: "VOZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 51.81,
//       longitude: 39.23,
//     },
//     shortName: "Voronezh Airport",
//     longName: "Voronezh-Chertovitskoye International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "VOZ",
//       shortName: "Voronezh",
//       longName: "Voronezh",
//     },
//   },
//   NYM: {
//     iataCode: "NYM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 65.48,
//       longitude: 72.7,
//     },
//     shortName: "Nadym",
//     longName: "Nadym",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "NYM",
//       shortName: "Nadym",
//       longName: "Nadym",
//     },
//   },
//   NUX: {
//     iataCode: "NUX",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 66.07,
//       longitude: 76.52,
//     },
//     shortName: "Novy Urengoy",
//     longName: "Novy Urengoy",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "NUX",
//       shortName: "Novy Urengoy",
//       longName: "Novy Urengoy",
//     },
//   },
//   SLY: {
//     iataCode: "SLY",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 66.59,
//       longitude: 66.61,
//     },
//     shortName: "Salekhard Airport",
//     longName: "Salekhard Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "SLY",
//       shortName: "Salekhard",
//       longName: "Salekhard",
//     },
//   },
//   SKX: {
//     iataCode: "SKX",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 54.13,
//       longitude: 45.21,
//     },
//     shortName: "Saransk Airport",
//     longName: "Saransk Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "SKX",
//       shortName: "Saransk",
//       longName: "Saransk",
//     },
//   },
//   SCW: {
//     iataCode: "SCW",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 61.65,
//       longitude: 50.85,
//     },
//     shortName: "Syktyvkar Airport",
//     longName: "Syktyvkar Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "RUS",
//       code: "RU",
//       shortName: "Russia",
//       longName: "Russia",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "SCW",
//       shortName: "Syktyvkar",
//       longName: "Syktyvkar",
//     },
//   },
//   BEG: {
//     iataCode: "BEG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 44.82,
//       longitude: 20.31,
//     },
//     shortName: "Belgrade",
//     longName: "Nikola Tesla Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "SRB",
//       code: "RS",
//       shortName: "Serbia",
//       longName: "Serbia",
//     },
//     city: {
//       code: "BEG",
//       shortName: "Belgrade",
//       longName: "Belgrade",
//     },
//   },
//   KSC: {
//     iataCode: "KSC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 21.24,
//       longitude: 48.66,
//     },
//     shortName: "Košice Airport",
//     longName: "Košice Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "SVK",
//       code: "SK",
//       shortName: "Slovakia",
//       longName: "Slovakia",
//     },
//     city: {
//       code: "KSC ",
//       shortName: "Košice",
//       longName: "Košice",
//     },
//   },
//   BTS: {
//     iataCode: "BTS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 48.17,
//       longitude: 17.21,
//     },
//     shortName: "Bratislava",
//     longName: "Bratislava Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "SVK",
//       code: "SK",
//       shortName: "Slovakia",
//       longName: "Slovakia",
//     },
//     city: {
//       code: "BTS",
//       shortName: "Bratislava",
//       longName: "Bratislava",
//     },
//   },
//   LJU: {
//     iataCode: "LJU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 46.22,
//       longitude: 14.46,
//     },
//     shortName: "Ljubljana",
//     longName: "Ljubljana Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "SVN",
//       code: "SI",
//       shortName: "Slovenia",
//       longName: "Slovenia",
//     },
//     city: {
//       code: "LJU",
//       shortName: "Ljubljana",
//       longName: "Ljubljana",
//     },
//   },
//   EEM: {
//     iataCode: "EEM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 38.95,
//       longitude: -1.86,
//     },
//     shortName: "Alabacete Rail Station",
//     longName: "Alabacete Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "ABC",
//       shortName: "Alabacete",
//       longName: "Alabacete",
//     },
//   },
//   UGR: {
//     iataCode: "UGR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 42.36,
//       longitude: -3.62,
//     },
//     shortName: "Burgos Railway Station",
//     longName: "Burgos Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "RGS",
//       shortName: "Burgos",
//       longName: "Burgos",
//     },
//   },
//   CDZ: {
//     iataCode: "CDZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 40.42,
//       longitude: 2.45,
//     },
//     shortName: "Cadiz Railway Station",
//     longName: "Cadiz Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "CDZ",
//       shortName: "Cadiz",
//       longName: "Cadiz",
//     },
//   },
//   CPJ: {
//     iataCode: "CPJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 40,
//       longitude: 0.03,
//     },
//     shortName: "Castellon Railway Station",
//     longName: "Castellon Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "CDT",
//       shortName: "Castellon De La Plana",
//       longName: "Castellon De La Plana",
//     },
//   },
//   CEJ: {
//     iataCode: "CEJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 41.76,
//       longitude: -2.77,
//     },
//     shortName: "Cuenca Railway Station",
//     longName: "Cuenca Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "CEJ",
//       shortName: "Cuenca",
//       longName: "Cuenca",
//     },
//   },
//   XJI: {
//     iataCode: "XJI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 40.43,
//       longitude: -3.45,
//     },
//     shortName: "Cuidad Real Railway Station",
//     longName: "Cuidad Real Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "CJI",
//       shortName: "Cuidad Real",
//       longName: "Cuidad Real",
//     },
//   },
//   XOJ: {
//     iataCode: "XOJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 37.84,
//       longitude: -4.85,
//     },
//     shortName: "Córdoba Rail Station",
//     longName: "Córdoba Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "ODB",
//       shortName: "Córdoba",
//       longName: "Córdoba",
//     },
//   },
//   AMR: {
//     iataCode: "AMR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 36.84,
//       longitude: -2.37,
//     },
//     shortName: "Almeria Railway Station",
//     longName: "Almeria Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "LEI",
//       shortName: "Almeria",
//       longName: "Almeria",
//     },
//   },
//   LEI: {
//     iataCode: "LEI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 36.84,
//       longitude: -2.37,
//     },
//     shortName: "Almeria",
//     longName: "Almería Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "LEI",
//       shortName: "Almeria",
//       longName: "Almeria",
//     },
//   },
//   GRX: {
//     iataCode: "GRX",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 37.19,
//       longitude: -3.78,
//     },
//     shortName: "Granada",
//     longName: "Federico García Lorca Granada-Jaén Airpor",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "GRX",
//       shortName: "Granada",
//       longName: "Granada",
//     },
//   },
//   YJG: {
//     iataCode: "YJG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 37.19,
//       longitude: -3.78,
//     },
//     shortName: "Granada Rail Station",
//     longName: "Granada Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "GRX",
//       shortName: "Granada",
//       longName: "Granada",
//     },
//   },
//   XRY: {
//     iataCode: "XRY",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 36.74,
//       longitude: -6.06,
//     },
//     shortName: "Jerez De La Fron",
//     longName: "Jerez Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "XRY",
//       shortName: "Jerez De La Fron",
//       longName: "Jerez De La Fron",
//     },
//   },
//   YJW: {
//     iataCode: "YJW",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 36.74,
//       longitude: -6.06,
//     },
//     shortName: "Jerez Rail Station",
//     longName: "Jerez Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "XRY",
//       shortName: "Jerez De La Fron",
//       longName: "Jerez De La Fron",
//     },
//   },
//   YJM: {
//     iataCode: "YJM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 36.67,
//       longitude: -4.5,
//     },
//     shortName: "Malaga Train Station",
//     longName: "Malaga Train Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "AGP",
//       shortName: "Malaga",
//       longName: "Malaga",
//     },
//   },
//   AGP: {
//     iataCode: "AGP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 36.67,
//       longitude: -4.5,
//     },
//     shortName: "Malaga",
//     longName: "Pablo Ruiz Picasso Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "AGP",
//       shortName: "Malaga",
//       longName: "Malaga",
//     },
//   },
//   XQA: {
//     iataCode: "XQA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 37.42,
//       longitude: -5.89,
//     },
//     shortName: "Sevilla Railway Station",
//     longName: "Sevilla Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "SVQ",
//       shortName: "Sevilla",
//       longName: "Sevilla",
//     },
//   },
//   SVQ: {
//     iataCode: "SVQ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 37.42,
//       longitude: -5.9,
//     },
//     shortName: "Sevilla",
//     longName: "Seville Airport[",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "SVQ",
//       shortName: "Sevilla",
//       longName: "Sevilla",
//     },
//   },
//   ZAZ: {
//     iataCode: "ZAZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 41.67,
//       longitude: -1.04,
//     },
//     shortName: "Zaragoza",
//     longName: "Zaragoza Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "ZAZ",
//       shortName: "Zaragoza",
//       longName: "Zaragoza",
//     },
//   },
//   XZZ: {
//     iataCode: "XZZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 41.67,
//       longitude: -1.04,
//     },
//     shortName: "Zaragoza Railway Station",
//     longName: "Zaragoza Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "ZAZ",
//       shortName: "Zaragoza",
//       longName: "Zaragoza",
//     },
//   },
//   OVD: {
//     iataCode: "OVD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.56,
//       longitude: -6.03,
//     },
//     shortName: "Oviedo",
//     longName: "Asturias Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "OVD",
//       shortName: "Oviedo",
//       longName: "Oviedo",
//     },
//   },
//   OVI: {
//     iataCode: "OVI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.56,
//       longitude: -6.03,
//     },
//     shortName: "Oviedo Railway Station",
//     longName: "Oviedo Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "OVD",
//       shortName: "Oviedo",
//       longName: "Oviedo",
//     },
//   },
//   IBZ: {
//     iataCode: "IBZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 38.87,
//       longitude: 1.37,
//     },
//     shortName: "Ibiza",
//     longName: "Ibiza Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "IBZ",
//       shortName: "Ibiza",
//       longName: "Ibiza",
//     },
//   },
//   MAH: {
//     iataCode: "MAH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 39.86,
//       longitude: 4.22,
//     },
//     shortName: "Menorca",
//     longName: "Menorca Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "MAH",
//       shortName: "Menorca",
//       longName: "Menorca",
//     },
//   },
//   PMI: {
//     iataCode: "PMI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 39.55,
//       longitude: 2.74,
//     },
//     shortName: "Palma De Mallorc",
//     longName: "Palma de Mallorca Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "PMI",
//       shortName: "Palma De Mallorc",
//       longName: "Palma De Mallorc",
//     },
//   },
//   YJI: {
//     iataCode: "YJI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.3,
//       longitude: -2.91,
//     },
//     shortName: "Bilbao Abando Rail Station",
//     longName: "Bilbao Abando Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "BIO",
//       shortName: "Bilbao",
//       longName: "Bilbao",
//     },
//   },
//   BIO: {
//     iataCode: "BIO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.3,
//       longitude: -2.91,
//     },
//     shortName: "Bilbao",
//     longName: "Bilbao Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "BIO",
//       shortName: "Bilbao",
//       longName: "Bilbao",
//     },
//   },
//   EAS: {
//     iataCode: "EAS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.36,
//       longitude: -1.79,
//     },
//     shortName: "San Sebastian",
//     longName: "San Sebastián Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "EAS",
//       shortName: "San Sebastian",
//       longName: "San Sebastian",
//     },
//   },
//   LPA: {
//     iataCode: "LPA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 27.93,
//       longitude: -15.39,
//     },
//     shortName: "Gran Canaria",
//     longName: "Gran Canaria Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "LPA",
//       shortName: "Gran Canaria",
//       longName: "Gran Canaria",
//     },
//   },
//   ACE: {
//     iataCode: "ACE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 28.95,
//       longitude: -13.61,
//     },
//     shortName: "Lanzarote",
//     longName: "Lanzarote",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "ACE",
//       shortName: "Lanzarote",
//       longName: "Lanzarote",
//     },
//   },
//   SPC: {
//     iataCode: "SPC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 28.63,
//       longitude: -17.76,
//     },
//     shortName: "Santa Cruz de la Palma",
//     longName: "La Palma Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "SPC",
//       shortName: "Santa Cruz de la Palma",
//       longName: "Santa Cruz de la Palma",
//     },
//   },
//   TFN: {
//     iataCode: "TFN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 28.04,
//       longitude: -16.57,
//     },
//     shortName: "Tenerife North",
//     longName: "Tenerife North Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "TFN",
//       shortName: "Tenerife",
//       longName: "Tenerife",
//     },
//   },
//   TFS: {
//     iataCode: "TFS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 28.04,
//       longitude: -16.57,
//     },
//     shortName: "Tenerife South",
//     longName: "Tenerife South Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "TFN",
//       shortName: "Tenerife",
//       longName: "Tenerife",
//     },
//   },
//   SDR: {
//     iataCode: "SDR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.43,
//       longitude: -3.82,
//     },
//     shortName: "Santander",
//     longName: "Santander Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "SDR",
//       shortName: "Santander",
//       longName: "Santander",
//     },
//   },
//   EEU: {
//     iataCode: "EEU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 42.59,
//       longitude: -5.66,
//     },
//     shortName: "Leon Railway Station",
//     longName: "Leon Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "LEN",
//       shortName: "Leon",
//       longName: "Leon",
//     },
//   },
//   LEN: {
//     iataCode: "LEN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 42.59,
//       longitude: -5.66,
//     },
//     shortName: "Leon",
//     longName: "León Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "LEN",
//       shortName: "Leon",
//       longName: "Leon",
//     },
//   },
//   BCN: {
//     iataCode: "BCN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 41.3,
//       longitude: 2.08,
//     },
//     shortName: "Barcelona",
//     longName: "El Prat Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "BCN",
//       shortName: "Barcelona",
//       longName: "Barcelona",
//     },
//   },
//   MAD: {
//     iataCode: "MAD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 40.47,
//       longitude: -3.56,
//     },
//     shortName: "Madrid",
//     longName: "Madrid-Barajas Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "MAD",
//       shortName: "Madrid",
//       longName: "Madrid",
//     },
//   },
//   BJZ: {
//     iataCode: "BJZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 38.89,
//       longitude: -6.82,
//     },
//     shortName: "Badajoz",
//     longName: "Badajoz Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "BJZ",
//       shortName: "Badajoz",
//       longName: "Badajoz",
//     },
//   },
//   LCG: {
//     iataCode: "LCG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.3,
//       longitude: -8.38,
//     },
//     shortName: "La Coruna",
//     longName: "A Coruña Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "LCG",
//       shortName: "La Coruna",
//       longName: "La Coruna",
//     },
//   },
//   YJC: {
//     iataCode: "YJC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.3,
//       longitude: -8.38,
//     },
//     shortName: "A Coruña Rail station",
//     longName: "A Coruña Rail station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "LCG",
//       shortName: "La Coruna",
//       longName: "La Coruna",
//     },
//   },
//   SCQ: {
//     iataCode: "SCQ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 42.9,
//       longitude: -8.42,
//     },
//     shortName: "Santiago De Comp",
//     longName: "Santiago de Compostela Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "SCQ",
//       shortName: "Santiago De Comp",
//       longName: "Santiago De Comp",
//     },
//   },
//   JBU: {
//     iataCode: "JBU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 42.9,
//       longitude: -8.42,
//     },
//     shortName: "Santiago de Compostela Rail Station",
//     longName: "Santiago de Compostela Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "SCQ",
//       shortName: "Santiago De Comp",
//       longName: "Santiago De Comp",
//     },
//   },
//   VGO: {
//     iataCode: "VGO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 42.23,
//       longitude: -8.63,
//     },
//     shortName: "Vigo",
//     longName: "Vigo Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "VGO",
//       shortName: "Vigo",
//       longName: "Vigo",
//     },
//   },
//   RJL: {
//     iataCode: "RJL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 42.46,
//       longitude: -2.32,
//     },
//     shortName: "Logrono",
//     longName: "Logroño-Agoncillo Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "RJL",
//       shortName: "Logrono",
//       longName: "Logrono",
//     },
//   },
//   MLN: {
//     iataCode: "MLN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 35.28,
//       longitude: -2.96,
//     },
//     shortName: "Melilla",
//     longName: "Melilla Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "MLN",
//       shortName: "Melilla",
//       longName: "Melilla",
//     },
//   },
//   PNA: {
//     iataCode: "PNA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 42.77,
//       longitude: -1.65,
//     },
//     shortName: "Pamplona",
//     longName: "Pamplona Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "PNA",
//       shortName: "Pamplona",
//       longName: "Pamplona",
//     },
//   },
//   EEP: {
//     iataCode: "EEP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 42.77,
//       longitude: -1.65,
//     },
//     shortName: "Pamplona Railway Station",
//     longName: "Pamplona Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "PNA",
//       shortName: "Pamplona",
//       longName: "Pamplona",
//     },
//   },
//   XUT: {
//     iataCode: "XUT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 37.78,
//       longitude: -0.81,
//     },
//     shortName: "Murcia Railway Station",
//     longName: "Murcia Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "MJV",
//       shortName: "Murcia",
//       longName: "Murcia",
//     },
//   },
//   MJV: {
//     iataCode: "MJV",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 37.77,
//       longitude: -0.81,
//     },
//     shortName: "Murcia",
//     longName: "Murcia-San Javier Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "MJV",
//       shortName: "Murcia",
//       longName: "Murcia",
//     },
//   },
//   ALC: {
//     iataCode: "ALC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 38.28,
//       longitude: -0.56,
//     },
//     shortName: "Alicante",
//     longName: "Alicante Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "ALC",
//       shortName: "Alicante",
//       longName: "Alicante",
//     },
//   },
//   YJE: {
//     iataCode: "YJE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 38.28,
//       longitude: -0.56,
//     },
//     shortName: "Alicante Railway Station",
//     longName: "Alicante Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "ALC",
//       shortName: "Alicante",
//       longName: "Alicante",
//     },
//   },
//   VLC: {
//     iataCode: "VLC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 39.49,
//       longitude: -0.48,
//     },
//     shortName: "Valencia",
//     longName: "Valencia Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "VLC",
//       shortName: "Valencia",
//       longName: "Valencia",
//     },
//   },
//   YJV: {
//     iataCode: "YJV",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 39.49,
//       longitude: -0.48,
//     },
//     shortName: "Valencia Railway Station",
//     longName: "Valencia Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "VLC",
//       shortName: "Valencia",
//       longName: "Valencia",
//     },
//   },
//   FUE: {
//     iataCode: "FUE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 28.45,
//       longitude: -13.86,
//     },
//     shortName: "Fuerteventura",
//     longName: "Fuerteventura Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "FUE",
//       shortName: "Fuerteventura",
//       longName: "Fuerteventura",
//     },
//   },
//   GIA: {
//     iataCode: "GIA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 41.9,
//       longitude: 2.76,
//     },
//     shortName: "Girona Railway Station",
//     longName: "Girona Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "GRO",
//       shortName: "Girona",
//       longName: "Girona",
//     },
//   },
//   HEV: {
//     iataCode: "HEV",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 37.36,
//       longitude: -6.92,
//     },
//     shortName: "Huelva Railway Station",
//     longName: "Huelva Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "HEV",
//       shortName: "Huelva",
//       longName: "Huelva",
//     },
//   },
//   QLQ: {
//     iataCode: "QLQ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 41.73,
//       longitude: 0.54,
//     },
//     shortName: "Lleida Railway Station",
//     longName: "Lleida Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "ILD",
//       shortName: "Lleida",
//       longName: "Lleida",
//     },
//   },
//   OUQ: {
//     iataCode: "OUQ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 41.34,
//       longitude: -6.38,
//     },
//     shortName: "Ourense Rail Station",
//     longName: "Ourense Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "OUQ",
//       shortName: "Ourense",
//       longName: "Ourense",
//     },
//   },
//   PCI: {
//     iataCode: "PCI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 36.42,
//       longitude: -2.45,
//     },
//     shortName: "Palencia Railway Station",
//     longName: "Palencia  Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "PCI",
//       shortName: "Palencia",
//       longName: "Palencia",
//     },
//   },
//   XOU: {
//     iataCode: "XOU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 36.57,
//       longitude: -5.47,
//     },
//     shortName: "Segovia Railway Station",
//     longName: "Segovia Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "XOU",
//       shortName: "Segovia",
//       longName: "Segovia",
//     },
//   },
//   QGN: {
//     iataCode: "QGN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 34.43,
//       longitude: -2.55,
//     },
//     shortName: "Tarragona Railway Station",
//     longName: "Tarragona Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "QGN",
//       shortName: "Tarragona",
//       longName: "Tarragona",
//     },
//   },
//   XTJ: {
//     iataCode: "XTJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 39.47,
//       longitude: -3.24,
//     },
//     shortName: "Toldeo Railway Station",
//     longName: "Toldeo Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "XTJ",
//       shortName: "Toldeo",
//       longName: "Toldeo",
//     },
//   },
//   XIV: {
//     iataCode: "XIV",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 41.71,
//       longitude: -4.85,
//     },
//     shortName: "Valadolid Railway Station",
//     longName: "Valadolid Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "VLL",
//       shortName: "Valadolid",
//       longName: "Valadolid",
//     },
//   },
//   VIO: {
//     iataCode: "VIO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 42.88,
//       longitude: -2.72,
//     },
//     shortName: "Vitoria Rail Station",
//     longName: "Vitoria Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "VIT",
//       shortName: "Vitoria",
//       longName: "Vitoria",
//     },
//   },
//   ZOB: {
//     iataCode: "ZOB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 39.31,
//       longitude: -7.28,
//     },
//     shortName: "Zamora Rail Station",
//     longName: "Zamora Rail Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "ESP",
//       code: "ES",
//       shortName: "Spain",
//       longName: "Spain",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "ZOB",
//       shortName: "Zamora",
//       longName: "Zamora",
//     },
//   },
//   XWF: {
//     iataCode: "XWF",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 60.42,
//       longitude: 15.52,
//     },
//     shortName: "Borlange Falun Railway Station",
//     longName: "Borlange Falun Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "SWE",
//       code: "SE",
//       shortName: "Sweden",
//       longName: "Sweden",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "BLE",
//       shortName: "Borlange",
//       longName: "Borlange",
//     },
//   },
//   XYB: {
//     iataCode: "XYB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 60.42,
//       longitude: 15.52,
//     },
//     shortName: "Borlange Railway Station",
//     longName: "Borlange Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "SWE",
//       code: "SE",
//       shortName: "Sweden",
//       longName: "Sweden",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "BLE",
//       shortName: "Borlange",
//       longName: "Borlange",
//     },
//   },
//   XFJ: {
//     iataCode: "XFJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 59.35,
//       longitude: 16.71,
//     },
//     shortName: "Eskilstuna Railway Station",
//     longName: "Eskilstuna Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "SWE",
//       code: "SE",
//       shortName: "Sweden",
//       longName: "Sweden",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "EKT",
//       shortName: "Eskilstuna",
//       longName: "Eskilstuna",
//     },
//   },
//   GOT: {
//     iataCode: "GOT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 57.66,
//       longitude: 12.29,
//     },
//     shortName: "Gothenburg",
//     longName: "Landvetter Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "SWE",
//       code: "SE",
//       shortName: "Sweden",
//       longName: "Sweden",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "GOT",
//       shortName: "Gothenburg",
//       longName: "Gothenburg",
//     },
//   },
//   QYU: {
//     iataCode: "QYU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 60.59,
//       longitude: 16.95,
//     },
//     shortName: "Gävle Railway Station",
//     longName: "Gävle Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "SWE",
//       code: "SE",
//       shortName: "Sweden",
//       longName: "Sweden",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "GVX",
//       shortName: "Gävle ",
//       longName: "Gävle ",
//     },
//   },
//   HAD: {
//     iataCode: "HAD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 56.69,
//       longitude: 12.82,
//     },
//     shortName: "Halmstad Airport",
//     longName: "Halmstad Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "SWE",
//       code: "SE",
//       shortName: "Sweden",
//       longName: "Sweden",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "HAD",
//       shortName: "Halmstad",
//       longName: "Halmstad",
//     },
//   },
//   XXU: {
//     iataCode: "XXU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 60.28,
//       longitude: 15.98,
//     },
//     shortName: "Hedemora Railway Station",
//     longName: "Hedemora Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "SWE",
//       code: "SE",
//       shortName: "Sweden",
//       longName: "Sweden",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "XXU",
//       shortName: "Hedemora",
//       longName: "Hedemora",
//     },
//   },
//   AGH: {
//     iataCode: "AGH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 56.3,
//       longitude: 12.85,
//     },
//     shortName: "Angelholm-Helsingborg Airport",
//     longName: "Angelholm-Helsingborg Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "SWE",
//       code: "SE",
//       shortName: "Sweden",
//       longName: "Sweden",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "AGH",
//       shortName: "Helsingborg",
//       longName: "Helsingborg",
//     },
//   },
//   KLR: {
//     iataCode: "KLR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 56.69,
//       longitude: 16.29,
//     },
//     shortName: "Kalmar Airport",
//     longName: "Kalmar Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "SWE",
//       code: "SE",
//       shortName: "Sweden",
//       longName: "Sweden",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "KLR",
//       shortName: "Kalmar",
//       longName: "Kalmar",
//     },
//   },
//   XXO: {
//     iataCode: "XXO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 47.42,
//       longitude: 18.53,
//     },
//     shortName: "Leksand Railway Station",
//     longName: "Leksand Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "SWE",
//       code: "SE",
//       shortName: "Sweden",
//       longName: "Sweden",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "XXO",
//       shortName: "Leksand",
//       longName: "Leksand",
//     },
//   },
//   LLA: {
//     iataCode: "LLA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 65.54,
//       longitude: 22.12,
//     },
//     shortName: "Lulea Airport",
//     longName: "Lulea Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "SWE",
//       code: "SE",
//       shortName: "Sweden",
//       longName: "Sweden",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "LLA",
//       shortName: "Lulea",
//       longName: "Lulea",
//     },
//   },
//   MMX: {
//     iataCode: "MMX",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 55.55,
//       longitude: 13.35,
//     },
//     shortName: "Malmö",
//     longName: "Malmö-Sturup Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "SWE",
//       code: "SE",
//       shortName: "Sweden",
//       longName: "Sweden",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "MMX",
//       shortName: "Malmö",
//       longName: "Malmö",
//     },
//   },
//   XYK: {
//     iataCode: "XYK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 58.59,
//       longitude: 16.25,
//     },
//     shortName: "Norrköping Railway Station",
//     longName: "Norrköping Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "SWE",
//       code: "SE",
//       shortName: "Sweden",
//       longName: "Sweden",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "NRK",
//       shortName: "Norrköping",
//       longName: "Norrköping",
//     },
//   },
//   RNB: {
//     iataCode: "RNB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 56.27,
//       longitude: 15.27,
//     },
//     shortName: "Ronneby Airport",
//     longName: "Ronneby Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "SWE",
//       code: "SE",
//       shortName: "Sweden",
//       longName: "Sweden",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "RNB",
//       shortName: "Ronneby",
//       longName: "Ronneby",
//     },
//   },
//   OSD: {
//     iataCode: "OSD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 63.19,
//       longitude: 14.5,
//     },
//     shortName: "Ostersund Airport",
//     longName: "Ostersund Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "SWE",
//       code: "SE",
//       shortName: "Sweden",
//       longName: "Sweden",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "OSD",
//       shortName: "Ostersund",
//       longName: "Ostersund",
//     },
//   },
//   KRN: {
//     iataCode: "KRN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 67.82,
//       longitude: 20.34,
//     },
//     shortName: "Kiruna Airport",
//     longName: "Kiruna Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "SWE",
//       code: "SE",
//       shortName: "Sweden",
//       longName: "Sweden",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "KRN",
//       shortName: "Kiruna",
//       longName: "Kiruna",
//     },
//   },
//   SFT: {
//     iataCode: "SFT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 64.62,
//       longitude: 21.08,
//     },
//     shortName: "Skelleftea Airport",
//     longName: "Skelleftea Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "SWE",
//       code: "SE",
//       shortName: "Sweden",
//       longName: "Sweden",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "SFT",
//       shortName: "Skelleftea",
//       longName: "Skelleftea",
//     },
//   },
//   UME: {
//     iataCode: "UME",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 63.79,
//       longitude: 20.28,
//     },
//     shortName: "Umea Airport",
//     longName: "Umea Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "SWE",
//       code: "SE",
//       shortName: "Sweden",
//       longName: "Sweden",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "UME",
//       shortName: "Umea",
//       longName: "Umea",
//     },
//   },
//   XYX: {
//     iataCode: "XYX",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 45.47,
//       longitude: 19.71,
//     },
//     shortName: "Sala Railway Station",
//     longName: "Sala Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "SWE",
//       code: "SE",
//       shortName: "Sweden",
//       longName: "Sweden",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "XYX",
//       shortName: "Sala",
//       longName: "Sala",
//     },
//   },
//   XEZ: {
//     iataCode: "XEZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 59.26,
//       longitude: 17.62,
//     },
//     shortName: "Sodertalje Railway Station",
//     longName: "Sodertalje Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "SWE",
//       code: "SE",
//       shortName: "Sweden",
//       longName: "Sweden",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "JSO",
//       shortName: "Sodertalje",
//       longName: "Sodertalje",
//     },
//   },
//   ARN: {
//     iataCode: "ARN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 59.65,
//       longitude: 17.92,
//     },
//     shortName: "Stockholm",
//     longName: "Stockholm-Arlanda Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "SWE",
//       code: "SE",
//       shortName: "Sweden",
//       longName: "Sweden",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "ARN",
//       shortName: "Stockholm",
//       longName: "Stockholm",
//     },
//   },
//   SDL: {
//     iataCode: "SDL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 62.53,
//       longitude: 17.44,
//     },
//     shortName: "Sundsvall Harnosand Airport",
//     longName: "Sundsvall Harnosand Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "SWE",
//       code: "SE",
//       shortName: "Sweden",
//       longName: "Sweden",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "SDL",
//       shortName: "Sundsvall",
//       longName: "Sundsvall",
//     },
//   },
//   XXZ: {
//     iataCode: "XXZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 62.53,
//       longitude: 17.44,
//     },
//     shortName: "Sundsvall Railway Station",
//     longName: "Sundsvall Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "SWE",
//       code: "SE",
//       shortName: "Sweden",
//       longName: "Sweden",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "SDL",
//       shortName: "Sundsvall",
//       longName: "Sundsvall",
//     },
//   },
//   SCR: {
//     iataCode: "SCR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 58.57,
//       longitude: 13.42,
//     },
//     shortName: "Sälen Trysil Airport",
//     longName: "Sälen Scandinavian Mountains Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "SWE",
//       code: "SE",
//       shortName: "Sweden",
//       longName: "Sweden",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "SCR",
//       shortName: "Sälen",
//       longName: "Sälen",
//     },
//   },
//   QYX: {
//     iataCode: "QYX",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 59.9,
//       longitude: 17.59,
//     },
//     shortName: "Uppsala Railway Station",
//     longName: "Uppsala Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "SWE",
//       code: "SE",
//       shortName: "Sweden",
//       longName: "Sweden",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "QYX",
//       shortName: "Uppsala",
//       longName: "Uppsala",
//     },
//   },
//   VBY: {
//     iataCode: "VBY",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 57.66,
//       longitude: 18.35,
//     },
//     shortName: "Visby Airport",
//     longName: "Visby Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "SWE",
//       code: "SE",
//       shortName: "Sweden",
//       longName: "Sweden",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "VBY",
//       shortName: "Visby",
//       longName: "Visby",
//     },
//   },
//   XWR: {
//     iataCode: "XWR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 59.22,
//       longitude: 15.04,
//     },
//     shortName: "Örebro Railway Station",
//     longName: "Örebro Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "SWE",
//       code: "SE",
//       shortName: "Sweden",
//       longName: "Sweden",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "ORB",
//       shortName: "Örebro",
//       longName: "Örebro",
//     },
//   },
//   OER: {
//     iataCode: "OER",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 63.41,
//       longitude: 18.99,
//     },
//     shortName: "Örnsköldsvik Airport",
//     longName: "Örnsköldsvik Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "SWE",
//       code: "SE",
//       shortName: "Sweden",
//       longName: "Sweden",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "OER",
//       shortName: "Örnsköldsvik",
//       longName: "Örnsköldsvik",
//     },
//   },
//   ZDH: {
//     iataCode: "ZDH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 47.59,
//       longitude: 7.53,
//     },
//     shortName: "Basel Railway Station",
//     longName: "Basel Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "CHE",
//       code: "CH",
//       shortName: "Switzerland",
//       longName: "Switzerland",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "EAP",
//       shortName: "Basel",
//       longName: "Basel Mulhouse",
//     },
//   },
//   BSL: {
//     iataCode: "BSL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 7.52,
//       longitude: 47.6,
//     },
//     shortName: "Basel Airport",
//     longName: "EuroAirport Basel-Mulhouse-Freiburg",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "CHE",
//       code: "CH",
//       shortName: "Switzerland",
//       longName: "Switzerland",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "EAP",
//       shortName: "Basel",
//       longName: "Basel Mulhouse",
//     },
//   },
//   ZDJ: {
//     iataCode: "ZDJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 46.91,
//       longitude: 7.5,
//     },
//     shortName: "Bern Railway Station",
//     longName: "Bern Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "CHE",
//       code: "CH",
//       shortName: "Switzerland",
//       longName: "Switzerland",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "BRN",
//       shortName: "Bern",
//       longName: "Bern",
//     },
//   },
//   GVA: {
//     iataCode: "GVA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 46.24,
//       longitude: 6.11,
//     },
//     shortName: "Geneva",
//     longName: "Geneva International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "CHE",
//       code: "CH",
//       shortName: "Switzerland",
//       longName: "Switzerland",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "GVA",
//       shortName: "Geneva",
//       longName: "Geneva",
//     },
//   },
//   ZRH: {
//     iataCode: "ZRH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 47.46,
//       longitude: 8.55,
//     },
//     shortName: "Zürich",
//     alternateNames: ["Zurich", "Zuerich"],
//     longName: "Zürich-Kloten Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "CHE",
//       code: "CH",
//       shortName: "Switzerland",
//       longName: "Switzerland",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "ZRH",
//       shortName: "Zürich",
//       longName: "Zürich",
//     },
//   },
//   ZDT: {
//     iataCode: "ZDT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 45.94,
//       longitude: 7.29,
//     },
//     shortName: "Chur Railway Station",
//     longName: "Chur Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "CHE",
//       code: "CH",
//       shortName: "Switzerland",
//       longName: "Switzerland",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "ZDT",
//       shortName: "Chur",
//       longName: "Chur",
//     },
//   },
//   ZHI: {
//     iataCode: "ZHI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 47.18,
//       longitude: 7.42,
//     },
//     shortName: "Grenchen Railway Station",
//     longName: "Grenchen Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "CHE",
//       code: "CH",
//       shortName: "Switzerland",
//       longName: "Switzerland",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "ZHI",
//       shortName: "Grenchen",
//       longName: "Grenchen",
//     },
//   },
//   QLS: {
//     iataCode: "QLS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 46.55,
//       longitude: 6.62,
//     },
//     shortName: "Lausanne Railway Station",
//     longName: "Lausanne Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "CHE",
//       code: "CH",
//       shortName: "Switzerland",
//       longName: "Switzerland",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "QLS",
//       shortName: "Lausanne",
//       longName: "Lausanne",
//     },
//   },
//   QLJ: {
//     iataCode: "QLJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 46.54,
//       longitude: 7.12,
//     },
//     shortName: "Lucerne Railway Station",
//     longName: "Lucerne Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "CHE",
//       code: "CH",
//       shortName: "Switzerland",
//       longName: "Switzerland",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "QLJ",
//       shortName: "Lucerne",
//       longName: "Lucerne",
//     },
//   },
//   SIR: {
//     iataCode: "SIR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 46.22,
//       longitude: 7.33,
//     },
//     shortName: "Sion Railway Station",
//     longName: "Sion Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "CHE",
//       code: "CH",
//       shortName: "Switzerland",
//       longName: "Switzerland",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "SIR",
//       shortName: "Sion",
//       longName: "Sion",
//     },
//   },
//   QGL: {
//     iataCode: "QGL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "2",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 45.32,
//       longitude: 6.76,
//     },
//     shortName: "St. Gallen Railway Station",
//     longName: "St. Gallen Railway Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "CHE",
//       code: "CH",
//       shortName: "Switzerland",
//       longName: "Switzerland",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "QGL",
//       shortName: "St. Gallen",
//       longName: "St. Gallen",
//     },
//   },
//   AYT: {
//     iataCode: "AYT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 36.9,
//       longitude: 30.79,
//     },
//     shortName: "Antalya",
//     longName: "Antalya",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "TUR",
//       code: "TR",
//       shortName: "Türkiye",
//       longName: "Türkiye",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "AYT",
//       shortName: "Antalya",
//       longName: "Antalya",
//     },
//   },
//   BJV: {
//     iataCode: "BJV",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 37.25,
//       longitude: 27.68,
//     },
//     shortName: "Bodrum",
//     longName: "Milas-Bodrum Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "TUR",
//       code: "TR",
//       shortName: "Türkiye",
//       longName: "Türkiye",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "BJV",
//       shortName: "Bodrum",
//       longName: "Bodrum",
//     },
//   },
//   IST: {
//     iataCode: "IST",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 40.98,
//       longitude: 28.81,
//     },
//     shortName: "Istanbul Airport",
//     longName: "Istanbul Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "TUR",
//       code: "TR",
//       shortName: "Türkiye",
//       longName: "Türkiye",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "IST",
//       shortName: "Istanbul",
//       longName: "Istanbul",
//     },
//   },
//   SAW: {
//     iataCode: "SAW",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 40.9,
//       longitude: 29.31,
//     },
//     shortName: "Istanbul Sabiha Gokcen",
//     longName: "Istanbul Sabiha Gokcen International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "TUR",
//       code: "TR",
//       shortName: "Türkiye",
//       longName: "Türkiye",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "IST",
//       shortName: "Istanbul",
//       longName: "Istanbul",
//     },
//   },
//   ADB: {
//     iataCode: "ADB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 38.29,
//       longitude: 27.16,
//     },
//     shortName: "Izmir",
//     longName: "Izmir Adnan Menderes International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "TUR",
//       code: "TR",
//       shortName: "Türkiye",
//       longName: "Türkiye",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "ADB",
//       shortName: "Izmir",
//       longName: "Izmir",
//     },
//   },
//   SSX: {
//     iataCode: "SSX",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 41.27,
//       longitude: 36.55,
//     },
//     shortName: "Samsun",
//     longName: "Samsun Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "TUR",
//       code: "TR",
//       shortName: "Türkiye",
//       longName: "Türkiye",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "SSX",
//       shortName: "Samsun",
//       longName: "Samsun",
//     },
//   },
//   ADA: {
//     iataCode: "ADA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 36.98,
//       longitude: 35.28,
//     },
//     shortName: "Adana",
//     longName: "Adana",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "TUR",
//       code: "TR",
//       shortName: "Türkiye",
//       longName: "Türkiye",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "ADA",
//       shortName: "Adana",
//       longName: "Adana",
//     },
//   },
//   ESB: {
//     iataCode: "ESB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 40.13,
//       longitude: 33,
//     },
//     shortName: "Ankara",
//     longName: "Esenboga International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "TUR",
//       code: "TR",
//       shortName: "Türkiye",
//       longName: "Türkiye",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "ESB",
//       shortName: "Ankara",
//       longName: "Ankara",
//     },
//   },
//   DNZ: {
//     iataCode: "DNZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 37.79,
//       longitude: 29.71,
//     },
//     shortName: "Denizli",
//     longName: "Denizli Çardak Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "TUR",
//       code: "TR",
//       shortName: "Türkiye",
//       longName: "Türkiye",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "DNZ",
//       shortName: "Denizli",
//       longName: "Denizli",
//     },
//   },
//   DIY: {
//     iataCode: "DIY",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 37.89,
//       longitude: 40.2,
//     },
//     shortName: "Diyarbakir",
//     longName: "Diyarbakir Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "TUR",
//       code: "TR",
//       shortName: "Türkiye",
//       longName: "Türkiye",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "DIY",
//       shortName: "Diyarbakir",
//       longName: "Diyarbakir",
//     },
//   },
//   ERZ: {
//     iataCode: "ERZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 39.96,
//       longitude: 41.17,
//     },
//     shortName: "Erzurum",
//     longName: "Erzurum Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "TUR",
//       code: "TR",
//       shortName: "Türkiye",
//       longName: "Türkiye",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "ERZ",
//       shortName: "Erzurum",
//       longName: "Erzurum",
//     },
//   },
//   ECN: {
//     iataCode: "ECN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 35.16,
//       longitude: 33.5,
//     },
//     shortName: "Ercan",
//     longName: "Ercan International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "TUR",
//       code: "TR",
//       shortName: "Türkiye",
//       longName: "Türkiye",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "ECN",
//       shortName: "Ercan",
//       longName: "Ercan",
//     },
//   },
//   GZT: {
//     iataCode: "GZT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 36.95,
//       longitude: 37.48,
//     },
//     shortName: "Gaziantep",
//     longName: "Gaziantep Oguzeli International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "TUR",
//       code: "TR",
//       shortName: "Türkiye",
//       longName: "Türkiye",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "GZT",
//       shortName: "Gaziantep",
//       longName: "Gaziantep",
//     },
//   },
//   HTY: {
//     iataCode: "HTY",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 36.37,
//       longitude: 36.3,
//     },
//     shortName: "Hatay",
//     longName: "Hatay Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "TUR",
//       code: "TR",
//       shortName: "Türkiye",
//       longName: "Türkiye",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "HTY",
//       shortName: "Hatay",
//       longName: "Hatay",
//     },
//   },
//   ASR: {
//     iataCode: "ASR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 38.77,
//       longitude: 35.5,
//     },
//     shortName: "Kayseri",
//     longName: "Kayseri",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "TUR",
//       code: "TR",
//       shortName: "Türkiye",
//       longName: "Türkiye",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "ASR",
//       shortName: "Kayseri",
//       longName: "Kayseri",
//     },
//   },
//   KYA: {
//     iataCode: "KYA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 37.98,
//       longitude: 32.56,
//     },
//     shortName: "Konya",
//     longName: "Konya",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "TUR",
//       code: "TR",
//       shortName: "Türkiye",
//       longName: "Türkiye",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "KYA",
//       shortName: "Konya",
//       longName: "Konya",
//     },
//   },
//   MLX: {
//     iataCode: "MLX",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 38.43,
//       longitude: 38.08,
//     },
//     shortName: "Malatya",
//     longName: "Malatya",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "TUR",
//       code: "TR",
//       shortName: "Türkiye",
//       longName: "Türkiye",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "MLX",
//       shortName: "Malatya",
//       longName: "Malatya",
//     },
//   },
//   DLM: {
//     iataCode: "DLM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 36.71,
//       longitude: 28.79,
//     },
//     shortName: "Dalaman",
//     longName: "Dalaman International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "TUR",
//       code: "TR",
//       shortName: "Türkiye",
//       longName: "Türkiye",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "DLM",
//       shortName: "Dalaman",
//       longName: "Dalaman",
//     },
//   },
//   GNY: {
//     iataCode: "GNY",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 37.46,
//       longitude: 38.91,
//     },
//     shortName: "Sanliurfa",
//     longName: "Sanliurfa Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "TUR",
//       code: "TR",
//       shortName: "Türkiye",
//       longName: "Türkiye",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "GNY",
//       shortName: "Sanliurfa",
//       longName: "Sanliurfa",
//     },
//   },
//   TZX: {
//     iataCode: "TZX",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 41,
//       longitude: 39.79,
//     },
//     shortName: "Trabzon",
//     longName: "Trabzon Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "TUR",
//       code: "TR",
//       shortName: "Türkiye",
//       longName: "Türkiye",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "TZX",
//       shortName: "Trabzon",
//       longName: "Trabzon",
//     },
//   },
//   SIP: {
//     iataCode: "SIP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 45.05,
//       longitude: 33.98,
//     },
//     shortName: "Simferopol Airport",
//     longName: "Simferopol International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "UKR",
//       code: "UA",
//       shortName: "Ukraine",
//       longName: "Ukraine",
//     },
//     city: {
//       code: "SIP",
//       shortName: "Simferopol",
//       longName: "Simferopol",
//     },
//   },
//   DNK: {
//     iataCode: "DNK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 48.36,
//       longitude: 35.1,
//     },
//     shortName: "Dnipropetrovsk Airport",
//     longName: "Dnipropetrovsk Int Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "UKR",
//       code: "UA",
//       shortName: "Ukraine",
//       longName: "Ukraine",
//     },
//     city: {
//       code: "DNK",
//       shortName: "Dnipropetrovsk",
//       longName: "Dnipropetrovsk",
//     },
//   },
//   DOK: {
//     iataCode: "DOK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 48.07,
//       longitude: 37.74,
//     },
//     shortName: "Donetsk",
//     longName: "Donetsk International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "UKR",
//       code: "UA",
//       shortName: "Ukraine",
//       longName: "Ukraine",
//     },
//     city: {
//       code: "DOK",
//       shortName: "Donetsk",
//       longName: "Donetsk",
//     },
//   },
//   HRK: {
//     iataCode: "HRK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 49.92,
//       longitude: 36.29,
//     },
//     shortName: "Kharkiv",
//     longName: "Osnova International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "UKR",
//       code: "UA",
//       shortName: "Ukraine",
//       longName: "Ukraine",
//     },
//     city: {
//       code: "HRK",
//       shortName: "Kharkiv",
//       longName: "Kharkiv",
//     },
//   },
//   IEV: {
//     iataCode: "IEV",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 50.4,
//       longitude: 30.45,
//     },
//     shortName: "Kyiv Airport",
//     alternateNames: ["Kiev Airport"],
//     longName: "Kyiv Zhuliany Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "UKR",
//       code: "UA",
//       shortName: "Ukraine",
//       longName: "Ukraine",
//     },
//     city: {
//       code: "KBP",
//       shortName: "Kyiv",
//       alternateNames: ["Kiev"],
//       longName: "Kyiv",
//     },
//   },
//   KBP: {
//     iataCode: "KBP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 50.34,
//       longitude: 30.89,
//     },
//     shortName: "Kiev",
//     longName: "Boryspil International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "UKR",
//       code: "UA",
//       shortName: "Ukraine",
//       longName: "Ukraine",
//     },
//     city: {
//       code: "KBP",
//       shortName: "Kyiv",
//       alternateNames: ["Kiev"],
//       longName: "Kyiv",
//     },
//   },
//   LWO: {
//     iataCode: "LWO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 49.81,
//       longitude: 23.96,
//     },
//     shortName: "Lviv Airport",
//     longName: "Lviv Danylo Halytskyi Int. Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "UKR",
//       code: "UA",
//       shortName: "Ukraine",
//       longName: "Ukraine",
//     },
//     city: {
//       code: "LWO",
//       shortName: "Lviv",
//       longName: "Lviv",
//     },
//   },
//   ODS: {
//     iataCode: "ODS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 46.43,
//       longitude: 30.68,
//     },
//     shortName: "Odessa Airport",
//     longName: "Odessa International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "UKR",
//       code: "UA",
//       shortName: "Ukraine",
//       longName: "Ukraine",
//     },
//     city: {
//       code: "ODS",
//       shortName: "Odessa",
//       longName: "Odessa",
//     },
//   },
//   BRS: {
//     iataCode: "BRS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 51.38,
//       longitude: -2.72,
//     },
//     shortName: "Bristol Airport",
//     longName: "Bristol Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "BRS",
//       shortName: "Bristol",
//       longName: "Bristol",
//     },
//   },
//   CHW: {
//     iataCode: "CHW",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "1",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 55.38,
//       longitude: -3.44,
//     },
//     shortName: "Cheltenham Spa Bus Station",
//     longName: "Cheltenham Spa Bus Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "CHW",
//       shortName: "Cheltenham Spa",
//       longName: "Cheltenham Spa",
//     },
//   },
//   CLB: {
//     iataCode: "CLB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "1",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 55.38,
//       longitude: -3.44,
//     },
//     shortName: "Colchester Bus Station",
//     longName: "Colchester Bus Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "CLB",
//       shortName: "Colchester",
//       longName: "Colchester",
//     },
//   },
//   CBG: {
//     iataCode: "CBG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "1",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 52.21,
//       longitude: 0.18,
//     },
//     shortName: "Cambridge Bus Station",
//     longName: "Cambridge Central Bus Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "CBG",
//       shortName: "Cambridge",
//       longName: "Cambridge",
//     },
//   },
//   BOH: {
//     iataCode: "BOH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "1",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 50.78,
//       longitude: -1.84,
//     },
//     shortName: "Bournemouth Airport",
//     longName: "Bournemouth Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "BOH",
//       shortName: "Bournemouth",
//       longName: "Bournemouth",
//     },
//   },
//   BSH: {
//     iataCode: "BSH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "1",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 50.84,
//       longitude: -0.3,
//     },
//     shortName: "Brighton Bus Station",
//     longName: "Brighton Central Bus Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "BSH",
//       shortName: "Brighton",
//       longName: "Brighton",
//     },
//   },
//   BHX: {
//     iataCode: "BHX",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: true,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 52.45,
//       longitude: -1.75,
//     },
//     shortName: "Birmingham",
//     longName: "Birmingham International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "BHX",
//       shortName: "Birmingham",
//       longName: "Birmingham",
//     },
//   },
//   MME: {
//     iataCode: "MME",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 54.51,
//       longitude: -1.43,
//     },
//     shortName: "Teesside International Airport",
//     longName: "Teesside International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "MME",
//       shortName: "Durham",
//       longName: "Durham",
//     },
//   },
//   EXT: {
//     iataCode: "EXT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: true,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 50.73,
//       longitude: -3.41,
//     },
//     shortName: "Exeter",
//     longName: "Exeter International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "EXT",
//       shortName: "Exeter",
//       longName: "Exeter",
//     },
//   },
//   GCI: {
//     iataCode: "GCI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: true,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 49.57,
//       longitude: -2.74,
//     },
//     shortName: "Guernsey Airport",
//     longName: "Guernsey Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "GCI",
//       shortName: "Guernsey",
//       longName: "Guernsey",
//     },
//   },
//   JER: {
//     iataCode: "JER",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: true,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 49.21,
//       longitude: -2.2,
//     },
//     shortName: "Jersey",
//     longName: "Jersey Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "JER",
//       shortName: "Jersey",
//       longName: "Jersey",
//     },
//   },
//   LON: {
//     iataCode: "LON",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: true,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 51.3,
//       longitude: -0.82,
//     },
//     shortName: "London",
//     longName: "London All Airports",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "LON",
//       shortName: "London",
//       longName: "London",
//     },
//   },
//   LGW: {
//     iataCode: "LGW",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: true,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 51.15,
//       longitude: -0.19,
//     },
//     shortName: "London Gatwick",
//     alternateNames: ["London Stansted (STN)", "London Heathrow (LHR)"],
//     longName: "London Gatwick Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "LON",
//       shortName: "London",
//       longName: "London",
//     },
//   },
//   LHR: {
//     iataCode: "LHR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: true,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 51.48,
//       longitude: -0.46,
//     },
//     shortName: "London Heathrow",
//     alternateNames: ["London Stansted (STN)", "London Gatwick (LGW)"],
//     longName: "London Heathrow Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "LON",
//       shortName: "London",
//       longName: "London",
//     },
//   },
//   STN: {
//     iataCode: "STN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: true,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 51.89,
//       longitude: 0.24,
//     },
//     shortName: "London Stansted",
//     alternateNames: [
//       "London Gatwick airport (LGW)",
//       "London Heathrow airport (LHR)",
//     ],
//     longName: "London Stansted",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "LON",
//       shortName: "London",
//       longName: "London",
//     },
//   },
//   MAN: {
//     iataCode: "MAN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: true,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 53.35,
//       longitude: -2.27,
//     },
//     shortName: "Manchester",
//     longName: "Manchester International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "MAN",
//       shortName: "Manchester",
//       longName: "Manchester",
//     },
//   },
//   NCL: {
//     iataCode: "NCL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: true,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 55.04,
//       longitude: -1.69,
//     },
//     shortName: "Newcastle",
//     longName: "Newcastle Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "NCL",
//       shortName: "Newcastle",
//       longName: "Newcastle",
//     },
//   },
//   NQY: {
//     iataCode: "NQY",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: true,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 50.44,
//       longitude: -5,
//     },
//     shortName: "Newquay",
//     longName: "Newquay Cornwall Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "NQY",
//       shortName: "Newquay",
//       longName: "Newquay",
//     },
//   },
//   LXC: {
//     iataCode: "LXC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "1",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 53.33,
//       longitude: -2.85,
//     },
//     shortName: "Liverpool Bus Station",
//     longName: "Liverpool Central Bus Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "LPL",
//       shortName: "Liverpool",
//       longName: "Liverpool",
//     },
//   },
//   NWI: {
//     iataCode: "NWI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "1",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 52.68,
//       longitude: 1.28,
//     },
//     shortName: "Norwich",
//     longName: "Norwich International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "NWI",
//       shortName: "Norwich",
//       longName: "Norwich",
//     },
//   },
//   BHD: {
//     iataCode: "BHD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: true,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 54.62,
//       longitude: -5.87,
//     },
//     shortName: "Belfast",
//     longName: "George Best Belfast City Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "BHD",
//       shortName: "Belfast",
//       longName: "Belfast",
//     },
//   },
//   LDY: {
//     iataCode: "LDY",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 55.04,
//       longitude: -7.16,
//     },
//     shortName: "Londonderry Airport",
//     longName: "Londonderry Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "LDY",
//       shortName: "Londonderry",
//       longName: "Londonderry",
//     },
//   },
//   EMA: {
//     iataCode: "EMA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: true,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 52.83,
//       longitude: -1.33,
//     },
//     shortName: "EAST MIDLANDS Airport",
//     longName: "East Midlands Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "NQT",
//       shortName: "Nottingham",
//       longName: "Nottingham",
//     },
//   },
//   ABZ: {
//     iataCode: "ABZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: true,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 57.2,
//       longitude: -2.2,
//     },
//     shortName: "Aberdeen",
//     longName: "Aberdeen Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "ABZ",
//       shortName: "Aberdeen",
//       longName: "Aberdeen",
//     },
//   },
//   BRR: {
//     iataCode: "BRR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 57.02,
//       longitude: -7.44,
//     },
//     shortName: "Barra Airport",
//     longName: "Barra Eoligarry Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "BRR",
//       shortName: "Barra",
//       longName: "Barra",
//     },
//   },
//   BEB: {
//     iataCode: "BEB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: true,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 57.48,
//       longitude: -7.36,
//     },
//     shortName: "Benbecula",
//     longName: "Benbecula Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "BEB",
//       shortName: "Benbecula",
//       longName: "Benbecula",
//     },
//   },
//   CAL: {
//     iataCode: "CAL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: true,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 55.44,
//       longitude: -5.69,
//     },
//     shortName: "Campbeltown",
//     longName: "Campbeltown Airport ",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "CAL",
//       shortName: "Campbeltown",
//       longName: "Campbeltown",
//     },
//   },
//   DND: {
//     iataCode: "DND",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 56.45,
//       longitude: -3.03,
//     },
//     shortName: "Dundee Airport",
//     longName: "Dundee Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "DND",
//       shortName: "Dundee",
//       longName: "Dundee",
//     },
//   },
//   EDI: {
//     iataCode: "EDI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: true,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 55.95,
//       longitude: -3.37,
//     },
//     shortName: "Edinburgh",
//     alternateNames: ["Glasgow"],
//     longName: "Edinburgh Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "EDI",
//       shortName: "Edinburgh",
//       longName: "Edinburgh",
//     },
//   },
//   GLA: {
//     iataCode: "GLA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: true,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 55.87,
//       longitude: -4.43,
//     },
//     shortName: "Glasgow",
//     alternateNames: ["Edinburgh"],
//     longName: "Glasgow International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "GLA",
//       shortName: "Glasgow",
//       longName: "Glasgow",
//     },
//   },
//   INV: {
//     iataCode: "INV",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: true,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 57.54,
//       longitude: -4.05,
//     },
//     shortName: "Inverness Airport",
//     longName: "Inverness Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "INV",
//       shortName: "Inverness",
//       longName: "Inverness",
//     },
//   },
//   ILY: {
//     iataCode: "ILY",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: true,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 55.68,
//       longitude: -6.26,
//     },
//     shortName: "Islay",
//     longName: "Islay Airport ",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "ILY",
//       shortName: "Islay",
//       longName: "Islay",
//     },
//   },
//   KOI: {
//     iataCode: "KOI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: true,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 58.96,
//       longitude: -2.9,
//     },
//     shortName: "Kirkwall",
//     longName: "Kirkwall Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "KOI",
//       shortName: "Kirkwall",
//       longName: "Kirkwall",
//     },
//   },
//   LSI: {
//     iataCode: "LSI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: true,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 59.88,
//       longitude: -1.3,
//     },
//     shortName: "Sumburgh",
//     longName: "Sumburgh Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "SDZ",
//       shortName: "Shetland Islands",
//       longName: "Shetland Islands",
//     },
//   },
//   SYY: {
//     iataCode: "SYY",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: true,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 58.22,
//       longitude: -6.33,
//     },
//     shortName: "Stornoway",
//     longName: "Stornoway Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "SYY",
//       shortName: "Stornoway ",
//       longName: "Stornoway ",
//     },
//   },
//   TRE: {
//     iataCode: "TRE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: true,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 56.5,
//       longitude: -6.87,
//     },
//     shortName: "Tiree",
//     longName: "Tiree Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "TRE",
//       shortName: "Tiree",
//       longName: "Tiree Island",
//     },
//   },
//   WIC: {
//     iataCode: "WIC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 58.46,
//       longitude: -3.09,
//     },
//     shortName: "Wick Airport",
//     longName: "Wick Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "WIC",
//       shortName: "Wick",
//       longName: "Wick",
//     },
//   },
//   QQX: {
//     iataCode: "QQX",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "1",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 53.83,
//       longitude: -1.2,
//     },
//     shortName: "Bath Spa Bus Station",
//     longName: "Bath Spa Central Bus Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "QQX",
//       shortName: "Bath Spa",
//       longName: "Bath Spa",
//     },
//   },
//   XNE: {
//     iataCode: "XNE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "1",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 51.51,
//       longitude: -1.02,
//     },
//     shortName: "Newport Bus Station",
//     longName: "Newport Central Bus Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "XNE",
//       shortName: "Newport",
//       longName: "Newport",
//     },
//   },
//   CVT: {
//     iataCode: "CVT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "1",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 52.37,
//       longitude: -1.48,
//     },
//     shortName: "Coventry Bus Station",
//     longName: "Coventry Central Bus Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "CVT",
//       shortName: "Coventry",
//       longName: "Coventry",
//     },
//   },
//   ZFC: {
//     iataCode: "ZFC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "1",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 53.77,
//       longitude: -1.66,
//     },
//     shortName: "Leeds Bradford Bus Station",
//     longName: "Leeds Bradford Bus Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "LBA",
//       shortName: "Leeds",
//       longName: "Leeds",
//     },
//   },
//   ZLZ: {
//     iataCode: "ZLZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "1",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 53.87,
//       longitude: -1.65,
//     },
//     shortName: "Leeds Bus Station",
//     longName: "Leeds Central Bus Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "LBA",
//       shortName: "Leeds",
//       longName: "Leeds",
//     },
//   },
//   QEW: {
//     iataCode: "QEW",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "1",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 52.61,
//       longitude: -1.03,
//     },
//     shortName: "Leicester Bus Station",
//     longName: "Leicester Central Bus Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "QEW",
//       shortName: "Leicester",
//       longName: "Leicester",
//     },
//   },
//   KYN: {
//     iataCode: "KYN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "1",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 55.38,
//       longitude: -3.44,
//     },
//     shortName: "Milton Keynes Bus Station",
//     longName: "Milton Keynes Bus Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "KYN",
//       shortName: "Milton Keynes",
//       longName: "Milton Keynes",
//     },
//   },
//   PLH: {
//     iataCode: "PLH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "1",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 50.42,
//       longitude: -4.11,
//     },
//     shortName: "Plymouth Bus Station",
//     longName: "Plymouth Central Bus Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "PLH",
//       shortName: "Plymouth",
//       longName: "Plymouth",
//     },
//   },
//   POQ: {
//     iataCode: "POQ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "1",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 55.38,
//       longitude: -3.44,
//     },
//     shortName: "Poole Bus Station",
//     longName: "Poole Bus Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "POQ",
//       shortName: "Poole",
//       longName: "Poole",
//     },
//   },
//   RNW: {
//     iataCode: "RNW",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "1",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 55.38,
//       longitude: -3.44,
//     },
//     shortName: "Ringwood Bus Station",
//     longName: "Ringwood Bus Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "RNW",
//       shortName: "Ringwood",
//       longName: "Ringwood",
//     },
//   },
//   SWS: {
//     iataCode: "SWS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "1",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 51.61,
//       longitude: -4.07,
//     },
//     shortName: "Swansea Bus Station",
//     longName: "Swansea Central Bus Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "SWS",
//       shortName: "Swansea",
//       longName: "Swansea",
//     },
//   },
//   XWS: {
//     iataCode: "XWS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "1",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 51.49,
//       longitude: -1.74,
//     },
//     shortName: "Swindon Bus Station",
//     longName: "Swindon Central Bus Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "XWS",
//       shortName: "Swindon",
//       longName: "Swindon",
//     },
//   },
//   TTY: {
//     iataCode: "TTY",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "1",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 51,
//       longitude: -3.24,
//     },
//     shortName: "Taunton Bus Station",
//     longName: "Taunton Central Bus Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "TTY",
//       shortName: "Taunton",
//       longName: "Taunton",
//     },
//   },
//   WNC: {
//     iataCode: "WNC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "1",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 55.38,
//       longitude: -3.44,
//     },
//     shortName: "Winchester Bus Station",
//     longName: "Winchester Bus Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "Europe",
//       longName: "Europe",
//       code: "EURO",
//     },
//     country: {
//       a3code: "GBR",
//       code: "GB",
//       shortName: "United Kingdom",
//       alternateNames: ["England", "Britain", "Scotland", "UK"],
//       longName: "United Kingdom",
//       otherRegion: {
//         shortName: "Europe",
//         longName: "Europe",
//       },
//     },
//     city: {
//       code: "WNC",
//       shortName: "Winchester",
//       longName: "Winchester",
//     },
//   },
//   ANU: {
//     iataCode: "ANU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 17.14,
//       longitude: -61.79,
//     },
//     shortName: "Antigua Airport",
//     longName: "Antigua V.C. Bird International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "ATG",
//       code: "AG",
//       shortName: "Antigua and Barbuda",
//       longName: "Antigua and Barbuda",
//     },
//     city: {
//       code: "ANU",
//       shortName: "Antigua",
//       longName: "Antigua",
//     },
//   },
//   RES: {
//     iataCode: "RES",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -27.45,
//       longitude: -59.06,
//     },
//     shortName: "Resistencia Airport",
//     longName: "Resistencia Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "ARG",
//       code: "AR",
//       shortName: "Argentina",
//       longName: "Argentina",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "RES",
//       shortName: "Resistencia",
//       longName: "Resistencia",
//     },
//   },
//   CRD: {
//     iataCode: "CRD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -45.79,
//       longitude: -67.47,
//     },
//     shortName: "Comodoro Rivadavia Airport",
//     longName: "Comodoro Rivadavia Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "ARG",
//       code: "AR",
//       shortName: "Argentina",
//       longName: "Argentina",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "CRD",
//       shortName: "Comodoro Rivadavia",
//       longName: "Comodoro Rivadavia",
//     },
//   },
//   EQS: {
//     iataCode: "EQS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -42.91,
//       longitude: -71.14,
//     },
//     shortName: "Esquel Airport",
//     longName: "Esquel Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "ARG",
//       code: "AR",
//       shortName: "Argentina",
//       longName: "Argentina",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "EQS",
//       shortName: "Esquel",
//       longName: "Esquel",
//     },
//   },
//   PMY: {
//     iataCode: "PMY",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -42.76,
//       longitude: -65.1,
//     },
//     shortName: "Puerto Madryn Airport",
//     longName: "Puerto Madryn El Tehuelche Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "ARG",
//       code: "AR",
//       shortName: "Argentina",
//       longName: "Argentina",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "PMY",
//       shortName: "Puerto Madryn",
//       longName: "Puerto Madryn",
//     },
//   },
//   REL: {
//     iataCode: "REL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -43.21,
//       longitude: -65.27,
//     },
//     shortName: "Trelew Airport",
//     longName: "Trelew Almirante Marco Andres Zar Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "ARG",
//       code: "AR",
//       shortName: "Argentina",
//       longName: "Argentina",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "REL",
//       shortName: "Trelew",
//       longName: "Trelew",
//     },
//   },
//   COR: {
//     iataCode: "COR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -31.31,
//       longitude: -64.21,
//     },
//     shortName: "Cordoba",
//     longName: "Córdoba Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "ARG",
//       code: "AR",
//       shortName: "Argentina",
//       longName: "Argentina",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "COR",
//       shortName: "Cordoba",
//       longName: "Cordoba",
//     },
//   },
//   CNQ: {
//     iataCode: "CNQ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -27.45,
//       longitude: -58.76,
//     },
//     shortName: "Corrientes Airport",
//     longName: "Corrientes Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "ARG",
//       code: "AR",
//       shortName: "Argentina",
//       longName: "Argentina",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "CNQ",
//       shortName: "Corrientes",
//       longName: "Corrientes",
//     },
//   },
//   JUJ: {
//     iataCode: "JUJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -24.39,
//       longitude: -65.1,
//     },
//     shortName: "San Salvador de Jujuy",
//     longName: "San Salvador de Jujuy Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "ARG",
//       code: "AR",
//       shortName: "Argentina",
//       longName: "Argentina",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "JUJ",
//       shortName: "San Salvador de Jujuy",
//       longName: "San Salvador de Jujuy",
//     },
//   },
//   MDZ: {
//     iataCode: "MDZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -32.83,
//       longitude: -68.79,
//     },
//     shortName: "Mendoza Airport",
//     longName: "Mendoza El Plumerillo Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "ARG",
//       code: "AR",
//       shortName: "Argentina",
//       longName: "Argentina",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "MDZ",
//       shortName: "Mendoza",
//       longName: "Mendoza",
//     },
//   },
//   PSS: {
//     iataCode: "PSS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -27.39,
//       longitude: -55.97,
//     },
//     shortName: "Posadas Airport",
//     longName: "Posadas Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "ARG",
//       code: "AR",
//       shortName: "Argentina",
//       longName: "Argentina",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "PSS",
//       shortName: "Posadas",
//       longName: "Posadas",
//     },
//   },
//   BRC: {
//     iataCode: "BRC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -41.15,
//       longitude: -71.16,
//     },
//     shortName: "San Carlos de Bariloche",
//     longName: "San Carlos de Bariloche Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "ARG",
//       code: "AR",
//       shortName: "Argentina",
//       longName: "Argentina",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "BRC",
//       shortName: "San Carlos de Bariloche",
//       longName: "San Carlos de Bariloche",
//     },
//   },
//   SLA: {
//     iataCode: "SLA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -24.86,
//       longitude: -65.49,
//     },
//     shortName: "Salta Airport",
//     longName: "Salta Martin Miguel De Guemes Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "ARG",
//       code: "AR",
//       shortName: "Argentina",
//       longName: "Argentina",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "SLA",
//       shortName: "Salta",
//       longName: "Salta",
//     },
//   },
//   UAQ: {
//     iataCode: "UAQ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -31.57,
//       longitude: -68.42,
//     },
//     shortName: "San Juan Airport",
//     longName: "San Juan Domingo Faustino Sarmiento Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "ARG",
//       code: "AR",
//       shortName: "Argentina",
//       longName: "Argentina",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "UAQ",
//       shortName: "San Juan",
//       longName: "San Juan",
//     },
//   },
//   FTE: {
//     iataCode: "FTE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -50.28,
//       longitude: -72.05,
//     },
//     shortName: "El Calafate Airport",
//     longName: "El Calafate Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "ARG",
//       code: "AR",
//       shortName: "Argentina",
//       longName: "Argentina",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "FTE",
//       shortName: "El Calafate",
//       longName: "El Calafate",
//     },
//   },
//   ROS: {
//     iataCode: "ROS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -32.9,
//       longitude: -60.78,
//     },
//     shortName: "Rosario Airport",
//     longName: "Rosario Islas Malvinas Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "ARG",
//       code: "AR",
//       shortName: "Argentina",
//       longName: "Argentina",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "ROS",
//       shortName: "Rosario",
//       longName: "Rosario",
//     },
//   },
//   USH: {
//     iataCode: "USH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -54.84,
//       longitude: -68.3,
//     },
//     shortName: "Ushuahia Airport",
//     longName: "Ushuahia Malvinas Argentinas Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "ARG",
//       code: "AR",
//       shortName: "Argentina",
//       longName: "Argentina",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "USH",
//       shortName: "Ushuaia",
//       longName: "Ushuaia",
//     },
//   },
//   TUC: {
//     iataCode: "TUC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -26.84,
//       longitude: -65.1,
//     },
//     shortName: "San Miguel de Tucumán",
//     longName: "San Miguel de Tucumán Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "ARG",
//       code: "AR",
//       shortName: "Argentina",
//       longName: "Argentina",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "TUC",
//       shortName: "Tucumán",
//       longName: "Tucumán",
//     },
//   },
//   EZE: {
//     iataCode: "EZE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: -34.82,
//       longitude: -58.54,
//     },
//     shortName: "Buenos Aires",
//     longName: "Ministro Pistarini International Airport",
//     nearbyAirports: ["GRU"],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "ARG",
//       code: "AR",
//       shortName: "Argentina",
//       longName: "Argentina",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "BUE",
//       shortName: "Buenos Aires",
//       longName: "Buenos Aires",
//     },
//   },
//   FMA: {
//     iataCode: "FMA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -26.21,
//       longitude: -58.23,
//     },
//     shortName: "Formosa Airport",
//     longName: "Formosa Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "ARG",
//       code: "AR",
//       shortName: "Argentina",
//       longName: "Argentina",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "FMA",
//       shortName: "Formosa",
//       longName: "Formosa",
//     },
//   },
//   NQN: {
//     iataCode: "NQN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -38.95,
//       longitude: -68.16,
//     },
//     shortName: "Neuquen Airport",
//     longName: "Neuquen Presidente Peron Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "ARG",
//       code: "AR",
//       shortName: "Argentina",
//       longName: "Argentina",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "NQN",
//       shortName: "Neuquen",
//       longName: "Neuquen",
//     },
//   },
//   IGR: {
//     iataCode: "IGR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -25.74,
//       longitude: -54.47,
//     },
//     shortName: "Puerto Iguazu Airport",
//     longName: "Cataratas Del Iguazú International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "ARG",
//       code: "AR",
//       shortName: "Argentina",
//       longName: "Argentina",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "IGR",
//       shortName: "Puerto Iguazu",
//       longName: "Puerto Iguazu",
//     },
//   },
//   RGL: {
//     iataCode: "RGL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -51.61,
//       longitude: -69.31,
//     },
//     shortName: "Rio Gallegos Airport",
//     longName: "Rio Gallegos Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "ARG",
//       code: "AR",
//       shortName: "Argentina",
//       longName: "Argentina",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "RGL",
//       shortName: "Rio Gallegos",
//       longName: "Rio Gallegos",
//     },
//   },
//   RGA: {
//     iataCode: "RGA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -53.78,
//       longitude: -67.75,
//     },
//     shortName: "Rio Grande Airport",
//     longName: "Rio Grande Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "ARG",
//       code: "AR",
//       shortName: "Argentina",
//       longName: "Argentina",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "RGA",
//       shortName: "Rio Grande",
//       longName: "Rio Grande",
//     },
//   },
//   CPC: {
//     iataCode: "CPC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -40.08,
//       longitude: -71.14,
//     },
//     shortName: "San Martin de los Andes Airport",
//     longName: "San Martin de los Andes Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "ARG",
//       code: "AR",
//       shortName: "Argentina",
//       longName: "Argentina",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "CPC",
//       shortName: "San Martin de los Andes",
//       longName: "San Martin de los Andes",
//     },
//   },
//   AUA: {
//     iataCode: "AUA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 12.5,
//       longitude: -70.02,
//     },
//     shortName: "Aruba",
//     longName: "Reina Beatrix Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "ABW",
//       code: "AW",
//       shortName: "Aruba",
//       longName: "Aruba",
//     },
//     city: {
//       code: "AUA",
//       shortName: "Aruba",
//       longName: "Aruba",
//     },
//   },
//   NAS: {
//     iataCode: "NAS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 25.04,
//       longitude: -77.47,
//     },
//     shortName: "Nassau",
//     longName: "Nassau International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BHS",
//       code: "BS",
//       shortName: "Bahamas",
//       longName: "Bahamas",
//     },
//     city: {
//       code: "NAS",
//       shortName: "Nassau",
//       longName: "Nassau",
//     },
//   },
//   BGI: {
//     iataCode: "BGI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 13.07,
//       longitude: -59.49,
//     },
//     shortName: "Bridgetown",
//     longName: "Grantley Adams International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRB",
//       code: "BB",
//       shortName: "Barbados",
//       longName: "Barbados",
//     },
//     city: {
//       code: "BGI",
//       shortName: "Bridgetown",
//       longName: "Bridgetown",
//     },
//   },
//   BDA: {
//     iataCode: "BDA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 32.36,
//       longitude: -64.68,
//     },
//     shortName: "Bermuda",
//     longName: "Bermuda International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BMU",
//       code: "BM",
//       shortName: "Bermuda",
//       longName: "Bermuda",
//     },
//     city: {
//       code: "BDA",
//       shortName: "Bermuda",
//       longName: "Bermuda",
//     },
//   },
//   CBB: {
//     iataCode: "CBB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -17.42,
//       longitude: -66.18,
//     },
//     shortName: "Cochabamba Airport",
//     longName: "Cochabamba Jorge Wilsterman International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BOL",
//       code: "BO",
//       shortName: "Bolivia",
//       longName: "Bolivia",
//     },
//     city: {
//       code: "CBB",
//       shortName: "Cochabamba",
//       longName: "Cochabamba",
//     },
//   },
//   LPB: {
//     iataCode: "LPB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -16.51,
//       longitude: -68.19,
//     },
//     shortName: "La Paz Airport",
//     longName: "La Paz El Alto International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BOL",
//       code: "BO",
//       shortName: "Bolivia",
//       longName: "Bolivia",
//     },
//     city: {
//       code: "LPB",
//       shortName: "La Paz",
//       longName: "La Paz",
//     },
//   },
//   VVI: {
//     iataCode: "VVI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -17.64,
//       longitude: -63.14,
//     },
//     shortName: "Santacruz Airport",
//     longName: "Santacruz Viru Viru Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BOL",
//       code: "BO",
//       shortName: "Bolivia",
//       longName: "Bolivia",
//     },
//     city: {
//       code: "SRZ",
//       shortName: "Santacruz",
//       longName: "Santacruz",
//     },
//   },
//   MCZ: {
//     iataCode: "MCZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -9.52,
//       longitude: -35.78,
//     },
//     shortName: "Maceió",
//     longName: "Zumbi dos Palmares Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "MCZ",
//       shortName: "Maceió",
//       longName: "Maceió",
//     },
//   },
//   MAO: {
//     iataCode: "MAO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -3.04,
//       longitude: -60.05,
//     },
//     shortName: "Manaus",
//     longName: "Eduardo Gomes International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "MAO",
//       shortName: "Manaus",
//       longName: "Manaus",
//     },
//   },
//   SLZ: {
//     iataCode: "SLZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -2.59,
//       longitude: -44.24,
//     },
//     shortName: "São Luis",
//     longName: "Marechal Cunha Machado International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "SLZ",
//       shortName: "São Luis",
//       longName: "São Luis",
//     },
//   },
//   IOS: {
//     iataCode: "IOS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -14.81,
//       longitude: -39.03,
//     },
//     shortName: "Ilheus Airport",
//     longName: "Jorge Amado Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "IOS",
//       shortName: "Ilhéus",
//       longName: "Ilhéus",
//     },
//   },
//   SSA: {
//     iataCode: "SSA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -12.91,
//       longitude: -38.32,
//     },
//     shortName: "Salvador",
//     longName: "Dep. Luis E. Magalhães International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "SSA",
//       shortName: "Salvador",
//       longName: "Salvador",
//     },
//   },
//   VDC: {
//     iataCode: "VDC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -14.86,
//       longitude: -40.86,
//     },
//     shortName: "Vitória Da Conquista Airport",
//     longName: "Vitória Da Conquista Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "VDC",
//       shortName: "Vitória Da Conquista",
//       longName: "Vitória Da Conquista",
//     },
//   },
//   FOR: {
//     iataCode: "FOR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -3.78,
//       longitude: -38.53,
//     },
//     shortName: "Fortaleza",
//     longName: "Pinto Martins International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "FOR",
//       shortName: "Fortaleza",
//       longName: "Fortaleza",
//     },
//   },
//   JJD: {
//     iataCode: "JJD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -2.91,
//       longitude: -40.36,
//     },
//     shortName: "Jericoacoara Airport",
//     longName: "Jericoacoara Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "JJD",
//       shortName: "Jijoca de Jericoacoara",
//       longName: "Jijoca de Jericoacoara",
//     },
//   },
//   BSB: {
//     iataCode: "BSB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -15.87,
//       longitude: -47.92,
//     },
//     shortName: "Brasilia",
//     longName: "Brasília International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "BSB",
//       shortName: "Brasilia",
//       longName: "Brasilia",
//     },
//   },
//   VIX: {
//     iataCode: "VIX",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -20.26,
//       longitude: -40.29,
//     },
//     shortName: "Vitória",
//     longName: "Goiabeiras Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "VIX",
//       shortName: "Vitória",
//       longName: "Vitória",
//     },
//   },
//   GYN: {
//     iataCode: "GYN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -16.63,
//       longitude: -49.23,
//     },
//     shortName: "Goiânia",
//     longName: "Santa Genoveva Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "GYN",
//       shortName: "Goiânia",
//       longName: "Goiânia",
//     },
//   },
//   MCP: {
//     iataCode: "MCP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 0.05,
//       longitude: -51.07,
//     },
//     shortName: "Macapa Airport",
//     longName: "Macapá-Alberto Alcolumbre Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "MCP",
//       shortName: "Macapa",
//       longName: "Macapa",
//     },
//   },
//   IMP: {
//     iataCode: "IMP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -5.53,
//       longitude: -47.46,
//     },
//     shortName: "Imperatriz Airport",
//     longName: "Imperatriz Prefeito Renato Moreira Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "IMP",
//       shortName: "Imperatriz",
//       longName: "Imperatriz",
//     },
//   },
//   CGB: {
//     iataCode: "CGB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -15.65,
//       longitude: -56.12,
//     },
//     shortName: "Cuiabá",
//     longName: "Marechal Rondon International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "CGB",
//       shortName: "Cuiabá",
//       longName: "Cuiabá",
//     },
//   },
//   CGR: {
//     iataCode: "CGR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -20.47,
//       longitude: -54.67,
//     },
//     shortName: "Campo Grande",
//     longName: "Campo Grande International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "CGR",
//       shortName: "Campo Grande",
//       longName: "Campo Grande",
//     },
//   },
//   DOU: {
//     iataCode: "DOU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -22.2,
//       longitude: -54.93,
//     },
//     shortName: "Dourados Airport",
//     longName: "Dourados Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "DOU",
//       shortName: "Dourados",
//       longName: "Dourados",
//     },
//   },
//   OPS: {
//     iataCode: "OPS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -11.89,
//       longitude: -55.59,
//     },
//     shortName: "Sinop Airport",
//     longName: "Sinop Presidente João Batista Figueiredo Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "OPS",
//       shortName: "Sinop",
//       longName: "Sinop",
//     },
//   },
//   CNF: {
//     iataCode: "CNF",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -19.62,
//       longitude: -43.97,
//     },
//     shortName: "Belo Horizonte",
//     longName: "Confins International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "CNF",
//       shortName: "Belo Horizonte",
//       longName: "Belo Horizonte",
//     },
//   },
//   UDI: {
//     iataCode: "UDI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -18.88,
//       longitude: -48.23,
//     },
//     shortName: "Uberlândia",
//     longName: "Uberlândia Airport/Ten Cesar Bombonato",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "UDI",
//       shortName: "Uberlândia",
//       longName: "Uberlândia",
//     },
//   },
//   BEL: {
//     iataCode: "BEL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -1.38,
//       longitude: -48.48,
//     },
//     shortName: "Belém",
//     longName: "Val de Caes International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "BEL",
//       shortName: "Belém",
//       longName: "Belém",
//     },
//   },
//   JPA: {
//     iataCode: "JPA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -7.15,
//       longitude: -34.95,
//     },
//     shortName: "João Pessoa",
//     longName: "Presidente Castro Pinto International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "JPA",
//       shortName: "João Pessoa",
//       longName: "João Pessoa",
//     },
//   },
//   CAC: {
//     iataCode: "CAC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -25,
//       longitude: -53.5,
//     },
//     shortName: "Cascavel Airport",
//     longName: "Cascavel Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "CAC",
//       shortName: "Cascavel",
//       longName: "Cascavel",
//     },
//   },
//   CWB: {
//     iataCode: "CWB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -25.53,
//       longitude: -49.18,
//     },
//     shortName: "Curitiba",
//     longName: "Afonso Pena International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "CWB",
//       shortName: "Curitiba",
//       longName: "Curitiba",
//     },
//   },
//   IGU: {
//     iataCode: "IGU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -25.6,
//       longitude: -54.48,
//     },
//     shortName: "Foz do Iguaçu",
//     longName: "Foz do Iguaçu/Cataratas International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "IGU",
//       shortName: "Foz do Iguaçu",
//       longName: "Foz do Iguaçu",
//     },
//   },
//   LDB: {
//     iataCode: "LDB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -23.33,
//       longitude: -51.14,
//     },
//     shortName: "Londrina",
//     longName: "Londrina Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "LDB",
//       shortName: "Londrina",
//       longName: "Londrina",
//     },
//   },
//   MGF: {
//     iataCode: "MGF",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -23.48,
//       longitude: -52.01,
//     },
//     shortName: "Maringá",
//     longName: "Maringá Domestic Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "MGF",
//       shortName: "Maringá",
//       longName: "Maringá",
//     },
//   },
//   REC: {
//     iataCode: "REC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -8.13,
//       longitude: -34.92,
//     },
//     shortName: "Recife",
//     longName: "Guararapes International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "REC",
//       shortName: "Recife",
//       longName: "Recife",
//     },
//   },
//   PNZ: {
//     iataCode: "PNZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -9.36,
//       longitude: -40.57,
//     },
//     shortName: "Petrolina Airport",
//     longName: "Petrolina–Senador Nilo Coelho Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "PNZ",
//       shortName: "Petrolina",
//       longName: "Petrolina",
//     },
//   },
//   BPS: {
//     iataCode: "BPS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -16.44,
//       longitude: -39.08,
//     },
//     shortName: "Porto Seguro Airport",
//     longName: "Porto Seguro Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "BPS",
//       shortName: "Porto Seguro",
//       longName: "Porto Seguro",
//     },
//   },
//   NAT: {
//     iataCode: "NAT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -5.91,
//       longitude: -35.25,
//     },
//     shortName: "Natal",
//     longName: "Augusto Severo International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "NAT",
//       shortName: "Natal",
//       longName: "Natal",
//     },
//   },
//   PFB: {
//     iataCode: "PFB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -28.24,
//       longitude: -52.33,
//     },
//     shortName: "Passo Fundo Airport",
//     longName: "Passo Fundo Lauro Kurtz Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "PFB",
//       shortName: "Passo Fundo",
//       longName: "Passo Fundo",
//     },
//   },
//   POA: {
//     iataCode: "POA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -29.99,
//       longitude: -51.17,
//     },
//     shortName: "Porto Alegre",
//     longName: "Salgado Filho International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "POA",
//       shortName: "Porto Alegre",
//       longName: "Porto Alegre",
//     },
//   },
//   GIG: {
//     iataCode: "GIG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: -22.81,
//       longitude: -43.25,
//     },
//     shortName: "Rio de Janeiro",
//     longName: "Antônio Carlos Jobim International Airport (Galeão)",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "RIO",
//       shortName: "Rio de Janeiro",
//       longName: "Rio de Janeiro",
//     },
//   },
//   SDU: {
//     iataCode: "SDU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -22.91,
//       longitude: -43.16,
//     },
//     shortName: "Rio De Janeiro Santos Dumont Airport",
//     longName: "Rio De Janeiro Santos Dumont Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "RIO",
//       shortName: "Rio de Janeiro",
//       longName: "Rio de Janeiro",
//     },
//   },
//   PVH: {
//     iataCode: "PVH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -8.71,
//       longitude: -63.9,
//     },
//     shortName: "Porto Velho Airport",
//     longName: "Porto Velho Governador Jorge Teixeira De Oliveira Airport ",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "PVH",
//       shortName: "Porto Velho",
//       longName: "Porto Velho",
//     },
//   },
//   XAP: {
//     iataCode: "XAP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -27.13,
//       longitude: -52.66,
//     },
//     shortName: "Chapecó Airport",
//     longName: "Chapecó Serafin Enoss Bertaso Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "XAP",
//       shortName: "Chapecó",
//       longName: "Chapecó",
//     },
//   },
//   FLN: {
//     iataCode: "FLN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -27.67,
//       longitude: -48.55,
//     },
//     shortName: "Florianópolis",
//     longName: "Hercilio Luz International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "FLN",
//       shortName: "Florianópolis",
//       longName: "Florianópolis",
//     },
//   },
//   JOI: {
//     iataCode: "JOI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -26.22,
//       longitude: -48.8,
//     },
//     shortName: "Joinville Airport",
//     longName: "Joinville-Lauro Carneiro de Loyola Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "JOI",
//       shortName: "Joinville",
//       longName: "Joinville",
//     },
//   },
//   NVT: {
//     iataCode: "NVT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -26.88,
//       longitude: -48.65,
//     },
//     shortName: "Navegantes",
//     longName: "Ministro Victor Konder International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "NVT",
//       shortName: "Navegantes",
//       longName: "Navegantes",
//     },
//   },
//   AJU: {
//     iataCode: "AJU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -10.99,
//       longitude: -37.07,
//     },
//     shortName: "Aracajú",
//     longName: "Santa Maria Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "AJU",
//       shortName: "Aracajú",
//       longName: "Aracajú",
//     },
//   },
//   PPB: {
//     iataCode: "PPB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -22.18,
//       longitude: -51.42,
//     },
//     shortName: "Presidente Prudente Airport",
//     longName: "Presidente Prudente Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "PPB",
//       shortName: "Presidente Prudente",
//       longName: "Presidente Prudente",
//     },
//   },
//   RAO: {
//     iataCode: "RAO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -21.14,
//       longitude: -47.78,
//     },
//     shortName: "Ribeirão Preto",
//     longName: "Leite Lopes Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "RAO",
//       shortName: "Ribeirão Preto",
//       longName: "Ribeirão Preto",
//     },
//   },
//   SJP: {
//     iataCode: "SJP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -20.82,
//       longitude: -49.4,
//     },
//     shortName: "São José do Rio Preto",
//     longName: "São José do Rio Preto Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "SJP",
//       shortName: "São José do Rio Preto",
//       longName: "São José do Rio Preto",
//     },
//   },
//   GRU: {
//     iataCode: "GRU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: -23.44,
//       longitude: -46.47,
//     },
//     shortName: "São Paulo",
//     longName: "Guarulhos International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "SAO",
//       shortName: "São Paulo",
//       longName: "São Paulo",
//     },
//   },
//   THE: {
//     iataCode: "THE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -5.06,
//       longitude: -42.82,
//     },
//     shortName: "Teresina Airport",
//     longName: "Teresina–Senador Petrônio Portella Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "THE",
//       shortName: "Teresina",
//       longName: "Teresina",
//     },
//   },
//   CPV: {
//     iataCode: "CPV",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -7.27,
//       longitude: -35.9,
//     },
//     shortName: "Campina Grande Airport",
//     longName: "Campina Grande Presidente João Suassuna Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "CPV",
//       shortName: "Campina Grande",
//       longName: "Campina Grande",
//     },
//   },
//   CXJ: {
//     iataCode: "CXJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -29.2,
//       longitude: -51.19,
//     },
//     shortName: "Caxias Do Sul Airport",
//     longName: "Caxias Do Sul Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "CXJ",
//       shortName: "Caxias Do Sul",
//       longName: "Caxias Do Sul",
//     },
//   },
//   JJG: {
//     iataCode: "JJG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -28.68,
//       longitude: -49.06,
//     },
//     shortName: "Jaguaruna Airport",
//     longName: "Jaguaruna Regional Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "JJG",
//       shortName: "Jaguaruna",
//       longName: "Jaguaruna",
//     },
//   },
//   JDO: {
//     iataCode: "JDO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -7.22,
//       longitude: -39.27,
//     },
//     shortName: "Juazeiro Do Norte Airport",
//     longName: "Juazeiro Do Norte Orlando Bezerra De Menezes Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "JDO",
//       shortName: "Juazeiro Do Norte",
//       longName: "Juazeiro Do Norte",
//     },
//   },
//   MOC: {
//     iataCode: "MOC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -16.71,
//       longitude: -43.82,
//     },
//     shortName: "Montes Claros Airport",
//     longName: "Montes Claros Mário Ribeiro Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "MOC",
//       shortName: "Montes Claros",
//       longName: "Montes Claros",
//     },
//   },
//   PMW: {
//     iataCode: "PMW",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -10.29,
//       longitude: -48.36,
//     },
//     shortName: "Palmas Airport",
//     longName: "Palmas Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "PMW",
//       shortName: "Palmas",
//       longName: "Palmas",
//     },
//   },
//   PET: {
//     iataCode: "PET",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -31.72,
//       longitude: -52.33,
//     },
//     shortName: "Pelotas Airport",
//     longName: "Pelotas João Simões Lopes Neto International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "PET",
//       shortName: "Pelotas",
//       longName: "Pelotas",
//     },
//   },
//   QNS: {
//     iataCode: "QNS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -29.95,
//       longitude: -51.14,
//     },
//     shortName: "Canoas Airport",
//     longName: "Canoas Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "QNS",
//       shortName: "Porto Alegre Canoas",
//       longName: "Porto Alegre Canoas",
//     },
//   },
//   GEL: {
//     iataCode: "GEL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -28.28,
//       longitude: -54.17,
//     },
//     shortName: "Santo Ângelo Airport",
//     longName: "Santo Ângelo Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "BRA",
//       code: "BR",
//       shortName: "Brazil",
//       longName: "Brazil",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "GEL",
//       shortName: "Santo Ângelo",
//       longName: "Santo Ângelo",
//     },
//   },
//   YYC: {
//     iataCode: "YYC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 51.11,
//       longitude: -114.02,
//     },
//     shortName: "Calgary",
//     longName: "Calgary International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "CAN",
//       code: "CA",
//       shortName: "Canada",
//       longName: "Canada",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "YYC",
//       shortName: "Calgary",
//       longName: "Calgary",
//     },
//   },
//   YEG: {
//     iataCode: "YEG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 53.31,
//       longitude: -113.58,
//     },
//     shortName: "Edmonton",
//     longName: "Edmonton International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "CAN",
//       code: "CA",
//       shortName: "Canada",
//       longName: "Canada",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "YEG",
//       shortName: "Edmonton",
//       longName: "Edmonton",
//     },
//   },
//   YMM: {
//     iataCode: "YMM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 56.65,
//       longitude: -111.22,
//     },
//     shortName: "Fort McMurray Airport",
//     longName: "Fort McMurray International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "CAN",
//       code: "CA",
//       shortName: "Canada",
//       longName: "Canada",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "YMM",
//       shortName: "Fort McMurray",
//       longName: "Fort McMurray",
//     },
//   },
//   YQU: {
//     iataCode: "YQU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 55.18,
//       longitude: -118.89,
//     },
//     shortName: "Grande Prairie Airport",
//     longName: "Grande Prairie Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "CAN",
//       code: "CA",
//       shortName: "Canada",
//       longName: "Canada",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "YQU",
//       shortName: "Grande Prairie",
//       longName: "Grande Prairie",
//     },
//   },
//   YVG: {
//     iataCode: "YVG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 53.36,
//       longitude: -110.82,
//     },
//     shortName: "Vermilion Airport",
//     longName: "Vermilion Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "CAN",
//       code: "CA",
//       shortName: "Canada",
//       longName: "Canada",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "YVG",
//       shortName: "Vermilion",
//       longName: "Vermilion",
//     },
//   },
//   YQQ: {
//     iataCode: "YQQ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 49.71,
//       longitude: -124.89,
//     },
//     shortName: "Comox Airport",
//     longName: "Comox Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "CAN",
//       code: "CA",
//       shortName: "Canada",
//       longName: "Canada",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "YQQ",
//       shortName: "Comox",
//       longName: "Comox",
//     },
//   },
//   YKA: {
//     iataCode: "YKA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 50.7,
//       longitude: -120.44,
//     },
//     shortName: "Kamloops Airport",
//     longName: "Kamloops Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "CAN",
//       code: "CA",
//       shortName: "Canada",
//       longName: "Canada",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "YKA",
//       shortName: "Kamloops",
//       longName: "Kamloops",
//     },
//   },
//   YLW: {
//     iataCode: "YLW",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 49.96,
//       longitude: -119.38,
//     },
//     shortName: "Kelowna",
//     longName: "Kelowna International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "CAN",
//       code: "CA",
//       shortName: "Canada",
//       longName: "Canada",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "YLW",
//       shortName: "Kelowna",
//       longName: "Kelowna",
//     },
//   },
//   YVR: {
//     iataCode: "YVR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 49.19,
//       longitude: -123.18,
//     },
//     shortName: "Vancouver",
//     longName: "Vancouver International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "CAN",
//       code: "CA",
//       shortName: "Canada",
//       longName: "Canada",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "YVR",
//       shortName: "Vancouver",
//       longName: "Vancouver",
//     },
//   },
//   YYJ: {
//     iataCode: "YYJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 48.65,
//       longitude: -123.43,
//     },
//     shortName: "Victoria",
//     longName: "Victoria International",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "CAN",
//       code: "CA",
//       shortName: "Canada",
//       longName: "Canada",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "YYJ",
//       shortName: "Victoria",
//       longName: "Victoria",
//     },
//   },
//   YWG: {
//     iataCode: "YWG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 49.91,
//       longitude: -97.24,
//     },
//     shortName: "Winnipeg",
//     longName: "Winnipeg International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "CAN",
//       code: "CA",
//       shortName: "Canada",
//       longName: "Canada",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "YWG",
//       shortName: "Winnipeg",
//       longName: "Winnipeg",
//     },
//   },
//   YQM: {
//     iataCode: "YQM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 46.11,
//       longitude: -64.68,
//     },
//     shortName: "Moncton Airport",
//     longName: "Greater Moncton International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "CAN",
//       code: "CA",
//       shortName: "Canada",
//       longName: "Canada",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "YQM",
//       shortName: "Moncton",
//       longName: "Moncton",
//     },
//   },
//   YDF: {
//     iataCode: "YDF",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 49.21,
//       longitude: -57.39,
//     },
//     shortName: "Deer Lake Airport",
//     longName: "Deer Lake Regional Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "CAN",
//       code: "CA",
//       shortName: "Canada",
//       longName: "Canada",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "YDF",
//       shortName: "Deer Lake",
//       longName: "Deer Lake",
//     },
//   },
//   YQX: {
//     iataCode: "YQX",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 48.94,
//       longitude: -54.57,
//     },
//     shortName: "Gander Airport",
//     longName: "Gander International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "CAN",
//       code: "CA",
//       shortName: "Canada",
//       longName: "Canada",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "YQX",
//       shortName: "Gander",
//       longName: "Gander",
//     },
//   },
//   YYT: {
//     iataCode: "YYT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 47.62,
//       longitude: -52.75,
//     },
//     shortName: "St. John's Airport",
//     longName: "St. John's International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "CAN",
//       code: "CA",
//       shortName: "Canada",
//       longName: "Canada",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "YYT",
//       shortName: "Saint Johns",
//       longName: "Saint Johns",
//     },
//   },
//   YHZ: {
//     iataCode: "YHZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 44.88,
//       longitude: -63.51,
//     },
//     shortName: "Halifax",
//     longName: "Halifax International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "CAN",
//       code: "CA",
//       shortName: "Canada",
//       longName: "Canada",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "YHZ",
//       shortName: "Halifax",
//       longName: "Halifax",
//     },
//   },
//   YQY: {
//     iataCode: "YQY",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 46.16,
//       longitude: -60.05,
//     },
//     shortName: "Sydney Nova Scotia Airport",
//     longName: "Sydney Nova Scotia J.A. Douglas McCurdy Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "CAN",
//       code: "CA",
//       shortName: "Canada",
//       longName: "Canada",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "YQY",
//       shortName: "Sydney",
//       longName: "Sydney",
//     },
//   },
//   YOW: {
//     iataCode: "YOW",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 45.32,
//       longitude: -75.67,
//     },
//     shortName: "Ottawa",
//     longName: "Ottawa Macdonald-Cartier International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "CAN",
//       code: "CA",
//       shortName: "Canada",
//       longName: "Canada",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "YOW",
//       shortName: "Ottawa",
//       longName: "Ottawa",
//     },
//   },
//   YAM: {
//     iataCode: "YAM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 46.49,
//       longitude: -84.51,
//     },
//     shortName: "Sault Ste. Marie Airport",
//     longName: "Sault Ste. Marie Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "CAN",
//       code: "CA",
//       shortName: "Canada",
//       longName: "Canada",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "YAM",
//       shortName: "Saulte Ste Marie",
//       longName: "Saulte Ste Marie",
//     },
//   },
//   YSB: {
//     iataCode: "YSB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 46.63,
//       longitude: -80.8,
//     },
//     shortName: "Sudbury Airport",
//     longName: "Sudbury Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "CAN",
//       code: "CA",
//       shortName: "Canada",
//       longName: "Canada",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "YSB",
//       shortName: "Sudbury",
//       longName: "Sudbury",
//     },
//   },
//   YQT: {
//     iataCode: "YQT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 48.37,
//       longitude: -89.32,
//     },
//     shortName: "Thunder Bay Airport",
//     longName: "Thunder Bay Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "CAN",
//       code: "CA",
//       shortName: "Canada",
//       longName: "Canada",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "YQT",
//       shortName: "Thunder Bay",
//       longName: "Thunder Bay",
//     },
//   },
//   YTS: {
//     iataCode: "YTS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 48.57,
//       longitude: -81.38,
//     },
//     shortName: "Timmins Airport",
//     longName: "Timmins Victor M. Power Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "CAN",
//       code: "CA",
//       shortName: "Canada",
//       longName: "Canada",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "YTS",
//       shortName: "Timmins",
//       longName: "Timmins",
//     },
//   },
//   YTZ: {
//     iataCode: "YTZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.63,
//       longitude: -79.4,
//     },
//     shortName: "Toronto City Airport",
//     longName: "Billy Bishop Toronto City Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "CAN",
//       code: "CA",
//       shortName: "Canada",
//       longName: "Canada",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "YTO",
//       shortName: "Toronto",
//       longName: "Toronto",
//     },
//   },
//   YYZ: {
//     iataCode: "YYZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 43.68,
//       longitude: -79.63,
//     },
//     shortName: "Toronto",
//     longName: "Pearson International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "CAN",
//       code: "CA",
//       shortName: "Canada",
//       longName: "Canada",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "YTO",
//       shortName: "Toronto",
//       longName: "Toronto",
//     },
//   },
//   YQG: {
//     iataCode: "YQG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 42.28,
//       longitude: -82.96,
//     },
//     shortName: "Windsor  Airport",
//     longName: "Windsor International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "CAN",
//       code: "CA",
//       shortName: "Canada",
//       longName: "Canada",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "YQG",
//       shortName: "Windsor",
//       longName: "Windsor",
//     },
//   },
//   YYG: {
//     iataCode: "YYG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 46.29,
//       longitude: -63.12,
//     },
//     shortName: "Charlottetown Airport",
//     longName: "Charlottetown Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "CAN",
//       code: "CA",
//       shortName: "Canada",
//       longName: "Canada",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "YYG",
//       shortName: "Charlottetown",
//       longName: "Charlottetown",
//     },
//   },
//   YTM: {
//     iataCode: "YTM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 46.41,
//       longitude: -74.78,
//     },
//     shortName: "Mont Tremblant Airport",
//     longName: "La Macaza – Mont Tremblant Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "CAN",
//       code: "CA",
//       shortName: "Canada",
//       longName: "Canada",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "YTM",
//       shortName: "Mont Tremblant",
//       longName: "Mont Tremblant",
//     },
//   },
//   YUL: {
//     iataCode: "YUL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 45.47,
//       longitude: -73.74,
//     },
//     shortName: "Montréal",
//     longName: "Pierre Elliott Trudeau International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "CAN",
//       code: "CA",
//       shortName: "Canada",
//       longName: "Canada",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "YMQ",
//       shortName: "Montréal",
//       longName: "Montréal",
//     },
//   },
//   YQB: {
//     iataCode: "YQB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 46.79,
//       longitude: -71.39,
//     },
//     shortName: "Quebec Airport",
//     longName: "Quebec City Jean Lesage International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "CAN",
//       code: "CA",
//       shortName: "Canada",
//       longName: "Canada",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "YQB",
//       shortName: "Quebec",
//       longName: "Quebec",
//     },
//   },
//   YQR: {
//     iataCode: "YQR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 50.43,
//       longitude: -104.67,
//     },
//     shortName: "Regina",
//     longName: "Regina International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "CAN",
//       code: "CA",
//       shortName: "Canada",
//       longName: "Canada",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "YQR",
//       shortName: "Regina",
//       longName: "Regina",
//     },
//   },
//   YXE: {
//     iataCode: "YXE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 52.17,
//       longitude: -106.7,
//     },
//     shortName: "Saskatoon  Airport",
//     longName: "Saskatoon John G. Diefenbaker International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "CAN",
//       code: "CA",
//       shortName: "Canada",
//       longName: "Canada",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "YXE",
//       shortName: "Saskatoon",
//       longName: "Saskatoon",
//     },
//   },
//   YFC: {
//     iataCode: "YFC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 45.87,
//       longitude: -66.54,
//     },
//     shortName: "Fredericton Airport",
//     longName: "Fredericton Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "CAN",
//       code: "CA",
//       shortName: "Canada",
//       longName: "Canada",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "YFC",
//       shortName: "Fredericton",
//       longName: "Fredericton",
//     },
//   },
//   YSJ: {
//     iataCode: "YSJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 45.32,
//       longitude: -65.89,
//     },
//     shortName: "Saint John Airport",
//     longName: "Saint John Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "CAN",
//       code: "CA",
//       shortName: "Canada",
//       longName: "Canada",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "YSJ",
//       shortName: "Saint John",
//       longName: "Saint John",
//     },
//   },
//   CYB: {
//     iataCode: "CYB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 19.69,
//       longitude: -79.88,
//     },
//     shortName: "Cayman Brac Airport",
//     longName: "Cayman Brac Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "CYM",
//       code: "KY",
//       shortName: "Cayman Islands",
//       longName: "Cayman Islands",
//     },
//     city: {
//       code: "CYB",
//       shortName: "Cayman Brac",
//       longName: "Cayman Brac",
//     },
//   },
//   GCM: {
//     iataCode: "GCM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 19.29,
//       longitude: -81.36,
//     },
//     shortName: "Grand Cayman Airport",
//     longName: "Cayman Islands Owen Roberts Int. Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "CYM",
//       code: "KY",
//       shortName: "Cayman Islands",
//       longName: "Cayman Islands",
//     },
//     city: {
//       code: "GCM",
//       shortName: "Grand Cayman",
//       longName: "Grand Cayman",
//     },
//   },
//   SCL: {
//     iataCode: "SCL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: -33.39,
//       longitude: -70.79,
//     },
//     shortName: "Santiago De Chile",
//     longName: "Comodoro Arturo Merino Benítez International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "CHL",
//       code: "CL",
//       shortName: "Chile",
//       longName: "Chile",
//       otherRegion: {
//         shortName: "South America",
//         longName: "South America",
//       },
//     },
//     city: {
//       code: "SCL",
//       shortName: "Santiago de Chile",
//       longName: "Santiago de Chile",
//     },
//   },
//   BAQ: {
//     iataCode: "BAQ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 10.89,
//       longitude: -74.78,
//     },
//     shortName: "Barranquilla Airport",
//     longName: "Barranquilla Ernesto Cortissoz Int Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "COL",
//       code: "CO",
//       shortName: "Colombia",
//       longName: "Colombia",
//     },
//     city: {
//       code: "BAQ",
//       shortName: "Barranquilla",
//       longName: "Barranquilla",
//     },
//   },
//   BGA: {
//     iataCode: "BGA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 7.13,
//       longitude: -73.18,
//     },
//     shortName: "Bucaramanga Airport",
//     longName: "Bucaramanga Palonegro Int Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "COL",
//       code: "CO",
//       shortName: "Colombia",
//       longName: "Colombia",
//     },
//     city: {
//       code: "BGA",
//       shortName: "Bucaramanga",
//       longName: "Bucaramanga",
//     },
//   },
//   BOG: {
//     iataCode: "BOG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 4.7,
//       longitude: -74.15,
//     },
//     shortName: "Bogotá",
//     longName: "El Dorado International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "COL",
//       code: "CO",
//       shortName: "Colombia",
//       longName: "Colombia",
//     },
//     city: {
//       code: "BOG",
//       shortName: "Bogotá",
//       longName: "Bogotá",
//     },
//   },
//   CLO: {
//     iataCode: "CLO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 3.54,
//       longitude: -76.38,
//     },
//     shortName: "Cali",
//     longName: "Alfonso Bonilla Aragón International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "COL",
//       code: "CO",
//       shortName: "Colombia",
//       longName: "Colombia",
//     },
//     city: {
//       code: "CLO",
//       shortName: "Cali",
//       longName: "Cali",
//     },
//   },
//   CTG: {
//     iataCode: "CTG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 10.44,
//       longitude: -75.51,
//     },
//     shortName: "Cartagena Airport",
//     longName: "Cartagena Rafael Núñez Int Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "COL",
//       code: "CO",
//       shortName: "Colombia",
//       longName: "Colombia",
//     },
//     city: {
//       code: "CTG",
//       shortName: "Cartagena",
//       longName: "Cartagena",
//     },
//   },
//   CUC: {
//     iataCode: "CUC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 7.93,
//       longitude: -72.51,
//     },
//     shortName: "Cúcuta Airport",
//     longName: "Cúcuta Camilo Daza Int Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "COL",
//       code: "CO",
//       shortName: "Colombia",
//       longName: "Colombia",
//     },
//     city: {
//       code: "CUC",
//       shortName: "Cúcuta",
//       longName: "Cúcuta",
//     },
//   },
//   MDE: {
//     iataCode: "MDE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 6.16,
//       longitude: -75.42,
//     },
//     shortName: "Medellin",
//     longName: "José María Córdova International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "COL",
//       code: "CO",
//       shortName: "Colombia",
//       longName: "Colombia",
//     },
//     city: {
//       code: "MDE",
//       shortName: "Medellín",
//       longName: "Medellín",
//     },
//   },
//   PEI: {
//     iataCode: "PEI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 4.81,
//       longitude: -75.74,
//     },
//     shortName: "Pereira Airport",
//     longName: "Pereira Matecaña Int Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "COL",
//       code: "CO",
//       shortName: "Colombia",
//       longName: "Colombia",
//     },
//     city: {
//       code: "PEI",
//       shortName: "Pereira",
//       longName: "Pereira",
//     },
//   },
//   ADZ: {
//     iataCode: "ADZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 12.58,
//       longitude: -81.71,
//     },
//     shortName: "San Andrés Airport",
//     longName: "San Andrés Gustavo Rojas Pinilla Int Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "COL",
//       code: "CO",
//       shortName: "Colombia",
//       longName: "Colombia",
//     },
//     city: {
//       code: "ADZ",
//       shortName: "San Andrés Island",
//       longName: "San Andrés Island",
//     },
//   },
//   CMW: {
//     iataCode: "CMW",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 21.42,
//       longitude: -77.85,
//     },
//     shortName: "Camaguey Airport",
//     longName: "Camaguey Ignacio Agramonte International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "CRI",
//       code: "CR",
//       shortName: "Costa Rica",
//       longName: "Costa Rica",
//     },
//     city: {
//       code: "CMW",
//       shortName: "Camaguey",
//       longName: "Camaguey",
//     },
//   },
//   LIR: {
//     iataCode: "LIR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 10.59,
//       longitude: -85.54,
//     },
//     shortName: "Liberia Airport",
//     longName: "Liberira Daniel Oduber Quirós Int Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "CRI",
//       code: "CR",
//       shortName: "Costa Rica",
//       longName: "Costa Rica",
//     },
//     city: {
//       code: "LIR",
//       shortName: "Liberia",
//       longName: "Liberia",
//     },
//   },
//   SJO: {
//     iataCode: "SJO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 9.99,
//       longitude: -84.21,
//     },
//     shortName: "San Jose Costa Rica Airport",
//     longName: "San Jose Juan Santamaría Int.Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "CRI",
//       code: "CR",
//       shortName: "Costa Rica",
//       longName: "Costa Rica",
//     },
//     city: {
//       code: "SJO",
//       shortName: "San Jose Costa Rica",
//       longName: "San Jose Costa Rica",
//     },
//   },
//   HAV: {
//     iataCode: "HAV",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 22.99,
//       longitude: -82.41,
//     },
//     shortName: "Havana",
//     longName: "Jose Marti International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "CUB",
//       code: "CU",
//       shortName: "Cuba",
//       longName: "Cuba",
//     },
//     city: {
//       code: "HAV",
//       shortName: "Havana",
//       longName: "Havana",
//     },
//   },
//   HOG: {
//     iataCode: "HOG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 20.79,
//       longitude: -76.32,
//     },
//     shortName: "Holguin Airport",
//     longName: "Holguin Frank Pais International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "CUB",
//       code: "CU",
//       shortName: "Cuba",
//       longName: "Cuba",
//     },
//     city: {
//       code: "HOG",
//       shortName: "Holguin",
//       longName: "Holguin",
//     },
//   },
//   SNU: {
//     iataCode: "SNU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 22.49,
//       longitude: -79.94,
//     },
//     shortName: "Santa Clara Airport",
//     longName: "Abel Santamaría Int Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "CUB",
//       code: "CU",
//       shortName: "Cuba",
//       longName: "Cuba",
//     },
//     city: {
//       code: "SNU",
//       shortName: "Santa Clara",
//       longName: "Santa Clara",
//     },
//   },
//   VRA: {
//     iataCode: "VRA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 23.03,
//       longitude: -81.44,
//     },
//     shortName: "Varadero Airport",
//     longName: "Varadero Juan Gualberto Gomez International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "CUB",
//       code: "CU",
//       shortName: "Cuba",
//       longName: "Cuba",
//     },
//     city: {
//       code: "VRA",
//       shortName: "Varadero",
//       longName: "Varadero",
//     },
//   },
//   CUR: {
//     iataCode: "CUR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 12.19,
//       longitude: -68.96,
//     },
//     shortName: "Curacao Airport",
//     longName: "Curacao Hato International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "CUW",
//       code: "CW",
//       shortName: "Curacao",
//       longName: "Curacao",
//     },
//     city: {
//       code: "CUR",
//       shortName: "Curacao",
//       longName: "Curacao",
//     },
//   },
//   PUJ: {
//     iataCode: "PUJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 18.57,
//       longitude: -68.36,
//     },
//     shortName: "Punta cana",
//     longName: "Punta Cana International",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "DOM",
//       code: "DO",
//       shortName: "Dominican Republic",
//       longName: "Dominican Republic",
//     },
//     city: {
//       code: "PUJ",
//       shortName: "Punta cana",
//       longName: "Punta cana",
//     },
//   },
//   SDQ: {
//     iataCode: "SDQ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 18.43,
//       longitude: -69.67,
//     },
//     shortName: "Santo Domingo",
//     longName: "Las Americas International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "DOM",
//       code: "DO",
//       shortName: "Dominican Republic",
//       longName: "Dominican Republic",
//     },
//     city: {
//       code: "SDQ",
//       shortName: "Santo Domingo",
//       longName: "Santo Domingo",
//     },
//   },
//   POP: {
//     iataCode: "POP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 19.76,
//       longitude: -70.57,
//     },
//     shortName: "Puerto Plata",
//     longName: "Puerto Plata Gregorio Luperon Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "DOM",
//       code: "DO",
//       shortName: "Dominican Republic",
//       longName: "Dominican Republic",
//     },
//     city: {
//       code: "POP",
//       shortName: "Puerto Plata",
//       longName: "Puerto Plata",
//     },
//   },
//   STI: {
//     iataCode: "STI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 19.41,
//       longitude: -70.6,
//     },
//     shortName: "Santiago",
//     longName: "Santiago Municipal Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "DOM",
//       code: "DO",
//       shortName: "Dominican Republic",
//       longName: "Dominican Republic",
//     },
//     city: {
//       code: "STI",
//       shortName: "Santiago",
//       longName: "Santiago",
//     },
//   },
//   LRM: {
//     iataCode: "LRM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 18.45,
//       longitude: -68.91,
//     },
//     shortName: "La Romana Airport",
//     longName: "La Romana Casa De Campo Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "DOM",
//       code: "DO",
//       shortName: "Dominican Republic",
//       longName: "Dominican Republic",
//     },
//     city: {
//       code: "LRM",
//       shortName: "La Romana",
//       longName: "La Romana",
//     },
//   },
//   AZS: {
//     iataCode: "AZS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 19.27,
//       longitude: -69.74,
//     },
//     shortName: "Samana Airport",
//     longName: "Samaná El Catey International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "DOM",
//       code: "DO",
//       shortName: "Dominican Republic",
//       longName: "Dominican Republic",
//     },
//     city: {
//       code: "AZS",
//       shortName: "Samana",
//       longName: "Samana",
//     },
//   },
//   GYE: {
//     iataCode: "GYE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -2.16,
//       longitude: -79.88,
//     },
//     shortName: "Guayaquil Airport",
//     longName: "Guayaquil José Joaquín de Olmedo",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "ECU",
//       code: "EC",
//       shortName: "Ecuador",
//       longName: "Ecuador",
//     },
//     city: {
//       code: "GYE",
//       shortName: "Guayaquil",
//       longName: "Guayaquil",
//     },
//   },
//   UIO: {
//     iataCode: "UIO",
//     showAsOrigin: false,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -0.13,
//       longitude: -78.36,
//     },
//     shortName: "Quito Airport",
//     longName: "Mariscal Sucre Quito Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "ECU",
//       code: "EC",
//       shortName: "Ecuador",
//       longName: "Ecuador",
//     },
//     city: {
//       code: "UIO",
//       shortName: "Quito",
//       longName: "Quito",
//     },
//   },
//   SAL: {
//     iataCode: "SAL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 13.44,
//       longitude: -89.06,
//     },
//     shortName: "San Salvador Airport",
//     longName: "San Salvador Monseñor Óscar Arnulfo Romero Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "SLV",
//       code: "SV",
//       shortName: "El Salvador",
//       longName: "El Salvador",
//     },
//     city: {
//       code: "SAL",
//       shortName: "San Salvador",
//       longName: "San Salvador",
//     },
//   },
//   GND: {
//     iataCode: "GND",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 12,
//       longitude: -61.79,
//     },
//     shortName: "Grenada Airport",
//     longName: "Grenada Point Salines International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "GRD",
//       code: "GD",
//       shortName: "Grenada",
//       longName: "Grenada",
//     },
//     city: {
//       code: "GND",
//       shortName: "Grenada",
//       longName: "Grenada",
//     },
//   },
//   PTP: {
//     iataCode: "PTP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 16.27,
//       longitude: -61.53,
//     },
//     shortName: "Pointe-à-Pitre Airport",
//     longName: "Pointe-à-Pitre Le Raizet Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "GLP",
//       code: "GP",
//       shortName: "Guadeloupe",
//       longName: "Guadeloupe",
//     },
//     city: {
//       code: "PTP",
//       shortName: "Pointe-à-Pitre",
//       longName: "Pointe-à-Pitre",
//     },
//   },
//   GUA: {
//     iataCode: "GUA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 14.58,
//       longitude: -90.53,
//     },
//     shortName: "Guatemala City Airport",
//     longName: "Guatemala La Aurora Int Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "GTM",
//       code: "GT",
//       shortName: "Guatemala",
//       longName: "Guatemala",
//     },
//     city: {
//       code: "GUA",
//       shortName: "Guatemala City",
//       longName: "Guatemala City",
//     },
//   },
//   GEO: {
//     iataCode: "GEO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 6.5,
//       longitude: -58.25,
//     },
//     shortName: "Georgetown Airport",
//     longName: "Georgetown Cheddi Jagan International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "GUY",
//       code: "GY",
//       shortName: "Guyana",
//       longName: "Guyana",
//     },
//     city: {
//       code: "GEO",
//       shortName: "Georgetown",
//       longName: "Georgetown",
//     },
//   },
//   PAP: {
//     iataCode: "PAP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 18.58,
//       longitude: -72.29,
//     },
//     shortName: "Port Au Prince Airport",
//     longName: "Port Au Prince Toussaint L'Ouverture Int Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "HTI",
//       code: "HT",
//       shortName: "Haiti",
//       longName: "Haiti",
//     },
//     city: {
//       code: "PAP",
//       shortName: "Port Au Prince",
//       longName: "Port Au Prince",
//     },
//   },
//   SAP: {
//     iataCode: "SAP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 15.45,
//       longitude: -87.92,
//     },
//     shortName: "San Pedro Sula Airport",
//     longName: "Ramón Villeda Morales Int Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "HND",
//       code: "HN",
//       shortName: "Honduras",
//       longName: "Honduras",
//     },
//     city: {
//       code: "SAP",
//       shortName: "San Pedro Sula",
//       longName: "San Pedro Sula",
//     },
//   },
//   TGU: {
//     iataCode: "TGU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 14.06,
//       longitude: -87.22,
//     },
//     shortName: "Tegucigalpa Airport",
//     longName: "Tegucigalpa Toncontín Int Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "HND",
//       code: "HN",
//       shortName: "Honduras",
//       longName: "Honduras",
//     },
//     city: {
//       code: "TGU",
//       shortName: "Tegucigalpa",
//       longName: "Tegucigalpa",
//     },
//   },
//   KIN: {
//     iataCode: "KIN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 17.94,
//       longitude: -76.79,
//     },
//     shortName: "Kingston",
//     longName: "Norman Manley Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "JAM",
//       code: "JM",
//       shortName: "Jamaica",
//       longName: "Jamaica",
//     },
//     city: {
//       code: "KIN",
//       shortName: "Kingston",
//       longName: "Kingston",
//     },
//   },
//   MBJ: {
//     iataCode: "MBJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 18.5,
//       longitude: -77.91,
//     },
//     shortName: "Montego Bay",
//     longName: "Sangster International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "JAM",
//       code: "JM",
//       shortName: "Jamaica",
//       longName: "Jamaica",
//     },
//     city: {
//       code: "MBJ",
//       shortName: "Montego Bay",
//       longName: "Montego Bay",
//     },
//   },
//   ACA: {
//     iataCode: "ACA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 16.76,
//       longitude: -99.75,
//     },
//     shortName: "Acapulco Airport",
//     longName: "Acapulco General Juan N Alvarez Intl Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "MEX",
//       code: "MX",
//       shortName: "Mexico",
//       longName: "Mexico",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "ACA",
//       shortName: "Acapulco",
//       longName: "Acapulco",
//     },
//   },
//   CPE: {
//     iataCode: "CPE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 19.82,
//       longitude: -90.5,
//     },
//     shortName: "Campeche Airport",
//     longName: "Campeche Ingeniero Alberto Acuña Ongay Intl Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "MEX",
//       code: "MX",
//       shortName: "Mexico",
//       longName: "Mexico",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "CPE",
//       shortName: "Campeche",
//       longName: "Campeche",
//     },
//   },
//   CTM: {
//     iataCode: "CTM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 18.5,
//       longitude: -88.33,
//     },
//     shortName: "Chetumal Airport",
//     longName: "Chetumal International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "MEX",
//       code: "MX",
//       shortName: "Mexico",
//       longName: "Mexico",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "CTM",
//       shortName: "Chetumal",
//       longName: "Chetumal",
//     },
//   },
//   CJS: {
//     iataCode: "CJS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 31.64,
//       longitude: -106.43,
//     },
//     shortName: "Ciudad Juárez Airport",
//     longName: "Ciudad Juárez Abraham González Intl Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "MEX",
//       code: "MX",
//       shortName: "Mexico",
//       longName: "Mexico",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "CJS",
//       shortName: "Ciudad Juárez",
//       longName: "Ciudad Juárez",
//     },
//   },
//   CVM: {
//     iataCode: "CVM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 23.7,
//       longitude: -98.96,
//     },
//     shortName: "Ciudad Victoria Airport",
//     longName: "Ciudad Victoria General Pedro Jose Mendez International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "MEX",
//       code: "MX",
//       shortName: "Mexico",
//       longName: "Mexico",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "CVM",
//       shortName: "Ciudad Victoria",
//       longName: "Ciudad Victoria",
//     },
//   },
//   CME: {
//     iataCode: "CME",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 18.65,
//       longitude: -91.8,
//     },
//     shortName: "Ciudad del Carmen Airport",
//     longName: "Ciudad del Carmen International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "MEX",
//       code: "MX",
//       shortName: "Mexico",
//       longName: "Mexico",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "CME",
//       shortName: "Ciudad del Carmen",
//       longName: "Ciudad del Carmen",
//     },
//   },
//   CUL: {
//     iataCode: "CUL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 24.76,
//       longitude: -107.47,
//     },
//     shortName: "Culiacán Airport",
//     longName: "Culiacán Bachigualato Federal International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "MEX",
//       code: "MX",
//       shortName: "Mexico",
//       longName: "Mexico",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "CUL",
//       shortName: "Culiacán",
//       longName: "Culiacán",
//     },
//   },
//   BJX: {
//     iataCode: "BJX",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 20.99,
//       longitude: -101.48,
//     },
//     shortName: "Guanajuato Airport",
//     longName: "Guanajuato Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "MEX",
//       code: "MX",
//       shortName: "Mexico",
//       longName: "Mexico",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "BJX",
//       shortName: "Guanajuato ",
//       longName: "Guanajuato ",
//     },
//   },
//   HMO: {
//     iataCode: "HMO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 29.1,
//       longitude: -111.05,
//     },
//     shortName: "Hermosillo Airport",
//     longName: "Hermosillo International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "MEX",
//       code: "MX",
//       shortName: "Mexico",
//       longName: "Mexico",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "HMO",
//       shortName: "Hermosillo",
//       longName: "Hermosillo",
//     },
//   },
//   HUX: {
//     iataCode: "HUX",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 15.78,
//       longitude: -96.26,
//     },
//     shortName: "Huatulco Airport",
//     longName: "Bahías De Huatulco International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "MEX",
//       code: "MX",
//       shortName: "Mexico",
//       longName: "Mexico",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "HUX",
//       shortName: "Huatulco",
//       longName: "Huatulco",
//     },
//   },
//   IZT: {
//     iataCode: "IZT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 16.45,
//       longitude: -95.09,
//     },
//     shortName: "Ixtepec Airport",
//     longName: "Ixtepec Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "MEX",
//       code: "MX",
//       shortName: "Mexico",
//       longName: "Mexico",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "IZT",
//       shortName: "Ixtepec",
//       longName: "Ixtepec",
//     },
//   },
//   LZC: {
//     iataCode: "LZC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 18,
//       longitude: -102.22,
//     },
//     shortName: "Lázaro Cárdenas Airport",
//     longName: "Lázaro Cárdenas Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "MEX",
//       code: "MX",
//       shortName: "Mexico",
//       longName: "Mexico",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "LZC",
//       shortName: "Lázaro Cárdenas",
//       longName: "Lázaro Cárdenas",
//     },
//   },
//   CUU: {
//     iataCode: "CUU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 28.7,
//       longitude: -105.96,
//     },
//     shortName: "Chihuahua",
//     longName: "General Roberto Fierro Villalobos International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "MEX",
//       code: "MX",
//       shortName: "Mexico",
//       longName: "Mexico",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "CUU",
//       shortName: "Chihuahua",
//       longName: "Chihuahua",
//     },
//   },
//   TRC: {
//     iataCode: "TRC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 25.57,
//       longitude: -103.41,
//     },
//     shortName: "Torreón Airport",
//     longName: "Torreón Francisco Sarabia International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "MEX",
//       code: "MX",
//       shortName: "Mexico",
//       longName: "Mexico",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "TRC",
//       shortName: "Torreon",
//       longName: "Torreon",
//     },
//   },
//   CLQ: {
//     iataCode: "CLQ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 19.28,
//       longitude: -103.58,
//     },
//     shortName: "Colima Airport",
//     longName: "Colima Licenciado Miguel De La Madrid Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "MEX",
//       code: "MX",
//       shortName: "Mexico",
//       longName: "Mexico",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "CLQ",
//       shortName: "Colima",
//       longName: "Colima",
//     },
//   },
//   ZLO: {
//     iataCode: "ZLO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 19.14,
//       longitude: -104.56,
//     },
//     shortName: "Manzanillo",
//     longName: "Playa de Oro International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "MEX",
//       code: "MX",
//       shortName: "Mexico",
//       longName: "Mexico",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "ZLO",
//       shortName: "Manzanillo",
//       longName: "Manzanillo",
//     },
//   },
//   MEX: {
//     iataCode: "MEX",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 19.44,
//       longitude: -99.07,
//     },
//     shortName: "Mexico City Airport",
//     longName: "Mexico City International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "MEX",
//       code: "MX",
//       shortName: "Mexico",
//       longName: "Mexico",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "MEX",
//       shortName: "Mexico City",
//       longName: "Mexico City",
//     },
//   },
//   ZIH: {
//     iataCode: "ZIH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 17.6,
//       longitude: -101.46,
//     },
//     shortName: "Ixtapa",
//     longName: "Ixtapa Zihuatanejo International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "MEX",
//       code: "MX",
//       shortName: "Mexico",
//       longName: "Mexico",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "ZIH",
//       shortName: "Ixtapa",
//       longName: "Ixtapa",
//     },
//   },
//   GDL: {
//     iataCode: "GDL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 20.52,
//       longitude: -103.31,
//     },
//     shortName: "Guadalajara",
//     longName: "Miguel Hidal Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "MEX",
//       code: "MX",
//       shortName: "Mexico",
//       longName: "Mexico",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "GDL",
//       shortName: "Guadalajara",
//       longName: "Guadalajara",
//     },
//   },
//   MTY: {
//     iataCode: "MTY",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 25.78,
//       longitude: -100.11,
//     },
//     shortName: "Monterrey",
//     longName: "General Mariano Escobedo",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "MEX",
//       code: "MX",
//       shortName: "Mexico",
//       longName: "Mexico",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "MTY",
//       shortName: "Monterrey",
//       longName: "Monterrey",
//     },
//   },
//   CUN: {
//     iataCode: "CUN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 21.04,
//       longitude: -86.87,
//     },
//     shortName: "Cancun",
//     longName: "Cancun International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "MEX",
//       code: "MX",
//       shortName: "Mexico",
//       longName: "Mexico",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "CUN",
//       shortName: "Cancun",
//       longName: "Cancun",
//     },
//   },
//   CZM: {
//     iataCode: "CZM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 20.52,
//       longitude: -86.93,
//     },
//     shortName: "Cozumel",
//     longName: "Cozumel International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "MEX",
//       code: "MX",
//       shortName: "Mexico",
//       longName: "Mexico",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "CZM",
//       shortName: "Cozumel",
//       longName: "Cozumel",
//     },
//   },
//   SLP: {
//     iataCode: "SLP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 22.25,
//       longitude: -100.93,
//     },
//     shortName: "San Luis Potosi",
//     longName: "Ponciano Arriaga International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "MEX",
//       code: "MX",
//       shortName: "Mexico",
//       longName: "Mexico",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "SLP",
//       shortName: "San Luis Potosi",
//       longName: "San Luis Potosi",
//     },
//   },
//   MZT: {
//     iataCode: "MZT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 23.16,
//       longitude: -106.26,
//     },
//     shortName: "Mazatlan",
//     longName: "General Rafael Buelna International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "MEX",
//       code: "MX",
//       shortName: "Mexico",
//       longName: "Mexico",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "MZT",
//       shortName: "Mazatlan",
//       longName: "Mazatlan",
//     },
//   },
//   LTO: {
//     iataCode: "LTO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 25.99,
//       longitude: -111.35,
//     },
//     shortName: "Loreto",
//     longName: "Loreto International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "MEX",
//       code: "MX",
//       shortName: "Mexico",
//       longName: "Mexico",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "LTO",
//       shortName: "Loreto",
//       longName: "Loreto",
//     },
//   },
//   MLM: {
//     iataCode: "MLM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 19.85,
//       longitude: -101.03,
//     },
//     shortName: "Morelia Airport",
//     longName: "Morelia International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "MEX",
//       code: "MX",
//       shortName: "Mexico",
//       longName: "Mexico",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "MLM",
//       shortName: "Morelia",
//       longName: "Morelia",
//     },
//   },
//   MID: {
//     iataCode: "MID",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 20.94,
//       longitude: -89.66,
//     },
//     shortName: "Mérida Airport",
//     longName: "Mérida Licenciado Manuel Crescencio Rejon Intl Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "MEX",
//       code: "MX",
//       shortName: "Mexico",
//       longName: "Mexico",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "MID",
//       shortName: "Mérida",
//       longName: "Mérida",
//     },
//   },
//   NLD: {
//     iataCode: "NLD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 27.44,
//       longitude: -99.57,
//     },
//     shortName: "Nuevo Laredo Airport",
//     longName: "Nuevo Laredo Quetzalcóatl International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "MEX",
//       code: "MX",
//       shortName: "Mexico",
//       longName: "Mexico",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "NLD",
//       shortName: "Nuevo Laredo",
//       longName: "Nuevo Laredo",
//     },
//   },
//   OAX: {
//     iataCode: "OAX",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 17,
//       longitude: -96.73,
//     },
//     shortName: "Oaxaca Airport",
//     longName: "Oaxaca Xoxocotlán International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "MEX",
//       code: "MX",
//       shortName: "Mexico",
//       longName: "Mexico",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "OAX",
//       shortName: "Oaxaca",
//       longName: "Oaxaca",
//     },
//   },
//   PVR: {
//     iataCode: "PVR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 20.68,
//       longitude: -105.25,
//     },
//     shortName: "Puerto Vallarta Airport",
//     longName: "Lic. Gustavo Díaz Ordaz Puerto Vallarta Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "MEX",
//       code: "MX",
//       shortName: "Mexico",
//       longName: "Mexico",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "PVR",
//       shortName: "PUERTO VALLARTA",
//       longName: "PUERTO VALLARTA",
//     },
//   },
//   PQM: {
//     iataCode: "PQM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 17.53,
//       longitude: -92.02,
//     },
//     shortName: "Palenque Airport",
//     longName: "Palenque International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "MEX",
//       code: "MX",
//       shortName: "Mexico",
//       longName: "Mexico",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "PQM",
//       shortName: "Palenque",
//       longName: "Palenque",
//     },
//   },
//   PDS: {
//     iataCode: "PDS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 28.63,
//       longitude: -100.54,
//     },
//     shortName: "Piedras Negras Airport",
//     longName: "Piedras Negras International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "MEX",
//       code: "MX",
//       shortName: "Mexico",
//       longName: "Mexico",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "PDS",
//       shortName: "Piedras Negras",
//       longName: "Piedras Negras",
//     },
//   },
//   PAZ: {
//     iataCode: "PAZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 20.6,
//       longitude: -97.46,
//     },
//     shortName: "Poza Rica Airport",
//     longName: "Poza Rica El Tajín National Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "MEX",
//       code: "MX",
//       shortName: "Mexico",
//       longName: "Mexico",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "PAZ",
//       shortName: "Poza Rica",
//       longName: "Poza Rica",
//     },
//   },
//   PBC: {
//     iataCode: "PBC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 19.16,
//       longitude: -98.37,
//     },
//     shortName: "Puebla Airport",
//     longName: "Puebla Hermanos Serdán Int Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "MEX",
//       code: "MX",
//       shortName: "Mexico",
//       longName: "Mexico",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "PBC",
//       shortName: "Puebla",
//       longName: "Puebla",
//     },
//   },
//   PXM: {
//     iataCode: "PXM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 15.88,
//       longitude: -97.09,
//     },
//     shortName: "Puerto Escondido Airport",
//     longName: "Puerto Escondido International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "MEX",
//       code: "MX",
//       shortName: "Mexico",
//       longName: "Mexico",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "PXM",
//       shortName: "Puerto Escondido",
//       longName: "Puerto Escondido",
//     },
//   },
//   QRO: {
//     iataCode: "QRO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 20.62,
//       longitude: -100.19,
//     },
//     shortName: "Queretaro Airport",
//     longName: "Queretaro Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "MEX",
//       code: "MX",
//       shortName: "Mexico",
//       longName: "Mexico",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "QRO",
//       shortName: "Queretaro",
//       longName: "Queretaro",
//     },
//   },
//   REX: {
//     iataCode: "REX",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 26.01,
//       longitude: -98.23,
//     },
//     shortName: "Reynosa Airport",
//     longName: "Reynosa International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "MEX",
//       code: "MX",
//       shortName: "Mexico",
//       longName: "Mexico",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "REX",
//       shortName: "Reynosa",
//       longName: "Reynosa",
//     },
//   },
//   SJD: {
//     iataCode: "SJD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 23.15,
//       longitude: -109.72,
//     },
//     shortName: "San José del Cabo Airport",
//     longName: "San José del Cabo Los Cabos International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "MEX",
//       code: "MX",
//       shortName: "Mexico",
//       longName: "Mexico",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "SJD",
//       shortName: "San José del Cabo",
//       longName: "San José del Cabo",
//     },
//   },
//   TAM: {
//     iataCode: "TAM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 22.3,
//       longitude: -97.87,
//     },
//     shortName: "Tampico Airport",
//     longName: "Tampico General Francisco Javier Mina Intl Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "MEX",
//       code: "MX",
//       shortName: "Mexico",
//       longName: "Mexico",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "TAM",
//       shortName: "Tampico",
//       longName: "Tampico",
//     },
//   },
//   TPQ: {
//     iataCode: "TPQ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 21.42,
//       longitude: -104.84,
//     },
//     shortName: "Tepic Airport",
//     longName: "Tepic Amado Nervo National Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "MEX",
//       code: "MX",
//       shortName: "Mexico",
//       longName: "Mexico",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "TPQ",
//       shortName: "Tepic",
//       longName: "Tepic",
//     },
//   },
//   TIJ: {
//     iataCode: "TIJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 32.54,
//       longitude: -116.97,
//     },
//     shortName: "Tijuana Airport",
//     longName: "Tijuana General Abelardo L. Rodríguez Intl Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "MEX",
//       code: "MX",
//       shortName: "Mexico",
//       longName: "Mexico",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "TIJ",
//       shortName: "Tijuana",
//       longName: "Tijuana",
//     },
//   },
//   TGZ: {
//     iataCode: "TGZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 16.57,
//       longitude: -93.03,
//     },
//     shortName: "Tuxtla Gutiérrez Airport",
//     longName: "Tuxtla Gutiérrez International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "MEX",
//       code: "MX",
//       shortName: "Mexico",
//       longName: "Mexico",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "TGZ",
//       shortName: "Tuxtla Gutiérrez",
//       longName: "Tuxtla Gutiérrez",
//     },
//   },
//   VER: {
//     iataCode: "VER",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 19.15,
//       longitude: -96.19,
//     },
//     shortName: "Veracruz Airport",
//     longName: "Veracruz General Heriberto Jara International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "MEX",
//       code: "MX",
//       shortName: "Mexico",
//       longName: "Mexico",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "VER",
//       shortName: "Veracruz",
//       longName: "Veracruz",
//     },
//   },
//   VSA: {
//     iataCode: "VSA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 18,
//       longitude: -92.82,
//     },
//     shortName: "Villahermosa Airport",
//     longName: "Villahermosa Carlos Rovirosa Pérez Int Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "MEX",
//       code: "MX",
//       shortName: "Mexico",
//       longName: "Mexico",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "VSA",
//       shortName: "Villahermosa",
//       longName: "Villahermosa",
//     },
//   },
//   MGA: {
//     iataCode: "MGA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 12.14,
//       longitude: -86.17,
//     },
//     shortName: "Managua Airport",
//     longName: "Managua Augusto C. Sandino Int Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "NIC",
//       code: "NI",
//       shortName: "Nicaragua",
//       longName: "Nicaragua",
//     },
//     city: {
//       code: "MGA",
//       shortName: "Managua",
//       longName: "Managua",
//     },
//   },
//   PTY: {
//     iataCode: "PTY",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 9.07,
//       longitude: -79.38,
//     },
//     shortName: "Panama City",
//     longName: "Tocumen International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "PAN",
//       code: "PA",
//       shortName: "Panama",
//       longName: "Panama",
//     },
//     city: {
//       code: "PTY",
//       shortName: "Panama City",
//       longName: "Panama City",
//     },
//   },
//   ASU: {
//     iataCode: "ASU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -25.24,
//       longitude: -57.52,
//     },
//     shortName: "Asuncion Airport",
//     longName: "Silvio Pettirossi Asuncion Aiport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "PRY",
//       code: "PY",
//       shortName: "Paraguay",
//       longName: "Paraguay",
//     },
//     city: {
//       code: "ASU",
//       shortName: "Asuncion",
//       longName: "Asuncion",
//     },
//   },
//   AGT: {
//     iataCode: "AGT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -25.46,
//       longitude: -54.84,
//     },
//     shortName: "Ciudad Del Este Airport",
//     longName: "Guarani Ciudad Del Este Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "PRY",
//       code: "PY",
//       shortName: "Paraguay",
//       longName: "Paraguay",
//     },
//     city: {
//       code: "AGT",
//       shortName: "CIUDAD DEL ESTE",
//       longName: "CIUDAD DEL ESTE",
//     },
//   },
//   LIM: {
//     iataCode: "LIM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -12.02,
//       longitude: -77.11,
//     },
//     shortName: "Lima",
//     longName: "Jorge Chávez International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "PER",
//       code: "PE",
//       shortName: "Peru",
//       longName: "Peru",
//     },
//     city: {
//       code: "LIM",
//       shortName: "Lima",
//       longName: "Lima",
//     },
//   },
//   BQN: {
//     iataCode: "BQN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 18.49,
//       longitude: -67.13,
//     },
//     shortName: "Aguadilla",
//     longName: "Rafael Hernández Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "PRI",
//       code: "PR",
//       shortName: "Puerto Rico",
//       longName: "Puerto Rico",
//     },
//     city: {
//       code: "BQN",
//       shortName: "Aguadilla",
//       longName: "Aguadilla",
//     },
//   },
//   PSE: {
//     iataCode: "PSE",
//     showAsOrigin: false,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 18.01,
//       longitude: -66.56,
//     },
//     shortName: "Ponce",
//     longName: "Mercedita Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "PRI",
//       code: "PR",
//       shortName: "Puerto Rico",
//       longName: "Puerto Rico",
//     },
//     city: {
//       code: "PSE",
//       shortName: "Ponce",
//       longName: "Ponce",
//     },
//   },
//   SJU: {
//     iataCode: "SJU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 18.44,
//       longitude: -66,
//     },
//     shortName: "San Juan",
//     longName: "Luis Munoz Marin International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "PRI",
//       code: "PR",
//       shortName: "Puerto Rico",
//       longName: "Puerto Rico",
//     },
//     city: {
//       code: "SJU",
//       shortName: "San Juan",
//       longName: "San Juan",
//     },
//   },
//   UVF: {
//     iataCode: "UVF",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 13.73,
//       longitude: -60.95,
//     },
//     shortName: "Saint lucia",
//     longName: "Hewanorra Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "LCA",
//       code: "LC",
//       shortName: "St Lucia",
//       longName: "St Lucia",
//     },
//     city: {
//       code: "UVF",
//       shortName: "Saint lucia",
//       longName: "Saint lucia",
//     },
//   },
//   SXM: {
//     iataCode: "SXM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 18.04,
//       longitude: -63.11,
//     },
//     shortName: "St Maarten",
//     longName: "Princess Juliana International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "SXM",
//       code: "SX",
//       shortName: "St Maarten",
//       longName: "St Maarten",
//     },
//     city: {
//       code: "SXM",
//       shortName: "St Maarten",
//       longName: "St Maarten",
//     },
//   },
//   POS: {
//     iataCode: "POS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 10.6,
//       longitude: -61.34,
//     },
//     shortName: "Port of Spain Airport",
//     longName: "Port of Spain Piarco Int. Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "TTO",
//       code: "TT",
//       shortName: "Trinidad and Tobago",
//       longName: "Trinidad and Tobago",
//     },
//     city: {
//       code: "POS",
//       shortName: "Port of Spain",
//       longName: "Port of Spain",
//     },
//   },
//   TAB: {
//     iataCode: "TAB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 11.15,
//       longitude: -60.83,
//     },
//     shortName: "Tobago Airport",
//     longName: "Tobago-Crown Point Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "TTO",
//       code: "TT",
//       shortName: "Trinidad and Tobago",
//       longName: "Trinidad and Tobago",
//     },
//     city: {
//       code: "TAB",
//       shortName: "Scarborough",
//       longName: "Scarborough",
//     },
//   },
//   PLS: {
//     iataCode: "PLS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 21.77,
//       longitude: -72.27,
//     },
//     shortName: "Providenciales Airport",
//     longName: "Providenciales Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "TCA",
//       code: "TC",
//       shortName: "Turks and Caicos Islands",
//       longName: "Turks and Caicos Islands",
//     },
//     city: {
//       code: "PLS",
//       shortName: "Providenciales",
//       longName: "Providenciales",
//     },
//   },
//   CAK: {
//     iataCode: "CAK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 40.92,
//       longitude: -81.44,
//     },
//     shortName: "Akron Airport",
//     longName: "Akron Canton Regional Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "CAK",
//       shortName: "Akron",
//       longName: "Akron",
//     },
//   },
//   ABE: {
//     iataCode: "ABE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 40.65,
//       longitude: -75.44,
//     },
//     shortName: "Allentown Airport",
//     longName: "Allentown Lehigh Valley International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "ABE",
//       shortName: "Allentown",
//       longName: "Allentown",
//     },
//   },
//   ATW: {
//     iataCode: "ATW",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 44.26,
//       longitude: -88.52,
//     },
//     shortName: "Appleton Airport",
//     longName: "Appleton International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "ATW",
//       shortName: "Appleton",
//       longName: "Appleton",
//     },
//   },
//   ACV: {
//     iataCode: "ACV",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 40.98,
//       longitude: -124.11,
//     },
//     shortName: "Arcata Airport",
//     longName: "Arcata Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "ACV",
//       shortName: "Arcata",
//       longName: "Arcata",
//     },
//   },
//   BFL: {
//     iataCode: "BFL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 35.43,
//       longitude: -119.06,
//     },
//     shortName: "Bakersfield Airport",
//     longName: "Bakersfield Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "BFL",
//       shortName: "Bakersfield",
//       longName: "Bakersfield",
//     },
//   },
//   BTR: {
//     iataCode: "BTR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 30.53,
//       longitude: -91.15,
//     },
//     shortName: "Baton Rouge Airport",
//     longName: "Baton Rouge Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "BTR",
//       shortName: "Baton Rouge",
//       longName: "Baton Rouge",
//     },
//   },
//   BIL: {
//     iataCode: "BIL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 45.81,
//       longitude: -108.54,
//     },
//     shortName: "Billings Airport",
//     longName: "Billings Logan International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "BIL",
//       shortName: "Billings",
//       longName: "Billings",
//     },
//   },
//   BZN: {
//     iataCode: "BZN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 45.78,
//       longitude: -111.15,
//     },
//     shortName: "Bozeman Airport",
//     longName: "Bozeman Yellowstone International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "BZN",
//       shortName: "Bozeman",
//       longName: "Bozeman",
//     },
//   },
//   BRO: {
//     iataCode: "BRO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 25.91,
//       longitude: -97.43,
//     },
//     shortName: "Brownsville Airport",
//     longName: "Brownsville Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "BRO",
//       shortName: "Brownsville",
//       longName: "Brownsville",
//     },
//   },
//   CID: {
//     iataCode: "CID",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 41.88,
//       longitude: -91.71,
//     },
//     shortName: "Cedar Rapids Airport",
//     longName: "Cedar Rapids Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "CID",
//       shortName: "Cedar Rapids",
//       longName: "Cedar Rapids",
//     },
//   },
//   CHA: {
//     iataCode: "CHA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 35.04,
//       longitude: -85.2,
//     },
//     shortName: "Chattanooga Airport",
//     longName: "Chattanooga Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "CHA",
//       shortName: "Chattanooga",
//       longName: "Chattanooga",
//     },
//   },
//   COS: {
//     iataCode: "COS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 38.81,
//       longitude: -104.7,
//     },
//     shortName: "Colorado Springs Airport",
//     longName: "Colorado Springs Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "COS",
//       shortName: "Colorado Springs",
//       longName: "Colorado Springs",
//     },
//   },
//   DAB: {
//     iataCode: "DAB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 29.18,
//       longitude: -81.06,
//     },
//     shortName: "Daytona Beach Airport",
//     longName: "Daytona Beach International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "DAB",
//       shortName: "Daytona Beach",
//       longName: "Daytona Beach",
//     },
//   },
//   DLH: {
//     iataCode: "DLH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 46.84,
//       longitude: -92.19,
//     },
//     shortName: "Duluth Airport",
//     longName: "Duluth Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "DLH",
//       shortName: "Duluth",
//       longName: "Duluth",
//     },
//   },
//   EAU: {
//     iataCode: "EAU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 44.87,
//       longitude: -91.48,
//     },
//     shortName: "Eau Claire Airport",
//     longName: "Eau Claire Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "EAU",
//       shortName: "Eau Claire",
//       longName: "Eau Claire",
//     },
//   },
//   ERI: {
//     iataCode: "ERI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 42.08,
//       longitude: -80.17,
//     },
//     shortName: "Erie Airport",
//     longName: "Erie Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "ERI",
//       shortName: "Erie",
//       longName: "Erie",
//     },
//   },
//   FAR: {
//     iataCode: "FAR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 46.92,
//       longitude: -96.82,
//     },
//     shortName: "Fargo Airport",
//     longName: "Fargo Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "FAR",
//       shortName: "Fargo",
//       longName: "Fargo",
//     },
//   },
//   FNT: {
//     iataCode: "FNT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 42.97,
//       longitude: -83.74,
//     },
//     shortName: "Flint Airport",
//     longName: "Flint Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "FNT",
//       shortName: "Flint",
//       longName: "Flint",
//     },
//   },
//   TBN: {
//     iataCode: "TBN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 37.74,
//       longitude: -92.14,
//     },
//     shortName: "Fort Leonard Wood Airport",
//     longName: "Fort Leonard Wood Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "TBN",
//       shortName: "Fort Leonard Wood",
//       longName: "Fort Leonard Wood",
//     },
//   },
//   FWA: {
//     iataCode: "FWA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 40.98,
//       longitude: -85.2,
//     },
//     shortName: "Fort Wayne Airport",
//     longName: "Fort Wayne Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "FWA",
//       shortName: "Fort Wayne",
//       longName: "Fort Wayne",
//     },
//   },
//   GRR: {
//     iataCode: "GRR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 42.88,
//       longitude: -85.52,
//     },
//     shortName: "Grand Rapids Airport",
//     longName: "Grand Rapids Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "GRR",
//       shortName: "Grand Rapids",
//       longName: "Grand Rapids",
//     },
//   },
//   GTF: {
//     iataCode: "GTF",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 47.48,
//       longitude: -111.37,
//     },
//     shortName: "Great Falls Airport",
//     longName: "Great Falls International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "GTF",
//       shortName: "Great Falls",
//       longName: "Great Falls",
//     },
//   },
//   GRB: {
//     iataCode: "GRB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 44.49,
//       longitude: -88.13,
//     },
//     shortName: "Green Bay Airport",
//     longName: "Green Bay Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "GRB",
//       shortName: "Green Bay",
//       longName: "Green Bay",
//     },
//   },
//   GSP: {
//     iataCode: "GSP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 34.9,
//       longitude: -82.22,
//     },
//     shortName: "Greenville Spartanburg Airport",
//     longName: "Greenville Spartanburg International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "GSP",
//       shortName: "Greenville",
//       longName: "Greenville",
//     },
//   },
//   HRL: {
//     iataCode: "HRL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 26.23,
//       longitude: -97.65,
//     },
//     shortName: "Harlingen Airport",
//     longName: "Harlingen Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "HRL",
//       shortName: "Harlingen",
//       longName: "Harlingen",
//     },
//   },
//   HOB: {
//     iataCode: "HOB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 32.68,
//       longitude: -103.22,
//     },
//     shortName: "Hobbs Airport",
//     longName: "Hobbs Lea County Regional Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "HOB",
//       shortName: "Hobbs",
//       longName: "Hobbs",
//     },
//   },
//   HSV: {
//     iataCode: "HSV",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 34.64,
//       longitude: -86.78,
//     },
//     shortName: "Huntsville Airport",
//     longName: "Huntsville Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "HSV",
//       shortName: "Huntsville",
//       longName: "Huntsville",
//     },
//   },
//   HYA: {
//     iataCode: "HYA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 41.67,
//       longitude: -70.28,
//     },
//     shortName: "Hyannis Airport",
//     longName: "Hyannis Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "HYA",
//       shortName: "Hyannis",
//       longName: "Hyannis",
//     },
//   },
//   JAN: {
//     iataCode: "JAN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 32.31,
//       longitude: -90.08,
//     },
//     shortName: "Jackson Evers Airport",
//     longName: "Jackson Evers Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "JAN",
//       shortName: "Jackson",
//       longName: "Jackson",
//     },
//   },
//   JAC: {
//     iataCode: "JAC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.61,
//       longitude: -110.74,
//     },
//     shortName: "Jackson Hole Airport",
//     longName: "Jackson Hole Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "JAC",
//       shortName: "Jackson Hole",
//       longName: "Jackson Hole",
//     },
//   },
//   JST: {
//     iataCode: "JST",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 40.32,
//       longitude: -78.83,
//     },
//     shortName: "Johnstown Airport",
//     longName: "Johnstown Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "JST",
//       shortName: "Johnstown",
//       longName: "Johnstown",
//     },
//   },
//   FCA: {
//     iataCode: "FCA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 48.31,
//       longitude: -114.26,
//     },
//     shortName: "Kalispell Airport",
//     longName: "Kalispell Glacier Park International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "FCA",
//       shortName: "Kalispell",
//       longName: "Kalispell",
//     },
//   },
//   LWB: {
//     iataCode: "LWB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 37.86,
//       longitude: -80.4,
//     },
//     shortName: "Lewisburg Airport",
//     longName: "Lewisburg Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "LWB",
//       shortName: "Lewisburg",
//       longName: "Lewisburg",
//     },
//   },
//   LWS: {
//     iataCode: "LWS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 46.37,
//       longitude: -117.01,
//     },
//     shortName: "Lewiston Airport",
//     longName: "Lewiston–Nez Perce County Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "LWS",
//       shortName: "Lewiston",
//       longName: "Lewiston",
//     },
//   },
//   LNK: {
//     iataCode: "LNK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 40.85,
//       longitude: -96.76,
//     },
//     shortName: "Lincoln Airport",
//     longName: "Lincoln Nebraska Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "LNK",
//       shortName: "Lincoln",
//       longName: "Lincoln",
//     },
//   },
//   LIT: {
//     iataCode: "LIT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 34.73,
//       longitude: -92.22,
//     },
//     shortName: "Little Rock Airport",
//     longName: "Little Rock Arkansa Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "LIT",
//       shortName: "Little Rock",
//       longName: "Little Rock Arkansa",
//     },
//   },
//   LBB: {
//     iataCode: "LBB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 33.66,
//       longitude: -101.82,
//     },
//     shortName: "Lubbock Airport",
//     longName: "Lubbock Preston Smith International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "LBB",
//       shortName: "Lubbock",
//       longName: "Lubbock",
//     },
//   },
//   MSN: {
//     iataCode: "MSN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.14,
//       longitude: -89.34,
//     },
//     shortName: "Madison Airport",
//     longName: "Madison Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "MSN",
//       shortName: "Madison",
//       longName: "Madison",
//     },
//   },
//   MMH: {
//     iataCode: "MMH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 37.62,
//       longitude: -118.84,
//     },
//     shortName: "Mammoth Airport",
//     longName: "Mammoth Yosemite Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "MMH",
//       shortName: "Mammoth Lakes",
//       longName: "Mammoth Lakes",
//     },
//   },
//   MVY: {
//     iataCode: "MVY",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 41.39,
//       longitude: -70.61,
//     },
//     shortName: "Martha's Vineyard Airport",
//     longName: "Martha's Vineyard Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "MVY",
//       shortName: "Marthas Vineyard",
//       longName: "Marthas Vineyard",
//     },
//   },
//   MCW: {
//     iataCode: "MCW",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.16,
//       longitude: -93.33,
//     },
//     shortName: "Mason City Airport",
//     longName: "Mason City Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "MCW",
//       shortName: "Mason City",
//       longName: "Mason City",
//     },
//   },
//   MAF: {
//     iataCode: "MAF",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 31.94,
//       longitude: -102.2,
//     },
//     shortName: "Midland Airport",
//     longName: "Midland International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "MAF",
//       shortName: "Midland",
//       longName: "Midland",
//     },
//   },
//   MSO: {
//     iataCode: "MSO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 46.92,
//       longitude: -114.09,
//     },
//     shortName: "Missoula Airport",
//     longName: "Missoula International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "MSO",
//       shortName: "Missoula",
//       longName: "Missoula",
//     },
//   },
//   MLI: {
//     iataCode: "MLI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 41.45,
//       longitude: -90.51,
//     },
//     shortName: "Moline Airport",
//     longName: "Moline Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "MLI",
//       shortName: "Moline",
//       longName: "Moline",
//     },
//   },
//   MRY: {
//     iataCode: "MRY",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 36.59,
//       longitude: -121.84,
//     },
//     shortName: "Monterey Airport",
//     longName: "Monterey Regional Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "MRY",
//       shortName: "Monterey",
//       longName: "Monterey",
//     },
//   },
//   MKG: {
//     iataCode: "MKG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.17,
//       longitude: -86.24,
//     },
//     shortName: "Muskegon Airport",
//     longName: "Muskegon Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "MKG",
//       shortName: "Muskegon",
//       longName: "Muskegon",
//     },
//   },
//   ACK: {
//     iataCode: "ACK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 41.25,
//       longitude: -70.06,
//     },
//     shortName: "Nantucket Airport",
//     longName: "Nantucket Memorial Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "ACK",
//       shortName: "Nantucket",
//       longName: "Nantucket",
//     },
//   },
//   ONT: {
//     iataCode: "ONT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 34.06,
//       longitude: -117.6,
//     },
//     shortName: "Ontario Airport",
//     longName: "Ontario International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "ONT",
//       shortName: "Ontario",
//       longName: "Ontario",
//     },
//   },
//   PSP: {
//     iataCode: "PSP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 33.83,
//       longitude: -116.51,
//     },
//     shortName: "Palm Springs Airport",
//     longName: "Palm Springs International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "PSP",
//       shortName: "Palm Springs",
//       longName: "Palm Springs",
//     },
//   },
//   PNS: {
//     iataCode: "PNS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 30.47,
//       longitude: -87.19,
//     },
//     shortName: "Pensacola Airport",
//     longName: "Pensacola Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "PNS",
//       shortName: "Pensacola",
//       longName: "Pensacola",
//     },
//   },
//   PIA: {
//     iataCode: "PIA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 40.66,
//       longitude: -89.69,
//     },
//     shortName: "Peoria Airport",
//     longName: "Peoria Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "PIA",
//       shortName: "Peoria",
//       longName: "Peoria",
//     },
//   },
//   PVD: {
//     iataCode: "PVD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 41.73,
//       longitude: -71.42,
//     },
//     shortName: "Providence Airport",
//     longName: "Providence Theodore Francis Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "PVD",
//       shortName: "Providence",
//       longName: "Providence",
//     },
//   },
//   RAP: {
//     iataCode: "RAP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 44.05,
//       longitude: -103.06,
//     },
//     shortName: "Rapid City Airport",
//     longName: "Rapid City Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "RAP",
//       shortName: "Rapid City",
//       longName: "Rapid City",
//     },
//   },
//   RNO: {
//     iataCode: "RNO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 39.5,
//       longitude: -119.77,
//     },
//     shortName: "Reno Airport",
//     longName: "Reno–Tahoe International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "RNO",
//       shortName: "Reno",
//       longName: "Reno",
//     },
//   },
//   MBS: {
//     iataCode: "MBS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.53,
//       longitude: -84.08,
//     },
//     shortName: "Saginaw Airport",
//     longName: "Saginaw MBS International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "MBS",
//       shortName: "Saginaw",
//       longName: "Saginaw",
//     },
//   },
//   SNA: {
//     iataCode: "SNA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 33.68,
//       longitude: -117.87,
//     },
//     shortName: "Santa Ana Airport",
//     longName: "Santa Ana John Wayne Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "SNA",
//       shortName: "Santa Ana",
//       longName: "Santa Ana",
//     },
//   },
//   STS: {
//     iataCode: "STS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 38.51,
//       longitude: -122.81,
//     },
//     shortName: "Santa Rosa Airport",
//     longName: "Santa Rosa Charles M. Schulz–Sonoma County Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "STS",
//       shortName: "Santa Rosa",
//       longName: "Santa Rosa",
//     },
//   },
//   SAV: {
//     iataCode: "SAV",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 32.13,
//       longitude: -81.2,
//     },
//     shortName: "Savannah Airport",
//     longName: "Savannah / Hilton Head International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "SAV",
//       shortName: "Savannah",
//       longName: "Savannah",
//     },
//   },
//   SBN: {
//     iataCode: "SBN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 41.71,
//       longitude: -86.32,
//     },
//     shortName: "South Bend Airport",
//     longName: "South Bend Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "SBN",
//       shortName: "South Bend",
//       longName: "South Bend",
//     },
//   },
//   SPI: {
//     iataCode: "SPI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 39.84,
//       longitude: -89.68,
//     },
//     shortName: "Springfield Illinois Airport",
//     longName: "Springfield Illinois Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "SPI",
//       shortName: "Springfield Illinois",
//       longName: "Springfield Illinois",
//     },
//   },
//   SGF: {
//     iataCode: "SGF",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 37.25,
//       longitude: -93.39,
//     },
//     shortName: "Springfield Missouri Airport",
//     longName: "Springfield Missouri Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "SGF",
//       shortName: "Springfield Missouri",
//       longName: "Springfield Missouri",
//     },
//   },
//   SCE: {
//     iataCode: "SCE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 40.85,
//       longitude: -77.85,
//     },
//     shortName: "State College Airport",
//     longName: "State College University Park Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "SCE",
//       shortName: "State College",
//       longName: "State College",
//     },
//   },
//   SHD: {
//     iataCode: "SHD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 38.26,
//       longitude: -78.9,
//     },
//     shortName: "Staunton Airport",
//     longName: "Staunton Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "SHD",
//       shortName: "Staunton",
//       longName: "Staunton",
//     },
//   },
//   TVC: {
//     iataCode: "TVC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 44.74,
//       longitude: -85.58,
//     },
//     shortName: "Traverse City Airport",
//     longName: "Traverse City Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "TVC",
//       shortName: "Traverse City",
//       longName: "Traverse City",
//     },
//   },
//   MOB: {
//     iataCode: "MOB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 30.69,
//       longitude: -88.24,
//     },
//     shortName: "Mobile",
//     longName: "Mobile Regional Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "MOB",
//       shortName: "Mobile",
//       longName: "Mobile",
//     },
//   },
//   ANC: {
//     iataCode: "ANC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 61.17,
//       longitude: -150,
//     },
//     shortName: "Anchorage",
//     longName: "Ted Stevens Anchorage International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "ANC",
//       shortName: "Anchorage",
//       longName: "Anchorage",
//     },
//   },
//   FAI: {
//     iataCode: "FAI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 64.82,
//       longitude: -147.86,
//     },
//     shortName: "Fairbanks",
//     longName: "Fairbanks International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "FAI",
//       shortName: "Fairbanks",
//       longName: "Fairbanks",
//     },
//   },
//   JNU: {
//     iataCode: "JNU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 58.35,
//       longitude: -134.58,
//     },
//     shortName: "Juneau",
//     longName: "Juneau International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "JNU",
//       shortName: "Juneau",
//       longName: "Juneau",
//     },
//   },
//   KTN: {
//     iataCode: "KTN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 55.35,
//       longitude: -131.71,
//     },
//     shortName: "Ketchikan",
//     longName: "Ketchikan International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "KTN",
//       shortName: "Ketchikan",
//       longName: "Ketchikan",
//     },
//   },
//   PHX: {
//     iataCode: "PHX",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 33.43,
//       longitude: -112.01,
//     },
//     shortName: "Phoenix",
//     longName: "Sky Harbor International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "PHX",
//       shortName: "Phoenix",
//       longName: "Phoenix",
//     },
//   },
//   TUS: {
//     iataCode: "TUS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 32.12,
//       longitude: -110.94,
//     },
//     shortName: "Tucson",
//     longName: "Tucson International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "TUS",
//       shortName: "Tucson",
//       longName: "Tucson",
//     },
//   },
//   XNA: {
//     iataCode: "XNA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 36.28,
//       longitude: -94.31,
//     },
//     shortName: "Fayetteville",
//     longName: "Northwest Arkansas Regional Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "XNA",
//       shortName: "Fayetteville",
//       longName: "Fayetteville",
//     },
//   },
//   BUR: {
//     iataCode: "BUR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 34.2,
//       longitude: -118.36,
//     },
//     shortName: "Burbank",
//     longName: "Bob Hope Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "BUR",
//       shortName: "Burbank",
//       longName: "Burbank",
//     },
//   },
//   FAT: {
//     iataCode: "FAT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 36.78,
//       longitude: -119.72,
//     },
//     shortName: "Fresno",
//     longName: "Fresno Yosemite International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "FAT",
//       shortName: "Fresno",
//       longName: "Fresno",
//     },
//   },
//   LGB: {
//     iataCode: "LGB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 33.82,
//       longitude: -118.15,
//     },
//     shortName: "Long Beach",
//     longName: "Long Beach",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "LGB",
//       shortName: "Long Beach",
//       longName: "Long Beach",
//     },
//   },
//   LAX: {
//     iataCode: "LAX",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 33.94,
//       longitude: -118.41,
//     },
//     shortName: "Los Angeles",
//     longName: "Los Angeles International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "LAX",
//       shortName: "Los Angeles",
//       longName: "Los Angeles",
//     },
//   },
//   OAK: {
//     iataCode: "OAK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 37.72,
//       longitude: -122.22,
//     },
//     shortName: "Oakland",
//     longName: "Oakland International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "OAK",
//       shortName: "Oakland",
//       longName: "Oakland",
//     },
//   },
//   SMF: {
//     iataCode: "SMF",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 38.7,
//       longitude: -121.59,
//     },
//     shortName: "Sacramento",
//     longName: "Sacramento International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "SMF",
//       shortName: "Sacramento",
//       longName: "Sacramento",
//     },
//   },
//   SAN: {
//     iataCode: "SAN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 32.73,
//       longitude: -117.19,
//     },
//     shortName: "San Diego",
//     longName: "Lindberg Field Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "SAN",
//       shortName: "San Diego",
//       longName: "San Diego",
//     },
//   },
//   SFO: {
//     iataCode: "SFO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 37.62,
//       longitude: -122.37,
//     },
//     shortName: "San Francisco",
//     longName: "San Francisco International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "SFO",
//       shortName: "San Francisco",
//       longName: "San Francisco",
//     },
//   },
//   SJC: {
//     iataCode: "SJC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 37.36,
//       longitude: -121.93,
//     },
//     shortName: "San Jose",
//     longName: "San Jose",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "SJC",
//       shortName: "San Jose",
//       longName: "San Jose",
//     },
//   },
//   DEN: {
//     iataCode: "DEN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 39.86,
//       longitude: -104.67,
//     },
//     shortName: "Denver",
//     longName: "Denver International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "DEN",
//       shortName: "Denver",
//       longName: "Denver",
//     },
//   },
//   HDN: {
//     iataCode: "HDN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 40.48,
//       longitude: -107.22,
//     },
//     shortName: "Hayden Airport",
//     longName: "Hayden Yampa Valley Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "HDN",
//       shortName: "Hayden",
//       longName: "Hayden",
//     },
//   },
//   MTJ: {
//     iataCode: "MTJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 38.51,
//       longitude: -107.89,
//     },
//     shortName: "Montrose Airport",
//     longName: "Montrose Regional Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "MTJ",
//       shortName: "Montrose",
//       longName: "Montrose",
//     },
//   },
//   BDL: {
//     iataCode: "BDL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 41.94,
//       longitude: -72.68,
//     },
//     shortName: "Hartford",
//     longName: "Bradley International",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "BDL",
//       shortName: "Hartford",
//       longName: "Hartford",
//     },
//   },
//   IAD: {
//     iataCode: "IAD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 38.95,
//       longitude: -77.46,
//     },
//     shortName: "Washington Dulles International ",
//     longName: "Dulles International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "WAS",
//       shortName: "Washington, D.C.",
//       longName: "Washington, D.C.",
//     },
//   },
//   DCA: {
//     iataCode: "DCA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 38.85,
//       longitude: -77.04,
//     },
//     shortName: "Washington Ronald Reagan Airport",
//     longName: "Ronald Reagan National Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "WAS",
//       shortName: "Washington, D.C.",
//       longName: "Washington, D.C.",
//     },
//   },
//   FLL: {
//     iataCode: "FLL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 26.07,
//       longitude: -80.15,
//     },
//     shortName: "Fort Lauderdale",
//     longName: "Fort Lauderdale-Hollywood International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "FLL",
//       shortName: "Fort Lauderdale",
//       alternateNames: ["Florida"],
//       longName: "Fort Lauderdale (South Florida)",
//     },
//   },
//   RSW: {
//     iataCode: "RSW",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 26.54,
//       longitude: -81.76,
//     },
//     shortName: "Fort Myers",
//     longName: "Southwest Florida International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "RSW",
//       shortName: "Fort Myers",
//       longName: "Fort Myers",
//     },
//   },
//   JAX: {
//     iataCode: "JAX",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 30.49,
//       longitude: -81.69,
//     },
//     shortName: "Jacksonville",
//     longName: "Jacksonville International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "JAX",
//       shortName: "Jacksonville",
//       longName: "Jacksonville",
//     },
//   },
//   EYW: {
//     iataCode: "EYW",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 24.56,
//       longitude: -81.76,
//     },
//     shortName: "Key West Airport",
//     longName: "Key West International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "EYW",
//       shortName: "Key West",
//       longName: "Key West",
//     },
//   },
//   MIA: {
//     iataCode: "MIA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 25.8,
//       longitude: -80.29,
//     },
//     shortName: "Miami",
//     longName: "Miami International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "MIA",
//       shortName: "Miami",
//       longName: "Miami",
//     },
//   },
//   MCO: {
//     iataCode: "MCO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 28.43,
//       longitude: -81.31,
//     },
//     shortName: "Orlando",
//     alternateNames: ["Florida"],
//     longName: "Orlando International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "ORL",
//       shortName: "Orlando",
//       alternateNames: ["Florida"],
//       longName: "Orlando",
//     },
//   },
//   SRQ: {
//     iataCode: "SRQ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 27.4,
//       longitude: -82.55,
//     },
//     shortName: "Sarasota",
//     longName: "Sarasota-Bradenton International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "SRQ",
//       shortName: "Sarasota",
//       longName: "Sarasota",
//     },
//   },
//   TPA: {
//     iataCode: "TPA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 27.98,
//       longitude: -82.53,
//     },
//     shortName: "Tampa",
//     longName: "Tampa International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "TPA",
//       shortName: "Tampa",
//       longName: "Tampa",
//     },
//   },
//   PBI: {
//     iataCode: "PBI",
//     showAsOrigin: true,
//     sellingPOS: "MIA",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 26.68,
//       longitude: -80.1,
//     },
//     shortName: "West Palm Beach",
//     longName: "Palm Beach International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "PBI",
//       shortName: "West Palm Beach",
//       longName: "West Palm Beach",
//     },
//   },
//   ATL: {
//     iataCode: "ATL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 33.64,
//       longitude: -84.43,
//     },
//     shortName: "Atlanta",
//     longName: "William B Hartsfield Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "ATL",
//       shortName: "Atlanta",
//       longName: "Atlanta",
//     },
//   },
//   HNL: {
//     iataCode: "HNL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 21.32,
//       longitude: -157.92,
//     },
//     shortName: "Honolulu",
//     longName: "Honolulu",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "HNL",
//       shortName: "Honolulu",
//       longName: "Honolulu",
//     },
//   },
//   OGG: {
//     iataCode: "OGG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 20.9,
//       longitude: -156.43,
//     },
//     shortName: "Kahului",
//     longName: "Kahului Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "OGG",
//       shortName: "Kahului",
//       longName: "Kahului",
//     },
//   },
//   LIH: {
//     iataCode: "LIH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 21.98,
//       longitude: -159.34,
//     },
//     shortName: "Kauai Island",
//     longName: "Lihue Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "LIH",
//       shortName: "Kauai Island",
//       longName: "Kauai Island",
//     },
//   },
//   KOA: {
//     iataCode: "KOA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 19.74,
//       longitude: -156.05,
//     },
//     shortName: "Kona",
//     longName: "Kona International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "KOA",
//       shortName: "Kona",
//       longName: "Kona",
//     },
//   },
//   BOI: {
//     iataCode: "BOI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.56,
//       longitude: -116.22,
//     },
//     shortName: "Boise",
//     longName: "Boise Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "BOI",
//       shortName: "Boise",
//       longName: "Boise",
//     },
//   },
//   ORD: {
//     iataCode: "ORD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 41.98,
//       longitude: -87.91,
//     },
//     shortName: "Chicago",
//     longName: "O'Hare International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "CHI",
//       shortName: "Chicago",
//       longName: "Chicago",
//     },
//   },
//   IND: {
//     iataCode: "IND",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 39.72,
//       longitude: -86.29,
//     },
//     shortName: "Indianapolis",
//     longName: "Indianapolis International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "IND",
//       shortName: "Indianapolis",
//       longName: "Indianapolis",
//     },
//   },
//   DSM: {
//     iataCode: "DSM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 41.53,
//       longitude: -93.66,
//     },
//     shortName: "Des Moines",
//     longName: "Des Moines",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "DSM",
//       shortName: "Des Moines",
//       longName: "Des Moines",
//     },
//   },
//   ICT: {
//     iataCode: "ICT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 37.65,
//       longitude: -97.43,
//     },
//     shortName: "Wichita",
//     longName: "Wichita Mid-Continent Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "ICT",
//       shortName: "Wichita",
//       longName: "Wichita",
//     },
//   },
//   LEX: {
//     iataCode: "LEX",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 38.04,
//       longitude: -84.61,
//     },
//     shortName: "Lexington",
//     longName: "Blue Grass Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "LEX",
//       shortName: "Lexington",
//       longName: "Lexington",
//     },
//   },
//   SDF: {
//     iataCode: "SDF",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 38.17,
//       longitude: -85.74,
//     },
//     shortName: "Louisville",
//     longName: "Louisville International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "SDF",
//       shortName: "Louisville",
//       longName: "Louisville",
//     },
//   },
//   LFT: {
//     iataCode: "LFT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 30.21,
//       longitude: -91.99,
//     },
//     shortName: "Lafayette",
//     longName: "Lafayette Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "LFT",
//       shortName: "Lafayette",
//       longName: "Lafayette",
//     },
//   },
//   MSY: {
//     iataCode: "MSY",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 29.99,
//       longitude: -90.26,
//     },
//     shortName: "New Orleans",
//     longName: "New Orleans",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "MSY",
//       shortName: "New Orleans",
//       longName: "New Orleans",
//     },
//   },
//   SHV: {
//     iataCode: "SHV",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 32.45,
//       longitude: -93.83,
//     },
//     shortName: "Shreveport Regional Airport",
//     longName: "Shreveport Regional Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "SHV",
//       shortName: "Shreveport",
//       longName: "Shreveport",
//     },
//   },
//   BGR: {
//     iataCode: "BGR",
//     showAsOrigin: true,
//     sellingPOS: "PWM",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 44.81,
//       longitude: -68.83,
//     },
//     shortName: "Bangor",
//     longName: "Bangor International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "BGR",
//       shortName: "Bangor",
//       longName: "Bangor",
//     },
//   },
//   PWM: {
//     iataCode: "PWM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.65,
//       longitude: -70.31,
//     },
//     shortName: "Portland",
//     longName: "Portland International Jetport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "PWM",
//       shortName: "Portland Maine",
//       longName: "Portland Maine",
//     },
//   },
//   BWI: {
//     iataCode: "BWI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 39.18,
//       longitude: -76.67,
//     },
//     shortName: "Baltimore",
//     longName: "Washington International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "BWI",
//       shortName: "Baltimore",
//       longName: "Baltimore",
//     },
//   },
//   BOS: {
//     iataCode: "BOS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 42.36,
//       longitude: -71.01,
//     },
//     shortName: "Boston",
//     longName: "Logan International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "BOS",
//       shortName: "Boston",
//       longName: "Boston",
//     },
//   },
//   PVC: {
//     iataCode: "PVC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 42.07,
//       longitude: -70.22,
//     },
//     shortName: "Provincetown Airport",
//     longName: "Provincetown Municipal Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "PVC",
//       shortName: "Provincetown",
//       longName: "Provincetown",
//     },
//   },
//   DTW: {
//     iataCode: "DTW",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 42.21,
//       longitude: -83.35,
//     },
//     shortName: "Detroit",
//     longName: "Wayne County Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "DTT",
//       shortName: "Detroit",
//       longName: "Detroit",
//     },
//   },
//   MSP: {
//     iataCode: "MSP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 44.88,
//       longitude: -93.22,
//     },
//     shortName: "Minneapolis",
//     longName: "St Paul International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "MSP",
//       shortName: "Minneapolis",
//       longName: "Minneapolis",
//     },
//   },
//   MCI: {
//     iataCode: "MCI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 39.3,
//       longitude: -94.71,
//     },
//     shortName: "Kansas City",
//     longName: "Kansas City International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "MCI",
//       shortName: "Kansas City",
//       longName: "Kansas City",
//     },
//   },
//   STL: {
//     iataCode: "STL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 38.75,
//       longitude: -90.37,
//     },
//     shortName: "St Louis",
//     longName: "Lambert International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "STL",
//       shortName: "St Louis",
//       longName: "St Louis",
//     },
//   },
//   OMA: {
//     iataCode: "OMA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 41.3,
//       longitude: -95.89,
//     },
//     shortName: "Omaha Airport",
//     longName: "Omaha Eppley Airfield",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "OMA",
//       shortName: "Omaha",
//       longName: "Omaha",
//     },
//   },
//   LAS: {
//     iataCode: "LAS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 36.08,
//       longitude: -115.15,
//     },
//     shortName: "Las Vegas",
//     longName: "McCarran International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "LAS",
//       shortName: "Las Vegas",
//       longName: "Las Vegas",
//     },
//   },
//   ABQ: {
//     iataCode: "ABQ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 35.04,
//       longitude: -106.61,
//     },
//     shortName: "Albuquerque",
//     longName: "Albuquerque International",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "ABQ",
//       shortName: "Albuquerque",
//       longName: "Albuquerque",
//     },
//   },
//   ALB: {
//     iataCode: "ALB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 42.75,
//       longitude: -73.8,
//     },
//     shortName: "Albany",
//     longName: "Albany",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "ALB",
//       shortName: "Albany",
//       longName: "Albany",
//     },
//   },
//   BUF: {
//     iataCode: "BUF",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 42.94,
//       longitude: -78.73,
//     },
//     shortName: "Buffalo",
//     longName: "Buffalo Niagara International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "BUF",
//       shortName: "Buffalo",
//       longName: "Buffalo",
//     },
//   },
//   JFK: {
//     iataCode: "JFK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 40.64,
//       longitude: -73.78,
//     },
//     shortName: "New York John F Kennedy",
//     longName: "John F Kennedy International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "NYC",
//       shortName: "New York",
//       longName: "New York",
//     },
//   },
//   LGA: {
//     iataCode: "LGA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 40.78,
//       longitude: -73.87,
//     },
//     shortName: "La Guardia Airport ",
//     longName: "New York La Guardia Airport ",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "NYC",
//       shortName: "New York",
//       longName: "New York",
//     },
//   },
//   NYC: {
//     iataCode: "NYC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 40.71,
//       longitude: -74.01,
//     },
//     shortName: "New York",
//     longName: "New York All Airports",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "NYC",
//       shortName: "New York",
//       longName: "New York",
//     },
//   },
//   EWR: {
//     iataCode: "EWR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 40.69,
//       longitude: -74.17,
//     },
//     shortName: "Newark",
//     longName: "Newark Liberty International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "NYC",
//       shortName: "New York",
//       longName: "New York",
//     },
//   },
//   ROC: {
//     iataCode: "ROC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.12,
//       longitude: -77.67,
//     },
//     shortName: "Rochester",
//     longName: "Greater Rochester International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "ROC",
//       shortName: "Rochester",
//       longName: "Rochester",
//     },
//   },
//   SYR: {
//     iataCode: "SYR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.11,
//       longitude: -76.11,
//     },
//     shortName: "Syracuse",
//     longName: "Syracuse Hancock International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "SYR",
//       shortName: "Syracuse",
//       longName: "Syracuse",
//     },
//   },
//   AVL: {
//     iataCode: "AVL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 35.44,
//       longitude: -82.54,
//     },
//     shortName: "Asheville",
//     longName: "Asheville Regional Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "AVL",
//       shortName: "Asheville",
//       longName: "Asheville",
//     },
//   },
//   CLT: {
//     iataCode: "CLT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 35.21,
//       longitude: -80.95,
//     },
//     shortName: "Charlotte",
//     longName: "Douglas Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "CLT",
//       shortName: "Charlotte",
//       longName: "Charlotte",
//     },
//   },
//   GSO: {
//     iataCode: "GSO",
//     showAsOrigin: true,
//     sellingPOS: "RDU",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 36.1,
//       longitude: -79.94,
//     },
//     shortName: "Greensboro",
//     longName: "Piedmont Triad International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "GSO",
//       shortName: "Greensboro",
//       longName: "Greensboro",
//     },
//   },
//   RDU: {
//     iataCode: "RDU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 35.88,
//       longitude: -78.79,
//     },
//     shortName: "Raleigh",
//     longName: "Durham Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "RDU",
//       shortName: "Raleigh",
//       longName: "Raleigh",
//     },
//   },
//   CVG: {
//     iataCode: "CVG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 39.05,
//       longitude: -84.67,
//     },
//     shortName: "Cincinnati",
//     longName: "Cincinnati International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "CVG",
//       shortName: "Cincinnati",
//       longName: "Cincinnati",
//     },
//   },
//   CLE: {
//     iataCode: "CLE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 41.41,
//       longitude: -81.85,
//     },
//     shortName: "Cleveland",
//     longName: "Hopkins International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "CLE",
//       shortName: "Cleveland",
//       longName: "Cleveland",
//     },
//   },
//   CMH: {
//     iataCode: "CMH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 40,
//       longitude: -82.89,
//     },
//     shortName: "Columbus",
//     longName: "Port Columbus International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "CMH",
//       shortName: "Columbus",
//       longName: "Columbus",
//     },
//   },
//   DAY: {
//     iataCode: "DAY",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 39.9,
//       longitude: -84.22,
//     },
//     shortName: "Dayton",
//     longName: "James M. Cox Dayton International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "DAY",
//       shortName: "Dayton",
//       longName: "Dayton",
//     },
//   },
//   OKC: {
//     iataCode: "OKC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 35.39,
//       longitude: -97.6,
//     },
//     shortName: "Oklahoma City",
//     longName: "Will Rogers Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "OKC",
//       shortName: "Oklahoma City",
//       longName: "Oklahoma City",
//     },
//   },
//   TUL: {
//     iataCode: "TUL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 36.2,
//       longitude: -95.89,
//     },
//     shortName: "Tulsa",
//     longName: "Tulsa International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "TUL",
//       shortName: "Tulsa",
//       longName: "Tulsa",
//     },
//   },
//   EUG: {
//     iataCode: "EUG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 44.12,
//       longitude: -123.21,
//     },
//     shortName: "Eugene",
//     longName: "Eugene Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "EUG",
//       shortName: "Eugene",
//       longName: "Eugene",
//     },
//   },
//   MFR: {
//     iataCode: "MFR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 42.37,
//       longitude: -122.87,
//     },
//     shortName: "Medford",
//     longName: "Rogue Valley International Medford Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "MFR",
//       shortName: "Medford",
//       longName: "Medford",
//     },
//   },
//   PDX: {
//     iataCode: "PDX",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 45.59,
//       longitude: -122.6,
//     },
//     shortName: "Portland",
//     longName: "Portland",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "PDX",
//       shortName: "Portland Oregon",
//       longName: "Portland Oregon",
//     },
//   },
//   MDT: {
//     iataCode: "MDT",
//     showAsOrigin: true,
//     sellingPOS: "IAD",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 40.19,
//       longitude: -76.76,
//     },
//     shortName: "Harrisburg",
//     longName: "Harrisburg International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "MDT",
//       shortName: "Harrisburg",
//       longName: "Harrisburg",
//     },
//   },
//   PHL: {
//     iataCode: "PHL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 39.87,
//       longitude: -75.24,
//     },
//     shortName: "Philadelphia",
//     longName: "Philadelphia International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "PHL",
//       shortName: "Philadelphia",
//       longName: "Philadelphia",
//     },
//   },
//   PIT: {
//     iataCode: "PIT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 40.49,
//       longitude: -80.23,
//     },
//     shortName: "Pittsburgh",
//     longName: "Pittsburgh International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "PIT",
//       shortName: "Pittsburgh",
//       longName: "Pittsburgh",
//     },
//   },
//   CHS: {
//     iataCode: "CHS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 32.78,
//       longitude: -79.93,
//     },
//     shortName: "Charlestown",
//     longName: "Charleston International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "CHS",
//       shortName: "Charleston",
//       longName: "Charleston",
//     },
//   },
//   CAE: {
//     iataCode: "CAE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 33.94,
//       longitude: -81.12,
//     },
//     shortName: "Columbia",
//     longName: "Columbia Metropolitan Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "CAE",
//       shortName: "Columbia",
//       longName: "Columbia",
//     },
//   },
//   FLO: {
//     iataCode: "FLO",
//     showAsOrigin: true,
//     sellingPOS: "CHS",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 34.19,
//       longitude: -79.72,
//     },
//     shortName: "Florence",
//     longName: "Florence Regional Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "FLO",
//       shortName: "Florence",
//       longName: "Florence",
//     },
//   },
//   MYR: {
//     iataCode: "MYR",
//     showAsOrigin: true,
//     sellingPOS: "CHS",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 33.68,
//       longitude: -78.93,
//     },
//     shortName: "Myrtle Beach",
//     longName: "Myrtle Beach International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "MYR",
//       shortName: "Myrtle Beach",
//       longName: "Myrtle Beach",
//     },
//   },
//   TYS: {
//     iataCode: "TYS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 35.81,
//       longitude: -83.99,
//     },
//     shortName: "Knoxville",
//     longName: "McGhee Tyson Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "TYS",
//       shortName: "Knoxville",
//       longName: "Knoxville",
//     },
//   },
//   MHT: {
//     iataCode: "MHT",
//     showAsOrigin: true,
//     sellingPOS: "BOS",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 42.93,
//       longitude: -71.44,
//     },
//     shortName: "Manchester",
//     longName: "Manchester-Boston Regional Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "MHT",
//       shortName: "Manchester",
//       longName: "Manchester",
//     },
//   },
//   MEM: {
//     iataCode: "MEM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 35.04,
//       longitude: -89.98,
//     },
//     shortName: "Memphis",
//     longName: "Memphis International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "MEM",
//       shortName: "Memphis",
//       longName: "Memphis",
//     },
//   },
//   BNA: {
//     iataCode: "BNA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 36.12,
//       longitude: -86.68,
//     },
//     shortName: "Nashville",
//     longName: "Nashville Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "BNA",
//       shortName: "Nashville",
//       longName: "Nashville",
//     },
//   },
//   ABI: {
//     iataCode: "ABI",
//     showAsOrigin: true,
//     sellingPOS: "DFW",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 32.41,
//       longitude: -99.68,
//     },
//     shortName: "Abilene",
//     longName: "Abilene Regional Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "ABI",
//       shortName: "Abilene",
//       longName: "Abilene",
//     },
//   },
//   AUS: {
//     iataCode: "AUS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 30.19,
//       longitude: -97.67,
//     },
//     shortName: "Austin",
//     longName: "Austin Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "AUS",
//       shortName: "Austin",
//       longName: "Austin",
//     },
//   },
//   CRP: {
//     iataCode: "CRP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 27.77,
//       longitude: -97.5,
//     },
//     shortName: "Corpus Christi",
//     longName: "Corpus Christi International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "CRP",
//       shortName: "Corpus Christi",
//       longName: "Corpus Christi",
//     },
//   },
//   DFW: {
//     iataCode: "DFW",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 32.9,
//       longitude: -97.04,
//     },
//     shortName: "Dallas",
//     longName: "Dallas/Fort Worth International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "DAL",
//       shortName: "Dallas",
//       longName: "Dallas",
//     },
//   },
//   ELP: {
//     iataCode: "ELP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 31.81,
//       longitude: -106.38,
//     },
//     shortName: "El Paso",
//     longName: "El Paso International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "ELP",
//       shortName: "El Paso",
//       longName: "El Paso",
//     },
//   },
//   IAH: {
//     iataCode: "IAH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 29.98,
//       longitude: -95.34,
//     },
//     shortName: "Houston",
//     longName: "George Bush Intercontinental Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "HOU",
//       shortName: "Houston",
//       longName: "Houston",
//     },
//   },
//   LRD: {
//     iataCode: "LRD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 27.54,
//       longitude: -99.46,
//     },
//     shortName: "Laredo Airport",
//     longName: "Laredo International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "LRD",
//       shortName: "Laredo",
//       longName: "Laredo",
//     },
//   },
//   MFE: {
//     iataCode: "MFE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 26.18,
//       longitude: -98.24,
//     },
//     shortName: "Mc Allen Airport",
//     longName: "Mc Allen Miller International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "MFE",
//       shortName: "Mc Allen",
//       longName: "Mc Allen",
//     },
//   },
//   SAT: {
//     iataCode: "SAT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 29.53,
//       longitude: -98.47,
//     },
//     shortName: "San Antonio",
//     longName: "San Antonio International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "SAT",
//       shortName: "San Antonio",
//       longName: "San Antonio",
//     },
//   },
//   SLC: {
//     iataCode: "SLC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 40.79,
//       longitude: -111.98,
//     },
//     shortName: "Salt Lake City",
//     longName: "Salt Lake City International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "SLC",
//       shortName: "Salt Lake City",
//       longName: "Salt Lake City",
//     },
//   },
//   BTV: {
//     iataCode: "BTV",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 44.47,
//       longitude: -73.15,
//     },
//     shortName: "Burlington",
//     longName: "Burlington International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "BTV",
//       shortName: "Burlington",
//       longName: "Burlington",
//     },
//   },
//   RUT: {
//     iataCode: "RUT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 43.53,
//       longitude: -72.95,
//     },
//     shortName: "Rutland Airport",
//     longName: "Rutland Southern Vermont Regional Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "RUT",
//       shortName: "Rutland",
//       longName: "Rutland",
//     },
//   },
//   CHO: {
//     iataCode: "CHO",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 38.14,
//       longitude: -78.45,
//     },
//     shortName: "Charlottesville",
//     longName: "Charlottesville-Albemarle Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "CHO",
//       shortName: "Charlottesville",
//       longName: "Charlottesville",
//     },
//   },
//   ORF: {
//     iataCode: "ORF",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 36.89,
//       longitude: -76.2,
//     },
//     shortName: "Norfolk",
//     longName: "Norfolk International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "ORF",
//       shortName: "Norfolk",
//       longName: "Norfolk",
//     },
//   },
//   RIC: {
//     iataCode: "RIC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 37.51,
//       longitude: -77.32,
//     },
//     shortName: "Richmond",
//     longName: "Richmond International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "RIC",
//       shortName: "Richmond",
//       longName: "Richmond",
//     },
//   },
//   ROA: {
//     iataCode: "ROA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 37.33,
//       longitude: -79.98,
//     },
//     shortName: "Roanoke",
//     longName: "Roanoke Regional Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "ROA",
//       shortName: "Roanoke",
//       longName: "Roanoke",
//     },
//   },
//   BLI: {
//     iataCode: "BLI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 48.79,
//       longitude: -122.54,
//     },
//     shortName: "Bellingham",
//     longName: "Bellingham International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "BLI",
//       shortName: "Bellingham",
//       longName: "Bellingham",
//     },
//   },
//   PSC: {
//     iataCode: "PSC",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 46.26,
//       longitude: -119.12,
//     },
//     shortName: "Pasco",
//     longName: "Tri Cities Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "PSC",
//       shortName: "Pasco",
//       longName: "Pasco",
//     },
//   },
//   PUW: {
//     iataCode: "PUW",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 46.74,
//       longitude: -117.11,
//     },
//     shortName: "Pullman",
//     longName: "Pullman Regional Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "PUW",
//       shortName: "Pullman",
//       longName: "Pullman",
//     },
//   },
//   RDM: {
//     iataCode: "RDM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 44.25,
//       longitude: -121.15,
//     },
//     shortName: "Redmond",
//     longName: "Redmond Municipal Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "RDM",
//       shortName: "Redmond",
//       longName: "Redmond",
//     },
//   },
//   SEA: {
//     iataCode: "SEA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 47.45,
//       longitude: -122.31,
//     },
//     shortName: "Seattle",
//     longName: "Seattle-Tacoma international Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "SEA",
//       shortName: "Seattle",
//       longName: "Seattle",
//     },
//   },
//   GEG: {
//     iataCode: "GEG",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 47.62,
//       longitude: -117.54,
//     },
//     shortName: "Spokane",
//     longName: "Spokane International",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "GEG",
//       shortName: "Spokane",
//       longName: "Spokane",
//     },
//   },
//   ALW: {
//     iataCode: "ALW",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 46.09,
//       longitude: -118.29,
//     },
//     shortName: "Walla Walla",
//     longName: "Walla Walla Regional Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "ALW",
//       shortName: "Walla Walla",
//       longName: "Walla Walla",
//     },
//   },
//   EAT: {
//     iataCode: "EAT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 47.4,
//       longitude: -120.21,
//     },
//     shortName: "Wenatchee",
//     longName: "Pangborn Memorial Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "EAT",
//       shortName: "Wenatchee",
//       longName: "Wenatchee",
//     },
//   },
//   YKM: {
//     iataCode: "YKM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 46.57,
//       longitude: -120.54,
//     },
//     shortName: "Yakima",
//     longName: "Yakima Air Terminal",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "YKM",
//       shortName: "Yakima",
//       longName: "Yakima",
//     },
//   },
//   CRW: {
//     iataCode: "CRW",
//     showAsOrigin: true,
//     sellingPOS: "PIT",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 38.37,
//       longitude: -81.59,
//     },
//     shortName: "Charleston",
//     longName: "Yeager Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "CRW",
//       shortName: "Charleston",
//       longName: "Charleston",
//     },
//   },
//   MKE: {
//     iataCode: "MKE",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 42.95,
//       longitude: -87.9,
//     },
//     shortName: "Milwaukee",
//     longName: "General Mitchell Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "MKE",
//       shortName: "Milwaukee",
//       longName: "Milwaukee",
//     },
//   },
//   ORH: {
//     iataCode: "ORH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 42.27,
//       longitude: -71.88,
//     },
//     shortName: "Worcester Airport",
//     longName: "Worcester Regional Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "ORH",
//       shortName: "Worcester",
//       longName: "Worcester",
//     },
//   },
//   HPN: {
//     iataCode: "HPN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 41.07,
//       longitude: -73.71,
//     },
//     shortName: "Westchester Airport",
//     longName: "Westchester White Plains County Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "HPN",
//       shortName: "White Plains",
//       longName: "White Plains",
//     },
//   },
//   AVP: {
//     iataCode: "AVP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 41.34,
//       longitude: -75.72,
//     },
//     shortName: "Wilkes Barre Scranton Airport",
//     longName: "Wilkes Barre Scranton International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "USA",
//       code: "US",
//       shortName: "United States",
//       longName: "United States",
//       otherRegion: {
//         shortName: "North America",
//         longName: "North America",
//       },
//     },
//     city: {
//       code: "AVP",
//       shortName: "Wilkes-Barre/Scranton",
//       longName: "Wilkes-Barre/Scranton",
//     },
//   },
//   MVD: {
//     iataCode: "MVD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: -34.83,
//       longitude: -56.03,
//     },
//     shortName: "Montevideo",
//     longName: "Carrasco General Cesáreo L. Berisso International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "URY",
//       code: "UY",
//       shortName: "Uruguay",
//       longName: "Uruguay",
//     },
//     city: {
//       code: "MVD",
//       shortName: "Montevideo",
//       longName: "Montevideo",
//     },
//   },
//   CCS: {
//     iataCode: "CCS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 10.6,
//       longitude: -66.99,
//     },
//     shortName: "Caracas",
//     longName: "Simón Bolívar International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "VEN",
//       code: "VE",
//       shortName: "Venezuela",
//       longName: "Venezuela",
//     },
//     city: {
//       code: "CCS",
//       shortName: "Caracas",
//       longName: "Caracas",
//     },
//   },
//   MAR: {
//     iataCode: "MAR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 10.56,
//       longitude: -71.73,
//     },
//     shortName: "Maracaibo",
//     longName: "La Chinita International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "VEN",
//       code: "VE",
//       shortName: "Venezuela",
//       longName: "Venezuela",
//     },
//     city: {
//       code: "MAR",
//       shortName: "Maracaibo",
//       longName: "Maracaibo",
//     },
//   },
//   VLN: {
//     iataCode: "VLN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 10.15,
//       longitude: -67.93,
//     },
//     shortName: "Valencia Venezuela Airport",
//     longName: "Valencia Arturo Michelena Int Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Americas",
//       longName: "The Americas",
//       code: "NASA",
//     },
//     country: {
//       a3code: "VEN",
//       code: "VE",
//       shortName: "Venezuela",
//       longName: "Venezuela",
//     },
//     city: {
//       code: "VLN",
//       shortName: "Valencia Venezuela",
//       longName: "Valencia Venezuela",
//     },
//   },
//   BAH: {
//     iataCode: "BAH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 26.27,
//       longitude: 50.63,
//     },
//     shortName: "Bahrain",
//     longName: "Bahrain International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "BHR",
//       code: "BH",
//       shortName: "Bahrain",
//       longName: "Bahrain",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "BAH",
//       shortName: "Bahrain",
//       longName: "Bahrain",
//     },
//   },
//   AWZ: {
//     iataCode: "AWZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 31.34,
//       longitude: 48.76,
//     },
//     shortName: "Ahwaz Airport",
//     longName: "Ahwaz Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "IRN",
//       code: "IR",
//       shortName: "Iran",
//       longName: "Iran",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "AWZ",
//       shortName: "Ahwaz",
//       longName: "Ahwaz",
//     },
//   },
//   BND: {
//     iataCode: "BND",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 27.22,
//       longitude: 56.38,
//     },
//     shortName: "Bandar Abbas Airport",
//     longName: "Bandar Abbas International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "IRN",
//       code: "IR",
//       shortName: "Iran",
//       longName: "Iran",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "BND",
//       shortName: "Bandar Abbas",
//       longName: "Bandar Abbas",
//     },
//   },
//   BUZ: {
//     iataCode: "BUZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 28.94,
//       longitude: 50.83,
//     },
//     shortName: "Bushehr Airport",
//     longName: "Bushehr Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "IRN",
//       code: "IR",
//       shortName: "Iran",
//       longName: "Iran",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "BUZ",
//       shortName: "Bushehr",
//       longName: "Bushehr",
//     },
//   },
//   MHD: {
//     iataCode: "MHD",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 36.24,
//       longitude: 59.64,
//     },
//     shortName: "Mashhad",
//     longName: "Mashhad Shahid Hashemi Nejad",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "IRN",
//       code: "IR",
//       shortName: "Iran",
//       longName: "Iran",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "MHD",
//       shortName: "Mashhad",
//       longName: "Mashhad",
//     },
//   },
//   IKA: {
//     iataCode: "IKA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 35.42,
//       longitude: 51.15,
//     },
//     shortName: "Tehran",
//     longName: "Imam Khomeini International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "IRN",
//       code: "IR",
//       shortName: "Iran",
//       longName: "Iran",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "THR",
//       shortName: "Tehran",
//       longName: "Tehran",
//     },
//   },
//   IFN: {
//     iataCode: "IFN",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 32.75,
//       longitude: 51.86,
//     },
//     shortName: "Isfahan Airport",
//     longName: "Isfahan International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "IRN",
//       code: "IR",
//       shortName: "Iran",
//       longName: "Iran",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "IFN",
//       shortName: "Isfahan",
//       longName: "Isfahan",
//     },
//   },
//   KER: {
//     iataCode: "KER",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 30.27,
//       longitude: 56.95,
//     },
//     shortName: "Kerman Airport",
//     longName: "Kerman Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "IRN",
//       code: "IR",
//       shortName: "Iran",
//       longName: "Iran",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "KER",
//       shortName: "Kerman",
//       longName: "Kerman",
//     },
//   },
//   KIH: {
//     iataCode: "KIH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 26.53,
//       longitude: 53.98,
//     },
//     shortName: "Kish Airport",
//     longName: "Kish International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "IRN",
//       code: "IR",
//       shortName: "Iran",
//       longName: "Iran",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "KIH",
//       shortName: "Kish Island",
//       longName: "Kish Island",
//     },
//   },
//   LRR: {
//     iataCode: "LRR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 27.67,
//       longitude: 54.38,
//     },
//     shortName: "Lar Airport",
//     longName: "Lar Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "IRN",
//       code: "IR",
//       shortName: "Iran",
//       longName: "Iran",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "LRR",
//       shortName: "Lar",
//       longName: "Lar",
//     },
//   },
//   GSM: {
//     iataCode: "GSM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 26.95,
//       longitude: 56.27,
//     },
//     shortName: "Qeshm Airport",
//     longName: "Qeshm International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "IRN",
//       code: "IR",
//       shortName: "Iran",
//       longName: "Iran",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "GSM",
//       shortName: "Qeshm",
//       longName: "Qeshm",
//     },
//   },
//   SYZ: {
//     iataCode: "SYZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 29.54,
//       longitude: 52.59,
//     },
//     shortName: "Shiraz Airport",
//     longName: "Shiraz Shahid Dastghaib International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "IRN",
//       code: "IR",
//       shortName: "Iran",
//       longName: "Iran",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "SYZ",
//       shortName: "Shiraz",
//       longName: "Shiraz",
//     },
//   },
//   TBZ: {
//     iataCode: "TBZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 38.13,
//       longitude: 46.24,
//     },
//     shortName: "Tabriz Airport",
//     longName: "Tabriz International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "IRN",
//       code: "IR",
//       shortName: "Iran",
//       longName: "Iran",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "TBZ",
//       shortName: "Tabriz",
//       longName: "Tabriz",
//     },
//   },
//   EBL: {
//     iataCode: "EBL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 36.24,
//       longitude: 43.95,
//     },
//     shortName: "Erbil",
//     longName: "Erbil International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "IRQ",
//       code: "IQ",
//       shortName: "Iraq",
//       longName: "Iraq",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "EBL",
//       shortName: "Erbil",
//       longName: "Erbil",
//     },
//   },
//   BGW: {
//     iataCode: "BGW",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 33.26,
//       longitude: 44.23,
//     },
//     shortName: "Baghdad",
//     longName: "Baghdad International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "IRQ",
//       code: "IQ",
//       shortName: "Iraq",
//       longName: "Iraq",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "BGW",
//       shortName: "Baghdad",
//       longName: "Baghdad",
//     },
//   },
//   BSR: {
//     iataCode: "BSR",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 30.55,
//       longitude: 47.66,
//     },
//     shortName: "Basra",
//     longName: "Basra International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "IRQ",
//       code: "IQ",
//       shortName: "Iraq",
//       longName: "Iraq",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "BSR",
//       shortName: "Basra",
//       longName: "Basra",
//     },
//   },
//   NJF: {
//     iataCode: "NJF",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 31.99,
//       longitude: 44.4,
//     },
//     shortName: "Najaf",
//     longName: "Al Najaf International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "IRQ",
//       code: "IQ",
//       shortName: "Iraq",
//       longName: "Iraq",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "NJF",
//       shortName: "Najaf",
//       longName: "Najaf",
//     },
//   },
//   ISU: {
//     iataCode: "ISU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 35.56,
//       longitude: 45.31,
//     },
//     shortName: "Sulaymaniyah",
//     longName: "Sulaimaniyah International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "IRQ",
//       code: "IQ",
//       shortName: "Iraq",
//       longName: "Iraq",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "ISU",
//       shortName: "Sulaymaniyah",
//       longName: "Sulaymaniyah",
//     },
//   },
//   TLV: {
//     iataCode: "TLV",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 32.01,
//       longitude: 34.89,
//     },
//     shortName: "Tel Aviv",
//     longName: "Tel Aviv Ben Gurion International Airport ",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "ISR",
//       code: "IL",
//       shortName: "Israel",
//       longName: "Israel",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "TLV",
//       shortName: "Tel Aviv",
//       longName: "Tel Aviv",
//     },
//   },
//   AMM: {
//     iataCode: "AMM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 31.72,
//       longitude: 35.99,
//     },
//     shortName: "Amman",
//     longName: "Queen Alia International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "JOR",
//       code: "JO",
//       shortName: "Jordan",
//       longName: "Jordan",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "AMM",
//       shortName: "Amman",
//       longName: "Amman",
//     },
//   },
//   AQJ: {
//     iataCode: "AQJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 29.61,
//       longitude: 35.02,
//     },
//     shortName: "Aqaba Airport",
//     longName: "Aqaba King Hussein International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "JOR",
//       code: "JO",
//       shortName: "Jordan",
//       longName: "Jordan",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "AQJ",
//       shortName: "Aqaba",
//       longName: "Aqaba",
//     },
//   },
//   KWI: {
//     iataCode: "KWI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 29.23,
//       longitude: 47.98,
//     },
//     shortName: "Kuwait",
//     longName: "Kuwait International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "KWT",
//       code: "KW",
//       shortName: "Kuwait",
//       longName: "Kuwait",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "KWI",
//       shortName: "Kuwait",
//       longName: "Kuwait City",
//     },
//   },
//   BEY: {
//     iataCode: "BEY",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 33.82,
//       longitude: 35.49,
//     },
//     shortName: "Beirut",
//     longName: "Rafic Hariri International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "LBN",
//       code: "LB",
//       shortName: "Lebanon",
//       longName: "Lebanon",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "BEY",
//       shortName: "Beirut",
//       longName: "Beirut",
//     },
//   },
//   SLL: {
//     iataCode: "SLL",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 17.04,
//       longitude: 54.09,
//     },
//     shortName: "Salalah",
//     longName: "Salalah Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "OMN",
//       code: "OM",
//       shortName: "Oman",
//       longName: "Oman",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "SLL",
//       shortName: "Salalah",
//       longName: "Salalah",
//     },
//   },
//   MCT: {
//     iataCode: "MCT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 23.59,
//       longitude: 58.28,
//     },
//     shortName: "Muscat",
//     longName: "Muscat International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "OMN",
//       code: "OM",
//       shortName: "Oman",
//       longName: "Oman",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "MCT",
//       shortName: "Muscat",
//       longName: "Muscat",
//     },
//   },
//   DIA: {
//     iataCode: "DIA",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 25.26,
//       longitude: 51.61,
//     },
//     shortName: "Doha International Airport",
//     longName: "Doha International Airport",
//     nearbyAirports: ["DOH"],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "QAT",
//       code: "QA",
//       shortName: "Qatar",
//       longName: "Qatar",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "DOH",
//       shortName: "Doha",
//       longName: "Doha",
//     },
//   },
//   DOH: {
//     iataCode: "DOH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 25.26,
//       longitude: 51.57,
//     },
//     shortName: "Doha",
//     longName: "Hamad International Airport",
//     nearbyAirports: ["DIA"],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "QAT",
//       code: "QA",
//       shortName: "Qatar",
//       longName: "Qatar",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "DOH",
//       shortName: "Doha",
//       longName: "Doha",
//     },
//   },
//   ABT: {
//     iataCode: "ABT",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 20.3,
//       longitude: 41.63,
//     },
//     shortName: "Al Baha Airport",
//     longName: "Al Baha Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "SAU",
//       code: "SA",
//       shortName: "Saudi Arabia",
//       longName: "Saudi Arabia",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "ABT",
//       shortName: "Al Baha",
//       longName: "Al Baha",
//     },
//   },
//   ULH: {
//     iataCode: "ULH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 26.48,
//       longitude: 38.13,
//     },
//     shortName: "AlUla Airport",
//     longName: "AlUla Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "SAU",
//       code: "SA",
//       shortName: "Saudi Arabia",
//       longName: "Saudi Arabia",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "ULH",
//       shortName: "AlUla",
//       longName: "AlUla",
//     },
//   },
//   GIZ: {
//     iataCode: "GIZ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 16.9,
//       longitude: 42.59,
//     },
//     shortName: "Jizan Airport",
//     longName: "Jizan King Abdullah bin Abdulaziz Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "SAU",
//       code: "SA",
//       shortName: "Saudi Arabia",
//       longName: "Saudi Arabia",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "GIZ",
//       shortName: "Jizan",
//       longName: "Jizan",
//     },
//   },
//   EAM: {
//     iataCode: "EAM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 17.61,
//       longitude: 44.42,
//     },
//     shortName: "Nejran Airport",
//     longName: "Nejran Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "SAU",
//       code: "SA",
//       shortName: "Saudi Arabia",
//       longName: "Saudi Arabia",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "EAM",
//       shortName: "Nejran",
//       longName: "Nejran",
//     },
//   },
//   NUM: {
//     iataCode: "NUM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 25.34,
//       longitude: 45.43,
//     },
//     shortName: "Neom Bay Airport",
//     longName: "Neom Bay Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "SAU",
//       code: "SA",
//       shortName: "Saudi Arabia",
//       longName: "Saudi Arabia",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "NUM",
//       shortName: "Neom Bay",
//       longName: "Neom Bay",
//     },
//   },
//   AQI: {
//     iataCode: "AQI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 28.34,
//       longitude: 46.13,
//     },
//     shortName: "Qaisumah Airport",
//     longName: "Al Qaisumah Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "SAU",
//       code: "SA",
//       shortName: "Saudi Arabia",
//       longName: "Saudi Arabia",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "AQI",
//       shortName: "Qaisumah",
//       longName: "Qaisumah",
//     },
//   },
//   AJF: {
//     iataCode: "AJF",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 29.79,
//       longitude: 40.1,
//     },
//     shortName: "Al Jouf Airport",
//     longName: "Al Jouf Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "SAU",
//       code: "SA",
//       shortName: "Saudi Arabia",
//       longName: "Saudi Arabia",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "AJF",
//       shortName: "Al Jouf",
//       longName: "Al Jouf",
//     },
//   },
//   AHB: {
//     iataCode: "AHB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 18.24,
//       longitude: 42.66,
//     },
//     shortName: "Abha",
//     longName: "Abha Regional Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "SAU",
//       code: "SA",
//       shortName: "Saudi Arabia",
//       longName: "Saudi Arabia",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "AHB",
//       shortName: "Abha",
//       longName: "Abha",
//     },
//   },
//   DMS: {
//     iataCode: "DMS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "1",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 26.47,
//       longitude: 49.8,
//     },
//     shortName: "Khobar Sabtco Bus Station",
//     longName: "Khobar Sabtco Bus Station",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "SAU",
//       code: "SA",
//       shortName: "Saudi Arabia",
//       longName: "Saudi Arabia",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "DMM",
//       shortName: "Dammam",
//       longName: "Dammam",
//     },
//   },
//   DMM: {
//     iataCode: "DMM",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 26.47,
//       longitude: 49.8,
//     },
//     shortName: "Dammam",
//     longName: "King Fahd International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "SAU",
//       code: "SA",
//       shortName: "Saudi Arabia",
//       longName: "Saudi Arabia",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "DMM",
//       shortName: "Dammam",
//       longName: "Dammam",
//     },
//   },
//   HAS: {
//     iataCode: "HAS",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 27.44,
//       longitude: 41.69,
//     },
//     shortName: "Ha'il",
//     longName: "Ha'il Regional Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "SAU",
//       code: "SA",
//       shortName: "Saudi Arabia",
//       longName: "Saudi Arabia",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "HAS",
//       shortName: "Ha'il",
//       longName: "Ha'il",
//     },
//   },
//   HOF: {
//     iataCode: "HOF",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 25.29,
//       longitude: 49.49,
//     },
//     shortName: "Hofuf Airport",
//     longName: "Hofuf Al Ahsa Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "SAU",
//       code: "SA",
//       shortName: "Saudi Arabia",
//       longName: "Saudi Arabia",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "HOF",
//       shortName: "Hofuf",
//       longName: "Hofuf",
//     },
//   },
//   MED: {
//     iataCode: "MED",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 24.55,
//       longitude: 39.71,
//     },
//     shortName: "Medina",
//     longName: "Prince Mohammad Bin Abdulaziz Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "SAU",
//       code: "SA",
//       shortName: "Saudi Arabia",
//       longName: "Saudi Arabia",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "MED",
//       shortName: "Medina",
//       longName: "Medina (Madinah)",
//     },
//   },
//   YNB: {
//     iataCode: "YNB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 24.14,
//       longitude: 38.06,
//     },
//     shortName: "Yanbu",
//     longName: "Yanbu International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "SAU",
//       code: "SA",
//       shortName: "Saudi Arabia",
//       longName: "Saudi Arabia",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "YNB",
//       shortName: "Yanbu",
//       longName: "Yanbu",
//     },
//   },
//   JED: {
//     iataCode: "JED",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 21.68,
//       longitude: 39.16,
//     },
//     shortName: "Jeddah",
//     longName: "King Abdulaziz International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "SAU",
//       code: "SA",
//       shortName: "Saudi Arabia",
//       longName: "Saudi Arabia",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "JED",
//       shortName: "Jeddah",
//       longName: "Jeddah",
//     },
//   },
//   TIF: {
//     iataCode: "TIF",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 21.48,
//       longitude: 40.54,
//     },
//     shortName: "Ta’if",
//     longName: "Ta’if Regional Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "SAU",
//       code: "SA",
//       shortName: "Saudi Arabia",
//       longName: "Saudi Arabia",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "TIF",
//       shortName: "Ta’if",
//       longName: "Ta’if",
//     },
//   },
//   ELQ: {
//     iataCode: "ELQ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 26.3,
//       longitude: 43.77,
//     },
//     shortName: "Buraidah",
//     longName: "Qassim Regional Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "SAU",
//       code: "SA",
//       shortName: "Saudi Arabia",
//       longName: "Saudi Arabia",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "ELQ",
//       shortName: "Buraidah",
//       longName: "Buraidah",
//     },
//   },
//   RUH: {
//     iataCode: "RUH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 24.96,
//       longitude: 46.71,
//     },
//     shortName: "Riyadh International Airport",
//     longName: "King Khalid International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "SAU",
//       code: "SA",
//       shortName: "Saudi Arabia",
//       longName: "Saudi Arabia",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "RUH",
//       shortName: "Riyadh",
//       longName: "Riyadh",
//     },
//   },
//   TUU: {
//     iataCode: "TUU",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 28.37,
//       longitude: 36.62,
//     },
//     shortName: "Tabuk",
//     longName: "Tabuk Regional Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "SAU",
//       code: "SA",
//       shortName: "Saudi Arabia",
//       longName: "Saudi Arabia",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "TUU",
//       shortName: "Tabuk",
//       longName: "Tabuk",
//     },
//   },
//   RSI: {
//     iataCode: "RSI",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 25.63,
//       longitude: 37.08,
//     },
//     shortName: "Red Sea Airport",
//     longName: "Red Sea International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "SAU",
//       code: "SA",
//       shortName: "Saudi Arabia",
//       longName: "Saudi Arabia",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "RSI",
//       shortName: "The Red Sea",
//       longName: "The Red Sea",
//     },
//   },
//   ALP: {
//     iataCode: "ALP",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 36.18,
//       longitude: 37.23,
//     },
//     shortName: "Aleppo",
//     longName: "Aleppo International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "SYR",
//       code: "SY",
//       shortName: "Syria",
//       longName: "Syria",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "ALP",
//       shortName: "Aleppo",
//       longName: "Aleppo",
//     },
//   },
//   LTK: {
//     iataCode: "LTK",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: true,
//     isGBE: false,
//     isOFW: false,
//     geoCoordinates: {
//       latitude: 35.41,
//       longitude: 35.95,
//     },
//     shortName: "Latakia",
//     longName: "Bassel Al-Assad International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "SYR",
//       code: "SY",
//       shortName: "Syria",
//       longName: "Syria",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "LTK",
//       shortName: "Latakia",
//       longName: "Latakia",
//     },
//   },
//   ZVJ: {
//     iataCode: "ZVJ",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "1",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 24.47,
//       longitude: 54.38,
//     },
//     shortName: "Abu Dhabi (BUS)",
//     longName: "Emirates Down Town Office - Khalidiya - Corniche",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "ARE",
//       code: "AE",
//       shortName: "United Arab Emirates",
//       alternateNames: ["UAE"],
//       longName: "United Arab Emirates",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "AUH",
//       shortName: "Abu Dhabi",
//       longName: "Abu Dhabi",
//     },
//   },
//   ZVH: {
//     iataCode: "ZVH",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "1",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 23.88,
//       longitude: 55.27,
//     },
//     shortName: "Al Ain (BUS)",
//     longName: "Commercial Complex, Shaikh Khalifa Street",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "ARE",
//       code: "AE",
//       shortName: "United Arab Emirates",
//       alternateNames: ["UAE"],
//       longName: "United Arab Emirates",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "AAN",
//       shortName: "Al Ain",
//       longName: "Al Ain",
//     },
//   },
//   DXB: {
//     iataCode: "DXB",
//     showAsOrigin: true,
//     sellingPOS: "",
//     stationType: "0",
//     isInterlineOperated: false,
//     isGBE: false,
//     isOFW: false,
//     isEK: "Yes",
//     geoCoordinates: {
//       latitude: 25.25,
//       longitude: 55.36,
//     },
//     shortName: "Dubai",
//     longName: "Dubai International Airport",
//     nearbyAirports: [],
//     region: {
//       shortName: "The Middle East",
//       longName: "The Middle East",
//       code: "MIEA",
//     },
//     country: {
//       a3code: "ARE",
//       code: "AE",
//       shortName: "United Arab Emirates",
//       alternateNames: ["UAE"],
//       longName: "United Arab Emirates",
//       otherRegion: {
//         shortName: "Gulf and Middle East",
//         longName: "Gulf and Middle East",
//       },
//     },
//     city: {
//       code: "DXB",
//       shortName: "Dubai",
//       longName: "Dubai",
//     },
//   },
// }

const data = [
          {
              "cityCode": "MCZ",
              "cityName": "Maceio",
              "code": "MCZ",
              "countryName": "Brazil",
              "displayText": "Maceio, Palmares",
              "isDestination": true,
              "isOrigin": true,
              "label": "Palmares",
              "phoneticLabel": null,
              "searchText": "mcz palmares brazil maceio",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BEL",
              "cityName": "Belem",
              "code": "BEL",
              "countryName": "Brazil",
              "displayText": "Belem, Val De Cans",
              "isDestination": true,
              "isOrigin": true,
              "label": "Val De Cans",
              "phoneticLabel": null,
              "searchText": "bel val de cans brazil belem",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "POA",
              "cityName": "Porto Alegre",
              "code": "POA",
              "countryName": "Brazil",
              "displayText": "Porto Alegre, Salgado Filho",
              "isDestination": true,
              "isOrigin": true,
              "label": "Salgado Filho",
              "phoneticLabel": null,
              "searchText": "poa salgado filho brazil porto alegre",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BVB",
              "cityName": "Boa Vista",
              "code": "BVB",
              "countryName": "Brazil",
              "displayText": "Boa Vista, Boa Vista International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Boa Vista International Airport",
              "phoneticLabel": null,
              "searchText": "bvb boa vista international airport brazil boa vista",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "OPS",
              "cityName": "Sinop",
              "code": "OPS",
              "countryName": "Brazil",
              "displayText": "Sinop, Presidente João Batista Figueiredo Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Presidente João Batista Figueiredo Airport",
              "phoneticLabel": null,
              "searchText": "ops presidente joão batista figueiredo airport brazil sinop",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PFB",
              "cityName": "Passo Fundo",
              "code": "PFB",
              "countryName": "Brazil",
              "displayText": "Passo Fundo, Passo Fundo Lauro Kurtz Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Passo Fundo Lauro Kurtz Airport",
              "phoneticLabel": null,
              "searchText": "pfb passo fundo lauro kurtz airport brazil passo fundo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "JDO",
              "cityName": "Juazeiro do Norte",
              "code": "JDO",
              "countryName": "Brazil",
              "displayText": "Juazeiro do Norte, Cariri Regional Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Cariri Regional Airport",
              "phoneticLabel": null,
              "searchText": "jdo cariri regional airport brazil juazeiro do norte",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PMW",
              "cityName": "Palmas",
              "code": "PMW",
              "countryName": "Brazil",
              "displayText": "Palmas, Brigadeiro Lysias Rodrigues Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Brigadeiro Lysias Rodrigues Airport",
              "phoneticLabel": null,
              "searchText": "pmw brigadeiro lysias rodrigues airport brazil palmas",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "RIO",
              "cityName": "Rio de Janeiro",
              "code": "RIO",
              "countryName": "Brazil",
              "displayText": "Rio de Janeiro",
              "isDestination": true,
              "isOrigin": true,
              "label": "Rio de Janeiro",
              "phoneticLabel": null,
              "searchText": "rio rio de janeiro brazil",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "RIO",
              "cityName": "Rio de Janeiro",
              "code": "SDU",
              "countryName": "Brazil",
              "displayText": "Rio de Janeiro, Santos Dumont Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Santos Dumont Airport",
              "phoneticLabel": null,
              "searchText": "sdu santos dumont airport brazil rio de janeiro",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "RIO",
              "cityName": "Rio de Janeiro",
              "code": "GIG",
              "countryName": "Brazil",
              "displayText": "Rio de Janeiro, Rio Internacional",
              "isDestination": true,
              "isOrigin": true,
              "label": "Rio Internacional",
              "phoneticLabel": null,
              "searchText": "gig rio internacional brazil rio de janeiro",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BHZ",
              "cityName": "Belo Horizonte",
              "code": "CNF",
              "countryName": "Brazil",
              "displayText": "Belo Horizonte, Tancredo Neves",
              "isDestination": true,
              "isOrigin": true,
              "label": "Tancredo Neves",
              "phoneticLabel": null,
              "searchText": "cnf tancredo neves brazil belo horizonte",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "IOS",
              "cityName": "Ilheus",
              "code": "IOS",
              "countryName": "Brazil",
              "displayText": "Ilheus, Jorge Amado Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Jorge Amado Airport",
              "phoneticLabel": null,
              "searchText": "ios jorge amado airport brazil ilheus",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "REC",
              "cityName": "Recife",
              "code": "REC",
              "countryName": "Brazil",
              "displayText": "Recife, Guararapes International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Guararapes International",
              "phoneticLabel": null,
              "searchText": "rec guararapes international brazil recife",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "JPA",
              "cityName": "Joao Pessoa",
              "code": "JPA",
              "countryName": "Brazil",
              "displayText": "Joao Pessoa, Castro Pinto",
              "isDestination": true,
              "isOrigin": true,
              "label": "Castro Pinto",
              "phoneticLabel": null,
              "searchText": "jpa castro pinto brazil joao pessoa",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SJP",
              "cityName": "Sao Jose do Rio Preto",
              "code": "SJP",
              "countryName": "Brazil",
              "displayText": "Sao Jose do Rio Preto, Sao Jose Do Rio Preto",
              "isDestination": true,
              "isOrigin": true,
              "label": "Sao Jose Do Rio Preto",
              "phoneticLabel": null,
              "searchText": "sjp sao jose do rio preto brazil sao jose do rio preto",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SAO",
              "cityName": "Sao Paulo",
              "code": "SAO",
              "countryName": "Brazil",
              "displayText": "Sao Paulo",
              "isDestination": true,
              "isOrigin": true,
              "label": "Sao Paulo",
              "phoneticLabel": null,
              "searchText": "sao sao paulo brazil",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "SAO",
              "cityName": "Sao Paulo",
              "code": "CGH",
              "countryName": "Brazil",
              "displayText": "Sao Paulo, Congonhas",
              "isDestination": true,
              "isOrigin": true,
              "label": "Congonhas",
              "phoneticLabel": null,
              "searchText": "cgh congonhas brazil sao paulo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SAO",
              "cityName": "Sao Paulo",
              "code": "GRU",
              "countryName": "Brazil",
              "displayText": "Sao Paulo, Guarulhos International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Guarulhos International",
              "phoneticLabel": null,
              "searchText": "gru guarulhos international brazil sao paulo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SAO",
              "cityName": "Sao Paulo",
              "code": "VCP",
              "countryName": "Brazil",
              "displayText": "Sao Paulo, Viracopos-Campinas International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Viracopos-Campinas International Airport",
              "phoneticLabel": null,
              "searchText": "vcp viracopos-campinas international airport brazil sao paulo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "IGU",
              "cityName": "Foz do Iguacu",
              "code": "IGU",
              "countryName": "Brazil",
              "displayText": "Foz do Iguacu, Iguaçu International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Iguaçu International Airport",
              "phoneticLabel": null,
              "searchText": "igu iguaçu international airport brazil foz do iguacu",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SSA",
              "cityName": "Salvador",
              "code": "SSA",
              "countryName": "Brazil",
              "displayText": "Salvador, Luis E Magalhaes",
              "isDestination": true,
              "isOrigin": true,
              "label": "Luis E Magalhaes",
              "phoneticLabel": null,
              "searchText": "ssa luis e magalhaes brazil salvador",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "QNS",
              "cityName": "Canoas",
              "code": "QNS",
              "countryName": "Brazil",
              "displayText": "Canoas, Canoas Campo Nossa Senhora de Fatima",
              "isDestination": true,
              "isOrigin": true,
              "label": "Canoas Campo Nossa Senhora de Fatima",
              "phoneticLabel": null,
              "searchText": "qns canoas campo nossa senhora de fatima brazil canoas",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "GYN",
              "cityName": "Goiania",
              "code": "GYN",
              "countryName": "Brazil",
              "displayText": "Goiania, Santa Genoveva",
              "isDestination": true,
              "isOrigin": true,
              "label": "Santa Genoveva",
              "phoneticLabel": null,
              "searchText": "gyn santa genoveva brazil goiania",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "XOE",
              "cityName": "Sao Jose",
              "code": "JJD",
              "countryName": "Brazil",
              "displayText": "Sao Jose, Jericoacoara Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Jericoacoara Airport",
              "phoneticLabel": null,
              "searchText": "jjd jericoacoara airport brazil sao jose",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "JJG",
              "cityName": "Jaguaruna",
              "code": "JJG",
              "countryName": "Brazil",
              "displayText": "Jaguaruna, Humberto Bortoluzzi Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Humberto Bortoluzzi Airport",
              "phoneticLabel": null,
              "searchText": "jjg humberto bortoluzzi airport brazil jaguaruna",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BSB",
              "cityName": "Brasilia",
              "code": "BSB",
              "countryName": "Brazil",
              "displayText": "Brasilia, Brasilia International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Brasilia International Airport",
              "phoneticLabel": null,
              "searchText": "bsb brasilia international airport brazil brasilia",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "VIX",
              "cityName": "Vitoria",
              "code": "VIX",
              "countryName": "Brazil",
              "displayText": "Vitoria, Eurico Sales",
              "isDestination": true,
              "isOrigin": true,
              "label": "Eurico Sales",
              "phoneticLabel": null,
              "searchText": "vix eurico sales brazil vitoria",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PNZ",
              "cityName": "Petrolina",
              "code": "PNZ",
              "countryName": "Brazil",
              "displayText": "Petrolina, Senador Nilo Coelho International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Senador Nilo Coelho International Airport",
              "phoneticLabel": null,
              "searchText": "pnz senador nilo coelho international airport brazil petrolina",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BPS",
              "cityName": "Porto Seguro",
              "code": "BPS",
              "countryName": "Brazil",
              "displayText": "Porto Seguro, Porto Seguro",
              "isDestination": true,
              "isOrigin": true,
              "label": "Porto Seguro",
              "phoneticLabel": null,
              "searchText": "bps porto seguro brazil porto seguro",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "FOR",
              "cityName": "Fortaleza",
              "code": "FOR",
              "countryName": "Brazil",
              "displayText": "Fortaleza, Pinto Martins",
              "isDestination": true,
              "isOrigin": true,
              "label": "Pinto Martins",
              "phoneticLabel": null,
              "searchText": "for pinto martins brazil fortaleza",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "JOI",
              "cityName": "Joinville",
              "code": "JOI",
              "countryName": "Brazil",
              "displayText": "Joinville, Lauro Carneiro Loyola",
              "isDestination": true,
              "isOrigin": true,
              "label": "Lauro Carneiro Loyola",
              "phoneticLabel": null,
              "searchText": "joi lauro carneiro loyola brazil joinville",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "THE",
              "cityName": "Teresina",
              "code": "THE",
              "countryName": "Brazil",
              "displayText": "Teresina, Senador Petrônio Portella Regional Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Senador Petrônio Portella Regional Airport",
              "phoneticLabel": null,
              "searchText": "the senador petrônio portella regional airport brazil teresina",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CWB",
              "cityName": "Curitiba",
              "code": "CWB",
              "countryName": "Brazil",
              "displayText": "Curitiba, Afonso Pena",
              "isDestination": true,
              "isOrigin": true,
              "label": "Afonso Pena",
              "phoneticLabel": null,
              "searchText": "cwb afonso pena brazil curitiba",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "AJU",
              "cityName": "Aracaju",
              "code": "AJU",
              "countryName": "Brazil",
              "displayText": "Aracaju, Santa Maria Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Santa Maria Airport",
              "phoneticLabel": null,
              "searchText": "aju santa maria airport brazil aracaju",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CXJ",
              "cityName": "Caxias do Sul",
              "code": "CXJ",
              "countryName": "Brazil",
              "displayText": "Caxias do Sul, Hugo Cantergiani Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Hugo Cantergiani Airport",
              "phoneticLabel": null,
              "searchText": "cxj hugo cantergiani airport brazil caxias do sul",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CPV",
              "cityName": "Campina Grande",
              "code": "CPV",
              "countryName": "Brazil",
              "displayText": "Campina Grande, Campina Grande Joao Suassuna Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Campina Grande Joao Suassuna Airport",
              "phoneticLabel": null,
              "searchText": "cpv campina grande joao suassuna airport brazil campina grande",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CGB",
              "cityName": "Cuiaba",
              "code": "CGB",
              "countryName": "Brazil",
              "displayText": "Cuiaba, Marechal Rondon Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Marechal Rondon Airport",
              "phoneticLabel": null,
              "searchText": "cgb marechal rondon airport brazil cuiaba",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "VDC",
              "cityName": "Vitoria da Conquista",
              "code": "VDC",
              "countryName": "Brazil",
              "displayText": "Vitoria da Conquista, Vitoria da Conquista Glauber Rocha Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Vitoria da Conquista Glauber Rocha Airport",
              "phoneticLabel": null,
              "searchText": "vdc vitoria da conquista glauber rocha airport brazil vitoria da conquista",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CGR",
              "cityName": "Campo Grande",
              "code": "CGR",
              "countryName": "Brazil",
              "displayText": "Campo Grande, Campo Grande International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Campo Grande International Airport",
              "phoneticLabel": null,
              "searchText": "cgr campo grande international airport brazil campo grande",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MGF",
              "cityName": "Maringa",
              "code": "MGF",
              "countryName": "Brazil",
              "displayText": "Maringa, Regional De Maringa",
              "isDestination": true,
              "isOrigin": true,
              "label": "Regional De Maringa",
              "phoneticLabel": null,
              "searchText": "mgf regional de maringa brazil maringa",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "IMP",
              "cityName": "Imperatriz",
              "code": "IMP",
              "countryName": "Brazil",
              "displayText": "Imperatriz, Imperatriz Renato Moreira Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Imperatriz Renato Moreira Airport",
              "phoneticLabel": null,
              "searchText": "imp imperatriz renato moreira airport brazil imperatriz",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NVT",
              "cityName": "Navegantes",
              "code": "NVT",
              "countryName": "Brazil",
              "displayText": "Navegantes, Navegantes",
              "isDestination": true,
              "isOrigin": true,
              "label": "Navegantes",
              "phoneticLabel": null,
              "searchText": "nvt navegantes brazil navegantes",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "FLN",
              "cityName": "Florianopolis",
              "code": "FLN",
              "countryName": "Brazil",
              "displayText": "Florianopolis, Hercílio Luz International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Hercílio Luz International Airport",
              "phoneticLabel": null,
              "searchText": "fln hercílio luz international airport brazil florianopolis",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NAT",
              "cityName": "Natal",
              "code": "NAT",
              "countryName": "Brazil",
              "displayText": "Natal, Natal International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Natal International Airport",
              "phoneticLabel": null,
              "searchText": "nat natal international airport brazil natal",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "STM",
              "cityName": "Santarem",
              "code": "STM",
              "countryName": "Brazil",
              "displayText": "Santarem, Maestro Wilson Fonseca",
              "isDestination": true,
              "isOrigin": true,
              "label": "Maestro Wilson Fonseca",
              "phoneticLabel": null,
              "searchText": "stm maestro wilson fonseca brazil santarem",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MAO",
              "cityName": "Manaus",
              "code": "MAO",
              "countryName": "Brazil",
              "displayText": "Manaus, Eduardo Gomes International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Eduardo Gomes International Airport",
              "phoneticLabel": null,
              "searchText": "mao eduardo gomes international airport brazil manaus",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SLZ",
              "cityName": "Sao Luis",
              "code": "SLZ",
              "countryName": "Brazil",
              "displayText": "Sao Luis, Marechal Cunha Machado International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Marechal Cunha Machado International Airport",
              "phoneticLabel": null,
              "searchText": "slz marechal cunha machado international airport brazil sao luis",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "UDI",
              "cityName": "Uberlandia",
              "code": "UDI",
              "countryName": "Brazil",
              "displayText": "Uberlandia, Ten. Cel. Av. César Bombonato Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Ten. Cel. Av. César Bombonato Airport",
              "phoneticLabel": null,
              "searchText": "udi ten. cel. av. césar bombonato airport brazil uberlandia",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "XAP",
              "cityName": "Chapeco",
              "code": "XAP",
              "countryName": "Brazil",
              "displayText": "Chapeco, Chapeco Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Chapeco Airport",
              "phoneticLabel": null,
              "searchText": "xap chapeco airport brazil chapeco",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PET",
              "cityName": "Pelotas",
              "code": "PET",
              "countryName": "Brazil",
              "displayText": "Pelotas, Pelotas International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Pelotas International",
              "phoneticLabel": null,
              "searchText": "pet pelotas international brazil pelotas",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "RAO",
              "cityName": "Ribeirao Preto",
              "code": "RAO",
              "countryName": "Brazil",
              "displayText": "Ribeirao Preto, Dr. Leite Lopes",
              "isDestination": true,
              "isOrigin": true,
              "label": "Dr. Leite Lopes",
              "phoneticLabel": null,
              "searchText": "rao dr. leite lopes brazil ribeirao preto",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MOC",
              "cityName": "Montes Claros",
              "code": "MOC",
              "countryName": "Brazil",
              "displayText": "Montes Claros, Mário Ribeiro Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Mário Ribeiro Airport",
              "phoneticLabel": null,
              "searchText": "moc mário ribeiro airport brazil montes claros",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CAC",
              "cityName": "Cascavel",
              "code": "CAC",
              "countryName": "Brazil",
              "displayText": "Cascavel, Cascavel A. Mendes da Silva Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Cascavel A. Mendes da Silva Airport",
              "phoneticLabel": null,
              "searchText": "cac cascavel a. mendes da silva airport brazil cascavel",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LDB",
              "cityName": "Londrina",
              "code": "LDB",
              "countryName": "Brazil",
              "displayText": "Londrina, Londrina Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Londrina Airport",
              "phoneticLabel": null,
              "searchText": "ldb londrina airport brazil londrina",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BRD",
              "cityName": "Brainerd",
              "code": "BRD",
              "countryName": "United States",
              "displayText": "Brainerd, Crow Wing County Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Crow Wing County Airport",
              "phoneticLabel": null,
              "searchText": "brd crow wing county airport united states brainerd",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KOA",
              "cityName": "Kona",
              "code": "KOA",
              "countryName": "United States",
              "displayText": "Kona, Keahole",
              "isDestination": true,
              "isOrigin": true,
              "label": "Keahole",
              "phoneticLabel": null,
              "searchText": "koa keahole united states kona",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SMF",
              "cityName": "Sacramento",
              "code": "SMF",
              "countryName": "United States",
              "displayText": "Sacramento, Sacramento International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Sacramento International Airport",
              "phoneticLabel": null,
              "searchText": "smf sacramento international airport united states sacramento",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MKG",
              "cityName": "Muskegon",
              "code": "MKG",
              "countryName": "United States",
              "displayText": "Muskegon, Muskegon",
              "isDestination": true,
              "isOrigin": true,
              "label": "Muskegon",
              "phoneticLabel": null,
              "searchText": "mkg muskegon united states muskegon",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SAT",
              "cityName": "San Antonio",
              "code": "SAT",
              "countryName": "United States",
              "displayText": "San Antonio, San Antonio International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "San Antonio International Airport",
              "phoneticLabel": null,
              "searchText": "sat san antonio international airport united states san antonio",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MQT",
              "cityName": "Marquette",
              "code": "MQT",
              "countryName": "United States",
              "displayText": "Marquette, Sawyer International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Sawyer International Airport",
              "phoneticLabel": null,
              "searchText": "mqt sawyer international airport united states marquette",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LRD",
              "cityName": "Laredo",
              "code": "LRD",
              "countryName": "United States",
              "displayText": "Laredo, Laredo International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Laredo International Airport",
              "phoneticLabel": null,
              "searchText": "lrd laredo international airport united states laredo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SYR",
              "cityName": "Syracuse",
              "code": "SYR",
              "countryName": "United States",
              "displayText": "Syracuse, Hancock International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Hancock International Airport",
              "phoneticLabel": null,
              "searchText": "syr hancock international airport united states syracuse",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "DLH",
              "cityName": "Duluth",
              "code": "DLH",
              "countryName": "United States",
              "displayText": "Duluth, Duluth International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Duluth International Airport",
              "phoneticLabel": null,
              "searchText": "dlh duluth international airport united states duluth",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "FWA",
              "cityName": "Fort Wayne",
              "code": "FWA",
              "countryName": "United States",
              "displayText": "Fort Wayne, Municipal",
              "isDestination": true,
              "isOrigin": true,
              "label": "Municipal",
              "phoneticLabel": null,
              "searchText": "fwa municipal united states fort wayne",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ICT",
              "cityName": "Wichita",
              "code": "ICT",
              "countryName": "United States",
              "displayText": "Wichita, Dwight D. Eisenhower National Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Dwight D. Eisenhower National Airport",
              "phoneticLabel": null,
              "searchText": "ict dwight d. eisenhower national airport united states wichita",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CRP",
              "cityName": "Corpus Christi",
              "code": "CRP",
              "countryName": "United States",
              "displayText": "Corpus Christi, Corpus Christi International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Corpus Christi International Airport",
              "phoneticLabel": null,
              "searchText": "crp corpus christi international airport united states corpus christi",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HNL",
              "cityName": "Honolulu",
              "code": "HNL",
              "countryName": "United States",
              "displayText": "Honolulu, Honolulu International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Honolulu International",
              "phoneticLabel": null,
              "searchText": "hnl honolulu international united states honolulu",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ESC",
              "cityName": "Escanaba",
              "code": "ESC",
              "countryName": "United States",
              "displayText": "Escanaba, Delta County",
              "isDestination": true,
              "isOrigin": true,
              "label": "Delta County",
              "phoneticLabel": null,
              "searchText": "esc delta county united states escanaba",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "GSP",
              "cityName": "Greenville Spartanburg, SC",
              "code": "GSP",
              "countryName": "United States",
              "displayText": "Greenville Spartanburg, SC, Greenville-Spartanburg International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Greenville-Spartanburg International Airport",
              "phoneticLabel": null,
              "searchText": "gsp greenville-spartanburg international airport united states greenville spartanburg, sc",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LAX",
              "cityName": "Los Angeles",
              "code": "LAX",
              "countryName": "United States",
              "displayText": "Los Angeles",
              "isDestination": true,
              "isOrigin": true,
              "label": "Los Angeles",
              "phoneticLabel": null,
              "searchText": "lax los angeles united states",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "LAX",
              "cityName": "Los Angeles",
              "code": "LAX",
              "countryName": "United States",
              "displayText": "Los Angeles, Los Angeles International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Los Angeles International Airport",
              "phoneticLabel": null,
              "searchText": "lax los angeles international airport united states los angeles",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LAX",
              "cityName": "Los Angeles",
              "code": "ONT",
              "countryName": "United States",
              "displayText": "Los Angeles, Ontario International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Ontario International Airport",
              "phoneticLabel": null,
              "searchText": "ont ontario international airport united states los angeles",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CLT",
              "cityName": "Charlotte",
              "code": "CLT",
              "countryName": "United States",
              "displayText": "Charlotte, Douglas",
              "isDestination": true,
              "isOrigin": true,
              "label": "Douglas",
              "phoneticLabel": null,
              "searchText": "clt douglas united states charlotte",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PHX",
              "cityName": "Phoenix",
              "code": "PHX",
              "countryName": "United States",
              "displayText": "Phoenix, Sky Harbor International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Sky Harbor International Airport",
              "phoneticLabel": null,
              "searchText": "phx sky harbor international airport united states phoenix",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "EVV",
              "cityName": "Evansville",
              "code": "EVV",
              "countryName": "United States",
              "displayText": "Evansville, Dress Regional Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Dress Regional Airport",
              "phoneticLabel": null,
              "searchText": "evv dress regional airport united states evansville",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CHA",
              "cityName": "Chattanooga",
              "code": "CHA",
              "countryName": "United States",
              "displayText": "Chattanooga, Lovell Field",
              "isDestination": true,
              "isOrigin": true,
              "label": "Lovell Field",
              "phoneticLabel": null,
              "searchText": "cha lovell field united states chattanooga",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MLB",
              "cityName": "Melbourne, FL",
              "code": "MLB",
              "countryName": "United States",
              "displayText": "Melbourne, FL, Melbourne Intl",
              "isDestination": true,
              "isOrigin": true,
              "label": "Melbourne Intl",
              "phoneticLabel": null,
              "searchText": "mlb melbourne intl united states melbourne, fl",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "RHI",
              "cityName": "Rhinelander",
              "code": "RHI",
              "countryName": "United States",
              "displayText": "Rhinelander, Oneida County Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Oneida County Airport",
              "phoneticLabel": null,
              "searchText": "rhi oneida county airport united states rhinelander",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MOB",
              "cityName": "Mobile",
              "code": "MOB",
              "countryName": "United States",
              "displayText": "Mobile, Mobile Regional Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Mobile Regional Airport",
              "phoneticLabel": null,
              "searchText": "mob mobile regional airport united states mobile",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "INL",
              "cityName": "International Falls",
              "code": "INL",
              "countryName": "United States",
              "displayText": "International Falls, Falls International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Falls International Airport",
              "phoneticLabel": null,
              "searchText": "inl falls international airport united states international falls",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ITH",
              "cityName": "Ithaca",
              "code": "ITH",
              "countryName": "United States",
              "displayText": "Ithaca, Tompkins County",
              "isDestination": true,
              "isOrigin": true,
              "label": "Tompkins County",
              "phoneticLabel": null,
              "searchText": "ith tompkins county united states ithaca",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PBI",
              "cityName": "West Palm Beach",
              "code": "PBI",
              "countryName": "United States",
              "displayText": "West Palm Beach, Palm Beach International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Palm Beach International Airport",
              "phoneticLabel": null,
              "searchText": "pbi palm beach international airport united states west palm beach",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CVG",
              "cityName": "Cincinnati",
              "code": "CVG",
              "countryName": "United States",
              "displayText": "Cincinnati, Northern Kentucky International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Northern Kentucky International Airport",
              "phoneticLabel": null,
              "searchText": "cvg northern kentucky international airport united states cincinnati",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PIR",
              "cityName": "Pierre",
              "code": "PIR",
              "countryName": "United States",
              "displayText": "Pierre, Pierre Regional Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Pierre Regional Airport",
              "phoneticLabel": null,
              "searchText": "pir pierre regional airport united states pierre",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HLN",
              "cityName": "Helena",
              "code": "HLN",
              "countryName": "United States",
              "displayText": "Helena, Helena",
              "isDestination": true,
              "isOrigin": true,
              "label": "Helena",
              "phoneticLabel": null,
              "searchText": "hln helena united states helena",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TUP",
              "cityName": "Tupelo",
              "code": "TUP",
              "countryName": "United States",
              "displayText": "Tupelo, Lemons Municipal",
              "isDestination": true,
              "isOrigin": true,
              "label": "Lemons Municipal",
              "phoneticLabel": null,
              "searchText": "tup lemons municipal united states tupelo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TWF",
              "cityName": "Twin Falls",
              "code": "TWF",
              "countryName": "United States",
              "displayText": "Twin Falls, Twin Falls Magic Valley Regional Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Twin Falls Magic Valley Regional Airport",
              "phoneticLabel": null,
              "searchText": "twf twin falls magic valley regional airport united states twin falls",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "EUG",
              "cityName": "Eugene",
              "code": "EUG",
              "countryName": "United States",
              "displayText": "Eugene, Eugene Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Eugene Airport",
              "phoneticLabel": null,
              "searchText": "eug eugene airport united states eugene",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ASE",
              "cityName": "Aspen",
              "code": "ASE",
              "countryName": "United States",
              "displayText": "Aspen, Aspen Pitkin County Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Aspen Pitkin County Airport",
              "phoneticLabel": null,
              "searchText": "ase aspen pitkin county airport united states aspen",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MSP",
              "cityName": "Minneapolis",
              "code": "MSP",
              "countryName": "United States",
              "displayText": "Minneapolis, Saint Paul International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Saint Paul International Airport",
              "phoneticLabel": null,
              "searchText": "msp saint paul international airport united states minneapolis",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MSY",
              "cityName": "New Orleans",
              "code": "MSY",
              "countryName": "United States",
              "displayText": "New Orleans, Louis Armstrong International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Louis Armstrong International Airport",
              "phoneticLabel": null,
              "searchText": "msy louis armstrong international airport united states new orleans",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MSO",
              "cityName": "Missoula",
              "code": "MSO",
              "countryName": "United States",
              "displayText": "Missoula, Johnson-Bell Field",
              "isDestination": true,
              "isOrigin": true,
              "label": "Johnson-Bell Field",
              "phoneticLabel": null,
              "searchText": "mso johnson-bell field united states missoula",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "GFK",
              "cityName": "Grand Forks",
              "code": "GFK",
              "countryName": "United States",
              "displayText": "Grand Forks, Grand Forks International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Grand Forks International Airport",
              "phoneticLabel": null,
              "searchText": "gfk grand forks international airport united states grand forks",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "DHN",
              "cityName": "Dothan",
              "code": "DHN",
              "countryName": "United States",
              "displayText": "Dothan, Dothan Regional Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Dothan Regional Airport",
              "phoneticLabel": null,
              "searchText": "dhn dothan regional airport united states dothan",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "JAN",
              "cityName": "Jackson, MS",
              "code": "JAN",
              "countryName": "United States",
              "displayText": "Jackson, MS, Jackson-Evers International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Jackson-Evers International Airport",
              "phoneticLabel": null,
              "searchText": "jan jackson-evers international airport united states jackson, ms",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BMI",
              "cityName": "Bloomington Normal",
              "code": "BMI",
              "countryName": "United States",
              "displayText": "Bloomington Normal, Bloomington-Normal Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Bloomington-Normal Airport",
              "phoneticLabel": null,
              "searchText": "bmi bloomington-normal airport united states bloomington normal",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LAN",
              "cityName": "Lansing",
              "code": "LAN",
              "countryName": "United States",
              "displayText": "Lansing, Lansing Capital City Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Lansing Capital City Airport",
              "phoneticLabel": null,
              "searchText": "lan lansing capital city airport united states lansing",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HSV",
              "cityName": "Huntsville",
              "code": "HSV",
              "countryName": "United States",
              "displayText": "Huntsville, Huntsville International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Huntsville International Airport",
              "phoneticLabel": null,
              "searchText": "hsv huntsville international airport united states huntsville",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TUS",
              "cityName": "Tucson",
              "code": "TUS",
              "countryName": "United States",
              "displayText": "Tucson, Tucson International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Tucson International Airport",
              "phoneticLabel": null,
              "searchText": "tus tucson international airport united states tucson",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SUN",
              "cityName": "Hailey Sun Valley",
              "code": "SUN",
              "countryName": "United States",
              "displayText": "Hailey Sun Valley, Hailey Sun Valley Friedman Memorial Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Hailey Sun Valley Friedman Memorial Airport",
              "phoneticLabel": null,
              "searchText": "sun hailey sun valley friedman memorial airport united states hailey sun valley",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "OMA",
              "cityName": "Omaha",
              "code": "OMA",
              "countryName": "United States",
              "displayText": "Omaha, Eppley Airfield",
              "isDestination": true,
              "isOrigin": true,
              "label": "Eppley Airfield",
              "phoneticLabel": null,
              "searchText": "oma eppley airfield united states omaha",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BUR",
              "cityName": "Burbank",
              "code": "BUR",
              "countryName": "United States",
              "displayText": "Burbank, Bob Hope International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Bob Hope International Airport",
              "phoneticLabel": null,
              "searchText": "bur bob hope international airport united states burbank",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PNS",
              "cityName": "Pensacola",
              "code": "PNS",
              "countryName": "United States",
              "displayText": "Pensacola, Regional Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Regional Airport",
              "phoneticLabel": null,
              "searchText": "pns regional airport united states pensacola",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BIS",
              "cityName": "Bismarck",
              "code": "BIS",
              "countryName": "United States",
              "displayText": "Bismarck, Bismarck Municipal",
              "isDestination": true,
              "isOrigin": true,
              "label": "Bismarck Municipal",
              "phoneticLabel": null,
              "searchText": "bis bismarck municipal united states bismarck",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SFO",
              "cityName": "San Francisco",
              "code": "SFO",
              "countryName": "United States",
              "displayText": "San Francisco, San Francisco Intl.",
              "isDestination": true,
              "isOrigin": true,
              "label": "San Francisco Intl.",
              "phoneticLabel": null,
              "searchText": "sfo san francisco intl. united states san francisco",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "RDM",
              "cityName": "Redmond Bend, OR",
              "code": "RDM",
              "countryName": "United States",
              "displayText": "Redmond Bend, OR, Roberts Field",
              "isDestination": true,
              "isOrigin": true,
              "label": "Roberts Field",
              "phoneticLabel": null,
              "searchText": "rdm roberts field united states redmond bend, or",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "AZO",
              "cityName": "Kalamazoo",
              "code": "AZO",
              "countryName": "United States",
              "displayText": "Kalamazoo, Battle Creek International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Battle Creek International",
              "phoneticLabel": null,
              "searchText": "azo battle creek international united states kalamazoo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PDX",
              "cityName": "Portland, OR",
              "code": "PDX",
              "countryName": "United States",
              "displayText": "Portland, OR, Portland International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Portland International Airport",
              "phoneticLabel": null,
              "searchText": "pdx portland international airport united states portland, or",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "IND",
              "cityName": "Indianapolis",
              "code": "IND",
              "countryName": "United States",
              "displayText": "Indianapolis, Indianapolis International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Indianapolis International Airport",
              "phoneticLabel": null,
              "searchText": "ind indianapolis international airport united states indianapolis",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "FAI",
              "cityName": "Fairbanks",
              "code": "FAI",
              "countryName": "United States",
              "displayText": "Fairbanks, Fairbanks International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Fairbanks International Airport",
              "phoneticLabel": null,
              "searchText": "fai fairbanks international airport united states fairbanks",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "COS",
              "cityName": "Colorado Springs",
              "code": "COS",
              "countryName": "United States",
              "displayText": "Colorado Springs, Colorado Springs Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Colorado Springs Airport",
              "phoneticLabel": null,
              "searchText": "cos colorado springs airport united states colorado springs",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "OGG",
              "cityName": "Kahului, Maui",
              "code": "OGG",
              "countryName": "United States",
              "displayText": "Kahului, Maui, Kahului",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kahului",
              "phoneticLabel": null,
              "searchText": "ogg kahului united states kahului, maui",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "UBS",
              "cityName": "Columbus, MS",
              "code": "UBS",
              "countryName": "United States",
              "displayText": "Columbus, MS",
              "isDestination": true,
              "isOrigin": true,
              "label": "Columbus, MS",
              "phoneticLabel": null,
              "searchText": "ubs columbus, ms united states",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "UBS",
              "cityName": "Columbus, MS",
              "code": "GTR",
              "countryName": "United States",
              "displayText": "Columbus, MS, Golden Triangle Regional Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Golden Triangle Regional Airport",
              "phoneticLabel": null,
              "searchText": "gtr golden triangle regional airport united states columbus, ms",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "UBS",
              "cityName": "Columbus, MS",
              "code": "UBS",
              "countryName": "United States",
              "displayText": "Columbus, MS, Lowndes County Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Lowndes County Airport",
              "phoneticLabel": null,
              "searchText": "ubs lowndes county airport united states columbus, ms",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LAS",
              "cityName": "Las Vegas",
              "code": "LAS",
              "countryName": "United States",
              "displayText": "Las Vegas, Harry Reid International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Harry Reid International Airport",
              "phoneticLabel": null,
              "searchText": "las harry reid international airport united states las vegas",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BJI",
              "cityName": "Bemidji",
              "code": "BJI",
              "countryName": "United States",
              "displayText": "Bemidji, Bemidji Regional",
              "isDestination": true,
              "isOrigin": true,
              "label": "Bemidji Regional",
              "phoneticLabel": null,
              "searchText": "bji bemidji regional united states bemidji",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "FSD",
              "cityName": "Sioux Falls",
              "code": "FSD",
              "countryName": "United States",
              "displayText": "Sioux Falls, Joe Foss Field",
              "isDestination": true,
              "isOrigin": true,
              "label": "Joe Foss Field",
              "phoneticLabel": null,
              "searchText": "fsd joe foss field united states sioux falls",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HIB",
              "cityName": "Hibbing Chisholm",
              "code": "HIB",
              "countryName": "United States",
              "displayText": "Hibbing Chisholm, Chisholm-Hibbing Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Chisholm-Hibbing Airport",
              "phoneticLabel": null,
              "searchText": "hib chisholm-hibbing airport united states hibbing chisholm",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BZN",
              "cityName": "Bozeman",
              "code": "BZN",
              "countryName": "United States",
              "displayText": "Bozeman, Gallatin Field Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Gallatin Field Airport",
              "phoneticLabel": null,
              "searchText": "bzn gallatin field airport united states bozeman",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "VPS",
              "cityName": "Destin Ft Walton Beach",
              "code": "VPS",
              "countryName": "United States",
              "displayText": "Destin Ft Walton Beach, Fort Walton Beach",
              "isDestination": true,
              "isOrigin": true,
              "label": "Fort Walton Beach",
              "phoneticLabel": null,
              "searchText": "vps fort walton beach united states destin ft walton beach",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LWS",
              "cityName": "Lewiston",
              "code": "LWS",
              "countryName": "United States",
              "displayText": "Lewiston, Nez Perce County Regional",
              "isDestination": true,
              "isOrigin": true,
              "label": "Nez Perce County Regional",
              "phoneticLabel": null,
              "searchText": "lws nez perce county regional united states lewiston",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SBA",
              "cityName": "Santa Barbara",
              "code": "SBA",
              "countryName": "United States",
              "displayText": "Santa Barbara, Santa Barbara Municipal Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Santa Barbara Municipal Airport",
              "phoneticLabel": null,
              "searchText": "sba santa barbara municipal airport united states santa barbara",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TVF",
              "cityName": "Thief River Falls",
              "code": "TVF",
              "countryName": "United States",
              "displayText": "Thief River Falls, Thief River Falls Regional Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Thief River Falls Regional Airport",
              "phoneticLabel": null,
              "searchText": "tvf thief river falls regional airport united states thief river falls",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BTR",
              "cityName": "Baton Rouge",
              "code": "BTR",
              "countryName": "United States",
              "displayText": "Baton Rouge, Ryan Field",
              "isDestination": true,
              "isOrigin": true,
              "label": "Ryan Field",
              "phoneticLabel": null,
              "searchText": "btr ryan field united states baton rouge",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MDT",
              "cityName": "Harrisburg",
              "code": "MDT",
              "countryName": "United States",
              "displayText": "Harrisburg, Harrisburg International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Harrisburg International Airport",
              "phoneticLabel": null,
              "searchText": "mdt harrisburg international airport united states harrisburg",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CLE",
              "cityName": "Cleveland",
              "code": "CLE",
              "countryName": "United States",
              "displayText": "Cleveland, Cleveland Hopkins International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Cleveland Hopkins International Airport",
              "phoneticLabel": null,
              "searchText": "cle cleveland hopkins international airport united states cleveland",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ECP",
              "cityName": "Panama City, Florida",
              "code": "ECP",
              "countryName": "United States",
              "displayText": "Panama City, Florida, Northwest Florida Beaches International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Northwest Florida Beaches International Airport",
              "phoneticLabel": null,
              "searchText": "ecp northwest florida beaches international airport united states panama city, florida",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "GPT",
              "cityName": "Gulfport",
              "code": "GPT",
              "countryName": "United States",
              "displayText": "Gulfport, Biloxi Regional Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Biloxi Regional Airport",
              "phoneticLabel": null,
              "searchText": "gpt biloxi regional airport united states gulfport",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ATL",
              "cityName": "Atlanta",
              "code": "ATL",
              "countryName": "United States",
              "displayText": "Atlanta, Hartsfield-Jackson Atlanta International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Hartsfield-Jackson Atlanta International Airport",
              "phoneticLabel": null,
              "searchText": "atl hartsfield-jackson atlanta international airport united states atlanta",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SSI",
              "cityName": "Brunswick",
              "code": "SSI",
              "countryName": "United States",
              "displayText": "Brunswick",
              "isDestination": true,
              "isOrigin": true,
              "label": "Brunswick",
              "phoneticLabel": null,
              "searchText": "ssi brunswick united states",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "SSI",
              "cityName": "Brunswick",
              "code": "BQK",
              "countryName": "United States",
              "displayText": "Brunswick, Glynco Jetport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Glynco Jetport",
              "phoneticLabel": null,
              "searchText": "bqk glynco jetport united states brunswick",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SSI",
              "cityName": "Brunswick",
              "code": "SSI",
              "countryName": "United States",
              "displayText": "Brunswick, Mckinnon St Simons Is Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Mckinnon St Simons Is Airport",
              "phoneticLabel": null,
              "searchText": "ssi mckinnon st simons is airport united states brunswick",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MCO",
              "cityName": "Orlando",
              "code": "MCO",
              "countryName": "United States",
              "displayText": "Orlando, Orlando International airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Orlando International airport",
              "phoneticLabel": null,
              "searchText": "mco orlando international airport united states orlando",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "OAK",
              "cityName": "Oakland",
              "code": "OAK",
              "countryName": "United States",
              "displayText": "Oakland, Oakland International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Oakland International Airport",
              "phoneticLabel": null,
              "searchText": "oak oakland international airport united states oakland",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YKM",
              "cityName": "Yakima",
              "code": "YKM",
              "countryName": "United States",
              "displayText": "Yakima, Yakima Air Terminal",
              "isDestination": true,
              "isOrigin": true,
              "label": "Yakima Air Terminal",
              "phoneticLabel": null,
              "searchText": "ykm yakima air terminal united states yakima",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "GEG",
              "cityName": "Spokane",
              "code": "GEG",
              "countryName": "United States",
              "displayText": "Spokane, Spokane International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Spokane International Airport",
              "phoneticLabel": null,
              "searchText": "geg spokane international airport united states spokane",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SJC",
              "cityName": "San Jose",
              "code": "SJC",
              "countryName": "United States",
              "displayText": "San Jose, Norman Y. Mineta San José International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Norman Y. Mineta San José International Airport",
              "phoneticLabel": null,
              "searchText": "sjc norman y. mineta san josé international airport united states san jose",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BGM",
              "cityName": "Binghamton",
              "code": "BGM",
              "countryName": "United States",
              "displayText": "Binghamton, Greater Binghamton Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Greater Binghamton Airport",
              "phoneticLabel": null,
              "searchText": "bgm greater binghamton airport united states binghamton",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LIT",
              "cityName": "Little Rock",
              "code": "LIT",
              "countryName": "United States",
              "displayText": "Little Rock, Little Rock National Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Little Rock National Airport",
              "phoneticLabel": null,
              "searchText": "lit little rock national airport united states little rock",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ELM",
              "cityName": "Elmira",
              "code": "ELM",
              "countryName": "United States",
              "displayText": "Elmira, Elmira Regional Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Elmira Regional Airport",
              "phoneticLabel": null,
              "searchText": "elm elmira regional airport united states elmira",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CMH",
              "cityName": "Columbus, OH",
              "code": "CMH",
              "countryName": "United States",
              "displayText": "Columbus, OH, Port Columbus International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Port Columbus International Airport",
              "phoneticLabel": null,
              "searchText": "cmh port columbus international airport united states columbus, oh",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "GNV",
              "cityName": "Gainesville",
              "code": "GNV",
              "countryName": "United States",
              "displayText": "Gainesville, Gainesville Regional Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Gainesville Regional Airport",
              "phoneticLabel": null,
              "searchText": "gnv gainesville regional airport united states gainesville",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TYS",
              "cityName": "Knoxville",
              "code": "TYS",
              "countryName": "United States",
              "displayText": "Knoxville, Mc Ghee Tyson Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Mc Ghee Tyson Airport",
              "phoneticLabel": null,
              "searchText": "tys mc ghee tyson airport united states knoxville",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LEX",
              "cityName": "Lexington",
              "code": "LEX",
              "countryName": "United States",
              "displayText": "Lexington, Blue Grass Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Blue Grass Airport",
              "phoneticLabel": null,
              "searchText": "lex blue grass airport united states lexington",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "GTF",
              "cityName": "Great Falls",
              "code": "GTF",
              "countryName": "United States",
              "displayText": "Great Falls, Great Falls International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Great Falls International Airport",
              "phoneticLabel": null,
              "searchText": "gtf great falls international airport united states great falls",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KTN",
              "cityName": "Ketchikan",
              "code": "KTN",
              "countryName": "United States",
              "displayText": "Ketchikan, Ketchikan International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Ketchikan International Airport",
              "phoneticLabel": null,
              "searchText": "ktn ketchikan international airport united states ketchikan",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CRW",
              "cityName": "Charleston, WV",
              "code": "CRW",
              "countryName": "United States",
              "displayText": "Charleston, WV, Yeager",
              "isDestination": true,
              "isOrigin": true,
              "label": "Yeager",
              "phoneticLabel": null,
              "searchText": "crw yeager united states charleston, wv",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NYC",
              "cityName": "New York",
              "code": "NYC",
              "countryName": "United States",
              "displayText": "New York",
              "isDestination": true,
              "isOrigin": true,
              "label": "New York",
              "phoneticLabel": null,
              "searchText": "nyc new york united states",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "NYC",
              "cityName": "New York",
              "code": "LGA",
              "countryName": "United States",
              "displayText": "New York, La Guardia Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "La Guardia Airport",
              "phoneticLabel": null,
              "searchText": "lga la guardia airport united states new york",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NYC",
              "cityName": "New York",
              "code": "SWF",
              "countryName": "United States",
              "displayText": "New York, Stewart International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Stewart International Airport",
              "phoneticLabel": null,
              "searchText": "swf stewart international airport united states new york",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NYC",
              "cityName": "New York",
              "code": "JFK",
              "countryName": "United States",
              "displayText": "New York, John F. Kennedy International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "John F. Kennedy International Airport",
              "phoneticLabel": null,
              "searchText": "jfk john f. kennedy international airport united states new york",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NYC",
              "cityName": "New York",
              "code": "EWR",
              "countryName": "United States",
              "displayText": "New York, Newark Liberty International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Newark Liberty International Airport",
              "phoneticLabel": null,
              "searchText": "ewr newark liberty international airport united states new york",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SLC",
              "cityName": "Salt Lake City",
              "code": "SLC",
              "countryName": "United States",
              "displayText": "Salt Lake City, Salt Lake City International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Salt Lake City International Airport",
              "phoneticLabel": null,
              "searchText": "slc salt lake city international airport united states salt lake city",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BUF",
              "cityName": "Buffalo",
              "code": "BUF",
              "countryName": "United States",
              "displayText": "Buffalo, Buffalo Niagara International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Buffalo Niagara International Airport",
              "phoneticLabel": null,
              "searchText": "buf buffalo niagara international airport united states buffalo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "OAJ",
              "cityName": "Jacksonville, NC",
              "code": "OAJ",
              "countryName": "United States",
              "displayText": "Jacksonville, NC, Albert J. Ellis Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Albert J. Ellis Airport",
              "phoneticLabel": null,
              "searchText": "oaj albert j. ellis airport united states jacksonville, nc",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "IDA",
              "cityName": "Idaho Falls",
              "code": "IDA",
              "countryName": "United States",
              "displayText": "Idaho Falls, Idaho Falls",
              "isDestination": true,
              "isOrigin": true,
              "label": "Idaho Falls",
              "phoneticLabel": null,
              "searchText": "ida idaho falls united states idaho falls",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ATW",
              "cityName": "Appleton",
              "code": "ATW",
              "countryName": "United States",
              "displayText": "Appleton, Outagamie County Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Outagamie County Airport",
              "phoneticLabel": null,
              "searchText": "atw outagamie county airport united states appleton",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "GRR",
              "cityName": "Grand Rapids, MI",
              "code": "GRR",
              "countryName": "United States",
              "displayText": "Grand Rapids, MI, Gerald R. Ford International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Gerald R. Ford International Airport",
              "phoneticLabel": null,
              "searchText": "grr gerald r. ford international airport united states grand rapids, mi",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ABQ",
              "cityName": "Albuquerque",
              "code": "ABQ",
              "countryName": "United States",
              "displayText": "Albuquerque, Albuquerque International Sunport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Albuquerque International Sunport",
              "phoneticLabel": null,
              "searchText": "abq albuquerque international sunport united states albuquerque",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "FLL",
              "cityName": "Fort Lauderdale",
              "code": "FLL",
              "countryName": "United States",
              "displayText": "Fort Lauderdale, Fort Lauderdale International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Fort Lauderdale International Airport",
              "phoneticLabel": null,
              "searchText": "fll fort lauderdale international airport united states fort lauderdale",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "IMT",
              "cityName": "Iron Mountain",
              "code": "IMT",
              "countryName": "United States",
              "displayText": "Iron Mountain, Ford",
              "isDestination": true,
              "isOrigin": true,
              "label": "Ford",
              "phoneticLabel": null,
              "searchText": "imt ford united states iron mountain",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MYR",
              "cityName": "Myrtle Beach",
              "code": "MYR",
              "countryName": "United States",
              "displayText": "Myrtle Beach, Myrtle Beach International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Myrtle Beach International Airport",
              "phoneticLabel": null,
              "searchText": "myr myrtle beach international airport united states myrtle beach",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CSG",
              "cityName": "Columbus, GA",
              "code": "CSG",
              "countryName": "United States",
              "displayText": "Columbus, GA, Columbus Metropolitan Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Columbus Metropolitan Airport",
              "phoneticLabel": null,
              "searchText": "csg columbus metropolitan airport united states columbus, ga",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LBB",
              "cityName": "Lubbock",
              "code": "LBB",
              "countryName": "United States",
              "displayText": "Lubbock, Lubbock Preston Smith International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Lubbock Preston Smith International Airport",
              "phoneticLabel": null,
              "searchText": "lbb lubbock preston smith international airport united states lubbock",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SEA",
              "cityName": "Seattle",
              "code": "SEA",
              "countryName": "United States",
              "displayText": "Seattle, Seattle-Tacoma International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Seattle-Tacoma International Airport",
              "phoneticLabel": null,
              "searchText": "sea seattle-tacoma international airport united states seattle",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "AGS",
              "cityName": "Augusta, GA",
              "code": "AGS",
              "countryName": "United States",
              "displayText": "Augusta, GA, Bush Field",
              "isDestination": true,
              "isOrigin": true,
              "label": "Bush Field",
              "phoneticLabel": null,
              "searchText": "ags bush field united states augusta, ga",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CMX",
              "cityName": "Hancock, MI",
              "code": "CMX",
              "countryName": "United States",
              "displayText": "Hancock, MI, Houghton County Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Houghton County Airport",
              "phoneticLabel": null,
              "searchText": "cmx houghton county airport united states hancock, mi",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MLU",
              "cityName": "Monroe",
              "code": "MLU",
              "countryName": "United States",
              "displayText": "Monroe, Monroe Municipal Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Monroe Municipal Airport",
              "phoneticLabel": null,
              "searchText": "mlu monroe municipal airport united states monroe",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MSL",
              "cityName": "Muscle Shoals",
              "code": "MSL",
              "countryName": "United States",
              "displayText": "Muscle Shoals, Muscle Shoals",
              "isDestination": true,
              "isOrigin": true,
              "label": "Muscle Shoals",
              "phoneticLabel": null,
              "searchText": "msl muscle shoals united states muscle shoals",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "JNU",
              "cityName": "Juneau",
              "code": "JNU",
              "countryName": "United States",
              "displayText": "Juneau, Juneau International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Juneau International Airport",
              "phoneticLabel": null,
              "searchText": "jnu juneau international airport united states juneau",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ELP",
              "cityName": "El Paso",
              "code": "ELP",
              "countryName": "United States",
              "displayText": "El Paso, El Paso International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "El Paso International Airport",
              "phoneticLabel": null,
              "searchText": "elp el paso international airport united states el paso",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ILM",
              "cityName": "Wilmington",
              "code": "ILM",
              "countryName": "United States",
              "displayText": "Wilmington, Wilmington International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Wilmington International Airport",
              "phoneticLabel": null,
              "searchText": "ilm wilmington international airport united states wilmington",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SIT",
              "cityName": "Sitka",
              "code": "SIT",
              "countryName": "United States",
              "displayText": "Sitka, Rocky Gutierrez Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Rocky Gutierrez Airport",
              "phoneticLabel": null,
              "searchText": "sit rocky gutierrez airport united states sitka",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "APN",
              "cityName": "Alpena",
              "code": "APN",
              "countryName": "United States",
              "displayText": "Alpena, Alpena County Regional Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Alpena County Regional Airport",
              "phoneticLabel": null,
              "searchText": "apn alpena county regional airport united states alpena",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ABY",
              "cityName": "Albany, GA",
              "code": "ABY",
              "countryName": "United States",
              "displayText": "Albany, GA, Southwest Georgia Regional Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Southwest Georgia Regional Airport",
              "phoneticLabel": null,
              "searchText": "aby southwest georgia regional airport united states albany, ga",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SHV",
              "cityName": "Shreveport",
              "code": "SHV",
              "countryName": "United States",
              "displayText": "Shreveport, Shreveport Regional Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Shreveport Regional Airport",
              "phoneticLabel": null,
              "searchText": "shv shreveport regional airport united states shreveport",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TLH",
              "cityName": "Tallahassee",
              "code": "TLH",
              "countryName": "United States",
              "displayText": "Tallahassee, Tallahassee Municipal Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Tallahassee Municipal Airport",
              "phoneticLabel": null,
              "searchText": "tlh tallahassee municipal airport united states tallahassee",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LGB",
              "cityName": "Long Beach",
              "code": "LGB",
              "countryName": "United States",
              "displayText": "Long Beach, Daugherty Field",
              "isDestination": true,
              "isOrigin": true,
              "label": "Daugherty Field",
              "phoneticLabel": null,
              "searchText": "lgb daugherty field united states long beach",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PSC",
              "cityName": "Pasco",
              "code": "PSC",
              "countryName": "United States",
              "displayText": "Pasco, Tri-Cities Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Tri-Cities Airport",
              "phoneticLabel": null,
              "searchText": "psc tri-cities airport united states pasco",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "RDU",
              "cityName": "Raleigh Durham",
              "code": "RDU",
              "countryName": "United States",
              "displayText": "Raleigh Durham, Raleigh-Durham International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Raleigh-Durham International Airport",
              "phoneticLabel": null,
              "searchText": "rdu raleigh-durham international airport united states raleigh durham",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "DAB",
              "cityName": "Daytona Beach",
              "code": "DAB",
              "countryName": "United States",
              "displayText": "Daytona Beach, Daytona Beach International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Daytona Beach International Airport",
              "phoneticLabel": null,
              "searchText": "dab daytona beach international airport united states daytona beach",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "DAY",
              "cityName": "Dayton",
              "code": "DAY",
              "countryName": "United States",
              "displayText": "Dayton, James M. Cox International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "James M. Cox International Airport",
              "phoneticLabel": null,
              "searchText": "day james m. cox international airport united states dayton",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BDL",
              "cityName": "Hartford",
              "code": "BDL",
              "countryName": "United States",
              "displayText": "Hartford, Bradley International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Bradley International",
              "phoneticLabel": null,
              "searchText": "bdl bradley international united states hartford",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "FAR",
              "cityName": "Fargo",
              "code": "FAR",
              "countryName": "United States",
              "displayText": "Fargo, Hector Field",
              "isDestination": true,
              "isOrigin": true,
              "label": "Hector Field",
              "phoneticLabel": null,
              "searchText": "far hector field united states fargo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ABE",
              "cityName": "Allentown",
              "code": "ABE",
              "countryName": "United States",
              "displayText": "Allentown, Lehigh Valley International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Lehigh Valley International Airport",
              "phoneticLabel": null,
              "searchText": "abe lehigh valley international airport united states allentown",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PHL",
              "cityName": "Philadelphia",
              "code": "PHL",
              "countryName": "United States",
              "displayText": "Philadelphia, Philadelphia International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Philadelphia International Airport",
              "phoneticLabel": null,
              "searchText": "phl philadelphia international airport united states philadelphia",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TRI",
              "cityName": "Bristol Johnson City Kingsport",
              "code": "TRI",
              "countryName": "United States",
              "displayText": "Bristol Johnson City Kingsport, Tri-Cities Regional",
              "isDestination": true,
              "isOrigin": true,
              "label": "Tri-Cities Regional",
              "phoneticLabel": null,
              "searchText": "tri tri-cities regional united states bristol johnson city kingsport",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ANC",
              "cityName": "Anchorage",
              "code": "ANC",
              "countryName": "United States",
              "displayText": "Anchorage, Anchorage International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Anchorage International Airport",
              "phoneticLabel": null,
              "searchText": "anc anchorage international airport united states anchorage",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "RIC",
              "cityName": "Richmond, VA",
              "code": "RIC",
              "countryName": "United States",
              "displayText": "Richmond, VA, Richmond International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Richmond International Airport",
              "phoneticLabel": null,
              "searchText": "ric richmond international airport united states richmond, va",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SAN",
              "cityName": "San Diego",
              "code": "SAN",
              "countryName": "United States",
              "displayText": "San Diego, San Diego International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "San Diego International Airport",
              "phoneticLabel": null,
              "searchText": "san san diego international airport united states san diego",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "DSM",
              "cityName": "Des Moines",
              "code": "DSM",
              "countryName": "United States",
              "displayText": "Des Moines, Des Moines International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Des Moines International Airport",
              "phoneticLabel": null,
              "searchText": "dsm des moines international airport united states des moines",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MFE",
              "cityName": "McAllen Mission",
              "code": "MFE",
              "countryName": "United States",
              "displayText": "McAllen Mission, McAllen Mission Miller International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "McAllen Mission Miller International Airport",
              "phoneticLabel": null,
              "searchText": "mfe mcallen mission miller international airport united states mcallen mission",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BOI",
              "cityName": "Boise",
              "code": "BOI",
              "countryName": "United States",
              "displayText": "Boise, Boise Air Terminal - Gowen",
              "isDestination": true,
              "isOrigin": true,
              "label": "Boise Air Terminal - Gowen",
              "phoneticLabel": null,
              "searchText": "boi boise air terminal - gowen united states boise",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CWA",
              "cityName": "Wausau",
              "code": "CWA",
              "countryName": "United States",
              "displayText": "Wausau, Central Wisconsin Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Central Wisconsin Airport",
              "phoneticLabel": null,
              "searchText": "cwa central wisconsin airport united states wausau",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "JAC",
              "cityName": "Jackson, WY",
              "code": "JAC",
              "countryName": "United States",
              "displayText": "Jackson, WY, Jackson Hole",
              "isDestination": true,
              "isOrigin": true,
              "label": "Jackson Hole",
              "phoneticLabel": null,
              "searchText": "jac jackson hole united states jackson, wy",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ROC",
              "cityName": "Rochester, NY",
              "code": "ROC",
              "countryName": "United States",
              "displayText": "Rochester, NY, Greater Rochester International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Greater Rochester International Airport",
              "phoneticLabel": null,
              "searchText": "roc greater rochester international airport united states rochester, ny",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "RST",
              "cityName": "Rochester, MN",
              "code": "RST",
              "countryName": "United States",
              "displayText": "Rochester, MN, Rochester International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Rochester International Airport",
              "phoneticLabel": null,
              "searchText": "rst rochester international airport united states rochester, mn",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BTM",
              "cityName": "Butte",
              "code": "BTM",
              "countryName": "United States",
              "displayText": "Butte, Butte",
              "isDestination": true,
              "isOrigin": true,
              "label": "Butte",
              "phoneticLabel": null,
              "searchText": "btm butte united states butte",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "WAS",
              "cityName": "Washington",
              "code": "WAS",
              "countryName": "United States",
              "displayText": "Washington",
              "isDestination": true,
              "isOrigin": true,
              "label": "Washington",
              "phoneticLabel": null,
              "searchText": "was washington united states",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "WAS",
              "cityName": "Washington",
              "code": "BWI",
              "countryName": "United States",
              "displayText": "Washington, Baltimore/Washington International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Baltimore/Washington International Airport",
              "phoneticLabel": null,
              "searchText": "bwi baltimore/washington international airport united states washington",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "WAS",
              "cityName": "Washington",
              "code": "DCA",
              "countryName": "United States",
              "displayText": "Washington, Ronald Reagan National",
              "isDestination": true,
              "isOrigin": true,
              "label": "Ronald Reagan National",
              "phoneticLabel": null,
              "searchText": "dca ronald reagan national united states washington",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "WAS",
              "cityName": "Washington",
              "code": "IAD",
              "countryName": "United States",
              "displayText": "Washington, Dulles International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Dulles International Airport",
              "phoneticLabel": null,
              "searchText": "iad dulles international airport united states washington",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "STC",
              "cityName": "Saint Cloud, MN",
              "code": "STC",
              "countryName": "United States",
              "displayText": "Saint Cloud, MN, Saint Cloud Regional Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Saint Cloud Regional Airport",
              "phoneticLabel": null,
              "searchText": "stc saint cloud regional airport united states saint cloud, mn",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BNA",
              "cityName": "Nashville",
              "code": "BNA",
              "countryName": "United States",
              "displayText": "Nashville, Nashville International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Nashville International Airport",
              "phoneticLabel": null,
              "searchText": "bna nashville international airport united states nashville",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "RSW",
              "cityName": "Fort Myers",
              "code": "RSW",
              "countryName": "United States",
              "displayText": "Fort Myers, Fort Myers Southwest Florida International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Fort Myers Southwest Florida International Airport",
              "phoneticLabel": null,
              "searchText": "rsw fort myers southwest florida international airport united states fort myers",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "DEN",
              "cityName": "Denver",
              "code": "DEN",
              "countryName": "United States",
              "displayText": "Denver, Denver International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Denver International",
              "phoneticLabel": null,
              "searchText": "den denver international united states denver",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CDC",
              "cityName": "Cedar City",
              "code": "CDC",
              "countryName": "United States",
              "displayText": "Cedar City, Cedar City",
              "isDestination": true,
              "isOrigin": true,
              "label": "Cedar City",
              "phoneticLabel": null,
              "searchText": "cdc cedar city united states cedar city",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MOT",
              "cityName": "Minot",
              "code": "MOT",
              "countryName": "United States",
              "displayText": "Minot, Minot International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Minot International Airport",
              "phoneticLabel": null,
              "searchText": "mot minot international airport united states minot",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "AEX",
              "cityName": "Alexandria, LA",
              "code": "AEX",
              "countryName": "United States",
              "displayText": "Alexandria, LA, Alexandria International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Alexandria International Airport",
              "phoneticLabel": null,
              "searchText": "aex alexandria international airport united states alexandria, la",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ROA",
              "cityName": "Roanoke",
              "code": "ROA",
              "countryName": "United States",
              "displayText": "Roanoke, Roanoke Regional Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Roanoke Regional Airport",
              "phoneticLabel": null,
              "searchText": "roa roanoke regional airport united states roanoke",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HOU",
              "cityName": "Houston",
              "code": "HOU",
              "countryName": "United States",
              "displayText": "Houston",
              "isDestination": true,
              "isOrigin": true,
              "label": "Houston",
              "phoneticLabel": null,
              "searchText": "hou houston united states",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "HOU",
              "cityName": "Houston",
              "code": "HOU",
              "countryName": "United States",
              "displayText": "Houston, William P. Hobby Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "William P. Hobby Airport",
              "phoneticLabel": null,
              "searchText": "hou william p. hobby airport united states houston",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HOU",
              "cityName": "Houston",
              "code": "IAH",
              "countryName": "United States",
              "displayText": "Houston, George Bush Intercontinental",
              "isDestination": true,
              "isOrigin": true,
              "label": "George Bush Intercontinental",
              "phoneticLabel": null,
              "searchText": "iah george bush intercontinental united states houston",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CHO",
              "cityName": "Charlottesville",
              "code": "CHO",
              "countryName": "United States",
              "displayText": "Charlottesville, Albemarle",
              "isDestination": true,
              "isOrigin": true,
              "label": "Albemarle",
              "phoneticLabel": null,
              "searchText": "cho albemarle united states charlottesville",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "DIK",
              "cityName": "Dickinson",
              "code": "DIK",
              "countryName": "United States",
              "displayText": "Dickinson, Theodore Roosevelt Regional Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Theodore Roosevelt Regional Airport",
              "phoneticLabel": null,
              "searchText": "dik theodore roosevelt regional airport united states dickinson",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MGM",
              "cityName": "Montgomery",
              "code": "MGM",
              "countryName": "United States",
              "displayText": "Montgomery, Dannelly Field",
              "isDestination": true,
              "isOrigin": true,
              "label": "Dannelly Field",
              "phoneticLabel": null,
              "searchText": "mgm dannelly field united states montgomery",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BTV",
              "cityName": "Burlington, VT",
              "code": "BTV",
              "countryName": "United States",
              "displayText": "Burlington, VT, Burlington International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Burlington International Airport",
              "phoneticLabel": null,
              "searchText": "btv burlington international airport united states burlington, vt",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "VLD",
              "cityName": "Valdosta",
              "code": "VLD",
              "countryName": "United States",
              "displayText": "Valdosta, Valdosta Regional Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Valdosta Regional Airport",
              "phoneticLabel": null,
              "searchText": "vld valdosta regional airport united states valdosta",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "AUS",
              "cityName": "Austin",
              "code": "AUS",
              "countryName": "United States",
              "displayText": "Austin, Bergstrom International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Bergstrom International",
              "phoneticLabel": null,
              "searchText": "aus bergstrom international united states austin",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BHM",
              "cityName": "Birmingham, AL",
              "code": "BHM",
              "countryName": "United States",
              "displayText": "Birmingham, AL, Birmingham",
              "isDestination": true,
              "isOrigin": true,
              "label": "Birmingham",
              "phoneticLabel": null,
              "searchText": "bhm birmingham united states birmingham, al",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "DFW",
              "cityName": "Dallas",
              "code": "DFW",
              "countryName": "United States",
              "displayText": "Dallas",
              "isDestination": true,
              "isOrigin": true,
              "label": "Dallas",
              "phoneticLabel": null,
              "searchText": "dfw dallas united states",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "DFW",
              "cityName": "Dallas",
              "code": "DAL",
              "countryName": "United States",
              "displayText": "Dallas, Love Field",
              "isDestination": true,
              "isOrigin": true,
              "label": "Love Field",
              "phoneticLabel": null,
              "searchText": "dal love field united states dallas",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "DFW",
              "cityName": "Dallas",
              "code": "DFW",
              "countryName": "United States",
              "displayText": "Dallas, Dallas-Fort Worth International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Dallas-Fort Worth International Airport",
              "phoneticLabel": null,
              "searchText": "dfw dallas-fort worth international airport united states dallas",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LUL",
              "cityName": "Laurel",
              "code": "PIB",
              "countryName": "United States",
              "displayText": "Laurel, Hattiesburg-Laurel Regional Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Hattiesburg-Laurel Regional Airport",
              "phoneticLabel": null,
              "searchText": "pib hattiesburg-laurel regional airport united states laurel",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MEM",
              "cityName": "Memphis",
              "code": "MEM",
              "countryName": "United States",
              "displayText": "Memphis, Memphis International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Memphis International Airport",
              "phoneticLabel": null,
              "searchText": "mem memphis international airport united states memphis",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "EYW",
              "cityName": "Key West",
              "code": "EYW",
              "countryName": "United States",
              "displayText": "Key West, Key West International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Key West International Airport",
              "phoneticLabel": null,
              "searchText": "eyw key west international airport united states key west",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SBN",
              "cityName": "South Bend",
              "code": "SBN",
              "countryName": "United States",
              "displayText": "South Bend, South Bend Regional Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "South Bend Regional Airport",
              "phoneticLabel": null,
              "searchText": "sbn south bend regional airport united states south bend",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MCI",
              "cityName": "Kansas City",
              "code": "MCI",
              "countryName": "United States",
              "displayText": "Kansas City, Kansas City Intl.",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kansas City Intl.",
              "phoneticLabel": null,
              "searchText": "mci kansas city intl. united states kansas city",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SAV",
              "cityName": "Savannah",
              "code": "SAV",
              "countryName": "United States",
              "displayText": "Savannah, Savannah/Hilton Head International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Savannah/Hilton Head International Airport",
              "phoneticLabel": null,
              "searchText": "sav savannah/hilton head international airport united states savannah",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PVD",
              "cityName": "Providence",
              "code": "PVD",
              "countryName": "United States",
              "displayText": "Providence, T.F. Green Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "T.F. Green Airport",
              "phoneticLabel": null,
              "searchText": "pvd t.f. green airport united states providence",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PSP",
              "cityName": "Palm Springs",
              "code": "PSP",
              "countryName": "United States",
              "displayText": "Palm Springs, Palm Springs International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Palm Springs International Airport",
              "phoneticLabel": null,
              "searchText": "psp palm springs international airport united states palm springs",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "AVL",
              "cityName": "Asheville",
              "code": "AVL",
              "countryName": "United States",
              "displayText": "Asheville, Asheville Regional",
              "isDestination": true,
              "isOrigin": true,
              "label": "Asheville Regional",
              "phoneticLabel": null,
              "searchText": "avl asheville regional united states asheville",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PIH",
              "cityName": "Pocatello",
              "code": "PIH",
              "countryName": "United States",
              "displayText": "Pocatello, Pocatello Regional Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Pocatello Regional Airport",
              "phoneticLabel": null,
              "searchText": "pih pocatello regional airport united states pocatello",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TUL",
              "cityName": "Tulsa",
              "code": "TUL",
              "countryName": "United States",
              "displayText": "Tulsa, Tulsa International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Tulsa International Airport",
              "phoneticLabel": null,
              "searchText": "tul tulsa international airport united states tulsa",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "FCA",
              "cityName": "Kalispell",
              "code": "FCA",
              "countryName": "United States",
              "displayText": "Kalispell, Glacier National Park",
              "isDestination": true,
              "isOrigin": true,
              "label": "Glacier National Park",
              "phoneticLabel": null,
              "searchText": "fca glacier national park united states kalispell",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MSN",
              "cityName": "Madison",
              "code": "MSN",
              "countryName": "United States",
              "displayText": "Madison, Dane County Regional",
              "isDestination": true,
              "isOrigin": true,
              "label": "Dane County Regional",
              "phoneticLabel": null,
              "searchText": "msn dane county regional united states madison",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "GSO",
              "cityName": "Greensboro High Point",
              "code": "GSO",
              "countryName": "United States",
              "displayText": "Greensboro High Point, Piedmont Triad International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Piedmont Triad International",
              "phoneticLabel": null,
              "searchText": "gso piedmont triad international united states greensboro high point",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "RNO",
              "cityName": "Reno",
              "code": "RNO",
              "countryName": "United States",
              "displayText": "Reno, Reno/Tahoe International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Reno/Tahoe International",
              "phoneticLabel": null,
              "searchText": "rno reno/tahoe international united states reno",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "FAY",
              "cityName": "Fayetteville, NC",
              "code": "FAY",
              "countryName": "United States",
              "displayText": "Fayetteville, NC, Fayetteville Regional Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Fayetteville Regional Airport",
              "phoneticLabel": null,
              "searchText": "fay fayetteville regional airport united states fayetteville, nc",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SDF",
              "cityName": "Louisville",
              "code": "SDF",
              "countryName": "United States",
              "displayText": "Louisville, Louisville International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Louisville International Airport",
              "phoneticLabel": null,
              "searchText": "sdf louisville international airport united states louisville",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PLN",
              "cityName": "Pellston",
              "code": "PLN",
              "countryName": "United States",
              "displayText": "Pellston, Emmet County Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Emmet County Airport",
              "phoneticLabel": null,
              "searchText": "pln emmet county airport united states pellston",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CHS",
              "cityName": "Charleston, SC",
              "code": "CHS",
              "countryName": "United States",
              "displayText": "Charleston, SC, Charleston International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Charleston International Airport",
              "phoneticLabel": null,
              "searchText": "chs charleston international airport united states charleston, sc",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MLI",
              "cityName": "Moline",
              "code": "MLI",
              "countryName": "United States",
              "displayText": "Moline, Quad-City Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Quad-City Airport",
              "phoneticLabel": null,
              "searchText": "mli quad-city airport united states moline",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ABR",
              "cityName": "Aberdeen, SD",
              "code": "ABR",
              "countryName": "United States",
              "displayText": "Aberdeen, SD, Municipal Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Municipal Airport",
              "phoneticLabel": null,
              "searchText": "abr municipal airport united states aberdeen, sd",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SSM",
              "cityName": "Sault Saint Marie",
              "code": "CIU",
              "countryName": "United States",
              "displayText": "Sault Saint Marie, Chippewa County Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Chippewa County Airport",
              "phoneticLabel": null,
              "searchText": "ciu chippewa county airport united states sault saint marie",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MKE",
              "cityName": "Milwaukee",
              "code": "MKE",
              "countryName": "United States",
              "displayText": "Milwaukee, General Mitchell",
              "isDestination": true,
              "isOrigin": true,
              "label": "General Mitchell",
              "phoneticLabel": null,
              "searchText": "mke general mitchell united states milwaukee",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "STL",
              "cityName": "Saint Louis",
              "code": "STL",
              "countryName": "United States",
              "displayText": "Saint Louis, St. Louis Lambert International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "St. Louis Lambert International Airport",
              "phoneticLabel": null,
              "searchText": "stl st. louis lambert international airport united states saint louis",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HPN",
              "cityName": "White Plains",
              "code": "HPN",
              "countryName": "United States",
              "displayText": "White Plains, Westchester County",
              "isDestination": true,
              "isOrigin": true,
              "label": "Westchester County",
              "phoneticLabel": null,
              "searchText": "hpn westchester county united states white plains",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TVC",
              "cityName": "Traverse City",
              "code": "TVC",
              "countryName": "United States",
              "displayText": "Traverse City, Traverse City",
              "isDestination": true,
              "isOrigin": true,
              "label": "Traverse City",
              "phoneticLabel": null,
              "searchText": "tvc traverse city united states traverse city",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TPA",
              "cityName": "Tampa",
              "code": "TPA",
              "countryName": "United States",
              "displayText": "Tampa, Tampa International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Tampa International Airport",
              "phoneticLabel": null,
              "searchText": "tpa tampa international airport united states tampa",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ORF",
              "cityName": "Norfolk",
              "code": "ORF",
              "countryName": "United States",
              "displayText": "Norfolk, Norfolk International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Norfolk International Airport",
              "phoneticLabel": null,
              "searchText": "orf norfolk international airport united states norfolk",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BIL",
              "cityName": "Billings",
              "code": "BIL",
              "countryName": "United States",
              "displayText": "Billings, Billings Logan International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Billings Logan International Airport",
              "phoneticLabel": null,
              "searchText": "bil billings logan international airport united states billings",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PIT",
              "cityName": "Pittsburgh",
              "code": "PIT",
              "countryName": "United States",
              "displayText": "Pittsburgh, Pittsburg International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Pittsburg International",
              "phoneticLabel": null,
              "searchText": "pit pittsburg international united states pittsburgh",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BOS",
              "cityName": "Boston",
              "code": "BOS",
              "countryName": "United States",
              "displayText": "Boston, Logan International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Logan International",
              "phoneticLabel": null,
              "searchText": "bos logan international united states boston",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SNA",
              "cityName": "Santa Ana",
              "code": "SNA",
              "countryName": "United States",
              "displayText": "Santa Ana, John Wayne",
              "isDestination": true,
              "isOrigin": true,
              "label": "John Wayne",
              "phoneticLabel": null,
              "searchText": "sna john wayne united states santa ana",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "XNA",
              "cityName": "Fayetteville Springdale",
              "code": "XNA",
              "countryName": "United States",
              "displayText": "Fayetteville Springdale, Northwest Arkansas Regional Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Northwest Arkansas Regional Airport",
              "phoneticLabel": null,
              "searchText": "xna northwest arkansas regional airport united states fayetteville springdale",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PWM",
              "cityName": "Portland, ME",
              "code": "PWM",
              "countryName": "United States",
              "displayText": "Portland, ME, Portland International Jetport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Portland International Jetport",
              "phoneticLabel": null,
              "searchText": "pwm portland international jetport united states portland, me",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "FAT",
              "cityName": "Fresno",
              "code": "FAT",
              "countryName": "United States",
              "displayText": "Fresno, Yosemite International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Yosemite International Airport",
              "phoneticLabel": null,
              "searchText": "fat yosemite international airport united states fresno",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SRQ",
              "cityName": "Sarasota",
              "code": "SRQ",
              "countryName": "United States",
              "displayText": "Sarasota, Bradenton",
              "isDestination": true,
              "isOrigin": true,
              "label": "Bradenton",
              "phoneticLabel": null,
              "searchText": "srq bradenton united states sarasota",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SGF",
              "cityName": "Springfield, MO",
              "code": "SGF",
              "countryName": "United States",
              "displayText": "Springfield, MO, Springfield-Branson National Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Springfield-Branson National Airport",
              "phoneticLabel": null,
              "searchText": "sgf springfield-branson national airport united states springfield, mo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "GRB",
              "cityName": "Green Bay",
              "code": "GRB",
              "countryName": "United States",
              "displayText": "Green Bay, Austin-Straubel Field",
              "isDestination": true,
              "isOrigin": true,
              "label": "Austin-Straubel Field",
              "phoneticLabel": null,
              "searchText": "grb austin-straubel field united states green bay",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MBS",
              "cityName": "Saginaw",
              "code": "MBS",
              "countryName": "United States",
              "displayText": "Saginaw, Tri City Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Tri City Airport",
              "phoneticLabel": null,
              "searchText": "mbs tri city airport united states saginaw",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BGR",
              "cityName": "Bangor",
              "code": "BGR",
              "countryName": "United States",
              "displayText": "Bangor, Bangor International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Bangor International Airport",
              "phoneticLabel": null,
              "searchText": "bgr bangor international airport united states bangor",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CAE",
              "cityName": "Columbia, SC",
              "code": "CAE",
              "countryName": "United States",
              "displayText": "Columbia, SC, Columbia Metropolitan Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Columbia Metropolitan Airport",
              "phoneticLabel": null,
              "searchText": "cae columbia metropolitan airport united states columbia, sc",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LFT",
              "cityName": "Lafayette, LA",
              "code": "LFT",
              "countryName": "United States",
              "displayText": "Lafayette, LA, Lafayette Regional Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Lafayette Regional Airport",
              "phoneticLabel": null,
              "searchText": "lft lafayette regional airport united states lafayette, la",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "DTT",
              "cityName": "Detroit",
              "code": "DTW",
              "countryName": "United States",
              "displayText": "Detroit, Detroit Metro Wayne County Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Detroit Metro Wayne County Airport",
              "phoneticLabel": null,
              "searchText": "dtw detroit metro wayne county airport united states detroit",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "RAP",
              "cityName": "Rapid City",
              "code": "RAP",
              "countryName": "United States",
              "displayText": "Rapid City, Rapid City Regional Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Rapid City Regional Airport",
              "phoneticLabel": null,
              "searchText": "rap rapid city regional airport united states rapid city",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ALB",
              "cityName": "Albany, NY",
              "code": "ALB",
              "countryName": "United States",
              "displayText": "Albany, NY, Albany International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Albany International Airport",
              "phoneticLabel": null,
              "searchText": "alb albany international airport united states albany, ny",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MIA",
              "cityName": "Miami",
              "code": "MIA",
              "countryName": "United States",
              "displayText": "Miami, Miami International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Miami International Airport",
              "phoneticLabel": null,
              "searchText": "mia miami international airport united states miami",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CID",
              "cityName": "Cedar Rapids",
              "code": "CID",
              "countryName": "United States",
              "displayText": "Cedar Rapids, Eastern Iowa Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Eastern Iowa Airport",
              "phoneticLabel": null,
              "searchText": "cid eastern iowa airport united states cedar rapids",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MFR",
              "cityName": "Medford",
              "code": "MFR",
              "countryName": "United States",
              "displayText": "Medford, Jackson County",
              "isDestination": true,
              "isOrigin": true,
              "label": "Jackson County",
              "phoneticLabel": null,
              "searchText": "mfr jackson county united states medford",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "OKC",
              "cityName": "Oklahoma City",
              "code": "OKC",
              "countryName": "United States",
              "displayText": "Oklahoma City, Will Rogers World",
              "isDestination": true,
              "isOrigin": true,
              "label": "Will Rogers World",
              "phoneticLabel": null,
              "searchText": "okc will rogers world united states oklahoma city",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CHI",
              "cityName": "Chicago",
              "code": "CHI",
              "countryName": "United States",
              "displayText": "Chicago",
              "isDestination": true,
              "isOrigin": true,
              "label": "Chicago",
              "phoneticLabel": null,
              "searchText": "chi chicago united states",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "CHI",
              "cityName": "Chicago",
              "code": "ORD",
              "countryName": "United States",
              "displayText": "Chicago, O'Hare International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "O'Hare International Airport",
              "phoneticLabel": null,
              "searchText": "ord o'hare international airport united states chicago",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CHI",
              "cityName": "Chicago",
              "code": "MDW",
              "countryName": "United States",
              "displayText": "Chicago, Midway Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Midway Airport",
              "phoneticLabel": null,
              "searchText": "mdw midway airport united states chicago",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HRL",
              "cityName": "Harlingen",
              "code": "HRL",
              "countryName": "United States",
              "displayText": "Harlingen, Valley International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Valley International Airport",
              "phoneticLabel": null,
              "searchText": "hrl valley international airport united states harlingen",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LIH",
              "cityName": "Kauai Island",
              "code": "LIH",
              "countryName": "United States",
              "displayText": "Kauai Island, Lihue",
              "isDestination": true,
              "isOrigin": true,
              "label": "Lihue",
              "phoneticLabel": null,
              "searchText": "lih lihue united states kauai island",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "JAX",
              "cityName": "Jacksonville, FL",
              "code": "JAX",
              "countryName": "United States",
              "displayText": "Jacksonville, FL, Jacksonville International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Jacksonville International Airport",
              "phoneticLabel": null,
              "searchText": "jax jacksonville international airport united states jacksonville, fl",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LIR",
              "cityName": "Liberia",
              "code": "LIR",
              "countryName": "Costa Rica",
              "displayText": "Liberia, Daniel Oduber Quiros International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Daniel Oduber Quiros International Airport",
              "phoneticLabel": null,
              "searchText": "lir daniel oduber quiros international airport costa rica liberia",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SJO",
              "cityName": "San Jose",
              "code": "SJO",
              "countryName": "Costa Rica",
              "displayText": "San Jose, Juan Santamaría International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Juan Santamaría International Airport",
              "phoneticLabel": null,
              "searchText": "sjo juan santamaría international airport costa rica san jose",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BON",
              "cityName": "Bonaire",
              "code": "BON",
              "countryName": "Bonaire, St Eustatius, Saba",
              "displayText": "Bonaire, Flamingo International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Flamingo International",
              "phoneticLabel": null,
              "searchText": "bon flamingo international bonaire, st eustatius, saba bonaire",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "EUX",
              "cityName": "Saint Eustatius",
              "code": "EUX",
              "countryName": "Bonaire, St Eustatius, Saba",
              "displayText": "Saint Eustatius, F.D. Roosevelt Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "F.D. Roosevelt Airport",
              "phoneticLabel": null,
              "searchText": "eux f.d. roosevelt airport bonaire, st eustatius, saba saint eustatius",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SAB",
              "cityName": "Saba",
              "code": "SAB",
              "countryName": "Bonaire, St Eustatius, Saba",
              "displayText": "Saba, Juancho E. Yrausquin Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Juancho E. Yrausquin Airport",
              "phoneticLabel": null,
              "searchText": "sab juancho e. yrausquin airport bonaire, st eustatius, saba saba",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LJU",
              "cityName": "Ljubljana",
              "code": "LJU",
              "countryName": "Slovenia",
              "displayText": "Ljubljana, Ljubljana Joze Pucnik Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Ljubljana Joze Pucnik Airport",
              "phoneticLabel": null,
              "searchText": "lju ljubljana joze pucnik airport slovenia ljubljana",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SVD",
              "cityName": "Saint Vincent",
              "code": "SVD",
              "countryName": "Saint Vincent and the Grenadines",
              "displayText": "Saint Vincent, Argyle Intl Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Argyle Intl Airport",
              "phoneticLabel": null,
              "searchText": "svd argyle intl airport saint vincent and the grenadines saint vincent",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "WDH",
              "cityName": "Windhoek",
              "code": "WDH",
              "countryName": "Namibia",
              "displayText": "Windhoek, Hosea Kutako International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Hosea Kutako International Airport",
              "phoneticLabel": null,
              "searchText": "wdh hosea kutako international airport namibia windhoek",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "WVB",
              "cityName": "Walvis Bay",
              "code": "WVB",
              "countryName": "Namibia",
              "displayText": "Walvis Bay, Walvis Bay",
              "isDestination": true,
              "isOrigin": true,
              "label": "Walvis Bay",
              "phoneticLabel": null,
              "searchText": "wvb walvis bay namibia walvis bay",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ALF",
              "cityName": "Alta",
              "code": "ALF",
              "countryName": "Norway",
              "displayText": "Alta, Alta Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Alta Airport",
              "phoneticLabel": null,
              "searchText": "alf alta airport norway alta",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SSJ",
              "cityName": "Sandnessjoen",
              "code": "SSJ",
              "countryName": "Norway",
              "displayText": "Sandnessjoen, Stokka Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Stokka Airport",
              "phoneticLabel": null,
              "searchText": "ssj stokka airport norway sandnessjoen",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "FDE",
              "cityName": "Forde",
              "code": "FDE",
              "countryName": "Norway",
              "displayText": "Forde, Førde Airport, Bringeland",
              "isDestination": true,
              "isOrigin": true,
              "label": "Førde Airport, Bringeland",
              "phoneticLabel": null,
              "searchText": "fde førde airport, bringeland norway forde",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KRS",
              "cityName": "Kristiansand",
              "code": "KRS",
              "countryName": "Norway",
              "displayText": "Kristiansand, Kjevik",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kjevik",
              "phoneticLabel": null,
              "searchText": "krs kjevik norway kristiansand",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SVG",
              "cityName": "Stavanger",
              "code": "SVG",
              "countryName": "Norway",
              "displayText": "Stavanger, Sola Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Sola Airport",
              "phoneticLabel": null,
              "searchText": "svg sola airport norway stavanger",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "AES",
              "cityName": "Alesund",
              "code": "AES",
              "countryName": "Norway",
              "displayText": "Alesund, Vigra",
              "isDestination": true,
              "isOrigin": true,
              "label": "Vigra",
              "phoneticLabel": null,
              "searchText": "aes vigra norway alesund",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MJF",
              "cityName": "Mosjoen",
              "code": "MJF",
              "countryName": "Norway",
              "displayText": "Mosjoen, Kjaerstad",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kjaerstad",
              "phoneticLabel": null,
              "searchText": "mjf kjaerstad norway mosjoen",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TOS",
              "cityName": "Tromso",
              "code": "TOS",
              "countryName": "Norway",
              "displayText": "Tromso, Tromso Langnes Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Tromso Langnes Airport",
              "phoneticLabel": null,
              "searchText": "tos tromso langnes airport norway tromso",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "FRO",
              "cityName": "Floro",
              "code": "FRO",
              "countryName": "Norway",
              "displayText": "Floro, Floro",
              "isDestination": true,
              "isOrigin": true,
              "label": "Floro",
              "phoneticLabel": null,
              "searchText": "fro floro norway floro",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KKN",
              "cityName": "Kirkenes",
              "code": "KKN",
              "countryName": "Norway",
              "displayText": "Kirkenes, Kirkenes Hoybuktmoen Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kirkenes Hoybuktmoen Airport",
              "phoneticLabel": null,
              "searchText": "kkn kirkenes hoybuktmoen airport norway kirkenes",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BNN",
              "cityName": "Bronnoysund",
              "code": "BNN",
              "countryName": "Norway",
              "displayText": "Bronnoysund, Bronnoy",
              "isDestination": true,
              "isOrigin": true,
              "label": "Bronnoy",
              "phoneticLabel": null,
              "searchText": "bnn bronnoy norway bronnoysund",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SVJ",
              "cityName": "Svolvaer",
              "code": "SVJ",
              "countryName": "Norway",
              "displayText": "Svolvaer, Helle",
              "isDestination": true,
              "isOrigin": true,
              "label": "Helle",
              "phoneticLabel": null,
              "searchText": "svj helle norway svolvaer",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HOV",
              "cityName": "Orsta Volda",
              "code": "HOV",
              "countryName": "Norway",
              "displayText": "Orsta Volda, Hovden",
              "isDestination": true,
              "isOrigin": true,
              "label": "Hovden",
              "phoneticLabel": null,
              "searchText": "hov hovden norway orsta volda",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MQN",
              "cityName": "Mo i rana",
              "code": "MQN",
              "countryName": "Norway",
              "displayText": "Mo i rana, Rossvoll",
              "isDestination": true,
              "isOrigin": true,
              "label": "Rossvoll",
              "phoneticLabel": null,
              "searchText": "mqn rossvoll norway mo i rana",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "EVE",
              "cityName": "Narvik Lofoten",
              "code": "EVE",
              "countryName": "Norway",
              "displayText": "Narvik Lofoten, Evenes Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Evenes Airport",
              "phoneticLabel": null,
              "searchText": "eve evenes airport norway narvik lofoten",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SKN",
              "cityName": "Stokmarknes",
              "code": "SKN",
              "countryName": "Norway",
              "displayText": "Stokmarknes, Skagen",
              "isDestination": true,
              "isOrigin": true,
              "label": "Skagen",
              "phoneticLabel": null,
              "searchText": "skn skagen norway stokmarknes",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SDN",
              "cityName": "Sandane",
              "code": "SDN",
              "countryName": "Norway",
              "displayText": "Sandane, Sandane Airport, Anda",
              "isDestination": true,
              "isOrigin": true,
              "label": "Sandane Airport, Anda",
              "phoneticLabel": null,
              "searchText": "sdn sandane airport, anda norway sandane",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HAU",
              "cityName": "Haugesund",
              "code": "HAU",
              "countryName": "Norway",
              "displayText": "Haugesund, Haugesund Karmoy Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Haugesund Karmoy Airport",
              "phoneticLabel": null,
              "searchText": "hau haugesund karmoy airport norway haugesund",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SOG",
              "cityName": "Sogndal",
              "code": "SOG",
              "countryName": "Norway",
              "displayText": "Sogndal, Haukasen",
              "isDestination": true,
              "isOrigin": true,
              "label": "Haukasen",
              "phoneticLabel": null,
              "searchText": "sog haukasen norway sogndal",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KSU",
              "cityName": "Kristiansund",
              "code": "KSU",
              "countryName": "Norway",
              "displayText": "Kristiansund, Kristiansund Kvernberget Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kristiansund Kvernberget Airport",
              "phoneticLabel": null,
              "searchText": "ksu kristiansund kvernberget airport norway kristiansund",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "OSL",
              "cityName": "Oslo",
              "code": "OSL",
              "countryName": "Norway",
              "displayText": "Oslo",
              "isDestination": true,
              "isOrigin": true,
              "label": "Oslo",
              "phoneticLabel": null,
              "searchText": "osl oslo norway",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "OSL",
              "cityName": "Oslo",
              "code": "TRF",
              "countryName": "Norway",
              "displayText": "Oslo, Torp Sandefjord Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Torp Sandefjord Airport",
              "phoneticLabel": null,
              "searchText": "trf torp sandefjord airport norway oslo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "OSL",
              "cityName": "Oslo",
              "code": "OSL",
              "countryName": "Norway",
              "displayText": "Oslo, Oslo Gardermoen",
              "isDestination": true,
              "isOrigin": true,
              "label": "Oslo Gardermoen",
              "phoneticLabel": null,
              "searchText": "osl oslo gardermoen norway oslo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LKN",
              "cityName": "Leknes",
              "code": "LKN",
              "countryName": "Norway",
              "displayText": "Leknes, Leknes",
              "isDestination": true,
              "isOrigin": true,
              "label": "Leknes",
              "phoneticLabel": null,
              "searchText": "lkn leknes norway leknes",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BGO",
              "cityName": "Bergen",
              "code": "BGO",
              "countryName": "Norway",
              "displayText": "Bergen, Flesland",
              "isDestination": true,
              "isOrigin": true,
              "label": "Flesland",
              "phoneticLabel": null,
              "searchText": "bgo flesland norway bergen",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BOO",
              "cityName": "Bodo",
              "code": "BOO",
              "countryName": "Norway",
              "displayText": "Bodo, Bodo Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Bodo Airport",
              "phoneticLabel": null,
              "searchText": "boo bodo airport norway bodo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SKE",
              "cityName": "Skien",
              "code": "SKE",
              "countryName": "Norway",
              "displayText": "Skien, Geiteryggen",
              "isDestination": true,
              "isOrigin": true,
              "label": "Geiteryggen",
              "phoneticLabel": null,
              "searchText": "ske geiteryggen norway skien",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TRD",
              "cityName": "Trondheim",
              "code": "TRD",
              "countryName": "Norway",
              "displayText": "Trondheim, Vaernes",
              "isDestination": true,
              "isOrigin": true,
              "label": "Vaernes",
              "phoneticLabel": null,
              "searchText": "trd vaernes norway trondheim",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MOL",
              "cityName": "Molde",
              "code": "MOL",
              "countryName": "Norway",
              "displayText": "Molde, Molde Aro Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Molde Aro Airport",
              "phoneticLabel": null,
              "searchText": "mol molde aro airport norway molde",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "JIB",
              "cityName": "Djibouti",
              "code": "JIB",
              "countryName": "Djibouti",
              "displayText": "Djibouti, Ambouli Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Ambouli Airport",
              "phoneticLabel": null,
              "searchText": "jib ambouli airport djibouti djibouti",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "INV",
              "cityName": "Inverness",
              "code": "INV",
              "countryName": "United Kingdom",
              "displayText": "Inverness, Inverness",
              "isDestination": true,
              "isOrigin": true,
              "label": "Inverness",
              "phoneticLabel": null,
              "searchText": "inv inverness united kingdom inverness",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "EDI",
              "cityName": "Edinburgh",
              "code": "EDI",
              "countryName": "United Kingdom",
              "displayText": "Edinburgh, Edinburgh",
              "isDestination": true,
              "isOrigin": true,
              "label": "Edinburgh",
              "phoneticLabel": null,
              "searchText": "edi edinburgh united kingdom edinburgh",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NCL",
              "cityName": "Newcastle",
              "code": "NCL",
              "countryName": "United Kingdom",
              "displayText": "Newcastle, Newcastle International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Newcastle International Airport",
              "phoneticLabel": null,
              "searchText": "ncl newcastle international airport united kingdom newcastle",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LON",
              "cityName": "London",
              "code": "LON",
              "countryName": "United Kingdom",
              "displayText": "London",
              "isDestination": true,
              "isOrigin": true,
              "label": "London",
              "phoneticLabel": null,
              "searchText": "lon london united kingdom",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "LON",
              "cityName": "London",
              "code": "LGW",
              "countryName": "United Kingdom",
              "displayText": "London, London Gatwick Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "London Gatwick Airport",
              "phoneticLabel": null,
              "searchText": "lgw london gatwick airport united kingdom london",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LON",
              "cityName": "London",
              "code": "LHR",
              "countryName": "United Kingdom",
              "displayText": "London, London Heathrow Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "London Heathrow Airport",
              "phoneticLabel": null,
              "searchText": "lhr london heathrow airport united kingdom london",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LON",
              "cityName": "London",
              "code": "LCY",
              "countryName": "United Kingdom",
              "displayText": "London, London City Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "London City Airport",
              "phoneticLabel": null,
              "searchText": "lcy london city airport united kingdom london",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LDY",
              "cityName": "Derry",
              "code": "LDY",
              "countryName": "United Kingdom",
              "displayText": "Derry, City of Derry Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "City of Derry Airport",
              "phoneticLabel": null,
              "searchText": "ldy city of derry airport united kingdom derry",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NWI",
              "cityName": "Norwich",
              "code": "NWI",
              "countryName": "United Kingdom",
              "displayText": "Norwich, Norwich Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Norwich Airport",
              "phoneticLabel": null,
              "searchText": "nwi norwich airport united kingdom norwich",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BFS",
              "cityName": "Belfast",
              "code": "BHD",
              "countryName": "United Kingdom",
              "displayText": "Belfast, George Best Belfast City Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "George Best Belfast City Airport",
              "phoneticLabel": null,
              "searchText": "bhd george best belfast city airport united kingdom belfast",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SYY",
              "cityName": "Stornoway",
              "code": "SYY",
              "countryName": "United Kingdom",
              "displayText": "Stornoway, Stornoway",
              "isDestination": true,
              "isOrigin": true,
              "label": "Stornoway",
              "phoneticLabel": null,
              "searchText": "syy stornoway united kingdom stornoway",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HUY",
              "cityName": "Humberside",
              "code": "HUY",
              "countryName": "United Kingdom",
              "displayText": "Humberside, Humberside airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Humberside airport",
              "phoneticLabel": null,
              "searchText": "huy humberside airport united kingdom humberside",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BRS",
              "cityName": "Bristol",
              "code": "BRS",
              "countryName": "United Kingdom",
              "displayText": "Bristol, Bristol Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Bristol Airport",
              "phoneticLabel": null,
              "searchText": "brs bristol airport united kingdom bristol",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ABZ",
              "cityName": "Aberdeen",
              "code": "ABZ",
              "countryName": "United Kingdom",
              "displayText": "Aberdeen, Dyce",
              "isDestination": true,
              "isOrigin": true,
              "label": "Dyce",
              "phoneticLabel": null,
              "searchText": "abz dyce united kingdom aberdeen",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "GLA",
              "cityName": "Glasgow",
              "code": "GLA",
              "countryName": "United Kingdom",
              "displayText": "Glasgow, Glasgow International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Glasgow International Airport",
              "phoneticLabel": null,
              "searchText": "gla glasgow international airport united kingdom glasgow",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NQT",
              "cityName": "Nottingham",
              "code": "EMA",
              "countryName": "United Kingdom",
              "displayText": "Nottingham, East Midlands Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "East Midlands Airport",
              "phoneticLabel": null,
              "searchText": "ema east midlands airport united kingdom nottingham",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MAN",
              "cityName": "Manchester",
              "code": "MAN",
              "countryName": "United Kingdom",
              "displayText": "Manchester, Manchester Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Manchester Airport",
              "phoneticLabel": null,
              "searchText": "man manchester airport united kingdom manchester",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MME",
              "cityName": "Teesside",
              "code": "MME",
              "countryName": "United Kingdom",
              "displayText": "Teesside, Teesside International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Teesside International Airport",
              "phoneticLabel": null,
              "searchText": "mme teesside international airport united kingdom teesside",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LBA",
              "cityName": "Leeds Bradford",
              "code": "LBA",
              "countryName": "United Kingdom",
              "displayText": "Leeds Bradford, Leeds Bradford Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Leeds Bradford Airport",
              "phoneticLabel": null,
              "searchText": "lba leeds bradford airport united kingdom leeds bradford",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CWL",
              "cityName": "Cardiff",
              "code": "CWL",
              "countryName": "United Kingdom",
              "displayText": "Cardiff, Cardiff-Wales Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Cardiff-Wales Airport",
              "phoneticLabel": null,
              "searchText": "cwl cardiff-wales airport united kingdom cardiff",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SOU",
              "cityName": "Southampton",
              "code": "SOU",
              "countryName": "United Kingdom",
              "displayText": "Southampton, Southampton Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Southampton Airport",
              "phoneticLabel": null,
              "searchText": "sou southampton airport united kingdom southampton",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "EXT",
              "cityName": "Exeter",
              "code": "EXT",
              "countryName": "United Kingdom",
              "displayText": "Exeter, Exeter Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Exeter Airport",
              "phoneticLabel": null,
              "searchText": "ext exeter airport united kingdom exeter",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BHX",
              "cityName": "Birmingham",
              "code": "BHX",
              "countryName": "United Kingdom",
              "displayText": "Birmingham, Birmingham Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Birmingham Airport",
              "phoneticLabel": null,
              "searchText": "bhx birmingham airport united kingdom birmingham",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LBU",
              "cityName": "Labuan",
              "code": "LBU",
              "countryName": "Malaysia",
              "displayText": "Labuan, Labuan",
              "isDestination": true,
              "isOrigin": true,
              "label": "Labuan",
              "phoneticLabel": null,
              "searchText": "lbu labuan malaysia labuan",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KUL",
              "cityName": "Kuala Lumpur",
              "code": "KUL",
              "countryName": "Malaysia",
              "displayText": "Kuala Lumpur, Kuala Lumpur International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kuala Lumpur International Airport",
              "phoneticLabel": null,
              "searchText": "kul kuala lumpur international airport malaysia kuala lumpur",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MYY",
              "cityName": "Miri",
              "code": "MYY",
              "countryName": "Malaysia",
              "displayText": "Miri, Miri",
              "isDestination": true,
              "isOrigin": true,
              "label": "Miri",
              "phoneticLabel": null,
              "searchText": "myy miri malaysia miri",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BTU",
              "cityName": "Bintulu",
              "code": "BTU",
              "countryName": "Malaysia",
              "displayText": "Bintulu, Bintulu Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Bintulu Airport",
              "phoneticLabel": null,
              "searchText": "btu bintulu airport malaysia bintulu",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TWU",
              "cityName": "Tawau",
              "code": "TWU",
              "countryName": "Malaysia",
              "displayText": "Tawau, Tawau",
              "isDestination": true,
              "isOrigin": true,
              "label": "Tawau",
              "phoneticLabel": null,
              "searchText": "twu tawau malaysia tawau",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LGK",
              "cityName": "Langkawi",
              "code": "LGK",
              "countryName": "Malaysia",
              "displayText": "Langkawi, Langkawi International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Langkawi International",
              "phoneticLabel": null,
              "searchText": "lgk langkawi international malaysia langkawi",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KBR",
              "cityName": "Kota Bharu",
              "code": "KBR",
              "countryName": "Malaysia",
              "displayText": "Kota Bharu, Pengkalan Chepa",
              "isDestination": true,
              "isOrigin": true,
              "label": "Pengkalan Chepa",
              "phoneticLabel": null,
              "searchText": "kbr pengkalan chepa malaysia kota bharu",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "AOR",
              "cityName": "Alor Setar",
              "code": "AOR",
              "countryName": "Malaysia",
              "displayText": "Alor Setar, Alor Setar",
              "isDestination": true,
              "isOrigin": true,
              "label": "Alor Setar",
              "phoneticLabel": null,
              "searchText": "aor alor setar malaysia alor setar",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PEN",
              "cityName": "Penang",
              "code": "PEN",
              "countryName": "Malaysia",
              "displayText": "Penang, Penang International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Penang International Airport",
              "phoneticLabel": null,
              "searchText": "pen penang international airport malaysia penang",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KUA",
              "cityName": "Kuantan",
              "code": "KUA",
              "countryName": "Malaysia",
              "displayText": "Kuantan, Kuantan",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kuantan",
              "phoneticLabel": null,
              "searchText": "kua kuantan malaysia kuantan",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KCH",
              "cityName": "Kuching",
              "code": "KCH",
              "countryName": "Malaysia",
              "displayText": "Kuching, Kuching",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kuching",
              "phoneticLabel": null,
              "searchText": "kch kuching malaysia kuching",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "JHB",
              "cityName": "Johor Bahru",
              "code": "JHB",
              "countryName": "Malaysia",
              "displayText": "Johor Bahru, Sultan Ismail International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Sultan Ismail International Airport",
              "phoneticLabel": null,
              "searchText": "jhb sultan ismail international airport malaysia johor bahru",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BKI",
              "cityName": "Kota Kinabalu",
              "code": "BKI",
              "countryName": "Malaysia",
              "displayText": "Kota Kinabalu, Kota Kinabalu",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kota Kinabalu",
              "phoneticLabel": null,
              "searchText": "bki kota kinabalu malaysia kota kinabalu",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SDK",
              "cityName": "Sandakan",
              "code": "SDK",
              "countryName": "Malaysia",
              "displayText": "Sandakan, Sandakan",
              "isDestination": true,
              "isOrigin": true,
              "label": "Sandakan",
              "phoneticLabel": null,
              "searchText": "sdk sandakan malaysia sandakan",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SBW",
              "cityName": "Sibu",
              "code": "SBW",
              "countryName": "Malaysia",
              "displayText": "Sibu, Sibu",
              "isDestination": true,
              "isOrigin": true,
              "label": "Sibu",
              "phoneticLabel": null,
              "searchText": "sbw sibu malaysia sibu",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TGG",
              "cityName": "Kuala Terengganu",
              "code": "TGG",
              "countryName": "Malaysia",
              "displayText": "Kuala Terengganu, Sultan Mahmud",
              "isDestination": true,
              "isOrigin": true,
              "label": "Sultan Mahmud",
              "phoneticLabel": null,
              "searchText": "tgg sultan mahmud malaysia kuala terengganu",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ACC",
              "cityName": "Accra",
              "code": "ACC",
              "countryName": "Ghana",
              "displayText": "Accra, Kotoka International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kotoka International Airport",
              "phoneticLabel": null,
              "searchText": "acc kotoka international airport ghana accra",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SYZ",
              "cityName": "Shiraz",
              "code": "SYZ",
              "countryName": "Iran",
              "displayText": "Shiraz, Shahid Dastghaib International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Shahid Dastghaib International Airport",
              "phoneticLabel": null,
              "searchText": "syz shahid dastghaib international airport iran shiraz",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "THR",
              "cityName": "Tehran",
              "code": "THR",
              "countryName": "Iran",
              "displayText": "Tehran",
              "isDestination": true,
              "isOrigin": true,
              "label": "Tehran",
              "phoneticLabel": null,
              "searchText": "thr tehran iran",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "THR",
              "cityName": "Tehran",
              "code": "THR",
              "countryName": "Iran",
              "displayText": "Tehran, Mehrabad International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Mehrabad International",
              "phoneticLabel": null,
              "searchText": "thr mehrabad international iran tehran",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "THR",
              "cityName": "Tehran",
              "code": "IKA",
              "countryName": "Iran",
              "displayText": "Tehran, Imam Khomeini Int.",
              "isDestination": true,
              "isOrigin": true,
              "label": "Imam Khomeini Int.",
              "phoneticLabel": null,
              "searchText": "ika imam khomeini int. iran tehran",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MHD",
              "cityName": "Mashhad",
              "code": "MHD",
              "countryName": "Iran",
              "displayText": "Mashhad, Shahid Hashemi Nejad",
              "isDestination": true,
              "isOrigin": true,
              "label": "Shahid Hashemi Nejad",
              "phoneticLabel": null,
              "searchText": "mhd shahid hashemi nejad iran mashhad",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "IFN",
              "cityName": "Esfahan",
              "code": "IFN",
              "countryName": "Iran",
              "displayText": "Esfahan, Shahid Beheshti International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Shahid Beheshti International Airport",
              "phoneticLabel": null,
              "searchText": "ifn shahid beheshti international airport iran esfahan",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "RUN",
              "cityName": "Saint Denis",
              "code": "RUN",
              "countryName": "Reunion",
              "displayText": "Saint Denis, Roland Garros",
              "isDestination": true,
              "isOrigin": true,
              "label": "Roland Garros",
              "phoneticLabel": null,
              "searchText": "run roland garros reunion saint denis",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ZSE",
              "cityName": "Saint Pierre",
              "code": "ZSE",
              "countryName": "Reunion",
              "displayText": "Saint Pierre, Pierrefonds Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Pierrefonds Airport",
              "phoneticLabel": null,
              "searchText": "zse pierrefonds airport reunion saint pierre",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PNH",
              "cityName": "Phnom Penh",
              "code": "PNH",
              "countryName": "Cambodia",
              "displayText": "Phnom Penh, Pochentong International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Pochentong International Airport",
              "phoneticLabel": null,
              "searchText": "pnh pochentong international airport cambodia phnom penh",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SAI",
              "cityName": "Siem Reap",
              "code": "SAI",
              "countryName": "Cambodia",
              "displayText": "Siem Reap, Siem Reap Angkor International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Siem Reap Angkor International Airport",
              "phoneticLabel": null,
              "searchText": "sai siem reap angkor international airport cambodia siem reap",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MLA",
              "cityName": "Malta",
              "code": "MLA",
              "countryName": "Malta",
              "displayText": "Malta, Luqa International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Luqa International",
              "phoneticLabel": null,
              "searchText": "mla luqa international malta malta",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SZZ",
              "cityName": "Szczecin",
              "code": "SZZ",
              "countryName": "Poland",
              "displayText": "Szczecin, Szczecin-Goleniów Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Szczecin-Goleniów Airport",
              "phoneticLabel": null,
              "searchText": "szz szczecin-goleniów airport poland szczecin",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "POZ",
              "cityName": "Poznan",
              "code": "POZ",
              "countryName": "Poland",
              "displayText": "Poznan, Lawica Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Lawica Airport",
              "phoneticLabel": null,
              "searchText": "poz lawica airport poland poznan",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "RZE",
              "cityName": "Rzeszow",
              "code": "RZE",
              "countryName": "Poland",
              "displayText": "Rzeszow, Rzeszów-Jasionka Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Rzeszów-Jasionka Airport",
              "phoneticLabel": null,
              "searchText": "rze rzeszów-jasionka airport poland rzeszow",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KTW",
              "cityName": "Katowice",
              "code": "KTW",
              "countryName": "Poland",
              "displayText": "Katowice, Katowice International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Katowice International Airport",
              "phoneticLabel": null,
              "searchText": "ktw katowice international airport poland katowice",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LUZ",
              "cityName": "Lublin",
              "code": "LUZ",
              "countryName": "Poland",
              "displayText": "Lublin, Lublin Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Lublin Airport",
              "phoneticLabel": null,
              "searchText": "luz lublin airport poland lublin",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BZG",
              "cityName": "Bydgoszcz",
              "code": "BZG",
              "countryName": "Poland",
              "displayText": "Bydgoszcz, Bydgoszcz Ignacy Jan Paderewski Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Bydgoszcz Ignacy Jan Paderewski Airport",
              "phoneticLabel": null,
              "searchText": "bzg bydgoszcz ignacy jan paderewski airport poland bydgoszcz",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "IEG",
              "cityName": "Zielona Gora",
              "code": "IEG",
              "countryName": "Poland",
              "displayText": "Zielona Gora, Babimost Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Babimost Airport",
              "phoneticLabel": null,
              "searchText": "ieg babimost airport poland zielona gora",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "GDN",
              "cityName": "Gdansk",
              "code": "GDN",
              "countryName": "Poland",
              "displayText": "Gdansk, Lech Walesa Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Lech Walesa Airport",
              "phoneticLabel": null,
              "searchText": "gdn lech walesa airport poland gdansk",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "WRO",
              "cityName": "Wroclaw",
              "code": "WRO",
              "countryName": "Poland",
              "displayText": "Wroclaw, Wroclaw Nicolaus Copernicus Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Wroclaw Nicolaus Copernicus Airport",
              "phoneticLabel": null,
              "searchText": "wro wroclaw nicolaus copernicus airport poland wroclaw",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "WAW",
              "cityName": "Warsaw",
              "code": "WAW",
              "countryName": "Poland",
              "displayText": "Warsaw, Frederic Chopin",
              "isDestination": true,
              "isOrigin": true,
              "label": "Frederic Chopin",
              "phoneticLabel": null,
              "searchText": "waw frederic chopin poland warsaw",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KRK",
              "cityName": "Krakow",
              "code": "KRK",
              "countryName": "Poland",
              "displayText": "Krakow, John Paul II International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "John Paul II International Airport",
              "phoneticLabel": null,
              "searchText": "krk john paul ii international airport poland krakow",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MAR",
              "cityName": "Maracaibo",
              "code": "MAR",
              "countryName": "Venezuela",
              "displayText": "Maracaibo, La Chinita",
              "isDestination": true,
              "isOrigin": true,
              "label": "La Chinita",
              "phoneticLabel": null,
              "searchText": "mar la chinita venezuela maracaibo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CCS",
              "cityName": "Caracas",
              "code": "CCS",
              "countryName": "Venezuela",
              "displayText": "Caracas, Simon Bolivar Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Simon Bolivar Airport",
              "phoneticLabel": null,
              "searchText": "ccs simon bolivar airport venezuela caracas",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BLA",
              "cityName": "Barcelona",
              "code": "BLA",
              "countryName": "Venezuela",
              "displayText": "Barcelona, General José Antonio Anzoátegui",
              "isDestination": true,
              "isOrigin": true,
              "label": "General José Antonio Anzoátegui",
              "phoneticLabel": null,
              "searchText": "bla general josé antonio anzoátegui venezuela barcelona",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "VLN",
              "cityName": "Valencia",
              "code": "VLN",
              "countryName": "Venezuela",
              "displayText": "Valencia, Valencia",
              "isDestination": true,
              "isOrigin": true,
              "label": "Valencia",
              "phoneticLabel": null,
              "searchText": "vln valencia venezuela valencia",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CAY",
              "cityName": "Cayenne",
              "code": "CAY",
              "countryName": "French Guiana",
              "displayText": "Cayenne, Felix Eboue",
              "isDestination": true,
              "isOrigin": true,
              "label": "Felix Eboue",
              "phoneticLabel": null,
              "searchText": "cay felix eboue french guiana cayenne",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BKO",
              "cityName": "Bamako",
              "code": "BKO",
              "countryName": "Mali",
              "displayText": "Bamako, Senou International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Senou International",
              "phoneticLabel": null,
              "searchText": "bko senou international mali bamako",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TOV",
              "cityName": "Tortola",
              "code": "EIS",
              "countryName": "Virgin Islands, British",
              "displayText": "Tortola, Beef Island",
              "isDestination": true,
              "isOrigin": true,
              "label": "Beef Island",
              "phoneticLabel": null,
              "searchText": "eis beef island virgin islands, british tortola",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KTM",
              "cityName": "Kathmandu",
              "code": "KTM",
              "countryName": "Nepal",
              "displayText": "Kathmandu, Tribhuvan International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Tribhuvan International Airport",
              "phoneticLabel": null,
              "searchText": "ktm tribhuvan international airport nepal kathmandu",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BNE",
              "cityName": "Brisbane",
              "code": "BNE",
              "countryName": "Australia",
              "displayText": "Brisbane, Brisbane Intl. Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Brisbane Intl. Airport",
              "phoneticLabel": null,
              "searchText": "bne brisbane intl. airport australia brisbane",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CNS",
              "cityName": "Cairns",
              "code": "CNS",
              "countryName": "Australia",
              "displayText": "Cairns, Cairns International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Cairns International Airport",
              "phoneticLabel": null,
              "searchText": "cns cairns international airport australia cairns",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MEL",
              "cityName": "Melbourne",
              "code": "MEL",
              "countryName": "Australia",
              "displayText": "Melbourne, Melbourne Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Melbourne Airport",
              "phoneticLabel": null,
              "searchText": "mel melbourne airport australia melbourne",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HBA",
              "cityName": "Hobart",
              "code": "HBA",
              "countryName": "Australia",
              "displayText": "Hobart, Hobart International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Hobart International Airport",
              "phoneticLabel": null,
              "searchText": "hba hobart international airport australia hobart",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PER",
              "cityName": "Perth",
              "code": "PER",
              "countryName": "Australia",
              "displayText": "Perth, Perth Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Perth Airport",
              "phoneticLabel": null,
              "searchText": "per perth airport australia perth",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ADL",
              "cityName": "Adelaide",
              "code": "ADL",
              "countryName": "Australia",
              "displayText": "Adelaide, Adelaide International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Adelaide International Airport",
              "phoneticLabel": null,
              "searchText": "adl adelaide international airport australia adelaide",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "OOL",
              "cityName": "Gold Coast",
              "code": "OOL",
              "countryName": "Australia",
              "displayText": "Gold Coast, Coolangatta",
              "isDestination": true,
              "isOrigin": true,
              "label": "Coolangatta",
              "phoneticLabel": null,
              "searchText": "ool coolangatta australia gold coast",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "DRW",
              "cityName": "Darwin",
              "code": "DRW",
              "countryName": "Australia",
              "displayText": "Darwin, Darwin International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Darwin International Airport",
              "phoneticLabel": null,
              "searchText": "drw darwin international airport australia darwin",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SYD",
              "cityName": "Sydney",
              "code": "SYD",
              "countryName": "Australia",
              "displayText": "Sydney, Kingsford Smith International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kingsford Smith International Airport",
              "phoneticLabel": null,
              "searchText": "syd kingsford smith international airport australia sydney",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CBR",
              "cityName": "Canberra",
              "code": "CBR",
              "countryName": "Australia",
              "displayText": "Canberra, Canberra",
              "isDestination": true,
              "isOrigin": true,
              "label": "Canberra",
              "phoneticLabel": null,
              "searchText": "cbr canberra australia canberra",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MSU",
              "cityName": "Maseru",
              "code": "MSU",
              "countryName": "Lesotho",
              "displayText": "Maseru, Moshoeshoe I International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Moshoeshoe I International Airport",
              "phoneticLabel": null,
              "searchText": "msu moshoeshoe i international airport lesotho maseru",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "GUA",
              "cityName": "Guatemala City",
              "code": "GUA",
              "countryName": "Guatemala",
              "displayText": "Guatemala City, La Aurora",
              "isDestination": true,
              "isOrigin": true,
              "label": "La Aurora",
              "phoneticLabel": null,
              "searchText": "gua la aurora guatemala guatemala city",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "GUM",
              "cityName": "Guam",
              "code": "GUM",
              "countryName": "Guam",
              "displayText": "Guam, Ab Won Pat International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Ab Won Pat International",
              "phoneticLabel": null,
              "searchText": "gum ab won pat international guam guam",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MBA",
              "cityName": "Mombasa",
              "code": "MBA",
              "countryName": "Kenya",
              "displayText": "Mombasa, Moi International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Moi International Airport",
              "phoneticLabel": null,
              "searchText": "mba moi international airport kenya mombasa",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KIS",
              "cityName": "Kisumu",
              "code": "KIS",
              "countryName": "Kenya",
              "displayText": "Kisumu, Kisumu",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kisumu",
              "phoneticLabel": null,
              "searchText": "kis kisumu kenya kisumu",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "EDL",
              "cityName": "Eldoret",
              "code": "EDL",
              "countryName": "Kenya",
              "displayText": "Eldoret, Eldoret",
              "isDestination": true,
              "isOrigin": true,
              "label": "Eldoret",
              "phoneticLabel": null,
              "searchText": "edl eldoret kenya eldoret",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MYD",
              "cityName": "Malindi",
              "code": "MYD",
              "countryName": "Kenya",
              "displayText": "Malindi, Malindi",
              "isDestination": true,
              "isOrigin": true,
              "label": "Malindi",
              "phoneticLabel": null,
              "searchText": "myd malindi kenya malindi",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NBO",
              "cityName": "Nairobi",
              "code": "NBO",
              "countryName": "Kenya",
              "displayText": "Nairobi, Jomo Kenyatta International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Jomo Kenyatta International Airport",
              "phoneticLabel": null,
              "searchText": "nbo jomo kenyatta international airport kenya nairobi",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "QRV",
              "cityName": "Arras",
              "code": "XRZ",
              "countryName": "France",
              "displayText": "Arras, Arras Train Station",
              "isDestination": true,
              "isOrigin": true,
              "label": "Arras Train Station",
              "phoneticLabel": null,
              "searchText": "xrz arras train station france arras",
              "stationType": "RAILWAY_STATION",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PGF",
              "cityName": "Perpignan",
              "code": "PGF",
              "countryName": "France",
              "displayText": "Perpignan",
              "isDestination": true,
              "isOrigin": true,
              "label": "Perpignan",
              "phoneticLabel": null,
              "searchText": "pgf perpignan france",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "CFE",
              "cityName": "Clermont Ferrand",
              "code": "CFE",
              "countryName": "France",
              "displayText": "Clermont Ferrand, Clermont Ferrand Auvergne Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Clermont Ferrand Auvergne Airport",
              "phoneticLabel": null,
              "searchText": "cfe clermont ferrand auvergne airport france clermont ferrand",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "AUR",
              "cityName": "Aurillac",
              "code": "AUR",
              "countryName": "France",
              "displayText": "Aurillac, Aurillac Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Aurillac Airport",
              "phoneticLabel": null,
              "searchText": "aur aurillac airport france aurillac",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CFR",
              "cityName": "Caen",
              "code": "CFR",
              "countryName": "France",
              "displayText": "Caen, Caen Carpiquet Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Caen Carpiquet Airport",
              "phoneticLabel": null,
              "searchText": "cfr caen carpiquet airport france caen",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ETZ",
              "cityName": "Metz Nancy",
              "code": "ETZ",
              "countryName": "France",
              "displayText": "Metz Nancy",
              "isDestination": true,
              "isOrigin": true,
              "label": "Metz Nancy",
              "phoneticLabel": null,
              "searchText": "etz metz nancy france",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "SXB",
              "cityName": "Strasbourg",
              "code": "SXB",
              "countryName": "France",
              "displayText": "Strasbourg",
              "isDestination": true,
              "isOrigin": true,
              "label": "Strasbourg",
              "phoneticLabel": null,
              "searchText": "sxb strasbourg france",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "MRS",
              "cityName": "Marseille",
              "code": "MRS",
              "countryName": "France",
              "displayText": "Marseille",
              "isDestination": true,
              "isOrigin": true,
              "label": "Marseille",
              "phoneticLabel": null,
              "searchText": "mrs marseille france",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "CLY",
              "cityName": "Calvi - Corsica",
              "code": "CLY",
              "countryName": "France",
              "displayText": "Calvi - Corsica, Sainte Catherine Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Sainte Catherine Airport",
              "phoneticLabel": null,
              "searchText": "cly sainte catherine airport france calvi - corsica",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NTE",
              "cityName": "Nantes",
              "code": "NTE",
              "countryName": "France",
              "displayText": "Nantes",
              "isDestination": true,
              "isOrigin": true,
              "label": "Nantes",
              "phoneticLabel": null,
              "searchText": "nte nantes france",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "BIQ",
              "cityName": "Biarritz",
              "code": "BIQ",
              "countryName": "France",
              "displayText": "Biarritz, Biarritz Pays Basque Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Biarritz Pays Basque Airport",
              "phoneticLabel": null,
              "searchText": "biq biarritz pays basque airport france biarritz",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LPY",
              "cityName": "Le Puy",
              "code": "LPY",
              "countryName": "France",
              "displayText": "Le Puy, Le Puy Loudes Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Le Puy Loudes Airport",
              "phoneticLabel": null,
              "searchText": "lpy le puy loudes airport france le puy",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NCE",
              "cityName": "Nice",
              "code": "NCE",
              "countryName": "France",
              "displayText": "Nice, Nice Côte d'Azur Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Nice Côte d'Azur Airport",
              "phoneticLabel": null,
              "searchText": "nce nice côte d'azur airport france nice",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MPL",
              "cityName": "Montpellier",
              "code": "MPL",
              "countryName": "France",
              "displayText": "Montpellier",
              "isDestination": true,
              "isOrigin": true,
              "label": "Montpellier",
              "phoneticLabel": null,
              "searchText": "mpl montpellier france",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "PUF",
              "cityName": "Pau",
              "code": "PUF",
              "countryName": "France",
              "displayText": "Pau, Pau Pyrénées Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Pau Pyrénées Airport",
              "phoneticLabel": null,
              "searchText": "puf pau pyrénées airport france pau",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LIG",
              "cityName": "Limoges",
              "code": "LIG",
              "countryName": "France",
              "displayText": "Limoges, Limoges Bellegarde Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Limoges Bellegarde Airport",
              "phoneticLabel": null,
              "searchText": "lig limoges bellegarde airport france limoges",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LME",
              "cityName": "Le Mans",
              "code": "ZLN",
              "countryName": "France",
              "displayText": "Le Mans, Le Mans Train Station",
              "isDestination": true,
              "isOrigin": true,
              "label": "Le Mans Train Station",
              "phoneticLabel": null,
              "searchText": "zln le mans train station france le mans",
              "stationType": "RAILWAY_STATION",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BOD",
              "cityName": "Bordeaux",
              "code": "BOD",
              "countryName": "France",
              "displayText": "Bordeaux",
              "isDestination": true,
              "isOrigin": true,
              "label": "Bordeaux",
              "phoneticLabel": null,
              "searchText": "bod bordeaux france",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "TLS",
              "cityName": "Toulouse",
              "code": "TLS",
              "countryName": "France",
              "displayText": "Toulouse, Toulouse Blagnac Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Toulouse Blagnac Airport",
              "phoneticLabel": null,
              "searchText": "tls toulouse blagnac airport france toulouse",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "FSC",
              "cityName": "Figari - Corsica",
              "code": "FSC",
              "countryName": "France",
              "displayText": "Figari - Corsica, Figari Sud Corse Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Figari Sud Corse Airport",
              "phoneticLabel": null,
              "searchText": "fsc figari sud corse airport france figari - corsica",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "DCM",
              "cityName": "Castres",
              "code": "DCM",
              "countryName": "France",
              "displayText": "Castres, Castres Mazamet Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Castres Mazamet Airport",
              "phoneticLabel": null,
              "searchText": "dcm castres mazamet airport france castres",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LVA",
              "cityName": "Laval",
              "code": "LAV",
              "countryName": "France",
              "displayText": "Laval, Laval Train Station",
              "isDestination": true,
              "isOrigin": true,
              "label": "Laval Train Station",
              "phoneticLabel": null,
              "searchText": "lav laval train station france laval",
              "stationType": "RAILWAY_STATION",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "RHE",
              "cityName": "Reims",
              "code": "XIZ",
              "countryName": "France",
              "displayText": "Reims, Champagne Ardenne TGV Train Station",
              "isDestination": true,
              "isOrigin": true,
              "label": "Champagne Ardenne TGV Train Station",
              "phoneticLabel": null,
              "searchText": "xiz champagne ardenne tgv train station france reims",
              "stationType": "RAILWAY_STATION",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "VAF",
              "cityName": "Valence",
              "code": "XHK",
              "countryName": "France",
              "displayText": "Valence, Valence TGV Train Station",
              "isDestination": true,
              "isOrigin": true,
              "label": "Valence TGV Train Station",
              "phoneticLabel": null,
              "searchText": "xhk valence tgv train station france valence",
              "stationType": "RAILWAY_STATION",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BIA",
              "cityName": "Bastia - Corsica",
              "code": "BIA",
              "countryName": "France",
              "displayText": "Bastia - Corsica, Bastia Poretta Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Bastia Poretta Airport",
              "phoneticLabel": null,
              "searchText": "bia bastia poretta airport france bastia - corsica",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "FNI",
              "cityName": "Nîmes",
              "code": "ZYN",
              "countryName": "France",
              "displayText": "Nîmes, Nîmes Train Station",
              "isDestination": true,
              "isOrigin": true,
              "label": "Nîmes Train Station",
              "phoneticLabel": null,
              "searchText": "zyn nîmes train station france nîmes",
              "stationType": "RAILWAY_STATION",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PAR",
              "cityName": "Paris",
              "code": "PAR",
              "countryName": "France",
              "displayText": "Paris",
              "isDestination": true,
              "isOrigin": true,
              "label": "Paris",
              "phoneticLabel": null,
              "searchText": "par paris france",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "PAR",
              "cityName": "Paris",
              "code": "CDG",
              "countryName": "France",
              "displayText": "Paris, Paris-Charles de Gaulle airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Paris-Charles de Gaulle airport",
              "phoneticLabel": null,
              "searchText": "cdg paris-charles de gaulle airport france paris",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PAR",
              "cityName": "Paris",
              "code": "ORY",
              "countryName": "France",
              "displayText": "Paris, Paris-Orly airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Paris-Orly airport",
              "phoneticLabel": null,
              "searchText": "ory paris-orly airport france paris",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "AVN",
              "cityName": "Avignon",
              "code": "AVN",
              "countryName": "France",
              "displayText": "Avignon",
              "isDestination": true,
              "isOrigin": true,
              "label": "Avignon",
              "phoneticLabel": null,
              "searchText": "avn avignon france",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "LYS",
              "cityName": "Lyon",
              "code": "LYS",
              "countryName": "France",
              "displayText": "Lyon",
              "isDestination": true,
              "isOrigin": true,
              "label": "Lyon",
              "phoneticLabel": null,
              "searchText": "lys lyon france",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "LIL",
              "cityName": "Lille",
              "code": "LIL",
              "countryName": "France",
              "displayText": "Lille",
              "isDestination": true,
              "isOrigin": true,
              "label": "Lille",
              "phoneticLabel": null,
              "searchText": "lil lille france",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "BES",
              "cityName": "Brest",
              "code": "BES",
              "countryName": "France",
              "displayText": "Brest, Brest Bretagne Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Brest Bretagne Airport",
              "phoneticLabel": null,
              "searchText": "bes brest bretagne airport france brest",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TUF",
              "cityName": "Tours",
              "code": "XSH",
              "countryName": "France",
              "displayText": "Tours, Saint Pierre des Corps Train Station",
              "isDestination": true,
              "isOrigin": true,
              "label": "Saint Pierre des Corps Train Station",
              "phoneticLabel": null,
              "searchText": "xsh saint pierre des corps train station france tours",
              "stationType": "RAILWAY_STATION",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "RNS",
              "cityName": "Rennes",
              "code": "RNS",
              "countryName": "France",
              "displayText": "Rennes",
              "isDestination": true,
              "isOrigin": true,
              "label": "Rennes",
              "phoneticLabel": null,
              "searchText": "rns rennes france",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "QXB",
              "cityName": "Aix en Provence",
              "code": "QXB",
              "countryName": "France",
              "displayText": "Aix en Provence, Aix en Provence TGV Train Station",
              "isDestination": true,
              "isOrigin": true,
              "label": "Aix en Provence TGV Train Station",
              "phoneticLabel": null,
              "searchText": "qxb aix en provence tgv train station france aix en provence",
              "stationType": "RAILWAY_STATION",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "AJA",
              "cityName": "Ajaccio - Corsica",
              "code": "AJA",
              "countryName": "France",
              "displayText": "Ajaccio - Corsica, Ajaccio Napoleon Bonaparte Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Ajaccio Napoleon Bonaparte Airport",
              "phoneticLabel": null,
              "searchText": "aja ajaccio napoleon bonaparte airport france ajaccio - corsica",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BVE",
              "cityName": "Brive la Gaillarde",
              "code": "BVE",
              "countryName": "France",
              "displayText": "Brive la Gaillarde, Brive Vallée de la Dordogne Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Brive Vallée de la Dordogne Airport",
              "phoneticLabel": null,
              "searchText": "bve brive vallée de la dordogne airport france brive la gaillarde",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "EGC",
              "cityName": "Bergerac",
              "code": "EGC",
              "countryName": "France",
              "displayText": "Bergerac, Bergerac Dordogne Périgord Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Bergerac Dordogne Périgord Airport",
              "phoneticLabel": null,
              "searchText": "egc bergerac dordogne périgord airport france bergerac",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TLN",
              "cityName": "Toulon Hyeres",
              "code": "TLN",
              "countryName": "France",
              "displayText": "Toulon Hyeres",
              "isDestination": true,
              "isOrigin": true,
              "label": "Toulon Hyeres",
              "phoneticLabel": null,
              "searchText": "tln toulon hyeres france",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "PIS",
              "cityName": "Poitiers",
              "code": "XOP",
              "countryName": "France",
              "displayText": "Poitiers, Poitiers Train Station",
              "isDestination": true,
              "isOrigin": true,
              "label": "Poitiers Train Station",
              "phoneticLabel": null,
              "searchText": "xop poitiers train station france poitiers",
              "stationType": "RAILWAY_STATION",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ANE",
              "cityName": "Angers",
              "code": "QXG",
              "countryName": "France",
              "displayText": "Angers, Angers Saint Laud Train Station",
              "isDestination": true,
              "isOrigin": true,
              "label": "Angers Saint Laud Train Station",
              "phoneticLabel": null,
              "searchText": "qxg angers saint laud train station france angers",
              "stationType": "RAILWAY_STATION",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "GRZ",
              "cityName": "Graz",
              "code": "GRZ",
              "countryName": "Austria",
              "displayText": "Graz, Graz",
              "isDestination": true,
              "isOrigin": true,
              "label": "Graz",
              "phoneticLabel": null,
              "searchText": "grz graz austria graz",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "INN",
              "cityName": "Innsbruck",
              "code": "INN",
              "countryName": "Austria",
              "displayText": "Innsbruck, Innsbruck",
              "isDestination": true,
              "isOrigin": true,
              "label": "Innsbruck",
              "phoneticLabel": null,
              "searchText": "inn innsbruck austria innsbruck",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SZG",
              "cityName": "Salzburg",
              "code": "SZG",
              "countryName": "Austria",
              "displayText": "Salzburg, Wolfgang A Mozart",
              "isDestination": true,
              "isOrigin": true,
              "label": "Wolfgang A Mozart",
              "phoneticLabel": null,
              "searchText": "szg wolfgang a mozart austria salzburg",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "VIE",
              "cityName": "Vienna",
              "code": "VIE",
              "countryName": "Austria",
              "displayText": "Vienna, Vienna International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Vienna International Airport",
              "phoneticLabel": null,
              "searchText": "vie vienna international airport austria vienna",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HGO",
              "cityName": "Korhogo",
              "code": "HGO",
              "countryName": "Cote D’Ivoire",
              "displayText": "Korhogo, Korhogo Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Korhogo Airport",
              "phoneticLabel": null,
              "searchText": "hgo korhogo airport cote d’ivoire korhogo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MJC",
              "cityName": "Man",
              "code": "MJC",
              "countryName": "Cote D’Ivoire",
              "displayText": "Man, Man Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Man Airport",
              "phoneticLabel": null,
              "searchText": "mjc man airport cote d’ivoire man",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BYK",
              "cityName": "Bouake",
              "code": "BYK",
              "countryName": "Cote D’Ivoire",
              "displayText": "Bouake, Bouake",
              "isDestination": true,
              "isOrigin": true,
              "label": "Bouake",
              "phoneticLabel": null,
              "searchText": "byk bouake cote d’ivoire bouake",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KEO",
              "cityName": "Odienne",
              "code": "KEO",
              "countryName": "Cote D’Ivoire",
              "displayText": "Odienne, Odienne Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Odienne Airport",
              "phoneticLabel": null,
              "searchText": "keo odienne airport cote d’ivoire odienne",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SPY",
              "cityName": "San Pedro",
              "code": "SPY",
              "countryName": "Cote D’Ivoire",
              "displayText": "San Pedro, San Pedro",
              "isDestination": true,
              "isOrigin": true,
              "label": "San Pedro",
              "phoneticLabel": null,
              "searchText": "spy san pedro cote d’ivoire san pedro",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ABJ",
              "cityName": "Abidjan",
              "code": "ABJ",
              "countryName": "Cote D’Ivoire",
              "displayText": "Abidjan, Felix Houphouet Boigny International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Felix Houphouet Boigny International Airport",
              "phoneticLabel": null,
              "searchText": "abj felix houphouet boigny international airport cote d’ivoire abidjan",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "FAO",
              "cityName": "Faro",
              "code": "FAO",
              "countryName": "Portugal",
              "displayText": "Faro, Faro Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Faro Airport",
              "phoneticLabel": null,
              "searchText": "fao faro airport portugal faro",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LIS",
              "cityName": "Lisbon",
              "code": "LIS",
              "countryName": "Portugal",
              "displayText": "Lisbon, Humberto Delgado Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Humberto Delgado Airport",
              "phoneticLabel": null,
              "searchText": "lis humberto delgado airport portugal lisbon",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "FNC",
              "cityName": "Funchal",
              "code": "FNC",
              "countryName": "Portugal",
              "displayText": "Funchal, Madeira",
              "isDestination": true,
              "isOrigin": true,
              "label": "Madeira",
              "phoneticLabel": null,
              "searchText": "fnc madeira portugal funchal",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SMA",
              "cityName": "Santa Maria Island - Azores",
              "code": "SMA",
              "countryName": "Portugal",
              "displayText": "Santa Maria Island - Azores, Santa Maria Island",
              "isDestination": true,
              "isOrigin": true,
              "label": "Santa Maria Island",
              "phoneticLabel": null,
              "searchText": "sma santa maria island portugal santa maria island - azores",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "OPO",
              "cityName": "Porto",
              "code": "OPO",
              "countryName": "Portugal",
              "displayText": "Porto, Francisco Sá Carneiro Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Francisco Sá Carneiro Airport",
              "phoneticLabel": null,
              "searchText": "opo francisco sá carneiro airport portugal porto",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HOR",
              "cityName": "Horta",
              "code": "HOR",
              "countryName": "Portugal",
              "displayText": "Horta, Horta",
              "isDestination": true,
              "isOrigin": true,
              "label": "Horta",
              "phoneticLabel": null,
              "searchText": "hor horta portugal horta",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TER",
              "cityName": "Terceira - Azores",
              "code": "TER",
              "countryName": "Portugal",
              "displayText": "Terceira - Azores, Lajes Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Lajes Airport",
              "phoneticLabel": null,
              "searchText": "ter lajes airport portugal terceira - azores",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PIX",
              "cityName": "Pico",
              "code": "PIX",
              "countryName": "Portugal",
              "displayText": "Pico, Pico Island",
              "isDestination": true,
              "isOrigin": true,
              "label": "Pico Island",
              "phoneticLabel": null,
              "searchText": "pix pico island portugal pico",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PDL",
              "cityName": "Ponta Delgada",
              "code": "PDL",
              "countryName": "Portugal",
              "displayText": "Ponta Delgada, João Paulo II Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "João Paulo II Airport",
              "phoneticLabel": null,
              "searchText": "pdl joão paulo ii airport portugal ponta delgada",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ADD",
              "cityName": "Addis Ababa",
              "code": "ADD",
              "countryName": "Ethiopia",
              "displayText": "Addis Ababa, Bole International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Bole International Airport",
              "phoneticLabel": null,
              "searchText": "add bole international airport ethiopia addis ababa",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HKG",
              "cityName": "Hong Kong",
              "code": "HKG",
              "countryName": "Hong Kong, China",
              "displayText": "Hong Kong, Hong Kong International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Hong Kong International Airport",
              "phoneticLabel": null,
              "searchText": "hkg hong kong international airport hong kong, china hong kong",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NAS",
              "cityName": "Nassau",
              "code": "NAS",
              "countryName": "Bahamas",
              "displayText": "Nassau, Nassau International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Nassau International Airport",
              "phoneticLabel": null,
              "searchText": "nas nassau international airport bahamas nassau",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TLV",
              "cityName": "Tel Aviv Yafo",
              "code": "TLV",
              "countryName": "Israel",
              "displayText": "Tel Aviv Yafo, Ben Gurion International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Ben Gurion International",
              "phoneticLabel": null,
              "searchText": "tlv ben gurion international israel tel aviv yafo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TAY",
              "cityName": "Tartu",
              "code": "TAY",
              "countryName": "Estonia",
              "displayText": "Tartu, Ulenurme",
              "isDestination": true,
              "isOrigin": true,
              "label": "Ulenurme",
              "phoneticLabel": null,
              "searchText": "tay ulenurme estonia tartu",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TLL",
              "cityName": "Tallinn",
              "code": "TLL",
              "countryName": "Estonia",
              "displayText": "Tallinn, Tallinn Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Tallinn Airport",
              "phoneticLabel": null,
              "searchText": "tll tallinn airport estonia tallinn",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "DOM",
              "cityName": "Dominica",
              "code": "DOM",
              "countryName": "Dominica",
              "displayText": "Dominica",
              "isDestination": true,
              "isOrigin": true,
              "label": "Dominica",
              "phoneticLabel": null,
              "searchText": "dom dominica dominica",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "DOM",
              "cityName": "Dominica",
              "code": "DCF",
              "countryName": "Dominica",
              "displayText": "Dominica, Canefield",
              "isDestination": true,
              "isOrigin": true,
              "label": "Canefield",
              "phoneticLabel": null,
              "searchText": "dcf canefield dominica dominica",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "DOM",
              "cityName": "Dominica",
              "code": "DOM",
              "countryName": "Dominica",
              "displayText": "Dominica, Melville Hall Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Melville Hall Airport",
              "phoneticLabel": null,
              "searchText": "dom melville hall airport dominica dominica",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PNL",
              "cityName": "Pantelleria - Sicily",
              "code": "PNL",
              "countryName": "Italy",
              "displayText": "Pantelleria - Sicily, Pantelleria",
              "isDestination": true,
              "isOrigin": true,
              "label": "Pantelleria",
              "phoneticLabel": null,
              "searchText": "pnl pantelleria italy pantelleria - sicily",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TRN",
              "cityName": "Turin",
              "code": "TRN",
              "countryName": "Italy",
              "displayText": "Turin, Turin International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Turin International Airport",
              "phoneticLabel": null,
              "searchText": "trn turin international airport italy turin",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BDS",
              "cityName": "Brindisi",
              "code": "BDS",
              "countryName": "Italy",
              "displayText": "Brindisi, Casale Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Casale Airport",
              "phoneticLabel": null,
              "searchText": "bds casale airport italy brindisi",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "FLR",
              "cityName": "Florence",
              "code": "FLR",
              "countryName": "Italy",
              "displayText": "Florence, Peretola",
              "isDestination": true,
              "isOrigin": true,
              "label": "Peretola",
              "phoneticLabel": null,
              "searchText": "flr peretola italy florence",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NAP",
              "cityName": "Naples",
              "code": "NAP",
              "countryName": "Italy",
              "displayText": "Naples, Naples International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Naples International Airport",
              "phoneticLabel": null,
              "searchText": "nap naples international airport italy naples",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CAG",
              "cityName": "Cagliari - Sardinia",
              "code": "CAG",
              "countryName": "Italy",
              "displayText": "Cagliari - Sardinia, Elmas",
              "isDestination": true,
              "isOrigin": true,
              "label": "Elmas",
              "phoneticLabel": null,
              "searchText": "cag elmas italy cagliari - sardinia",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PEG",
              "cityName": "Perugia",
              "code": "PEG",
              "countryName": "Italy",
              "displayText": "Perugia, Perugia / San Egidio Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Perugia / San Egidio Airport",
              "phoneticLabel": null,
              "searchText": "peg perugia / san egidio airport italy perugia",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "REG",
              "cityName": "Reggio di Calabria",
              "code": "REG",
              "countryName": "Italy",
              "displayText": "Reggio di Calabria, Reggio Calabria Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Reggio Calabria Airport",
              "phoneticLabel": null,
              "searchText": "reg reggio calabria airport italy reggio di calabria",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "OLB",
              "cityName": "Olbia - Sardinia",
              "code": "OLB",
              "countryName": "Italy",
              "displayText": "Olbia - Sardinia, Costa Smeralda",
              "isDestination": true,
              "isOrigin": true,
              "label": "Costa Smeralda",
              "phoneticLabel": null,
              "searchText": "olb costa smeralda italy olbia - sardinia",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "QAQ",
              "cityName": "L'Aquila",
              "code": "QAQ",
              "countryName": "Italy",
              "displayText": "L'Aquila, L'Aquila",
              "isDestination": true,
              "isOrigin": true,
              "label": "L'Aquila",
              "phoneticLabel": null,
              "searchText": "qaq l'aquila italy l'aquila",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PSA",
              "cityName": "Pisa",
              "code": "PSA",
              "countryName": "Italy",
              "displayText": "Pisa, Galileo Galilei",
              "isDestination": true,
              "isOrigin": true,
              "label": "Galileo Galilei",
              "phoneticLabel": null,
              "searchText": "psa galileo galilei italy pisa",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BLQ",
              "cityName": "Bologna",
              "code": "BLQ",
              "countryName": "Italy",
              "displayText": "Bologna, Guglielmo Marconi Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Guglielmo Marconi Airport",
              "phoneticLabel": null,
              "searchText": "blq guglielmo marconi airport italy bologna",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "GOA",
              "cityName": "Genoa",
              "code": "GOA",
              "countryName": "Italy",
              "displayText": "Genoa, Cristoforo Colombo",
              "isDestination": true,
              "isOrigin": true,
              "label": "Cristoforo Colombo",
              "phoneticLabel": null,
              "searchText": "goa cristoforo colombo italy genoa",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PMO",
              "cityName": "Palermo - Sicily",
              "code": "PMO",
              "countryName": "Italy",
              "displayText": "Palermo - Sicily, Palermo International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Palermo International Airport",
              "phoneticLabel": null,
              "searchText": "pmo palermo international airport italy palermo - sicily",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "VCE",
              "cityName": "Venice",
              "code": "VCE",
              "countryName": "Italy",
              "displayText": "Venice, Marco Polo",
              "isDestination": true,
              "isOrigin": true,
              "label": "Marco Polo",
              "phoneticLabel": null,
              "searchText": "vce marco polo italy venice",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ROM",
              "cityName": "Rome",
              "code": "FCO",
              "countryName": "Italy",
              "displayText": "Rome, Fiumicino Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Fiumicino Airport",
              "phoneticLabel": null,
              "searchText": "fco fiumicino airport italy rome",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CTA",
              "cityName": "Catania - Sicily",
              "code": "CTA",
              "countryName": "Italy",
              "displayText": "Catania - Sicily, Fontanarossa",
              "isDestination": true,
              "isOrigin": true,
              "label": "Fontanarossa",
              "phoneticLabel": null,
              "searchText": "cta fontanarossa italy catania - sicily",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "VRN",
              "cityName": "Verona",
              "code": "VRN",
              "countryName": "Italy",
              "displayText": "Verona, Villafranca Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Villafranca Airport",
              "phoneticLabel": null,
              "searchText": "vrn villafranca airport italy verona",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TRS",
              "cityName": "Trieste",
              "code": "TRS",
              "countryName": "Italy",
              "displayText": "Trieste, Dei Legionari",
              "isDestination": true,
              "isOrigin": true,
              "label": "Dei Legionari",
              "phoneticLabel": null,
              "searchText": "trs dei legionari italy trieste",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BRI",
              "cityName": "Bari",
              "code": "BRI",
              "countryName": "Italy",
              "displayText": "Bari, Palese",
              "isDestination": true,
              "isOrigin": true,
              "label": "Palese",
              "phoneticLabel": null,
              "searchText": "bri palese italy bari",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SUF",
              "cityName": "Lamezia Terme",
              "code": "SUF",
              "countryName": "Italy",
              "displayText": "Lamezia Terme, Lamezia Terme International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Lamezia Terme International Airport",
              "phoneticLabel": null,
              "searchText": "suf lamezia terme international airport italy lamezia terme",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MIL",
              "cityName": "Milan",
              "code": "MIL",
              "countryName": "Italy",
              "displayText": "Milan",
              "isDestination": true,
              "isOrigin": true,
              "label": "Milan",
              "phoneticLabel": null,
              "searchText": "mil milan italy",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "MIL",
              "cityName": "Milan",
              "code": "MXP",
              "countryName": "Italy",
              "displayText": "Milan, Malpensa Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Malpensa Airport",
              "phoneticLabel": null,
              "searchText": "mxp malpensa airport italy milan",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MIL",
              "cityName": "Milan",
              "code": "LIN",
              "countryName": "Italy",
              "displayText": "Milan, Linate Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Linate Airport",
              "phoneticLabel": null,
              "searchText": "lin linate airport italy milan",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MIL",
              "cityName": "Milan",
              "code": "PMF",
              "countryName": "Italy",
              "displayText": "Milan, Parma",
              "isDestination": true,
              "isOrigin": true,
              "label": "Parma",
              "phoneticLabel": null,
              "searchText": "pmf parma italy milan",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HLZ",
              "cityName": "Hamilton",
              "code": "HLZ",
              "countryName": "New Zealand",
              "displayText": "Hamilton, Hamilton International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Hamilton International Airport",
              "phoneticLabel": null,
              "searchText": "hlz hamilton international airport new zealand hamilton",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ROT",
              "cityName": "Rotorua",
              "code": "ROT",
              "countryName": "New Zealand",
              "displayText": "Rotorua, Rotorua",
              "isDestination": true,
              "isOrigin": true,
              "label": "Rotorua",
              "phoneticLabel": null,
              "searchText": "rot rotorua new zealand rotorua",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PMR",
              "cityName": "Palmerston North",
              "code": "PMR",
              "countryName": "New Zealand",
              "displayText": "Palmerston North, Palmerston North",
              "isDestination": true,
              "isOrigin": true,
              "label": "Palmerston North",
              "phoneticLabel": null,
              "searchText": "pmr palmerston north new zealand palmerston north",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KKE",
              "cityName": "Kerikeri",
              "code": "KKE",
              "countryName": "New Zealand",
              "displayText": "Kerikeri, Kerikeri",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kerikeri",
              "phoneticLabel": null,
              "searchText": "kke kerikeri new zealand kerikeri",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TUO",
              "cityName": "Taupo",
              "code": "TUO",
              "countryName": "New Zealand",
              "displayText": "Taupo, Taupo",
              "isDestination": true,
              "isOrigin": true,
              "label": "Taupo",
              "phoneticLabel": null,
              "searchText": "tuo taupo new zealand taupo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "AKL",
              "cityName": "Auckland",
              "code": "AKL",
              "countryName": "New Zealand",
              "displayText": "Auckland, Auckland Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Auckland Airport",
              "phoneticLabel": null,
              "searchText": "akl auckland airport new zealand auckland",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "GIS",
              "cityName": "Gisborne",
              "code": "GIS",
              "countryName": "New Zealand",
              "displayText": "Gisborne, Gisborne",
              "isDestination": true,
              "isOrigin": true,
              "label": "Gisborne",
              "phoneticLabel": null,
              "searchText": "gis gisborne new zealand gisborne",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NPL",
              "cityName": "New Plymouth",
              "code": "NPL",
              "countryName": "New Zealand",
              "displayText": "New Plymouth, New Plymouth",
              "isDestination": true,
              "isOrigin": true,
              "label": "New Plymouth",
              "phoneticLabel": null,
              "searchText": "npl new plymouth new zealand new plymouth",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "WRE",
              "cityName": "Whangarei",
              "code": "WRE",
              "countryName": "New Zealand",
              "displayText": "Whangarei, Whangarei",
              "isDestination": true,
              "isOrigin": true,
              "label": "Whangarei",
              "phoneticLabel": null,
              "searchText": "wre whangarei new zealand whangarei",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CHC",
              "cityName": "Christchurch",
              "code": "CHC",
              "countryName": "New Zealand",
              "displayText": "Christchurch, International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "International Airport",
              "phoneticLabel": null,
              "searchText": "chc international airport new zealand christchurch",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NSN",
              "cityName": "Nelson",
              "code": "NSN",
              "countryName": "New Zealand",
              "displayText": "Nelson, Nelson",
              "isDestination": true,
              "isOrigin": true,
              "label": "Nelson",
              "phoneticLabel": null,
              "searchText": "nsn nelson new zealand nelson",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "WLG",
              "cityName": "Wellington",
              "code": "WLG",
              "countryName": "New Zealand",
              "displayText": "Wellington, Wellington International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Wellington International Airport",
              "phoneticLabel": null,
              "searchText": "wlg wellington international airport new zealand wellington",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BHE",
              "cityName": "Blenheim",
              "code": "BHE",
              "countryName": "New Zealand",
              "displayText": "Blenheim, Blenheim",
              "isDestination": true,
              "isOrigin": true,
              "label": "Blenheim",
              "phoneticLabel": null,
              "searchText": "bhe blenheim new zealand blenheim",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NPE",
              "cityName": "Napier Hastings",
              "code": "NPE",
              "countryName": "New Zealand",
              "displayText": "Napier Hastings, Hawkes Bay",
              "isDestination": true,
              "isOrigin": true,
              "label": "Hawkes Bay",
              "phoneticLabel": null,
              "searchText": "npe hawkes bay new zealand napier hastings",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ZQN",
              "cityName": "Queenstown",
              "code": "ZQN",
              "countryName": "New Zealand",
              "displayText": "Queenstown, Queenstown",
              "isDestination": true,
              "isOrigin": true,
              "label": "Queenstown",
              "phoneticLabel": null,
              "searchText": "zqn queenstown new zealand queenstown",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "DUD",
              "cityName": "Dunedin",
              "code": "DUD",
              "countryName": "New Zealand",
              "displayText": "Dunedin, Dunedin",
              "isDestination": true,
              "isOrigin": true,
              "label": "Dunedin",
              "phoneticLabel": null,
              "searchText": "dud dunedin new zealand dunedin",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TRG",
              "cityName": "Tauranga",
              "code": "TRG",
              "countryName": "New Zealand",
              "displayText": "Tauranga, Tauranga",
              "isDestination": true,
              "isOrigin": true,
              "label": "Tauranga",
              "phoneticLabel": null,
              "searchText": "trg tauranga new zealand tauranga",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "GEO",
              "cityName": "Georgetown",
              "code": "GEO",
              "countryName": "Guyana",
              "displayText": "Georgetown, Cheddi Jagan International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Cheddi Jagan International",
              "phoneticLabel": null,
              "searchText": "geo cheddi jagan international guyana georgetown",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MVD",
              "cityName": "Montevideo",
              "code": "MVD",
              "countryName": "Uruguay",
              "displayText": "Montevideo, Montevideo Carrasco Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Montevideo Carrasco Airport",
              "phoneticLabel": null,
              "searchText": "mvd montevideo carrasco airport uruguay montevideo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BGI",
              "cityName": "Bridgetown",
              "code": "BGI",
              "countryName": "Barbados",
              "displayText": "Bridgetown, Grantley Adams airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Grantley Adams airport",
              "phoneticLabel": null,
              "searchText": "bgi grantley adams airport barbados bridgetown",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LUX",
              "cityName": "Luxembourg",
              "code": "LUX",
              "countryName": "Luxembourg",
              "displayText": "Luxembourg, Findel International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Findel International Airport",
              "phoneticLabel": null,
              "searchText": "lux findel international airport luxembourg luxembourg",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YAO",
              "cityName": "Yaounde",
              "code": "NSI",
              "countryName": "Cameroon",
              "displayText": "Yaounde, Nsimalen Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Nsimalen Airport",
              "phoneticLabel": null,
              "searchText": "nsi nsimalen airport cameroon yaounde",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "DLA",
              "cityName": "Douala",
              "code": "DLA",
              "countryName": "Cameroon",
              "displayText": "Douala, Douala Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Douala Airport",
              "phoneticLabel": null,
              "searchText": "dla douala airport cameroon douala",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CKY",
              "cityName": "Conakry",
              "code": "CKY",
              "countryName": "Guinea",
              "displayText": "Conakry, Ahmed Sekou Touré Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Ahmed Sekou Touré Airport",
              "phoneticLabel": null,
              "searchText": "cky ahmed sekou touré airport guinea conakry",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "RMO",
              "cityName": "Chisinau",
              "code": "RMO",
              "countryName": "Republic of Moldova",
              "displayText": "Chisinau, Chisinau International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Chisinau International Airport",
              "phoneticLabel": null,
              "searchText": "rmo chisinau international airport republic of moldova chisinau",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MDL",
              "cityName": "Mandalay",
              "code": "MDL",
              "countryName": "Myanmar",
              "displayText": "Mandalay, Mandalay International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Mandalay International Airport",
              "phoneticLabel": null,
              "searchText": "mdl mandalay international airport myanmar mandalay",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "RGN",
              "cityName": "Yangon",
              "code": "RGN",
              "countryName": "Myanmar",
              "displayText": "Yangon, Mingaladon",
              "isDestination": true,
              "isOrigin": true,
              "label": "Mingaladon",
              "phoneticLabel": null,
              "searchText": "rgn mingaladon myanmar yangon",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "DOH",
              "cityName": "Doha",
              "code": "DOH",
              "countryName": "Qatar",
              "displayText": "Doha, Hamad International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Hamad International",
              "phoneticLabel": null,
              "searchText": "doh hamad international qatar doha",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "WLS",
              "cityName": "Wallis - Uvea",
              "code": "WLS",
              "countryName": "Wallis and Futuna Island",
              "displayText": "Wallis - Uvea, Hihifo Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Hihifo Airport",
              "phoneticLabel": null,
              "searchText": "wls hihifo airport wallis and futuna island wallis - uvea",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SKB",
              "cityName": "Saint Kitts",
              "code": "SKB",
              "countryName": "Saint Kitts and Nevis",
              "displayText": "Saint Kitts, Robert L. Bradshaw International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Robert L. Bradshaw International Airport",
              "phoneticLabel": null,
              "searchText": "skb robert l. bradshaw international airport saint kitts and nevis saint kitts",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NEV",
              "cityName": "Nevis",
              "code": "NEV",
              "countryName": "Saint Kitts and Nevis",
              "displayText": "Nevis, Vance W. Amory International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Vance W. Amory International Airport",
              "phoneticLabel": null,
              "searchText": "nev vance w. amory international airport saint kitts and nevis nevis",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CUR",
              "cityName": "Curacao",
              "code": "CUR",
              "countryName": "Curacao",
              "displayText": "Curacao, Hato International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Hato International Airport",
              "phoneticLabel": null,
              "searchText": "cur hato international airport curacao curacao",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KBV",
              "cityName": "Krabi",
              "code": "KBV",
              "countryName": "Thailand",
              "displayText": "Krabi, Krabi",
              "isDestination": true,
              "isOrigin": true,
              "label": "Krabi",
              "phoneticLabel": null,
              "searchText": "kbv krabi thailand krabi",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BKK",
              "cityName": "Bangkok",
              "code": "BKK",
              "countryName": "Thailand",
              "displayText": "Bangkok, Suvarnabhumi International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Suvarnabhumi International",
              "phoneticLabel": null,
              "searchText": "bkk suvarnabhumi international thailand bangkok",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "THS",
              "cityName": "Sukhothai",
              "code": "THS",
              "countryName": "Thailand",
              "displayText": "Sukhothai, Sukhothai",
              "isDestination": true,
              "isOrigin": true,
              "label": "Sukhothai",
              "phoneticLabel": null,
              "searchText": "ths sukhothai thailand sukhothai",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HKT",
              "cityName": "Phuket",
              "code": "HKT",
              "countryName": "Thailand",
              "displayText": "Phuket, Phuket International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Phuket International Airport",
              "phoneticLabel": null,
              "searchText": "hkt phuket international airport thailand phuket",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "USM",
              "cityName": "Koh Samui",
              "code": "USM",
              "countryName": "Thailand",
              "displayText": "Koh Samui, Koh Samui",
              "isDestination": true,
              "isOrigin": true,
              "label": "Koh Samui",
              "phoneticLabel": null,
              "searchText": "usm koh samui thailand koh samui",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TDX",
              "cityName": "Trat",
              "code": "TDX",
              "countryName": "Thailand",
              "displayText": "Trat, Trat Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Trat Airport",
              "phoneticLabel": null,
              "searchText": "tdx trat airport thailand trat",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CNX",
              "cityName": "Chiang Mai",
              "code": "CNX",
              "countryName": "Thailand",
              "displayText": "Chiang Mai, Chiang Mai International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Chiang Mai International Airport",
              "phoneticLabel": null,
              "searchText": "cnx chiang mai international airport thailand chiang mai",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PFO",
              "cityName": "Paphos",
              "code": "PFO",
              "countryName": "Cyprus",
              "displayText": "Paphos, Paphos International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Paphos International Airport",
              "phoneticLabel": null,
              "searchText": "pfo paphos international airport cyprus paphos",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ECN",
              "cityName": "Ercan",
              "code": "ECN",
              "countryName": "Cyprus",
              "displayText": "Ercan, Ercan International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Ercan International Airport",
              "phoneticLabel": null,
              "searchText": "ecn ercan international airport cyprus ercan",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LCA",
              "cityName": "Larnaca",
              "code": "LCA",
              "countryName": "Cyprus",
              "displayText": "Larnaca, Larnaca International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Larnaca International",
              "phoneticLabel": null,
              "searchText": "lca larnaca international cyprus larnaca",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TAB",
              "cityName": "Tobago",
              "code": "TAB",
              "countryName": "Trinidad and Tobago",
              "displayText": "Tobago, A.N.R. Robinson Intl Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "A.N.R. Robinson Intl Airport",
              "phoneticLabel": null,
              "searchText": "tab a.n.r. robinson intl airport trinidad and tobago tobago",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "POS",
              "cityName": "Port of Spain",
              "code": "POS",
              "countryName": "Trinidad and Tobago",
              "displayText": "Port of Spain, Piarco International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Piarco International Airport",
              "phoneticLabel": null,
              "searchText": "pos piarco international airport trinidad and tobago port of spain",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PTP",
              "cityName": "Pointe a Pitre",
              "code": "PTP",
              "countryName": "Guadeloupe",
              "displayText": "Pointe a Pitre, Guadeloupe Maryse Condé International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Guadeloupe Maryse Condé International Airport",
              "phoneticLabel": null,
              "searchText": "ptp guadeloupe maryse condé international airport guadeloupe pointe a pitre",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MBJ",
              "cityName": "Montego Bay",
              "code": "MBJ",
              "countryName": "Jamaica",
              "displayText": "Montego Bay, Sangster International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Sangster International Airport",
              "phoneticLabel": null,
              "searchText": "mbj sangster international airport jamaica montego bay",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KIN",
              "cityName": "Kingston",
              "code": "KIN",
              "countryName": "Jamaica",
              "displayText": "Kingston, Norman Manley",
              "isDestination": true,
              "isOrigin": true,
              "label": "Norman Manley",
              "phoneticLabel": null,
              "searchText": "kin norman manley jamaica kingston",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MNL",
              "cityName": "Manila",
              "code": "MNL",
              "countryName": "Philippines",
              "displayText": "Manila, Ninoy Aquino International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Ninoy Aquino International Airport",
              "phoneticLabel": null,
              "searchText": "mnl ninoy aquino international airport philippines manila",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CEB",
              "cityName": "Cebu",
              "code": "CEB",
              "countryName": "Philippines",
              "displayText": "Cebu, Mactan International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Mactan International",
              "phoneticLabel": null,
              "searchText": "ceb mactan international philippines cebu",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KLO",
              "cityName": "Kalibo",
              "code": "KLO",
              "countryName": "Philippines",
              "displayText": "Kalibo, Kalibo International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kalibo International",
              "phoneticLabel": null,
              "searchText": "klo kalibo international philippines kalibo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NCP",
              "cityName": "Luzon",
              "code": "CRK",
              "countryName": "Philippines",
              "displayText": "Luzon, Angeles Clark International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Angeles Clark International Airport",
              "phoneticLabel": null,
              "searchText": "crk angeles clark international airport philippines luzon",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "DVO",
              "cityName": "Davao",
              "code": "DVO",
              "countryName": "Philippines",
              "displayText": "Davao, Francisco Bangoy Intl",
              "isDestination": true,
              "isOrigin": true,
              "label": "Francisco Bangoy Intl",
              "phoneticLabel": null,
              "searchText": "dvo francisco bangoy intl philippines davao",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CMB",
              "cityName": "Colombo",
              "code": "CMB",
              "countryName": "Sri Lanka",
              "displayText": "Colombo, Bandaranaike International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Bandaranaike International Airport",
              "phoneticLabel": null,
              "searchText": "cmb bandaranaike international airport sri lanka colombo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MEC",
              "cityName": "Manta",
              "code": "MEC",
              "countryName": "Ecuador",
              "displayText": "Manta, Eloy Alfaro International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Eloy Alfaro International Airport",
              "phoneticLabel": null,
              "searchText": "mec eloy alfaro international airport ecuador manta",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CUE",
              "cityName": "Cuenca",
              "code": "CUE",
              "countryName": "Ecuador",
              "displayText": "Cuenca, Mariscal Lamar Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Mariscal Lamar Airport",
              "phoneticLabel": null,
              "searchText": "cue mariscal lamar airport ecuador cuenca",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LOH",
              "cityName": "Loja",
              "code": "LOH",
              "countryName": "Ecuador",
              "displayText": "Loja, Catamayo",
              "isDestination": true,
              "isOrigin": true,
              "label": "Catamayo",
              "phoneticLabel": null,
              "searchText": "loh catamayo ecuador loja",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "UIO",
              "cityName": "Quito",
              "code": "UIO",
              "countryName": "Ecuador",
              "displayText": "Quito, Mariscal Sucre Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Mariscal Sucre Airport",
              "phoneticLabel": null,
              "searchText": "uio mariscal sucre airport ecuador quito",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "GYE",
              "cityName": "Guayaquil",
              "code": "GYE",
              "countryName": "Ecuador",
              "displayText": "Guayaquil, José Joaquín de Olmedo International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "José Joaquín de Olmedo International Airport",
              "phoneticLabel": null,
              "searchText": "gye josé joaquín de olmedo international airport ecuador guayaquil",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ROR",
              "cityName": "Koror",
              "code": "ROR",
              "countryName": "Palau",
              "displayText": "Koror, Airai",
              "isDestination": true,
              "isOrigin": true,
              "label": "Airai",
              "phoneticLabel": null,
              "searchText": "ror airai palau koror",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TMR",
              "cityName": "Tamanrasset",
              "code": "TMR",
              "countryName": "Algeria",
              "displayText": "Tamanrasset, Tamanrasset Aguenar Hadj Bey Akhamok Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Tamanrasset Aguenar Hadj Bey Akhamok Airport",
              "phoneticLabel": null,
              "searchText": "tmr tamanrasset aguenar hadj bey akhamok airport algeria tamanrasset",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TEE",
              "cityName": "Tebessa",
              "code": "TEE",
              "countryName": "Algeria",
              "displayText": "Tebessa, Tbessa",
              "isDestination": true,
              "isOrigin": true,
              "label": "Tbessa",
              "phoneticLabel": null,
              "searchText": "tee tbessa algeria tebessa",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BJA",
              "cityName": "Bejaia",
              "code": "BJA",
              "countryName": "Algeria",
              "displayText": "Bejaia, Soummam Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Soummam Airport",
              "phoneticLabel": null,
              "searchText": "bja soummam airport algeria bejaia",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "DJG",
              "cityName": "Djanet",
              "code": "DJG",
              "countryName": "Algeria",
              "displayText": "Djanet, Djanet Cheikh Amoud Ben El Mokhtar Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Djanet Cheikh Amoud Ben El Mokhtar Airport",
              "phoneticLabel": null,
              "searchText": "djg djanet cheikh amoud ben el mokhtar airport algeria djanet",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ELU",
              "cityName": "El Oued",
              "code": "ELU",
              "countryName": "Algeria",
              "displayText": "El Oued, El Oued Abdel Kader Lamoudi Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "El Oued Abdel Kader Lamoudi Airport",
              "phoneticLabel": null,
              "searchText": "elu el oued abdel kader lamoudi airport algeria el oued",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ALG",
              "cityName": "Algiers",
              "code": "ALG",
              "countryName": "Algeria",
              "displayText": "Algiers, Houari Boumediene",
              "isDestination": true,
              "isOrigin": true,
              "label": "Houari Boumediene",
              "phoneticLabel": null,
              "searchText": "alg houari boumediene algeria algiers",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LOO",
              "cityName": "Laghouat",
              "code": "LOO",
              "countryName": "Algeria",
              "displayText": "Laghouat, Laghouat Moulay Ahmed Medeghri Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Laghouat Moulay Ahmed Medeghri Airport",
              "phoneticLabel": null,
              "searchText": "loo laghouat moulay ahmed medeghri airport algeria laghouat",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "VVZ",
              "cityName": "Illizi",
              "code": "VVZ",
              "countryName": "Algeria",
              "displayText": "Illizi, Illizi Takhamalt Ibrahim Ghouma Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Illizi Takhamalt Ibrahim Ghouma Airport",
              "phoneticLabel": null,
              "searchText": "vvz illizi takhamalt ibrahim ghouma airport algeria illizi",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ELG",
              "cityName": "El Golea",
              "code": "ELG",
              "countryName": "Algeria",
              "displayText": "El Golea, El Golea Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "El Golea Airport",
              "phoneticLabel": null,
              "searchText": "elg el golea airport algeria el golea",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "INZ",
              "cityName": "In Salah",
              "code": "INZ",
              "countryName": "Algeria",
              "displayText": "In Salah, In Salah Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "In Salah Airport",
              "phoneticLabel": null,
              "searchText": "inz in salah airport algeria in salah",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BMW",
              "cityName": "Bordj Mokhtar",
              "code": "BMW",
              "countryName": "Algeria",
              "displayText": "Bordj Mokhtar, Bordj Badji Mokhtar Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Bordj Badji Mokhtar Airport",
              "phoneticLabel": null,
              "searchText": "bmw bordj badji mokhtar airport algeria bordj mokhtar",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TLM",
              "cityName": "Tlemcen",
              "code": "TLM",
              "countryName": "Algeria",
              "displayText": "Tlemcen, Zenata Messali El Hadj",
              "isDestination": true,
              "isOrigin": true,
              "label": "Zenata Messali El Hadj",
              "phoneticLabel": null,
              "searchText": "tlm zenata messali el hadj algeria tlemcen",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CZL",
              "cityName": "Constantine",
              "code": "CZL",
              "countryName": "Algeria",
              "displayText": "Constantine, Mohamed Boudiaf",
              "isDestination": true,
              "isOrigin": true,
              "label": "Mohamed Boudiaf",
              "phoneticLabel": null,
              "searchText": "czl mohamed boudiaf algeria constantine",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TGR",
              "cityName": "Touggourt",
              "code": "TGR",
              "countryName": "Algeria",
              "displayText": "Touggourt, Sidi Mahdi",
              "isDestination": true,
              "isOrigin": true,
              "label": "Sidi Mahdi",
              "phoneticLabel": null,
              "searchText": "tgr sidi mahdi algeria touggourt",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BLJ",
              "cityName": "Batna",
              "code": "BLJ",
              "countryName": "Algeria",
              "displayText": "Batna, Mostepha Ben Boulaid Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Mostepha Ben Boulaid Airport",
              "phoneticLabel": null,
              "searchText": "blj mostepha ben boulaid airport algeria batna",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BSK",
              "cityName": "Biskra",
              "code": "BSK",
              "countryName": "Algeria",
              "displayText": "Biskra, Mohamed Khider Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Mohamed Khider Airport",
              "phoneticLabel": null,
              "searchText": "bsk mohamed khider airport algeria biskra",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "OGX",
              "cityName": "Ouargla",
              "code": "OGX",
              "countryName": "Algeria",
              "displayText": "Ouargla, Ain el Beida Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Ain el Beida Airport",
              "phoneticLabel": null,
              "searchText": "ogx ain el beida airport algeria ouargla",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TMX",
              "cityName": "Timimoun",
              "code": "TMX",
              "countryName": "Algeria",
              "displayText": "Timimoun, Timimoun",
              "isDestination": true,
              "isOrigin": true,
              "label": "Timimoun",
              "phoneticLabel": null,
              "searchText": "tmx timimoun algeria timimoun",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HME",
              "cityName": "Hassi Messaoud",
              "code": "HME",
              "countryName": "Algeria",
              "displayText": "Hassi Messaoud, Hassi Messaoud Oued Irara Krim Belkacem Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Hassi Messaoud Oued Irara Krim Belkacem Airport",
              "phoneticLabel": null,
              "searchText": "hme hassi messaoud oued irara krim belkacem airport algeria hassi messaoud",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ORN",
              "cityName": "Oran",
              "code": "ORN",
              "countryName": "Algeria",
              "displayText": "Oran, Ahmed Ben Bella",
              "isDestination": true,
              "isOrigin": true,
              "label": "Ahmed Ben Bella",
              "phoneticLabel": null,
              "searchText": "orn ahmed ben bella algeria oran",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "AAE",
              "cityName": "Annaba",
              "code": "AAE",
              "countryName": "Algeria",
              "displayText": "Annaba, Rabah Bitat",
              "isDestination": true,
              "isOrigin": true,
              "label": "Rabah Bitat",
              "phoneticLabel": null,
              "searchText": "aae rabah bitat algeria annaba",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TIN",
              "cityName": "Tindouf",
              "code": "TIN",
              "countryName": "Algeria",
              "displayText": "Tindouf, Tindouf",
              "isDestination": true,
              "isOrigin": true,
              "label": "Tindouf",
              "phoneticLabel": null,
              "searchText": "tin tindouf algeria tindouf",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CBH",
              "cityName": "Bechar",
              "code": "CBH",
              "countryName": "Algeria",
              "displayText": "Bechar, Boudghene B Ali Lotfi",
              "isDestination": true,
              "isOrigin": true,
              "label": "Boudghene B Ali Lotfi",
              "phoneticLabel": null,
              "searchText": "cbh boudghene b ali lotfi algeria bechar",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "GHA",
              "cityName": "Ghardaia",
              "code": "GHA",
              "countryName": "Algeria",
              "displayText": "Ghardaia, Ghardaia Noumerat Moufdi Zakaria Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Ghardaia Noumerat Moufdi Zakaria Airport",
              "phoneticLabel": null,
              "searchText": "gha ghardaia noumerat moufdi zakaria airport algeria ghardaia",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "IAM",
              "cityName": "In Amenas",
              "code": "IAM",
              "countryName": "Algeria",
              "displayText": "In Amenas, Zarzaitine Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Zarzaitine Airport",
              "phoneticLabel": null,
              "searchText": "iam zarzaitine airport algeria in amenas",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "GJL",
              "cityName": "Jijel",
              "code": "GJL",
              "countryName": "Algeria",
              "displayText": "Jijel, Jijel Ferhat Abbas Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Jijel Ferhat Abbas Airport",
              "phoneticLabel": null,
              "searchText": "gjl jijel ferhat abbas airport algeria jijel",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "QSF",
              "cityName": "Setif",
              "code": "QSF",
              "countryName": "Algeria",
              "displayText": "Setif, Ain Arnat Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Ain Arnat Airport",
              "phoneticLabel": null,
              "searchText": "qsf ain arnat airport algeria setif",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SJJ",
              "cityName": "Sarajevo",
              "code": "SJJ",
              "countryName": "Bosnia and Herzegovina",
              "displayText": "Sarajevo, Sarajevo International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Sarajevo International Airport",
              "phoneticLabel": null,
              "searchText": "sjj sarajevo international airport bosnia and herzegovina sarajevo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MCM",
              "cityName": "Monte Carlo",
              "code": "MCM",
              "countryName": "Monaco",
              "displayText": "Monte Carlo, Monte Carlo Heliport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Monte Carlo Heliport",
              "phoneticLabel": null,
              "searchText": "mcm monte carlo heliport monaco monte carlo",
              "stationType": "HELIPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BAH",
              "cityName": "Bahrain",
              "code": "BAH",
              "countryName": "Bahrain",
              "displayText": "Bahrain, Bahrain International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Bahrain International Airport",
              "phoneticLabel": null,
              "searchText": "bah bahrain international airport bahrain bahrain",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SAL",
              "cityName": "San Salvador",
              "code": "SAL",
              "countryName": "El Salvador",
              "displayText": "San Salvador, Comalapa International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Comalapa International Airport",
              "phoneticLabel": null,
              "searchText": "sal comalapa international airport el salvador san salvador",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "OUA",
              "cityName": "Ouagadougou",
              "code": "OUA",
              "countryName": "Burkina Faso",
              "displayText": "Ouagadougou, Ouagadougou Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Ouagadougou Airport",
              "phoneticLabel": null,
              "searchText": "oua ouagadougou airport burkina faso ouagadougou",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YVA",
              "cityName": "Moroni",
              "code": "HAH",
              "countryName": "Comoros",
              "displayText": "Moroni, Prince Said Ibrahim International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Prince Said Ibrahim International Airport",
              "phoneticLabel": null,
              "searchText": "hah prince said ibrahim international airport comoros moroni",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TMS",
              "cityName": "Sao Tome",
              "code": "TMS",
              "countryName": "Sao Tome and Principe",
              "displayText": "Sao Tome, Sao Tome International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Sao Tome International Airport",
              "phoneticLabel": null,
              "searchText": "tms sao tome international airport sao tome and principe sao tome",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PCP",
              "cityName": "Principe",
              "code": "PCP",
              "countryName": "Sao Tome and Principe",
              "displayText": "Principe, Principe Island Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Principe Island Airport",
              "phoneticLabel": null,
              "searchText": "pcp principe island airport sao tome and principe principe",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SSG",
              "cityName": "Malabo",
              "code": "SSG",
              "countryName": "Equatorial Guinea",
              "displayText": "Malabo, Malabo International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Malabo International Airport",
              "phoneticLabel": null,
              "searchText": "ssg malabo international airport equatorial guinea malabo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BSG",
              "cityName": "Bata",
              "code": "BSG",
              "countryName": "Equatorial Guinea",
              "displayText": "Bata, Bata",
              "isDestination": true,
              "isOrigin": true,
              "label": "Bata",
              "phoneticLabel": null,
              "searchText": "bsg bata equatorial guinea bata",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ESU",
              "cityName": "Essaouira",
              "code": "ESU",
              "countryName": "Morocco",
              "displayText": "Essaouira, Essaouira Mogador Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Essaouira Mogador Airport",
              "phoneticLabel": null,
              "searchText": "esu essaouira mogador airport morocco essaouira",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "OUD",
              "cityName": "Oujda",
              "code": "OUD",
              "countryName": "Morocco",
              "displayText": "Oujda, Angads",
              "isDestination": true,
              "isOrigin": true,
              "label": "Angads",
              "phoneticLabel": null,
              "searchText": "oud angads morocco oujda",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "OZZ",
              "cityName": "Ouarzazate",
              "code": "OZZ",
              "countryName": "Morocco",
              "displayText": "Ouarzazate, Ouarzazate",
              "isDestination": true,
              "isOrigin": true,
              "label": "Ouarzazate",
              "phoneticLabel": null,
              "searchText": "ozz ouarzazate morocco ouarzazate",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "RBA",
              "cityName": "Rabat",
              "code": "RBA",
              "countryName": "Morocco",
              "displayText": "Rabat, Salé",
              "isDestination": true,
              "isOrigin": true,
              "label": "Salé",
              "phoneticLabel": null,
              "searchText": "rba salé morocco rabat",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ERH",
              "cityName": "Errachidia",
              "code": "ERH",
              "countryName": "Morocco",
              "displayText": "Errachidia, Moulay Ali Cherif Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Moulay Ali Cherif Airport",
              "phoneticLabel": null,
              "searchText": "erh moulay ali cherif airport morocco errachidia",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "VIL",
              "cityName": "Dakhla",
              "code": "VIL",
              "countryName": "Morocco",
              "displayText": "Dakhla, Dakhla Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Dakhla Airport",
              "phoneticLabel": null,
              "searchText": "vil dakhla airport morocco dakhla",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "AGA",
              "cityName": "Agadir",
              "code": "AGA",
              "countryName": "Morocco",
              "displayText": "Agadir, Al Massira",
              "isDestination": true,
              "isOrigin": true,
              "label": "Al Massira",
              "phoneticLabel": null,
              "searchText": "aga al massira morocco agadir",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "FEZ",
              "cityName": "Fes",
              "code": "FEZ",
              "countryName": "Morocco",
              "displayText": "Fes, Saïss Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Saïss Airport",
              "phoneticLabel": null,
              "searchText": "fez saïss airport morocco fes",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NDR",
              "cityName": "Nador",
              "code": "NDR",
              "countryName": "Morocco",
              "displayText": "Nador, El Aroui",
              "isDestination": true,
              "isOrigin": true,
              "label": "El Aroui",
              "phoneticLabel": null,
              "searchText": "ndr el aroui morocco nador",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TNG",
              "cityName": "Tangier",
              "code": "TNG",
              "countryName": "Morocco",
              "displayText": "Tangier, Tangier Ibn Batouta Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Tangier Ibn Batouta Airport",
              "phoneticLabel": null,
              "searchText": "tng tangier ibn batouta airport morocco tangier",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CMN",
              "cityName": "Casablanca",
              "code": "CMN",
              "countryName": "Morocco",
              "displayText": "Casablanca, Mohamed V",
              "isDestination": true,
              "isOrigin": true,
              "label": "Mohamed V",
              "phoneticLabel": null,
              "searchText": "cmn mohamed v morocco casablanca",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "RAK",
              "cityName": "Marrakech",
              "code": "RAK",
              "countryName": "Morocco",
              "displayText": "Marrakech, Menara",
              "isDestination": true,
              "isOrigin": true,
              "label": "Menara",
              "phoneticLabel": null,
              "searchText": "rak menara morocco marrakech",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "REK",
              "cityName": "Reykjavik",
              "code": "KEF",
              "countryName": "Iceland",
              "displayText": "Reykjavik, Keflavik International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Keflavik International",
              "phoneticLabel": null,
              "searchText": "kef keflavik international iceland reykjavik",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TGD",
              "cityName": "Podgorica",
              "code": "TGD",
              "countryName": "Montenegro",
              "displayText": "Podgorica, Podgorica",
              "isDestination": true,
              "isOrigin": true,
              "label": "Podgorica",
              "phoneticLabel": null,
              "searchText": "tgd podgorica montenegro podgorica",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TIV",
              "cityName": "Tivat",
              "code": "TIV",
              "countryName": "Montenegro",
              "displayText": "Tivat, Tivat",
              "isDestination": true,
              "isOrigin": true,
              "label": "Tivat",
              "phoneticLabel": null,
              "searchText": "tiv tivat montenegro tivat",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CFN",
              "cityName": "Donegal",
              "code": "CFN",
              "countryName": "Ireland",
              "displayText": "Donegal, Donegal Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Donegal Airport",
              "phoneticLabel": null,
              "searchText": "cfn donegal airport ireland donegal",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NOC",
              "cityName": "Knock",
              "code": "NOC",
              "countryName": "Ireland",
              "displayText": "Knock, Knock Ireland West Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Knock Ireland West Airport",
              "phoneticLabel": null,
              "searchText": "noc knock ireland west airport ireland knock",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "DUB",
              "cityName": "Dublin",
              "code": "DUB",
              "countryName": "Ireland",
              "displayText": "Dublin, Dublin Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Dublin Airport",
              "phoneticLabel": null,
              "searchText": "dub dublin airport ireland dublin",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ORK",
              "cityName": "Cork",
              "code": "ORK",
              "countryName": "Ireland",
              "displayText": "Cork, Cork Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Cork Airport",
              "phoneticLabel": null,
              "searchText": "ork cork airport ireland cork",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KIR",
              "cityName": "Kerry",
              "code": "KIR",
              "countryName": "Ireland",
              "displayText": "Kerry, Kerry Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kerry Airport",
              "phoneticLabel": null,
              "searchText": "kir kerry airport ireland kerry",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SNN",
              "cityName": "Shannon",
              "code": "SNN",
              "countryName": "Ireland",
              "displayText": "Shannon, Shannon International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Shannon International Airport",
              "phoneticLabel": null,
              "searchText": "snn shannon international airport ireland shannon",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MGA",
              "cityName": "Managua",
              "code": "MGA",
              "countryName": "Nicaragua",
              "displayText": "Managua, Augusto C. Sandino",
              "isDestination": true,
              "isOrigin": true,
              "label": "Augusto C. Sandino",
              "phoneticLabel": null,
              "searchText": "mga augusto c. sandino nicaragua managua",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "GCM",
              "cityName": "Grand Cayman",
              "code": "GCM",
              "countryName": "Cayman Islands",
              "displayText": "Grand Cayman, Owen Roberts International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Owen Roberts International Airport",
              "phoneticLabel": null,
              "searchText": "gcm owen roberts international airport cayman islands grand cayman",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MIR",
              "cityName": "Monastir",
              "code": "MIR",
              "countryName": "Tunisia",
              "displayText": "Monastir, Habib Bourguiba International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Habib Bourguiba International",
              "phoneticLabel": null,
              "searchText": "mir habib bourguiba international tunisia monastir",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "DJE",
              "cityName": "Djerba",
              "code": "DJE",
              "countryName": "Tunisia",
              "displayText": "Djerba, Zarzis",
              "isDestination": true,
              "isOrigin": true,
              "label": "Zarzis",
              "phoneticLabel": null,
              "searchText": "dje zarzis tunisia djerba",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TUN",
              "cityName": "Tunis",
              "code": "TUN",
              "countryName": "Tunisia",
              "displayText": "Tunis, Carthage",
              "isDestination": true,
              "isOrigin": true,
              "label": "Carthage",
              "phoneticLabel": null,
              "searchText": "tun carthage tunisia tunis",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SFA",
              "cityName": "Sfax",
              "code": "SFA",
              "countryName": "Tunisia",
              "displayText": "Sfax, Thyna Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Thyna Airport",
              "phoneticLabel": null,
              "searchText": "sfa thyna airport tunisia sfax",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TOE",
              "cityName": "Tozeur",
              "code": "TOE",
              "countryName": "Tunisia",
              "displayText": "Tozeur, Nefta International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Nefta International Airport",
              "phoneticLabel": null,
              "searchText": "toe nefta international airport tunisia tozeur",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "EBB",
              "cityName": "Entebbe",
              "code": "EBB",
              "countryName": "Uganda",
              "displayText": "Entebbe, International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "International Airport",
              "phoneticLabel": null,
              "searchText": "ebb international airport uganda entebbe",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PUS",
              "cityName": "Busan",
              "code": "PUS",
              "countryName": "Korea, Republic of",
              "displayText": "Busan",
              "isDestination": true,
              "isOrigin": true,
              "label": "Busan",
              "phoneticLabel": null,
              "searchText": "pus busan korea, republic of",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "HIN",
              "cityName": "Jinju",
              "code": "HIN",
              "countryName": "Korea, Republic of",
              "displayText": "Jinju, Sacheon",
              "isDestination": true,
              "isOrigin": true,
              "label": "Sacheon",
              "phoneticLabel": null,
              "searchText": "hin sacheon korea, republic of jinju",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "USN",
              "cityName": "Ulsan",
              "code": "USN",
              "countryName": "Korea, Republic of",
              "displayText": "Ulsan, Ulsan",
              "isDestination": true,
              "isOrigin": true,
              "label": "Ulsan",
              "phoneticLabel": null,
              "searchText": "usn ulsan korea, republic of ulsan",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TAE",
              "cityName": "Daegu",
              "code": "TAE",
              "countryName": "Korea, Republic of",
              "displayText": "Daegu, Daegu",
              "isDestination": true,
              "isOrigin": true,
              "label": "Daegu",
              "phoneticLabel": null,
              "searchText": "tae daegu korea, republic of daegu",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SEL",
              "cityName": "Seoul",
              "code": "SEL",
              "countryName": "Korea, Republic of",
              "displayText": "Seoul",
              "isDestination": true,
              "isOrigin": true,
              "label": "Seoul",
              "phoneticLabel": null,
              "searchText": "sel seoul korea, republic of",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "SEL",
              "cityName": "Seoul",
              "code": "ICN",
              "countryName": "Korea, Republic of",
              "displayText": "Seoul, Incheon International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Incheon International Airport",
              "phoneticLabel": null,
              "searchText": "icn incheon international airport korea, republic of seoul",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SEL",
              "cityName": "Seoul",
              "code": "GMP",
              "countryName": "Korea, Republic of",
              "displayText": "Seoul, Gimpo International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Gimpo International",
              "phoneticLabel": null,
              "searchText": "gmp gimpo international korea, republic of seoul",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CJU",
              "cityName": "Jeju",
              "code": "CJU",
              "countryName": "Korea, Republic of",
              "displayText": "Jeju, Jeju International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Jeju International Airport",
              "phoneticLabel": null,
              "searchText": "cju jeju international airport korea, republic of jeju",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "RSU",
              "cityName": "Yeosu",
              "code": "RSU",
              "countryName": "Korea, Republic of",
              "displayText": "Yeosu, Yeosu",
              "isDestination": true,
              "isOrigin": true,
              "label": "Yeosu",
              "phoneticLabel": null,
              "searchText": "rsu yeosu korea, republic of yeosu",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KWJ",
              "cityName": "Gwangju",
              "code": "KWJ",
              "countryName": "Korea, Republic of",
              "displayText": "Gwangju, Gwangju",
              "isDestination": true,
              "isOrigin": true,
              "label": "Gwangju",
              "phoneticLabel": null,
              "searchText": "kwj gwangju korea, republic of gwangju",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PBM",
              "cityName": "Paramaribo",
              "code": "PBM",
              "countryName": "Suriname",
              "displayText": "Paramaribo, J.A. Pengel International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "J.A. Pengel International Airport",
              "phoneticLabel": null,
              "searchText": "pbm j.a. pengel international airport suriname paramaribo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "VVI",
              "cityName": "Santa Cruz",
              "code": "VVI",
              "countryName": "Bolivia",
              "displayText": "Santa Cruz, Viru Viru International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Viru Viru International",
              "phoneticLabel": null,
              "searchText": "vvi viru viru international bolivia santa cruz",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LPB",
              "cityName": "La Paz",
              "code": "LPB",
              "countryName": "Bolivia",
              "displayText": "La Paz, El Alto",
              "isDestination": true,
              "isOrigin": true,
              "label": "El Alto",
              "phoneticLabel": null,
              "searchText": "lpb el alto bolivia la paz",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "AUA",
              "cityName": "Aruba",
              "code": "AUA",
              "countryName": "Aruba",
              "displayText": "Aruba, Queen Beatrix Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Queen Beatrix Airport",
              "phoneticLabel": null,
              "searchText": "aua queen beatrix airport aruba aruba",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SIN",
              "cityName": "Singapore",
              "code": "SIN",
              "countryName": "Singapore",
              "displayText": "Singapore, Changi",
              "isDestination": true,
              "isOrigin": true,
              "label": "Changi",
              "phoneticLabel": null,
              "searchText": "sin changi singapore singapore",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "AAL",
              "cityName": "Aalborg",
              "code": "AAL",
              "countryName": "Denmark",
              "displayText": "Aalborg, Aalborg",
              "isDestination": true,
              "isOrigin": true,
              "label": "Aalborg",
              "phoneticLabel": null,
              "searchText": "aal aalborg denmark aalborg",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "AAR",
              "cityName": "Aarhus",
              "code": "AAR",
              "countryName": "Denmark",
              "displayText": "Aarhus, Aarhus Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Aarhus Airport",
              "phoneticLabel": null,
              "searchText": "aar aarhus airport denmark aarhus",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "RNN",
              "cityName": "Ronne - Bornholm",
              "code": "RNN",
              "countryName": "Denmark",
              "displayText": "Ronne - Bornholm, Ronne Bornholm Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Ronne Bornholm Airport",
              "phoneticLabel": null,
              "searchText": "rnn ronne bornholm airport denmark ronne - bornholm",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BLL",
              "cityName": "Billund",
              "code": "BLL",
              "countryName": "Denmark",
              "displayText": "Billund, Billund Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Billund Airport",
              "phoneticLabel": null,
              "searchText": "bll billund airport denmark billund",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SGD",
              "cityName": "Sonderborg",
              "code": "SGD",
              "countryName": "Denmark",
              "displayText": "Sonderborg, Sonderborg Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Sonderborg Airport",
              "phoneticLabel": null,
              "searchText": "sgd sonderborg airport denmark sonderborg",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CPH",
              "cityName": "Copenhagen",
              "code": "CPH",
              "countryName": "Denmark",
              "displayText": "Copenhagen, Copenhagen Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Copenhagen Airport",
              "phoneticLabel": null,
              "searchText": "cph copenhagen airport denmark copenhagen",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NKC",
              "cityName": "Nouakchott",
              "code": "NKC",
              "countryName": "Mauritania",
              "displayText": "Nouakchott, Nouakchott International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Nouakchott International Airport",
              "phoneticLabel": null,
              "searchText": "nkc nouakchott international airport mauritania nouakchott",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LPI",
              "cityName": "Linkoping",
              "code": "LPI",
              "countryName": "Sweden",
              "displayText": "Linkoping, Linköping City Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Linköping City Airport",
              "phoneticLabel": null,
              "searchText": "lpi linköping city airport sweden linkoping",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "VBY",
              "cityName": "Visby",
              "code": "VBY",
              "countryName": "Sweden",
              "displayText": "Visby, Visby Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Visby Airport",
              "phoneticLabel": null,
              "searchText": "vby visby airport sweden visby",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "OSD",
              "cityName": "Ostersund",
              "code": "OSD",
              "countryName": "Sweden",
              "displayText": "Ostersund, Are Ostersund Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Are Ostersund Airport",
              "phoneticLabel": null,
              "searchText": "osd are ostersund airport sweden ostersund",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SDL",
              "cityName": "Sundsvall Harnosand",
              "code": "SDL",
              "countryName": "Sweden",
              "displayText": "Sundsvall Harnosand, Sundsvall Timra Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Sundsvall Timra Airport",
              "phoneticLabel": null,
              "searchText": "sdl sundsvall timra airport sweden sundsvall harnosand",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "UME",
              "cityName": "Umea",
              "code": "UME",
              "countryName": "Sweden",
              "displayText": "Umea, Umea Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Umea Airport",
              "phoneticLabel": null,
              "searchText": "ume umea airport sweden umea",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KLR",
              "cityName": "Kalmar",
              "code": "KLR",
              "countryName": "Sweden",
              "displayText": "Kalmar, Kalmar Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kalmar Airport",
              "phoneticLabel": null,
              "searchText": "klr kalmar airport sweden kalmar",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SCR",
              "cityName": "Salen",
              "code": "SCR",
              "countryName": "Sweden",
              "displayText": "Salen, Salen Scandinavian Mountains Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Salen Scandinavian Mountains Airport",
              "phoneticLabel": null,
              "searchText": "scr salen scandinavian mountains airport sweden salen",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LLA",
              "cityName": "Lulea",
              "code": "LLA",
              "countryName": "Sweden",
              "displayText": "Lulea, Lulea Kallax Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Lulea Kallax Airport",
              "phoneticLabel": null,
              "searchText": "lla lulea kallax airport sweden lulea",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HAD",
              "cityName": "Halmstad",
              "code": "HAD",
              "countryName": "Sweden",
              "displayText": "Halmstad, Halmstad Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Halmstad Airport",
              "phoneticLabel": null,
              "searchText": "had halmstad airport sweden halmstad",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KRN",
              "cityName": "Kiruna",
              "code": "KRN",
              "countryName": "Sweden",
              "displayText": "Kiruna, Kiruna Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kiruna Airport",
              "phoneticLabel": null,
              "searchText": "krn kiruna airport sweden kiruna",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SFT",
              "cityName": "Skelleftea",
              "code": "SFT",
              "countryName": "Sweden",
              "displayText": "Skelleftea, Skelleftea Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Skelleftea Airport",
              "phoneticLabel": null,
              "searchText": "sft skelleftea airport sweden skelleftea",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "GOT",
              "cityName": "Gothenburg",
              "code": "GOT",
              "countryName": "Sweden",
              "displayText": "Gothenburg, Landvetter",
              "isDestination": true,
              "isOrigin": true,
              "label": "Landvetter",
              "phoneticLabel": null,
              "searchText": "got landvetter sweden gothenburg",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MMA",
              "cityName": "Malmo",
              "code": "MMX",
              "countryName": "Sweden",
              "displayText": "Malmo, Malmo International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Malmo International Airport",
              "phoneticLabel": null,
              "searchText": "mmx malmo international airport sweden malmo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "AGH",
              "cityName": "Helsingborg",
              "code": "AGH",
              "countryName": "Sweden",
              "displayText": "Helsingborg, Angelholm Helsingborg Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Angelholm Helsingborg Airport",
              "phoneticLabel": null,
              "searchText": "agh angelholm helsingborg airport sweden helsingborg",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "STO",
              "cityName": "Stockholm",
              "code": "ARN",
              "countryName": "Sweden",
              "displayText": "Stockholm, Arlanda Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Arlanda Airport",
              "phoneticLabel": null,
              "searchText": "arn arlanda airport sweden stockholm",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "RNB",
              "cityName": "Ronneby Karlskrona",
              "code": "RNB",
              "countryName": "Sweden",
              "displayText": "Ronneby Karlskrona, Kallinge Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kallinge Airport",
              "phoneticLabel": null,
              "searchText": "rnb kallinge airport sweden ronneby karlskrona",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BJM",
              "cityName": "Bujumbura",
              "code": "BJM",
              "countryName": "Burundi",
              "displayText": "Bujumbura, Bujumbura International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Bujumbura International Airport",
              "phoneticLabel": null,
              "searchText": "bjm bujumbura international airport burundi bujumbura",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SAP",
              "cityName": "San Pedro Sula",
              "code": "SAP",
              "countryName": "Honduras",
              "displayText": "San Pedro Sula, Ramon V Morales",
              "isDestination": true,
              "isOrigin": true,
              "label": "Ramon V Morales",
              "phoneticLabel": null,
              "searchText": "sap ramon v morales honduras san pedro sula",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TGU",
              "cityName": "Tegucigalpa",
              "code": "TGU",
              "countryName": "Honduras",
              "displayText": "Tegucigalpa",
              "isDestination": true,
              "isOrigin": true,
              "label": "Tegucigalpa",
              "phoneticLabel": null,
              "searchText": "tgu tegucigalpa honduras",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "TGU",
              "cityName": "Tegucigalpa",
              "code": "TGU",
              "countryName": "Honduras",
              "displayText": "Tegucigalpa, Toncontin",
              "isDestination": true,
              "isOrigin": true,
              "label": "Toncontin",
              "phoneticLabel": null,
              "searchText": "tgu toncontin honduras tegucigalpa",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TGU",
              "cityName": "Tegucigalpa",
              "code": "XPL",
              "countryName": "Honduras",
              "displayText": "Tegucigalpa, Palmerola International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Palmerola International Airport",
              "phoneticLabel": null,
              "searchText": "xpl palmerola international airport honduras tegucigalpa",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SPU",
              "cityName": "Split",
              "code": "SPU",
              "countryName": "Croatia",
              "displayText": "Split, Split",
              "isDestination": true,
              "isOrigin": true,
              "label": "Split",
              "phoneticLabel": null,
              "searchText": "spu split croatia split",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "DBV",
              "cityName": "Dubrovnik",
              "code": "DBV",
              "countryName": "Croatia",
              "displayText": "Dubrovnik, Dubrovnik",
              "isDestination": true,
              "isOrigin": true,
              "label": "Dubrovnik",
              "phoneticLabel": null,
              "searchText": "dbv dubrovnik croatia dubrovnik",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ZAD",
              "cityName": "Zadar",
              "code": "ZAD",
              "countryName": "Croatia",
              "displayText": "Zadar, Zadar",
              "isDestination": true,
              "isOrigin": true,
              "label": "Zadar",
              "phoneticLabel": null,
              "searchText": "zad zadar croatia zadar",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PUY",
              "cityName": "Pula",
              "code": "PUY",
              "countryName": "Croatia",
              "displayText": "Pula, Pula",
              "isDestination": true,
              "isOrigin": true,
              "label": "Pula",
              "phoneticLabel": null,
              "searchText": "puy pula croatia pula",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ZAG",
              "cityName": "Zagreb",
              "code": "ZAG",
              "countryName": "Croatia",
              "displayText": "Zagreb, Pleso",
              "isDestination": true,
              "isOrigin": true,
              "label": "Pleso",
              "phoneticLabel": null,
              "searchText": "zag pleso croatia zagreb",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SKG",
              "cityName": "Thessaloniki",
              "code": "SKG",
              "countryName": "Greece",
              "displayText": "Thessaloniki, Makedonia",
              "isDestination": true,
              "isOrigin": true,
              "label": "Makedonia",
              "phoneticLabel": null,
              "searchText": "skg makedonia greece thessaloniki",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "JNX",
              "cityName": "Naxos",
              "code": "JNX",
              "countryName": "Greece",
              "displayText": "Naxos, Naxos Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Naxos Airport",
              "phoneticLabel": null,
              "searchText": "jnx naxos airport greece naxos",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KIT",
              "cityName": "Kythira",
              "code": "KIT",
              "countryName": "Greece",
              "displayText": "Kythira, Alexandros A. Onassis Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Alexandros A. Onassis Airport",
              "phoneticLabel": null,
              "searchText": "kit alexandros a. onassis airport greece kythira",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CHQ",
              "cityName": "Chania",
              "code": "CHQ",
              "countryName": "Greece",
              "displayText": "Chania, Chania International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Chania International Airport",
              "phoneticLabel": null,
              "searchText": "chq chania international airport greece chania",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "JIK",
              "cityName": "Ikaria",
              "code": "JIK",
              "countryName": "Greece",
              "displayText": "Ikaria, Ikaria Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Ikaria Airport",
              "phoneticLabel": null,
              "searchText": "jik ikaria airport greece ikaria",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "JKL",
              "cityName": "Kalymnos",
              "code": "JKL",
              "countryName": "Greece",
              "displayText": "Kalymnos, Kalymnos Island National Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kalymnos Island National Airport",
              "phoneticLabel": null,
              "searchText": "jkl kalymnos island national airport greece kalymnos",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "JTY",
              "cityName": "Astypalaia",
              "code": "JTY",
              "countryName": "Greece",
              "displayText": "Astypalaia, Astypalaia Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Astypalaia Airport",
              "phoneticLabel": null,
              "searchText": "jty astypalaia airport greece astypalaia",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "RHO",
              "cityName": "Rhodes",
              "code": "RHO",
              "countryName": "Greece",
              "displayText": "Rhodes, Rhodes International Airport, \"Diagoras\"",
              "isDestination": true,
              "isOrigin": true,
              "label": "Rhodes International Airport, \"Diagoras\"",
              "phoneticLabel": null,
              "searchText": "rho rhodes international airport, \"diagoras\" greece rhodes",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "JTR",
              "cityName": "Santorini - Cyclades",
              "code": "JTR",
              "countryName": "Greece",
              "displayText": "Santorini - Cyclades, Santorini",
              "isDestination": true,
              "isOrigin": true,
              "label": "Santorini",
              "phoneticLabel": null,
              "searchText": "jtr santorini greece santorini - cyclades",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MLO",
              "cityName": "Milos",
              "code": "MLO",
              "countryName": "Greece",
              "displayText": "Milos, Milos Island National Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Milos Island National Airport",
              "phoneticLabel": null,
              "searchText": "mlo milos island national airport greece milos",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PAS",
              "cityName": "Paros",
              "code": "PAS",
              "countryName": "Greece",
              "displayText": "Paros, Paros",
              "isDestination": true,
              "isOrigin": true,
              "label": "Paros",
              "phoneticLabel": null,
              "searchText": "pas paros greece paros",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KVA",
              "cityName": "Kavala",
              "code": "KVA",
              "countryName": "Greece",
              "displayText": "Kavala, Megas Alexandros Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Megas Alexandros Airport",
              "phoneticLabel": null,
              "searchText": "kva megas alexandros airport greece kavala",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "JKH",
              "cityName": "Chios",
              "code": "JKH",
              "countryName": "Greece",
              "displayText": "Chios, Omiros",
              "isDestination": true,
              "isOrigin": true,
              "label": "Omiros",
              "phoneticLabel": null,
              "searchText": "jkh omiros greece chios",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "AXD",
              "cityName": "Alexandroupolis",
              "code": "AXD",
              "countryName": "Greece",
              "displayText": "Alexandroupolis, Dimokritos",
              "isDestination": true,
              "isOrigin": true,
              "label": "Dimokritos",
              "phoneticLabel": null,
              "searchText": "axd dimokritos greece alexandroupolis",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HER",
              "cityName": "Heraklion",
              "code": "HER",
              "countryName": "Greece",
              "displayText": "Heraklion, Nikos Kazantzakis",
              "isDestination": true,
              "isOrigin": true,
              "label": "Nikos Kazantzakis",
              "phoneticLabel": null,
              "searchText": "her nikos kazantzakis greece heraklion",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "EFL",
              "cityName": "Kefallinia",
              "code": "EFL",
              "countryName": "Greece",
              "displayText": "Kefallinia, Kefallinia",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kefallinia",
              "phoneticLabel": null,
              "searchText": "efl kefallinia greece kefallinia",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ZTH",
              "cityName": "Zakinthos Island",
              "code": "ZTH",
              "countryName": "Greece",
              "displayText": "Zakinthos Island, Zakynthos International Airport,",
              "isDestination": true,
              "isOrigin": true,
              "label": "Zakynthos International Airport,",
              "phoneticLabel": null,
              "searchText": "zth zakynthos international airport, greece zakinthos island",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "AOK",
              "cityName": "Karpathos",
              "code": "AOK",
              "countryName": "Greece",
              "displayText": "Karpathos, Karpathos",
              "isDestination": true,
              "isOrigin": true,
              "label": "Karpathos",
              "phoneticLabel": null,
              "searchText": "aok karpathos greece karpathos",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CFU",
              "cityName": "Kerkyra Corfu",
              "code": "CFU",
              "countryName": "Greece",
              "displayText": "Kerkyra Corfu, Ioannis Kapodistrias",
              "isDestination": true,
              "isOrigin": true,
              "label": "Ioannis Kapodistrias",
              "phoneticLabel": null,
              "searchText": "cfu ioannis kapodistrias greece kerkyra corfu",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SMI",
              "cityName": "Samos",
              "code": "SMI",
              "countryName": "Greece",
              "displayText": "Samos, Samos International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Samos International Airport",
              "phoneticLabel": null,
              "searchText": "smi samos international airport greece samos",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "IOA",
              "cityName": "Ioannina",
              "code": "IOA",
              "countryName": "Greece",
              "displayText": "Ioannina, Ioannina National Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Ioannina National Airport",
              "phoneticLabel": null,
              "searchText": "ioa ioannina national airport greece ioannina",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MJT",
              "cityName": "Mytilini",
              "code": "MJT",
              "countryName": "Greece",
              "displayText": "Mytilini, Odysseas Elytis",
              "isDestination": true,
              "isOrigin": true,
              "label": "Odysseas Elytis",
              "phoneticLabel": null,
              "searchText": "mjt odysseas elytis greece mytilini",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "JSY",
              "cityName": "Syros - Cyclades",
              "code": "JSY",
              "countryName": "Greece",
              "displayText": "Syros - Cyclades, Syros Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Syros Airport",
              "phoneticLabel": null,
              "searchText": "jsy syros airport greece syros - cyclades",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KLX",
              "cityName": "Kalamata",
              "code": "KLX",
              "countryName": "Greece",
              "displayText": "Kalamata, Kalamata",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kalamata",
              "phoneticLabel": null,
              "searchText": "klx kalamata greece kalamata",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "JMK",
              "cityName": "Mykonos - Cyclades",
              "code": "JMK",
              "countryName": "Greece",
              "displayText": "Mykonos - Cyclades, Mykonos",
              "isDestination": true,
              "isOrigin": true,
              "label": "Mykonos",
              "phoneticLabel": null,
              "searchText": "jmk mykonos greece mykonos - cyclades",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KGS",
              "cityName": "Kos",
              "code": "KGS",
              "countryName": "Greece",
              "displayText": "Kos, Ippokratis",
              "isDestination": true,
              "isOrigin": true,
              "label": "Ippokratis",
              "phoneticLabel": null,
              "searchText": "kgs ippokratis greece kos",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "JSI",
              "cityName": "Skiathos",
              "code": "JSI",
              "countryName": "Greece",
              "displayText": "Skiathos, Skiathos Island National Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Skiathos Island National Airport",
              "phoneticLabel": null,
              "searchText": "jsi skiathos island national airport greece skiathos",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ATH",
              "cityName": "Athens",
              "code": "ATH",
              "countryName": "Greece",
              "displayText": "Athens, Athens International E Venizelos",
              "isDestination": true,
              "isOrigin": true,
              "label": "Athens International E Venizelos",
              "phoneticLabel": null,
              "searchText": "ath athens international e venizelos greece athens",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SKU",
              "cityName": "Skyros",
              "code": "SKU",
              "countryName": "Greece",
              "displayText": "Skyros, Skyros Airport",
              "isDestination": false,
              "isOrigin": true,
              "label": "Skyros Airport",
              "phoneticLabel": null,
              "searchText": "sku skyros airport greece skyros",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PVK",
              "cityName": "Preveza Lefkada",
              "code": "PVK",
              "countryName": "Greece",
              "displayText": "Preveza Lefkada, Aktion",
              "isDestination": true,
              "isOrigin": true,
              "label": "Aktion",
              "phoneticLabel": null,
              "searchText": "pvk aktion greece preveza lefkada",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "VOL",
              "cityName": "Volos",
              "code": "VOL",
              "countryName": "Greece",
              "displayText": "Volos, Nea Anchialos",
              "isDestination": true,
              "isOrigin": true,
              "label": "Nea Anchialos",
              "phoneticLabel": null,
              "searchText": "vol nea anchialos greece volos",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SLL",
              "cityName": "Salalah",
              "code": "SLL",
              "countryName": "Oman",
              "displayText": "Salalah, Salalah Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Salalah Airport",
              "phoneticLabel": null,
              "searchText": "sll salalah airport oman salalah",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MCT",
              "cityName": "Muscat",
              "code": "MCT",
              "countryName": "Oman",
              "displayText": "Muscat, Muscat International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Muscat International Airport",
              "phoneticLabel": null,
              "searchText": "mct muscat international airport oman muscat",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LET",
              "cityName": "Leticia",
              "code": "LET",
              "countryName": "Colombia",
              "displayText": "Leticia, Leticia Alfredo V. Cobo International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Leticia Alfredo V. Cobo International Airport",
              "phoneticLabel": null,
              "searchText": "let leticia alfredo v. cobo international airport colombia leticia",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "EYP",
              "cityName": "El Yopal",
              "code": "EYP",
              "countryName": "Colombia",
              "displayText": "El Yopal, Yopal El Alcaravan Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Yopal El Alcaravan Airport",
              "phoneticLabel": null,
              "searchText": "eyp yopal el alcaravan airport colombia el yopal",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NVA",
              "cityName": "Neiva",
              "code": "NVA",
              "countryName": "Colombia",
              "displayText": "Neiva, La Marguita",
              "isDestination": true,
              "isOrigin": true,
              "label": "La Marguita",
              "phoneticLabel": null,
              "searchText": "nva la marguita colombia neiva",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "EJA",
              "cityName": "Barrancabermeja",
              "code": "EJA",
              "countryName": "Colombia",
              "displayText": "Barrancabermeja, Variguies",
              "isDestination": true,
              "isOrigin": true,
              "label": "Variguies",
              "phoneticLabel": null,
              "searchText": "eja variguies colombia barrancabermeja",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CUC",
              "cityName": "Cucuta",
              "code": "CUC",
              "countryName": "Colombia",
              "displayText": "Cucuta, Camilo Dazo",
              "isDestination": true,
              "isOrigin": true,
              "label": "Camilo Dazo",
              "phoneticLabel": null,
              "searchText": "cuc camilo dazo colombia cucuta",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SMR",
              "cityName": "Santa Marta",
              "code": "SMR",
              "countryName": "Colombia",
              "displayText": "Santa Marta, Simon Bolivar",
              "isDestination": true,
              "isOrigin": true,
              "label": "Simon Bolivar",
              "phoneticLabel": null,
              "searchText": "smr simon bolivar colombia santa marta",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "AXM",
              "cityName": "Armenia",
              "code": "AXM",
              "countryName": "Colombia",
              "displayText": "Armenia, El Eden",
              "isDestination": true,
              "isOrigin": true,
              "label": "El Eden",
              "phoneticLabel": null,
              "searchText": "axm el eden colombia armenia",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PPN",
              "cityName": "Popayan",
              "code": "PPN",
              "countryName": "Colombia",
              "displayText": "Popayan, Guillermo L Valencia",
              "isDestination": true,
              "isOrigin": true,
              "label": "Guillermo L Valencia",
              "phoneticLabel": null,
              "searchText": "ppn guillermo l valencia colombia popayan",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MDE",
              "cityName": "Medellin",
              "code": "MDE",
              "countryName": "Colombia",
              "displayText": "Medellin, José María Córdova International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "José María Córdova International Airport",
              "phoneticLabel": null,
              "searchText": "mde josé maría córdova international airport colombia medellin",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "VVC",
              "cityName": "Villavicencio",
              "code": "VVC",
              "countryName": "Colombia",
              "displayText": "Villavicencio, Villavivencio Vanguardia Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Villavivencio Vanguardia Airport",
              "phoneticLabel": null,
              "searchText": "vvc villavivencio vanguardia airport colombia villavicencio",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "VUP",
              "cityName": "Valledupar",
              "code": "VUP",
              "countryName": "Colombia",
              "displayText": "Valledupar, Valledupar Alfonso Lopez Pumarejo Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Valledupar Alfonso Lopez Pumarejo Airport",
              "phoneticLabel": null,
              "searchText": "vup valledupar alfonso lopez pumarejo airport colombia valledupar",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "IBE",
              "cityName": "Ibague",
              "code": "IBE",
              "countryName": "Colombia",
              "displayText": "Ibague, Ibague",
              "isDestination": true,
              "isOrigin": true,
              "label": "Ibague",
              "phoneticLabel": null,
              "searchText": "ibe ibague colombia ibague",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BAQ",
              "cityName": "Barranquilla",
              "code": "BAQ",
              "countryName": "Colombia",
              "displayText": "Barranquilla, Ernesto Cortissoz",
              "isDestination": true,
              "isOrigin": true,
              "label": "Ernesto Cortissoz",
              "phoneticLabel": null,
              "searchText": "baq ernesto cortissoz colombia barranquilla",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PSO",
              "cityName": "Pasto",
              "code": "PSO",
              "countryName": "Colombia",
              "displayText": "Pasto, Pasto Antonio Narino Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Pasto Antonio Narino Airport",
              "phoneticLabel": null,
              "searchText": "pso pasto antonio narino airport colombia pasto",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CTG",
              "cityName": "Cartagena",
              "code": "CTG",
              "countryName": "Colombia",
              "displayText": "Cartagena, Rafael Nunez",
              "isDestination": true,
              "isOrigin": true,
              "label": "Rafael Nunez",
              "phoneticLabel": null,
              "searchText": "ctg rafael nunez colombia cartagena",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ADZ",
              "cityName": "San Andres - Colombia",
              "code": "ADZ",
              "countryName": "Colombia",
              "displayText": "San Andres - Colombia, San Andres Island",
              "isDestination": true,
              "isOrigin": true,
              "label": "San Andres Island",
              "phoneticLabel": null,
              "searchText": "adz san andres island colombia san andres - colombia",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "RCH",
              "cityName": "Riohacha",
              "code": "RCH",
              "countryName": "Colombia",
              "displayText": "Riohacha, Riohacha Almirante Padilla Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Riohacha Almirante Padilla Airport",
              "phoneticLabel": null,
              "searchText": "rch riohacha almirante padilla airport colombia riohacha",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BGA",
              "cityName": "Bucaramanga",
              "code": "BGA",
              "countryName": "Colombia",
              "displayText": "Bucaramanga, Palo Negro",
              "isDestination": true,
              "isOrigin": true,
              "label": "Palo Negro",
              "phoneticLabel": null,
              "searchText": "bga palo negro colombia bucaramanga",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PEI",
              "cityName": "Pereira",
              "code": "PEI",
              "countryName": "Colombia",
              "displayText": "Pereira, Matecana",
              "isDestination": true,
              "isOrigin": true,
              "label": "Matecana",
              "phoneticLabel": null,
              "searchText": "pei matecana colombia pereira",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MTR",
              "cityName": "Monteria",
              "code": "MTR",
              "countryName": "Colombia",
              "displayText": "Monteria, Los Garzones Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Los Garzones Airport",
              "phoneticLabel": null,
              "searchText": "mtr los garzones airport colombia monteria",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CLO",
              "cityName": "Cali",
              "code": "CLO",
              "countryName": "Colombia",
              "displayText": "Cali, Alfonso B Aragon",
              "isDestination": true,
              "isOrigin": true,
              "label": "Alfonso B Aragon",
              "phoneticLabel": null,
              "searchText": "clo alfonso b aragon colombia cali",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BOG",
              "cityName": "Bogota",
              "code": "BOG",
              "countryName": "Colombia",
              "displayText": "Bogota, El Dorado International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "El Dorado International Airport",
              "phoneticLabel": null,
              "searchText": "bog el dorado international airport colombia bogota",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "OSR",
              "cityName": "Ostrava",
              "code": "OSR",
              "countryName": "Czech Republic",
              "displayText": "Ostrava, Leos Janacek",
              "isDestination": true,
              "isOrigin": true,
              "label": "Leos Janacek",
              "phoneticLabel": null,
              "searchText": "osr leos janacek czech republic ostrava",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PRG",
              "cityName": "Prague",
              "code": "PRG",
              "countryName": "Czech Republic",
              "displayText": "Prague, Václav Havel Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Václav Havel Airport",
              "phoneticLabel": null,
              "searchText": "prg václav havel airport czech republic prague",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SEZ",
              "cityName": "Mahe Island",
              "code": "SEZ",
              "countryName": "Seychelles",
              "displayText": "Mahe Island, Seychelles International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Seychelles International Airport",
              "phoneticLabel": null,
              "searchText": "sez seychelles international airport seychelles mahe island",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PRI",
              "cityName": "Praslin Island",
              "code": "PRI",
              "countryName": "Seychelles",
              "displayText": "Praslin Island, Praslin Island",
              "isDestination": true,
              "isOrigin": true,
              "label": "Praslin Island",
              "phoneticLabel": null,
              "searchText": "pri praslin island seychelles praslin island",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ANR",
              "cityName": "Antwerp",
              "code": "ANR",
              "countryName": "Belgium",
              "displayText": "Antwerp",
              "isDestination": true,
              "isOrigin": true,
              "label": "Antwerp",
              "phoneticLabel": null,
              "searchText": "anr antwerp belgium",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "BRU",
              "cityName": "Brussels",
              "code": "BRU",
              "countryName": "Belgium",
              "displayText": "Brussels",
              "isDestination": true,
              "isOrigin": true,
              "label": "Brussels",
              "phoneticLabel": null,
              "searchText": "bru brussels belgium",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "KGL",
              "cityName": "Kigali",
              "code": "KGL",
              "countryName": "Rwanda",
              "displayText": "Kigali, Kigali International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kigali International Airport",
              "phoneticLabel": null,
              "searchText": "kgl kigali international airport rwanda kigali",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LYR",
              "cityName": "Longyearbyen",
              "code": "LYR",
              "countryName": "Svalbard and Jan Mayen",
              "displayText": "Longyearbyen, Longyearbyen Svalbard Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Longyearbyen Svalbard Airport",
              "phoneticLabel": null,
              "searchText": "lyr longyearbyen svalbard airport svalbard and jan mayen longyearbyen",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MAU",
              "cityName": "Maupiti",
              "code": "MAU",
              "countryName": "French Polynesia",
              "displayText": "Maupiti, Maupiti Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Maupiti Airport",
              "phoneticLabel": null,
              "searchText": "mau maupiti airport french polynesia maupiti",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "XMH",
              "cityName": "Manihi",
              "code": "XMH",
              "countryName": "French Polynesia",
              "displayText": "Manihi, Manihi",
              "isDestination": true,
              "isOrigin": true,
              "label": "Manihi",
              "phoneticLabel": null,
              "searchText": "xmh manihi french polynesia manihi",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "RVV",
              "cityName": "Raivavae",
              "code": "RVV",
              "countryName": "French Polynesia",
              "displayText": "Raivavae, Raivavae Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Raivavae Airport",
              "phoneticLabel": null,
              "searchText": "rvv raivavae airport french polynesia raivavae",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "RMT",
              "cityName": "Rimatara",
              "code": "RMT",
              "countryName": "French Polynesia",
              "displayText": "Rimatara, Rimatara Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Rimatara Airport",
              "phoneticLabel": null,
              "searchText": "rmt rimatara airport french polynesia rimatara",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PPT",
              "cityName": "Papeete Tahiti",
              "code": "PPT",
              "countryName": "French Polynesia",
              "displayText": "Papeete Tahiti, Faaa",
              "isDestination": true,
              "isOrigin": true,
              "label": "Faaa",
              "phoneticLabel": null,
              "searchText": "ppt faaa french polynesia papeete tahiti",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HUH",
              "cityName": "Huahine",
              "code": "HUH",
              "countryName": "French Polynesia",
              "displayText": "Huahine, Fare Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Fare Airport",
              "phoneticLabel": null,
              "searchText": "huh fare airport french polynesia huahine",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "RFP",
              "cityName": "Raiatea",
              "code": "RFP",
              "countryName": "French Polynesia",
              "displayText": "Raiatea, Uturoa Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Uturoa Airport",
              "phoneticLabel": null,
              "searchText": "rfp uturoa airport french polynesia raiatea",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "FAV",
              "cityName": "Fakarava",
              "code": "FAV",
              "countryName": "French Polynesia",
              "displayText": "Fakarava, Fakarava Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Fakarava Airport",
              "phoneticLabel": null,
              "searchText": "fav fakarava airport french polynesia fakarava",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MOZ",
              "cityName": "Moorea",
              "code": "MOZ",
              "countryName": "French Polynesia",
              "displayText": "Moorea, Temae Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Temae Airport",
              "phoneticLabel": null,
              "searchText": "moz temae airport french polynesia moorea",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "RRR",
              "cityName": "Raroia",
              "code": "RRR",
              "countryName": "French Polynesia",
              "displayText": "Raroia, Raroia Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Raroia Airport",
              "phoneticLabel": null,
              "searchText": "rrr raroia airport french polynesia raroia",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "AUQ",
              "cityName": "Hiva Oa",
              "code": "AUQ",
              "countryName": "French Polynesia",
              "displayText": "Hiva Oa, Atuona Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Atuona Airport",
              "phoneticLabel": null,
              "searchText": "auq atuona airport french polynesia hiva oa",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TIH",
              "cityName": "Tikehau",
              "code": "TIH",
              "countryName": "French Polynesia",
              "displayText": "Tikehau, Tikehau",
              "isDestination": true,
              "isOrigin": true,
              "label": "Tikehau",
              "phoneticLabel": null,
              "searchText": "tih tikehau french polynesia tikehau",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TUB",
              "cityName": "Tubuai",
              "code": "TUB",
              "countryName": "French Polynesia",
              "displayText": "Tubuai, Mataura",
              "isDestination": true,
              "isOrigin": true,
              "label": "Mataura",
              "phoneticLabel": null,
              "searchText": "tub mataura french polynesia tubuai",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BOB",
              "cityName": "Bora Bora",
              "code": "BOB",
              "countryName": "French Polynesia",
              "displayText": "Bora Bora, Motu Mute Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Motu Mute Airport",
              "phoneticLabel": null,
              "searchText": "bob motu mute airport french polynesia bora bora",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "GMR",
              "cityName": "Totegegie",
              "code": "GMR",
              "countryName": "French Polynesia",
              "displayText": "Totegegie, Totegegie Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Totegegie Airport",
              "phoneticLabel": null,
              "searchText": "gmr totegegie airport french polynesia totegegie",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "RGI",
              "cityName": "Rangiroa",
              "code": "RGI",
              "countryName": "French Polynesia",
              "displayText": "Rangiroa, Rangiroa Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Rangiroa Airport",
              "phoneticLabel": null,
              "searchText": "rgi rangiroa airport french polynesia rangiroa",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MKP",
              "cityName": "Makemo",
              "code": "MKP",
              "countryName": "French Polynesia",
              "displayText": "Makemo, Makemo Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Makemo Airport",
              "phoneticLabel": null,
              "searchText": "mkp makemo airport french polynesia makemo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "RUR",
              "cityName": "Rurutu",
              "code": "RUR",
              "countryName": "French Polynesia",
              "displayText": "Rurutu, Rurutu Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Rurutu Airport",
              "phoneticLabel": null,
              "searchText": "rur rurutu airport french polynesia rurutu",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NHV",
              "cityName": "Nuku Hiva",
              "code": "NHV",
              "countryName": "French Polynesia",
              "displayText": "Nuku Hiva, Nuku Hiva Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Nuku Hiva Airport",
              "phoneticLabel": null,
              "searchText": "nhv nuku hiva airport french polynesia nuku hiva",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ANU",
              "cityName": "Antigua",
              "code": "ANU",
              "countryName": "Antigua and Barbuda",
              "displayText": "Antigua, V.C. Bird International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "V.C. Bird International Airport",
              "phoneticLabel": null,
              "searchText": "anu v.c. bird international airport antigua and barbuda antigua",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TPE",
              "cityName": "Taipei",
              "code": "TPE",
              "countryName": "Taiwan, China",
              "displayText": "Taipei, Taoyuan International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Taoyuan International Airport",
              "phoneticLabel": null,
              "searchText": "tpe taoyuan international airport taiwan, china taipei",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KHH",
              "cityName": "Kaohsiung",
              "code": "KHH",
              "countryName": "Taiwan, China",
              "displayText": "Kaohsiung, Kaohsiung International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kaohsiung International Airport",
              "phoneticLabel": null,
              "searchText": "khh kaohsiung international airport taiwan, china kaohsiung",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ZNZ",
              "cityName": "Zanzibar",
              "code": "ZNZ",
              "countryName": "Tanzania",
              "displayText": "Zanzibar, Zanzibar Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Zanzibar Airport",
              "phoneticLabel": null,
              "searchText": "znz zanzibar airport tanzania zanzibar",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "DAR",
              "cityName": "Dar es Salaam",
              "code": "DAR",
              "countryName": "Tanzania",
              "displayText": "Dar es Salaam, Dar Es Salaam Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Dar Es Salaam Airport",
              "phoneticLabel": null,
              "searchText": "dar dar es salaam airport tanzania dar es salaam",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MWZ",
              "cityName": "Mwanza",
              "code": "MWZ",
              "countryName": "Tanzania",
              "displayText": "Mwanza, Mwanza",
              "isDestination": true,
              "isOrigin": true,
              "label": "Mwanza",
              "phoneticLabel": null,
              "searchText": "mwz mwanza tanzania mwanza",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BKZ",
              "cityName": "Bukoba",
              "code": "BKZ",
              "countryName": "Tanzania",
              "displayText": "Bukoba, Bukoba Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Bukoba Airport",
              "phoneticLabel": null,
              "searchText": "bkz bukoba airport tanzania bukoba",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MBI",
              "cityName": "Mbeya",
              "code": "MBI",
              "countryName": "Tanzania",
              "displayText": "Mbeya, Mbeya Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Mbeya Airport",
              "phoneticLabel": null,
              "searchText": "mbi mbeya airport tanzania mbeya",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MYW",
              "cityName": "Mtwara",
              "code": "MYW",
              "countryName": "Tanzania",
              "displayText": "Mtwara, Mtwara",
              "isDestination": true,
              "isOrigin": true,
              "label": "Mtwara",
              "phoneticLabel": null,
              "searchText": "myw mtwara tanzania mtwara",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ARK",
              "cityName": "Arusha",
              "code": "ARK",
              "countryName": "Tanzania",
              "displayText": "Arusha, Arusha",
              "isDestination": true,
              "isOrigin": true,
              "label": "Arusha",
              "phoneticLabel": null,
              "searchText": "ark arusha tanzania arusha",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "DOD",
              "cityName": "Dodoma",
              "code": "DOD",
              "countryName": "Tanzania",
              "displayText": "Dodoma, Dodoma Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Dodoma Airport",
              "phoneticLabel": null,
              "searchText": "dod dodoma airport tanzania dodoma",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "JRO",
              "cityName": "Kilimanjaro",
              "code": "JRO",
              "countryName": "Tanzania",
              "displayText": "Kilimanjaro, Kilimanjaro International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kilimanjaro International Airport",
              "phoneticLabel": null,
              "searchText": "jro kilimanjaro international airport tanzania kilimanjaro",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BWN",
              "cityName": "Bandar Seri Begawan",
              "code": "BWN",
              "countryName": "Brunei Darussalam",
              "displayText": "Bandar Seri Begawan, Brunei International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Brunei International Airport",
              "phoneticLabel": null,
              "searchText": "bwn brunei international airport brunei darussalam bandar seri begawan",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "DXB",
              "cityName": "Dubai",
              "code": "DXB",
              "countryName": "United Arab Emirates",
              "displayText": "Dubai",
              "isDestination": true,
              "isOrigin": true,
              "label": "Dubai",
              "phoneticLabel": null,
              "searchText": "dxb dubai united arab emirates",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "DXB",
              "cityName": "Dubai",
              "code": "DXB",
              "countryName": "United Arab Emirates",
              "displayText": "Dubai, Dubai International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Dubai International Airport",
              "phoneticLabel": null,
              "searchText": "dxb dubai international airport united arab emirates dubai",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "DXB",
              "cityName": "Dubai",
              "code": "XNB",
              "countryName": "United Arab Emirates",
              "displayText": "Dubai, Travel Mall Ey Bus Station",
              "isDestination": true,
              "isOrigin": true,
              "label": "Travel Mall Ey Bus Station",
              "phoneticLabel": null,
              "searchText": "xnb travel mall ey bus station united arab emirates dubai",
              "stationType": "BUS_STATION",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "AUH",
              "cityName": "Abu Dhabi",
              "code": "AUH",
              "countryName": "United Arab Emirates",
              "displayText": "Abu Dhabi, Abu Dhabi International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Abu Dhabi International",
              "phoneticLabel": null,
              "searchText": "auh abu dhabi international united arab emirates abu dhabi",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "DZA",
              "cityName": "Dzaoudzi",
              "code": "DZA",
              "countryName": "Mayotte",
              "displayText": "Dzaoudzi, Pamandzi International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Pamandzi International Airport",
              "phoneticLabel": null,
              "searchText": "dza pamandzi international airport mayotte dzaoudzi",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PTY",
              "cityName": "Panama City",
              "code": "PTY",
              "countryName": "Panama",
              "displayText": "Panama City, Tocumen International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Tocumen International Airport",
              "phoneticLabel": null,
              "searchText": "pty tocumen international airport panama panama city",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "DAV",
              "cityName": "David",
              "code": "DAV",
              "countryName": "Panama",
              "displayText": "David, Enrique Malek International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Enrique Malek International Airport",
              "phoneticLabel": null,
              "searchText": "dav enrique malek international airport panama david",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PHC",
              "cityName": "Port Harcourt",
              "code": "PHC",
              "countryName": "Nigeria",
              "displayText": "Port Harcourt, Port Harcourt International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Port Harcourt International Airport",
              "phoneticLabel": null,
              "searchText": "phc port harcourt international airport nigeria port harcourt",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LOS",
              "cityName": "Lagos",
              "code": "LOS",
              "countryName": "Nigeria",
              "displayText": "Lagos, Murtala Mohammed Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Murtala Mohammed Airport",
              "phoneticLabel": null,
              "searchText": "los murtala mohammed airport nigeria lagos",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ABV",
              "cityName": "Abuja",
              "code": "ABV",
              "countryName": "Nigeria",
              "displayText": "Abuja, Nnamdi Azikiwe International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Nnamdi Azikiwe International Airport",
              "phoneticLabel": null,
              "searchText": "abv nnamdi azikiwe international airport nigeria abuja",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SPC",
              "cityName": "Santa Cruz De La Palma",
              "code": "SPC",
              "countryName": "Spain",
              "displayText": "Santa Cruz De La Palma, La Palma",
              "isDestination": true,
              "isOrigin": true,
              "label": "La Palma",
              "phoneticLabel": null,
              "searchText": "spc la palma spain santa cruz de la palma",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "VGO",
              "cityName": "Vigo",
              "code": "VGO",
              "countryName": "Spain",
              "displayText": "Vigo, Vigo",
              "isDestination": true,
              "isOrigin": true,
              "label": "Vigo",
              "phoneticLabel": null,
              "searchText": "vgo vigo spain vigo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LPA",
              "cityName": "Gran Canaria - Canary Islands",
              "code": "LPA",
              "countryName": "Spain",
              "displayText": "Gran Canaria - Canary Islands, Gran Canaria Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Gran Canaria Airport",
              "phoneticLabel": null,
              "searchText": "lpa gran canaria airport spain gran canaria - canary islands",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "GRO",
              "cityName": "Girona",
              "code": "GRO",
              "countryName": "Spain",
              "displayText": "Girona, Costa Brava Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Costa Brava Airport",
              "phoneticLabel": null,
              "searchText": "gro costa brava airport spain girona",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "IBZ",
              "cityName": "Ibiza - Balearic Islands",
              "code": "IBZ",
              "countryName": "Spain",
              "displayText": "Ibiza - Balearic Islands, Ibiza",
              "isDestination": true,
              "isOrigin": true,
              "label": "Ibiza",
              "phoneticLabel": null,
              "searchText": "ibz ibiza spain ibiza - balearic islands",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BIO",
              "cityName": "Bilbao",
              "code": "BIO",
              "countryName": "Spain",
              "displayText": "Bilbao, Bilbao",
              "isDestination": true,
              "isOrigin": true,
              "label": "Bilbao",
              "phoneticLabel": null,
              "searchText": "bio bilbao spain bilbao",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SVQ",
              "cityName": "Sevilla",
              "code": "SVQ",
              "countryName": "Spain",
              "displayText": "Sevilla, San Pablo Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "San Pablo Airport",
              "phoneticLabel": null,
              "searchText": "svq san pablo airport spain sevilla",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LCG",
              "cityName": "A Coruna",
              "code": "LCG",
              "countryName": "Spain",
              "displayText": "A Coruna, A Coruna Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "A Coruna Airport",
              "phoneticLabel": null,
              "searchText": "lcg a coruna airport spain a coruna",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ACE",
              "cityName": "Lanzarote - Canary Islands",
              "code": "ACE",
              "countryName": "Spain",
              "displayText": "Lanzarote - Canary Islands, Lanzarote",
              "isDestination": true,
              "isOrigin": true,
              "label": "Lanzarote",
              "phoneticLabel": null,
              "searchText": "ace lanzarote spain lanzarote - canary islands",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MAD",
              "cityName": "Madrid",
              "code": "MAD",
              "countryName": "Spain",
              "displayText": "Madrid, Barajas International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Barajas International Airport",
              "phoneticLabel": null,
              "searchText": "mad barajas international airport spain madrid",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SCQ",
              "cityName": "Santiago de Compostela",
              "code": "SCQ",
              "countryName": "Spain",
              "displayText": "Santiago de Compostela, Santiago de Compostela Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Santiago de Compostela Airport",
              "phoneticLabel": null,
              "searchText": "scq santiago de compostela airport spain santiago de compostela",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MAH",
              "cityName": "Menorca - Balearic Islands",
              "code": "MAH",
              "countryName": "Spain",
              "displayText": "Menorca - Balearic Islands, Menorca Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Menorca Airport",
              "phoneticLabel": null,
              "searchText": "mah menorca airport spain menorca - balearic islands",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BCN",
              "cityName": "Barcelona",
              "code": "BCN",
              "countryName": "Spain",
              "displayText": "Barcelona, Josep Tarradellas Barcelona-El Prat Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Josep Tarradellas Barcelona-El Prat Airport",
              "phoneticLabel": null,
              "searchText": "bcn josep tarradellas barcelona-el prat airport spain barcelona",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "VLC",
              "cityName": "Valencia",
              "code": "VLC",
              "countryName": "Spain",
              "displayText": "Valencia, Valencia Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Valencia Airport",
              "phoneticLabel": null,
              "searchText": "vlc valencia airport spain valencia",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "FUE",
              "cityName": "Fuerteventura - Canary Islands",
              "code": "FUE",
              "countryName": "Spain",
              "displayText": "Fuerteventura - Canary Islands, Fuerteventura",
              "isDestination": true,
              "isOrigin": true,
              "label": "Fuerteventura",
              "phoneticLabel": null,
              "searchText": "fue fuerteventura spain fuerteventura - canary islands",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ALC",
              "cityName": "Alicante",
              "code": "ALC",
              "countryName": "Spain",
              "displayText": "Alicante, Alicante",
              "isDestination": true,
              "isOrigin": true,
              "label": "Alicante",
              "phoneticLabel": null,
              "searchText": "alc alicante spain alicante",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "AGP",
              "cityName": "Malaga",
              "code": "AGP",
              "countryName": "Spain",
              "displayText": "Malaga, Málaga Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Málaga Airport",
              "phoneticLabel": null,
              "searchText": "agp málaga airport spain malaga",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TCI",
              "cityName": "Tenerife - Canary Islands",
              "code": "TCI",
              "countryName": "Spain",
              "displayText": "Tenerife - Canary Islands",
              "isDestination": true,
              "isOrigin": true,
              "label": "Tenerife - Canary Islands",
              "phoneticLabel": null,
              "searchText": "tci tenerife - canary islands spain",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "TCI",
              "cityName": "Tenerife - Canary Islands",
              "code": "TFN",
              "countryName": "Spain",
              "displayText": "Tenerife - Canary Islands, Norte Los Rodeas Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Norte Los Rodeas Airport",
              "phoneticLabel": null,
              "searchText": "tfn norte los rodeas airport spain tenerife - canary islands",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TCI",
              "cityName": "Tenerife - Canary Islands",
              "code": "TFS",
              "countryName": "Spain",
              "displayText": "Tenerife - Canary Islands, Tenerife Sur",
              "isDestination": true,
              "isOrigin": true,
              "label": "Tenerife Sur",
              "phoneticLabel": null,
              "searchText": "tfs tenerife sur spain tenerife - canary islands",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PMI",
              "cityName": "Palma de Mallorca - Balearic Islands",
              "code": "PMI",
              "countryName": "Spain",
              "displayText": "Palma de Mallorca - Balearic Islands, Palma de Mallorca Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Palma de Mallorca Airport",
              "phoneticLabel": null,
              "searchText": "pmi palma de mallorca airport spain palma de mallorca - balearic islands",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "FIH",
              "cityName": "Kinshasa",
              "code": "FIH",
              "countryName": "Democratic Republic of the Congo",
              "displayText": "Kinshasa, N'Djili",
              "isDestination": true,
              "isOrigin": true,
              "label": "N'Djili",
              "phoneticLabel": null,
              "searchText": "fih n'djili democratic republic of the congo kinshasa",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "FBM",
              "cityName": "Lubumbashi",
              "code": "FBM",
              "countryName": "Democratic Republic of the Congo",
              "displayText": "Lubumbashi, Luano",
              "isDestination": true,
              "isOrigin": true,
              "label": "Luano",
              "phoneticLabel": null,
              "searchText": "fbm luano democratic republic of the congo lubumbashi",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LFW",
              "cityName": "Lome",
              "code": "LFW",
              "countryName": "Togo",
              "displayText": "Lome, Lomé-Tokoin Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Lomé-Tokoin Airport",
              "phoneticLabel": null,
              "searchText": "lfw lomé-tokoin airport togo lome",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "FDF",
              "cityName": "Fort de France",
              "code": "FDF",
              "countryName": "Martinique",
              "displayText": "Fort de France, Martinique Aimé Césaire",
              "isDestination": true,
              "isOrigin": true,
              "label": "Martinique Aimé Césaire",
              "phoneticLabel": null,
              "searchText": "fdf martinique aimé césaire martinique fort de france",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "RRG",
              "cityName": "Rodrigues Island",
              "code": "RRG",
              "countryName": "Mauritius",
              "displayText": "Rodrigues Island, Plaine Corail Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Plaine Corail Airport",
              "phoneticLabel": null,
              "searchText": "rrg plaine corail airport mauritius rodrigues island",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MRU",
              "cityName": "Mauritius",
              "code": "MRU",
              "countryName": "Mauritius",
              "displayText": "Mauritius, Sir Seewoosagur",
              "isDestination": true,
              "isOrigin": true,
              "label": "Sir Seewoosagur",
              "phoneticLabel": null,
              "searchText": "mru sir seewoosagur mauritius mauritius",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "DAC",
              "cityName": "Dhaka",
              "code": "DAC",
              "countryName": "Bangladesh",
              "displayText": "Dhaka, Hazrat Shahjalal International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Hazrat Shahjalal International",
              "phoneticLabel": null,
              "searchText": "dac hazrat shahjalal international bangladesh dhaka",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "VAR",
              "cityName": "Varna",
              "code": "VAR",
              "countryName": "Bulgaria",
              "displayText": "Varna, Varna Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Varna Airport",
              "phoneticLabel": null,
              "searchText": "var varna airport bulgaria varna",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SOF",
              "cityName": "Sofia",
              "code": "SOF",
              "countryName": "Bulgaria",
              "displayText": "Sofia, Sofia International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Sofia International Airport",
              "phoneticLabel": null,
              "searchText": "sof sofia international airport bulgaria sofia",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LVI",
              "cityName": "Livingstone",
              "code": "LVI",
              "countryName": "Zambia",
              "displayText": "Livingstone, Livingstone Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Livingstone Airport",
              "phoneticLabel": null,
              "searchText": "lvi livingstone airport zambia livingstone",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LUN",
              "cityName": "Lusaka",
              "code": "LUN",
              "countryName": "Zambia",
              "displayText": "Lusaka, Lusaka International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Lusaka International Airport",
              "phoneticLabel": null,
              "searchText": "lun lusaka international airport zambia lusaka",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NLA",
              "cityName": "Ndola",
              "code": "NLA",
              "countryName": "Zambia",
              "displayText": "Ndola, Ndola",
              "isDestination": true,
              "isOrigin": true,
              "label": "Ndola",
              "phoneticLabel": null,
              "searchText": "nla ndola zambia ndola",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SID",
              "cityName": "Sal",
              "code": "SID",
              "countryName": "Cape Verde",
              "displayText": "Sal, Amilcar Cabral International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Amilcar Cabral International Airport",
              "phoneticLabel": null,
              "searchText": "sid amilcar cabral international airport cape verde sal",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "RAI",
              "cityName": "Praia",
              "code": "RAI",
              "countryName": "Cape Verde",
              "displayText": "Praia, Praia International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Praia International Airport",
              "phoneticLabel": null,
              "searchText": "rai praia international airport cape verde praia",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "VXE",
              "cityName": "Sao Vicente Island",
              "code": "VXE",
              "countryName": "Cape Verde",
              "displayText": "Sao Vicente Island, Sao Pedro Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Sao Pedro Airport",
              "phoneticLabel": null,
              "searchText": "vxe sao pedro airport cape verde sao vicente island",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BVC",
              "cityName": "Boa Vista",
              "code": "BVC",
              "countryName": "Cape Verde",
              "displayText": "Boa Vista, Rabil",
              "isDestination": true,
              "isOrigin": true,
              "label": "Rabil",
              "phoneticLabel": null,
              "searchText": "bvc rabil cape verde boa vista",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HRE",
              "cityName": "Harare",
              "code": "HRE",
              "countryName": "Zimbabwe",
              "displayText": "Harare, International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "International Airport",
              "phoneticLabel": null,
              "searchText": "hre international airport zimbabwe harare",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "VFA",
              "cityName": "Victoria Falls",
              "code": "VFA",
              "countryName": "Zimbabwe",
              "displayText": "Victoria Falls, Victoria Falls",
              "isDestination": true,
              "isOrigin": true,
              "label": "Victoria Falls",
              "phoneticLabel": null,
              "searchText": "vfa victoria falls zimbabwe victoria falls",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BUQ",
              "cityName": "Bulawayo",
              "code": "BUQ",
              "countryName": "Zimbabwe",
              "displayText": "Bulawayo, Joshua Mqabuko Nkomo International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Joshua Mqabuko Nkomo International Airport",
              "phoneticLabel": null,
              "searchText": "buq joshua mqabuko nkomo international airport zimbabwe bulawayo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "POR",
              "cityName": "Pori",
              "code": "POR",
              "countryName": "Finland",
              "displayText": "Pori, Pori",
              "isDestination": true,
              "isOrigin": true,
              "label": "Pori",
              "phoneticLabel": null,
              "searchText": "por pori finland pori",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TMP",
              "cityName": "Tampere",
              "code": "TMP",
              "countryName": "Finland",
              "displayText": "Tampere, Tampere-Pirkkala Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Tampere-Pirkkala Airport",
              "phoneticLabel": null,
              "searchText": "tmp tampere-pirkkala airport finland tampere",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "VAA",
              "cityName": "Vaasa",
              "code": "VAA",
              "countryName": "Finland",
              "displayText": "Vaasa, Vaasa Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Vaasa Airport",
              "phoneticLabel": null,
              "searchText": "vaa vaasa airport finland vaasa",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "IVL",
              "cityName": "Ivalo",
              "code": "IVL",
              "countryName": "Finland",
              "displayText": "Ivalo, Ivalo",
              "isDestination": true,
              "isOrigin": true,
              "label": "Ivalo",
              "phoneticLabel": null,
              "searchText": "ivl ivalo finland ivalo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KAO",
              "cityName": "Kuusamo",
              "code": "KAO",
              "countryName": "Finland",
              "displayText": "Kuusamo, Kuusamo",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kuusamo",
              "phoneticLabel": null,
              "searchText": "kao kuusamo finland kuusamo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TKU",
              "cityName": "Turku",
              "code": "TKU",
              "countryName": "Finland",
              "displayText": "Turku, Turku Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Turku Airport",
              "phoneticLabel": null,
              "searchText": "tku turku airport finland turku",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KTT",
              "cityName": "Kittila",
              "code": "KTT",
              "countryName": "Finland",
              "displayText": "Kittila, Kittila",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kittila",
              "phoneticLabel": null,
              "searchText": "ktt kittila finland kittila",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "OUL",
              "cityName": "Oulu",
              "code": "OUL",
              "countryName": "Finland",
              "displayText": "Oulu, Oulu",
              "isDestination": true,
              "isOrigin": true,
              "label": "Oulu",
              "phoneticLabel": null,
              "searchText": "oul oulu finland oulu",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MHQ",
              "cityName": "Mariehamn",
              "code": "MHQ",
              "countryName": "Finland",
              "displayText": "Mariehamn, Mariehamn",
              "isDestination": true,
              "isOrigin": true,
              "label": "Mariehamn",
              "phoneticLabel": null,
              "searchText": "mhq mariehamn finland mariehamn",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HEL",
              "cityName": "Helsinki",
              "code": "HEL",
              "countryName": "Finland",
              "displayText": "Helsinki, Helsinki-Vantaa",
              "isDestination": true,
              "isOrigin": true,
              "label": "Helsinki-Vantaa",
              "phoneticLabel": null,
              "searchText": "hel helsinki-vantaa finland helsinki",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "RVN",
              "cityName": "Rovaniemi",
              "code": "RVN",
              "countryName": "Finland",
              "displayText": "Rovaniemi, Rovaniemi Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Rovaniemi Airport",
              "phoneticLabel": null,
              "searchText": "rvn rovaniemi airport finland rovaniemi",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KUO",
              "cityName": "Kuopio",
              "code": "KUO",
              "countryName": "Finland",
              "displayText": "Kuopio, Kuopio",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kuopio",
              "phoneticLabel": null,
              "searchText": "kuo kuopio finland kuopio",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "FRU",
              "cityName": "Bishkek",
              "code": "FRU",
              "countryName": "Kyrgyzstan",
              "displayText": "Bishkek, Manas International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Manas International Airport",
              "phoneticLabel": null,
              "searchText": "fru manas international airport kyrgyzstan bishkek",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "FTU",
              "cityName": "Tolanaro",
              "code": "FTU",
              "countryName": "Madagascar",
              "displayText": "Tolanaro, Marillac Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Marillac Airport",
              "phoneticLabel": null,
              "searchText": "ftu marillac airport madagascar tolanaro",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SMS",
              "cityName": "Sainte Marie",
              "code": "SMS",
              "countryName": "Madagascar",
              "displayText": "Sainte Marie, Sainte Marie Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Sainte Marie Airport",
              "phoneticLabel": null,
              "searchText": "sms sainte marie airport madagascar sainte marie",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NOS",
              "cityName": "Nosy Be",
              "code": "NOS",
              "countryName": "Madagascar",
              "displayText": "Nosy Be, Nosy-Be Fascene Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Nosy-Be Fascene Airport",
              "phoneticLabel": null,
              "searchText": "nos nosy-be fascene airport madagascar nosy be",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TLE",
              "cityName": "Toliara",
              "code": "TLE",
              "countryName": "Madagascar",
              "displayText": "Toliara, Toliara Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Toliara Airport",
              "phoneticLabel": null,
              "searchText": "tle toliara airport madagascar toliara",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "DIE",
              "cityName": "Antsiranana",
              "code": "DIE",
              "countryName": "Madagascar",
              "displayText": "Antsiranana, Arrachart Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Arrachart Airport",
              "phoneticLabel": null,
              "searchText": "die arrachart airport madagascar antsiranana",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TNR",
              "cityName": "Antananarivo",
              "code": "TNR",
              "countryName": "Madagascar",
              "displayText": "Antananarivo, Antananarivo",
              "isDestination": true,
              "isOrigin": true,
              "label": "Antananarivo",
              "phoneticLabel": null,
              "searchText": "tnr antananarivo madagascar antananarivo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "WMN",
              "cityName": "Maroantsetra",
              "code": "WMN",
              "countryName": "Madagascar",
              "displayText": "Maroantsetra, Maroantsetra Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Maroantsetra Airport",
              "phoneticLabel": null,
              "searchText": "wmn maroantsetra airport madagascar maroantsetra",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MOQ",
              "cityName": "Morondava",
              "code": "MOQ",
              "countryName": "Madagascar",
              "displayText": "Morondava, Morondava Airport",
              "isDestination": true,
              "isOrigin": false,
              "label": "Morondava Airport",
              "phoneticLabel": null,
              "searchText": "moq morondava airport madagascar morondava",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SVB",
              "cityName": "Sambava",
              "code": "SVB",
              "countryName": "Madagascar",
              "displayText": "Sambava, Sambava Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Sambava Airport",
              "phoneticLabel": null,
              "searchText": "svb sambava airport madagascar sambava",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MJN",
              "cityName": "Mahajanga",
              "code": "MJN",
              "countryName": "Madagascar",
              "displayText": "Mahajanga, Philibert Tsiranana Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Philibert Tsiranana Airport",
              "phoneticLabel": null,
              "searchText": "mjn philibert tsiranana airport madagascar mahajanga",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TMM",
              "cityName": "Toamasina",
              "code": "TMM",
              "countryName": "Madagascar",
              "displayText": "Toamasina, Toamasina Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Toamasina Airport",
              "phoneticLabel": null,
              "searchText": "tmm toamasina airport madagascar toamasina",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MUB",
              "cityName": "Maun",
              "code": "MUB",
              "countryName": "Botswana",
              "displayText": "Maun, Maun Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Maun Airport",
              "phoneticLabel": null,
              "searchText": "mub maun airport botswana maun",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "GBE",
              "cityName": "Gaborone",
              "code": "GBE",
              "countryName": "Botswana",
              "displayText": "Gaborone, Sir Seretse Khama International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Sir Seretse Khama International Airport",
              "phoneticLabel": null,
              "searchText": "gbe sir seretse khama international airport botswana gaborone",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BBK",
              "cityName": "Kasane",
              "code": "BBK",
              "countryName": "Botswana",
              "displayText": "Kasane, Kasane Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kasane Airport",
              "phoneticLabel": null,
              "searchText": "bbk kasane airport botswana kasane",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "FSP",
              "cityName": "Saint Pierre",
              "code": "FSP",
              "countryName": "Saint Pierre and Miquelon",
              "displayText": "Saint Pierre, St. Pierre",
              "isDestination": true,
              "isOrigin": true,
              "label": "St. Pierre",
              "phoneticLabel": null,
              "searchText": "fsp st. pierre saint pierre and miquelon saint pierre",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ZHF",
              "cityName": "Fribourg",
              "code": "ZHF",
              "countryName": "Switzerland",
              "displayText": "Fribourg, Fribourg Train Station",
              "isDestination": true,
              "isOrigin": true,
              "label": "Fribourg Train Station",
              "phoneticLabel": null,
              "searchText": "zhf fribourg train station switzerland fribourg",
              "stationType": "RAILWAY_STATION",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "QGL",
              "cityName": "Saint Gallen",
              "code": "QGL",
              "countryName": "Switzerland",
              "displayText": "Saint Gallen, St. Gallen Train Station",
              "isDestination": true,
              "isOrigin": true,
              "label": "St. Gallen Train Station",
              "phoneticLabel": null,
              "searchText": "qgl st. gallen train station switzerland saint gallen",
              "stationType": "RAILWAY_STATION",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BRN",
              "cityName": "Bern",
              "code": "ZDJ",
              "countryName": "Switzerland",
              "displayText": "Bern, Berne Train Station",
              "isDestination": true,
              "isOrigin": true,
              "label": "Berne Train Station",
              "phoneticLabel": null,
              "searchText": "zdj berne train station switzerland bern",
              "stationType": "RAILWAY_STATION",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ZRH",
              "cityName": "Zurich",
              "code": "ZRH",
              "countryName": "Switzerland",
              "displayText": "Zurich, Zurich Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Zurich Airport",
              "phoneticLabel": null,
              "searchText": "zrh zurich airport switzerland zurich",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ZDK",
              "cityName": "Biel Bienne",
              "code": "ZDK",
              "countryName": "Switzerland",
              "displayText": "Biel Bienne, Biel/Bienne Train Station",
              "isDestination": true,
              "isOrigin": true,
              "label": "Biel/Bienne Train Station",
              "phoneticLabel": null,
              "searchText": "zdk biel/bienne train station switzerland biel bienne",
              "stationType": "RAILWAY_STATION",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ZTK",
              "cityName": "Thun",
              "code": "ZTK",
              "countryName": "Switzerland",
              "displayText": "Thun, Thun Train Station",
              "isDestination": true,
              "isOrigin": true,
              "label": "Thun Train Station",
              "phoneticLabel": null,
              "searchText": "ztk thun train station switzerland thun",
              "stationType": "RAILWAY_STATION",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BSL",
              "cityName": "Basel",
              "code": "BSL",
              "countryName": "Switzerland",
              "displayText": "Basel, EuroAirport Basel Mulhouse",
              "isDestination": true,
              "isOrigin": true,
              "label": "EuroAirport Basel Mulhouse",
              "phoneticLabel": null,
              "searchText": "bsl euroairport basel mulhouse switzerland basel",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "GVA",
              "cityName": "Geneva",
              "code": "GVA",
              "countryName": "Switzerland",
              "displayText": "Geneva, Geneva Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Geneva Airport",
              "phoneticLabel": null,
              "searchText": "gva geneva airport switzerland geneva",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "QLS",
              "cityName": "Lausanne",
              "code": "QLS",
              "countryName": "Switzerland",
              "displayText": "Lausanne, Lausanne Train Station",
              "isDestination": true,
              "isOrigin": true,
              "label": "Lausanne Train Station",
              "phoneticLabel": null,
              "searchText": "qls lausanne train station switzerland lausanne",
              "stationType": "RAILWAY_STATION",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "FDH",
              "cityName": "Friedrichshafen",
              "code": "FDH",
              "countryName": "Germany",
              "displayText": "Friedrichshafen, Friedrichshafen",
              "isDestination": true,
              "isOrigin": true,
              "label": "Friedrichshafen",
              "phoneticLabel": null,
              "searchText": "fdh friedrichshafen germany friedrichshafen",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "STR",
              "cityName": "Stuttgart",
              "code": "STR",
              "countryName": "Germany",
              "displayText": "Stuttgart, Stuttgart Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Stuttgart Airport",
              "phoneticLabel": null,
              "searchText": "str stuttgart airport germany stuttgart",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MUC",
              "cityName": "Munich",
              "code": "MUC",
              "countryName": "Germany",
              "displayText": "Munich, Munich International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Munich International Airport",
              "phoneticLabel": null,
              "searchText": "muc munich international airport germany munich",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "FRA",
              "cityName": "Frankfurt/Main",
              "code": "FRA",
              "countryName": "Germany",
              "displayText": "Frankfurt/Main, Frankfurt Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Frankfurt Airport",
              "phoneticLabel": null,
              "searchText": "fra frankfurt airport germany frankfurt/main",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HAJ",
              "cityName": "Hannover",
              "code": "HAJ",
              "countryName": "Germany",
              "displayText": "Hannover, Hannover Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Hannover Airport",
              "phoneticLabel": null,
              "searchText": "haj hannover airport germany hannover",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "DUS",
              "cityName": "Düsseldorf",
              "code": "DUS",
              "countryName": "Germany",
              "displayText": "Düsseldorf, International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "International Airport",
              "phoneticLabel": null,
              "searchText": "dus international airport germany düsseldorf",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HAM",
              "cityName": "Hamburg",
              "code": "HAM",
              "countryName": "Germany",
              "displayText": "Hamburg, Hamburg Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Hamburg Airport",
              "phoneticLabel": null,
              "searchText": "ham hamburg airport germany hamburg",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BRE",
              "cityName": "Bremen",
              "code": "BRE",
              "countryName": "Germany",
              "displayText": "Bremen, Bremen Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Bremen Airport",
              "phoneticLabel": null,
              "searchText": "bre bremen airport germany bremen",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NUE",
              "cityName": "Nuremberg",
              "code": "NUE",
              "countryName": "Germany",
              "displayText": "Nuremberg, Nuremberg Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Nuremberg Airport",
              "phoneticLabel": null,
              "searchText": "nue nuremberg airport germany nuremberg",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BER",
              "cityName": "Berlin",
              "code": "BER",
              "countryName": "Germany",
              "displayText": "Berlin, Berlin Brandenburg Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Berlin Brandenburg Airport",
              "phoneticLabel": null,
              "searchText": "ber berlin brandenburg airport germany berlin",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HAV",
              "cityName": "Havana",
              "code": "HAV",
              "countryName": "Cuba",
              "displayText": "Havana, Jose Marti International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Jose Marti International",
              "phoneticLabel": null,
              "searchText": "hav jose marti international cuba havana",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HOG",
              "cityName": "Holguin",
              "code": "HOG",
              "countryName": "Cuba",
              "displayText": "Holguin, Frank Pais",
              "isDestination": true,
              "isOrigin": true,
              "label": "Frank Pais",
              "phoneticLabel": null,
              "searchText": "hog frank pais cuba holguin",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TUU",
              "cityName": "Tabuk",
              "code": "TUU",
              "countryName": "Saudi Arabia",
              "displayText": "Tabuk, Tabuk Regional Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Tabuk Regional Airport",
              "phoneticLabel": null,
              "searchText": "tuu tabuk regional airport saudi arabia tabuk",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HAS",
              "cityName": "Hail",
              "code": "HAS",
              "countryName": "Saudi Arabia",
              "displayText": "Hail, Hail Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Hail Airport",
              "phoneticLabel": null,
              "searchText": "has hail airport saudi arabia hail",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "GIZ",
              "cityName": "Gizan",
              "code": "GIZ",
              "countryName": "Saudi Arabia",
              "displayText": "Gizan, Gizan Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Gizan Airport",
              "phoneticLabel": null,
              "searchText": "giz gizan airport saudi arabia gizan",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "JED",
              "cityName": "Jeddah",
              "code": "JED",
              "countryName": "Saudi Arabia",
              "displayText": "Jeddah, King Abdulaziz International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "King Abdulaziz International Airport",
              "phoneticLabel": null,
              "searchText": "jed king abdulaziz international airport saudi arabia jeddah",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "RAE",
              "cityName": "Arar",
              "code": "RAE",
              "countryName": "Saudi Arabia",
              "displayText": "Arar, Arar Domestic Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Arar Domestic Airport",
              "phoneticLabel": null,
              "searchText": "rae arar domestic airport saudi arabia arar",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "EAM",
              "cityName": "Nejran",
              "code": "EAM",
              "countryName": "Saudi Arabia",
              "displayText": "Nejran, Najran Domestic Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Najran Domestic Airport",
              "phoneticLabel": null,
              "searchText": "eam najran domestic airport saudi arabia nejran",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "DMM",
              "cityName": "Dammam Dhahran",
              "code": "DMM",
              "countryName": "Saudi Arabia",
              "displayText": "Dammam Dhahran, King Fahad International",
              "isDestination": true,
              "isOrigin": true,
              "label": "King Fahad International",
              "phoneticLabel": null,
              "searchText": "dmm king fahad international saudi arabia dammam dhahran",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ELQ",
              "cityName": "Gassim",
              "code": "ELQ",
              "countryName": "Saudi Arabia",
              "displayText": "Gassim, Gassim Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Gassim Airport",
              "phoneticLabel": null,
              "searchText": "elq gassim airport saudi arabia gassim",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YNB",
              "cityName": "Yanbu Al Bahr",
              "code": "YNB",
              "countryName": "Saudi Arabia",
              "displayText": "Yanbu Al Bahr, Yanbu al Bahr Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Yanbu al Bahr Airport",
              "phoneticLabel": null,
              "searchText": "ynb yanbu al bahr airport saudi arabia yanbu al bahr",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MED",
              "cityName": "Madinah",
              "code": "MED",
              "countryName": "Saudi Arabia",
              "displayText": "Madinah, Madinah Mohammad Bin Abdulaziz International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Madinah Mohammad Bin Abdulaziz International Airport",
              "phoneticLabel": null,
              "searchText": "med madinah mohammad bin abdulaziz international airport saudi arabia madinah",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "RUH",
              "cityName": "Riyadh",
              "code": "RUH",
              "countryName": "Saudi Arabia",
              "displayText": "Riyadh, King Khalid International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "King Khalid International Airport",
              "phoneticLabel": null,
              "searchText": "ruh king khalid international airport saudi arabia riyadh",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NUM",
              "cityName": "Neom Bay",
              "code": "NUM",
              "countryName": "Saudi Arabia",
              "displayText": "Neom Bay, Neom Bay Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Neom Bay Airport",
              "phoneticLabel": null,
              "searchText": "num neom bay airport saudi arabia neom bay",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "AHB",
              "cityName": "Abha",
              "code": "AHB",
              "countryName": "Saudi Arabia",
              "displayText": "Abha, Abha Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Abha Airport",
              "phoneticLabel": null,
              "searchText": "ahb abha airport saudi arabia abha",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ULH",
              "cityName": "Al Ula",
              "code": "ULH",
              "countryName": "Saudi Arabia",
              "displayText": "Al Ula, Alula International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Alula International Airport",
              "phoneticLabel": null,
              "searchText": "ulh alula international airport saudi arabia al ula",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BJL",
              "cityName": "Banjul",
              "code": "BJL",
              "countryName": "Gambia",
              "displayText": "Banjul, Banjul",
              "isDestination": true,
              "isOrigin": true,
              "label": "Banjul",
              "phoneticLabel": null,
              "searchText": "bjl banjul gambia banjul",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "IOM",
              "cityName": "Isle of Man",
              "code": "IOM",
              "countryName": "Isle of Man",
              "displayText": "Isle of Man, Isle of Man Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Isle of Man Airport",
              "phoneticLabel": null,
              "searchText": "iom isle of man airport isle of man isle of man",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SLU",
              "cityName": "Saint Lucia",
              "code": "SLU",
              "countryName": "Saint Lucia",
              "displayText": "Saint Lucia",
              "isDestination": true,
              "isOrigin": true,
              "label": "Saint Lucia",
              "phoneticLabel": null,
              "searchText": "slu saint lucia saint lucia",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "SLU",
              "cityName": "Saint Lucia",
              "code": "SLU",
              "countryName": "Saint Lucia",
              "displayText": "Saint Lucia, George F. L. Charles Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "George F. L. Charles Airport",
              "phoneticLabel": null,
              "searchText": "slu george f. l. charles airport saint lucia saint lucia",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SLU",
              "cityName": "Saint Lucia",
              "code": "UVF",
              "countryName": "Saint Lucia",
              "displayText": "Saint Lucia, Hewanorra International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Hewanorra International Airport",
              "phoneticLabel": null,
              "searchText": "uvf hewanorra international airport saint lucia saint lucia",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "FAE",
              "cityName": "Faroe Islands",
              "code": "FAE",
              "countryName": "Faroe Islands",
              "displayText": "Faroe Islands, Faroe Islands Vagar Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Faroe Islands Vagar Airport",
              "phoneticLabel": null,
              "searchText": "fae faroe islands vagar airport faroe islands faroe islands",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LLW",
              "cityName": "Lilongwe",
              "code": "LLW",
              "countryName": "Malawi",
              "displayText": "Lilongwe, Lilongwe International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Lilongwe International Airport",
              "phoneticLabel": null,
              "searchText": "llw lilongwe international airport malawi lilongwe",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BLZ",
              "cityName": "Blantyre",
              "code": "BLZ",
              "countryName": "Malawi",
              "displayText": "Blantyre, Chileka International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Chileka International Airport",
              "phoneticLabel": null,
              "searchText": "blz chileka international airport malawi blantyre",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TIA",
              "cityName": "Tirana",
              "code": "TIA",
              "countryName": "Albania",
              "displayText": "Tirana, Nene Tereza International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Nene Tereza International",
              "phoneticLabel": null,
              "searchText": "tia nene tereza international albania tirana",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BEG",
              "cityName": "Belgrade",
              "code": "BEG",
              "countryName": "Serbia",
              "displayText": "Belgrade, Nikola Tesla Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Nikola Tesla Airport",
              "phoneticLabel": null,
              "searchText": "beg nikola tesla airport serbia belgrade",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NOU",
              "cityName": "Noumea",
              "code": "NOU",
              "countryName": "New Caledonia",
              "displayText": "Noumea, La Tontouta International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "La Tontouta International Airport",
              "phoneticLabel": null,
              "searchText": "nou la tontouta international airport new caledonia noumea",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "VNO",
              "cityName": "Vilnius",
              "code": "VNO",
              "countryName": "Lithuania",
              "displayText": "Vilnius, Vilnius International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Vilnius International Airport",
              "phoneticLabel": null,
              "searchText": "vno vilnius international airport lithuania vilnius",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PLQ",
              "cityName": "Palanga",
              "code": "PLQ",
              "countryName": "Lithuania",
              "displayText": "Palanga, Palanga",
              "isDestination": true,
              "isOrigin": true,
              "label": "Palanga",
              "phoneticLabel": null,
              "searchText": "plq palanga lithuania palanga",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CIT",
              "cityName": "Shymkent",
              "code": "CIT",
              "countryName": "Kazakhstan",
              "displayText": "Shymkent, Shymkent International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Shymkent International",
              "phoneticLabel": null,
              "searchText": "cit shymkent international kazakhstan shymkent",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "URA",
              "cityName": "Uralsk",
              "code": "URA",
              "countryName": "Kazakhstan",
              "displayText": "Uralsk, Uralsk",
              "isDestination": true,
              "isOrigin": true,
              "label": "Uralsk",
              "phoneticLabel": null,
              "searchText": "ura uralsk kazakhstan uralsk",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SCO",
              "cityName": "Aktau",
              "code": "SCO",
              "countryName": "Kazakhstan",
              "displayText": "Aktau, Aktau",
              "isDestination": true,
              "isOrigin": true,
              "label": "Aktau",
              "phoneticLabel": null,
              "searchText": "sco aktau kazakhstan aktau",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ALA",
              "cityName": "Almaty",
              "code": "ALA",
              "countryName": "Kazakhstan",
              "displayText": "Almaty, Almaty International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Almaty International Airport",
              "phoneticLabel": null,
              "searchText": "ala almaty international airport kazakhstan almaty",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NQZ",
              "cityName": "Nur Sultan",
              "code": "NQZ",
              "countryName": "Kazakhstan",
              "displayText": "Nur Sultan, Nursultan Nazarbayev",
              "isDestination": true,
              "isOrigin": true,
              "label": "Nursultan Nazarbayev",
              "phoneticLabel": null,
              "searchText": "nqz nursultan nazarbayev kazakhstan nur sultan",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "GUW",
              "cityName": "Atyrau",
              "code": "GUW",
              "countryName": "Kazakhstan",
              "displayText": "Atyrau, Atyrau",
              "isDestination": true,
              "isOrigin": true,
              "label": "Atyrau",
              "phoneticLabel": null,
              "searchText": "guw atyrau kazakhstan atyrau",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KZO",
              "cityName": "Kyzylorda",
              "code": "KZO",
              "countryName": "Kazakhstan",
              "displayText": "Kyzylorda, Kyzylorda Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kyzylorda Airport",
              "phoneticLabel": null,
              "searchText": "kzo kyzylorda airport kazakhstan kyzylorda",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BOM",
              "cityName": "Mumbai Bombay",
              "code": "BOM",
              "countryName": "India",
              "displayText": "Mumbai Bombay, Chhatrapati Shivaji",
              "isDestination": true,
              "isOrigin": true,
              "label": "Chhatrapati Shivaji",
              "phoneticLabel": null,
              "searchText": "bom chhatrapati shivaji india mumbai bombay",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "IXU",
              "cityName": "Aurangabad",
              "code": "IXU",
              "countryName": "India",
              "displayText": "Aurangabad, Aurangabad Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Aurangabad Airport",
              "phoneticLabel": null,
              "searchText": "ixu aurangabad airport india aurangabad",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HYD",
              "cityName": "Hyderabad, India",
              "code": "HYD",
              "countryName": "India",
              "displayText": "Hyderabad, India, Rajiv Gandhi International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Rajiv Gandhi International",
              "phoneticLabel": null,
              "searchText": "hyd rajiv gandhi international india hyderabad, india",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TRV",
              "cityName": "Thiruvananthapuram",
              "code": "TRV",
              "countryName": "India",
              "displayText": "Thiruvananthapuram, Trivandrum International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Trivandrum International Airport",
              "phoneticLabel": null,
              "searchText": "trv trivandrum international airport india thiruvananthapuram",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "JDH",
              "cityName": "Jodhpur",
              "code": "JDH",
              "countryName": "India",
              "displayText": "Jodhpur, Jodhpur Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Jodhpur Airport",
              "phoneticLabel": null,
              "searchText": "jdh jodhpur airport india jodhpur",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "JAI",
              "cityName": "Jaipur",
              "code": "JAI",
              "countryName": "India",
              "displayText": "Jaipur, Jaipur International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Jaipur International Airport",
              "phoneticLabel": null,
              "searchText": "jai jaipur international airport india jaipur",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CJB",
              "cityName": "Coimbatore",
              "code": "CJB",
              "countryName": "India",
              "displayText": "Coimbatore, Coimbatore Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Coimbatore Airport",
              "phoneticLabel": null,
              "searchText": "cjb coimbatore airport india coimbatore",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SXR",
              "cityName": "Srinagar",
              "code": "SXR",
              "countryName": "India",
              "displayText": "Srinagar, Sheikh Ul Alam Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Sheikh Ul Alam Airport",
              "phoneticLabel": null,
              "searchText": "sxr sheikh ul alam airport india srinagar",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "IXL",
              "cityName": "Leh",
              "code": "IXL",
              "countryName": "India",
              "displayText": "Leh, Kushok Bakula Rimpochhe Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kushok Bakula Rimpochhe Airport",
              "phoneticLabel": null,
              "searchText": "ixl kushok bakula rimpochhe airport india leh",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LKO",
              "cityName": "Lucknow",
              "code": "LKO",
              "countryName": "India",
              "displayText": "Lucknow, Chaudhary Charan Singh",
              "isDestination": true,
              "isOrigin": true,
              "label": "Chaudhary Charan Singh",
              "phoneticLabel": null,
              "searchText": "lko chaudhary charan singh india lucknow",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PNQ",
              "cityName": "Pune",
              "code": "PNQ",
              "countryName": "India",
              "displayText": "Pune, Lohegaon",
              "isDestination": true,
              "isOrigin": true,
              "label": "Lohegaon",
              "phoneticLabel": null,
              "searchText": "pnq lohegaon india pune",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BDQ",
              "cityName": "Vadodara",
              "code": "BDQ",
              "countryName": "India",
              "displayText": "Vadodara, Vadodara",
              "isDestination": true,
              "isOrigin": true,
              "label": "Vadodara",
              "phoneticLabel": null,
              "searchText": "bdq vadodara india vadodara",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "VTZ",
              "cityName": "Vishakhapatnam",
              "code": "VTZ",
              "countryName": "India",
              "displayText": "Vishakhapatnam, Vishakhapatnam",
              "isDestination": true,
              "isOrigin": true,
              "label": "Vishakhapatnam",
              "phoneticLabel": null,
              "searchText": "vtz vishakhapatnam india vishakhapatnam",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BHJ",
              "cityName": "Bhuj",
              "code": "BHJ",
              "countryName": "India",
              "displayText": "Bhuj, Bhuj Shyamji Krishna Verma Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Bhuj Shyamji Krishna Verma Airport",
              "phoneticLabel": null,
              "searchText": "bhj bhuj shyamji krishna verma airport india bhuj",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "DEL",
              "cityName": "Delhi",
              "code": "DEL",
              "countryName": "India",
              "displayText": "Delhi, Indira Gandhi International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Indira Gandhi International",
              "phoneticLabel": null,
              "searchText": "del indira gandhi international india delhi",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TRZ",
              "cityName": "Tiruchchirappalli",
              "code": "TRZ",
              "countryName": "India",
              "displayText": "Tiruchchirappalli, Tiruchchirappalli",
              "isDestination": true,
              "isOrigin": true,
              "label": "Tiruchchirappalli",
              "phoneticLabel": null,
              "searchText": "trz tiruchchirappalli india tiruchchirappalli",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BHO",
              "cityName": "Bhopal",
              "code": "BHO",
              "countryName": "India",
              "displayText": "Bhopal, Raja Bhoi",
              "isDestination": true,
              "isOrigin": true,
              "label": "Raja Bhoi",
              "phoneticLabel": null,
              "searchText": "bho raja bhoi india bhopal",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "GOP",
              "cityName": "Gorakhpur",
              "code": "GOP",
              "countryName": "India",
              "displayText": "Gorakhpur, Gorakhpur",
              "isDestination": true,
              "isOrigin": true,
              "label": "Gorakhpur",
              "phoneticLabel": null,
              "searchText": "gop gorakhpur india gorakhpur",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "JGA",
              "cityName": "Jamnagar",
              "code": "JGA",
              "countryName": "India",
              "displayText": "Jamnagar, Jamnagar Govardhanpur Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Jamnagar Govardhanpur Airport",
              "phoneticLabel": null,
              "searchText": "jga jamnagar govardhanpur airport india jamnagar",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "UDR",
              "cityName": "Udaipur",
              "code": "UDR",
              "countryName": "India",
              "displayText": "Udaipur, Maharana Pratap",
              "isDestination": true,
              "isOrigin": true,
              "label": "Maharana Pratap",
              "phoneticLabel": null,
              "searchText": "udr maharana pratap india udaipur",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "IDR",
              "cityName": "Indore",
              "code": "IDR",
              "countryName": "India",
              "displayText": "Indore, Devi Ahilyabai Holkar",
              "isDestination": true,
              "isOrigin": true,
              "label": "Devi Ahilyabai Holkar",
              "phoneticLabel": null,
              "searchText": "idr devi ahilyabai holkar india indore",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "IXR",
              "cityName": "Ranchi",
              "code": "IXR",
              "countryName": "India",
              "displayText": "Ranchi, Birsa Munda",
              "isDestination": true,
              "isOrigin": true,
              "label": "Birsa Munda",
              "phoneticLabel": null,
              "searchText": "ixr birsa munda india ranchi",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "IXM",
              "cityName": "Madurai",
              "code": "IXM",
              "countryName": "India",
              "displayText": "Madurai, Madurai",
              "isDestination": true,
              "isOrigin": true,
              "label": "Madurai",
              "phoneticLabel": null,
              "searchText": "ixm madurai india madurai",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "IXJ",
              "cityName": "Jammu",
              "code": "IXJ",
              "countryName": "India",
              "displayText": "Jammu, Satwari Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Satwari Airport",
              "phoneticLabel": null,
              "searchText": "ixj satwari airport india jammu",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HSR",
              "cityName": "Hirasar",
              "code": "HSR",
              "countryName": "India",
              "displayText": "Hirasar, Hirasar Rajkot International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Hirasar Rajkot International Airport",
              "phoneticLabel": null,
              "searchText": "hsr hirasar rajkot international airport india hirasar",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "IXE",
              "cityName": "Mangalore",
              "code": "IXE",
              "countryName": "India",
              "displayText": "Mangalore, Mangalore Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Mangalore Airport",
              "phoneticLabel": null,
              "searchText": "ixe mangalore airport india mangalore",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ATQ",
              "cityName": "Amritsar",
              "code": "ATQ",
              "countryName": "India",
              "displayText": "Amritsar, Raja Sansi International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Raja Sansi International Airport",
              "phoneticLabel": null,
              "searchText": "atq raja sansi international airport india amritsar",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "DED",
              "cityName": "Dehra Dun",
              "code": "DED",
              "countryName": "India",
              "displayText": "Dehra Dun, Jolly Grant Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Jolly Grant Airport",
              "phoneticLabel": null,
              "searchText": "ded jolly grant airport india dehra dun",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "GOI",
              "cityName": "Goa",
              "code": "GOI",
              "countryName": "India",
              "displayText": "Goa",
              "isDestination": true,
              "isOrigin": true,
              "label": "Goa",
              "phoneticLabel": null,
              "searchText": "goi goa india",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "GOI",
              "cityName": "Goa",
              "code": "GOX",
              "countryName": "India",
              "displayText": "Goa, Goa Mopa International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Goa Mopa International Airport",
              "phoneticLabel": null,
              "searchText": "gox goa mopa international airport india goa",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "GOI",
              "cityName": "Goa",
              "code": "GOI",
              "countryName": "India",
              "displayText": "Goa, Dabolim",
              "isDestination": true,
              "isOrigin": true,
              "label": "Dabolim",
              "phoneticLabel": null,
              "searchText": "goi dabolim india goa",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PAT",
              "cityName": "Patna",
              "code": "PAT",
              "countryName": "India",
              "displayText": "Patna, Jay Prakash Narayan Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Jay Prakash Narayan Airport",
              "phoneticLabel": null,
              "searchText": "pat jay prakash narayan airport india patna",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MAA",
              "cityName": "Chennai Madras",
              "code": "MAA",
              "countryName": "India",
              "displayText": "Chennai Madras, Chennai International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Chennai International Airport",
              "phoneticLabel": null,
              "searchText": "maa chennai international airport india chennai madras",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BBI",
              "cityName": "Bhubaneswar",
              "code": "BBI",
              "countryName": "India",
              "displayText": "Bhubaneswar, Biju Patnaik Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Biju Patnaik Airport",
              "phoneticLabel": null,
              "searchText": "bbi biju patnaik airport india bhubaneswar",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CCU",
              "cityName": "Kolkata Calcutta",
              "code": "CCU",
              "countryName": "India",
              "displayText": "Kolkata Calcutta, Netaji Subhash Chandra Bose International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Netaji Subhash Chandra Bose International Airport",
              "phoneticLabel": null,
              "searchText": "ccu netaji subhash chandra bose international airport india kolkata calcutta",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "STV",
              "cityName": "Surat",
              "code": "STV",
              "countryName": "India",
              "displayText": "Surat, Surat Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Surat Airport",
              "phoneticLabel": null,
              "searchText": "stv surat airport india surat",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BLR",
              "cityName": "Bengaluru",
              "code": "BLR",
              "countryName": "India",
              "displayText": "Bengaluru, Bengaluru International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Bengaluru International Airport",
              "phoneticLabel": null,
              "searchText": "blr bengaluru international airport india bengaluru",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "VNS",
              "cityName": "Varanasi",
              "code": "VNS",
              "countryName": "India",
              "displayText": "Varanasi, Babatpur Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Babatpur Airport",
              "phoneticLabel": null,
              "searchText": "vns babatpur airport india varanasi",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "GAU",
              "cityName": "Guwahati",
              "code": "GAU",
              "countryName": "India",
              "displayText": "Guwahati, Lokpriya Gopinath Bordoloi International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Lokpriya Gopinath Bordoloi International Airport",
              "phoneticLabel": null,
              "searchText": "gau lokpriya gopinath bordoloi international airport india guwahati",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "IXZ",
              "cityName": "Port Blair",
              "code": "IXZ",
              "countryName": "India",
              "displayText": "Port Blair, Port Blair Veer Savarkar International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Port Blair Veer Savarkar International Airport",
              "phoneticLabel": null,
              "searchText": "ixz port blair veer savarkar international airport india port blair",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "AMD",
              "cityName": "Ahmedabad",
              "code": "AMD",
              "countryName": "India",
              "displayText": "Ahmedabad, Sardar Vallabhbhai Patel",
              "isDestination": true,
              "isOrigin": true,
              "label": "Sardar Vallabhbhai Patel",
              "phoneticLabel": null,
              "searchText": "amd sardar vallabhbhai patel india ahmedabad",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "VGA",
              "cityName": "Vijayawada",
              "code": "VGA",
              "countryName": "India",
              "displayText": "Vijayawada, Vijayawada",
              "isDestination": true,
              "isOrigin": true,
              "label": "Vijayawada",
              "phoneticLabel": null,
              "searchText": "vga vijayawada india vijayawada",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "IXB",
              "cityName": "Bagdogra",
              "code": "IXB",
              "countryName": "India",
              "displayText": "Bagdogra, Bagdogra",
              "isDestination": true,
              "isOrigin": true,
              "label": "Bagdogra",
              "phoneticLabel": null,
              "searchText": "ixb bagdogra india bagdogra",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "RPR",
              "cityName": "Raipur",
              "code": "RPR",
              "countryName": "India",
              "displayText": "Raipur, Raipur Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Raipur Airport",
              "phoneticLabel": null,
              "searchText": "rpr raipur airport india raipur",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "COK",
              "cityName": "Kochi",
              "code": "COK",
              "countryName": "India",
              "displayText": "Kochi, Kochi Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kochi Airport",
              "phoneticLabel": null,
              "searchText": "cok kochi airport india kochi",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CCJ",
              "cityName": "Kozhikode",
              "code": "CCJ",
              "countryName": "India",
              "displayText": "Kozhikode, Kozhikode",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kozhikode",
              "phoneticLabel": null,
              "searchText": "ccj kozhikode india kozhikode",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "IXC",
              "cityName": "Chandigarh",
              "code": "IXC",
              "countryName": "India",
              "displayText": "Chandigarh, Chandigarh",
              "isDestination": true,
              "isOrigin": true,
              "label": "Chandigarh",
              "phoneticLabel": null,
              "searchText": "ixc chandigarh india chandigarh",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NAG",
              "cityName": "Nagpur",
              "code": "NAG",
              "countryName": "India",
              "displayText": "Nagpur, Dr. Babasaheb Ambedkar International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Dr. Babasaheb Ambedkar International Airport",
              "phoneticLabel": null,
              "searchText": "nag dr. babasaheb ambedkar international airport india nagpur",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BGF",
              "cityName": "Bangui",
              "code": "BGF",
              "countryName": "Central African Republic",
              "displayText": "Bangui, Bangui M'Poko International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Bangui M'Poko International Airport",
              "phoneticLabel": null,
              "searchText": "bgf bangui m'poko international airport central african republic bangui",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "JUB",
              "cityName": "Juba",
              "code": "JUB",
              "countryName": "South Sudan",
              "displayText": "Juba, Juba",
              "isDestination": true,
              "isOrigin": true,
              "label": "Juba",
              "phoneticLabel": null,
              "searchText": "jub juba south sudan juba",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "AMS",
              "cityName": "Amsterdam",
              "code": "AMS",
              "countryName": "Netherlands",
              "displayText": "Amsterdam, Amsterdam Schiphol Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Amsterdam Schiphol Airport",
              "phoneticLabel": null,
              "searchText": "ams amsterdam schiphol airport netherlands amsterdam",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "RTM",
              "cityName": "Rotterdam",
              "code": "RTM",
              "countryName": "Netherlands",
              "displayText": "Rotterdam, Rotterdam",
              "isDestination": true,
              "isOrigin": true,
              "label": "Rotterdam",
              "phoneticLabel": null,
              "searchText": "rtm rotterdam netherlands rotterdam",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MST",
              "cityName": "Maastricht",
              "code": "MST",
              "countryName": "Netherlands",
              "displayText": "Maastricht",
              "isDestination": true,
              "isOrigin": true,
              "label": "Maastricht",
              "phoneticLabel": null,
              "searchText": "mst maastricht netherlands",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "MST",
              "cityName": "Maastricht",
              "code": "MST",
              "countryName": "Netherlands",
              "displayText": "Maastricht, Maastricht Aachen Airport – bus stop Vliegveldweg",
              "isDestination": true,
              "isOrigin": true,
              "label": "Maastricht Aachen Airport – bus stop Vliegveldweg",
              "phoneticLabel": null,
              "searchText": "mst maastricht aachen airport – bus stop vliegveldweg netherlands maastricht",
              "stationType": "BUS_STATION",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MST",
              "cityName": "Maastricht",
              "code": "ZYT",
              "countryName": "Netherlands",
              "displayText": "Maastricht, Maastricht (bus terminal Meerssenerweg)",
              "isDestination": true,
              "isOrigin": true,
              "label": "Maastricht (bus terminal Meerssenerweg)",
              "phoneticLabel": null,
              "searchText": "zyt maastricht (bus terminal meerssenerweg) netherlands maastricht",
              "stationType": "BUS_STATION",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "EIN",
              "cityName": "Eindhoven",
              "code": "EIN",
              "countryName": "Netherlands",
              "displayText": "Eindhoven, Eindhoven Airport – bus terminal Luchthavenweg",
              "isDestination": true,
              "isOrigin": true,
              "label": "Eindhoven Airport – bus terminal Luchthavenweg",
              "phoneticLabel": null,
              "searchText": "ein eindhoven airport – bus terminal luchthavenweg netherlands eindhoven",
              "stationType": "BUS_STATION",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NIM",
              "cityName": "Niamey",
              "code": "NIM",
              "countryName": "Niger",
              "displayText": "Niamey, Diori Hamani International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Diori Hamani International Airport",
              "phoneticLabel": null,
              "searchText": "nim diori hamani international airport niger niamey",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BUD",
              "cityName": "Budapest",
              "code": "BUD",
              "countryName": "Hungary",
              "displayText": "Budapest, Liszt Ferenc International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Liszt Ferenc International",
              "phoneticLabel": null,
              "searchText": "bud liszt ferenc international hungary budapest",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "EVN",
              "cityName": "Yerevan",
              "code": "EVN",
              "countryName": "Armenia",
              "displayText": "Yerevan, Zvartnots Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Zvartnots Airport",
              "phoneticLabel": null,
              "searchText": "evn zvartnots airport armenia yerevan",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KWI",
              "cityName": "Kuwait",
              "code": "KWI",
              "countryName": "Kuwait",
              "displayText": "Kuwait, Kuwait International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kuwait International Airport",
              "phoneticLabel": null,
              "searchText": "kwi kuwait international airport kuwait kuwait",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ROS",
              "cityName": "Rosario",
              "code": "ROS",
              "countryName": "Argentina",
              "displayText": "Rosario, Rosario - Islas Malvinas International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Rosario - Islas Malvinas International Airport",
              "phoneticLabel": null,
              "searchText": "ros rosario - islas malvinas international airport argentina rosario",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MDZ",
              "cityName": "Mendoza",
              "code": "MDZ",
              "countryName": "Argentina",
              "displayText": "Mendoza, El Plumerillo",
              "isDestination": true,
              "isOrigin": true,
              "label": "El Plumerillo",
              "phoneticLabel": null,
              "searchText": "mdz el plumerillo argentina mendoza",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NQN",
              "cityName": "Neuquen",
              "code": "NQN",
              "countryName": "Argentina",
              "displayText": "Neuquen, Presidente Perón",
              "isDestination": true,
              "isOrigin": true,
              "label": "Presidente Perón",
              "phoneticLabel": null,
              "searchText": "nqn presidente perón argentina neuquen",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "EQS",
              "cityName": "Esquel",
              "code": "EQS",
              "countryName": "Argentina",
              "displayText": "Esquel, Esquel Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Esquel Airport",
              "phoneticLabel": null,
              "searchText": "eqs esquel airport argentina esquel",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CTC",
              "cityName": "Catamarca",
              "code": "CTC",
              "countryName": "Argentina",
              "displayText": "Catamarca, Catamarca Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Catamarca Airport",
              "phoneticLabel": null,
              "searchText": "ctc catamarca airport argentina catamarca",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "RSA",
              "cityName": "Santa Rosa",
              "code": "RSA",
              "countryName": "Argentina",
              "displayText": "Santa Rosa, Santa Rosa Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Santa Rosa Airport",
              "phoneticLabel": null,
              "searchText": "rsa santa rosa airport argentina santa rosa",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "FTE",
              "cityName": "El Calafate",
              "code": "FTE",
              "countryName": "Argentina",
              "displayText": "El Calafate, El Calafate",
              "isDestination": true,
              "isOrigin": true,
              "label": "El Calafate",
              "phoneticLabel": null,
              "searchText": "fte el calafate argentina el calafate",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CRD",
              "cityName": "Comodoro Rivadavia",
              "code": "CRD",
              "countryName": "Argentina",
              "displayText": "Comodoro Rivadavia, Comodoro Rivadavia General E. Mosconi Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Comodoro Rivadavia General E. Mosconi Airport",
              "phoneticLabel": null,
              "searchText": "crd comodoro rivadavia general e. mosconi airport argentina comodoro rivadavia",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SDE",
              "cityName": "Santiago del Estero",
              "code": "SDE",
              "countryName": "Argentina",
              "displayText": "Santiago del Estero, Ángel de la Paz Aragonés Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Ángel de la Paz Aragonés Airport",
              "phoneticLabel": null,
              "searchText": "sde ángel de la paz aragonés airport argentina santiago del estero",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SFN",
              "cityName": "Santa Fe",
              "code": "SFN",
              "countryName": "Argentina",
              "displayText": "Santa Fe, Sauce Viejo Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Sauce Viejo Airport",
              "phoneticLabel": null,
              "searchText": "sfn sauce viejo airport argentina santa fe",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TUC",
              "cityName": "Tucuman",
              "code": "TUC",
              "countryName": "Argentina",
              "displayText": "Tucuman, Benjamin Matienzo",
              "isDestination": true,
              "isOrigin": true,
              "label": "Benjamin Matienzo",
              "phoneticLabel": null,
              "searchText": "tuc benjamin matienzo argentina tucuman",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BUE",
              "cityName": "Buenos Aires",
              "code": "BUE",
              "countryName": "Argentina",
              "displayText": "Buenos Aires",
              "isDestination": true,
              "isOrigin": true,
              "label": "Buenos Aires",
              "phoneticLabel": null,
              "searchText": "bue buenos aires argentina",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "BUE",
              "cityName": "Buenos Aires",
              "code": "AEP",
              "countryName": "Argentina",
              "displayText": "Buenos Aires, Jorge Newbery Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Jorge Newbery Airport",
              "phoneticLabel": null,
              "searchText": "aep jorge newbery airport argentina buenos aires",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BUE",
              "cityName": "Buenos Aires",
              "code": "EZE",
              "countryName": "Argentina",
              "displayText": "Buenos Aires, Ezeiza Ministro Pistarini",
              "isDestination": true,
              "isOrigin": true,
              "label": "Ezeiza Ministro Pistarini",
              "phoneticLabel": null,
              "searchText": "eze ezeiza ministro pistarini argentina buenos aires",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CNQ",
              "cityName": "Corrientes",
              "code": "CNQ",
              "countryName": "Argentina",
              "displayText": "Corrientes, Corrientes Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Corrientes Airport",
              "phoneticLabel": null,
              "searchText": "cnq corrientes airport argentina corrientes",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "COR",
              "cityName": "Cordoba",
              "code": "COR",
              "countryName": "Argentina",
              "displayText": "Cordoba, Pajas Blancas",
              "isDestination": true,
              "isOrigin": true,
              "label": "Pajas Blancas",
              "phoneticLabel": null,
              "searchText": "cor pajas blancas argentina cordoba",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "VDM",
              "cityName": "Viedma",
              "code": "VDM",
              "countryName": "Argentina",
              "displayText": "Viedma, Gobernador Edgardo Castello",
              "isDestination": true,
              "isOrigin": true,
              "label": "Gobernador Edgardo Castello",
              "phoneticLabel": null,
              "searchText": "vdm gobernador edgardo castello argentina viedma",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "RGL",
              "cityName": "Río Gallegos",
              "code": "RGL",
              "countryName": "Argentina",
              "displayText": "Río Gallegos, Piloto Civil Norberto Fernández International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Piloto Civil Norberto Fernández International Airport",
              "phoneticLabel": null,
              "searchText": "rgl piloto civil norberto fernández international airport argentina río gallegos",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "JUJ",
              "cityName": "Jujuy",
              "code": "JUJ",
              "countryName": "Argentina",
              "displayText": "Jujuy, Gobernador Horacio Guzmán International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Gobernador Horacio Guzmán International Airport",
              "phoneticLabel": null,
              "searchText": "juj gobernador horacio guzmán international airport argentina jujuy",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "RGA",
              "cityName": "Rio Grande",
              "code": "RGA",
              "countryName": "Argentina",
              "displayText": "Rio Grande, Hermes Quijada International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Hermes Quijada International Airport",
              "phoneticLabel": null,
              "searchText": "rga hermes quijada international airport argentina rio grande",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "IGR",
              "cityName": "Iguazu",
              "code": "IGR",
              "countryName": "Argentina",
              "displayText": "Iguazu, Cataratas del Iguazú International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Cataratas del Iguazú International Airport",
              "phoneticLabel": null,
              "searchText": "igr cataratas del iguazú international airport argentina iguazu",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "AFA",
              "cityName": "San Rafael",
              "code": "AFA",
              "countryName": "Argentina",
              "displayText": "San Rafael, San Rafael Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "San Rafael Airport",
              "phoneticLabel": null,
              "searchText": "afa san rafael airport argentina san rafael",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "USH",
              "cityName": "Ushuaia",
              "code": "USH",
              "countryName": "Argentina",
              "displayText": "Ushuaia, Malvinas Argentinas International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Malvinas Argentinas International Airport",
              "phoneticLabel": null,
              "searchText": "ush malvinas argentinas international airport argentina ushuaia",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LUQ",
              "cityName": "San Luis",
              "code": "LUQ",
              "countryName": "Argentina",
              "displayText": "San Luis, San Luis D. Cesar Raul Ojeda Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "San Luis D. Cesar Raul Ojeda Airport",
              "phoneticLabel": null,
              "searchText": "luq san luis d. cesar raul ojeda airport argentina san luis",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "REL",
              "cityName": "Trelew",
              "code": "REL",
              "countryName": "Argentina",
              "displayText": "Trelew, Almirante Zar Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Almirante Zar Airport",
              "phoneticLabel": null,
              "searchText": "rel almirante zar airport argentina trelew",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SLA",
              "cityName": "Salta",
              "code": "SLA",
              "countryName": "Argentina",
              "displayText": "Salta, Salta Martin M. de Guemes Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Salta Martin M. de Guemes Airport",
              "phoneticLabel": null,
              "searchText": "sla salta martin m. de guemes airport argentina salta",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CPC",
              "cityName": "San Martin Los Andes",
              "code": "CPC",
              "countryName": "Argentina",
              "displayText": "San Martin Los Andes, Aviador C. Campos Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Aviador C. Campos Airport",
              "phoneticLabel": null,
              "searchText": "cpc aviador c. campos airport argentina san martin los andes",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BRC",
              "cityName": "San Carlos Bariloche",
              "code": "BRC",
              "countryName": "Argentina",
              "displayText": "San Carlos Bariloche, Bariloche International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Bariloche International Airport",
              "phoneticLabel": null,
              "searchText": "brc bariloche international airport argentina san carlos bariloche",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MDQ",
              "cityName": "Mar del Plata",
              "code": "MDQ",
              "countryName": "Argentina",
              "displayText": "Mar del Plata, Astor Piazzola",
              "isDestination": true,
              "isOrigin": true,
              "label": "Astor Piazzola",
              "phoneticLabel": null,
              "searchText": "mdq astor piazzola argentina mar del plata",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PSS",
              "cityName": "Posadas",
              "code": "PSS",
              "countryName": "Argentina",
              "displayText": "Posadas, Posadas Jose de San Martin Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Posadas Jose de San Martin Airport",
              "phoneticLabel": null,
              "searchText": "pss posadas jose de san martin airport argentina posadas",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "UAQ",
              "cityName": "San Juan",
              "code": "UAQ",
              "countryName": "Argentina",
              "displayText": "San Juan, Domingo Faustino Sarmiento Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Domingo Faustino Sarmiento Airport",
              "phoneticLabel": null,
              "searchText": "uaq domingo faustino sarmiento airport argentina san juan",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "RES",
              "cityName": "Resistencia",
              "code": "RES",
              "countryName": "Argentina",
              "displayText": "Resistencia, Resistencia International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Resistencia International Airport",
              "phoneticLabel": null,
              "searchText": "res resistencia international airport argentina resistencia",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BHI",
              "cityName": "Bahia Blanca",
              "code": "BHI",
              "countryName": "Argentina",
              "displayText": "Bahia Blanca, Comandante Espora Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Comandante Espora Airport",
              "phoneticLabel": null,
              "searchText": "bhi comandante espora airport argentina bahia blanca",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "POM",
              "cityName": "Port Moresby",
              "code": "POM",
              "countryName": "Papua New Guinea",
              "displayText": "Port Moresby, Jacksons International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Jacksons International Airport",
              "phoneticLabel": null,
              "searchText": "pom jacksons international airport papua new guinea port moresby",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "COO",
              "cityName": "Cotonou",
              "code": "COO",
              "countryName": "Benin",
              "displayText": "Cotonou, Cadjehoun",
              "isDestination": true,
              "isOrigin": true,
              "label": "Cadjehoun",
              "phoneticLabel": null,
              "searchText": "coo cadjehoun benin cotonou",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "UET",
              "cityName": "Quetta",
              "code": "UET",
              "countryName": "Pakistan",
              "displayText": "Quetta, Quetta International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Quetta International Airport",
              "phoneticLabel": null,
              "searchText": "uet quetta international airport pakistan quetta",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LHE",
              "cityName": "Lahore",
              "code": "LHE",
              "countryName": "Pakistan",
              "displayText": "Lahore, Allama Iqbal International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Allama Iqbal International",
              "phoneticLabel": null,
              "searchText": "lhe allama iqbal international pakistan lahore",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ISB",
              "cityName": "Islamabad",
              "code": "ISB",
              "countryName": "Pakistan",
              "displayText": "Islamabad, Islamabad International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Islamabad International Airport",
              "phoneticLabel": null,
              "searchText": "isb islamabad international airport pakistan islamabad",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SKT",
              "cityName": "Sialkot",
              "code": "SKT",
              "countryName": "Pakistan",
              "displayText": "Sialkot, Sialkot International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Sialkot International Airport",
              "phoneticLabel": null,
              "searchText": "skt sialkot international airport pakistan sialkot",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KBH",
              "cityName": "Kalat",
              "code": "KBH",
              "countryName": "Pakistan",
              "displayText": "Kalat, Kalat Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kalat Airport",
              "phoneticLabel": null,
              "searchText": "kbh kalat airport pakistan kalat",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KHI",
              "cityName": "Karachi",
              "code": "KHI",
              "countryName": "Pakistan",
              "displayText": "Karachi, Jinnah International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Jinnah International Airport",
              "phoneticLabel": null,
              "searchText": "khi jinnah international airport pakistan karachi",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PEW",
              "cityName": "Peshawar",
              "code": "PEW",
              "countryName": "Pakistan",
              "displayText": "Peshawar, Peshawar Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Peshawar Airport",
              "phoneticLabel": null,
              "searchText": "pew peshawar airport pakistan peshawar",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LYP",
              "cityName": "Faisalabad",
              "code": "LYP",
              "countryName": "Pakistan",
              "displayText": "Faisalabad, Faisalabad International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Faisalabad International Airport",
              "phoneticLabel": null,
              "searchText": "lyp faisalabad international airport pakistan faisalabad",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MUX",
              "cityName": "Multan",
              "code": "MUX",
              "countryName": "Pakistan",
              "displayText": "Multan, Multan International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Multan International Airport",
              "phoneticLabel": null,
              "searchText": "mux multan international airport pakistan multan",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BUH",
              "cityName": "Bucharest",
              "code": "OTP",
              "countryName": "Romania",
              "displayText": "Bucharest, Henri Coanda International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Henri Coanda International Airport",
              "phoneticLabel": null,
              "searchText": "otp henri coanda international airport romania bucharest",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CLJ",
              "cityName": "Cluj Napoca",
              "code": "CLJ",
              "countryName": "Romania",
              "displayText": "Cluj Napoca, Cluj-Napoca International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Cluj-Napoca International Airport",
              "phoneticLabel": null,
              "searchText": "clj cluj-napoca international airport romania cluj napoca",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "OMR",
              "cityName": "Oradea",
              "code": "OMR",
              "countryName": "Romania",
              "displayText": "Oradea, Oradea",
              "isDestination": true,
              "isOrigin": true,
              "label": "Oradea",
              "phoneticLabel": null,
              "searchText": "omr oradea romania oradea",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TSR",
              "cityName": "Timisoara",
              "code": "TSR",
              "countryName": "Romania",
              "displayText": "Timisoara, Traian Vuia",
              "isDestination": true,
              "isOrigin": true,
              "label": "Traian Vuia",
              "phoneticLabel": null,
              "searchText": "tsr traian vuia romania timisoara",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BAY",
              "cityName": "Baia Mare",
              "code": "BAY",
              "countryName": "Romania",
              "displayText": "Baia Mare, Baia Mare",
              "isDestination": true,
              "isOrigin": true,
              "label": "Baia Mare",
              "phoneticLabel": null,
              "searchText": "bay baia mare romania baia mare",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SCV",
              "cityName": "Suceava",
              "code": "SCV",
              "countryName": "Romania",
              "displayText": "Suceava, Stefan Cel Mare",
              "isDestination": true,
              "isOrigin": true,
              "label": "Stefan Cel Mare",
              "phoneticLabel": null,
              "searchText": "scv stefan cel mare romania suceava",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "IAS",
              "cityName": "Iasi",
              "code": "IAS",
              "countryName": "Romania",
              "displayText": "Iasi, Iaşi Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Iaşi Airport",
              "phoneticLabel": null,
              "searchText": "ias iaşi airport romania iasi",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SUJ",
              "cityName": "Satu Mare",
              "code": "SUJ",
              "countryName": "Romania",
              "displayText": "Satu Mare, Satu Mare International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Satu Mare International Airport",
              "phoneticLabel": null,
              "searchText": "suj satu mare international airport romania satu mare",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NGB",
              "cityName": "Ningbo",
              "code": "NGB",
              "countryName": "China",
              "displayText": "Ningbo, Lishe International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Lishe International Airport",
              "phoneticLabel": null,
              "searchText": "ngb lishe international airport china ningbo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "DYG",
              "cityName": "Zhangjiajie",
              "code": "DYG",
              "countryName": "China",
              "displayText": "Zhangjiajie, Hehua",
              "isDestination": true,
              "isOrigin": true,
              "label": "Hehua",
              "phoneticLabel": null,
              "searchText": "dyg hehua china zhangjiajie",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CKG",
              "cityName": "Chongqing",
              "code": "CKG",
              "countryName": "China",
              "displayText": "Chongqing, Chongqing Jiangbei International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Chongqing Jiangbei International Airport",
              "phoneticLabel": null,
              "searchText": "ckg chongqing jiangbei international airport china chongqing",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NTG",
              "cityName": "Nantong",
              "code": "NTG",
              "countryName": "China",
              "displayText": "Nantong, Xingdong",
              "isDestination": true,
              "isOrigin": true,
              "label": "Xingdong",
              "phoneticLabel": null,
              "searchText": "ntg xingdong china nantong",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BHY",
              "cityName": "Beihai",
              "code": "BHY",
              "countryName": "China",
              "displayText": "Beihai, Fucheng",
              "isDestination": true,
              "isOrigin": true,
              "label": "Fucheng",
              "phoneticLabel": null,
              "searchText": "bhy fucheng china beihai",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HZH",
              "cityName": "Liping",
              "code": "HZH",
              "countryName": "China",
              "displayText": "Liping, Liping",
              "isDestination": true,
              "isOrigin": true,
              "label": "Liping",
              "phoneticLabel": null,
              "searchText": "hzh liping china liping",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SYX",
              "cityName": "Sanya",
              "code": "SYX",
              "countryName": "China",
              "displayText": "Sanya, Phoenix International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Phoenix International Airport",
              "phoneticLabel": null,
              "searchText": "syx phoenix international airport china sanya",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KWE",
              "cityName": "Guiyang",
              "code": "KWE",
              "countryName": "China",
              "displayText": "Guiyang, Longdongbao Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Longdongbao Airport",
              "phoneticLabel": null,
              "searchText": "kwe longdongbao airport china guiyang",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LYI",
              "cityName": "Linyi",
              "code": "LYI",
              "countryName": "China",
              "displayText": "Linyi, Shubuling Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Shubuling Airport",
              "phoneticLabel": null,
              "searchText": "lyi shubuling airport china linyi",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TAO",
              "cityName": "Qingdao",
              "code": "TAO",
              "countryName": "China",
              "displayText": "Qingdao, Qingdao Jiaodong International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Qingdao Jiaodong International Airport",
              "phoneticLabel": null,
              "searchText": "tao qingdao jiaodong international airport china qingdao",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TNA",
              "cityName": "Jinan",
              "code": "TNA",
              "countryName": "China",
              "displayText": "Jinan, Yaoqiang Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Yaoqiang Airport",
              "phoneticLabel": null,
              "searchText": "tna yaoqiang airport china jinan",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YNT",
              "cityName": "Yantai",
              "code": "YNT",
              "countryName": "China",
              "displayText": "Yantai, Laishan",
              "isDestination": true,
              "isOrigin": true,
              "label": "Laishan",
              "phoneticLabel": null,
              "searchText": "ynt laishan china yantai",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SWA",
              "cityName": "Shantou",
              "code": "SWA",
              "countryName": "China",
              "displayText": "Shantou, Jieyang Chaoshan Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Jieyang Chaoshan Airport",
              "phoneticLabel": null,
              "searchText": "swa jieyang chaoshan airport china shantou",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NNY",
              "cityName": "Nanyang",
              "code": "NNY",
              "countryName": "China",
              "displayText": "Nanyang, Jiangying",
              "isDestination": true,
              "isOrigin": true,
              "label": "Jiangying",
              "phoneticLabel": null,
              "searchText": "nny jiangying china nanyang",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ZUH",
              "cityName": "Zhuhai",
              "code": "ZUH",
              "countryName": "China",
              "displayText": "Zhuhai, Zhuhai Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Zhuhai Airport",
              "phoneticLabel": null,
              "searchText": "zuh zhuhai airport china zhuhai",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HAK",
              "cityName": "Haikou",
              "code": "HAK",
              "countryName": "China",
              "displayText": "Haikou, Meilan International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Meilan International Airport",
              "phoneticLabel": null,
              "searchText": "hak meilan international airport china haikou",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "AQG",
              "cityName": "Anqing",
              "code": "AQG",
              "countryName": "China",
              "displayText": "Anqing, Anqing Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Anqing Airport",
              "phoneticLabel": null,
              "searchText": "aqg anqing airport china anqing",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BJS",
              "cityName": "Beijing",
              "code": "BJS",
              "countryName": "China",
              "displayText": "Beijing",
              "isDestination": true,
              "isOrigin": true,
              "label": "Beijing",
              "phoneticLabel": null,
              "searchText": "bjs beijing china",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "BJS",
              "cityName": "Beijing",
              "code": "PEK",
              "countryName": "China",
              "displayText": "Beijing, Beijing Capital International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Beijing Capital International Airport",
              "phoneticLabel": null,
              "searchText": "pek beijing capital international airport china beijing",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BJS",
              "cityName": "Beijing",
              "code": "PKX",
              "countryName": "China",
              "displayText": "Beijing, Beijing Daxing International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Beijing Daxing International Airport",
              "phoneticLabel": null,
              "searchText": "pkx beijing daxing international airport china beijing",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CGQ",
              "cityName": "Changchun",
              "code": "CGQ",
              "countryName": "China",
              "displayText": "Changchun, Changchun Longjia International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Changchun Longjia International Airport",
              "phoneticLabel": null,
              "searchText": "cgq changchun longjia international airport china changchun",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TYN",
              "cityName": "Taiyuan",
              "code": "TYN",
              "countryName": "China",
              "displayText": "Taiyuan, Taiyuan Wusu Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Taiyuan Wusu Airport",
              "phoneticLabel": null,
              "searchText": "tyn taiyuan wusu airport china taiyuan",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "WUS",
              "cityName": "Wuyishan",
              "code": "WUS",
              "countryName": "China",
              "displayText": "Wuyishan, Wuyishan",
              "isDestination": true,
              "isOrigin": false,
              "label": "Wuyishan",
              "phoneticLabel": null,
              "searchText": "wus wuyishan china wuyishan",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CGD",
              "cityName": "Changde",
              "code": "CGD",
              "countryName": "China",
              "displayText": "Changde, Taohuayuan",
              "isDestination": true,
              "isOrigin": true,
              "label": "Taohuayuan",
              "phoneticLabel": null,
              "searchText": "cgd taohuayuan china changde",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LHW",
              "cityName": "Lanzhou",
              "code": "LHW",
              "countryName": "China",
              "displayText": "Lanzhou, Zhongchuan",
              "isDestination": true,
              "isOrigin": true,
              "label": "Zhongchuan",
              "phoneticLabel": null,
              "searchText": "lhw zhongchuan china lanzhou",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MXZ",
              "cityName": "Meixian",
              "code": "MXZ",
              "countryName": "China",
              "displayText": "Meixian, Meixian",
              "isDestination": true,
              "isOrigin": true,
              "label": "Meixian",
              "phoneticLabel": null,
              "searchText": "mxz meixian china meixian",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "URC",
              "cityName": "Urumqi",
              "code": "URC",
              "countryName": "China",
              "displayText": "Urumqi, Diwopu Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Diwopu Airport",
              "phoneticLabel": null,
              "searchText": "urc diwopu airport china urumqi",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "INC",
              "cityName": "Yinchuan",
              "code": "INC",
              "countryName": "China",
              "displayText": "Yinchuan, Hedong",
              "isDestination": true,
              "isOrigin": true,
              "label": "Hedong",
              "phoneticLabel": null,
              "searchText": "inc hedong china yinchuan",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YIH",
              "cityName": "Yichang",
              "code": "YIH",
              "countryName": "China",
              "displayText": "Yichang, Sanxia",
              "isDestination": true,
              "isOrigin": true,
              "label": "Sanxia",
              "phoneticLabel": null,
              "searchText": "yih sanxia china yichang",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "WNZ",
              "cityName": "Wenzhou",
              "code": "WNZ",
              "countryName": "China",
              "displayText": "Wenzhou, Yongqiang Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Yongqiang Airport",
              "phoneticLabel": null,
              "searchText": "wnz yongqiang airport china wenzhou",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "JGS",
              "cityName": "Ji'an",
              "code": "JGS",
              "countryName": "China",
              "displayText": "Ji'an, Jinggangshan Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Jinggangshan Airport",
              "phoneticLabel": null,
              "searchText": "jgs jinggangshan airport china ji'an",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CAN",
              "cityName": "Guangzhou",
              "code": "CAN",
              "countryName": "China",
              "displayText": "Guangzhou, Guangzhou Baiyun International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Guangzhou Baiyun International Airport",
              "phoneticLabel": null,
              "searchText": "can guangzhou baiyun international airport china guangzhou",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "DLC",
              "cityName": "Dalian",
              "code": "DLC",
              "countryName": "China",
              "displayText": "Dalian, Dalian Zhoushuizi International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Dalian Zhoushuizi International Airport",
              "phoneticLabel": null,
              "searchText": "dlc dalian zhoushuizi international airport china dalian",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NKG",
              "cityName": "Nanjing",
              "code": "NKG",
              "countryName": "China",
              "displayText": "Nanjing, Lukou International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Lukou International Airport",
              "phoneticLabel": null,
              "searchText": "nkg lukou international airport china nanjing",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "WUX",
              "cityName": "Wuxi",
              "code": "WUX",
              "countryName": "China",
              "displayText": "Wuxi, Sunan Shuofang",
              "isDestination": true,
              "isOrigin": true,
              "label": "Sunan Shuofang",
              "phoneticLabel": null,
              "searchText": "wux sunan shuofang china wuxi",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YNZ",
              "cityName": "Yancheng",
              "code": "YNZ",
              "countryName": "China",
              "displayText": "Yancheng, Yancheng Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Yancheng Airport",
              "phoneticLabel": null,
              "searchText": "ynz yancheng airport china yancheng",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "FUG",
              "cityName": "Fuyang",
              "code": "FUG",
              "countryName": "China",
              "displayText": "Fuyang, Xiguan",
              "isDestination": true,
              "isOrigin": true,
              "label": "Xiguan",
              "phoneticLabel": null,
              "searchText": "fug xiguan china fuyang",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LJG",
              "cityName": "Lijiang",
              "code": "LJG",
              "countryName": "China",
              "displayText": "Lijiang, Lijiang Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Lijiang Airport",
              "phoneticLabel": null,
              "searchText": "ljg lijiang airport china lijiang",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "XUZ",
              "cityName": "Xuzhou",
              "code": "XUZ",
              "countryName": "China",
              "displayText": "Xuzhou, Guanyin",
              "isDestination": true,
              "isOrigin": true,
              "label": "Guanyin",
              "phoneticLabel": null,
              "searchText": "xuz guanyin china xuzhou",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CGO",
              "cityName": "Zhengzhou",
              "code": "CGO",
              "countryName": "China",
              "displayText": "Zhengzhou, Zhengzhou Xinzheng International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Zhengzhou Xinzheng International Airport",
              "phoneticLabel": null,
              "searchText": "cgo zhengzhou xinzheng international airport china zhengzhou",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HFE",
              "cityName": "Hefei",
              "code": "HFE",
              "countryName": "China",
              "displayText": "Hefei, Luogang International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Luogang International Airport",
              "phoneticLabel": null,
              "searchText": "hfe luogang international airport china hefei",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KOW",
              "cityName": "Ganzhou",
              "code": "KOW",
              "countryName": "China",
              "displayText": "Ganzhou, Huangjin",
              "isDestination": true,
              "isOrigin": true,
              "label": "Huangjin",
              "phoneticLabel": null,
              "searchText": "kow huangjin china ganzhou",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "FOC",
              "cityName": "Fuzhou",
              "code": "FOC",
              "countryName": "China",
              "displayText": "Fuzhou, Fuzhou Changle International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Fuzhou Changle International Airport",
              "phoneticLabel": null,
              "searchText": "foc fuzhou changle international airport china fuzhou",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KHN",
              "cityName": "Nanchang",
              "code": "KHN",
              "countryName": "China",
              "displayText": "Nanchang, Changbei International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Changbei International Airport",
              "phoneticLabel": null,
              "searchText": "khn changbei international airport china nanchang",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SIA",
              "cityName": "Xi'an",
              "code": "SIA",
              "countryName": "China",
              "displayText": "Xi'an",
              "isDestination": true,
              "isOrigin": true,
              "label": "Xi'an",
              "phoneticLabel": null,
              "searchText": "sia xi'an china",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "SIA",
              "cityName": "Xi'an",
              "code": "XIY",
              "countryName": "China",
              "displayText": "Xi'an, Xianyang Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Xianyang Airport",
              "phoneticLabel": null,
              "searchText": "xiy xianyang airport china xi'an",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SIA",
              "cityName": "Xi'an",
              "code": "SIA",
              "countryName": "China",
              "displayText": "Xi'an, Xiguan Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Xiguan Airport",
              "phoneticLabel": null,
              "searchText": "sia xiguan airport china xi'an",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "WUH",
              "cityName": "Wuhan",
              "code": "WUH",
              "countryName": "China",
              "displayText": "Wuhan, Tianhe Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Tianhe Airport",
              "phoneticLabel": null,
              "searchText": "wuh tianhe airport china wuhan",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "XMN",
              "cityName": "Xiamen",
              "code": "XMN",
              "countryName": "China",
              "displayText": "Xiamen, Gaoqi International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Gaoqi International Airport",
              "phoneticLabel": null,
              "searchText": "xmn gaoqi international airport china xiamen",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LXA",
              "cityName": "Lhasa",
              "code": "LXA",
              "countryName": "China",
              "displayText": "Lhasa, Lhasa",
              "isDestination": true,
              "isOrigin": true,
              "label": "Lhasa",
              "phoneticLabel": null,
              "searchText": "lxa lhasa china lhasa",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HGH",
              "cityName": "Hangzhou",
              "code": "HGH",
              "countryName": "China",
              "displayText": "Hangzhou, Shanghai Area - Xiaoshan International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Shanghai Area - Xiaoshan International Airport",
              "phoneticLabel": null,
              "searchText": "hgh shanghai area - xiaoshan international airport china hangzhou",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CTU",
              "cityName": "Chengdu",
              "code": "CTU",
              "countryName": "China",
              "displayText": "Chengdu",
              "isDestination": true,
              "isOrigin": true,
              "label": "Chengdu",
              "phoneticLabel": null,
              "searchText": "ctu chengdu china",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "CTU",
              "cityName": "Chengdu",
              "code": "TFU",
              "countryName": "China",
              "displayText": "Chengdu, Chengdu Tianfu International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Chengdu Tianfu International Airport",
              "phoneticLabel": null,
              "searchText": "tfu chengdu tianfu international airport china chengdu",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CTU",
              "cityName": "Chengdu",
              "code": "CTU",
              "countryName": "China",
              "displayText": "Chengdu, Chengdu Shuangliu International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Chengdu Shuangliu International Airport",
              "phoneticLabel": null,
              "searchText": "ctu chengdu shuangliu international airport china chengdu",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SHE",
              "cityName": "Shenyang",
              "code": "SHE",
              "countryName": "China",
              "displayText": "Shenyang, Taoxian International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Taoxian International Airport",
              "phoneticLabel": null,
              "searchText": "she taoxian international airport china shenyang",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CZX",
              "cityName": "Changzhou",
              "code": "CZX",
              "countryName": "China",
              "displayText": "Changzhou, Benniu",
              "isDestination": true,
              "isOrigin": true,
              "label": "Benniu",
              "phoneticLabel": null,
              "searchText": "czx benniu china changzhou",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CIH",
              "cityName": "Changzhi",
              "code": "CIH",
              "countryName": "China",
              "displayText": "Changzhi, Wangcun",
              "isDestination": true,
              "isOrigin": true,
              "label": "Wangcun",
              "phoneticLabel": null,
              "searchText": "cih wangcun china changzhi",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SHA",
              "cityName": "Shanghai",
              "code": "SHA",
              "countryName": "China",
              "displayText": "Shanghai",
              "isDestination": true,
              "isOrigin": true,
              "label": "Shanghai",
              "phoneticLabel": null,
              "searchText": "sha shanghai china",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "SHA",
              "cityName": "Shanghai",
              "code": "SHA",
              "countryName": "China",
              "displayText": "Shanghai, Hongqiao International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Hongqiao International Airport",
              "phoneticLabel": null,
              "searchText": "sha hongqiao international airport china shanghai",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SHA",
              "cityName": "Shanghai",
              "code": "PVG",
              "countryName": "China",
              "displayText": "Shanghai, Pudong International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Pudong International Airport",
              "phoneticLabel": null,
              "searchText": "pvg pudong international airport china shanghai",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YNJ",
              "cityName": "Yanji",
              "code": "YNJ",
              "countryName": "China",
              "displayText": "Yanji, Chaoyangchuan Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Chaoyangchuan Airport",
              "phoneticLabel": null,
              "searchText": "ynj chaoyangchuan airport china yanji",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NAO",
              "cityName": "Nanchong",
              "code": "NAO",
              "countryName": "China",
              "displayText": "Nanchong, Nanchong Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Nanchong Airport",
              "phoneticLabel": null,
              "searchText": "nao nanchong airport china nanchong",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TSN",
              "cityName": "Tianjin",
              "code": "TSN",
              "countryName": "China",
              "displayText": "Tianjin, Beijing Area - Binhai International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Beijing Area - Binhai International Airport",
              "phoneticLabel": null,
              "searchText": "tsn beijing area - binhai international airport china tianjin",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HRB",
              "cityName": "Harbin",
              "code": "HRB",
              "countryName": "China",
              "displayText": "Harbin, Taiping International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Taiping International Airport",
              "phoneticLabel": null,
              "searchText": "hrb taiping international airport china harbin",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KMG",
              "cityName": "Kunming",
              "code": "KMG",
              "countryName": "China",
              "displayText": "Kunming, Kunming Changshui International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kunming Changshui International Airport",
              "phoneticLabel": null,
              "searchText": "kmg kunming changshui international airport china kunming",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "XNN",
              "cityName": "Xining",
              "code": "XNN",
              "countryName": "China",
              "displayText": "Xining, Caojiabu Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Caojiabu Airport",
              "phoneticLabel": null,
              "searchText": "xnn caojiabu airport china xining",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ZHA",
              "cityName": "Zhanjiang",
              "code": "ZHA",
              "countryName": "China",
              "displayText": "Zhanjiang, Zhanjiang",
              "isDestination": true,
              "isOrigin": true,
              "label": "Zhanjiang",
              "phoneticLabel": null,
              "searchText": "zha zhanjiang china zhanjiang",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "JNG",
              "cityName": "Jining",
              "code": "JNG",
              "countryName": "China",
              "displayText": "Jining, Jining Qufu Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Jining Qufu Airport",
              "phoneticLabel": null,
              "searchText": "jng jining qufu airport china jining",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SZX",
              "cityName": "Shenzhen",
              "code": "SZX",
              "countryName": "China",
              "displayText": "Shenzhen, Bao'an International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Bao'an International Airport",
              "phoneticLabel": null,
              "searchText": "szx bao'an international airport china shenzhen",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NNG",
              "cityName": "Nanning",
              "code": "NNG",
              "countryName": "China",
              "displayText": "Nanning, Wuxu Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Wuxu Airport",
              "phoneticLabel": null,
              "searchText": "nng wuxu airport china nanning",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "XFN",
              "cityName": "Xiangyang",
              "code": "XFN",
              "countryName": "China",
              "displayText": "Xiangyang, Xiangfan Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Xiangfan Airport",
              "phoneticLabel": null,
              "searchText": "xfn xiangfan airport china xiangyang",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YIW",
              "cityName": "Yiwu",
              "code": "YIW",
              "countryName": "China",
              "displayText": "Yiwu, Yiwu",
              "isDestination": true,
              "isOrigin": true,
              "label": "Yiwu",
              "phoneticLabel": null,
              "searchText": "yiw yiwu china yiwu",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TXN",
              "cityName": "Huangshan",
              "code": "TXN",
              "countryName": "China",
              "displayText": "Huangshan, Tunxi International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Tunxi International Airport",
              "phoneticLabel": null,
              "searchText": "txn tunxi international airport china huangshan",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HDG",
              "cityName": "Handan",
              "code": "HDG",
              "countryName": "China",
              "displayText": "Handan, Handan Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Handan Airport",
              "phoneticLabel": null,
              "searchText": "hdg handan airport china handan",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HET",
              "cityName": "Hohhot",
              "code": "HET",
              "countryName": "China",
              "displayText": "Hohhot, Baita International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Baita International Airport",
              "phoneticLabel": null,
              "searchText": "het baita international airport china hohhot",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KWL",
              "cityName": "Guilin",
              "code": "KWL",
              "countryName": "China",
              "displayText": "Guilin, Liangjiang International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Liangjiang International Airport",
              "phoneticLabel": null,
              "searchText": "kwl liangjiang international airport china guilin",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LYA",
              "cityName": "Luoyang",
              "code": "LYA",
              "countryName": "China",
              "displayText": "Luoyang, Beijiao",
              "isDestination": true,
              "isOrigin": true,
              "label": "Beijiao",
              "phoneticLabel": null,
              "searchText": "lya beijiao china luoyang",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LZH",
              "cityName": "Liuzhou",
              "code": "LZH",
              "countryName": "China",
              "displayText": "Liuzhou, Liuzhou Bailian Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Liuzhou Bailian Airport",
              "phoneticLabel": null,
              "searchText": "lzh liuzhou bailian airport china liuzhou",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LYG",
              "cityName": "Lianyungang",
              "code": "LYG",
              "countryName": "China",
              "displayText": "Lianyungang, Baitabu",
              "isDestination": true,
              "isOrigin": true,
              "label": "Baitabu",
              "phoneticLabel": null,
              "searchText": "lyg baitabu china lianyungang",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CSX",
              "cityName": "Changsha",
              "code": "CSX",
              "countryName": "China",
              "displayText": "Changsha, Changsha Huanghua International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Changsha Huanghua International Airport",
              "phoneticLabel": null,
              "searchText": "csx changsha huanghua international airport china changsha",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "WEH",
              "cityName": "Weihai",
              "code": "WEH",
              "countryName": "China",
              "displayText": "Weihai, Dashuibo",
              "isDestination": true,
              "isOrigin": true,
              "label": "Dashuibo",
              "phoneticLabel": null,
              "searchText": "weh dashuibo china weihai",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "JZH",
              "cityName": "Jiuzhaigou",
              "code": "JZH",
              "countryName": "China",
              "displayText": "Jiuzhaigou, Jiuzhai Huanglong Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Jiuzhai Huanglong Airport",
              "phoneticLabel": null,
              "searchText": "jzh jiuzhai huanglong airport china jiuzhaigou",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BAK",
              "cityName": "Baku",
              "code": "GYD",
              "countryName": "Azerbaijan",
              "displayText": "Baku, Heydar Aliyev International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Heydar Aliyev International Airport",
              "phoneticLabel": null,
              "searchText": "gyd heydar aliyev international airport azerbaijan baku",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "GZT",
              "cityName": "Gaziantep",
              "code": "GZT",
              "countryName": "Turkey",
              "displayText": "Gaziantep, Oguzeli Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Oguzeli Airport",
              "phoneticLabel": null,
              "searchText": "gzt oguzeli airport turkey gaziantep",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SFQ",
              "cityName": "Sanliurfa",
              "code": "GNY",
              "countryName": "Turkey",
              "displayText": "Sanliurfa, Guney Anadolu Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Guney Anadolu Airport",
              "phoneticLabel": null,
              "searchText": "gny guney anadolu airport turkey sanliurfa",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ERC",
              "cityName": "Erzincan",
              "code": "ERC",
              "countryName": "Turkey",
              "displayText": "Erzincan, Erzincan Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Erzincan Airport",
              "phoneticLabel": null,
              "searchText": "erc erzincan airport turkey erzincan",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KYA",
              "cityName": "Konya",
              "code": "KYA",
              "countryName": "Turkey",
              "displayText": "Konya, Konya Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Konya Airport",
              "phoneticLabel": null,
              "searchText": "kya konya airport turkey konya",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "DIY",
              "cityName": "Diyarbakir",
              "code": "DIY",
              "countryName": "Turkey",
              "displayText": "Diyarbakir, Diyarbakir Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Diyarbakir Airport",
              "phoneticLabel": null,
              "searchText": "diy diyarbakir airport turkey diyarbakir",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TZX",
              "cityName": "Trabzon",
              "code": "TZX",
              "countryName": "Turkey",
              "displayText": "Trabzon, Trabzon Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Trabzon Airport",
              "phoneticLabel": null,
              "searchText": "tzx trabzon airport turkey trabzon",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MSR",
              "cityName": "Mus",
              "code": "MSR",
              "countryName": "Turkey",
              "displayText": "Mus, Mus Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Mus Airport",
              "phoneticLabel": null,
              "searchText": "msr mus airport turkey mus",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MLX",
              "cityName": "Malatya",
              "code": "MLX",
              "countryName": "Turkey",
              "displayText": "Malatya, Erhac Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Erhac Airport",
              "phoneticLabel": null,
              "searchText": "mlx erhac airport turkey malatya",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "VAN",
              "cityName": "Van",
              "code": "VAN",
              "countryName": "Turkey",
              "displayText": "Van, Ferit Melen Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Ferit Melen Airport",
              "phoneticLabel": null,
              "searchText": "van ferit melen airport turkey van",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KZR",
              "cityName": "Kutahya",
              "code": "KZR",
              "countryName": "Turkey",
              "displayText": "Kutahya, Zafer Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Zafer Airport",
              "phoneticLabel": null,
              "searchText": "kzr zafer airport turkey kutahya",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SZF",
              "cityName": "Samsun",
              "code": "SZF",
              "countryName": "Turkey",
              "displayText": "Samsun, Carsamba Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Carsamba Airport",
              "phoneticLabel": null,
              "searchText": "szf carsamba airport turkey samsun",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MQM",
              "cityName": "Mardin",
              "code": "MQM",
              "countryName": "Turkey",
              "displayText": "Mardin, Mardin Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Mardin Airport",
              "phoneticLabel": null,
              "searchText": "mqm mardin airport turkey mardin",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "DNZ",
              "cityName": "Denizli",
              "code": "DNZ",
              "countryName": "Turkey",
              "displayText": "Denizli, Çardak Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Çardak Airport",
              "phoneticLabel": null,
              "searchText": "dnz çardak airport turkey denizli",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BAL",
              "cityName": "Batman",
              "code": "BAL",
              "countryName": "Turkey",
              "displayText": "Batman, Batman Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Batman Airport",
              "phoneticLabel": null,
              "searchText": "bal batman airport turkey batman",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ERZ",
              "cityName": "Erzurum",
              "code": "ERZ",
              "countryName": "Turkey",
              "displayText": "Erzurum, Erzurum Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Erzurum Airport",
              "phoneticLabel": null,
              "searchText": "erz erzurum airport turkey erzurum",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "GZP",
              "cityName": "Gazipasa",
              "code": "GZP",
              "countryName": "Turkey",
              "displayText": "Gazipasa, Gazipasa Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Gazipasa Airport",
              "phoneticLabel": null,
              "searchText": "gzp gazipasa airport turkey gazipasa",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "EZS",
              "cityName": "Elazig",
              "code": "EZS",
              "countryName": "Turkey",
              "displayText": "Elazig, Elazig Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Elazig Airport",
              "phoneticLabel": null,
              "searchText": "ezs elazig airport turkey elazig",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MZH",
              "cityName": "Amasya",
              "code": "MZH",
              "countryName": "Turkey",
              "displayText": "Amasya, Merzifon Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Merzifon Airport",
              "phoneticLabel": null,
              "searchText": "mzh merzifon airport turkey amasya",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "VAS",
              "cityName": "Sivas",
              "code": "VAS",
              "countryName": "Turkey",
              "displayText": "Sivas, Sivas Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Sivas Airport",
              "phoneticLabel": null,
              "searchText": "vas sivas airport turkey sivas",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "AYT",
              "cityName": "Antalya",
              "code": "AYT",
              "countryName": "Turkey",
              "displayText": "Antalya, Antalya Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Antalya Airport",
              "phoneticLabel": null,
              "searchText": "ayt antalya airport turkey antalya",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "IST",
              "cityName": "Istanbul",
              "code": "IST",
              "countryName": "Turkey",
              "displayText": "Istanbul",
              "isDestination": true,
              "isOrigin": true,
              "label": "Istanbul",
              "phoneticLabel": null,
              "searchText": "ist istanbul turkey",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "IST",
              "cityName": "Istanbul",
              "code": "IST",
              "countryName": "Turkey",
              "displayText": "Istanbul, Istanbul Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Istanbul Airport",
              "phoneticLabel": null,
              "searchText": "ist istanbul airport turkey istanbul",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "IST",
              "cityName": "Istanbul",
              "code": "SAW",
              "countryName": "Turkey",
              "displayText": "Istanbul, Sabiha Gokcen Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Sabiha Gokcen Airport",
              "phoneticLabel": null,
              "searchText": "saw sabiha gokcen airport turkey istanbul",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HTY",
              "cityName": "Hatay",
              "code": "HTY",
              "countryName": "Turkey",
              "displayText": "Hatay, Hatay Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Hatay Airport",
              "phoneticLabel": null,
              "searchText": "hty hatay airport turkey hatay",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "DLM",
              "cityName": "Dalaman",
              "code": "DLM",
              "countryName": "Turkey",
              "displayText": "Dalaman, Dalaman Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Dalaman Airport",
              "phoneticLabel": null,
              "searchText": "dlm dalaman airport turkey dalaman",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NAV",
              "cityName": "Nevsehir",
              "code": "NAV",
              "countryName": "Turkey",
              "displayText": "Nevsehir, Kapadokya Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kapadokya Airport",
              "phoneticLabel": null,
              "searchText": "nav kapadokya airport turkey nevsehir",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BXN",
              "cityName": "Bodrum",
              "code": "BJV",
              "countryName": "Turkey",
              "displayText": "Bodrum, Bodrum Milas Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Bodrum Milas Airport",
              "phoneticLabel": null,
              "searchText": "bjv bodrum milas airport turkey bodrum",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ANK",
              "cityName": "Ankara",
              "code": "ESB",
              "countryName": "Turkey",
              "displayText": "Ankara, Esenboga Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Esenboga Airport",
              "phoneticLabel": null,
              "searchText": "esb esenboga airport turkey ankara",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "IZM",
              "cityName": "Izmir",
              "code": "ADB",
              "countryName": "Turkey",
              "displayText": "Izmir, Adnan Menderes Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Adnan Menderes Airport",
              "phoneticLabel": null,
              "searchText": "adb adnan menderes airport turkey izmir",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ASR",
              "cityName": "Kayseri",
              "code": "ASR",
              "countryName": "Turkey",
              "displayText": "Kayseri, Erkilet Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Erkilet Airport",
              "phoneticLabel": null,
              "searchText": "asr erkilet airport turkey kayseri",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BZE",
              "cityName": "Belize City",
              "code": "BZE",
              "countryName": "Belize",
              "displayText": "Belize City, PSW Goldson International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "PSW Goldson International Airport",
              "phoneticLabel": null,
              "searchText": "bze psw goldson international airport belize belize city",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MLE",
              "cityName": "Malé",
              "code": "MLE",
              "countryName": "Maldives",
              "displayText": "Malé, Ibrahim Nasir International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Ibrahim Nasir International",
              "phoneticLabel": null,
              "searchText": "mle ibrahim nasir international maldives malé",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "VTE",
              "cityName": "Vientiane",
              "code": "VTE",
              "countryName": "Laos",
              "displayText": "Vientiane, Wattay",
              "isDestination": true,
              "isOrigin": true,
              "label": "Wattay",
              "phoneticLabel": null,
              "searchText": "vte wattay laos vientiane",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LPQ",
              "cityName": "Luang Prabang",
              "code": "LPQ",
              "countryName": "Laos",
              "displayText": "Luang Prabang, Luang Prabang",
              "isDestination": true,
              "isOrigin": true,
              "label": "Luang Prabang",
              "phoneticLabel": null,
              "searchText": "lpq luang prabang laos luang prabang",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "IKT",
              "cityName": "Irkutsk",
              "code": "IKT",
              "countryName": "Russia",
              "displayText": "Irkutsk, Irkutsk",
              "isDestination": true,
              "isOrigin": true,
              "label": "Irkutsk",
              "phoneticLabel": null,
              "searchText": "ikt irkutsk russia irkutsk",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MRV",
              "cityName": "Mineralnye Vody",
              "code": "MRV",
              "countryName": "Russia",
              "displayText": "Mineralnye Vody, Mineralnye Vody",
              "isDestination": true,
              "isOrigin": true,
              "label": "Mineralnye Vody",
              "phoneticLabel": null,
              "searchText": "mrv mineralnye vody russia mineralnye vody",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CEK",
              "cityName": "Chelyabinsk",
              "code": "CEK",
              "countryName": "Russia",
              "displayText": "Chelyabinsk, Balandino",
              "isDestination": true,
              "isOrigin": true,
              "label": "Balandino",
              "phoneticLabel": null,
              "searchText": "cek balandino russia chelyabinsk",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KHV",
              "cityName": "Khabarovsk",
              "code": "KHV",
              "countryName": "Russia",
              "displayText": "Khabarovsk, Novyy Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Novyy Airport",
              "phoneticLabel": null,
              "searchText": "khv novyy airport russia khabarovsk",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NJC",
              "cityName": "Nizhnevartovsk",
              "code": "NJC",
              "countryName": "Russia",
              "displayText": "Nizhnevartovsk, Nizhnevartovsk",
              "isDestination": true,
              "isOrigin": true,
              "label": "Nizhnevartovsk",
              "phoneticLabel": null,
              "searchText": "njc nizhnevartovsk russia nizhnevartovsk",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "VVO",
              "cityName": "Vladivostok",
              "code": "VVO",
              "countryName": "Russia",
              "displayText": "Vladivostok, Vladivostok International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Vladivostok International Airport",
              "phoneticLabel": null,
              "searchText": "vvo vladivostok international airport russia vladivostok",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KZN",
              "cityName": "Kazan",
              "code": "KZN",
              "countryName": "Russia",
              "displayText": "Kazan, Kazan International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kazan International Airport",
              "phoneticLabel": null,
              "searchText": "kzn kazan international airport russia kazan",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TJM",
              "cityName": "Tyumen",
              "code": "TJM",
              "countryName": "Russia",
              "displayText": "Tyumen, Roshchino",
              "isDestination": true,
              "isOrigin": true,
              "label": "Roshchino",
              "phoneticLabel": null,
              "searchText": "tjm roshchino russia tyumen",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "UFA",
              "cityName": "Ufa",
              "code": "UFA",
              "countryName": "Russia",
              "displayText": "Ufa, Ufa",
              "isDestination": true,
              "isOrigin": true,
              "label": "Ufa",
              "phoneticLabel": null,
              "searchText": "ufa ufa russia ufa",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PEE",
              "cityName": "Perm",
              "code": "PEE",
              "countryName": "Russia",
              "displayText": "Perm, Bolshoye Savino Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Bolshoye Savino Airport",
              "phoneticLabel": null,
              "searchText": "pee bolshoye savino airport russia perm",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MOW",
              "cityName": "Moscow",
              "code": "MOW",
              "countryName": "Russia",
              "displayText": "Moscow",
              "isDestination": true,
              "isOrigin": true,
              "label": "Moscow",
              "phoneticLabel": null,
              "searchText": "mow moscow russia",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "MOW",
              "cityName": "Moscow",
              "code": "SVO",
              "countryName": "Russia",
              "displayText": "Moscow, Sheremetyevo Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Sheremetyevo Airport",
              "phoneticLabel": null,
              "searchText": "svo sheremetyevo airport russia moscow",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MOW",
              "cityName": "Moscow",
              "code": "VKO",
              "countryName": "Russia",
              "displayText": "Moscow, Vnukovo International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Vnukovo International Airport",
              "phoneticLabel": null,
              "searchText": "vko vnukovo international airport russia moscow",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "VOG",
              "cityName": "Volgograd",
              "code": "VOG",
              "countryName": "Russia",
              "displayText": "Volgograd, Gumrak",
              "isDestination": true,
              "isOrigin": true,
              "label": "Gumrak",
              "phoneticLabel": null,
              "searchText": "vog gumrak russia volgograd",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "OVB",
              "cityName": "Novosibirsk",
              "code": "OVB",
              "countryName": "Russia",
              "displayText": "Novosibirsk, Tolmachevo",
              "isDestination": true,
              "isOrigin": true,
              "label": "Tolmachevo",
              "phoneticLabel": null,
              "searchText": "ovb tolmachevo russia novosibirsk",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KJA",
              "cityName": "Krasnoyarsk",
              "code": "KJA",
              "countryName": "Russia",
              "displayText": "Krasnoyarsk, Yemelyanovo",
              "isDestination": true,
              "isOrigin": true,
              "label": "Yemelyanovo",
              "phoneticLabel": null,
              "searchText": "kja yemelyanovo russia krasnoyarsk",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KUF",
              "cityName": "Samara",
              "code": "KUF",
              "countryName": "Russia",
              "displayText": "Samara, Kurumoch",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kurumoch",
              "phoneticLabel": null,
              "searchText": "kuf kurumoch russia samara",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "OMS",
              "cityName": "Omsk",
              "code": "OMS",
              "countryName": "Russia",
              "displayText": "Omsk, Tsentralny",
              "isDestination": true,
              "isOrigin": true,
              "label": "Tsentralny",
              "phoneticLabel": null,
              "searchText": "oms tsentralny russia omsk",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MMK",
              "cityName": "Murmansk",
              "code": "MMK",
              "countryName": "Russia",
              "displayText": "Murmansk, Murmansk Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Murmansk Airport",
              "phoneticLabel": null,
              "searchText": "mmk murmansk airport russia murmansk",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "AER",
              "cityName": "Sochi",
              "code": "AER",
              "countryName": "Russia",
              "displayText": "Sochi, Sochi International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Sochi International Airport",
              "phoneticLabel": null,
              "searchText": "aer sochi international airport russia sochi",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SVX",
              "cityName": "Yekaterinburg",
              "code": "SVX",
              "countryName": "Russia",
              "displayText": "Yekaterinburg, Koltsovo",
              "isDestination": true,
              "isOrigin": true,
              "label": "Koltsovo",
              "phoneticLabel": null,
              "searchText": "svx koltsovo russia yekaterinburg",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "UUS",
              "cityName": "Yuzhno Sakhalinsk",
              "code": "UUS",
              "countryName": "Russia",
              "displayText": "Yuzhno Sakhalinsk, Yuzhno-Sakhalinsk Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Yuzhno-Sakhalinsk Airport",
              "phoneticLabel": null,
              "searchText": "uus yuzhno-sakhalinsk airport russia yuzhno sakhalinsk",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "GOJ",
              "cityName": "Nizhny Novgorod",
              "code": "GOJ",
              "countryName": "Russia",
              "displayText": "Nizhny Novgorod, Strigino Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Strigino Airport",
              "phoneticLabel": null,
              "searchText": "goj strigino airport russia nizhny novgorod",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LED",
              "cityName": "St Petersburg",
              "code": "LED",
              "countryName": "Russia",
              "displayText": "St Petersburg, Pulkovo Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Pulkovo Airport",
              "phoneticLabel": null,
              "searchText": "led pulkovo airport russia st petersburg",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PBZ",
              "cityName": "Plettenberg",
              "code": "PBZ",
              "countryName": "South Africa",
              "displayText": "Plettenberg, Plettenberg Bay Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Plettenberg Bay Airport",
              "phoneticLabel": null,
              "searchText": "pbz plettenberg bay airport south africa plettenberg",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HDS",
              "cityName": "Hoedspruit",
              "code": "HDS",
              "countryName": "South Africa",
              "displayText": "Hoedspruit, Hoedspruit Air Force Base Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Hoedspruit Air Force Base Airport",
              "phoneticLabel": null,
              "searchText": "hds hoedspruit air force base airport south africa hoedspruit",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BFN",
              "cityName": "Bloemfontein",
              "code": "BFN",
              "countryName": "South Africa",
              "displayText": "Bloemfontein, Bloemfontein Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Bloemfontein Airport",
              "phoneticLabel": null,
              "searchText": "bfn bloemfontein airport south africa bloemfontein",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KIM",
              "cityName": "Kimberley",
              "code": "KIM",
              "countryName": "South Africa",
              "displayText": "Kimberley, Kimberley",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kimberley",
              "phoneticLabel": null,
              "searchText": "kim kimberley south africa kimberley",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PZB",
              "cityName": "Pietermaritzburg",
              "code": "PZB",
              "countryName": "South Africa",
              "displayText": "Pietermaritzburg, Pietermaritzburg Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Pietermaritzburg Airport",
              "phoneticLabel": null,
              "searchText": "pzb pietermaritzburg airport south africa pietermaritzburg",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ELS",
              "cityName": "East London",
              "code": "ELS",
              "countryName": "South Africa",
              "displayText": "East London, East London Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "East London Airport",
              "phoneticLabel": null,
              "searchText": "els east london airport south africa east london",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "DUR",
              "cityName": "Durban",
              "code": "DUR",
              "countryName": "South Africa",
              "displayText": "Durban, Durban International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Durban International Airport",
              "phoneticLabel": null,
              "searchText": "dur durban international airport south africa durban",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "UTT",
              "cityName": "Umtata",
              "code": "UTT",
              "countryName": "South Africa",
              "displayText": "Umtata, K.D. Matanzima Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "K.D. Matanzima Airport",
              "phoneticLabel": null,
              "searchText": "utt k.d. matanzima airport south africa umtata",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "UTN",
              "cityName": "Upington",
              "code": "UTN",
              "countryName": "South Africa",
              "displayText": "Upington, Upington Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Upington Airport",
              "phoneticLabel": null,
              "searchText": "utn upington airport south africa upington",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MQP",
              "cityName": "Nelspruit",
              "code": "MQP",
              "countryName": "South Africa",
              "displayText": "Nelspruit, Nelspruit Kruger Mpumalanga International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Nelspruit Kruger Mpumalanga International Airport",
              "phoneticLabel": null,
              "searchText": "mqp nelspruit kruger mpumalanga international airport south africa nelspruit",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CPT",
              "cityName": "Cape Town",
              "code": "CPT",
              "countryName": "South Africa",
              "displayText": "Cape Town, Cape Town International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Cape Town International Airport",
              "phoneticLabel": null,
              "searchText": "cpt cape town international airport south africa cape town",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SZK",
              "cityName": "Skukuza",
              "code": "SZK",
              "countryName": "South Africa",
              "displayText": "Skukuza, Skukuza Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Skukuza Airport",
              "phoneticLabel": null,
              "searchText": "szk skukuza airport south africa skukuza",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MGH",
              "cityName": "Margate",
              "code": "MGH",
              "countryName": "South Africa",
              "displayText": "Margate, Margate Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Margate Airport",
              "phoneticLabel": null,
              "searchText": "mgh margate airport south africa margate",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PLZ",
              "cityName": "Port Elizabeth",
              "code": "PLZ",
              "countryName": "South Africa",
              "displayText": "Port Elizabeth, Port Elizabeth Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Port Elizabeth Airport",
              "phoneticLabel": null,
              "searchText": "plz port elizabeth airport south africa port elizabeth",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "JNB",
              "cityName": "Johannesburg",
              "code": "JNB",
              "countryName": "South Africa",
              "displayText": "Johannesburg, O.R. Tambo International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "O.R. Tambo International Airport",
              "phoneticLabel": null,
              "searchText": "jnb o.r. tambo international airport south africa johannesburg",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SIS",
              "cityName": "Sishen",
              "code": "SIS",
              "countryName": "South Africa",
              "displayText": "Sishen, Sishen Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Sishen Airport",
              "phoneticLabel": null,
              "searchText": "sis sishen airport south africa sishen",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PTG",
              "cityName": "Polokwane",
              "code": "PTG",
              "countryName": "South Africa",
              "displayText": "Polokwane, Polokwane International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Polokwane International Airport",
              "phoneticLabel": null,
              "searchText": "ptg polokwane international airport south africa polokwane",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "RCB",
              "cityName": "Richards Bay",
              "code": "RCB",
              "countryName": "South Africa",
              "displayText": "Richards Bay, Richards Bay",
              "isDestination": true,
              "isOrigin": true,
              "label": "Richards Bay",
              "phoneticLabel": null,
              "searchText": "rcb richards bay south africa richards bay",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "GRJ",
              "cityName": "George",
              "code": "GRJ",
              "countryName": "South Africa",
              "displayText": "George, George Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "George Airport",
              "phoneticLabel": null,
              "searchText": "grj george airport south africa george",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BSR",
              "cityName": "Basrah",
              "code": "BSR",
              "countryName": "Iraq",
              "displayText": "Basrah, Basrah International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Basrah International",
              "phoneticLabel": null,
              "searchText": "bsr basrah international iraq basrah",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NJF",
              "cityName": "Al Najaf",
              "code": "NJF",
              "countryName": "Iraq",
              "displayText": "Al Najaf, Al-Ashraf International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Al-Ashraf International",
              "phoneticLabel": null,
              "searchText": "njf al-ashraf international iraq al najaf",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BGW",
              "cityName": "Baghdad",
              "code": "BGW",
              "countryName": "Iraq",
              "displayText": "Baghdad, Baghdad International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Baghdad International Airport",
              "phoneticLabel": null,
              "searchText": "bgw baghdad international airport iraq baghdad",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "EBL",
              "cityName": "Erbil",
              "code": "EBL",
              "countryName": "Iraq",
              "displayText": "Erbil, Erbil International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Erbil International",
              "phoneticLabel": null,
              "searchText": "ebl erbil international iraq erbil",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SHO",
              "cityName": "Manzini",
              "code": "SHO",
              "countryName": "Swaziland",
              "displayText": "Manzini, Manzini King Mswati III International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Manzini King Mswati III International Airport",
              "phoneticLabel": null,
              "searchText": "sho manzini king mswati iii international airport swaziland manzini",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LXR",
              "cityName": "Luxor",
              "code": "LXR",
              "countryName": "Egypt",
              "displayText": "Luxor, Luxor International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Luxor International Airport",
              "phoneticLabel": null,
              "searchText": "lxr luxor international airport egypt luxor",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SSH",
              "cityName": "Sharm El Sheikh",
              "code": "SSH",
              "countryName": "Egypt",
              "displayText": "Sharm El Sheikh, International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "International Airport",
              "phoneticLabel": null,
              "searchText": "ssh international airport egypt sharm el sheikh",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CAI",
              "cityName": "Cairo",
              "code": "CAI",
              "countryName": "Egypt",
              "displayText": "Cairo, Cairo International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Cairo International Airport",
              "phoneticLabel": null,
              "searchText": "cai cairo international airport egypt cairo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HRG",
              "cityName": "Hurghada",
              "code": "HRG",
              "countryName": "Egypt",
              "displayText": "Hurghada, Hurghada International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Hurghada International Airport",
              "phoneticLabel": null,
              "searchText": "hrg hurghada international airport egypt hurghada",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LAD",
              "cityName": "Luanda",
              "code": "LAD",
              "countryName": "Angola",
              "displayText": "Luanda, Quatro De Fevereiro Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Quatro De Fevereiro Airport",
              "phoneticLabel": null,
              "searchText": "lad quatro de fevereiro airport angola luanda",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "RAR",
              "cityName": "Rarotonga Island",
              "code": "RAR",
              "countryName": "Cook Islands",
              "displayText": "Rarotonga Island, Rarotonga Island",
              "isDestination": true,
              "isOrigin": true,
              "label": "Rarotonga Island",
              "phoneticLabel": null,
              "searchText": "rar rarotonga island cook islands rarotonga island",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BDA",
              "cityName": "Bermuda",
              "code": "BDA",
              "countryName": "Bermuda",
              "displayText": "Bermuda, Bermuda International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Bermuda International Airport",
              "phoneticLabel": null,
              "searchText": "bda bermuda international airport bermuda bermuda",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ULN",
              "cityName": "Ulaanbaatar",
              "code": "UBN",
              "countryName": "Mongolia",
              "displayText": "Ulaanbaatar, Chinggis Khaan International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Chinggis Khaan International Airport",
              "phoneticLabel": null,
              "searchText": "ubn chinggis khaan international airport mongolia ulaanbaatar",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "RIX",
              "cityName": "Riga",
              "code": "RIX",
              "countryName": "Latvia",
              "displayText": "Riga, Riga International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Riga International Airport",
              "phoneticLabel": null,
              "searchText": "rix riga international airport latvia riga",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "AQJ",
              "cityName": "Aqaba",
              "code": "AQJ",
              "countryName": "Jordan",
              "displayText": "Aqaba, King Hussein International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "King Hussein International Airport",
              "phoneticLabel": null,
              "searchText": "aqj king hussein international airport jordan aqaba",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "AMM",
              "cityName": "Amman",
              "code": "AMM",
              "countryName": "Jordan",
              "displayText": "Amman, Queen Alia International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Queen Alia International Airport",
              "phoneticLabel": null,
              "searchText": "amm queen alia international airport jordan amman",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "JOG",
              "cityName": "Yogyakarta",
              "code": "JOG",
              "countryName": "Indonesia",
              "displayText": "Yogyakarta",
              "isDestination": true,
              "isOrigin": true,
              "label": "Yogyakarta",
              "phoneticLabel": null,
              "searchText": "jog yogyakarta indonesia",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "JOG",
              "cityName": "Yogyakarta",
              "code": "YIA",
              "countryName": "Indonesia",
              "displayText": "Yogyakarta, New Yogyakarta International",
              "isDestination": true,
              "isOrigin": true,
              "label": "New Yogyakarta International",
              "phoneticLabel": null,
              "searchText": "yia new yogyakarta international indonesia yogyakarta",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "JOG",
              "cityName": "Yogyakarta",
              "code": "JOG",
              "countryName": "Indonesia",
              "displayText": "Yogyakarta, Yogyakarta Adisutjipto Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Yogyakarta Adisutjipto Airport",
              "phoneticLabel": null,
              "searchText": "jog yogyakarta adisutjipto airport indonesia yogyakarta",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SRG",
              "cityName": "Semarang",
              "code": "SRG",
              "countryName": "Indonesia",
              "displayText": "Semarang, Achmad Yani International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Achmad Yani International Airport",
              "phoneticLabel": null,
              "searchText": "srg achmad yani international airport indonesia semarang",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PDG",
              "cityName": "Padang",
              "code": "PDG",
              "countryName": "Indonesia",
              "displayText": "Padang, Minangkabau International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Minangkabau International Airport",
              "phoneticLabel": null,
              "searchText": "pdg minangkabau international airport indonesia padang",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BPN",
              "cityName": "Balikpapan",
              "code": "BPN",
              "countryName": "Indonesia",
              "displayText": "Balikpapan, Sepingan",
              "isDestination": true,
              "isOrigin": true,
              "label": "Sepingan",
              "phoneticLabel": null,
              "searchText": "bpn sepingan indonesia balikpapan",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MDC",
              "cityName": "Manado",
              "code": "MDC",
              "countryName": "Indonesia",
              "displayText": "Manado, Sam Ratulangi International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Sam Ratulangi International Airport",
              "phoneticLabel": null,
              "searchText": "mdc sam ratulangi international airport indonesia manado",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "UPG",
              "cityName": "Makassar",
              "code": "UPG",
              "countryName": "Indonesia",
              "displayText": "Makassar, Hasanudin",
              "isDestination": true,
              "isOrigin": true,
              "label": "Hasanudin",
              "phoneticLabel": null,
              "searchText": "upg hasanudin indonesia makassar",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BTH",
              "cityName": "Batam",
              "code": "BTH",
              "countryName": "Indonesia",
              "displayText": "Batam, Hang Nadim",
              "isDestination": true,
              "isOrigin": true,
              "label": "Hang Nadim",
              "phoneticLabel": null,
              "searchText": "bth hang nadim indonesia batam",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PLM",
              "cityName": "Palembang",
              "code": "PLM",
              "countryName": "Indonesia",
              "displayText": "Palembang, S.M. Badaruddin II Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "S.M. Badaruddin II Airport",
              "phoneticLabel": null,
              "searchText": "plm s.m. badaruddin ii airport indonesia palembang",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SOC",
              "cityName": "Surakarta Solo",
              "code": "SOC",
              "countryName": "Indonesia",
              "displayText": "Surakarta Solo, Adi Sumarmo",
              "isDestination": true,
              "isOrigin": true,
              "label": "Adi Sumarmo",
              "phoneticLabel": null,
              "searchText": "soc adi sumarmo indonesia surakarta solo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SUB",
              "cityName": "Surabaya",
              "code": "SUB",
              "countryName": "Indonesia",
              "displayText": "Surabaya, Juanda",
              "isDestination": true,
              "isOrigin": true,
              "label": "Juanda",
              "phoneticLabel": null,
              "searchText": "sub juanda indonesia surabaya",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PKU",
              "cityName": "Pekanbaru",
              "code": "PKU",
              "countryName": "Indonesia",
              "displayText": "Pekanbaru, Sultan Syarif Kasim II Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Sultan Syarif Kasim II Airport",
              "phoneticLabel": null,
              "searchText": "pku sultan syarif kasim ii airport indonesia pekanbaru",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BDJ",
              "cityName": "Banjarmasin",
              "code": "BDJ",
              "countryName": "Indonesia",
              "displayText": "Banjarmasin, Syamsudin Noor Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Syamsudin Noor Airport",
              "phoneticLabel": null,
              "searchText": "bdj syamsudin noor airport indonesia banjarmasin",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "DPS",
              "cityName": "Denpasar Bali",
              "code": "DPS",
              "countryName": "Indonesia",
              "displayText": "Denpasar Bali, Bali Island - Ngurah Rai International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Bali Island - Ngurah Rai International",
              "phoneticLabel": null,
              "searchText": "dps bali island - ngurah rai international indonesia denpasar bali",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "JKT",
              "cityName": "Jakarta",
              "code": "CGK",
              "countryName": "Indonesia",
              "displayText": "Jakarta, Soekarno-Hatta International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Soekarno-Hatta International",
              "phoneticLabel": null,
              "searchText": "cgk soekarno-hatta international indonesia jakarta",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KNO",
              "cityName": "Medan",
              "code": "KNO",
              "countryName": "Indonesia",
              "displayText": "Medan, Kuala Namu International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kuala Namu International",
              "phoneticLabel": null,
              "searchText": "kno kuala namu international indonesia medan",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SDQ",
              "cityName": "Santo Domingo",
              "code": "SDQ",
              "countryName": "Dominican Republic",
              "displayText": "Santo Domingo, Las Americas",
              "isDestination": true,
              "isOrigin": true,
              "label": "Las Americas",
              "phoneticLabel": null,
              "searchText": "sdq las americas dominican republic santo domingo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "STI",
              "cityName": "Santiago",
              "code": "STI",
              "countryName": "Dominican Republic",
              "displayText": "Santiago, Cibao International airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Cibao International airport",
              "phoneticLabel": null,
              "searchText": "sti cibao international airport dominican republic santiago",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PUJ",
              "cityName": "Punta Cana",
              "code": "PUJ",
              "countryName": "Dominican Republic",
              "displayText": "Punta Cana, Punta Cana International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Punta Cana International Airport",
              "phoneticLabel": null,
              "searchText": "puj punta cana international airport dominican republic punta cana",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TAS",
              "cityName": "Tashkent",
              "code": "TAS",
              "countryName": "Uzbekistan",
              "displayText": "Tashkent, Vostohny",
              "isDestination": true,
              "isOrigin": true,
              "label": "Vostohny",
              "phoneticLabel": null,
              "searchText": "tas vostohny uzbekistan tashkent",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SXM",
              "cityName": "St Martin",
              "code": "SXM",
              "countryName": "Saint Martin",
              "displayText": "St Martin, Princess Juliana International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Princess Juliana International Airport",
              "phoneticLabel": null,
              "searchText": "sxm princess juliana international airport saint martin st martin",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MPM",
              "cityName": "Maputo",
              "code": "MPM",
              "countryName": "Mozambique",
              "displayText": "Maputo, Maputo International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Maputo International Airport",
              "phoneticLabel": null,
              "searchText": "mpm maputo international airport mozambique maputo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "POL",
              "cityName": "Pemba",
              "code": "POL",
              "countryName": "Mozambique",
              "displayText": "Pemba, Pemba",
              "isDestination": true,
              "isOrigin": true,
              "label": "Pemba",
              "phoneticLabel": null,
              "searchText": "pol pemba mozambique pemba",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "VNX",
              "cityName": "Vilankulos",
              "code": "VNX",
              "countryName": "Mozambique",
              "displayText": "Vilankulos, Vilankulos Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Vilankulos Airport",
              "phoneticLabel": null,
              "searchText": "vnx vilankulos airport mozambique vilankulos",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "APL",
              "cityName": "Nampula",
              "code": "APL",
              "countryName": "Mozambique",
              "displayText": "Nampula, Nampula",
              "isDestination": true,
              "isOrigin": true,
              "label": "Nampula",
              "phoneticLabel": null,
              "searchText": "apl nampula mozambique nampula",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BEW",
              "cityName": "Beira",
              "code": "BEW",
              "countryName": "Mozambique",
              "displayText": "Beira, Beira Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Beira Airport",
              "phoneticLabel": null,
              "searchText": "bew beira airport mozambique beira",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SCL",
              "cityName": "Santiago de Chile",
              "code": "SCL",
              "countryName": "Chile",
              "displayText": "Santiago de Chile, Arturo Merino Benitez",
              "isDestination": true,
              "isOrigin": true,
              "label": "Arturo Merino Benitez",
              "phoneticLabel": null,
              "searchText": "scl arturo merino benitez chile santiago de chile",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "IPC",
              "cityName": "Easter Island",
              "code": "IPC",
              "countryName": "Chile",
              "displayText": "Easter Island, Mataveri International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Mataveri International",
              "phoneticLabel": null,
              "searchText": "ipc mataveri international chile easter island",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ZCO",
              "cityName": "Temuco",
              "code": "ZCO",
              "countryName": "Chile",
              "displayText": "Temuco, Maquehue Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Maquehue Airport",
              "phoneticLabel": null,
              "searchText": "zco maquehue airport chile temuco",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ZOS",
              "cityName": "Osorno",
              "code": "ZOS",
              "countryName": "Chile",
              "displayText": "Osorno, Osorno Canal Bajo Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Osorno Canal Bajo Airport",
              "phoneticLabel": null,
              "searchText": "zos osorno canal bajo airport chile osorno",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "WCA",
              "cityName": "Castro",
              "code": "MHC",
              "countryName": "Chile",
              "displayText": "Castro, Castro Mocopulli Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Castro Mocopulli Airport",
              "phoneticLabel": null,
              "searchText": "mhc castro mocopulli airport chile castro",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BBA",
              "cityName": "Balmaceda",
              "code": "BBA",
              "countryName": "Chile",
              "displayText": "Balmaceda, Balmaceda Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Balmaceda Airport",
              "phoneticLabel": null,
              "searchText": "bba balmaceda airport chile balmaceda",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ARI",
              "cityName": "Arica",
              "code": "ARI",
              "countryName": "Chile",
              "displayText": "Arica, Chacalluta International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Chacalluta International Airport",
              "phoneticLabel": null,
              "searchText": "ari chacalluta international airport chile arica",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ZAL",
              "cityName": "Valdivia",
              "code": "ZAL",
              "countryName": "Chile",
              "displayText": "Valdivia, Valdivia Pichoy Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Valdivia Pichoy Airport",
              "phoneticLabel": null,
              "searchText": "zal valdivia pichoy airport chile valdivia",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CJC",
              "cityName": "Calama",
              "code": "CJC",
              "countryName": "Chile",
              "displayText": "Calama, El Loa",
              "isDestination": true,
              "isOrigin": true,
              "label": "El Loa",
              "phoneticLabel": null,
              "searchText": "cjc el loa chile calama",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CPO",
              "cityName": "Copiapo",
              "code": "CPO",
              "countryName": "Chile",
              "displayText": "Copiapo, Desierto De Atacama",
              "isDestination": true,
              "isOrigin": true,
              "label": "Desierto De Atacama",
              "phoneticLabel": null,
              "searchText": "cpo desierto de atacama chile copiapo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PMC",
              "cityName": "Puerto Montt",
              "code": "PMC",
              "countryName": "Chile",
              "displayText": "Puerto Montt, Tepual",
              "isDestination": true,
              "isOrigin": true,
              "label": "Tepual",
              "phoneticLabel": null,
              "searchText": "pmc tepual chile puerto montt",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CCP",
              "cityName": "Concepcion",
              "code": "CCP",
              "countryName": "Chile",
              "displayText": "Concepcion, Carriel Sur",
              "isDestination": true,
              "isOrigin": true,
              "label": "Carriel Sur",
              "phoneticLabel": null,
              "searchText": "ccp carriel sur chile concepcion",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LSC",
              "cityName": "La Serena",
              "code": "LSC",
              "countryName": "Chile",
              "displayText": "La Serena, La Florida",
              "isDestination": true,
              "isOrigin": true,
              "label": "La Florida",
              "phoneticLabel": null,
              "searchText": "lsc la florida chile la serena",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PUQ",
              "cityName": "Punta Arenas",
              "code": "PUQ",
              "countryName": "Chile",
              "displayText": "Punta Arenas, Pres Ibanez",
              "isDestination": true,
              "isOrigin": true,
              "label": "Pres Ibanez",
              "phoneticLabel": null,
              "searchText": "puq pres ibanez chile punta arenas",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ANF",
              "cityName": "Antofagasta",
              "code": "ANF",
              "countryName": "Chile",
              "displayText": "Antofagasta, Cerro Moreno",
              "isDestination": true,
              "isOrigin": true,
              "label": "Cerro Moreno",
              "phoneticLabel": null,
              "searchText": "anf cerro moreno chile antofagasta",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "IQQ",
              "cityName": "Iquique",
              "code": "IQQ",
              "countryName": "Chile",
              "displayText": "Iquique, Diego Aracena",
              "isDestination": true,
              "isOrigin": true,
              "label": "Diego Aracena",
              "phoneticLabel": null,
              "searchText": "iqq diego aracena chile iquique",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PNT",
              "cityName": "Puerto Natales",
              "code": "PNT",
              "countryName": "Chile",
              "displayText": "Puerto Natales, Puerto Natales Teniente J. Gallardo Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Puerto Natales Teniente J. Gallardo Airport",
              "phoneticLabel": null,
              "searchText": "pnt puerto natales teniente j. gallardo airport chile puerto natales",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BEY",
              "cityName": "Beirut",
              "code": "BEY",
              "countryName": "Lebanon",
              "displayText": "Beirut, Rafic Hariri International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Rafic Hariri International Airport",
              "phoneticLabel": null,
              "searchText": "bey rafic hariri international airport lebanon beirut",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SJU",
              "cityName": "San Juan",
              "code": "SJU",
              "countryName": "Puerto Rico",
              "displayText": "San Juan, Luis Muñoz Marín International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Luis Muñoz Marín International Airport",
              "phoneticLabel": null,
              "searchText": "sju luis muñoz marín international airport puerto rico san juan",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MQQ",
              "cityName": "Moundou",
              "code": "MQQ",
              "countryName": "Chad",
              "displayText": "Moundou, Moundou Airport",
              "isDestination": false,
              "isOrigin": true,
              "label": "Moundou Airport",
              "phoneticLabel": null,
              "searchText": "mqq moundou airport chad moundou",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NDJ",
              "cityName": "N'Djamena",
              "code": "NDJ",
              "countryName": "Chad",
              "displayText": "N'Djamena, N'Djamena Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "N'Djamena Airport",
              "phoneticLabel": null,
              "searchText": "ndj n'djamena airport chad n'djamena",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "STT",
              "cityName": "Saint Thomas Island",
              "code": "STT",
              "countryName": "Virgin Islands, U.S.",
              "displayText": "Saint Thomas Island, Cyril E. King Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Cyril E. King Airport",
              "phoneticLabel": null,
              "searchText": "stt cyril e. king airport virgin islands, u.s. saint thomas island",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "STX",
              "cityName": "Saint Croix Island",
              "code": "STX",
              "countryName": "Virgin Islands, U.S.",
              "displayText": "Saint Croix Island, Henry E. Rohlsen Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Henry E. Rohlsen Airport",
              "phoneticLabel": null,
              "searchText": "stx henry e. rohlsen airport virgin islands, u.s. saint croix island",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "OKA",
              "cityName": "Okinawa",
              "code": "OKA",
              "countryName": "Japan",
              "displayText": "Okinawa, Naha",
              "isDestination": true,
              "isOrigin": true,
              "label": "Naha",
              "phoneticLabel": null,
              "searchText": "oka naha japan okinawa",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MMB",
              "cityName": "Memanbetsu",
              "code": "MMB",
              "countryName": "Japan",
              "displayText": "Memanbetsu, Memanbetsu Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Memanbetsu Airport",
              "phoneticLabel": null,
              "searchText": "mmb memanbetsu airport japan memanbetsu",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TAK",
              "cityName": "Takamatsu",
              "code": "TAK",
              "countryName": "Japan",
              "displayText": "Takamatsu, Takamatsu",
              "isDestination": true,
              "isOrigin": true,
              "label": "Takamatsu",
              "phoneticLabel": null,
              "searchText": "tak takamatsu japan takamatsu",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KOJ",
              "cityName": "Kagoshima",
              "code": "KOJ",
              "countryName": "Japan",
              "displayText": "Kagoshima, Kagoshima",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kagoshima",
              "phoneticLabel": null,
              "searchText": "koj kagoshima japan kagoshima",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "AXT",
              "cityName": "Akita",
              "code": "AXT",
              "countryName": "Japan",
              "displayText": "Akita, Akita",
              "isDestination": true,
              "isOrigin": true,
              "label": "Akita",
              "phoneticLabel": null,
              "searchText": "axt akita japan akita",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "FSZ",
              "cityName": "Shizuoka",
              "code": "FSZ",
              "countryName": "Japan",
              "displayText": "Shizuoka, Mount Fuji",
              "isDestination": true,
              "isOrigin": true,
              "label": "Mount Fuji",
              "phoneticLabel": null,
              "searchText": "fsz mount fuji japan shizuoka",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SHB",
              "cityName": "Nakashibetsu",
              "code": "SHB",
              "countryName": "Japan",
              "displayText": "Nakashibetsu, Nakashibetsu",
              "isDestination": true,
              "isOrigin": true,
              "label": "Nakashibetsu",
              "phoneticLabel": null,
              "searchText": "shb nakashibetsu japan nakashibetsu",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KKJ",
              "cityName": "Kitakyushu",
              "code": "KKJ",
              "countryName": "Japan",
              "displayText": "Kitakyushu, Kitakyushu Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kitakyushu Airport",
              "phoneticLabel": null,
              "searchText": "kkj kitakyushu airport japan kitakyushu",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "AKJ",
              "cityName": "Asahikawa",
              "code": "AKJ",
              "countryName": "Japan",
              "displayText": "Asahikawa, Asahikawa",
              "isDestination": true,
              "isOrigin": true,
              "label": "Asahikawa",
              "phoneticLabel": null,
              "searchText": "akj asahikawa japan asahikawa",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "OIT",
              "cityName": "Oita",
              "code": "OIT",
              "countryName": "Japan",
              "displayText": "Oita, Oita",
              "isDestination": true,
              "isOrigin": true,
              "label": "Oita",
              "phoneticLabel": null,
              "searchText": "oit oita japan oita",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HKD",
              "cityName": "Hakodate",
              "code": "HKD",
              "countryName": "Japan",
              "displayText": "Hakodate, Hakodate",
              "isDestination": true,
              "isOrigin": true,
              "label": "Hakodate",
              "phoneticLabel": null,
              "searchText": "hkd hakodate japan hakodate",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KMQ",
              "cityName": "Komatsu",
              "code": "KMQ",
              "countryName": "Japan",
              "displayText": "Komatsu, Komatsu",
              "isDestination": true,
              "isOrigin": true,
              "label": "Komatsu",
              "phoneticLabel": null,
              "searchText": "kmq komatsu japan komatsu",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TOY",
              "cityName": "Toyama",
              "code": "TOY",
              "countryName": "Japan",
              "displayText": "Toyama, Toyama Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Toyama Airport",
              "phoneticLabel": null,
              "searchText": "toy toyama airport japan toyama",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KMI",
              "cityName": "Miyazaki",
              "code": "KMI",
              "countryName": "Japan",
              "displayText": "Miyazaki, Miyazaki",
              "isDestination": true,
              "isOrigin": true,
              "label": "Miyazaki",
              "phoneticLabel": null,
              "searchText": "kmi miyazaki japan miyazaki",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MBE",
              "cityName": "Monbetsu",
              "code": "MBE",
              "countryName": "Japan",
              "displayText": "Monbetsu, Monbetsu",
              "isDestination": true,
              "isOrigin": true,
              "label": "Monbetsu",
              "phoneticLabel": null,
              "searchText": "mbe monbetsu japan monbetsu",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MSJ",
              "cityName": "Misawa",
              "code": "MSJ",
              "countryName": "Japan",
              "displayText": "Misawa, Misawa Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Misawa Airport",
              "phoneticLabel": null,
              "searchText": "msj misawa airport japan misawa",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "UBJ",
              "cityName": "Ube",
              "code": "UBJ",
              "countryName": "Japan",
              "displayText": "Ube, Yamaguchi Ube Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Yamaguchi Ube Airport",
              "phoneticLabel": null,
              "searchText": "ubj yamaguchi ube airport japan ube",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NGO",
              "cityName": "Nagoya",
              "code": "NGO",
              "countryName": "Japan",
              "displayText": "Nagoya, Chubu Centrair",
              "isDestination": true,
              "isOrigin": true,
              "label": "Chubu Centrair",
              "phoneticLabel": null,
              "searchText": "ngo chubu centrair japan nagoya",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "FUK",
              "cityName": "Fukuoka",
              "code": "FUK",
              "countryName": "Japan",
              "displayText": "Fukuoka, Fukuoka",
              "isDestination": true,
              "isOrigin": true,
              "label": "Fukuoka",
              "phoneticLabel": null,
              "searchText": "fuk fukuoka japan fukuoka",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KIJ",
              "cityName": "Niigata",
              "code": "KIJ",
              "countryName": "Japan",
              "displayText": "Niigata, Niigata",
              "isDestination": true,
              "isOrigin": true,
              "label": "Niigata",
              "phoneticLabel": null,
              "searchText": "kij niigata japan niigata",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TKS",
              "cityName": "Tokushima",
              "code": "TKS",
              "countryName": "Japan",
              "displayText": "Tokushima, Tokushima Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Tokushima Airport",
              "phoneticLabel": null,
              "searchText": "tks tokushima airport japan tokushima",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TYO",
              "cityName": "Tokyo",
              "code": "TYO",
              "countryName": "Japan",
              "displayText": "Tokyo",
              "isDestination": true,
              "isOrigin": true,
              "label": "Tokyo",
              "phoneticLabel": null,
              "searchText": "tyo tokyo japan",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "TYO",
              "cityName": "Tokyo",
              "code": "HND",
              "countryName": "Japan",
              "displayText": "Tokyo, Haneda",
              "isDestination": true,
              "isOrigin": true,
              "label": "Haneda",
              "phoneticLabel": null,
              "searchText": "hnd haneda japan tokyo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TYO",
              "cityName": "Tokyo",
              "code": "NRT",
              "countryName": "Japan",
              "displayText": "Tokyo, Narita Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Narita Airport",
              "phoneticLabel": null,
              "searchText": "nrt narita airport japan tokyo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YGJ",
              "cityName": "Yonago",
              "code": "YGJ",
              "countryName": "Japan",
              "displayText": "Yonago, Miho",
              "isDestination": true,
              "isOrigin": true,
              "label": "Miho",
              "phoneticLabel": null,
              "searchText": "ygj miho japan yonago",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "AOJ",
              "cityName": "Aomori",
              "code": "AOJ",
              "countryName": "Japan",
              "displayText": "Aomori, Aomori",
              "isDestination": true,
              "isOrigin": true,
              "label": "Aomori",
              "phoneticLabel": null,
              "searchText": "aoj aomori japan aomori",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "IZO",
              "cityName": "Izumo",
              "code": "IZO",
              "countryName": "Japan",
              "displayText": "Izumo, Izumo Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Izumo Airport",
              "phoneticLabel": null,
              "searchText": "izo izumo airport japan izumo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MYJ",
              "cityName": "Matsuyama",
              "code": "MYJ",
              "countryName": "Japan",
              "displayText": "Matsuyama, Matsuyama",
              "isDestination": true,
              "isOrigin": true,
              "label": "Matsuyama",
              "phoneticLabel": null,
              "searchText": "myj matsuyama japan matsuyama",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HIJ",
              "cityName": "Hiroshima",
              "code": "HIJ",
              "countryName": "Japan",
              "displayText": "Hiroshima, Hiroshima Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Hiroshima Airport",
              "phoneticLabel": null,
              "searchText": "hij hiroshima airport japan hiroshima",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NGS",
              "cityName": "Nagasaki",
              "code": "NGS",
              "countryName": "Japan",
              "displayText": "Nagasaki, Nagasaki",
              "isDestination": true,
              "isOrigin": true,
              "label": "Nagasaki",
              "phoneticLabel": null,
              "searchText": "ngs nagasaki japan nagasaki",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SYO",
              "cityName": "Shonai",
              "code": "SYO",
              "countryName": "Japan",
              "displayText": "Shonai, Shonai",
              "isDestination": true,
              "isOrigin": true,
              "label": "Shonai",
              "phoneticLabel": null,
              "searchText": "syo shonai japan shonai",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SPK",
              "cityName": "Sapporo",
              "code": "CTS",
              "countryName": "Japan",
              "displayText": "Sapporo, Chitose",
              "isDestination": true,
              "isOrigin": true,
              "label": "Chitose",
              "phoneticLabel": null,
              "searchText": "cts chitose japan sapporo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "OSA",
              "cityName": "Osaka",
              "code": "OSA",
              "countryName": "Japan",
              "displayText": "Osaka",
              "isDestination": true,
              "isOrigin": true,
              "label": "Osaka",
              "phoneticLabel": null,
              "searchText": "osa osaka japan",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "OSA",
              "cityName": "Osaka",
              "code": "KIX",
              "countryName": "Japan",
              "displayText": "Osaka, Kansai International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kansai International Airport",
              "phoneticLabel": null,
              "searchText": "kix kansai international airport japan osaka",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "OSA",
              "cityName": "Osaka",
              "code": "UKB",
              "countryName": "Japan",
              "displayText": "Osaka, Kobe",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kobe",
              "phoneticLabel": null,
              "searchText": "ukb kobe japan osaka",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "OSA",
              "cityName": "Osaka",
              "code": "ITM",
              "countryName": "Japan",
              "displayText": "Osaka, Itami",
              "isDestination": true,
              "isOrigin": true,
              "label": "Itami",
              "phoneticLabel": null,
              "searchText": "itm itami japan osaka",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KMJ",
              "cityName": "Kumamoto",
              "code": "KMJ",
              "countryName": "Japan",
              "displayText": "Kumamoto, Kumamoto",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kumamoto",
              "phoneticLabel": null,
              "searchText": "kmj kumamoto japan kumamoto",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KUH",
              "cityName": "Kushiro",
              "code": "KUH",
              "countryName": "Japan",
              "displayText": "Kushiro, Kushiro Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kushiro Airport",
              "phoneticLabel": null,
              "searchText": "kuh kushiro airport japan kushiro",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "OKJ",
              "cityName": "Okayama",
              "code": "OKJ",
              "countryName": "Japan",
              "displayText": "Okayama, Okayama",
              "isDestination": true,
              "isOrigin": true,
              "label": "Okayama",
              "phoneticLabel": null,
              "searchText": "okj okayama japan okayama",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SDJ",
              "cityName": "Sendai",
              "code": "SDJ",
              "countryName": "Japan",
              "displayText": "Sendai, Sendai",
              "isDestination": true,
              "isOrigin": true,
              "label": "Sendai",
              "phoneticLabel": null,
              "searchText": "sdj sendai japan sendai",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HAC",
              "cityName": "Hachijo Jima",
              "code": "HAC",
              "countryName": "Japan",
              "displayText": "Hachijo Jima, Hachijo Jima",
              "isDestination": true,
              "isOrigin": true,
              "label": "Hachijo Jima",
              "phoneticLabel": null,
              "searchText": "hac hachijo jima japan hachijo jima",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SHM",
              "cityName": "Shirahama",
              "code": "SHM",
              "countryName": "Japan",
              "displayText": "Shirahama, Nanki–Shirahama Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Nanki–Shirahama Airport",
              "phoneticLabel": null,
              "searchText": "shm nanki–shirahama airport japan shirahama",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "KCZ",
              "cityName": "Kochi",
              "code": "KCZ",
              "countryName": "Japan",
              "displayText": "Kochi, Kochi Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kochi Airport",
              "phoneticLabel": null,
              "searchText": "kcz kochi airport japan kochi",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "DAD",
              "cityName": "Da Nang",
              "code": "DAD",
              "countryName": "Vietnam",
              "displayText": "Da Nang, Da Nang",
              "isDestination": true,
              "isOrigin": true,
              "label": "Da Nang",
              "phoneticLabel": null,
              "searchText": "dad da nang vietnam da nang",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "DIN",
              "cityName": "Dien Bien Phu",
              "code": "DIN",
              "countryName": "Vietnam",
              "displayText": "Dien Bien Phu, Dien Bien Phu Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Dien Bien Phu Airport",
              "phoneticLabel": null,
              "searchText": "din dien bien phu airport vietnam dien bien phu",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NHA",
              "cityName": "Nha Trang",
              "code": "NHA",
              "countryName": "Vietnam",
              "displayText": "Nha Trang",
              "isDestination": true,
              "isOrigin": true,
              "label": "Nha Trang",
              "phoneticLabel": null,
              "searchText": "nha nha trang vietnam",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "NHA",
              "cityName": "Nha Trang",
              "code": "CXR",
              "countryName": "Vietnam",
              "displayText": "Nha Trang, Cam Ranh International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Cam Ranh International Airport",
              "phoneticLabel": null,
              "searchText": "cxr cam ranh international airport vietnam nha trang",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NHA",
              "cityName": "Nha Trang",
              "code": "NHA",
              "countryName": "Vietnam",
              "displayText": "Nha Trang, Nha Trang",
              "isDestination": true,
              "isOrigin": true,
              "label": "Nha Trang",
              "phoneticLabel": null,
              "searchText": "nha nha trang vietnam nha trang",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HUI",
              "cityName": "Hue",
              "code": "HUI",
              "countryName": "Vietnam",
              "displayText": "Hue, Phu Bai",
              "isDestination": true,
              "isOrigin": true,
              "label": "Phu Bai",
              "phoneticLabel": null,
              "searchText": "hui phu bai vietnam hue",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HAN",
              "cityName": "Hanoi",
              "code": "HAN",
              "countryName": "Vietnam",
              "displayText": "Hanoi, Noi Bai International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Noi Bai International Airport",
              "phoneticLabel": null,
              "searchText": "han noi bai international airport vietnam hanoi",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HPH",
              "cityName": "Haiphong",
              "code": "HPH",
              "countryName": "Vietnam",
              "displayText": "Haiphong, Catbi",
              "isDestination": true,
              "isOrigin": true,
              "label": "Catbi",
              "phoneticLabel": null,
              "searchText": "hph catbi vietnam haiphong",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PQC",
              "cityName": "Phu Quoc",
              "code": "PQC",
              "countryName": "Vietnam",
              "displayText": "Phu Quoc, Phu Quoc",
              "isDestination": true,
              "isOrigin": true,
              "label": "Phu Quoc",
              "phoneticLabel": null,
              "searchText": "pqc phu quoc vietnam phu quoc",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SGN",
              "cityName": "Ho Chi Minh City",
              "code": "SGN",
              "countryName": "Vietnam",
              "displayText": "Ho Chi Minh City, Tan Son Nhat",
              "isDestination": true,
              "isOrigin": true,
              "label": "Tan Son Nhat",
              "phoneticLabel": null,
              "searchText": "sgn tan son nhat vietnam ho chi minh city",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ASU",
              "cityName": "Asuncion",
              "code": "ASU",
              "countryName": "Paraguay",
              "displayText": "Asuncion, Asuncion Silvio Pettirossi International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Asuncion Silvio Pettirossi International Airport",
              "phoneticLabel": null,
              "searchText": "asu asuncion silvio pettirossi international airport paraguay asuncion",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "POG",
              "cityName": "Port Gentil",
              "code": "POG",
              "countryName": "Gabon",
              "displayText": "Port Gentil, Port Gentil International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Port Gentil International Airport",
              "phoneticLabel": null,
              "searchText": "pog port gentil international airport gabon port gentil",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MVB",
              "cityName": "Franceville",
              "code": "MVB",
              "countryName": "Gabon",
              "displayText": "Franceville, Franceville Mvengue Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Franceville Mvengue Airport",
              "phoneticLabel": null,
              "searchText": "mvb franceville mvengue airport gabon franceville",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "OYE",
              "cityName": "Oyem",
              "code": "OYE",
              "countryName": "Gabon",
              "displayText": "Oyem, Oyem Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Oyem Airport",
              "phoneticLabel": null,
              "searchText": "oye oyem airport gabon oyem",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LBV",
              "cityName": "Libreville",
              "code": "LBV",
              "countryName": "Gabon",
              "displayText": "Libreville, Leon M'Ba International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Leon M'Ba International Airport",
              "phoneticLabel": null,
              "searchText": "lbv leon m'ba international airport gabon libreville",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SKP",
              "cityName": "Skopje",
              "code": "SKP",
              "countryName": "Republic Of North Macedonia",
              "displayText": "Skopje, Skopje International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Skopje International Airport",
              "phoneticLabel": null,
              "searchText": "skp skopje international airport republic of north macedonia skopje",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YWG",
              "cityName": "Winnipeg",
              "code": "YWG",
              "countryName": "Canada",
              "displayText": "Winnipeg, James Armstrong Richardson International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "James Armstrong Richardson International Airport",
              "phoneticLabel": null,
              "searchText": "ywg james armstrong richardson international airport canada winnipeg",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YXJ",
              "cityName": "Fort Saint John",
              "code": "YXJ",
              "countryName": "Canada",
              "displayText": "Fort Saint John, Fort St. John Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Fort St. John Airport",
              "phoneticLabel": null,
              "searchText": "yxj fort st. john airport canada fort saint john",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YQL",
              "cityName": "Lethbridge",
              "code": "YQL",
              "countryName": "Canada",
              "displayText": "Lethbridge, Lethbridge",
              "isDestination": true,
              "isOrigin": true,
              "label": "Lethbridge",
              "phoneticLabel": null,
              "searchText": "yql lethbridge canada lethbridge",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YAM",
              "cityName": "Sault Ste Marie",
              "code": "YAM",
              "countryName": "Canada",
              "displayText": "Sault Ste Marie, Sault Ste Marie",
              "isDestination": true,
              "isOrigin": true,
              "label": "Sault Ste Marie",
              "phoneticLabel": null,
              "searchText": "yam sault ste marie canada sault ste marie",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YZV",
              "cityName": "Sept Iles",
              "code": "YZV",
              "countryName": "Canada",
              "displayText": "Sept Iles, Sept Iles",
              "isDestination": true,
              "isOrigin": true,
              "label": "Sept Iles",
              "phoneticLabel": null,
              "searchText": "yzv sept iles canada sept iles",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YYT",
              "cityName": "Saint John's",
              "code": "YYT",
              "countryName": "Canada",
              "displayText": "Saint John's, St. John's International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "St. John's International Airport",
              "phoneticLabel": null,
              "searchText": "yyt st. john's international airport canada saint john's",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YEA",
              "cityName": "Edmonton",
              "code": "YEG",
              "countryName": "Canada",
              "displayText": "Edmonton, Edmonton International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Edmonton International",
              "phoneticLabel": null,
              "searchText": "yeg edmonton international canada edmonton",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YQM",
              "cityName": "Moncton",
              "code": "YQM",
              "countryName": "Canada",
              "displayText": "Moncton, Greater Moncton International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Greater Moncton International Airport",
              "phoneticLabel": null,
              "searchText": "yqm greater moncton international airport canada moncton",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YYD",
              "cityName": "Smithers",
              "code": "YYD",
              "countryName": "Canada",
              "displayText": "Smithers, Smithers",
              "isDestination": true,
              "isOrigin": true,
              "label": "Smithers",
              "phoneticLabel": null,
              "searchText": "yyd smithers canada smithers",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YKA",
              "cityName": "Kamloops",
              "code": "YKA",
              "countryName": "Canada",
              "displayText": "Kamloops, Kamloops",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kamloops",
              "phoneticLabel": null,
              "searchText": "yka kamloops canada kamloops",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YZF",
              "cityName": "Yellowknife",
              "code": "YZF",
              "countryName": "Canada",
              "displayText": "Yellowknife, Yellowknife",
              "isDestination": true,
              "isOrigin": true,
              "label": "Yellowknife",
              "phoneticLabel": null,
              "searchText": "yzf yellowknife canada yellowknife",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YLW",
              "cityName": "Kelowna",
              "code": "YLW",
              "countryName": "Canada",
              "displayText": "Kelowna, Kelowna",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kelowna",
              "phoneticLabel": null,
              "searchText": "ylw kelowna canada kelowna",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YHZ",
              "cityName": "Halifax",
              "code": "YHZ",
              "countryName": "Canada",
              "displayText": "Halifax, Stanfield International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Stanfield International Airport",
              "phoneticLabel": null,
              "searchText": "yhz stanfield international airport canada halifax",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YQG",
              "cityName": "Windsor",
              "code": "YQG",
              "countryName": "Canada",
              "displayText": "Windsor, Windsor Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Windsor Airport",
              "phoneticLabel": null,
              "searchText": "yqg windsor airport canada windsor",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YXC",
              "cityName": "Cranbrook",
              "code": "YXC",
              "countryName": "Canada",
              "displayText": "Cranbrook, Cranbrook/Canadian Rockies International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Cranbrook/Canadian Rockies International Airport",
              "phoneticLabel": null,
              "searchText": "yxc cranbrook/canadian rockies international airport canada cranbrook",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YPR",
              "cityName": "Prince Rupert",
              "code": "YPR",
              "countryName": "Canada",
              "displayText": "Prince Rupert, Prince Rupert",
              "isDestination": true,
              "isOrigin": true,
              "label": "Prince Rupert",
              "phoneticLabel": null,
              "searchText": "ypr prince rupert canada prince rupert",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YQU",
              "cityName": "Grande Prairie",
              "code": "YQU",
              "countryName": "Canada",
              "displayText": "Grande Prairie, Grande Prairie",
              "isDestination": true,
              "isOrigin": true,
              "label": "Grande Prairie",
              "phoneticLabel": null,
              "searchText": "yqu grande prairie canada grande prairie",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YBR",
              "cityName": "Brandon",
              "code": "YBR",
              "countryName": "Canada",
              "displayText": "Brandon, Brandon Municipal Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Brandon Municipal Airport",
              "phoneticLabel": null,
              "searchText": "ybr brandon municipal airport canada brandon",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YMM",
              "cityName": "Fort Mc Murray",
              "code": "YMM",
              "countryName": "Canada",
              "displayText": "Fort Mc Murray, Fort Mc Murray",
              "isDestination": true,
              "isOrigin": true,
              "label": "Fort Mc Murray",
              "phoneticLabel": null,
              "searchText": "ymm fort mc murray canada fort mc murray",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YYG",
              "cityName": "Charlottetown",
              "code": "YYG",
              "countryName": "Canada",
              "displayText": "Charlottetown, Charlottetown",
              "isDestination": true,
              "isOrigin": true,
              "label": "Charlottetown",
              "phoneticLabel": null,
              "searchText": "yyg charlottetown canada charlottetown",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YXU",
              "cityName": "London",
              "code": "YXU",
              "countryName": "Canada",
              "displayText": "London, London International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "London International Airport",
              "phoneticLabel": null,
              "searchText": "yxu london international airport canada london",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YYC",
              "cityName": "Calgary",
              "code": "YYC",
              "countryName": "Canada",
              "displayText": "Calgary, Calgary International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Calgary International Airport",
              "phoneticLabel": null,
              "searchText": "yyc calgary international airport canada calgary",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YXS",
              "cityName": "Prince George",
              "code": "YXS",
              "countryName": "Canada",
              "displayText": "Prince George, Prince George",
              "isDestination": true,
              "isOrigin": true,
              "label": "Prince George",
              "phoneticLabel": null,
              "searchText": "yxs prince george canada prince george",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YQT",
              "cityName": "Thunder Bay",
              "code": "YQT",
              "countryName": "Canada",
              "displayText": "Thunder Bay, Thunder Bay",
              "isDestination": true,
              "isOrigin": true,
              "label": "Thunder Bay",
              "phoneticLabel": null,
              "searchText": "yqt thunder bay canada thunder bay",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YVR",
              "cityName": "Vancouver",
              "code": "YVR",
              "countryName": "Canada",
              "displayText": "Vancouver, Vancouver International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Vancouver International Airport",
              "phoneticLabel": null,
              "searchText": "yvr vancouver international airport canada vancouver",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YOW",
              "cityName": "Ottawa",
              "code": "YOW",
              "countryName": "Canada",
              "displayText": "Ottawa",
              "isDestination": true,
              "isOrigin": true,
              "label": "Ottawa",
              "phoneticLabel": null,
              "searchText": "yow ottawa canada",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "YXX",
              "cityName": "Abbotsford",
              "code": "YXX",
              "countryName": "Canada",
              "displayText": "Abbotsford, Abbotsford Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Abbotsford Airport",
              "phoneticLabel": null,
              "searchText": "yxx abbotsford airport canada abbotsford",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YYB",
              "cityName": "North Bay",
              "code": "YYB",
              "countryName": "Canada",
              "displayText": "North Bay, North Bay",
              "isDestination": true,
              "isOrigin": true,
              "label": "North Bay",
              "phoneticLabel": null,
              "searchText": "yyb north bay canada north bay",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ZBF",
              "cityName": "Bathurst",
              "code": "ZBF",
              "countryName": "Canada",
              "displayText": "Bathurst, Bathurst",
              "isDestination": true,
              "isOrigin": true,
              "label": "Bathurst",
              "phoneticLabel": null,
              "searchText": "zbf bathurst canada bathurst",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YQY",
              "cityName": "Sydney",
              "code": "YQY",
              "countryName": "Canada",
              "displayText": "Sydney, J.A. Douglas Mccurdy",
              "isDestination": true,
              "isOrigin": true,
              "label": "J.A. Douglas Mccurdy",
              "phoneticLabel": null,
              "searchText": "yqy j.a. douglas mccurdy canada sydney",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YQR",
              "cityName": "Regina",
              "code": "YQR",
              "countryName": "Canada",
              "displayText": "Regina, Regina International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Regina International Airport",
              "phoneticLabel": null,
              "searchText": "yqr regina international airport canada regina",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YMQ",
              "cityName": "Montreal",
              "code": "YUL",
              "countryName": "Canada",
              "displayText": "Montreal, Pierre Elliott Trudeau International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Pierre Elliott Trudeau International Airport",
              "phoneticLabel": null,
              "searchText": "yul pierre elliott trudeau international airport canada montreal",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YDF",
              "cityName": "Deer Lake",
              "code": "YDF",
              "countryName": "Canada",
              "displayText": "Deer Lake, Deer Lake",
              "isDestination": true,
              "isOrigin": true,
              "label": "Deer Lake",
              "phoneticLabel": null,
              "searchText": "ydf deer lake canada deer lake",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YXT",
              "cityName": "Terrace",
              "code": "YXT",
              "countryName": "Canada",
              "displayText": "Terrace, Terrace Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Terrace Airport",
              "phoneticLabel": null,
              "searchText": "yxt terrace airport canada terrace",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YTO",
              "cityName": "Toronto",
              "code": "YTO",
              "countryName": "Canada",
              "displayText": "Toronto",
              "isDestination": true,
              "isOrigin": true,
              "label": "Toronto",
              "phoneticLabel": null,
              "searchText": "yto toronto canada",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "YTO",
              "cityName": "Toronto",
              "code": "YTZ",
              "countryName": "Canada",
              "displayText": "Toronto, Billy Bishop City Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Billy Bishop City Airport",
              "phoneticLabel": null,
              "searchText": "ytz billy bishop city airport canada toronto",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YTO",
              "cityName": "Toronto",
              "code": "YKF",
              "countryName": "Canada",
              "displayText": "Toronto, Kitchener/Waterloo Regional Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Kitchener/Waterloo Regional Airport",
              "phoneticLabel": null,
              "searchText": "ykf kitchener/waterloo regional airport canada toronto",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YTO",
              "cityName": "Toronto",
              "code": "YHM",
              "countryName": "Canada",
              "displayText": "Toronto, John C Munro Intl",
              "isDestination": true,
              "isOrigin": true,
              "label": "John C Munro Intl",
              "phoneticLabel": null,
              "searchText": "yhm john c munro intl canada toronto",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YTO",
              "cityName": "Toronto",
              "code": "YYZ",
              "countryName": "Canada",
              "displayText": "Toronto, Pearson International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Pearson International Airport",
              "phoneticLabel": null,
              "searchText": "yyz pearson international airport canada toronto",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YQQ",
              "cityName": "Comox",
              "code": "YQQ",
              "countryName": "Canada",
              "displayText": "Comox, Comox",
              "isDestination": true,
              "isOrigin": true,
              "label": "Comox",
              "phoneticLabel": null,
              "searchText": "yqq comox canada comox",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YCD",
              "cityName": "Nanaimo",
              "code": "YCD",
              "countryName": "Canada",
              "displayText": "Nanaimo, Nanaimo",
              "isDestination": true,
              "isOrigin": true,
              "label": "Nanaimo",
              "phoneticLabel": null,
              "searchText": "ycd nanaimo canada nanaimo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YFC",
              "cityName": "Fredericton",
              "code": "YFC",
              "countryName": "Canada",
              "displayText": "Fredericton, Fredericton Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Fredericton Airport",
              "phoneticLabel": null,
              "searchText": "yfc fredericton airport canada fredericton",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YYJ",
              "cityName": "Victoria",
              "code": "YYJ",
              "countryName": "Canada",
              "displayText": "Victoria, Victoria International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Victoria International",
              "phoneticLabel": null,
              "searchText": "yyj victoria international canada victoria",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YXE",
              "cityName": "Saskatoon",
              "code": "YXE",
              "countryName": "Canada",
              "displayText": "Saskatoon, Saskatoon/John G. Diefenbaker International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Saskatoon/John G. Diefenbaker International Airport",
              "phoneticLabel": null,
              "searchText": "yxe saskatoon/john g. diefenbaker international airport canada saskatoon",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YQB",
              "cityName": "Quebec",
              "code": "YQB",
              "countryName": "Canada",
              "displayText": "Quebec",
              "isDestination": true,
              "isOrigin": true,
              "label": "Quebec",
              "phoneticLabel": null,
              "searchText": "yqb quebec canada",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "YQB",
              "cityName": "Quebec",
              "code": "BQC",
              "countryName": "Canada",
              "displayText": "Quebec, Sainte-Foy Bus Station",
              "isDestination": true,
              "isOrigin": true,
              "label": "Sainte-Foy Bus Station",
              "phoneticLabel": null,
              "searchText": "bqc sainte-foy bus station canada quebec",
              "stationType": "BUS_STATION",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YQB",
              "cityName": "Quebec",
              "code": "YQB",
              "countryName": "Canada",
              "displayText": "Quebec, Jean Lesage Intl",
              "isDestination": true,
              "isOrigin": true,
              "label": "Jean Lesage Intl",
              "phoneticLabel": null,
              "searchText": "yqb jean lesage intl canada quebec",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YTS",
              "cityName": "Timmins",
              "code": "YTS",
              "countryName": "Canada",
              "displayText": "Timmins, Timmins",
              "isDestination": true,
              "isOrigin": true,
              "label": "Timmins",
              "phoneticLabel": null,
              "searchText": "yts timmins canada timmins",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YSB",
              "cityName": "Sudbury",
              "code": "YSB",
              "countryName": "Canada",
              "displayText": "Sudbury, Sudbury",
              "isDestination": true,
              "isOrigin": true,
              "label": "Sudbury",
              "phoneticLabel": null,
              "searchText": "ysb sudbury canada sudbury",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YSJ",
              "cityName": "Saint John",
              "code": "YSJ",
              "countryName": "Canada",
              "displayText": "Saint John, Saint John Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Saint John Airport",
              "phoneticLabel": null,
              "searchText": "ysj saint john airport canada saint john",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YUY",
              "cityName": "Rouyn Noranda",
              "code": "YUY",
              "countryName": "Canada",
              "displayText": "Rouyn Noranda, Rouyn-Noranda Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Rouyn-Noranda Airport",
              "phoneticLabel": null,
              "searchText": "yuy rouyn-noranda airport canada rouyn noranda",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YVO",
              "cityName": "Val D'or",
              "code": "YVO",
              "countryName": "Canada",
              "displayText": "Val D'or, Val D'Or",
              "isDestination": true,
              "isOrigin": true,
              "label": "Val D'Or",
              "phoneticLabel": null,
              "searchText": "yvo val d'or canada val d'or",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YBG",
              "cityName": "Bagotville",
              "code": "YBG",
              "countryName": "Canada",
              "displayText": "Bagotville, Bagotville",
              "isDestination": true,
              "isOrigin": true,
              "label": "Bagotville",
              "phoneticLabel": null,
              "searchText": "ybg bagotville canada bagotville",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YYF",
              "cityName": "Penticton",
              "code": "YYF",
              "countryName": "Canada",
              "displayText": "Penticton, Penticton Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Penticton Airport",
              "phoneticLabel": null,
              "searchText": "yyf penticton airport canada penticton",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "YXY",
              "cityName": "Whitehorse",
              "code": "YXY",
              "countryName": "Canada",
              "displayText": "Whitehorse, Whitehorse International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Whitehorse International Airport",
              "phoneticLabel": null,
              "searchText": "yxy whitehorse international airport canada whitehorse",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LMM",
              "cityName": "Los Mochis",
              "code": "LMM",
              "countryName": "Mexico",
              "displayText": "Los Mochis, Federal",
              "isDestination": true,
              "isOrigin": true,
              "label": "Federal",
              "phoneticLabel": null,
              "searchText": "lmm federal mexico los mochis",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TGZ",
              "cityName": "Tuxtla Gutierrez",
              "code": "TGZ",
              "countryName": "Mexico",
              "displayText": "Tuxtla Gutierrez, Angel Albino Corzo International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Angel Albino Corzo International Airport",
              "phoneticLabel": null,
              "searchText": "tgz angel albino corzo international airport mexico tuxtla gutierrez",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MAM",
              "cityName": "Matamoros",
              "code": "MAM",
              "countryName": "Mexico",
              "displayText": "Matamoros, Servando Canales International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Servando Canales International Airport",
              "phoneticLabel": null,
              "searchText": "mam servando canales international airport mexico matamoros",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MEX",
              "cityName": "Mexico City",
              "code": "MEX",
              "countryName": "Mexico",
              "displayText": "Mexico City, Juarez International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Juarez International",
              "phoneticLabel": null,
              "searchText": "mex juarez international mexico mexico city",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LAP",
              "cityName": "La Paz",
              "code": "LAP",
              "countryName": "Mexico",
              "displayText": "La Paz, Leon",
              "isDestination": true,
              "isOrigin": true,
              "label": "Leon",
              "phoneticLabel": null,
              "searchText": "lap leon mexico la paz",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PXM",
              "cityName": "Puerto Escondido",
              "code": "PXM",
              "countryName": "Mexico",
              "displayText": "Puerto Escondido, Puerto Escondido International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Puerto Escondido International",
              "phoneticLabel": null,
              "searchText": "pxm puerto escondido international mexico puerto escondido",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CUU",
              "cityName": "Chihuahua",
              "code": "CUU",
              "countryName": "Mexico",
              "displayText": "Chihuahua, General Roberto Fierro Villalobos International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "General Roberto Fierro Villalobos International Airport",
              "phoneticLabel": null,
              "searchText": "cuu general roberto fierro villalobos international airport mexico chihuahua",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TRC",
              "cityName": "Torreon",
              "code": "TRC",
              "countryName": "Mexico",
              "displayText": "Torreon, Torreon",
              "isDestination": true,
              "isOrigin": true,
              "label": "Torreon",
              "phoneticLabel": null,
              "searchText": "trc torreon mexico torreon",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "REX",
              "cityName": "Reynosa",
              "code": "REX",
              "countryName": "Mexico",
              "displayText": "Reynosa, General Lucio Blanco International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "General Lucio Blanco International Airport",
              "phoneticLabel": null,
              "searchText": "rex general lucio blanco international airport mexico reynosa",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TIJ",
              "cityName": "Tijuana",
              "code": "TIJ",
              "countryName": "Mexico",
              "displayText": "Tijuana, Rodríguez International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Rodríguez International Airport",
              "phoneticLabel": null,
              "searchText": "tij rodríguez international airport mexico tijuana",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MID",
              "cityName": "Merida",
              "code": "MID",
              "countryName": "Mexico",
              "displayText": "Merida, Rejón International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Rejón International Airport",
              "phoneticLabel": null,
              "searchText": "mid rejón international airport mexico merida",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TUY",
              "cityName": "Tulum",
              "code": "TQO",
              "countryName": "Mexico",
              "displayText": "Tulum, Tulum Felipe Carrillo Puerto Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Tulum Felipe Carrillo Puerto Airport",
              "phoneticLabel": null,
              "searchText": "tqo tulum felipe carrillo puerto airport mexico tulum",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TAP",
              "cityName": "Tapachula",
              "code": "TAP",
              "countryName": "Mexico",
              "displayText": "Tapachula, Tapachula International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Tapachula International Airport",
              "phoneticLabel": null,
              "searchText": "tap tapachula international airport mexico tapachula",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MLM",
              "cityName": "Morelia",
              "code": "MLM",
              "countryName": "Mexico",
              "displayText": "Morelia, Morelia",
              "isDestination": true,
              "isOrigin": true,
              "label": "Morelia",
              "phoneticLabel": null,
              "searchText": "mlm morelia mexico morelia",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HUX",
              "cityName": "Huatulco",
              "code": "HUX",
              "countryName": "Mexico",
              "displayText": "Huatulco, Huatulco International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Huatulco International Airport",
              "phoneticLabel": null,
              "searchText": "hux huatulco international airport mexico huatulco",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "GDL",
              "cityName": "Guadalajara",
              "code": "GDL",
              "countryName": "Mexico",
              "displayText": "Guadalajara, Miguel Hidalgo International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Miguel Hidalgo International Airport",
              "phoneticLabel": null,
              "searchText": "gdl miguel hidalgo international airport mexico guadalajara",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CEN",
              "cityName": "Ciudad Obregon",
              "code": "CEN",
              "countryName": "Mexico",
              "displayText": "Ciudad Obregon, Ciudad Obregon",
              "isDestination": true,
              "isOrigin": true,
              "label": "Ciudad Obregon",
              "phoneticLabel": null,
              "searchText": "cen ciudad obregon mexico ciudad obregon",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "VER",
              "cityName": "Veracruz",
              "code": "VER",
              "countryName": "Mexico",
              "displayText": "Veracruz, Heriberto Jara International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Heriberto Jara International Airport",
              "phoneticLabel": null,
              "searchText": "ver heriberto jara international airport mexico veracruz",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PVR",
              "cityName": "Puerto Vallarta",
              "code": "PVR",
              "countryName": "Mexico",
              "displayText": "Puerto Vallarta, Ordaz",
              "isDestination": true,
              "isOrigin": true,
              "label": "Ordaz",
              "phoneticLabel": null,
              "searchText": "pvr ordaz mexico puerto vallarta",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "NLD",
              "cityName": "Nuevo Laredo",
              "code": "NLD",
              "countryName": "Mexico",
              "displayText": "Nuevo Laredo, Quetzalcóatl International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Quetzalcóatl International Airport",
              "phoneticLabel": null,
              "searchText": "nld quetzalcóatl international airport mexico nuevo laredo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TAM",
              "cityName": "Tampico",
              "code": "TAM",
              "countryName": "Mexico",
              "displayText": "Tampico, General F Javier Mina",
              "isDestination": true,
              "isOrigin": true,
              "label": "General F Javier Mina",
              "phoneticLabel": null,
              "searchText": "tam general f javier mina mexico tampico",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ACA",
              "cityName": "Acapulco",
              "code": "ACA",
              "countryName": "Mexico",
              "displayText": "Acapulco, Alvarez International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Alvarez International Airport",
              "phoneticLabel": null,
              "searchText": "aca alvarez international airport mexico acapulco",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CJS",
              "cityName": "Ciudad Juarez",
              "code": "CJS",
              "countryName": "Mexico",
              "displayText": "Ciudad Juarez, Abraham González International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Abraham González International Airport",
              "phoneticLabel": null,
              "searchText": "cjs abraham gonzález international airport mexico ciudad juarez",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "VSA",
              "cityName": "Villahermosa",
              "code": "VSA",
              "countryName": "Mexico",
              "displayText": "Villahermosa, Carlos Rovirosa Pérez International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Carlos Rovirosa Pérez International Airport",
              "phoneticLabel": null,
              "searchText": "vsa carlos rovirosa pérez international airport mexico villahermosa",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "QRO",
              "cityName": "Queretaro",
              "code": "QRO",
              "countryName": "Mexico",
              "displayText": "Queretaro, Queretaro",
              "isDestination": true,
              "isOrigin": true,
              "label": "Queretaro",
              "phoneticLabel": null,
              "searchText": "qro queretaro mexico queretaro",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "AGU",
              "cityName": "Aguascalientes",
              "code": "AGU",
              "countryName": "Mexico",
              "displayText": "Aguascalientes, Aguascalientes",
              "isDestination": true,
              "isOrigin": true,
              "label": "Aguascalientes",
              "phoneticLabel": null,
              "searchText": "agu aguascalientes mexico aguascalientes",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SLP",
              "cityName": "San Luis Potosi",
              "code": "SLP",
              "countryName": "Mexico",
              "displayText": "San Luis Potosi, San Luis Potosi",
              "isDestination": true,
              "isOrigin": true,
              "label": "San Luis Potosi",
              "phoneticLabel": null,
              "searchText": "slp san luis potosi mexico san luis potosi",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CZM",
              "cityName": "Cozumel",
              "code": "CZM",
              "countryName": "Mexico",
              "displayText": "Cozumel, Cozumel",
              "isDestination": true,
              "isOrigin": true,
              "label": "Cozumel",
              "phoneticLabel": null,
              "searchText": "czm cozumel mexico cozumel",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CUL",
              "cityName": "Culiacan",
              "code": "CUL",
              "countryName": "Mexico",
              "displayText": "Culiacan, Fedl De Bachiguala",
              "isDestination": true,
              "isOrigin": true,
              "label": "Fedl De Bachiguala",
              "phoneticLabel": null,
              "searchText": "cul fedl de bachiguala mexico culiacan",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MZT",
              "cityName": "Mazatlan",
              "code": "MZT",
              "countryName": "Mexico",
              "displayText": "Mazatlan, General Rafael Buelna",
              "isDestination": true,
              "isOrigin": true,
              "label": "General Rafael Buelna",
              "phoneticLabel": null,
              "searchText": "mzt general rafael buelna mexico mazatlan",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SJD",
              "cityName": "San Jose Cabo",
              "code": "SJD",
              "countryName": "Mexico",
              "displayText": "San Jose Cabo, Los Cabos",
              "isDestination": true,
              "isOrigin": true,
              "label": "Los Cabos",
              "phoneticLabel": null,
              "searchText": "sjd los cabos mexico san jose cabo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CPE",
              "cityName": "Campeche",
              "code": "CPE",
              "countryName": "Mexico",
              "displayText": "Campeche, Campeche A. Acuna Ongay International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Campeche A. Acuna Ongay International Airport",
              "phoneticLabel": null,
              "searchText": "cpe campeche a. acuna ongay international airport mexico campeche",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CME",
              "cityName": "Ciudad Del Carmen",
              "code": "CME",
              "countryName": "Mexico",
              "displayText": "Ciudad Del Carmen, Ciudad Del Carmen",
              "isDestination": true,
              "isOrigin": true,
              "label": "Ciudad Del Carmen",
              "phoneticLabel": null,
              "searchText": "cme ciudad del carmen mexico ciudad del carmen",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "OAX",
              "cityName": "Oaxaca",
              "code": "OAX",
              "countryName": "Mexico",
              "displayText": "Oaxaca, Xoxocotlan",
              "isDestination": true,
              "isOrigin": true,
              "label": "Xoxocotlan",
              "phoneticLabel": null,
              "searchText": "oax xoxocotlan mexico oaxaca",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BJX",
              "cityName": "Leon Guanajuato",
              "code": "BJX",
              "countryName": "Mexico",
              "displayText": "Leon Guanajuato, Guanajuato Del Bajio",
              "isDestination": true,
              "isOrigin": true,
              "label": "Guanajuato Del Bajio",
              "phoneticLabel": null,
              "searchText": "bjx guanajuato del bajio mexico leon guanajuato",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MTY",
              "cityName": "Monterrey",
              "code": "MTY",
              "countryName": "Mexico",
              "displayText": "Monterrey, General M. Escobedo",
              "isDestination": true,
              "isOrigin": true,
              "label": "General M. Escobedo",
              "phoneticLabel": null,
              "searchText": "mty general m. escobedo mexico monterrey",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MXL",
              "cityName": "Mexicali",
              "code": "MXL",
              "countryName": "Mexico",
              "displayText": "Mexicali, Mexicali",
              "isDestination": true,
              "isOrigin": true,
              "label": "Mexicali",
              "phoneticLabel": null,
              "searchText": "mxl mexicali mexico mexicali",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ZCL",
              "cityName": "Zacatecas",
              "code": "ZCL",
              "countryName": "Mexico",
              "displayText": "Zacatecas, Leobardo C. Ruiz International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Leobardo C. Ruiz International Airport",
              "phoneticLabel": null,
              "searchText": "zcl leobardo c. ruiz international airport mexico zacatecas",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "HMO",
              "cityName": "Hermosillo",
              "code": "HMO",
              "countryName": "Mexico",
              "displayText": "Hermosillo, General Pesqueira Garcia International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "General Pesqueira Garcia International Airport",
              "phoneticLabel": null,
              "searchText": "hmo general pesqueira garcia international airport mexico hermosillo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "MTT",
              "cityName": "Minatitlan",
              "code": "MTT",
              "countryName": "Mexico",
              "displayText": "Minatitlan, Coatzacoalcos Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Coatzacoalcos Airport",
              "phoneticLabel": null,
              "searchText": "mtt coatzacoalcos airport mexico minatitlan",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "DGO",
              "cityName": "Durango",
              "code": "DGO",
              "countryName": "Mexico",
              "displayText": "Durango, Guadalupe Victoria",
              "isDestination": true,
              "isOrigin": true,
              "label": "Guadalupe Victoria",
              "phoneticLabel": null,
              "searchText": "dgo guadalupe victoria mexico durango",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CTM",
              "cityName": "Chetumal",
              "code": "CTM",
              "countryName": "Mexico",
              "displayText": "Chetumal, Chetumal International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Chetumal International Airport",
              "phoneticLabel": null,
              "searchText": "ctm chetumal international airport mexico chetumal",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ZIH",
              "cityName": "Ixtapa Zihuatanejo",
              "code": "ZIH",
              "countryName": "Mexico",
              "displayText": "Ixtapa Zihuatanejo, International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "International Airport",
              "phoneticLabel": null,
              "searchText": "zih international airport mexico ixtapa zihuatanejo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CUN",
              "cityName": "Cancun",
              "code": "CUN",
              "countryName": "Mexico",
              "displayText": "Cancun, Cancun International airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Cancun International airport",
              "phoneticLabel": null,
              "searchText": "cun cancun international airport mexico cancun",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "ZLO",
              "cityName": "Manzanillo",
              "code": "ZLO",
              "countryName": "Mexico",
              "displayText": "Manzanillo, Manzanillo",
              "isDestination": true,
              "isOrigin": true,
              "label": "Manzanillo",
              "phoneticLabel": null,
              "searchText": "zlo manzanillo mexico manzanillo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PNR",
              "cityName": "Pointe Noire",
              "code": "PNR",
              "countryName": "Congo Brazzaville",
              "displayText": "Pointe Noire, Pointe Noire Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Pointe Noire Airport",
              "phoneticLabel": null,
              "searchText": "pnr pointe noire airport congo brazzaville pointe noire",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "BZV",
              "cityName": "Brazzaville",
              "code": "BZV",
              "countryName": "Congo Brazzaville",
              "displayText": "Brazzaville, Maya Maya Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Maya Maya Airport",
              "phoneticLabel": null,
              "searchText": "bzv maya maya airport congo brazzaville brazzaville",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TBS",
              "cityName": "Tbilisi",
              "code": "TBS",
              "countryName": "Georgia",
              "displayText": "Tbilisi, Tbilisi International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Tbilisi International Airport",
              "phoneticLabel": null,
              "searchText": "tbs tbilisi international airport georgia tbilisi",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "DKR",
              "cityName": "Dakar",
              "code": "DKR",
              "countryName": "Senegal",
              "displayText": "Dakar",
              "isDestination": true,
              "isOrigin": false,
              "label": "Dakar",
              "phoneticLabel": null,
              "searchText": "dkr dakar senegal",
              "stationType": "CITY",
              "type": "C",
              "__typename": "Station"
          },
          {
              "cityCode": "DKR",
              "cityName": "Dakar",
              "code": "DSS",
              "countryName": "Senegal",
              "displayText": "Dakar, Blaise Diagne International",
              "isDestination": true,
              "isOrigin": true,
              "label": "Blaise Diagne International",
              "phoneticLabel": null,
              "searchText": "dss blaise diagne international senegal dakar",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "DKR",
              "cityName": "Dakar",
              "code": "DKR",
              "countryName": "Senegal",
              "displayText": "Dakar, Leopold Sedar Senghor",
              "isDestination": true,
              "isOrigin": false,
              "label": "Leopold Sedar Senghor",
              "phoneticLabel": null,
              "searchText": "dkr leopold sedar senghor senegal dakar",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "SBH",
              "cityName": "Saint Barthelemy",
              "code": "SBH",
              "countryName": "Saint-Barthélemy",
              "displayText": "Saint Barthelemy, St. Barthelemy",
              "isDestination": true,
              "isOrigin": true,
              "label": "St. Barthelemy",
              "phoneticLabel": null,
              "searchText": "sbh st. barthelemy saint-barthélemy saint barthelemy",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CJA",
              "cityName": "Cajamarca",
              "code": "CJA",
              "countryName": "Peru",
              "displayText": "Cajamarca, Cajamarca Armando R. Iglesias Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Cajamarca Armando R. Iglesias Airport",
              "phoneticLabel": null,
              "searchText": "cja cajamarca armando r. iglesias airport peru cajamarca",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "JAU",
              "cityName": "Jauja",
              "code": "JAU",
              "countryName": "Peru",
              "displayText": "Jauja, Jauja Francisco Carle Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Jauja Francisco Carle Airport",
              "phoneticLabel": null,
              "searchText": "jau jauja francisco carle airport peru jauja",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "AYP",
              "cityName": "Ayacucho",
              "code": "AYP",
              "countryName": "Peru",
              "displayText": "Ayacucho, Ayacucho Alfredo M. Duarte Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Ayacucho Alfredo M. Duarte Airport",
              "phoneticLabel": null,
              "searchText": "ayp ayacucho alfredo m. duarte airport peru ayacucho",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TCQ",
              "cityName": "Tacna",
              "code": "TCQ",
              "countryName": "Peru",
              "displayText": "Tacna, Tacna C. Ciriani Santa Rosa Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Tacna C. Ciriani Santa Rosa Airport",
              "phoneticLabel": null,
              "searchText": "tcq tacna c. ciriani santa rosa airport peru tacna",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PCL",
              "cityName": "Pucallpa",
              "code": "PCL",
              "countryName": "Peru",
              "displayText": "Pucallpa, Pucallpa D. Abenzur Rengifo International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Pucallpa D. Abenzur Rengifo International Airport",
              "phoneticLabel": null,
              "searchText": "pcl pucallpa d. abenzur rengifo international airport peru pucallpa",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "AQP",
              "cityName": "Arequipa",
              "code": "AQP",
              "countryName": "Peru",
              "displayText": "Arequipa, Rodriguez Ballon International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Rodriguez Ballon International Airport",
              "phoneticLabel": null,
              "searchText": "aqp rodriguez ballon international airport peru arequipa",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PEM",
              "cityName": "Puerto Maldonado",
              "code": "PEM",
              "countryName": "Peru",
              "displayText": "Puerto Maldonado, Puerto Maldonado Padre Aldamiz International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Puerto Maldonado Padre Aldamiz International Airport",
              "phoneticLabel": null,
              "searchText": "pem puerto maldonado padre aldamiz international airport peru puerto maldonado",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TPP",
              "cityName": "Tarapoto",
              "code": "TPP",
              "countryName": "Peru",
              "displayText": "Tarapoto, G Del Castillo Paredes",
              "isDestination": true,
              "isOrigin": true,
              "label": "G Del Castillo Paredes",
              "phoneticLabel": null,
              "searchText": "tpp g del castillo paredes peru tarapoto",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CIX",
              "cityName": "Chiclayo",
              "code": "CIX",
              "countryName": "Peru",
              "displayText": "Chiclayo, José A. Quiñones Gonzales International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "José A. Quiñones Gonzales International Airport",
              "phoneticLabel": null,
              "searchText": "cix josé a. quiñones gonzales international airport peru chiclayo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TYL",
              "cityName": "Talara",
              "code": "TYL",
              "countryName": "Peru",
              "displayText": "Talara, Talara Victor Monteas Arias Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Talara Victor Monteas Arias Airport",
              "phoneticLabel": null,
              "searchText": "tyl talara victor monteas arias airport peru talara",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "JUL",
              "cityName": "Juliaca",
              "code": "JUL",
              "countryName": "Peru",
              "displayText": "Juliaca, Inca Manco Capac Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Inca Manco Capac Airport",
              "phoneticLabel": null,
              "searchText": "jul inca manco capac airport peru juliaca",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TBP",
              "cityName": "Tumbes",
              "code": "TBP",
              "countryName": "Peru",
              "displayText": "Tumbes, Tumbes Pedro Canga Rodriguez Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Tumbes Pedro Canga Rodriguez Airport",
              "phoneticLabel": null,
              "searchText": "tbp tumbes pedro canga rodriguez airport peru tumbes",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "LIM",
              "cityName": "Lima",
              "code": "LIM",
              "countryName": "Peru",
              "displayText": "Lima, J Chavez International",
              "isDestination": true,
              "isOrigin": true,
              "label": "J Chavez International",
              "phoneticLabel": null,
              "searchText": "lim j chavez international peru lima",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "PIU",
              "cityName": "Piura",
              "code": "PIU",
              "countryName": "Peru",
              "displayText": "Piura, Piura G. Concha Iberico International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Piura G. Concha Iberico International Airport",
              "phoneticLabel": null,
              "searchText": "piu piura g. concha iberico international airport peru piura",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "TRU",
              "cityName": "Trujillo",
              "code": "TRU",
              "countryName": "Peru",
              "displayText": "Trujillo, Trujillo C. Martinez de Pinillos Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "Trujillo C. Martinez de Pinillos Airport",
              "phoneticLabel": null,
              "searchText": "tru trujillo c. martinez de pinillos airport peru trujillo",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "IQT",
              "cityName": "Iquitos",
              "code": "IQT",
              "countryName": "Peru",
              "displayText": "Iquitos, F Secada Vignetta International Airport",
              "isDestination": true,
              "isOrigin": true,
              "label": "F Secada Vignetta International Airport",
              "phoneticLabel": null,
              "searchText": "iqt f secada vignetta international airport peru iquitos",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          },
          {
              "cityCode": "CUZ",
              "cityName": "Cuzco",
              "code": "CUZ",
              "countryName": "Peru",
              "displayText": "Cuzco, Velazco Astete",
              "isDestination": true,
              "isOrigin": true,
              "label": "Velazco Astete",
              "phoneticLabel": null,
              "searchText": "cuz velazco astete peru cuzco",
              "stationType": "AIRPORT",
              "type": "A",
              "__typename": "Station"
          }
      ]



// const extractAirportsData = Object.values(data).map((obj) => {
//   return {
//     code: obj?.city?.code,
//     city: obj?.shortName,
//     country: obj?.country?.longName,
//     airport: obj?.longName,
//   }
// })

const extractAirportsData = data.map((obj) => {
  return {
    code: obj?.code,
    city: obj?.cityName,
    country: obj?.countryName,
    airport: obj?.displayText,
  }
})
export const airportsData = Array.from(extractAirportsData).sort((a, b) =>
  a.city.localeCompare(b.city)
)
